
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8d63"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8d63"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionLane = 256, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextTransitionLane() {
    var lane = $dca0ddb82b882518$var$nextTransitionLane;
    $dca0ddb82b882518$var$nextTransitionLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextTransitionLane & 4194048) && ($dca0ddb82b882518$var$nextTransitionLane = 256);
    return lane;
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$5;
        entanglements[index$5] = 0;
        expirationTimes[index$5] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$5];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++){
            var update = hiddenUpdatesForLane[index$5];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$6;
        lane & entangledLanes | root[index$6] & entangledLanes && (root[index$6] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$8 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$9) {
                                control = x$9;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$10) {
                            control = x$10;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node) {
    var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    node._valueTracker || (node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node));
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$282;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_417 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_417) {
            var $dca0ddb82b882518$var$element$jscomp$inline_418 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_418.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_417 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_418.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$282 = $dca0ddb82b882518$var$isSupported$jscomp$inline_417;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$282 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_PROVIDER_TYPE:
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $dca0ddb82b882518$var$track(instance);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children), $dca0ddb82b882518$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(tag = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === tag) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        tag--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
                }
                fiber = fiber.nextSibling;
            }
            $dca0ddb82b882518$var$nextHydratableInstance = null;
        }
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$noop$3() {}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$3, $dca0ddb82b882518$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$3, $dca0ddb82b882518$var$noop$3);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    $dca0ddb82b882518$var$thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState$1 = null);
        $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState$1 = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$32 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$32 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    var create = $dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe);
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, $dca0ddb82b882518$var$createEffectInstance(), $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 124) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$38) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$38);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, $dca0ddb82b882518$var$createEffectInstance(), $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, createDeps) {
    tag = {
        tag: tag,
        create: create,
        deps: createDeps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$createEffectInstance() {
    return {
        destroy: void 0,
        resource: void 0
    };
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, $dca0ddb82b882518$var$createEffectInstance(), create, createDeps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, createDeps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, createDeps);
}
function $dca0ddb82b882518$var$updateEffect(create, createDeps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, createDeps);
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop$2() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop$2 : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$41 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$41 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$41, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$41, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
}, $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 124) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, $dca0ddb82b882518$var$createEffectInstance(), $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "\u00ab" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "\u00bb";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "\u00ab" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "\u00bb";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
}, $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
}, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$thenableIndexCounter = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = fiber);
        }
    } else $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(prevState = 0; null !== nextChildren;)prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = prevState & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($dca0ddb82b882518$var$isHydrating) {
                var nextInstance = $dca0ddb82b882518$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                            id: $dca0ddb82b882518$var$treeContextId,
                            overflow: $dca0ddb82b882518$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextInstance) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912, null;
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, nextProps;
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextInstance)) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = renderLanes & -renderLanes, nextProps = 0 !== (nextProps & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane)) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            "$?" === nextInstance.data || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextInstance.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && ($dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId, $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow, $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider, $dca0ddb82b882518$var$treeContextId = current.id, $dca0ddb82b882518$var$treeContextOverflow = current.overflow, $dca0ddb82b882518$var$treeContextProvider = workInProgress), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = $dca0ddb82b882518$var$createWorkInProgress(digest, showFallback) : (showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $dca0ddb82b882518$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, nextProps;
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    };
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $dca0ddb82b882518$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $dca0ddb82b882518$var$shouldConstruct(lazyComponent) ? (current = $dca0ddb82b882518$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $dca0ddb82b882518$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                lazyComponent = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                init = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, lazyComponent, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                lazyComponent = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent);
                lazyComponent !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                lazyComponent = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: lazyComponent,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else if (lazyComponent !== init) {
                        init = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError(init);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, lazyComponent, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (lazyComponent === init) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, lazyComponent[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(lazyComponent, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (lazyComponent = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, init = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = init, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(lazyComponent.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = init), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (init = lazyComponent = $dca0ddb82b882518$var$nextHydratableInstance) lazyComponent = $dca0ddb82b882518$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(lazyComponent.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent(init, prevState) ? lazyComponent = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = init);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), init = $dca0ddb82b882518$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return lazyComponent = workInProgress.pendingProps, renderLanes = workInProgress.mode, lazyComponent = {
                mode: lazyComponent.mode,
                children: lazyComponent.children
            }, null === current ? (renderLanes = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(lazyComponent, renderLanes), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes) : (renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current.child, lazyComponent), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes), workInProgress;
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), lazyComponent = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? (init = $dca0ddb82b882518$var$peekCacheFromPool(), null === init && (init = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), init.pooledCache = prevState, prevState.refCount++, null !== prevState && (init.pooledCacheLanes |= renderLanes), init = prevState), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, prevState = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        resource = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null !== $dca0ddb82b882518$var$shellBoundary : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || resource !== $dca0ddb82b882518$var$shellBoundary)) throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$113 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else for(child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== renderLanes ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$127 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
                cache$127 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$127 = type.rendering;
            if (null === cache$127) {
                if (newProps) $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$127 = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== cache$127) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1);
                            current = cache$127.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(cache$127), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$127.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - type.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$127.sibling = workInProgress.child, workInProgress.child = cache$127) : (current = type.last, null !== current ? current.sibling = cache$127 : workInProgress.child = cache$127, type.last = cache$127);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $dca0ddb82b882518$var$now(), workInProgress.sibling = null, current = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$143) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$142) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$142);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearSuspenseBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearSuspenseBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$144 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
                    var before$145 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
                    break;
                case 3:
                case 4:
                    var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$147, parent$146);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource($dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes) return $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes;
    if (null !== $dca0ddb82b882518$var$ReactSharedInternals.T) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $dca0ddb82b882518$var$requestTransitionLane();
    }
    return $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    0 === $dca0ddb82b882518$var$workInProgressDeferredLane && ($dca0ddb82b882518$var$workInProgressDeferredLane = 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 2, -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        if ($dca0ddb82b882518$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $dca0ddb82b882518$var$noop
        }, $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = $dca0ddb82b882518$var$waitForCommitToBeReady(), null !== suspendedCommitReason) {
            root.cancelPendingCommit = suspendedCommitReason($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, 1, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$4;
        didAttemptEntireTree[index$4] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$thenableIndexCounter = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$2 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root[index$2];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : 1) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$169) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$169);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState = null;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects(!0);
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects(wasDelayedCommit) {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects(wasDelayedCommit);
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$174 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$174;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$174.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$174, root$174 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                }
                root$174 = root$174.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane), $dca0ddb82b882518$var$currentEventTransitionLane = 0);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$3 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$3] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects(!0) && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    0 === $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = $dca0ddb82b882518$var$claimNextTransitionLane());
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1528 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1528 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1528++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1529 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1528], $dca0ddb82b882518$var$domEventName$jscomp$inline_1530 = $dca0ddb82b882518$var$eventName$jscomp$inline_1529.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1531 = $dca0ddb82b882518$var$eventName$jscomp$inline_1529[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1529.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1530, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1531);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $dca0ddb82b882518$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $dca0ddb82b882518$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $dca0ddb82b882518$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $dca0ddb82b882518$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $dca0ddb82b882518$var$getParent(inCapturePhase);
                                reactEventName = $dca0ddb82b882518$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$noop$1() {}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$188 = props[hasSrc];
                if (null != propValue$188) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$188;
                        break;
                    case "type":
                        propValue = propValue$188;
                        break;
                    case "checked":
                        checked = propValue$188;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$188;
                        break;
                    case "value":
                        propKey = propValue$188;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$188;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$188) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$188, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $dca0ddb82b882518$var$track(domElement);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $dca0ddb82b882518$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$188 in props)props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$188, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$205 in nextProps){
                var propKey = nextProps[propKey$205];
                lastProp = lastProps[propKey$205];
                if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp)) switch(propKey$205){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$205, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$205 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$205 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$205 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$205, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$205 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$205 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$205, propKey);
            return;
        case "option":
            for(var propKey$221 in lastProps)if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221)) switch(propKey$221){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$221, null, nextProps, propKey$205);
            }
            for(lastDefaultValue in nextProps)if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== typeof propKey$205;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$205, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$226 in lastProps)propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
            for(checked in nextProps)if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$205) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$205, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$231 in lastProps)propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$231, void 0, nextProps, propKey$205);
                for(defaultChecked in nextProps)propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$205, nextProps, propKey);
                return;
            }
    }
    for(var propKey$236 in lastProps)propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for(lastProp in nextProps)propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
                    node = possiblePreambleContribution;
                    var ownerDocument = parentInstance.ownerDocument;
                    node & 1 && $dca0ddb82b882518$var$releaseSingletonInstance(ownerDocument.documentElement);
                    node & 2 && $dca0ddb82b882518$var$releaseSingletonInstance(ownerDocument.body);
                    if (node & 4) for(node = ownerDocument.head, $dca0ddb82b882518$var$releaseSingletonInstance(node), ownerDocument = node.firstChild; ownerDocument;){
                        var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                        ownerDocument[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node.removeChild(ownerDocument);
                        ownerDocument = nextNode$jscomp$0;
                    }
                }
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" === node || "$?" === node || "$!" === node ? depth++ : possiblePreambleContribution = node.charCodeAt(0) - 48;
        } else possiblePreambleContribution = 0;
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(suspenseInstance);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$244 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$245 = styles$244.get(type);
                resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$244.set(type, resource$245), (styles$244 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$244 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$245.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$245;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$250 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$250) return resource.state.loading |= 4, resource.instance = instance$250, $dca0ddb82b882518$var$markNodeAsHoistable(instance$250), instance$250;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$250);
            var linkInstance = instance$250;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$250, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$250, props.precedence, hoistableRoot);
            return resource.instance = instance$250;
        case "script":
            instance$250 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$250))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$250)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $dca0ddb82b882518$var$suspendedState = null;
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $dca0ddb82b882518$var$suspendedState) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(475));
    var state = $dca0ddb82b882518$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $dca0ddb82b882518$var$waitForCommitToBeReady() {
    if (null === $dca0ddb82b882518$var$suspendedState) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(475));
    var state = $dca0ddb82b882518$var$suspendedState;
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $dca0ddb82b882518$var$requestUpdateLane();
                            lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
                            var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1785 = $acw62.version;
if ("19.1.0" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1785) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1785, "19.1.0"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.1.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2257.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2257.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2257.inject($dca0ddb82b882518$var$internals$jscomp$inline_2256), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2257;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.1.0";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});
parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray, $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$noop$1() {}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop$1, $72b03fdf46effee2$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $72b03fdf46effee2$var$noop() {}
$72b03fdf46effee2$export$dca3b0875bd9a954 = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, void 0, void 0, null, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, createDeps, update) {
    var dispatcher = $72b03fdf46effee2$var$ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.1.0";

});


parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.1.0";

});



parcelRegister("24qIq", function(module, exports) {
'use strict';
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $7YWkK = parcelRequire("7YWkK");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $1820ada193f67aeb$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $7YWkK();
};

});
parcelRegister("7YWkK", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});


parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $6b3372b60d35b33f$export$2b8d127b894957b9, (v) => $6b3372b60d35b33f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $6b3372b60d35b33f$export$cea3a54a6425200c, (v) => $6b3372b60d35b33f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$2b8d127b894957b9;
var $6b3372b60d35b33f$export$cea3a54a6425200c;
var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
'use strict';
var $6b3372b60d35b33f$var$b = "function" === typeof Symbol && Symbol.for, $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$b ? Symbol.for("react.element") : 60103, $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$b ? Symbol.for("react.portal") : 60106, $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$b ? Symbol.for("react.fragment") : 60107, $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$b ? Symbol.for("react.strict_mode") : 60108, $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$b ? Symbol.for("react.profiler") : 60114, $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$b ? Symbol.for("react.provider") : 60109, $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$b ? Symbol.for("react.context") : 60110, $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$b ? Symbol.for("react.async_mode") : 60111, $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$b ? Symbol.for("react.forward_ref") : 60112, $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense") : 60113, $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense_list") : 60120, $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$b ? Symbol.for("react.memo") : 60115, $6b3372b60d35b33f$var$t = $6b3372b60d35b33f$var$b ? Symbol.for("react.lazy") : 60116, $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$b ? Symbol.for("react.block") : 60121, $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$b ? Symbol.for("react.fundamental") : 60117, $6b3372b60d35b33f$var$x = $6b3372b60d35b33f$var$b ? Symbol.for("react.responder") : 60118, $6b3372b60d35b33f$var$y = $6b3372b60d35b33f$var$b ? Symbol.for("react.scope") : 60119;
function $6b3372b60d35b33f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6b3372b60d35b33f$var$c:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$g:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$t:
                            case $6b3372b60d35b33f$var$r:
                            case $6b3372b60d35b33f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6b3372b60d35b33f$var$d:
                return u;
        }
    }
}
function $6b3372b60d35b33f$var$A(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$m;
}
$6b3372b60d35b33f$export$2b8d127b894957b9 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$cea3a54a6425200c = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$k;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$t;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$r;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$92387174baf9b227 = function(a) {
    return $6b3372b60d35b33f$var$A(a) || $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$t;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$r;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$g || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$p || a === $6b3372b60d35b33f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$t || a.$$typeof === $6b3372b60d35b33f$var$r || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$w || a.$$typeof === $6b3372b60d35b33f$var$x || a.$$typeof === $6b3372b60d35b33f$var$y || a.$$typeof === $6b3372b60d35b33f$var$v);
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$z;

});

'use strict';
'use strict';
var $ca3e1754e676956d$exports = {};
'use strict';
var $3fbf1185731afe2b$exports = {};
'use strict';
var $3fbf1185731afe2b$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$3fbf1185731afe2b$exports = // eslint-disable-next-line es/no-global-this -- safe
$3fbf1185731afe2b$var$check(typeof globalThis == 'object' && globalThis) || $3fbf1185731afe2b$var$check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$3fbf1185731afe2b$var$check(typeof self == 'object' && self) || $3fbf1185731afe2b$var$check(typeof $parcel$global == 'object' && $parcel$global) || $3fbf1185731afe2b$var$check(typeof $3fbf1185731afe2b$exports == 'object' && $3fbf1185731afe2b$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();


// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $6d99163b6684d050$export$2d1720544b23b823;
'use strict';
var $ef322a7f89c3ed41$exports = {};
'use strict';
var $6140c9fa18232846$exports = {};
'use strict';
$6140c9fa18232846$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$ef322a7f89c3ed41$exports = !$6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $881ad37dbe259e8f$exports = {};
'use strict';
var $bcbe62e89adc7d37$exports = {};
'use strict';

$bcbe62e89adc7d37$exports = !$6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});


var $881ad37dbe259e8f$var$call = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
$881ad37dbe259e8f$exports = $bcbe62e89adc7d37$exports ? $881ad37dbe259e8f$var$call.bind($881ad37dbe259e8f$var$call) : function() {
    return $881ad37dbe259e8f$var$call.apply($881ad37dbe259e8f$var$call, arguments);
};


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $1e0782be6903ea7b$export$2d1720544b23b823;
'use strict';
var $1e0782be6903ea7b$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $1e0782be6903ea7b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $1e0782be6903ea7b$var$NASHORN_BUG = $1e0782be6903ea7b$var$getOwnPropertyDescriptor && !$1e0782be6903ea7b$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$1e0782be6903ea7b$export$2d1720544b23b823 = $1e0782be6903ea7b$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $1e0782be6903ea7b$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $1e0782be6903ea7b$var$$propertyIsEnumerable;


var $b66966b48674609b$exports = {};
'use strict';
$b66966b48674609b$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $4d273c9d7e1bdf46$exports = {};
'use strict';
var $8239f4c7c6082668$exports = {};
'use strict';
var $43b18aa2f1faac44$exports = {};
'use strict';

var $43b18aa2f1faac44$var$FunctionPrototype = Function.prototype;
var $43b18aa2f1faac44$var$call = $43b18aa2f1faac44$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var $43b18aa2f1faac44$var$uncurryThisWithBind = $bcbe62e89adc7d37$exports && $43b18aa2f1faac44$var$FunctionPrototype.bind.bind($43b18aa2f1faac44$var$call, $43b18aa2f1faac44$var$call);
$43b18aa2f1faac44$exports = $bcbe62e89adc7d37$exports ? $43b18aa2f1faac44$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $43b18aa2f1faac44$var$call.apply(fn, arguments);
    };
};



var $b0ba63bfbfb16088$exports = {};
'use strict';

var $b0ba63bfbfb16088$var$toString = $43b18aa2f1faac44$exports({}.toString);
var $b0ba63bfbfb16088$var$stringSlice = $43b18aa2f1faac44$exports(''.slice);
$b0ba63bfbfb16088$exports = function(it) {
    return $b0ba63bfbfb16088$var$stringSlice($b0ba63bfbfb16088$var$toString(it), 8, -1);
};


var $8239f4c7c6082668$var$$Object = Object;
var $8239f4c7c6082668$var$split = $43b18aa2f1faac44$exports(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$8239f4c7c6082668$exports = $6140c9fa18232846$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$8239f4c7c6082668$var$$Object('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $b0ba63bfbfb16088$exports(it) === 'String' ? $8239f4c7c6082668$var$split(it, '') : $8239f4c7c6082668$var$$Object(it);
} : $8239f4c7c6082668$var$$Object;


var $c378177673193450$exports = {};
'use strict';
var $7ce250ddf7b42d4d$exports = {};
'use strict';
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$7ce250ddf7b42d4d$exports = function(it) {
    return it === null || it === undefined;
};


var $c378177673193450$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$c378177673193450$exports = function(it) {
    if ($7ce250ddf7b42d4d$exports(it)) throw new $c378177673193450$var$$TypeError("Can't call method on " + it);
    return it;
};


$4d273c9d7e1bdf46$exports = function(it) {
    return $8239f4c7c6082668$exports($c378177673193450$exports(it));
};


var $7f19acfe53927f5c$exports = {};
'use strict';
var $8ffb6b36a733d3c0$exports = {};
'use strict';

var $6a130d390db46c8e$exports = {};
'use strict';
var $70e34a5a2021f756$exports = {};
'use strict';
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $70e34a5a2021f756$var$documentAll = typeof document == 'object' && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$70e34a5a2021f756$exports = typeof $70e34a5a2021f756$var$documentAll == 'undefined' && $70e34a5a2021f756$var$documentAll !== undefined ? function(argument) {
    return typeof argument == 'function' || argument === $70e34a5a2021f756$var$documentAll;
} : function(argument) {
    return typeof argument == 'function';
};


$6a130d390db46c8e$exports = function(it) {
    return typeof it == 'object' ? it !== null : $70e34a5a2021f756$exports(it);
};


var $0b429cc7792c7d26$exports = {};
'use strict';
var $a5217dbd1b0d33ce$exports = {};
'use strict';


var $a5217dbd1b0d33ce$var$aFunction = function(argument) {
    return $70e34a5a2021f756$exports(argument) ? argument : undefined;
};
$a5217dbd1b0d33ce$exports = function(namespace, method) {
    return arguments.length < 2 ? $a5217dbd1b0d33ce$var$aFunction($3fbf1185731afe2b$exports[namespace]) : $3fbf1185731afe2b$exports[namespace] && $3fbf1185731afe2b$exports[namespace][method];
};



var $41cc576e850a251e$exports = {};
'use strict';

$41cc576e850a251e$exports = $43b18aa2f1faac44$exports({}.isPrototypeOf);


var $47f18b427c2fbabf$exports = {};
'use strict';
var $4a39565fee8fe980$exports = {};
'use strict';
var $b2a56c1a090208a5$exports = {};
'use strict';

var $34fa2a1382dc63c1$exports = {};
'use strict';

var $34fa2a1382dc63c1$var$navigator = $3fbf1185731afe2b$exports.navigator;
var $34fa2a1382dc63c1$var$userAgent = $34fa2a1382dc63c1$var$navigator && $34fa2a1382dc63c1$var$navigator.userAgent;
$34fa2a1382dc63c1$exports = $34fa2a1382dc63c1$var$userAgent ? String($34fa2a1382dc63c1$var$userAgent) : '';


var $b2a56c1a090208a5$var$process = $3fbf1185731afe2b$exports.process;
var $b2a56c1a090208a5$var$Deno = $3fbf1185731afe2b$exports.Deno;
var $b2a56c1a090208a5$var$versions = $b2a56c1a090208a5$var$process && $b2a56c1a090208a5$var$process.versions || $b2a56c1a090208a5$var$Deno && $b2a56c1a090208a5$var$Deno.version;
var $b2a56c1a090208a5$var$v8 = $b2a56c1a090208a5$var$versions && $b2a56c1a090208a5$var$versions.v8;
var $b2a56c1a090208a5$var$match, $b2a56c1a090208a5$var$version;
if ($b2a56c1a090208a5$var$v8) {
    $b2a56c1a090208a5$var$match = $b2a56c1a090208a5$var$v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $b2a56c1a090208a5$var$version = $b2a56c1a090208a5$var$match[0] > 0 && $b2a56c1a090208a5$var$match[0] < 4 ? 1 : +($b2a56c1a090208a5$var$match[0] + $b2a56c1a090208a5$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$b2a56c1a090208a5$var$version && $34fa2a1382dc63c1$exports) {
    $b2a56c1a090208a5$var$match = $34fa2a1382dc63c1$exports.match(/Edge\/(\d+)/);
    if (!$b2a56c1a090208a5$var$match || $b2a56c1a090208a5$var$match[1] >= 74) {
        $b2a56c1a090208a5$var$match = $34fa2a1382dc63c1$exports.match(/Chrome\/(\d+)/);
        if ($b2a56c1a090208a5$var$match) $b2a56c1a090208a5$var$version = +$b2a56c1a090208a5$var$match[1];
    }
}
$b2a56c1a090208a5$exports = $b2a56c1a090208a5$var$version;




var $4a39565fee8fe980$var$$String = $3fbf1185731afe2b$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$4a39565fee8fe980$exports = !!Object.getOwnPropertySymbols && !$6140c9fa18232846$exports(function() {
    var symbol = Symbol('symbol detection');
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$4a39565fee8fe980$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $b2a56c1a090208a5$exports && $b2a56c1a090208a5$exports < 41;
});


$47f18b427c2fbabf$exports = $4a39565fee8fe980$exports && !Symbol.sham && typeof Symbol.iterator == 'symbol';


var $0b429cc7792c7d26$var$$Object = Object;
$0b429cc7792c7d26$exports = $47f18b427c2fbabf$exports ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    var $Symbol = $a5217dbd1b0d33ce$exports('Symbol');
    return $70e34a5a2021f756$exports($Symbol) && $41cc576e850a251e$exports($Symbol.prototype, $0b429cc7792c7d26$var$$Object(it));
};


var $eb80dcd0b8a5698c$exports = {};
'use strict';
var $ae485921c5498156$exports = {};
'use strict';

var $8f0ebae34f61e14c$exports = {};
'use strict';
var $8f0ebae34f61e14c$var$$String = String;
$8f0ebae34f61e14c$exports = function(argument) {
    try {
        return $8f0ebae34f61e14c$var$$String(argument);
    } catch (error) {
        return 'Object';
    }
};


var $ae485921c5498156$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$ae485921c5498156$exports = function(argument) {
    if ($70e34a5a2021f756$exports(argument)) return argument;
    throw new $ae485921c5498156$var$$TypeError($8f0ebae34f61e14c$exports(argument) + ' is not a function');
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$eb80dcd0b8a5698c$exports = function(V, P) {
    var func = V[P];
    return $7ce250ddf7b42d4d$exports(func) ? undefined : $ae485921c5498156$exports(func);
};


var $b0f812e443807cb5$exports = {};
'use strict';



var $b0f812e443807cb5$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$b0f812e443807cb5$exports = function(input, pref) {
    var fn, val;
    if (pref === 'string' && $70e34a5a2021f756$exports(fn = input.toString) && !$6a130d390db46c8e$exports(val = $881ad37dbe259e8f$exports(fn, input))) return val;
    if ($70e34a5a2021f756$exports(fn = input.valueOf) && !$6a130d390db46c8e$exports(val = $881ad37dbe259e8f$exports(fn, input))) return val;
    if (pref !== 'string' && $70e34a5a2021f756$exports(fn = input.toString) && !$6a130d390db46c8e$exports(val = $881ad37dbe259e8f$exports(fn, input))) return val;
    throw new $b0f812e443807cb5$var$$TypeError("Can't convert object to primitive value");
};


var $842f8f0a18746212$exports = {};
'use strict';

var $1946b9b54b48e7fd$exports = {};
'use strict';
var $d00d03e557d638db$exports = {};
'use strict';
var $e0409817d4e03fc4$exports = {};
'use strict';
$e0409817d4e03fc4$exports = false;



var $4ce407c7007beb63$exports = {};
'use strict';

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $4ce407c7007beb63$var$defineProperty = Object.defineProperty;
$4ce407c7007beb63$exports = function(key, value) {
    try {
        $4ce407c7007beb63$var$defineProperty($3fbf1185731afe2b$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $3fbf1185731afe2b$exports[key] = value;
    }
    return value;
};


var $d00d03e557d638db$var$SHARED = '__core-js_shared__';
var $d00d03e557d638db$var$store = $d00d03e557d638db$exports = $3fbf1185731afe2b$exports[$d00d03e557d638db$var$SHARED] || $4ce407c7007beb63$exports($d00d03e557d638db$var$SHARED, {});
($d00d03e557d638db$var$store.versions || ($d00d03e557d638db$var$store.versions = [])).push({
    version: '3.41.0',
    mode: $e0409817d4e03fc4$exports ? 'pure' : 'global',
    copyright: "\xa9 2014-2025 Denis Pushkarev (zloirock.ru)",
    license: 'https://github.com/zloirock/core-js/blob/v3.41.0/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});


$1946b9b54b48e7fd$exports = function(key, value) {
    return $d00d03e557d638db$exports[key] || ($d00d03e557d638db$exports[key] = value || {});
};


var $1f868a26fd901990$exports = {};
'use strict';

var $a2f3ebb5da11db12$exports = {};
'use strict';

var $a2f3ebb5da11db12$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$a2f3ebb5da11db12$exports = function(argument) {
    return $a2f3ebb5da11db12$var$$Object($c378177673193450$exports(argument));
};


var $1f868a26fd901990$var$hasOwnProperty = $43b18aa2f1faac44$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$1f868a26fd901990$exports = Object.hasOwn || function hasOwn(it, key) {
    return $1f868a26fd901990$var$hasOwnProperty($a2f3ebb5da11db12$exports(it), key);
};


var $5e0a1e292f79defc$exports = {};
'use strict';

var $5e0a1e292f79defc$var$id = 0;
var $5e0a1e292f79defc$var$postfix = Math.random();
var $5e0a1e292f79defc$var$toString = $43b18aa2f1faac44$exports(1.0.toString);
$5e0a1e292f79defc$exports = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + $5e0a1e292f79defc$var$toString(++$5e0a1e292f79defc$var$id + $5e0a1e292f79defc$var$postfix, 36);
};




var $842f8f0a18746212$var$Symbol = $3fbf1185731afe2b$exports.Symbol;
var $842f8f0a18746212$var$WellKnownSymbolsStore = $1946b9b54b48e7fd$exports('wks');
var $842f8f0a18746212$var$createWellKnownSymbol = $47f18b427c2fbabf$exports ? $842f8f0a18746212$var$Symbol['for'] || $842f8f0a18746212$var$Symbol : $842f8f0a18746212$var$Symbol && $842f8f0a18746212$var$Symbol.withoutSetter || $5e0a1e292f79defc$exports;
$842f8f0a18746212$exports = function(name) {
    if (!$1f868a26fd901990$exports($842f8f0a18746212$var$WellKnownSymbolsStore, name)) $842f8f0a18746212$var$WellKnownSymbolsStore[name] = $4a39565fee8fe980$exports && $1f868a26fd901990$exports($842f8f0a18746212$var$Symbol, name) ? $842f8f0a18746212$var$Symbol[name] : $842f8f0a18746212$var$createWellKnownSymbol('Symbol.' + name);
    return $842f8f0a18746212$var$WellKnownSymbolsStore[name];
};


var $8ffb6b36a733d3c0$var$$TypeError = TypeError;
var $8ffb6b36a733d3c0$var$TO_PRIMITIVE = $842f8f0a18746212$exports('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$8ffb6b36a733d3c0$exports = function(input, pref) {
    if (!$6a130d390db46c8e$exports(input) || $0b429cc7792c7d26$exports(input)) return input;
    var exoticToPrim = $eb80dcd0b8a5698c$exports(input, $8ffb6b36a733d3c0$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = $881ad37dbe259e8f$exports(exoticToPrim, input, pref);
        if (!$6a130d390db46c8e$exports(result) || $0b429cc7792c7d26$exports(result)) return result;
        throw new $8ffb6b36a733d3c0$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return $b0f812e443807cb5$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$7f19acfe53927f5c$exports = function(argument) {
    var key = $8ffb6b36a733d3c0$exports(argument, 'string');
    return $0b429cc7792c7d26$exports(key) ? key : key + '';
};



var $d45526d8245cb22c$exports = {};
'use strict';


var $15c0c414b89100b1$exports = {};
'use strict';


var $15c0c414b89100b1$var$document = $3fbf1185731afe2b$exports.document;
// typeof document.createElement is 'object' in old IE
var $15c0c414b89100b1$var$EXISTS = $6a130d390db46c8e$exports($15c0c414b89100b1$var$document) && $6a130d390db46c8e$exports($15c0c414b89100b1$var$document.createElement);
$15c0c414b89100b1$exports = function(it) {
    return $15c0c414b89100b1$var$EXISTS ? $15c0c414b89100b1$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$d45526d8245cb22c$exports = !$ef322a7f89c3ed41$exports && !$6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($15c0c414b89100b1$exports('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $6d99163b6684d050$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$6d99163b6684d050$export$2d1720544b23b823 = $ef322a7f89c3ed41$exports ? $6d99163b6684d050$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $4d273c9d7e1bdf46$exports(O);
    P = $7f19acfe53927f5c$exports(P);
    if ($d45526d8245cb22c$exports) try {
        return $6d99163b6684d050$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($1f868a26fd901990$exports(O, P)) return $b66966b48674609b$exports(!$881ad37dbe259e8f$exports($1e0782be6903ea7b$export$2d1720544b23b823, O, P), O[P]);
};


var $ca3e1754e676956d$require$getOwnPropertyDescriptor = $6d99163b6684d050$export$2d1720544b23b823;
var $8693737507995841$exports = {};
'use strict';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $2d0ac3aa5e39584b$export$2d1720544b23b823;
'use strict';


var $161a89d67c436ccf$exports = {};
'use strict';


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$161a89d67c436ccf$exports = $ef322a7f89c3ed41$exports && $6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $c845d421b7b0e630$exports = {};
'use strict';

var $c845d421b7b0e630$var$$String = String;
var $c845d421b7b0e630$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$c845d421b7b0e630$exports = function(argument) {
    if ($6a130d390db46c8e$exports(argument)) return argument;
    throw new $c845d421b7b0e630$var$$TypeError($c845d421b7b0e630$var$$String(argument) + ' is not an object');
};



var $2d0ac3aa5e39584b$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $2d0ac3aa5e39584b$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $2d0ac3aa5e39584b$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $2d0ac3aa5e39584b$var$ENUMERABLE = 'enumerable';
var $2d0ac3aa5e39584b$var$CONFIGURABLE = 'configurable';
var $2d0ac3aa5e39584b$var$WRITABLE = 'writable';
$2d0ac3aa5e39584b$export$2d1720544b23b823 = $ef322a7f89c3ed41$exports ? $161a89d67c436ccf$exports ? function defineProperty(O, P, Attributes) {
    $c845d421b7b0e630$exports(O);
    P = $7f19acfe53927f5c$exports(P);
    $c845d421b7b0e630$exports(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && $2d0ac3aa5e39584b$var$WRITABLE in Attributes && !Attributes[$2d0ac3aa5e39584b$var$WRITABLE]) {
        var current = $2d0ac3aa5e39584b$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$2d0ac3aa5e39584b$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $2d0ac3aa5e39584b$var$CONFIGURABLE in Attributes ? Attributes[$2d0ac3aa5e39584b$var$CONFIGURABLE] : current[$2d0ac3aa5e39584b$var$CONFIGURABLE],
                enumerable: $2d0ac3aa5e39584b$var$ENUMERABLE in Attributes ? Attributes[$2d0ac3aa5e39584b$var$ENUMERABLE] : current[$2d0ac3aa5e39584b$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $2d0ac3aa5e39584b$var$$defineProperty(O, P, Attributes);
} : $2d0ac3aa5e39584b$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $c845d421b7b0e630$exports(O);
    P = $7f19acfe53927f5c$exports(P);
    $c845d421b7b0e630$exports(Attributes);
    if ($d45526d8245cb22c$exports) try {
        return $2d0ac3aa5e39584b$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw new $2d0ac3aa5e39584b$var$$TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};



$8693737507995841$exports = $ef322a7f89c3ed41$exports ? function(object, key, value) {
    return $2d0ac3aa5e39584b$export$2d1720544b23b823(object, key, $b66966b48674609b$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};


var $40e957865125f98f$exports = {};
'use strict';


var $09c56ff2ae09b2d7$exports = {};
'use strict';





var $81c64883d194e3b4$exports = {};
'use strict';


var $81c64883d194e3b4$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $81c64883d194e3b4$var$getDescriptor = $ef322a7f89c3ed41$exports && Object.getOwnPropertyDescriptor;
var $81c64883d194e3b4$var$EXISTS = $1f868a26fd901990$exports($81c64883d194e3b4$var$FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var $81c64883d194e3b4$var$PROPER = $81c64883d194e3b4$var$EXISTS && (function something() {}).name === 'something';
var $81c64883d194e3b4$var$CONFIGURABLE = $81c64883d194e3b4$var$EXISTS && (!$ef322a7f89c3ed41$exports || $ef322a7f89c3ed41$exports && $81c64883d194e3b4$var$getDescriptor($81c64883d194e3b4$var$FunctionPrototype, 'name').configurable);
$81c64883d194e3b4$exports = {
    EXISTS: $81c64883d194e3b4$var$EXISTS,
    PROPER: $81c64883d194e3b4$var$PROPER,
    CONFIGURABLE: $81c64883d194e3b4$var$CONFIGURABLE
};


var $09c56ff2ae09b2d7$require$CONFIGURABLE_FUNCTION_NAME = $81c64883d194e3b4$exports.CONFIGURABLE;
var $9990f6f719f26a96$exports = {};
'use strict';



var $9990f6f719f26a96$var$functionToString = $43b18aa2f1faac44$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$70e34a5a2021f756$exports($d00d03e557d638db$exports.inspectSource)) $d00d03e557d638db$exports.inspectSource = function(it) {
    return $9990f6f719f26a96$var$functionToString(it);
};
$9990f6f719f26a96$exports = $d00d03e557d638db$exports.inspectSource;


var $3a8bcef306e86159$exports = {};
'use strict';
var $47d53bb84a8f3c5b$exports = {};
'use strict';


var $47d53bb84a8f3c5b$var$WeakMap = $3fbf1185731afe2b$exports.WeakMap;
$47d53bb84a8f3c5b$exports = $70e34a5a2021f756$exports($47d53bb84a8f3c5b$var$WeakMap) && /native code/.test(String($47d53bb84a8f3c5b$var$WeakMap));







var $834abcf0f8f3f871$exports = {};
'use strict';


var $834abcf0f8f3f871$var$keys = $1946b9b54b48e7fd$exports('keys');
$834abcf0f8f3f871$exports = function(key) {
    return $834abcf0f8f3f871$var$keys[key] || ($834abcf0f8f3f871$var$keys[key] = $5e0a1e292f79defc$exports(key));
};


var $9f571a3f3d135e31$exports = {};
'use strict';
$9f571a3f3d135e31$exports = {};


var $3a8bcef306e86159$var$OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var $3a8bcef306e86159$var$TypeError = $3fbf1185731afe2b$exports.TypeError;
var $3a8bcef306e86159$var$WeakMap = $3fbf1185731afe2b$exports.WeakMap;
var $3a8bcef306e86159$var$set, $3a8bcef306e86159$var$get, $3a8bcef306e86159$var$has;
var $3a8bcef306e86159$var$enforce = function(it) {
    return $3a8bcef306e86159$var$has(it) ? $3a8bcef306e86159$var$get(it) : $3a8bcef306e86159$var$set(it, {});
};
var $3a8bcef306e86159$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$6a130d390db46c8e$exports(it) || (state = $3a8bcef306e86159$var$get(it)).type !== TYPE) throw new $3a8bcef306e86159$var$TypeError('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if ($47d53bb84a8f3c5b$exports || $d00d03e557d638db$exports.state) {
    var $3a8bcef306e86159$var$store = $d00d03e557d638db$exports.state || ($d00d03e557d638db$exports.state = new $3a8bcef306e86159$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $3a8bcef306e86159$var$store.get = $3a8bcef306e86159$var$store.get;
    $3a8bcef306e86159$var$store.has = $3a8bcef306e86159$var$store.has;
    $3a8bcef306e86159$var$store.set = $3a8bcef306e86159$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $3a8bcef306e86159$var$set = function(it, metadata) {
        if ($3a8bcef306e86159$var$store.has(it)) throw new $3a8bcef306e86159$var$TypeError($3a8bcef306e86159$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $3a8bcef306e86159$var$store.set(it, metadata);
        return metadata;
    };
    $3a8bcef306e86159$var$get = function(it) {
        return $3a8bcef306e86159$var$store.get(it) || {};
    };
    $3a8bcef306e86159$var$has = function(it) {
        return $3a8bcef306e86159$var$store.has(it);
    };
} else {
    var $3a8bcef306e86159$var$STATE = $834abcf0f8f3f871$exports('state');
    $9f571a3f3d135e31$exports[$3a8bcef306e86159$var$STATE] = true;
    $3a8bcef306e86159$var$set = function(it, metadata) {
        if ($1f868a26fd901990$exports(it, $3a8bcef306e86159$var$STATE)) throw new $3a8bcef306e86159$var$TypeError($3a8bcef306e86159$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $8693737507995841$exports(it, $3a8bcef306e86159$var$STATE, metadata);
        return metadata;
    };
    $3a8bcef306e86159$var$get = function(it) {
        return $1f868a26fd901990$exports(it, $3a8bcef306e86159$var$STATE) ? it[$3a8bcef306e86159$var$STATE] : {};
    };
    $3a8bcef306e86159$var$has = function(it) {
        return $1f868a26fd901990$exports(it, $3a8bcef306e86159$var$STATE);
    };
}
$3a8bcef306e86159$exports = {
    set: $3a8bcef306e86159$var$set,
    get: $3a8bcef306e86159$var$get,
    has: $3a8bcef306e86159$var$has,
    enforce: $3a8bcef306e86159$var$enforce,
    getterFor: $3a8bcef306e86159$var$getterFor
};


var $09c56ff2ae09b2d7$var$enforceInternalState = $3a8bcef306e86159$exports.enforce;
var $09c56ff2ae09b2d7$var$getInternalState = $3a8bcef306e86159$exports.get;
var $09c56ff2ae09b2d7$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $09c56ff2ae09b2d7$var$defineProperty = Object.defineProperty;
var $09c56ff2ae09b2d7$var$stringSlice = $43b18aa2f1faac44$exports(''.slice);
var $09c56ff2ae09b2d7$var$replace = $43b18aa2f1faac44$exports(''.replace);
var $09c56ff2ae09b2d7$var$join = $43b18aa2f1faac44$exports([].join);
var $09c56ff2ae09b2d7$var$CONFIGURABLE_LENGTH = $ef322a7f89c3ed41$exports && !$6140c9fa18232846$exports(function() {
    return $09c56ff2ae09b2d7$var$defineProperty(function() {}, 'length', {
        value: 8
    }).length !== 8;
});
var $09c56ff2ae09b2d7$var$TEMPLATE = String(String).split('String');
var $09c56ff2ae09b2d7$var$makeBuiltIn = $09c56ff2ae09b2d7$exports = function(value, name, options) {
    if ($09c56ff2ae09b2d7$var$stringSlice($09c56ff2ae09b2d7$var$$String(name), 0, 7) === 'Symbol(') name = '[' + $09c56ff2ae09b2d7$var$replace($09c56ff2ae09b2d7$var$$String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;
    if (!$1f868a26fd901990$exports(value, 'name') || $09c56ff2ae09b2d7$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($ef322a7f89c3ed41$exports) $09c56ff2ae09b2d7$var$defineProperty(value, 'name', {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($09c56ff2ae09b2d7$var$CONFIGURABLE_LENGTH && options && $1f868a26fd901990$exports(options, 'arity') && value.length !== options.arity) $09c56ff2ae09b2d7$var$defineProperty(value, 'length', {
        value: options.arity
    });
    try {
        if (options && $1f868a26fd901990$exports(options, 'constructor') && options.constructor) {
            if ($ef322a7f89c3ed41$exports) $09c56ff2ae09b2d7$var$defineProperty(value, 'prototype', {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $09c56ff2ae09b2d7$var$enforceInternalState(value);
    if (!$1f868a26fd901990$exports(state, 'source')) state.source = $09c56ff2ae09b2d7$var$join($09c56ff2ae09b2d7$var$TEMPLATE, typeof name == 'string' ? name : '');
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $09c56ff2ae09b2d7$var$makeBuiltIn(function toString() {
    return $70e34a5a2021f756$exports(this) && $09c56ff2ae09b2d7$var$getInternalState(this).source || $9990f6f719f26a96$exports(this);
}, 'toString');



$40e957865125f98f$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($70e34a5a2021f756$exports(value)) $09c56ff2ae09b2d7$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $4ce407c7007beb63$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $2d0ac3aa5e39584b$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $ef14b437ba65973a$exports = {};
'use strict';

var $339f2419d379e6c2$exports = {};
'use strict';


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $f6c32256739dd9b5$export$2d1720544b23b823;
'use strict';
var $c4fba4611365c4f5$exports = {};
'use strict';



var $f00609c516640f24$exports = {};
'use strict';

var $1ef9432c43157f41$exports = {};
'use strict';
var $b5bb21648546ce5b$exports = {};
'use strict';
var $5395b5a4913a5e32$exports = {};
'use strict';
var $5395b5a4913a5e32$var$ceil = Math.ceil;
var $5395b5a4913a5e32$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$5395b5a4913a5e32$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $5395b5a4913a5e32$var$floor : $5395b5a4913a5e32$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$b5bb21648546ce5b$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $5395b5a4913a5e32$exports(number);
};


var $1ef9432c43157f41$var$max = Math.max;
var $1ef9432c43157f41$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$1ef9432c43157f41$exports = function(index, length) {
    var integer = $b5bb21648546ce5b$exports(index);
    return integer < 0 ? $1ef9432c43157f41$var$max(integer + length, 0) : $1ef9432c43157f41$var$min(integer, length);
};


var $04c91bd3815cd64a$exports = {};
'use strict';
var $4aba983aae3daed3$exports = {};
'use strict';

var $4aba983aae3daed3$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$4aba983aae3daed3$exports = function(argument) {
    var len = $b5bb21648546ce5b$exports(argument);
    return len > 0 ? $4aba983aae3daed3$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$04c91bd3815cd64a$exports = function(obj) {
    return $4aba983aae3daed3$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $f00609c516640f24$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $4d273c9d7e1bdf46$exports($this);
        var length = $04c91bd3815cd64a$exports(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $1ef9432c43157f41$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$f00609c516640f24$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $f00609c516640f24$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $f00609c516640f24$var$createMethod(false)
};


var $c4fba4611365c4f5$require$indexOf = $f00609c516640f24$exports.indexOf;

var $c4fba4611365c4f5$var$push = $43b18aa2f1faac44$exports([].push);
$c4fba4611365c4f5$exports = function(object, names) {
    var O = $4d273c9d7e1bdf46$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$1f868a26fd901990$exports($9f571a3f3d135e31$exports, key) && $1f868a26fd901990$exports(O, key) && $c4fba4611365c4f5$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($1f868a26fd901990$exports(O, key = names[i++])) ~$c4fba4611365c4f5$require$indexOf(result, key) || $c4fba4611365c4f5$var$push(result, key);
    return result;
};


var $e73f13f1d8a17cad$exports = {};
'use strict';
// IE8- don't enum bug keys
$e73f13f1d8a17cad$exports = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];


var $f6c32256739dd9b5$var$hiddenKeys = $e73f13f1d8a17cad$exports.concat('length', 'prototype');
$f6c32256739dd9b5$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $c4fba4611365c4f5$exports(O, $f6c32256739dd9b5$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $0ed66cde5c449819$export$2d1720544b23b823;
'use strict';
$0ed66cde5c449819$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $339f2419d379e6c2$var$concat = $43b18aa2f1faac44$exports([].concat);
// all object keys, includes non-enumerable and symbols
$339f2419d379e6c2$exports = $a5217dbd1b0d33ce$exports('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = $f6c32256739dd9b5$export$2d1720544b23b823($c845d421b7b0e630$exports(it));
    var getOwnPropertySymbols = $0ed66cde5c449819$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $339f2419d379e6c2$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$ef14b437ba65973a$exports = function(target, source, exceptions) {
    var keys = $339f2419d379e6c2$exports(source);
    var defineProperty = $2d0ac3aa5e39584b$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $6d99163b6684d050$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$1f868a26fd901990$exports(target, key) && !(exceptions && $1f868a26fd901990$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $ca268db110e9e457$exports = {};
'use strict';


var $ca268db110e9e457$var$replacement = /#|\.prototype\./;
var $ca268db110e9e457$var$isForced = function(feature, detection) {
    var value = $ca268db110e9e457$var$data[$ca268db110e9e457$var$normalize(feature)];
    return value === $ca268db110e9e457$var$POLYFILL ? true : value === $ca268db110e9e457$var$NATIVE ? false : $70e34a5a2021f756$exports(detection) ? $6140c9fa18232846$exports(detection) : !!detection;
};
var $ca268db110e9e457$var$normalize = $ca268db110e9e457$var$isForced.normalize = function(string) {
    return String(string).replace($ca268db110e9e457$var$replacement, '.').toLowerCase();
};
var $ca268db110e9e457$var$data = $ca268db110e9e457$var$isForced.data = {};
var $ca268db110e9e457$var$NATIVE = $ca268db110e9e457$var$isForced.NATIVE = 'N';
var $ca268db110e9e457$var$POLYFILL = $ca268db110e9e457$var$isForced.POLYFILL = 'P';
$ca268db110e9e457$exports = $ca268db110e9e457$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $ca3e1754e676956d$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $3fbf1185731afe2b$exports;
    else if (STATIC) target = $3fbf1185731afe2b$exports[TARGET] || $4ce407c7007beb63$exports(TARGET, {});
    else target = $3fbf1185731afe2b$exports[TARGET] && $3fbf1185731afe2b$exports[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $ca3e1754e676956d$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $ca268db110e9e457$exports(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $ef14b437ba65973a$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $8693737507995841$exports(sourceProperty, 'sham', true);
        $40e957865125f98f$exports(target, key, sourceProperty, options);
    }
};





var $a78806ef4ebb6167$exports = {};
'use strict';
var $43284f0171045916$exports = {};
'use strict';
var $4828cb1b4c7586c8$exports = {};
'use strict';


$4828cb1b4c7586c8$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($b0ba63bfbfb16088$exports(fn) === 'Function') return $43b18aa2f1faac44$exports(fn);
};




var $43284f0171045916$var$bind = $4828cb1b4c7586c8$exports($4828cb1b4c7586c8$exports.bind);
// optional / simple context binding
$43284f0171045916$exports = function(fn, that) {
    $ae485921c5498156$exports(fn);
    return that === undefined ? fn : $bcbe62e89adc7d37$exports ? $43284f0171045916$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};





var $570a6df80758b4be$exports = {};
'use strict';

var $0fe0dd04b0eb22af$exports = {};
'use strict';
$0fe0dd04b0eb22af$exports = {};


var $570a6df80758b4be$var$ITERATOR = $842f8f0a18746212$exports('iterator');
var $570a6df80758b4be$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$570a6df80758b4be$exports = function(it) {
    return it !== undefined && ($0fe0dd04b0eb22af$exports.Array === it || $570a6df80758b4be$var$ArrayPrototype[$570a6df80758b4be$var$ITERATOR] === it);
};




var $13a4c31eee540026$exports = {};
'use strict';




var $8d560b8b837672a0$exports = {};
'use strict';
var $b07c9aec2f9c74e4$exports = {};
'use strict';
var $a2c149aaa14cc75b$exports = {};
'use strict';

var $a2c149aaa14cc75b$var$TO_STRING_TAG = $842f8f0a18746212$exports('toStringTag');
var $a2c149aaa14cc75b$var$test = {};
$a2c149aaa14cc75b$var$test[$a2c149aaa14cc75b$var$TO_STRING_TAG] = 'z';
$a2c149aaa14cc75b$exports = String($a2c149aaa14cc75b$var$test) === '[object z]';





var $b07c9aec2f9c74e4$var$TO_STRING_TAG = $842f8f0a18746212$exports('toStringTag');
var $b07c9aec2f9c74e4$var$$Object = Object;
// ES3 wrong here
var $b07c9aec2f9c74e4$var$CORRECT_ARGUMENTS = $b0ba63bfbfb16088$exports(function() {
    return arguments;
}()) === 'Arguments';
// fallback for IE11 Script Access Denied error
var $b07c9aec2f9c74e4$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$b07c9aec2f9c74e4$exports = $a2c149aaa14cc75b$exports ? $b0ba63bfbfb16088$exports : function(it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = $b07c9aec2f9c74e4$var$tryGet(O = $b07c9aec2f9c74e4$var$$Object(it), $b07c9aec2f9c74e4$var$TO_STRING_TAG)) == 'string' ? tag : $b07c9aec2f9c74e4$var$CORRECT_ARGUMENTS ? $b0ba63bfbfb16088$exports(O) : (result = $b0ba63bfbfb16088$exports(O)) === 'Object' && $70e34a5a2021f756$exports(O.callee) ? 'Arguments' : result;
};






var $8d560b8b837672a0$var$ITERATOR = $842f8f0a18746212$exports('iterator');
$8d560b8b837672a0$exports = function(it) {
    if (!$7ce250ddf7b42d4d$exports(it)) return $eb80dcd0b8a5698c$exports(it, $8d560b8b837672a0$var$ITERATOR) || $eb80dcd0b8a5698c$exports(it, '@@iterator') || $0fe0dd04b0eb22af$exports[$b07c9aec2f9c74e4$exports(it)];
};


var $13a4c31eee540026$var$$TypeError = TypeError;
$13a4c31eee540026$exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $8d560b8b837672a0$exports(argument) : usingIterator;
    if ($ae485921c5498156$exports(iteratorMethod)) return $c845d421b7b0e630$exports($881ad37dbe259e8f$exports(iteratorMethod, argument));
    throw new $13a4c31eee540026$var$$TypeError($8f0ebae34f61e14c$exports(argument) + ' is not iterable');
};



var $4105790cb9bf2aaa$exports = {};
'use strict';



$4105790cb9bf2aaa$exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $c845d421b7b0e630$exports(iterator);
    try {
        innerResult = $eb80dcd0b8a5698c$exports(iterator, 'return');
        if (!innerResult) {
            if (kind === 'throw') throw value;
            return value;
        }
        innerResult = $881ad37dbe259e8f$exports(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === 'throw') throw value;
    if (innerError) throw innerResult;
    $c845d421b7b0e630$exports(innerResult);
    return value;
};


var $a78806ef4ebb6167$var$$TypeError = TypeError;
var $a78806ef4ebb6167$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $a78806ef4ebb6167$var$ResultPrototype = $a78806ef4ebb6167$var$Result.prototype;
$a78806ef4ebb6167$exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $43284f0171045916$exports(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $4105790cb9bf2aaa$exports(iterator, 'normal', condition);
        return new $a78806ef4ebb6167$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $c845d421b7b0e630$exports(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $8d560b8b837672a0$exports(iterable);
        if (!iterFn) throw new $a78806ef4ebb6167$var$$TypeError($8f0ebae34f61e14c$exports(iterable) + ' is not iterable');
        // optimisation for array iterators
        if ($570a6df80758b4be$exports(iterFn)) {
            for(index = 0, length = $04c91bd3815cd64a$exports(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $41cc576e850a251e$exports($a78806ef4ebb6167$var$ResultPrototype, result)) return result;
            }
            return new $a78806ef4ebb6167$var$Result(false);
        }
        iterator = $13a4c31eee540026$exports(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $881ad37dbe259e8f$exports(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $4105790cb9bf2aaa$exports(iterator, 'throw', error);
        }
        if (typeof result == 'object' && result && $41cc576e850a251e$exports($a78806ef4ebb6167$var$ResultPrototype, result)) return result;
    }
    return new $a78806ef4ebb6167$var$Result(false);
};


var $e055c888a6d66079$exports = {};
'use strict';

// eslint-disable-next-line es/no-map -- safe
var $e055c888a6d66079$var$MapPrototype = Map.prototype;
$e055c888a6d66079$exports = {
    // eslint-disable-next-line es/no-map -- safe
    Map: Map,
    set: $43b18aa2f1faac44$exports($e055c888a6d66079$var$MapPrototype.set),
    get: $43b18aa2f1faac44$exports($e055c888a6d66079$var$MapPrototype.get),
    has: $43b18aa2f1faac44$exports($e055c888a6d66079$var$MapPrototype.has),
    remove: $43b18aa2f1faac44$exports($e055c888a6d66079$var$MapPrototype['delete']),
    proto: $e055c888a6d66079$var$MapPrototype
};




var $37e12fa6c9b33441$var$Map = $e055c888a6d66079$exports.Map;
var $37e12fa6c9b33441$var$has = $e055c888a6d66079$exports.has;
var $37e12fa6c9b33441$var$get = $e055c888a6d66079$exports.get;
var $37e12fa6c9b33441$var$set = $e055c888a6d66079$exports.set;
var $37e12fa6c9b33441$var$push = $43b18aa2f1faac44$exports([].push);
var $37e12fa6c9b33441$var$DOES_NOT_WORK_WITH_PRIMITIVES = $e0409817d4e03fc4$exports || $6140c9fa18232846$exports(function() {
    return $37e12fa6c9b33441$var$Map.groupBy('ab', function(it) {
        return it;
    }).get('a').length !== 1;
});
// `Map.groupBy` method
// https://tc39.es/ecma262/#sec-map.groupby
$ca3e1754e676956d$exports({
    target: 'Map',
    stat: true,
    forced: $e0409817d4e03fc4$exports || $37e12fa6c9b33441$var$DOES_NOT_WORK_WITH_PRIMITIVES
}, {
    groupBy: function groupBy(items, callbackfn) {
        $c378177673193450$exports(items);
        $ae485921c5498156$exports(callbackfn);
        var map = new $37e12fa6c9b33441$var$Map();
        var k = 0;
        $a78806ef4ebb6167$exports(items, function(value) {
            var key = callbackfn(value, k++);
            if (!$37e12fa6c9b33441$var$has(map, key)) $37e12fa6c9b33441$var$set(map, key, [
                value
            ]);
            else $37e12fa6c9b33441$var$push($37e12fa6c9b33441$var$get(map, key), value);
        });
        return map;
    }
});




var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));


var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));



// src/mutationCache.ts
// src/notifyManager.ts
var $e2307e33fb454067$export$7c76da44185e6090 = (cb)=>setTimeout(cb, 0);
function $e2307e33fb454067$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = $e2307e33fb454067$export$7c76da44185e6090;
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
     * All calls to the wrapped function will be batched.
     */ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule: schedule,
        /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
var $e2307e33fb454067$export$520687f44db6e1ab = $e2307e33fb454067$export$316a8efd03cd1458();


// src/mutation.ts

// src/removable.ts
// src/utils.ts
var $938ae10f13d49bdc$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $938ae10f13d49bdc$export$8793edee2d425525() {}
function $938ae10f13d49bdc$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $938ae10f13d49bdc$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $938ae10f13d49bdc$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $938ae10f13d49bdc$export$cb3145f011bda3ac(staleTime, query) {
    return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function $938ae10f13d49bdc$export$8c88ee6f2357230d(enabled, query) {
    return typeof enabled === "function" ? enabled(query) : enabled;
}
function $938ae10f13d49bdc$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $938ae10f13d49bdc$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$938ae10f13d49bdc$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $938ae10f13d49bdc$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($938ae10f13d49bdc$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $938ae10f13d49bdc$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$938ae10f13d49bdc$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $938ae10f13d49bdc$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = options?.queryKeyHashFn || $938ae10f13d49bdc$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $938ae10f13d49bdc$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$938ae10f13d49bdc$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $938ae10f13d49bdc$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return Object.keys(b).every((key)=>$938ae10f13d49bdc$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
function $938ae10f13d49bdc$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $938ae10f13d49bdc$export$7a8558113332b71e(a) && $938ae10f13d49bdc$export$7a8558113332b71e(b);
    if (array || $938ae10f13d49bdc$export$53b83ca8eaab0383(a) && $938ae10f13d49bdc$export$53b83ca8eaab0383(b)) {
        const aItems = array ? a : Object.keys(a);
        const aSize = aItems.length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            if ((!array && aItems.includes(key) || array) && a[key] === void 0 && b[key] === void 0) {
                copy[key] = void 0;
                equalItems++;
            } else {
                copy[key] = $938ae10f13d49bdc$export$77a71fc411098696(a[key], b[key]);
                if (copy[key] === a[key] && a[key] !== void 0) equalItems++;
            }
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $938ae10f13d49bdc$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $938ae10f13d49bdc$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $938ae10f13d49bdc$export$53b83ca8eaab0383(o) {
    if (!$938ae10f13d49bdc$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$938ae10f13d49bdc$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function $938ae10f13d49bdc$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $938ae10f13d49bdc$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
function $938ae10f13d49bdc$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return $938ae10f13d49bdc$export$77a71fc411098696(prevData, data);
    }
    return data;
}
function $938ae10f13d49bdc$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $938ae10f13d49bdc$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $938ae10f13d49bdc$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $938ae10f13d49bdc$export$1aa5a89531b7670d = Symbol();
function $938ae10f13d49bdc$export$c71c44209368a3bc(options, fetchOptions) {
    if (!options.queryFn && fetchOptions?.initialPromise) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === $938ae10f13d49bdc$export$1aa5a89531b7670d) return ()=>Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}


var $e24fc843f912068a$export$e09608847fcc8c59 = class {
    #gcTimeout;
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $938ae10f13d49bdc$export$e539f754e934e270)(this.gcTime)) this.#gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime);
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $938ae10f13d49bdc$export$6acf61af03e62db) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if (this.#gcTimeout) {
            clearTimeout(this.#gcTimeout);
            this.#gcTimeout = void 0;
        }
    }
};


// src/retryer.ts
// src/focusManager.ts
// src/subscribable.ts
var $f28bf069faa02086$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};



var $3f1a0485b2ecb725$export$86f1af424b2ca4de = class extends (0, $f28bf069faa02086$export$d26086b469ecdbcc) {
    #focused;
    #cleanup;
    #setup;
    constructor(){
        super();
        this.#setup = (onFocus)=>{
            if (!(0, $938ae10f13d49bdc$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.#cleanup) this.setEventListener(this.#setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            this.#cleanup?.();
            this.#cleanup = void 0;
        }
    }
    setEventListener(setup) {
        this.#setup = setup;
        this.#cleanup?.();
        this.#cleanup = setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.#focused !== focused;
        if (changed) {
            this.#focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        if (typeof this.#focused === "boolean") return this.#focused;
        return globalThis.document?.visibilityState !== "hidden";
    }
};
var $3f1a0485b2ecb725$export$6bf54661be5b02cf = new $3f1a0485b2ecb725$export$86f1af424b2ca4de();


// src/onlineManager.ts


var $0d08006668a80e57$export$58774fb55d5ff7fc = class extends (0, $f28bf069faa02086$export$d26086b469ecdbcc) {
    #online = true;
    #cleanup;
    #setup;
    constructor(){
        super();
        this.#setup = (onOnline)=>{
            if (!(0, $938ae10f13d49bdc$export$6acf61af03e62db) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.#cleanup) this.setEventListener(this.#setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            this.#cleanup?.();
            this.#cleanup = void 0;
        }
    }
    setEventListener(setup) {
        this.#setup = setup;
        this.#cleanup?.();
        this.#cleanup = setup(this.setOnline.bind(this));
    }
    setOnline(online) {
        const changed = this.#online !== online;
        if (changed) {
            this.#online = online;
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return this.#online;
    }
};
var $0d08006668a80e57$export$b113e788b2dd3fdc = new $0d08006668a80e57$export$58774fb55d5ff7fc();


// src/thenable.ts
function $f6114de20f9a4572$export$d54630db02a12b72() {
    let resolve;
    let reject;
    const thenable = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    thenable.status = "pending";
    thenable.catch(()=>{});
    function finalize(data) {
        Object.assign(thenable, data);
        delete thenable.resolve;
        delete thenable.reject;
    }
    thenable.resolve = (value)=>{
        finalize({
            status: "fulfilled",
            value: value
        });
        resolve(value);
    };
    thenable.reject = (reason)=>{
        finalize({
            status: "rejected",
            reason: reason
        });
        reject(reason);
    };
    return thenable;
}



function $af92dbbbb3fbc9c5$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $af92dbbbb3fbc9c5$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $0d08006668a80e57$export$b113e788b2dd3fdc).isOnline() : true;
}
var $af92dbbbb3fbc9c5$export$a8430ed4188f35a9 = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options?.revert;
        this.silent = options?.silent;
    }
};
function $af92dbbbb3fbc9c5$export$986cc6445c1d323(value) {
    return value instanceof $af92dbbbb3fbc9c5$export$a8430ed4188f35a9;
}
function $af92dbbbb3fbc9c5$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    const thenable = (0, $f6114de20f9a4572$export$d54630db02a12b72)();
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new $af92dbbbb3fbc9c5$export$a8430ed4188f35a9(cancelOptions));
            config.abort?.();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $3f1a0485b2ecb725$export$6bf54661be5b02cf).isFocused() && (config.networkMode === "always" || (0, $0d08006668a80e57$export$b113e788b2dd3fdc).isOnline()) && config.canRun();
    const canStart = ()=>$af92dbbbb3fbc9c5$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess?.(value);
            continueFn?.();
            thenable.resolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError?.(value);
            continueFn?.();
            thenable.reject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                if (isResolved || canContinue()) continueResolve(value);
            };
            config.onPause?.();
        }).then(()=>{
            continueFn = void 0;
            if (!isResolved) config.onContinue?.();
        });
    };
    const run = ()=>{
        if (isResolved) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            if (isResolved) return;
            const retry = config.retry ?? ((0, $938ae10f13d49bdc$export$6acf61af03e62db) ? 0 : 3);
            const retryDelay = config.retryDelay ?? $af92dbbbb3fbc9c5$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            config.onFail?.(failureCount, error);
            (0, $938ae10f13d49bdc$export$e772c8ff12451969)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: thenable,
        cancel: cancel,
        continue: ()=>{
            continueFn?.();
            return thenable;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return thenable;
        }
    };
}


var $524c502dbe70a85f$export$17b8b19c814bcf56 = class extends (0, $e24fc843f912068a$export$e09608847fcc8c59) {
    #observers;
    #mutationCache;
    #retryer;
    constructor(config){
        super();
        this.mutationId = config.mutationId;
        this.#mutationCache = config.mutationCache;
        this.#observers = [];
        this.state = config.state || $524c502dbe70a85f$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!this.#observers.includes(observer)) {
            this.#observers.push(observer);
            this.clearGcTimeout();
            this.#mutationCache.notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.#observers = this.#observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.#mutationCache.notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.#observers.length) {
            if (this.state.status === "pending") this.scheduleGc();
            else this.#mutationCache.remove(this);
        }
    }
    continue() {
        return this.#retryer?.continue() ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        this.#retryer = (0, $af92dbbbb3fbc9c5$export$2cbd00fe8a2c8d85)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                return this.options.mutationFn(variables);
            },
            onFail: (failureCount, error)=>{
                this.#dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.#dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.#dispatch({
                    type: "continue"
                });
            },
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>this.#mutationCache.canRun(this)
        });
        const restored = this.state.status === "pending";
        const isPaused = !this.#retryer.canStart();
        try {
            if (!restored) {
                this.#dispatch({
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                await this.#mutationCache.config.onMutate?.(variables, this);
                const context = await this.options.onMutate?.(variables);
                if (context !== this.state.context) this.#dispatch({
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await this.#retryer.start();
            await this.#mutationCache.config.onSuccess?.(data, variables, this.state.context, this);
            await this.options.onSuccess?.(data, variables, this.state.context);
            await this.#mutationCache.config.onSettled?.(data, null, this.state.variables, this.state.context, this);
            await this.options.onSettled?.(data, null, variables, this.state.context);
            this.#dispatch({
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await this.#mutationCache.config.onError?.(error, variables, this.state.context, this);
                await this.options.onError?.(error, variables, this.state.context);
                await this.#mutationCache.config.onSettled?.(void 0, error, this.state.variables, this.state.context, this);
                await this.options.onSettled?.(void 0, error, variables, this.state.context);
                throw error;
            } finally{
                this.#dispatch({
                    type: "error",
                    error: error
                });
            }
        } finally{
            this.#mutationCache.runNext(this);
        }
    }
    #dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        isPaused: true
                    };
                case "continue":
                    return {
                        ...state,
                        isPaused: false
                    };
                case "pending":
                    return {
                        ...state,
                        context: action.context,
                        data: void 0,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: action.isPaused,
                        status: "pending",
                        variables: action.variables,
                        submittedAt: Date.now()
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: "success",
                        isPaused: false
                    };
                case "error":
                    return {
                        ...state,
                        data: void 0,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: "error"
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.#observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.#mutationCache.notify({
                mutation: this,
                type: "updated",
                action: action
            });
        });
    }
};
function $524c502dbe70a85f$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}




var $217efee59d834f2b$export$1fcfd9a244434844 = class extends (0, $f28bf069faa02086$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        this.#mutations = /* @__PURE__ */ new Set();
        this.#scopes = /* @__PURE__ */ new Map();
        this.#mutationId = 0;
    }
    #mutations;
    #scopes;
    #mutationId;
    build(client, options, state) {
        const mutation = new (0, $524c502dbe70a85f$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++this.#mutationId,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.#mutations.add(mutation);
        const scope = $217efee59d834f2b$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const scopedMutations = this.#scopes.get(scope);
            if (scopedMutations) scopedMutations.push(mutation);
            else this.#scopes.set(scope, [
                mutation
            ]);
        }
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        if (this.#mutations.delete(mutation)) {
            const scope = $217efee59d834f2b$var$scopeFor(mutation);
            if (typeof scope === "string") {
                const scopedMutations = this.#scopes.get(scope);
                if (scopedMutations) {
                    if (scopedMutations.length > 1) {
                        const index = scopedMutations.indexOf(mutation);
                        if (index !== -1) scopedMutations.splice(index, 1);
                    } else if (scopedMutations[0] === mutation) this.#scopes.delete(scope);
                }
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    canRun(mutation) {
        const scope = $217efee59d834f2b$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const mutationsWithSameScope = this.#scopes.get(scope);
            const firstPendingMutation = mutationsWithSameScope?.find((m)=>m.state.status === "pending");
            return !firstPendingMutation || firstPendingMutation === mutation;
        } else return true;
    }
    runNext(mutation) {
        const scope = $217efee59d834f2b$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const foundMutation = this.#scopes.get(scope)?.find((m)=>m !== mutation && m.state.isPaused);
            return foundMutation?.continue() ?? Promise.resolve();
        } else return Promise.resolve();
    }
    clear() {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.#mutations.forEach((mutation)=>{
                this.notify({
                    type: "removed",
                    mutation: mutation
                });
            });
            this.#mutations.clear();
            this.#scopes.clear();
        });
    }
    getAll() {
        return Array.from(this.#mutations);
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $938ae10f13d49bdc$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $938ae10f13d49bdc$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $938ae10f13d49bdc$export$8793edee2d425525)))));
    }
};
function $217efee59d834f2b$var$scopeFor(mutation) {
    return mutation.options.scope?.id;
}

// src/queryCache.ts

// src/query.ts




var $bbb5e4108fb61687$export$62297b13309008b2 = class extends (0, $e24fc843f912068a$export$e09608847fcc8c59) {
    #initialState;
    #revertState;
    #cache;
    #client;
    #retryer;
    #defaultOptions;
    #abortSignalConsumed;
    constructor(config){
        super();
        this.#abortSignalConsumed = false;
        this.#defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.#client = config.client;
        this.#cache = this.#client.getQueryCache();
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.#initialState = $bbb5e4108fb61687$var$getDefaultState(this.options);
        this.state = config.state ?? this.#initialState;
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    get promise() {
        return this.#retryer?.promise;
    }
    setOptions(options) {
        this.options = {
            ...this.#defaultOptions,
            ...options
        };
        this.updateGcTime(this.options.gcTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") this.#cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $938ae10f13d49bdc$export$17619bac5b909b23)(this.state.data, newData, this.options);
        this.#dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options?.updatedAt,
            manual: options?.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.#dispatch({
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        const promise = this.#retryer?.promise;
        this.#retryer?.cancel(options);
        return promise ? promise.then((0, $938ae10f13d49bdc$export$8793edee2d425525)).catch((0, $938ae10f13d49bdc$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.#initialState);
    }
    isActive() {
        return this.observers.some((observer)=>(0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(observer.options.enabled, this) !== false);
    }
    isDisabled() {
        if (this.getObserversCount() > 0) return !this.isActive();
        return this.options.queryFn === (0, $938ae10f13d49bdc$export$1aa5a89531b7670d) || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
    }
    isStale() {
        if (this.state.isInvalidated) return true;
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0;
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || this.state.data === void 0 || !(0, $938ae10f13d49bdc$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer?.refetch({
            cancelRefetch: false
        });
        this.#retryer?.continue();
    }
    onOnline() {
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer?.refetch({
            cancelRefetch: false
        });
        this.#retryer?.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            this.#cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                if (this.#retryer) {
                    if (this.#abortSignalConsumed) this.#retryer.cancel({
                        revert: true
                    });
                    else this.#retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.#cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.#dispatch({
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        if (this.state.fetchStatus !== "idle") {
            if (this.state.data !== void 0 && fetchOptions?.cancelRefetch) this.cancel({
                silent: true
            });
            else if (this.#retryer) {
                this.#retryer.continueRetry();
                return this.#retryer.promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    this.#abortSignalConsumed = true;
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, $938ae10f13d49bdc$export$c71c44209368a3bc)(this.options, fetchOptions);
            const queryFnContext = {
                client: this.#client,
                queryKey: this.queryKey,
                meta: this.meta
            };
            addSignalProperty(queryFnContext);
            this.#abortSignalConsumed = false;
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            client: this.#client,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        this.options.behavior?.onFetch(context, this);
        this.#revertState = this.state;
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== context.fetchOptions?.meta) this.#dispatch({
            type: "fetch",
            meta: context.fetchOptions?.meta
        });
        const onError = (error)=>{
            if (!((0, $af92dbbbb3fbc9c5$export$986cc6445c1d323)(error) && error.silent)) this.#dispatch({
                type: "error",
                error: error
            });
            if (!(0, $af92dbbbb3fbc9c5$export$986cc6445c1d323)(error)) {
                this.#cache.config.onError?.(error, this);
                this.#cache.config.onSettled?.(this.state.data, error, this);
            }
            this.scheduleGc();
        };
        this.#retryer = (0, $af92dbbbb3fbc9c5$export$2cbd00fe8a2c8d85)({
            initialPromise: fetchOptions?.initialPromise,
            fn: context.fetchFn,
            abort: abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                if (data === void 0) {
                    onError(new Error(`${this.queryHash} data is undefined`));
                    return;
                }
                try {
                    this.setData(data);
                } catch (error) {
                    onError(error);
                    return;
                }
                this.#cache.config.onSuccess?.(data, this);
                this.#cache.config.onSettled?.(data, this.state.error, this);
                this.scheduleGc();
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                this.#dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.#dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.#dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        });
        return this.#retryer.start();
    }
    #dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        fetchStatus: "paused"
                    };
                case "continue":
                    return {
                        ...state,
                        fetchStatus: "fetching"
                    };
                case "fetch":
                    return {
                        ...state,
                        ...$bbb5e4108fb61687$export$f3df9013f2b58bce(state.data, this.options),
                        fetchMeta: action.meta ?? null
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: action.dataUpdatedAt ?? Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: "success",
                        ...!action.manual && {
                            fetchStatus: "idle",
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                case "error":
                    const error = action.error;
                    if ((0, $af92dbbbb3fbc9c5$export$986cc6445c1d323)(error) && error.revert && this.#revertState) return {
                        ...this.#revertState,
                        fetchStatus: "idle"
                    };
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: "idle",
                        status: "error"
                    };
                case "invalidate":
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate();
            });
            this.#cache.notify({
                query: this,
                type: "updated",
                action: action
            });
        });
    }
};
function $bbb5e4108fb61687$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $af92dbbbb3fbc9c5$export$61b92f63f30245cf)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $bbb5e4108fb61687$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}




var $74dfca891c706a66$export$5dde0cd941da8468 = class extends (0, $f28bf069faa02086$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        this.#queries = /* @__PURE__ */ new Map();
    }
    #queries;
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $938ae10f13d49bdc$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $bbb5e4108fb61687$export$62297b13309008b2)({
                client: client,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.#queries.has(query.queryHash)) {
            this.#queries.set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.#queries.get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) this.#queries.delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.#queries.get(queryHash);
    }
    getAll() {
        return [
            ...this.#queries.values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $938ae10f13d49bdc$export$c5d1efe363797780)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $938ae10f13d49bdc$export$c5d1efe363797780)(filters, query)) : queries;
    }
    notify(event) {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};

// src/queryClient.ts






// src/infiniteQueryBehavior.ts

function $5e3ed657d3a894dc$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            const options = context.options;
            const direction = context.fetchOptions?.meta?.fetchMore?.direction;
            const oldPages = context.state.data?.pages || [];
            const oldPageParams = context.state.data?.pageParams || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            if (context.signal.aborted) cancelled = true;
                            else context.signal.addEventListener("abort", ()=>{
                                cancelled = true;
                            });
                            return context.signal;
                        }
                    });
                };
                const queryFn = (0, $938ae10f13d49bdc$export$c71c44209368a3bc)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const queryFnContext = {
                        client: context.client,
                        queryKey: context.queryKey,
                        pageParam: param,
                        direction: previous ? "backward" : "forward",
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $938ae10f13d49bdc$export$8c6246b73dd61f4a) : (0, $938ae10f13d49bdc$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $5e3ed657d3a894dc$var$getPreviousPageParam : $5e3ed657d3a894dc$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    const remainingPages = pages ?? oldPages.length;
                    do {
                        const param = currentPage === 0 ? oldPageParams[0] ?? options.initialPageParam : $5e3ed657d3a894dc$var$getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                return context.options.persister?.(fetchFn, {
                    client: context.client,
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $5e3ed657d3a894dc$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function $5e3ed657d3a894dc$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    return pages.length > 0 ? options.getPreviousPageParam?.(pages[0], pages, pageParams[0], pageParams) : void 0;
}
function $5e3ed657d3a894dc$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $5e3ed657d3a894dc$var$getNextPageParam(options, data) != null;
}
function $5e3ed657d3a894dc$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $5e3ed657d3a894dc$var$getPreviousPageParam(options, data) != null;
}


var $83ccb5f70678ce73$export$405d0624ed55a03f = class {
    #queryCache;
    #mutationCache;
    #defaultOptions;
    #queryDefaults;
    #mutationDefaults;
    #mountCount;
    #unsubscribeFocus;
    #unsubscribeOnline;
    constructor(config = {}){
        this.#queryCache = config.queryCache || new (0, $74dfca891c706a66$export$5dde0cd941da8468)();
        this.#mutationCache = config.mutationCache || new (0, $217efee59d834f2b$export$1fcfd9a244434844)();
        this.#defaultOptions = config.defaultOptions || {};
        this.#queryDefaults = /* @__PURE__ */ new Map();
        this.#mutationDefaults = /* @__PURE__ */ new Map();
        this.#mountCount = 0;
    }
    mount() {
        this.#mountCount++;
        if (this.#mountCount !== 1) return;
        this.#unsubscribeFocus = (0, $3f1a0485b2ecb725$export$6bf54661be5b02cf).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                this.#queryCache.onFocus();
            }
        });
        this.#unsubscribeOnline = (0, $0d08006668a80e57$export$b113e788b2dd3fdc).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                this.#queryCache.onOnline();
            }
        });
    }
    unmount() {
        this.#mountCount--;
        if (this.#mountCount !== 0) return;
        this.#unsubscribeFocus?.();
        this.#unsubscribeFocus = void 0;
        this.#unsubscribeOnline?.();
        this.#unsubscribeOnline = void 0;
    }
    isFetching(filters) {
        return this.#queryCache.findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return this.#mutationCache.findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    /**
   * Imperative (non-reactive) way to retrieve data for a QueryKey.
   * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
   *
   * Hint: Do not use this function inside a component, because it won't receive updates.
   * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
   */ getQueryData(queryKey) {
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return this.#queryCache.get(options.queryHash)?.state.data;
    }
    ensureQueryData(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        const query = this.#queryCache.build(this, defaultedOptions);
        const cachedData = query.state.data;
        if (cachedData === void 0) return this.fetchQuery(options);
        if (options.revalidateIfStale && query.isStaleByTime((0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
        return Promise.resolve(cachedData);
    }
    getQueriesData(filters) {
        return this.#queryCache.findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = this.#queryCache.get(defaultedOptions.queryHash);
        const prevData = query?.state.data;
        const data = (0, $938ae10f13d49bdc$export$7f095f455ad5af3f)(updater, prevData);
        if (data === void 0) return void 0;
        return this.#queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>this.#queryCache.findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return this.#queryCache.get(options.queryHash)?.state;
    }
    removeQueries(filters) {
        const queryCache = this.#queryCache;
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = this.#queryCache;
        return (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries({
                type: "active",
                ...filters
            }, options);
        });
    }
    cancelQueries(filters, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>this.#queryCache.findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $938ae10f13d49bdc$export$8793edee2d425525)).catch((0, $938ae10f13d49bdc$export$8793edee2d425525));
    }
    invalidateQueries(filters, options = {}) {
        return (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.#queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters?.refetchType === "none") return Promise.resolve();
            return this.refetchQueries({
                ...filters,
                type: filters?.refetchType ?? filters?.type ?? "active"
            }, options);
        });
    }
    refetchQueries(filters, options = {}) {
        const fetchOptions = {
            ...options,
            cancelRefetch: options.cancelRefetch ?? true
        };
        const promises = (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>this.#queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $938ae10f13d49bdc$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $938ae10f13d49bdc$export$8793edee2d425525));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = this.#queryCache.build(this, defaultedOptions);
        return query.isStaleByTime((0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $938ae10f13d49bdc$export$8793edee2d425525)).catch((0, $938ae10f13d49bdc$export$8793edee2d425525));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, $5e3ed657d3a894dc$export$84470d1367601e8d)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $938ae10f13d49bdc$export$8793edee2d425525)).catch((0, $938ae10f13d49bdc$export$8793edee2d425525));
    }
    ensureInfiniteQueryData(options) {
        options.behavior = (0, $5e3ed657d3a894dc$export$84470d1367601e8d)(options.pages);
        return this.ensureQueryData(options);
    }
    resumePausedMutations() {
        if ((0, $0d08006668a80e57$export$b113e788b2dd3fdc).isOnline()) return this.#mutationCache.resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return this.#queryCache;
    }
    getMutationCache() {
        return this.#mutationCache;
    }
    getDefaultOptions() {
        return this.#defaultOptions;
    }
    setDefaultOptions(options) {
        this.#defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        this.#queryDefaults.set((0, $938ae10f13d49bdc$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...this.#queryDefaults.values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $938ae10f13d49bdc$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        this.#mutationDefaults.set((0, $938ae10f13d49bdc$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...this.#mutationDefaults.values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $938ae10f13d49bdc$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...this.#defaultOptions.queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $938ae10f13d49bdc$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.queryFn === (0, $938ae10f13d49bdc$export$1aa5a89531b7670d)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options?._defaulted) return options;
        return {
            ...this.#defaultOptions.mutations,
            ...options?.mutationKey && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.#queryCache.clear();
        this.#mutationCache.clear();
    }
};


var $acw62 = parcelRequire("acw62");

"use client";
var $c780594f51309d36$export$da112d31b0149f31 = $acw62.createContext(void 0);
var $c780594f51309d36$export$22e77b9572c4fded = (queryClient)=>{
    const client = $acw62.useContext($c780594f51309d36$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $c780594f51309d36$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $acw62.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($c780594f51309d36$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};




var $acw62 = parcelRequire("acw62");
function $8600c5f9d86d8c95$export$cda51eb07c9d035c({ role: role, className: className, disabledBecause: disabledBecause, href: href, children: children, target: target, ...rest }) {
    return href ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
        role: role ?? 'button',
        className: className,
        "aria-disabled": disabledBecause !== undefined,
        title: disabledBecause,
        href: disabledBecause ? undefined : href,
        target: target,
        ...rest,
        children: children
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
}
function $8600c5f9d86d8c95$export$857ebcebc4ae5918({ ...rest }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8600c5f9d86d8c95$var$_MutationButton, {
        type: undefined,
        vars: undefined,
        ...rest
    });
}
function $8600c5f9d86d8c95$export$8b7b7cdfb85d78c5({ ...rest }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8600c5f9d86d8c95$var$_MutationButton, {
        type: "submit",
        ...rest
    });
}
function $8600c5f9d86d8c95$var$_MutationButton({ disabledBecause: disabledBecause, mutation: mutation, vars: vars, onSuccess: onSuccess, onError: onError, children: children, ...rest }) {
    const button = (0, $acw62.useRef)(null);
    const [isPending, setIsPending] = (0, $acw62.useOptimistic)(false);
    async function mutate(variables) {
        if (disabledBecause || !mutation) return;
        setIsPending(true);
        try {
            await mutation.mutateAsync(variables, {
                onSuccess: onSuccess ? (data)=>{
                    onSuccess(new $8600c5f9d86d8c95$var$MutationSuccessEvent('success', {
                        data: data
                    }, button.current));
                } : undefined,
                onError: onError ? (error)=>{
                    onError(new $8600c5f9d86d8c95$var$MutationErrorEvent('error', {
                        error: error
                    }, button.current));
                } : undefined
            });
        } catch (e) {} finally{
            // TODO remove if they fix https://github.com/facebook/react/issues/33545
            (0, $acw62.startTransition)(()=>{
                setIsPending(false);
            });
        }
    }
    return mutation !== null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        ref: button,
        disabled: disabledBecause !== undefined || !mutation || mutation.isPending || isPending,
        "data-pending": isPending ? true : undefined,
        title: disabledBecause ?? (!mutation ? "Loading\u2026" : undefined),
        formAction: vars ? async (data)=>{
            await mutate(vars(data));
        } : undefined,
        onClick: !vars ? (ev)=>{
            if (ev.defaultPrevented) return;
            ev.preventDefault();
            (0, $acw62.startTransition)(async ()=>{
                await mutate(undefined);
            });
        } : undefined,
        ...rest,
        children: [
            children,
            isPending ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("x-spinner", {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
        ]
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
}
class $8600c5f9d86d8c95$var$FakeSyntheticEvent {
    preventDefault() {}
    isDefaultPrevented() {
        return false;
    }
    #propagationStopped;
    stopPropagation() {
        this.#propagationStopped = true;
    }
    isPropagationStopped() {
        return this.#propagationStopped;
    }
    persist() {}
    constructor(type, currentTarget){
        this.bubbles = false;
        this.cancelable = false;
        this.defaultPrevented = false;
        this.eventPhase = 2;
        this.isTrusted = false;
        this.type = type;
        this.currentTarget = currentTarget;
        this.target = currentTarget;
        this.timeStamp = performance.now();
        this.#propagationStopped = false;
    }
}
class $8600c5f9d86d8c95$var$MutationSuccessEvent extends $8600c5f9d86d8c95$var$FakeSyntheticEvent {
    constructor(type, eventInitDict, currentTarget){
        super(type, currentTarget);
        this.data = eventInitDict.data;
    }
}
class $8600c5f9d86d8c95$var$MutationErrorEvent extends $8600c5f9d86d8c95$var$FakeSyntheticEvent {
    constructor(type, eventInitDict, currentTarget){
        super(type, currentTarget);
        this.error = eventInitDict.error;
    }
}




var $acw62 = parcelRequire("acw62");
// src/mutationObserver.ts




var $1ddf06f11bccca52$export$d3c1860ee66f291a = class extends (0, $f28bf069faa02086$export$d26086b469ecdbcc) {
    #client;
    #currentResult = void 0;
    #currentMutation;
    #mutateOptions;
    constructor(client, options){
        super();
        this.#client = client;
        this.setOptions(options);
        this.bindMethods();
        this.#updateResult();
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        const prevOptions = this.options;
        this.options = this.#client.defaultMutationOptions(options);
        if (!(0, $938ae10f13d49bdc$export$3e67810a3f0e9f1c)(this.options, prevOptions)) this.#client.getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: this.#currentMutation,
            observer: this
        });
        if (prevOptions?.mutationKey && this.options.mutationKey && (0, $938ae10f13d49bdc$export$1e87d19d4aab5805)(prevOptions.mutationKey) !== (0, $938ae10f13d49bdc$export$1e87d19d4aab5805)(this.options.mutationKey)) this.reset();
        else if (this.#currentMutation?.state.status === "pending") this.#currentMutation.setOptions(this.options);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.#currentMutation?.removeObserver(this);
    }
    onMutationUpdate(action) {
        this.#updateResult();
        this.#notify(action);
    }
    getCurrentResult() {
        return this.#currentResult;
    }
    reset() {
        this.#currentMutation?.removeObserver(this);
        this.#currentMutation = void 0;
        this.#updateResult();
        this.#notify();
    }
    mutate(variables, options) {
        this.#mutateOptions = options;
        this.#currentMutation?.removeObserver(this);
        this.#currentMutation = this.#client.getMutationCache().build(this.#client, this.options);
        this.#currentMutation.addObserver(this);
        return this.#currentMutation.execute(variables);
    }
    #updateResult() {
        const state = this.#currentMutation?.state ?? (0, $524c502dbe70a85f$export$a1659b54bac3252a)();
        this.#currentResult = {
            ...state,
            isPending: state.status === "pending",
            isSuccess: state.status === "success",
            isError: state.status === "error",
            isIdle: state.status === "idle",
            mutate: this.mutate,
            reset: this.reset
        };
    }
    #notify(action) {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            if (this.#mutateOptions && this.hasListeners()) {
                const variables = this.#currentResult.variables;
                const context = this.#currentResult.context;
                if (action?.type === "success") {
                    this.#mutateOptions.onSuccess?.(action.data, variables, context);
                    this.#mutateOptions.onSettled?.(action.data, null, variables, context);
                } else if (action?.type === "error") {
                    this.#mutateOptions.onError?.(action.error, variables, context);
                    this.#mutateOptions.onSettled?.(void 0, action.error, variables, context);
                }
            }
            this.listeners.forEach((listener)=>{
                listener(this.#currentResult);
            });
        });
    }
};



// src/utils.ts
function $74646d9ca64501e8$export$2072f68e6c3507cf(throwError, params) {
    if (typeof throwError === "function") return throwError(...params);
    return !!throwError;
}
function $74646d9ca64501e8$export$8793edee2d425525() {}


"use client";
function $6a05afbd57376433$export$609860bf8b0084c(options, queryClient) {
    const client = (0, $c780594f51309d36$export$22e77b9572c4fded)(queryClient);
    const [observer] = $acw62.useState(()=>new (0, $1ddf06f11bccca52$export$d3c1860ee66f291a)(client, options));
    $acw62.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = $acw62.useSyncExternalStore($acw62.useCallback((onStoreChange)=>observer.subscribe((0, $e2307e33fb454067$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $acw62.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch((0, $74646d9ca64501e8$export$8793edee2d425525));
    }, [
        observer
    ]);
    if (result.error && (0, $74646d9ca64501e8$export$2072f68e6c3507cf)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
}



var $acw62 = parcelRequire("acw62");
function $25f3549ac7b3cc04$export$d8e990c7994e01bd(ev) {
    ev.preventDefault();
    const dialog = ev.currentTarget.closest('dialog');
    if (dialog?.dispatchEvent(new Event('cancel', {
        cancelable: true
    }))) dialog.close();
}
function $25f3549ac7b3cc04$export$488fee190faedb43({ children: children }) {
    // formmethod="dialog" is not good enough, because it fires the close event, not the cancel event.
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        onClick: $25f3549ac7b3cc04$export$d8e990c7994e01bd,
        children: children
    });
}
function $25f3549ac7b3cc04$export$3ddf2d174ce01153({ mutation: mutation, children: children }) {
    const mydialog = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const dialog = mydialog.current;
        if (mutation.cancel) {
            dialog.showModal();
            dialog.classList.add('shown');
        } else if (dialog.classList.contains('shown')) {
            dialog.classList.remove('shown');
            setTimeout(()=>{
                dialog.close();
            }, 200);
        }
    }, [
        mutation.cancel
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dialog", {
        className: "basic",
        ref: mydialog,
        onCancel: (ev)=>{
            if (ev.defaultPrevented) return;
            ev.preventDefault();
            mutation.cancel();
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Suspense), {
            children: children
        })
    });
}
function $25f3549ac7b3cc04$export$7c29c638d2663c7c(start) {
    const [cancellableIntent, setCancellableIntent] = (0, $acw62.useState)(null);
    const mut = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: async ()=>{
            await new Promise((resolve, reject)=>{
                const intent = start();
                setCancellableIntent({
                    intent: intent,
                    cancel: resolve
                });
                intent.then((intent)=>{
                    if (!intent) resolve();
                }, (reason)=>{
                    reject(reason);
                });
            });
            setCancellableIntent(null);
        }
    });
    return {
        mutateAsync: mut.mutateAsync,
        isPending: cancellableIntent === null ? false : true,
        intent: cancellableIntent === null ? null : cancellableIntent.intent,
        cancel: cancellableIntent === null ? null : cancellableIntent.cancel
    };
}



function $cacb8253df5402d5$var$SegmentedButtonOption({ name: name, value: value, checked: checked, setChecked: setChecked, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "radio",
                name: name,
                value: value,
                checked: checked,
                onChange: (ev)=>{
                    setChecked();
                }
            }),
            " ",
            children
        ]
    });
}
function $cacb8253df5402d5$export$358303cbde861097({ name: name, value: value, setValue: setValue, children: children }) {
    for (const option of children)option.props.value;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-segmented-button": true,
        children: children.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cacb8253df5402d5$var$SegmentedButtonOption, {
                name: name,
                value: option.props.value,
                checked: value === option.props.value,
                setChecked: ()=>setValue(option.props.value),
                children: option.props.children
            }, option.props.value))
    });
}



var $acw62 = parcelRequire("acw62");
let $179b04608e775d68$export$7cd97e17c834df02 = undefined;
if (typeof window !== "undefined" && window.navigation) {
    const navigation = window.navigation;
    $179b04608e775d68$var$assertNavigation(navigation);
    $179b04608e775d68$export$7cd97e17c834df02 = navigation;
}
function $179b04608e775d68$var$assertNavigation(value) {
    if (!value) throw new Error("Expected Navigation");
}


function $2be1ebaf46e66ff0$export$9671ea99bd126ace(value) {
    function isLike(value) {
        return !!value;
    }
    return isLike(value) && (typeof value.type === "string" || typeof value.type === "symbol");
}
function $2be1ebaf46e66ff0$export$b3e112bfd3a4f448(value, type) {
    if (!$2be1ebaf46e66ff0$export$9671ea99bd126ace(value)) throw new Error("Expected event");
    if (typeof type !== "undefined" && value.type !== type) throw new Error(`Expected event type ${String(type)}, got ${value.type.toString()}`);
}


function $91792ca330a5b3d9$export$2067fa03405bba6d(value) {
    return (0, $2be1ebaf46e66ff0$export$9671ea99bd126ace)(value) && value.parallel !== false;
}



class $a52002d449639897$export$18b052ffd8c84d7 extends Error {
    constructor(message){
        super(`AbortError${message ? `: ${message}` : ""}`);
        this.name = "AbortError";
    }
}
function $a52002d449639897$export$d2c30ea522b3259e(error) {
    return error instanceof Error && error.name === "AbortError";
}
class $a52002d449639897$export$b251fc1661a3152d extends Error {
    constructor(message){
        super(`InvalidStateError${message ? `: ${message}` : ""}`);
        this.name = "InvalidStateError";
    }
}
function $a52002d449639897$export$3c2c840c2f50edf4(error) {
    return error instanceof Error && error.name === "InvalidStateError";
}


function $5170b4b0adb4435d$export$8fb8889db6ef9202(value) {
    function isAbortSignalLike(value) {
        return typeof value === "object";
    }
    return isAbortSignalLike(value) && typeof value.aborted === "boolean" && typeof value.addEventListener === "function";
}
function $5170b4b0adb4435d$export$2e263014b1ee279f(value) {
    function isAbortControllerLike(value) {
        return typeof value === "object";
    }
    return isAbortControllerLike(value) && typeof value.abort === "function" && $5170b4b0adb4435d$export$8fb8889db6ef9202(value.signal);
}
function $5170b4b0adb4435d$export$48c7997137bc95de(value) {
    function isSignalEventLike(value) {
        return value.hasOwnProperty("signal");
    }
    return (0, $2be1ebaf46e66ff0$export$9671ea99bd126ace)(value) && isSignalEventLike(value) && $5170b4b0adb4435d$export$8fb8889db6ef9202(value.signal);
}
function $5170b4b0adb4435d$export$e2fcd5ba498e3bdb(event, error) {
    if ($5170b4b0adb4435d$export$48c7997137bc95de(event) && event.signal.aborted && error instanceof Error && (0, $a52002d449639897$export$d2c30ea522b3259e)(error)) return true;
}



/**
 * @experimental
 */ const $a3a1ae9ed3ef743c$export$fbd154b5770d63aa = Symbol.for("@opennetwork/environment/events/target/listeners");
const $a3a1ae9ed3ef743c$export$eac13c622e4b254d = Symbol.for("@opennetwork/environment/events/target/listeners/ignore");
const $a3a1ae9ed3ef743c$export$2933d823a8fe1702 = Symbol.for("@opennetwork/environment/events/target/listeners/match");
const $a3a1ae9ed3ef743c$export$df4f535c2662fcc6 = Symbol.for("@opennetwork/environment/events/target/listeners/this");


const $5749d3109afb8ed5$export$6de80ec085c730d9 = Symbol.for("@opennetwork/environment/events/descriptor");



function $d4c35942b8933c9e$export$9ade392b281c8422(type, callback, options) {
    const optionsDescriptor = isOptionsDescriptor(options) ? options : undefined;
    return (descriptor)=>{
        if (optionsDescriptor) return optionsDescriptor === descriptor;
        return (!callback || callback === descriptor.callback) && type === descriptor.type;
    };
    function isOptionsDescriptor(options) {
        function isLike(options) {
            return !!options;
        }
        return isLike(options) && options[0, $5749d3109afb8ed5$export$6de80ec085c730d9] === true;
    }
}





function $e2e3bcf8ee511b58$var$isFunctionEventCallback(fn) {
    return typeof fn === "function";
}
const $e2e3bcf8ee511b58$var$EventTargetDescriptors = Symbol.for("@virtualstate/navigation/event-target/descriptors");
class $e2e3bcf8ee511b58$export$fbd154b5770d63aa {
    [$e2e3bcf8ee511b58$var$EventTargetDescriptors] = [];
    [(0, $a3a1ae9ed3ef743c$export$eac13c622e4b254d)] = new WeakSet();
    get [(0, $a3a1ae9ed3ef743c$export$fbd154b5770d63aa)]() {
        return [
            ...this[$e2e3bcf8ee511b58$var$EventTargetDescriptors] ?? []
        ];
    }
    [(0, $a3a1ae9ed3ef743c$export$2933d823a8fe1702)](type) {
        const external = this[0, $a3a1ae9ed3ef743c$export$fbd154b5770d63aa];
        const matched = [
            ...new Set([
                ...external ?? [],
                ...this[$e2e3bcf8ee511b58$var$EventTargetDescriptors] ?? []
            ])
        ].filter((descriptor)=>descriptor.type === type || descriptor.type === "*").filter((descriptor)=>!this[0, $a3a1ae9ed3ef743c$export$eac13c622e4b254d]?.has(descriptor));
        const listener = typeof type === "string" ? this[`on${type}`] : undefined;
        if (typeof listener === "function" && $e2e3bcf8ee511b58$var$isFunctionEventCallback(listener)) matched.push({
            type: type,
            callback: listener,
            [(0, $5749d3109afb8ed5$export$6de80ec085c730d9)]: true
        });
        return matched;
    }
    addEventListener(type, callback, options) {
        const listener = {
            ...options,
            isListening: ()=>!!this[$e2e3bcf8ee511b58$var$EventTargetDescriptors]?.find((0, $d4c35942b8933c9e$export$9ade392b281c8422)(type, callback)),
            descriptor: {
                [(0, $5749d3109afb8ed5$export$6de80ec085c730d9)]: true,
                ...options,
                type: type,
                callback: callback
            },
            timestamp: Date.now()
        };
        if (listener.isListening()) return;
        this[$e2e3bcf8ee511b58$var$EventTargetDescriptors]?.push(listener.descriptor);
    }
    removeEventListener(type, callback, options) {
        if (!$e2e3bcf8ee511b58$var$isFunctionEventCallback(callback)) return;
        const externalListeners = this[0, $a3a1ae9ed3ef743c$export$fbd154b5770d63aa] ?? this[$e2e3bcf8ee511b58$var$EventTargetDescriptors] ?? [];
        const externalIndex = externalListeners.findIndex((0, $d4c35942b8933c9e$export$9ade392b281c8422)(type, callback, options));
        if (externalIndex === -1) return;
        const index = this[$e2e3bcf8ee511b58$var$EventTargetDescriptors]?.findIndex((0, $d4c35942b8933c9e$export$9ade392b281c8422)(type, callback, options)) ?? -1;
        if (index !== -1) this[$e2e3bcf8ee511b58$var$EventTargetDescriptors]?.splice(index, 1);
        const descriptor = externalListeners[externalIndex];
        if (descriptor) this[0, $a3a1ae9ed3ef743c$export$eac13c622e4b254d]?.add(descriptor);
    }
    hasEventListener(type, callback) {
        if (callback && !$e2e3bcf8ee511b58$var$isFunctionEventCallback(callback)) return false;
        const foundIndex = this[$e2e3bcf8ee511b58$var$EventTargetDescriptors]?.findIndex((0, $d4c35942b8933c9e$export$9ade392b281c8422)(type, callback)) ?? -1;
        return foundIndex > -1;
    }
}
function $e2e3bcf8ee511b58$export$e2fcd5ba498e3bdb(event, error) {
    if ((0, $5170b4b0adb4435d$export$48c7997137bc95de)(event) && event.signal.aborted && error instanceof Error && (0, $a52002d449639897$export$d2c30ea522b3259e)(error)) return true;
}


class $96453b2084624330$export$a46c3fcba5e3b3d1 extends (0, $e2e3bcf8ee511b58$export$fbd154b5770d63aa) {
    [(0, $a3a1ae9ed3ef743c$export$df4f535c2662fcc6)];
    constructor(thisValue){
        super();
        this[0, $a3a1ae9ed3ef743c$export$df4f535c2662fcc6] = thisValue;
    }
    async dispatchEvent(event) {
        const listeners = this[0, $a3a1ae9ed3ef743c$export$2933d823a8fe1702]?.(event.type) ?? [];
        // Don't even dispatch an aborted event
        if ((0, $5170b4b0adb4435d$export$48c7997137bc95de)(event) && event.signal.aborted) throw new (0, $a52002d449639897$export$18b052ffd8c84d7)();
        const parallel = (0, $91792ca330a5b3d9$export$2067fa03405bba6d)(event);
        const promises = [];
        for(let index = 0; index < listeners.length; index += 1){
            const descriptor = listeners[index];
            const promise = (async ()=>{
                // Remove the listener before invoking the callback
                // This ensures that inside of the callback causes no more additional event triggers to this
                // listener
                if (descriptor.once) // by passing the descriptor as the options, we get an internal redirect
                // that forces an instance level object equals, meaning
                // we will only remove _this_ descriptor!
                this.removeEventListener(descriptor.type, descriptor.callback, descriptor);
                await descriptor.callback.call(this[0, $a3a1ae9ed3ef743c$export$df4f535c2662fcc6] ?? this, event);
            })();
            if (!parallel) {
                try {
                    await promise;
                } catch (error) {
                    if (!(0, $5170b4b0adb4435d$export$e2fcd5ba498e3bdb)(event, error)) await Promise.reject(error);
                }
                if ((0, $5170b4b0adb4435d$export$48c7997137bc95de)(event) && event.signal.aborted) // bye
                return;
            } else promises.push(promise);
        }
        if (promises.length) {
            // Allows for all promises to settle finish so we can stay within the event, we then
            // will utilise Promise.all which will reject with the first rejected promise
            const results = await Promise.allSettled(promises);
            const rejected = results.filter((result)=>{
                return result.status === "rejected";
            });
            if (rejected.length) {
                let unhandled = rejected;
                // If the event was aborted, then allow abort errors to occur, and handle these as handled errors
                // The dispatcher does not care about this because they requested it
                //
                // There may be other unhandled errors that are more pressing to the task they are doing.
                //
                // The dispatcher can throw an abort error if they need to throw it up the chain
                if ((0, $5170b4b0adb4435d$export$48c7997137bc95de)(event) && event.signal.aborted) unhandled = unhandled.filter((result)=>!(0, $5170b4b0adb4435d$export$e2fcd5ba498e3bdb)(event, result.reason));
                if (unhandled.length === 1) {
                    await Promise.reject(unhandled[0].reason);
                    throw unhandled[0].reason; // We shouldn't get here
                } else if (unhandled.length > 1) throw new AggregateError(unhandled.map(({ reason: reason })=>reason));
            }
        }
    }
}


const $a115c0998f194487$var$defaultEventTargetModule = {
    EventTarget: (0, $96453b2084624330$export$a46c3fcba5e3b3d1),
    AsyncEventTarget: $96453b2084624330$export$a46c3fcba5e3b3d1,
    SyncEventTarget: (0, $96453b2084624330$export$a46c3fcba5e3b3d1)
};
let $a115c0998f194487$var$eventTargetModule = $a115c0998f194487$var$defaultEventTargetModule;
//
// try {
//     eventTargetModule = await import("@virtualstate/navigation/event-target");
//     console.log("Using @virtualstate/navigation/event-target", eventTargetModule);
// } catch {
//     console.log("Using defaultEventTargetModule");
//     eventTargetModule = defaultEventTargetModule;
// }
const $a115c0998f194487$var$EventTargetImplementation = $a115c0998f194487$var$eventTargetModule.EventTarget || $a115c0998f194487$var$eventTargetModule.SyncEventTarget || $a115c0998f194487$var$eventTargetModule.AsyncEventTarget;
function $a115c0998f194487$var$assertEventTarget(target) {
    if (typeof target !== "function") throw new Error("Could not load EventTarget implementation");
}
class $a115c0998f194487$export$648eec84020a2b10 extends (0, $96453b2084624330$export$a46c3fcba5e3b3d1) {
    constructor(...args){
        super();
        if ($a115c0998f194487$var$EventTargetImplementation) {
            $a115c0998f194487$var$assertEventTarget($a115c0998f194487$var$EventTargetImplementation);
            const { dispatchEvent: dispatchEvent } = new $a115c0998f194487$var$EventTargetImplementation(...args);
            this.dispatchEvent = dispatchEvent;
        }
    }
}











class $59fb29ec9303510a$export$8c30d737b03b98a0 extends (0, $e2e3bcf8ee511b58$export$fbd154b5770d63aa) {
    [(0, $a3a1ae9ed3ef743c$export$df4f535c2662fcc6)];
    constructor(thisValue){
        super();
        this[0, $a3a1ae9ed3ef743c$export$df4f535c2662fcc6] = thisValue;
    }
    dispatchEvent(event) {
        const listeners = this[0, $a3a1ae9ed3ef743c$export$2933d823a8fe1702]?.(event.type) ?? [];
        // Don't even dispatch an aborted event
        if ((0, $5170b4b0adb4435d$export$48c7997137bc95de)(event) && event.signal.aborted) throw new (0, $a52002d449639897$export$18b052ffd8c84d7)();
        for(let index = 0; index < listeners.length; index += 1){
            const descriptor = listeners[index];
            // Remove the listener before invoking the callback
            // This ensures that inside of the callback causes no more additional event triggers to this
            // listener
            if (descriptor.once) // by passing the descriptor as the options, we get an internal redirect
            // that forces an instance level object equals, meaning
            // we will only remove _this_ descriptor!
            this.removeEventListener(descriptor.type, descriptor.callback, descriptor);
            try {
                descriptor.callback.call(this[0, $a3a1ae9ed3ef743c$export$df4f535c2662fcc6] ?? this, event);
            } catch (error) {
                if (!(0, $5170b4b0adb4435d$export$e2fcd5ba498e3bdb)(event, error)) throw error;
            }
            if ((0, $5170b4b0adb4435d$export$48c7997137bc95de)(event) && event.signal.aborted) throw new (0, $a52002d449639897$export$18b052ffd8c84d7)();
        }
    }
}




function $435caa4fe4cd0ed1$export$6f5bcba59178a7ae(value) {
    function isInterceptEventLike(value) {
        return (0, $2be1ebaf46e66ff0$export$9671ea99bd126ace)(value);
    }
    return isInterceptEventLike(value) && typeof value.intercept === "function";
}




class $42cfb527d3c25157$export$792e6c53c031b501 extends (0, $a115c0998f194487$export$648eec84020a2b10) {
    addEventListener(type, listener, options) {
        assertEventCallback(listener);
        return super.addEventListener(type, listener, typeof options === "boolean" ? {
            once: options
        } : options);
        function assertEventCallback(listener) {
            if (typeof listener !== "function") throw new Error("Please us the function variant of event listener");
        }
    }
    removeEventListener(type, listener, options) {
        assertEventCallback(listener);
        return super.removeEventListener(type, listener);
        function assertEventCallback(listener) {
            if (typeof listener !== "function") throw new Error("Please us the function variant of event listener");
        }
    }
}



const $a777f6d8c654ab05$var$isWebCryptoSupported = "crypto" in globalThis && typeof globalThis.crypto.randomUUID === "function";
const $a777f6d8c654ab05$export$afaf85bc510dd0d6 = $a777f6d8c654ab05$var$isWebCryptoSupported ? globalThis.crypto.randomUUID.bind(globalThis.crypto) : ()=>Array.from({
        length: 5
    }, ()=>`${Math.random()}`.replace(/^0\./, "")).join("-").replace(".", "");


// To prevent cyclic imports, where a circular is used, instead use the prototype interface
// and then copy over the "private" symbol
const $d39a6d1af7a1320e$var$NavigationGetState = Symbol.for("@virtualstate/navigation/getState");
const $d39a6d1af7a1320e$export$e898b85e70a9bba1 = Symbol.for("@virtualstate/navigation/entry/navigationType");
const $d39a6d1af7a1320e$export$917d66dd2393ec9 = Symbol.for("@virtualstate/navigation/entry/knownAs");
const $d39a6d1af7a1320e$export$9d1b4bef73c5a796 = Symbol.for("@virtualstate/navigation/entry/setState");
function $d39a6d1af7a1320e$var$isPrimitiveValue(state) {
    return typeof state === "number" || typeof state === "boolean" || typeof state === "symbol" || typeof state === "bigint" || typeof state === "string";
}
function $d39a6d1af7a1320e$var$isValue(state) {
    return !!(state || $d39a6d1af7a1320e$var$isPrimitiveValue(state));
}
class $d39a6d1af7a1320e$export$a26b5d4ae65022a0 extends (0, $42cfb527d3c25157$export$792e6c53c031b501) {
    #index;
    #state;
    get index() {
        return typeof this.#index === "number" ? this.#index : this.#index();
    }
    key;
    id;
    url;
    sameDocument;
    get [$d39a6d1af7a1320e$export$e898b85e70a9bba1]() {
        return this.#options.navigationType;
    }
    get [$d39a6d1af7a1320e$export$917d66dd2393ec9]() {
        const set = new Set(this.#options[$d39a6d1af7a1320e$export$917d66dd2393ec9]);
        set.add(this.id);
        return set;
    }
    #options;
    get [(0, $a3a1ae9ed3ef743c$export$fbd154b5770d63aa)]() {
        return [
            ...super[0, $a3a1ae9ed3ef743c$export$fbd154b5770d63aa] ?? [],
            ...this.#options[0, $a3a1ae9ed3ef743c$export$fbd154b5770d63aa] ?? []
        ];
    }
    constructor(init){
        super();
        this.#options = init;
        this.key = init.key || (0, $a777f6d8c654ab05$export$afaf85bc510dd0d6)();
        this.id = (0, $a777f6d8c654ab05$export$afaf85bc510dd0d6)();
        this.url = init.url ?? undefined;
        this.#index = init.index;
        this.sameDocument = init.sameDocument ?? true;
        this.#state = init.state ?? undefined;
    }
    [$d39a6d1af7a1320e$var$NavigationGetState]() {
        return this.#options?.getState?.(this);
    }
    getState() {
        let state = this.#state;
        if (!$d39a6d1af7a1320e$var$isValue(state)) {
            const external = this[$d39a6d1af7a1320e$var$NavigationGetState]();
            if ($d39a6d1af7a1320e$var$isValue(external)) state = this.#state = external;
        }
        /**
         * https://github.com/WICG/app-history/blob/7c0332b30746b14863f717404402bc49e497a2b2/spec.bs#L1406
         * Note that in general, unless the state value is a primitive, entry.getState() !== entry.getState(), since a fresh copy is returned each time.
         */ if (typeof state === "undefined" || $d39a6d1af7a1320e$var$isPrimitiveValue(state)) return state;
        if (typeof state === "function") {
            console.warn("State passed to Navigation.navigate was a function, this may be unintentional");
            console.warn("Unless a state value is primitive, with a standard implementation of Navigation");
            console.warn("your state value will be serialized and deserialized before this point, meaning");
            console.warn("a function would not be usable.");
        }
        return {
            ...state
        };
    }
    [$d39a6d1af7a1320e$export$9d1b4bef73c5a796](state) {
        this.#state = state;
    }
}





/**
 * @param handleCatch rejected promises automatically to allow free usage
 */ function $4fa8f0314a30e68a$export$b37aab7cecdd910a(handleCatch) {
    let resolve = undefined, reject = undefined;
    const promise = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    $4fa8f0314a30e68a$var$ok(resolve);
    $4fa8f0314a30e68a$var$ok(reject);
    return {
        resolve: resolve,
        reject: reject,
        promise: handleCatch ? promise.catch(handleCatch) : promise
    };
}
function $4fa8f0314a30e68a$var$ok(value) {
    if (!value) throw new Error("Value not provided");
}




const $f7245913a1e34b9e$export$6acf73fc75e074d6 = typeof AbortController !== "undefined" ? AbortController : undefined;


if (!(0, $f7245913a1e34b9e$export$6acf73fc75e074d6)) throw new Error("AbortController expected to be available or polyfilled");
const $1f241e6fe62a87d2$export$48f7e099c149af88 = (0, $f7245913a1e34b9e$export$6acf73fc75e074d6);


function $7eb4e6f571ed6cae$export$4369c812aac99591(value) {
    return $7eb4e6f571ed6cae$export$e94e5ec04a02879c(value) && typeof value.then === "function";
}
function $7eb4e6f571ed6cae$export$dcb8b3f0e2de7e49(value, message = "Expected value") {
    if (!value) throw new Error(message);
}
function $7eb4e6f571ed6cae$export$3d37f2d7023409fe(value) {
    return value.status === "rejected";
}
function $7eb4e6f571ed6cae$export$e94e5ec04a02879c(value) {
    return !!value;
}


const $527ac3ea9aeb1f18$var$THIS_WILL_BE_REMOVED = "This will be removed when the first major release of @virtualstate/navigation is published";
const $527ac3ea9aeb1f18$var$WARNINGS = {
    EVENT_INTERCEPT_HANDLER: `You are using a non standard interface, please update your code to use event.intercept({ async handler() {} })\n${$527ac3ea9aeb1f18$var$THIS_WILL_BE_REMOVED}`
};
let $527ac3ea9aeb1f18$var$GLOBAL_IS_WARNINGS_IGNORED = false;
let $527ac3ea9aeb1f18$var$GLOBAL_IS_WARNINGS_TRACED = true;
function $527ac3ea9aeb1f18$export$a8f5ced8d0e95c4c(ignore) {
    $527ac3ea9aeb1f18$var$GLOBAL_IS_WARNINGS_IGNORED = ignore;
}
function $527ac3ea9aeb1f18$export$417cdc740fdb6cee(ignore) {
    $527ac3ea9aeb1f18$var$GLOBAL_IS_WARNINGS_TRACED = ignore;
}
function $527ac3ea9aeb1f18$export$ebd6064652549ce9(warning, ...message) {
    if ($527ac3ea9aeb1f18$var$GLOBAL_IS_WARNINGS_IGNORED) return;
    try {
        if ($527ac3ea9aeb1f18$var$GLOBAL_IS_WARNINGS_TRACED) console.trace($527ac3ea9aeb1f18$var$WARNINGS[warning], ...message);
        else console.warn($527ac3ea9aeb1f18$var$WARNINGS[warning], ...message);
    } catch  {
    // We don't want attempts to log causing issues
    // maybe we don't have a console
    }
}


const $ea85f7056740ec00$export$7120dacfaec4cc51 = Symbol.for("@virtualstate/navigation/rollback");
const $ea85f7056740ec00$export$5da459000fb5cd5d = Symbol.for("@virtualstate/navigation/unset");
const $ea85f7056740ec00$export$27a3f42c68f838e8 = Symbol.for("@virtualstate/navigation/transition/parentEventTarget");
const $ea85f7056740ec00$export$53d274ff6cf27e72 = Symbol.for("@virtualstate/navigation/transition/deferred/finished");
const $ea85f7056740ec00$export$75e8373815314e38 = Symbol.for("@virtualstate/navigation/transition/deferred/committed");
const $ea85f7056740ec00$export$51ca3b558101ee70 = Symbol.for("@virtualstate/navigation/transition/navigationType");
const $ea85f7056740ec00$export$608af6101082792f = Symbol.for("@virtualstate/navigation/transition/entries/initial");
const $ea85f7056740ec00$export$b3aa1a30c1be6ccf = Symbol.for("@virtualstate/navigation/transition/entries/finished");
const $ea85f7056740ec00$export$cd7d645b85723832 = Symbol.for("@virtualstate/navigation/transition/index/initial");
const $ea85f7056740ec00$export$eec296038e945a73 = Symbol.for("@virtualstate/navigation/transition/index/finished");
const $ea85f7056740ec00$export$98f7c008938296e8 = Symbol.for("@virtualstate/navigation/transition/entry");
const $ea85f7056740ec00$export$b800289c89bdaaf3 = Symbol.for("@virtualstate/navigation/transition/isCommitted");
const $ea85f7056740ec00$export$69f2a32f51f09215 = Symbol.for("@virtualstate/navigation/transition/isFinished");
const $ea85f7056740ec00$export$9ffb7c01bcc2234f = Symbol.for("@virtualstate/navigation/transition/isRejected");
const $ea85f7056740ec00$export$8c9121c6a72fae8a = Symbol.for("@virtualstate/navigation/transition/known");
const $ea85f7056740ec00$export$45671a2ef776443d = Symbol.for("@virtualstate/navigation/transition/promises");
const $ea85f7056740ec00$export$e85ed60a89cb8005 = Symbol.for("@virtualstate/navigation/intercept");
const $ea85f7056740ec00$export$b7070e52b60cc6df = Symbol.for("@virtualstate/navigation/transition/isOngoing");
const $ea85f7056740ec00$export$b713da2f1a748c68 = Symbol.for("@virtualstate/navigation/transition/isPending");
const $ea85f7056740ec00$export$e886b3d682640d85 = Symbol.for("@virtualstate/navigation/transition/isAsync");
const $ea85f7056740ec00$export$c1c2d0f134ac5619 = Symbol.for("@virtualstate/navigation/transition/wait");
const $ea85f7056740ec00$export$ff9ce26ee90a6553 = Symbol.for("@virtualstate/navigation/transition/promise/resolved");
const $ea85f7056740ec00$export$e16e101a1029cd84 = Symbol.for("@virtualstate/navigation/transition/rejected");
const $ea85f7056740ec00$export$5771dbe7ac52e162 = Symbol.for("@virtualstate/navigation/transition/commit");
const $ea85f7056740ec00$export$f900dcbbc6493d39 = Symbol.for("@virtualstate/navigation/transition/finish");
const $ea85f7056740ec00$export$a2e9fc3e5bd44093 = Symbol.for("@virtualstate/navigation/transition/start");
const $ea85f7056740ec00$export$f8d26213ff40b8ab = Symbol.for("@virtualstate/navigation/transition/start/deadline");
const $ea85f7056740ec00$export$93b29e3d61aa456f = Symbol.for("@virtualstate/navigation/transition/error");
const $ea85f7056740ec00$export$122fd4ab5408eace = Symbol.for("@virtualstate/navigation/transition/finally");
const $ea85f7056740ec00$export$749b993fcfdc629f = Symbol.for("@virtualstate/navigation/transition/abort");
const $ea85f7056740ec00$export$1bc62e618753f7b5 = Symbol.for("@virtualstate/navigation/transition/intercept/options/commit");
const $ea85f7056740ec00$export$23635c7475f4b84b = Symbol.for("@virtualstate/navigation/transition/commit/isManual");
class $ea85f7056740ec00$export$6f37f4a617702ecc extends (0, $a115c0998f194487$export$648eec84020a2b10) {
    finished;
    /**
     * @experimental
     */ committed;
    from;
    navigationType;
    /**
     * true if transition has an async intercept
     */ [$ea85f7056740ec00$export$e886b3d682640d85] = false;
    /**
     * @experimental
     */ [$ea85f7056740ec00$export$1bc62e618753f7b5];
    #options;
    [$ea85f7056740ec00$export$53d274ff6cf27e72] = (0, $4fa8f0314a30e68a$export$b37aab7cecdd910a)();
    [$ea85f7056740ec00$export$75e8373815314e38] = (0, $4fa8f0314a30e68a$export$b37aab7cecdd910a)();
    get [$ea85f7056740ec00$export$b713da2f1a748c68]() {
        return !!this.#promises.size;
    }
    get [$ea85f7056740ec00$export$51ca3b558101ee70]() {
        return this.#options[$ea85f7056740ec00$export$51ca3b558101ee70];
    }
    get [$ea85f7056740ec00$export$608af6101082792f]() {
        return this.#options[$ea85f7056740ec00$export$608af6101082792f];
    }
    get [$ea85f7056740ec00$export$cd7d645b85723832]() {
        return this.#options[$ea85f7056740ec00$export$cd7d645b85723832];
    }
    get [$ea85f7056740ec00$export$23635c7475f4b84b]() {
        return !!(this[$ea85f7056740ec00$export$1bc62e618753f7b5]?.includes("after-transition") || this[$ea85f7056740ec00$export$1bc62e618753f7b5]?.includes("manual"));
    }
    [$ea85f7056740ec00$export$b3aa1a30c1be6ccf];
    [$ea85f7056740ec00$export$eec296038e945a73];
    [$ea85f7056740ec00$export$b800289c89bdaaf3] = false;
    [$ea85f7056740ec00$export$69f2a32f51f09215] = false;
    [$ea85f7056740ec00$export$9ffb7c01bcc2234f] = false;
    [$ea85f7056740ec00$export$b7070e52b60cc6df] = false;
    [$ea85f7056740ec00$export$8c9121c6a72fae8a] = new Set();
    [$ea85f7056740ec00$export$98f7c008938296e8];
    #promises = new Set();
    #rolledBack = false;
    #abortController = new (0, $1f241e6fe62a87d2$export$48f7e099c149af88)();
    get signal() {
        return this.#abortController.signal;
    }
    get [$ea85f7056740ec00$export$45671a2ef776443d]() {
        return this.#promises;
    }
    constructor(init){
        super();
        this[$ea85f7056740ec00$export$1bc62e618753f7b5] = [];
        this[$ea85f7056740ec00$export$53d274ff6cf27e72] = init[$ea85f7056740ec00$export$53d274ff6cf27e72] ?? this[$ea85f7056740ec00$export$53d274ff6cf27e72];
        this[$ea85f7056740ec00$export$75e8373815314e38] = init[$ea85f7056740ec00$export$75e8373815314e38] ?? this[$ea85f7056740ec00$export$75e8373815314e38];
        this.#options = init;
        const finished = this.finished = this[$ea85f7056740ec00$export$53d274ff6cf27e72].promise;
        const committed = this.committed = this[$ea85f7056740ec00$export$75e8373815314e38].promise;
        // Auto catching abort
        finished.catch((error)=>error);
        committed.catch((error)=>error);
        this.from = init.from;
        this.navigationType = init.navigationType;
        this[$ea85f7056740ec00$export$b3aa1a30c1be6ccf] = init[$ea85f7056740ec00$export$b3aa1a30c1be6ccf];
        this[$ea85f7056740ec00$export$eec296038e945a73] = init[$ea85f7056740ec00$export$eec296038e945a73];
        const known = init[$ea85f7056740ec00$export$8c9121c6a72fae8a];
        if (known) for (const entry of known)this[$ea85f7056740ec00$export$8c9121c6a72fae8a].add(entry);
        this[$ea85f7056740ec00$export$98f7c008938296e8] = init[$ea85f7056740ec00$export$98f7c008938296e8];
        this.addEventListener($ea85f7056740ec00$export$5771dbe7ac52e162, this.#onCommitPromise, {
            once: true
        });
        this.addEventListener($ea85f7056740ec00$export$f900dcbbc6493d39, this.#onFinishPromise, {
            once: true
        });
        this.addEventListener($ea85f7056740ec00$export$5771dbe7ac52e162, this.#onCommitSetProperty, {
            once: true
        });
        this.addEventListener($ea85f7056740ec00$export$f900dcbbc6493d39, this.#onFinishSetProperty, {
            once: true
        });
        this.addEventListener($ea85f7056740ec00$export$93b29e3d61aa456f, this.#onError, {
            once: true
        });
        this.addEventListener($ea85f7056740ec00$export$749b993fcfdc629f, ()=>{
            if (!this[$ea85f7056740ec00$export$69f2a32f51f09215]) return this[$ea85f7056740ec00$export$e16e101a1029cd84](new (0, $a52002d449639897$export$18b052ffd8c84d7)());
        });
        this.addEventListener("*", this[$ea85f7056740ec00$export$98f7c008938296e8].dispatchEvent.bind(this[$ea85f7056740ec00$export$98f7c008938296e8]));
        this.addEventListener("*", init[$ea85f7056740ec00$export$27a3f42c68f838e8].dispatchEvent.bind(init[$ea85f7056740ec00$export$27a3f42c68f838e8]));
    }
    rollback = (options)=>{
        // console.log({ rolled: this.#rolledBack });
        if (this.#rolledBack) // TODO
        throw new (0, $a52002d449639897$export$b251fc1661a3152d)("Rollback invoked multiple times: Please raise an issue at https://github.com/virtualstate/navigation with the use case where you want to use a rollback multiple times, this may have been unexpected behaviour");
        this.#rolledBack = true;
        return this.#options.rollback(options);
    };
    #onCommitSetProperty = ()=>{
        this[$ea85f7056740ec00$export$b800289c89bdaaf3] = true;
    };
    #onFinishSetProperty = ()=>{
        this[$ea85f7056740ec00$export$69f2a32f51f09215] = true;
    };
    #onFinishPromise = ()=>{
        // console.log("onFinishPromise")
        this[$ea85f7056740ec00$export$53d274ff6cf27e72].resolve(this[$ea85f7056740ec00$export$98f7c008938296e8]);
    };
    #onCommitPromise = ()=>{
        if (this.signal.aborted) ;
        else this[$ea85f7056740ec00$export$75e8373815314e38].resolve(this[$ea85f7056740ec00$export$98f7c008938296e8]);
    };
    #onError = (event)=>{
        return this[$ea85f7056740ec00$export$e16e101a1029cd84](event.error);
    };
    [$ea85f7056740ec00$export$ff9ce26ee90a6553] = (...promises)=>{
        for (const promise of promises)this.#promises.delete(promise);
    };
    [$ea85f7056740ec00$export$e16e101a1029cd84] = async (reason)=>{
        if (this[$ea85f7056740ec00$export$9ffb7c01bcc2234f]) return;
        this[$ea85f7056740ec00$export$9ffb7c01bcc2234f] = true;
        this[$ea85f7056740ec00$export$749b993fcfdc629f]();
        const navigationType = this[$ea85f7056740ec00$export$51ca3b558101ee70];
        // console.log({ navigationType, reason, entry: this[NavigationTransitionEntry] });
        if (typeof navigationType === "string" || navigationType === $ea85f7056740ec00$export$7120dacfaec4cc51) {
            // console.log("navigateerror", { reason, z: isInvalidStateError(reason) });
            await this.dispatchEvent({
                type: "navigateerror",
                error: reason,
                get message () {
                    if (reason instanceof Error) return reason.message;
                    return `${reason}`;
                }
            });
            // console.log("navigateerror finished");
            if (navigationType !== $ea85f7056740ec00$export$7120dacfaec4cc51 && !((0, $a52002d449639897$export$3c2c840c2f50edf4)(reason) || (0, $a52002d449639897$export$d2c30ea522b3259e)(reason))) try {
                // console.log("Rollback", navigationType);
                // console.warn("Rolling back immediately due to internal error", error);
                await this.rollback()?.finished;
            // console.log("Rollback complete", navigationType);
            } catch (error) {
                // console.error("Failed to rollback", error);
                throw new (0, $a52002d449639897$export$b251fc1661a3152d)("Failed to rollback, please raise an issue at https://github.com/virtualstate/navigation/issues");
            }
        }
        this[$ea85f7056740ec00$export$75e8373815314e38].reject(reason);
        this[$ea85f7056740ec00$export$53d274ff6cf27e72].reject(reason);
    };
    [$ea85f7056740ec00$export$e85ed60a89cb8005] = (options)=>{
        const transition = this;
        const promise = parseOptions();
        this[$ea85f7056740ec00$export$b7070e52b60cc6df] = true;
        if (!promise) return;
        this[$ea85f7056740ec00$export$e886b3d682640d85] = true;
        const statusPromise = promise.then(()=>({
                status: "fulfilled",
                value: undefined
            })).catch(async (reason)=>{
            await this[$ea85f7056740ec00$export$e16e101a1029cd84](reason);
            return {
                status: "rejected",
                reason: reason
            };
        });
        this.#promises.add(statusPromise);
        function parseOptions() {
            if (!options) return undefined;
            if ((0, $7eb4e6f571ed6cae$export$4369c812aac99591)(options)) {
                (0, $527ac3ea9aeb1f18$export$ebd6064652549ce9)("EVENT_INTERCEPT_HANDLER");
                return options;
            }
            if (typeof options === "function") {
                (0, $527ac3ea9aeb1f18$export$ebd6064652549ce9)("EVENT_INTERCEPT_HANDLER");
                return options();
            }
            const { handler: handler, commit: commit } = options;
            if (commit && typeof commit === "string") transition[$ea85f7056740ec00$export$1bc62e618753f7b5].push(commit);
            if (typeof handler !== "function") return;
            return handler();
        }
    };
    [$ea85f7056740ec00$export$c1c2d0f134ac5619] = async ()=>{
        if (!this.#promises.size) return this[$ea85f7056740ec00$export$98f7c008938296e8];
        try {
            const captured = [
                ...this.#promises
            ];
            const results = await Promise.all(captured);
            const rejected = results.filter((result)=>result.status === "rejected");
            // console.log({ rejected, results, captured });
            if (rejected.length) {
                // TODO handle differently when there are failures, e.g. we could move navigateerror to here
                if (rejected.length === 1) throw rejected[0].reason;
                if (typeof AggregateError !== "undefined") throw new AggregateError(rejected.map(({ reason: reason })=>reason));
                throw new Error();
            }
            this[$ea85f7056740ec00$export$ff9ce26ee90a6553](...captured);
            if (this[$ea85f7056740ec00$export$b713da2f1a748c68]) return this[$ea85f7056740ec00$export$c1c2d0f134ac5619]();
            return this[$ea85f7056740ec00$export$98f7c008938296e8];
        } catch (error) {
            await this.#onError(error);
            throw await Promise.reject(error);
        } finally{
            await this[$ea85f7056740ec00$export$f900dcbbc6493d39]();
        }
    };
    [$ea85f7056740ec00$export$749b993fcfdc629f]() {
        if (this.#abortController.signal.aborted) return;
        this.#abortController.abort();
        this.dispatchEvent({
            type: $ea85f7056740ec00$export$749b993fcfdc629f,
            transition: this,
            entry: this[$ea85f7056740ec00$export$98f7c008938296e8]
        });
    }
    [$ea85f7056740ec00$export$f900dcbbc6493d39] = async ()=>{
        if (this[$ea85f7056740ec00$export$69f2a32f51f09215]) return;
        await this.dispatchEvent({
            type: $ea85f7056740ec00$export$f900dcbbc6493d39,
            transition: this,
            entry: this[$ea85f7056740ec00$export$98f7c008938296e8],
            intercept: this[$ea85f7056740ec00$export$e85ed60a89cb8005]
        });
    };
}





function $18b9c1146cff103d$var$getWindowBaseURL() {
    try {
        if (typeof window !== "undefined" && window.location) return window.location.href;
    } catch  {}
}
function $18b9c1146cff103d$export$c9e73fbda7da57b6(url) {
    const baseURL = $18b9c1146cff103d$var$getWindowBaseURL() ?? "https://html.spec.whatwg.org/";
    return new URL(// Deno wants this to be always a string
    (url ?? "").toString(), baseURL);
}



function $ead07aa9d9ef68fd$export$260e5c0943f31606() {
    let resolve = undefined, reject = undefined, settled = false, status = "pending";
    const promise = new Promise((resolveFn, rejectFn)=>{
        resolve = (value)=>{
            status = "fulfilled";
            settled = true;
            resolveFn(value);
        };
        reject = (reason)=>{
            status = "rejected";
            settled = true;
            rejectFn(reason);
        };
    });
    (0, $7eb4e6f571ed6cae$export$dcb8b3f0e2de7e49)(resolve);
    (0, $7eb4e6f571ed6cae$export$dcb8b3f0e2de7e49)(reject);
    return {
        get settled () {
            return settled;
        },
        get status () {
            return status;
        },
        resolve: resolve,
        reject: reject,
        promise: promise
    };
}



class $fd92e4d83a142555$export$a92131f18c012555 {
    type;
    from;
    navigationType;
    constructor(type, init){
        this.type = type;
        if (!init) throw new TypeError("init required");
        if (!init.from) throw new TypeError("from required");
        this.from = init.from;
        this.navigationType = init.navigationType ?? undefined;
    }
}


class $7ffe441ff806057c$export$5df3ac09e96c1e8a {
    type;
    canIntercept;
    /**
     * @deprecated
     */ canTransition;
    destination;
    downloadRequest;
    formData;
    hashChange;
    info;
    signal;
    userInitiated;
    navigationType;
    constructor(type, init){
        this.type = type;
        if (!init) throw new TypeError("init required");
        if (!init.destination) throw new TypeError("destination required");
        if (!init.signal) throw new TypeError("signal required");
        this.canIntercept = init.canIntercept ?? false;
        this.canTransition = init.canIntercept ?? false;
        this.destination = init.destination;
        this.downloadRequest = init.downloadRequest;
        this.formData = init.formData;
        this.hashChange = init.hashChange ?? false;
        this.info = init.info;
        this.signal = init.signal;
        this.userInitiated = init.userInitiated ?? false;
        this.navigationType = init.navigationType ?? "push";
    }
    commit() {
        throw new Error("Not implemented");
    }
    intercept(options) {
        throw new Error("Not implemented");
    }
    preventDefault() {
        throw new Error("Not implemented");
    }
    reportError(reason) {
        throw new Error("Not implemented");
    }
    scroll() {
        throw new Error("Not implemented");
    }
    /**
     * @deprecated
     */ transitionWhile(options) {
        return this.intercept(options);
    }
}




const $e0d3ceb9d041758f$export$1702c71b214c9253 = Symbol.for("@virtualstate/navigation/formData");
const $e0d3ceb9d041758f$export$cb6dacf1341f1dfe = Symbol.for("@virtualstate/navigation/downloadRequest");
const $e0d3ceb9d041758f$export$2dd6397f028c9ac3 = Symbol.for("@virtualstate/navigation/canIntercept");
const $e0d3ceb9d041758f$export$a0e53803a1d175a0 = Symbol.for("@virtualstate/navigation/userInitiated");
const $e0d3ceb9d041758f$export$f018627649046fa1 = Symbol.for("@virtualstate/navigation/originalEvent");
const $e0d3ceb9d041758f$export$2ee2a53b12325201 = Symbol.for("@virtualstate/navigation/event/abortController");
function $e0d3ceb9d041758f$var$noop() {
    return undefined;
}
function $e0d3ceb9d041758f$var$getEntryIndex(entries, entry) {
    const knownIndex = entry.index;
    if (knownIndex !== -1) return knownIndex;
    // TODO find an entry if it has changed id
    return -1;
}
function $e0d3ceb9d041758f$export$14b93d0987fe4b7e(context) {
    const { commit: transitionCommit, currentIndex: currentIndex, options: options, known: initialKnown, currentEntry: currentEntry, transition: transition, transition: { [(0, $ea85f7056740ec00$export$608af6101082792f)]: previousEntries, [(0, $ea85f7056740ec00$export$98f7c008938296e8)]: entry, [(0, $ea85f7056740ec00$export$e85ed60a89cb8005)]: intercept }, reportError: reportError } = context;
    let { transition: { [(0, $ea85f7056740ec00$export$51ca3b558101ee70)]: navigationType } } = context;
    let resolvedEntries = [
        ...previousEntries
    ];
    const known = new Set(initialKnown);
    let destinationIndex = -1, nextIndex = currentIndex;
    if (navigationType === (0, $ea85f7056740ec00$export$7120dacfaec4cc51)) {
        const { index: index } = options ?? {
            index: undefined
        };
        if (typeof index !== "number") throw new (0, $a52002d449639897$export$b251fc1661a3152d)("Expected index to be provided for rollback");
        destinationIndex = index;
        nextIndex = index;
    } else if (navigationType === "traverse" || navigationType === "reload") {
        destinationIndex = $e0d3ceb9d041758f$var$getEntryIndex(previousEntries, entry);
        nextIndex = destinationIndex;
    } else if (navigationType === "replace") {
        if (currentIndex === -1) {
            navigationType = "push";
            destinationIndex = currentIndex + 1;
            nextIndex = destinationIndex;
        } else {
            destinationIndex = currentIndex;
            nextIndex = currentIndex;
        }
    } else {
        destinationIndex = currentIndex + 1;
        nextIndex = destinationIndex;
    }
    if (typeof destinationIndex !== "number" || destinationIndex === -1) throw new (0, $a52002d449639897$export$b251fc1661a3152d)("Could not resolve next index");
    // console.log({ navigationType, entry, options });
    if (!entry.url) {
        console.trace({
            navigationType: navigationType,
            entry: entry,
            options: options
        });
        throw new (0, $a52002d449639897$export$b251fc1661a3152d)("Expected entry url");
    }
    const destination = {
        url: entry.url,
        key: entry.key,
        index: destinationIndex,
        sameDocument: entry.sameDocument,
        getState () {
            return entry.getState();
        }
    };
    let hashChange = false;
    const currentUrlInstance = (0, $18b9c1146cff103d$export$c9e73fbda7da57b6)(currentEntry?.url);
    const destinationUrlInstance = new URL(destination.url);
    const currentHash = currentUrlInstance.hash;
    const destinationHash = destinationUrlInstance.hash;
    // console.log({ currentHash, destinationHash });
    if (currentHash !== destinationHash) {
        const currentUrlInstanceWithoutHash = new URL(currentUrlInstance.toString());
        currentUrlInstanceWithoutHash.hash = "";
        const destinationUrlInstanceWithoutHash = new URL(destinationUrlInstance.toString());
        destinationUrlInstanceWithoutHash.hash = "";
        hashChange = currentUrlInstanceWithoutHash.toString() === destinationUrlInstanceWithoutHash.toString();
    // console.log({ hashChange, currentUrlInstanceWithoutHash: currentUrlInstanceWithoutHash.toString(), before: destinationUrlInstanceWithoutHash.toString() })
    }
    let contextToCommit;
    const { resolve: resolveCommit, promise: waitForCommit } = (0, $ead07aa9d9ef68fd$export$260e5c0943f31606)();
    function commit() {
        (0, $7eb4e6f571ed6cae$export$dcb8b3f0e2de7e49)(contextToCommit, "Expected contextToCommit");
        resolveCommit(transitionCommit(contextToCommit));
    }
    const abortController = new (0, $1f241e6fe62a87d2$export$48f7e099c149af88)();
    const event = new (0, $7ffe441ff806057c$export$5df3ac09e96c1e8a)("navigate", {
        signal: abortController.signal,
        info: undefined,
        ...options,
        canIntercept: options?.[$e0d3ceb9d041758f$export$2dd6397f028c9ac3] ?? true,
        formData: options?.[$e0d3ceb9d041758f$export$1702c71b214c9253] ?? undefined,
        downloadRequest: options?.[$e0d3ceb9d041758f$export$cb6dacf1341f1dfe] ?? undefined,
        hashChange: hashChange,
        navigationType: options?.navigationType ?? (typeof navigationType === "string" ? navigationType : "replace"),
        userInitiated: options?.[$e0d3ceb9d041758f$export$a0e53803a1d175a0] ?? false,
        destination: destination
    });
    const originalEvent = options?.[$e0d3ceb9d041758f$export$f018627649046fa1];
    const preventDefault = transition[0, $ea85f7056740ec00$export$749b993fcfdc629f].bind(transition);
    if (originalEvent) {
        const definedEvent = originalEvent;
        event.intercept = function originalEventIntercept(options) {
            definedEvent.preventDefault();
            return intercept(options);
        };
        event.preventDefault = function originalEventPreventDefault() {
            definedEvent.preventDefault();
            return preventDefault();
        };
    } else {
        event.intercept = intercept;
        event.preventDefault = preventDefault;
    }
    // Enforce that transitionWhile and intercept match
    event.transitionWhile = event.intercept;
    event.commit = commit;
    if (reportError) event.reportError = reportError;
    event.scroll = $e0d3ceb9d041758f$var$noop;
    if (originalEvent) event.originalEvent = originalEvent;
    const currentEntryChange = new (0, $fd92e4d83a142555$export$a92131f18c012555)("currententrychange", {
        from: currentEntry,
        navigationType: event.navigationType
    });
    let updatedEntries = [], removedEntries = [], addedEntries = [];
    const previousKeys = previousEntries.map((entry)=>entry.key);
    if (navigationType === (0, $ea85f7056740ec00$export$7120dacfaec4cc51)) {
        const { entries: entries } = options ?? {
            entries: undefined
        };
        if (!entries) throw new (0, $a52002d449639897$export$b251fc1661a3152d)("Expected entries to be provided for rollback");
        resolvedEntries = entries;
        resolvedEntries.forEach((entry)=>known.add(entry));
        const keys = resolvedEntries.map((entry)=>entry.key);
        removedEntries = previousEntries.filter((entry)=>!keys.includes(entry.key));
        addedEntries = resolvedEntries.filter((entry)=>!previousKeys.includes(entry.key));
    } else if (navigationType === "replace" || navigationType === "traverse" || navigationType === "reload") {
        resolvedEntries[destination.index] = entry;
        if (navigationType !== "traverse") updatedEntries.push(entry);
        if (navigationType === "replace") resolvedEntries = resolvedEntries.slice(0, destination.index + 1);
        const keys = resolvedEntries.map((entry)=>entry.key);
        removedEntries = previousEntries.filter((entry)=>!keys.includes(entry.key));
        if (previousKeys.includes(entry.id)) addedEntries = [
            entry
        ];
    } else if (navigationType === "push") {
        let removed = false;
        // Trim forward, we have reset our stack
        if (resolvedEntries[destination.index]) {
            // const before = [...this.#entries];
            resolvedEntries = resolvedEntries.slice(0, destination.index);
            // console.log({ before, after: [...this.#entries]})
            removed = true;
        }
        resolvedEntries.push(entry);
        addedEntries = [
            entry
        ];
        if (removed) {
            const keys = resolvedEntries.map((entry)=>entry.key);
            removedEntries = previousEntries.filter((entry)=>!keys.includes(entry.key));
        }
    }
    known.add(entry);
    let entriesChange = undefined;
    if (updatedEntries.length || addedEntries.length || removedEntries.length) entriesChange = {
        updatedEntries: updatedEntries,
        addedEntries: addedEntries,
        removedEntries: removedEntries
    };
    contextToCommit = {
        entries: resolvedEntries,
        index: nextIndex,
        known: known,
        entriesChange: entriesChange
    };
    return {
        entries: resolvedEntries,
        known: known,
        index: nextIndex,
        currentEntryChange: currentEntryChange,
        destination: destination,
        navigate: event,
        navigationType: navigationType,
        waitForCommit: waitForCommit,
        commit: commit,
        abortController: abortController
    };
}



function $543819b23186aa1a$export$c30017717ce2168e(event) {
    if (typeof CustomEvent !== "undefined" && typeof event.type === "string") {
        if (event instanceof CustomEvent) return event;
        const { type: type, detail: detail, ...rest } = event;
        const customEvent = new CustomEvent(type, {
            detail: detail ?? rest
        });
        Object.assign(customEvent, rest);
        (0, $2be1ebaf46e66ff0$export$b3e112bfd3a4f448)(customEvent, event.type);
        return customEvent;
    }
    return event;
}





/**
 * This file is derived from https://github.com/WICG/app-history/blob/7c0332b30746b14863f717404402bc49e497a2b2/app_history.d.ts
 *
 * The main changes here is the usage of optional types over null, and support for updateCurrent()?.then;
 *
 * null is still included in places where properties have been marked as optional
 */ 


const $17c92abbed43f089$export$6bf089adaaa3be72 = Symbol.for("@virtualstate/navigation/setOptions");
const $17c92abbed43f089$export$e8045dd104aa1647 = Symbol.for("@virtualstate/navigation/setEntries");
const $17c92abbed43f089$export$ce02488f4a425f47 = Symbol.for("@virtualstate/navigation/setCurrentIndex");
const $17c92abbed43f089$export$7dba3b6849322596 = Symbol.for("@virtualstate/navigation/setCurrentKey");
const $17c92abbed43f089$export$9a8432e896bc1a4 = Symbol.for("@virtualstate/navigation/getState");
const $17c92abbed43f089$export$68263e3e4082ce08 = Symbol.for("@virtualstate/navigation/setState");
const $17c92abbed43f089$export$30e76a02c37d3ebc = Symbol.for("@virtualstate/navigation/disposeState");
function $17c92abbed43f089$export$faddcf84922b5483(value) {
    return value === "reload" || value === "push" || value === "replace" || value === "traverse";
}
class $17c92abbed43f089$export$b8a61e5c71402559 extends (0, $42cfb527d3c25157$export$792e6c53c031b501) {
    // Should be always 0 or 1
    #transitionInProgressCount = 0;
    // #activePromise?: Promise<void> = undefined;
    #entries = [];
    #known = new Set();
    #currentIndex = -1;
    #activeTransition;
    #knownTransitions = new WeakSet();
    #baseURL = "";
    #initialEntry = undefined;
    #options = undefined;
    get canGoBack() {
        return !!this.#entries[this.#currentIndex - 1];
    }
    get canGoForward() {
        return !!this.#entries[this.#currentIndex + 1];
    }
    get currentEntry() {
        if (this.#currentIndex === -1) {
            if (!this.#initialEntry) this.#initialEntry = new (0, $d39a6d1af7a1320e$export$a26b5d4ae65022a0)({
                getState: this[$17c92abbed43f089$export$9a8432e896bc1a4],
                navigationType: "push",
                index: -1,
                sameDocument: false,
                url: this.#baseURL.toString()
            });
            return this.#initialEntry;
        }
        return this.#entries[this.#currentIndex];
    }
    get transition() {
        const transition = this.#activeTransition;
        // Never let an aborted transition leak, it doesn't need to be accessed any more
        return transition?.signal.aborted ? undefined : transition;
    }
    constructor(options = {}){
        super();
        this[$17c92abbed43f089$export$6bf089adaaa3be72](options);
    }
    [$17c92abbed43f089$export$6bf089adaaa3be72](options) {
        this.#options = options;
        this.#baseURL = (0, $18b9c1146cff103d$export$c9e73fbda7da57b6)(options?.baseURL);
        this.#entries = [];
        if (options.entries) this[$17c92abbed43f089$export$e8045dd104aa1647](options.entries);
        if (options.currentKey) this[$17c92abbed43f089$export$7dba3b6849322596](options.currentKey);
        else if (typeof options.currentIndex === "number") this[$17c92abbed43f089$export$ce02488f4a425f47](options.currentIndex);
    }
    /**
     * Set the current entry key without any lifecycle eventing
     *
     * This would be more exact than providing an index
     * @param key
     */ [$17c92abbed43f089$export$7dba3b6849322596](key) {
        const index = this.#entries.findIndex((entry)=>entry.key === key);
        // If the key can't be found, becomes a no-op
        if (index === -1) return;
        this.#currentIndex = index;
    }
    /**
     * Set the current entry index without any lifecycle eventing
     * @param index
     */ [$17c92abbed43f089$export$ce02488f4a425f47](index) {
        if (index <= -1) return;
        if (index >= this.#entries.length) return;
        this.#currentIndex = index;
    }
    /**
     * Set the entries available without any lifecycle eventing
     * @param entries
     */ [$17c92abbed43f089$export$e8045dd104aa1647](entries) {
        this.#entries = entries.map(({ key: key, url: url, navigationType: navigationType, state: state, sameDocument: sameDocument }, index)=>new (0, $d39a6d1af7a1320e$export$a26b5d4ae65022a0)({
                getState: this[$17c92abbed43f089$export$9a8432e896bc1a4],
                navigationType: $17c92abbed43f089$export$faddcf84922b5483(navigationType) ? navigationType : "push",
                sameDocument: sameDocument ?? true,
                index: index,
                url: url,
                key: key,
                state: state
            }));
        if (this.#currentIndex === -1 && this.#entries.length) // Initialise, even if its not the one that was expected
        this.#currentIndex = 0;
    }
    [$17c92abbed43f089$export$9a8432e896bc1a4] = (entry)=>{
        return this.#options?.getState?.(entry) ?? undefined;
    };
    [$17c92abbed43f089$export$68263e3e4082ce08] = (entry)=>{
        return this.#options?.setState?.(entry);
    };
    [$17c92abbed43f089$export$30e76a02c37d3ebc] = (entry)=>{
        return this.#options?.disposeState?.(entry);
    };
    back(options) {
        if (!this.canGoBack) throw new (0, $a52002d449639897$export$b251fc1661a3152d)("Cannot go back");
        const entry = this.#entries[this.#currentIndex - 1];
        return this.#pushEntry("traverse", this.#cloneNavigationHistoryEntry(entry, {
            ...options,
            navigationType: "traverse"
        }));
    }
    entries() {
        return [
            ...this.#entries
        ];
    }
    forward(options) {
        if (!this.canGoForward) throw new (0, $a52002d449639897$export$b251fc1661a3152d)();
        const entry = this.#entries[this.#currentIndex + 1];
        return this.#pushEntry("traverse", this.#cloneNavigationHistoryEntry(entry, {
            ...options,
            navigationType: "traverse"
        }));
    }
    /**
    /**
     * @deprecated use traverseTo
     */ goTo(key, options) {
        return this.traverseTo(key, options);
    }
    traverseTo(key, options) {
        const found = this.#entries.find((entry)=>entry.key === key);
        if (found) return this.#pushEntry("traverse", this.#cloneNavigationHistoryEntry(found, {
            ...options,
            navigationType: "traverse"
        }));
        throw new (0, $a52002d449639897$export$b251fc1661a3152d)();
    }
    #isSameDocument = (url)=>{
        function isSameOrigins(a, b) {
            return a.origin === b.origin;
        }
        const currentEntryUrl = this.currentEntry?.url;
        if (!currentEntryUrl) return true;
        return isSameOrigins(new URL(currentEntryUrl), new URL(url));
    };
    navigate(url, options) {
        let baseURL = this.#baseURL;
        if (this.currentEntry?.url) // This allows use to use relative
        baseURL = this.currentEntry?.url;
        const nextUrl = new URL(url, baseURL).toString();
        let navigationType = "push";
        if (options?.history === "push" || options?.history === "replace") navigationType = options?.history;
        const entry = this.#createNavigationHistoryEntry({
            getState: this[$17c92abbed43f089$export$9a8432e896bc1a4],
            url: nextUrl,
            ...options,
            sameDocument: this.#isSameDocument(nextUrl),
            navigationType: navigationType
        });
        return this.#pushEntry(navigationType, entry, undefined, options);
    }
    #cloneNavigationHistoryEntry = (entry, options)=>{
        return this.#createNavigationHistoryEntry({
            ...entry,
            getState: this[$17c92abbed43f089$export$9a8432e896bc1a4],
            index: entry?.index ?? undefined,
            state: options?.state ?? entry?.getState(),
            navigationType: entry?.[0, $d39a6d1af7a1320e$export$e898b85e70a9bba1] ?? (typeof options?.navigationType === "string" ? options.navigationType : "replace"),
            ...options,
            get [(0, $d39a6d1af7a1320e$export$917d66dd2393ec9)] () {
                return entry?.[0, $d39a6d1af7a1320e$export$917d66dd2393ec9];
            },
            get [(0, $a3a1ae9ed3ef743c$export$fbd154b5770d63aa)] () {
                return entry?.[0, $a3a1ae9ed3ef743c$export$fbd154b5770d63aa];
            }
        });
    };
    #createNavigationHistoryEntry = (options)=>{
        const entry = new (0, $d39a6d1af7a1320e$export$a26b5d4ae65022a0)({
            ...options,
            index: options.index ?? (()=>{
                return this.#entries.indexOf(entry);
            })
        });
        return entry;
    };
    #pushEntry = (navigationType, entry, transition, options)=>{
        /* c8 ignore start */ if (entry === this.currentEntry) throw new (0, $a52002d449639897$export$b251fc1661a3152d)();
        const existingPosition = this.#entries.findIndex((existing)=>existing.id === entry.id);
        if (existingPosition > -1) throw new (0, $a52002d449639897$export$b251fc1661a3152d)();
        /* c8 ignore end */ return this.#commitTransition(navigationType, entry, transition, options);
    };
    #commitTransition = (givenNavigationType, entry, transition, options)=>{
        const nextTransition = transition ?? new (0, $ea85f7056740ec00$export$6f37f4a617702ecc)({
            from: this.currentEntry,
            navigationType: typeof givenNavigationType === "string" ? givenNavigationType : "replace",
            rollback: (options)=>{
                return this.#rollback(nextTransition, options);
            },
            [(0, $ea85f7056740ec00$export$51ca3b558101ee70)]: givenNavigationType,
            [(0, $ea85f7056740ec00$export$608af6101082792f)]: [
                ...this.#entries
            ],
            [(0, $ea85f7056740ec00$export$cd7d645b85723832)]: this.#currentIndex,
            [(0, $ea85f7056740ec00$export$8c9121c6a72fae8a)]: [
                ...this.#known
            ],
            [(0, $ea85f7056740ec00$export$98f7c008938296e8)]: entry,
            [(0, $ea85f7056740ec00$export$27a3f42c68f838e8)]: this
        });
        const { finished: finished, committed: committed } = nextTransition;
        const handler = ()=>{
            return this.#immediateTransition(givenNavigationType, entry, nextTransition, options);
        };
        this.#queueTransition(nextTransition);
        handler().catch((error)=>void 0);
        // let nextPromise;
        // if (!this.#transitionInProgressCount || !this.#activePromise) {
        //   nextPromise = handler().catch((error) => void error);
        // } else {
        //   nextPromise = this.#activePromise.then(handler);
        // }
        //
        // const promise = nextPromise
        //     .catch(error => void error)
        //     .then(() => {
        //       if (this.#activePromise === promise) {
        //         this.#activePromise = undefined;
        //       }
        //     })
        //
        // this.#activePromise = promise;
        return {
            committed: committed,
            finished: finished
        };
    };
    #queueTransition = (transition)=>{
        // TODO consume errors that are not abort errors
        // transition.finished.catch(error => void error);
        this.#knownTransitions.add(transition);
    };
    #immediateTransition = (givenNavigationType, entry, transition, options)=>{
        try {
            // This number can grow if navigation is
            // called during a transition
            //
            // ... I had used transitionInProgressCount as a
            // safeguard until I could see this flow firsthand
            this.#transitionInProgressCount += 1;
            return this.#transition(givenNavigationType, entry, transition, options);
        } finally{
            this.#transitionInProgressCount -= 1;
        }
    };
    #rollback = (rollbackTransition, options)=>{
        const previousEntries = rollbackTransition[0, $ea85f7056740ec00$export$608af6101082792f];
        const previousIndex = rollbackTransition[0, $ea85f7056740ec00$export$cd7d645b85723832];
        const previousCurrent = previousEntries[previousIndex];
        // console.log("z");
        // console.log("Rollback!", { previousCurrent, previousEntries, previousIndex });
        const entry = previousCurrent ? this.#cloneNavigationHistoryEntry(previousCurrent, options) : undefined;
        const nextOptions = {
            ...options,
            index: previousIndex,
            known: new Set([
                ...this.#known,
                ...previousEntries
            ]),
            navigationType: entry?.[0, $d39a6d1af7a1320e$export$e898b85e70a9bba1] ?? "replace",
            entries: previousEntries
        };
        const resolvedNavigationType = entry ? (0, $ea85f7056740ec00$export$7120dacfaec4cc51) : (0, $ea85f7056740ec00$export$5da459000fb5cd5d);
        const resolvedEntry = entry ?? this.#createNavigationHistoryEntry({
            getState: this[$17c92abbed43f089$export$9a8432e896bc1a4],
            navigationType: "replace",
            index: nextOptions.index,
            sameDocument: true,
            ...options
        });
        return this.#pushEntry(resolvedNavigationType, resolvedEntry, undefined, nextOptions);
    };
    #transition = (givenNavigationType, entry, transition, options)=>{
        // console.log({ givenNavigationType, transition });
        let navigationType = givenNavigationType;
        const performance1 = $17c92abbed43f089$var$getPerformance();
        if (performance1 && entry.sameDocument && typeof navigationType === "string") performance1?.mark?.(`same-document-navigation:${entry.id}`);
        let currentEntryChangeEvent = false, committedCurrentEntryChange = false;
        const { currentEntry: currentEntry } = this;
        this.#activeTransition?.finished?.catch((error)=>error);
        this.#activeTransition?.[0, $ea85f7056740ec00$export$53d274ff6cf27e72]?.promise?.catch((error)=>error);
        this.#activeTransition?.[0, $ea85f7056740ec00$export$75e8373815314e38]?.promise?.catch((error)=>error);
        this.#activeTransition?.[0, $ea85f7056740ec00$export$749b993fcfdc629f]();
        this.#activeTransition = transition;
        const startEventPromise = transition.dispatchEvent({
            type: (0, $ea85f7056740ec00$export$a2e9fc3e5bd44093),
            transition: transition,
            entry: entry
        });
        const syncCommit = ({ entries: entries, index: index, known: known })=>{
            if (transition.signal.aborted) return;
            this.#entries = entries;
            if (known) this.#known = new Set([
                ...this.#known,
                ...known
            ]);
            this.#currentIndex = index;
            // Let's trigger external state here
            // because it is the absolute point of
            // committing to using an entry
            //
            // If the entry came from an external source
            // then internal to getState the external source will be pulled from
            // only if the entry doesn't hold the state in memory
            //
            // TLDR I believe this will be no issue doing here, even if we end up
            // calling an external setState multiple times, it is better than
            // loss of the state
            this[$17c92abbed43f089$export$68263e3e4082ce08](this.currentEntry);
        };
        const asyncCommit = async (commit)=>{
            if (committedCurrentEntryChange) return;
            committedCurrentEntryChange = true;
            syncCommit(commit);
            const { entriesChange: entriesChange } = commit;
            const promises = [
                transition.dispatchEvent((0, $543819b23186aa1a$export$c30017717ce2168e)({
                    type: (0, $ea85f7056740ec00$export$5771dbe7ac52e162),
                    transition: transition,
                    entry: entry
                }))
            ];
            if (entriesChange) promises.push(this.dispatchEvent((0, $543819b23186aa1a$export$c30017717ce2168e)({
                type: "entrieschange",
                ...entriesChange
            })));
            await Promise.all(promises);
        };
        const unsetTransition = async ()=>{
            await startEventPromise;
            if (!(typeof options?.index === "number" && options.entries)) throw new (0, $a52002d449639897$export$b251fc1661a3152d)();
            const previous = this.entries();
            const previousKeys = previous.map((entry)=>entry.key);
            const keys = options.entries.map((entry)=>entry.key);
            const removedEntries = previous.filter((entry)=>!keys.includes(entry.key));
            const addedEntries = options.entries.filter((entry)=>!previousKeys.includes(entry.key));
            await asyncCommit({
                entries: options.entries,
                index: options.index,
                known: options.known,
                entriesChange: removedEntries.length || addedEntries.length ? {
                    removedEntries: removedEntries,
                    addedEntries: addedEntries,
                    updatedEntries: []
                } : undefined
            });
            await this.dispatchEvent((0, $543819b23186aa1a$export$c30017717ce2168e)({
                type: "currententrychange"
            }));
            currentEntryChangeEvent = true;
            return entry;
        };
        const completeTransition = ()=>{
            if (givenNavigationType === (0, $ea85f7056740ec00$export$5da459000fb5cd5d)) return unsetTransition();
            const transitionResult = (0, $e0d3ceb9d041758f$export$14b93d0987fe4b7e)({
                currentEntry: currentEntry,
                currentIndex: this.#currentIndex,
                options: options,
                transition: transition,
                known: this.#known,
                commit: asyncCommit,
                reportError: transition[0, $ea85f7056740ec00$export$e16e101a1029cd84]
            });
            const microtask = new Promise(queueMicrotask);
            let promises = [];
            const iterator = transitionSteps(transitionResult)[Symbol.iterator]();
            const iterable = {
                [Symbol.iterator]: ()=>({
                        next: ()=>iterator.next()
                    })
            };
            async function syncTransition() {
                for (const promise of iterable){
                    if ((0, $7eb4e6f571ed6cae$export$4369c812aac99591)(promise)) promises.push(Promise.allSettled([
                        promise
                    ]).then(([result])=>result));
                    if (transition[0, $ea85f7056740ec00$export$23635c7475f4b84b] || currentEntryChangeEvent && transition[0, $ea85f7056740ec00$export$e886b3d682640d85]) return asyncTransition().then(syncTransition);
                    if (transition.signal.aborted) break;
                }
                if (promises.length) return asyncTransition();
            }
            async function asyncTransition() {
                const captured = [
                    ...promises
                ];
                if (captured.length) {
                    promises = [];
                    const results = await Promise.all(captured);
                    const rejected = results.filter((0, $7eb4e6f571ed6cae$export$3d37f2d7023409fe));
                    if (rejected.length === 1) throw await Promise.reject(rejected[0]);
                    else if (rejected.length) throw new AggregateError(rejected, rejected[0].reason?.message);
                } else if (!transition[0, $ea85f7056740ec00$export$b7070e52b60cc6df]) await microtask;
            }
            // console.log("Returning", { entry });
            return syncTransition().then(()=>transition[0, $ea85f7056740ec00$export$b7070e52b60cc6df] ? undefined : microtask).then(()=>entry);
        };
        const dispose = async ()=>this.#dispose();
        function* transitionSteps(transitionResult) {
            const microtask = new Promise(queueMicrotask);
            const { currentEntryChange: currentEntryChange, navigate: navigate, waitForCommit: waitForCommit, commit: commit, abortController: abortController } = transitionResult;
            const navigateAbort = abortController.abort.bind(abortController);
            transition.signal.addEventListener("abort", navigateAbort, {
                once: true
            });
            if (typeof navigationType === "string" || navigationType === (0, $ea85f7056740ec00$export$7120dacfaec4cc51)) {
                const promise = currentEntry?.dispatchEvent((0, $543819b23186aa1a$export$c30017717ce2168e)({
                    type: "navigatefrom",
                    intercept: transition[0, $ea85f7056740ec00$export$e85ed60a89cb8005],
                    /**
                     * @deprecated
                     */ transitionWhile: transition[0, $ea85f7056740ec00$export$e85ed60a89cb8005]
                }));
                if (promise) yield promise;
            }
            if (typeof navigationType === "string") yield transition.dispatchEvent(navigate);
            if (!transition[0, $ea85f7056740ec00$export$23635c7475f4b84b]) commit();
            yield waitForCommit;
            if (entry.sameDocument) yield transition.dispatchEvent(currentEntryChange);
            currentEntryChangeEvent = true;
            if (typeof navigationType === "string") yield entry.dispatchEvent((0, $543819b23186aa1a$export$c30017717ce2168e)({
                type: "navigateto",
                intercept: transition[0, $ea85f7056740ec00$export$e85ed60a89cb8005],
                /**
                     * @deprecated
                     */ transitionWhile: transition[0, $ea85f7056740ec00$export$e85ed60a89cb8005]
            }));
            yield dispose();
            if (!transition[0, $ea85f7056740ec00$export$45671a2ef776443d].size) yield microtask;
            yield transition.dispatchEvent({
                type: (0, $ea85f7056740ec00$export$f8d26213ff40b8ab),
                transition: transition,
                entry: entry
            });
            yield transition[0, $ea85f7056740ec00$export$c1c2d0f134ac5619]();
            transition.signal.removeEventListener("abort", navigateAbort);
            yield transition[0, $ea85f7056740ec00$export$f900dcbbc6493d39]();
            if (typeof navigationType === "string") {
                yield transition.dispatchEvent((0, $543819b23186aa1a$export$c30017717ce2168e)({
                    type: "finish",
                    intercept: transition[0, $ea85f7056740ec00$export$e85ed60a89cb8005],
                    /**
                     * @deprecated
                     */ transitionWhile: transition[0, $ea85f7056740ec00$export$e85ed60a89cb8005]
                }));
                yield transition.dispatchEvent((0, $543819b23186aa1a$export$c30017717ce2168e)({
                    type: "navigatesuccess",
                    intercept: transition[0, $ea85f7056740ec00$export$e85ed60a89cb8005],
                    /**
                     * @deprecated
                     */ transitionWhile: transition[0, $ea85f7056740ec00$export$e85ed60a89cb8005]
                }));
            }
        }
        const maybeSyncTransition = ()=>{
            try {
                return completeTransition();
            } catch (error) {
                return Promise.reject(error);
            }
        };
        return Promise.allSettled([
            maybeSyncTransition()
        ]).then(async ([detail])=>{
            if (detail.status === "rejected") await transition.dispatchEvent({
                type: (0, $ea85f7056740ec00$export$93b29e3d61aa456f),
                error: detail.reason,
                transition: transition,
                entry: entry
            });
            await dispose();
            await transition.dispatchEvent({
                type: (0, $ea85f7056740ec00$export$122fd4ab5408eace),
                transition: transition,
                entry: entry
            });
            await transition[0, $ea85f7056740ec00$export$c1c2d0f134ac5619]();
            if (this.#activeTransition === transition) this.#activeTransition = undefined;
            if (entry.sameDocument && typeof navigationType === "string") {
                performance1.mark(`same-document-navigation-finish:${entry.id}`);
                performance1.measure(`same-document-navigation:${entry.url}`, `same-document-navigation:${entry.id}`, `same-document-navigation-finish:${entry.id}`);
            }
        }).then(()=>entry);
    };
    #dispose = async ()=>{
        // console.log(JSON.stringify({ known: [...this.#known], entries: this.#entries }));
        for (const known of this.#known){
            const index = this.#entries.findIndex((entry)=>entry.key === known.key);
            if (index !== -1) continue;
            // No index, no longer known
            this.#known.delete(known);
            const event = (0, $543819b23186aa1a$export$c30017717ce2168e)({
                type: "dispose",
                entry: known
            });
            this[$17c92abbed43f089$export$30e76a02c37d3ebc](known);
            await known.dispatchEvent(event);
            await this.dispatchEvent(event);
        }
    // console.log(JSON.stringify({ pruned: [...this.#known] }));
    };
    reload(options) {
        const { currentEntry: currentEntry } = this;
        if (!currentEntry) throw new (0, $a52002d449639897$export$b251fc1661a3152d)();
        const entry = this.#cloneNavigationHistoryEntry(currentEntry, options);
        return this.#pushEntry("reload", entry, undefined, options);
    }
    updateCurrentEntry(options) {
        const { currentEntry: currentEntry } = this;
        if (!currentEntry) throw new (0, $a52002d449639897$export$b251fc1661a3152d)("Expected current entry");
        // Instant change
        currentEntry[0, $d39a6d1af7a1320e$export$9d1b4bef73c5a796](options.state);
        this[$17c92abbed43f089$export$68263e3e4082ce08](currentEntry);
        const currentEntryChange = new (0, $fd92e4d83a142555$export$a92131f18c012555)("currententrychange", {
            from: currentEntry,
            navigationType: undefined
        });
        const entriesChange = (0, $543819b23186aa1a$export$c30017717ce2168e)({
            type: "entrieschange",
            addedEntries: [],
            removedEntries: [],
            updatedEntries: [
                currentEntry
            ]
        });
        return Promise.all([
            this.dispatchEvent(currentEntryChange),
            this.dispatchEvent(entriesChange)
        ]);
    }
}
function $17c92abbed43f089$var$getPerformance() {
    if (typeof performance !== "undefined") return performance;
    /* c8 ignore start */ return {
        now () {
            return Date.now();
        },
        mark () {},
        measure () {}
    };
// const { performance: nodePerformance } = await import("perf_hooks");
// return nodePerformance;
/* c8 ignore end */ }


let $1d03eab8cfde430b$var$navigation;
function $1d03eab8cfde430b$export$454d28c32a19d348() {
    if (0, $179b04608e775d68$export$7cd97e17c834df02) return 0, $179b04608e775d68$export$7cd97e17c834df02;
    if ($1d03eab8cfde430b$var$navigation) return $1d03eab8cfde430b$var$navigation;
    return $1d03eab8cfde430b$var$navigation = new (0, $17c92abbed43f089$export$b8a61e5c71402559)();
}





let $62d80cef6992b787$var$GLOBAL_SERIALIZER = JSON;
function $62d80cef6992b787$export$676a5fc3626c5240(serializer) {
    $62d80cef6992b787$var$GLOBAL_SERIALIZER = serializer;
}
function $62d80cef6992b787$export$fac44ee5b035f737(value) {
    return $62d80cef6992b787$var$GLOBAL_SERIALIZER.stringify(value);
}
function $62d80cef6992b787$export$98e6a39c04603d36(value) {
    return $62d80cef6992b787$var$GLOBAL_SERIALIZER.parse(value);
}




const $d8eaa4236f6a5f9d$export$c8abcb34577ba511 = Symbol.for("@virtualstate/navigation/location/checkChange");
const $d8eaa4236f6a5f9d$export$405ad8fd701962f0 = Symbol.for("@virtualstate/navigation/location/awaitFinished");
const $d8eaa4236f6a5f9d$export$98b2bff5461efb35 = Symbol.for("@virtualstate/navigation/location/transitionURL");
const $d8eaa4236f6a5f9d$export$aff38f30cd82550 = Symbol.for("@virtualstate/navigation/location/url");
const $d8eaa4236f6a5f9d$export$d0d2b690a630787a = "https://html.spec.whatwg.org/";
class $d8eaa4236f6a5f9d$export$763f95e026c05695 {
    #options;
    #navigation;
    constructor(options){
        this.#options = options;
        this.#navigation = options.navigation;
        const reset = ()=>{
            this.#transitioningURL = undefined;
            this.#baseURL = undefined;
        };
        this.#navigation.addEventListener("navigate", ()=>{
            const transition = this.#navigation.transition;
            if (transition && isCommittedAvailable(transition)) transition[0, $ea85f7056740ec00$export$75e8373815314e38].promise.then(reset, reset);
            function isCommittedAvailable(transition) {
                return (0, $ea85f7056740ec00$export$75e8373815314e38) in transition;
            }
        });
        this.#navigation.addEventListener("currententrychange", reset);
    }
    #urls = new WeakMap();
    #transitioningURL;
    #baseURL;
    get [$d8eaa4236f6a5f9d$export$aff38f30cd82550]() {
        if (this.#transitioningURL) return this.#transitioningURL;
        const { currentEntry: currentEntry } = this.#navigation;
        if (!currentEntry) {
            this.#baseURL = (0, $18b9c1146cff103d$export$c9e73fbda7da57b6)(this.#options.baseURL);
            return this.#baseURL;
        }
        const existing = this.#urls.get(currentEntry);
        if (existing) return existing;
        const next = new URL(currentEntry.url ?? $d8eaa4236f6a5f9d$export$d0d2b690a630787a);
        this.#urls.set(currentEntry, next);
        return next;
    }
    get hash() {
        return this[$d8eaa4236f6a5f9d$export$aff38f30cd82550].hash;
    }
    set hash(value) {
        this.#setUrlValue("hash", value);
    }
    get host() {
        return this[$d8eaa4236f6a5f9d$export$aff38f30cd82550].host;
    }
    set host(value) {
        this.#setUrlValue("host", value);
    }
    get hostname() {
        return this[$d8eaa4236f6a5f9d$export$aff38f30cd82550].hostname;
    }
    set hostname(value) {
        this.#setUrlValue("hostname", value);
    }
    get href() {
        return this[$d8eaa4236f6a5f9d$export$aff38f30cd82550].href;
    }
    set href(value) {
        this.#setUrlValue("href", value);
    }
    get origin() {
        return this[$d8eaa4236f6a5f9d$export$aff38f30cd82550].origin;
    }
    get pathname() {
        return this[$d8eaa4236f6a5f9d$export$aff38f30cd82550].pathname;
    }
    set pathname(value) {
        this.#setUrlValue("pathname", value);
    }
    get port() {
        return this[$d8eaa4236f6a5f9d$export$aff38f30cd82550].port;
    }
    set port(value) {
        this.#setUrlValue("port", value);
    }
    get protocol() {
        return this[$d8eaa4236f6a5f9d$export$aff38f30cd82550].protocol;
    }
    set protocol(value) {
        this.#setUrlValue("protocol", value);
    }
    get search() {
        return this[$d8eaa4236f6a5f9d$export$aff38f30cd82550].search;
    }
    set search(value) {
        this.#setUrlValue("search", value);
    }
    #setUrlValue = (key, value)=>{
        const currentUrlString = this[$d8eaa4236f6a5f9d$export$aff38f30cd82550].toString();
        let nextUrl;
        if (key === "href") nextUrl = new URL(value, currentUrlString);
        else {
            nextUrl = new URL(currentUrlString);
            nextUrl[key] = value;
        }
        const nextUrlString = nextUrl.toString();
        if (currentUrlString === nextUrlString) return;
        this.#transitionURL(nextUrl, ()=>this.#navigation.navigate(nextUrlString));
    };
    replace(url) {
        return this.#transitionURL(url, (url)=>this.#navigation.navigate(url.toString(), {
                history: "replace"
            }));
    }
    reload() {
        return this.#awaitFinished(this.#navigation.reload());
    }
    assign(url) {
        return this.#transitionURL(url, (url)=>this.#navigation.navigate(url.toString()));
    }
    [$d8eaa4236f6a5f9d$export$98b2bff5461efb35](url, fn) {
        return this.#transitionURL(url, fn);
    }
    #transitionURL = async (url, fn)=>{
        const instance = this.#transitioningURL = typeof url === "string" ? new URL(url, this[$d8eaa4236f6a5f9d$export$aff38f30cd82550].toString()) : url;
        try {
            await this.#awaitFinished(fn(instance));
        } finally{
            if (this.#transitioningURL === instance) this.#transitioningURL = undefined;
        }
    };
    [$d8eaa4236f6a5f9d$export$405ad8fd701962f0](result) {
        return this.#awaitFinished(result);
    }
    #awaitFinished = async (result)=>{
        this.#baseURL = undefined;
        if (!result) return;
        const { committed: committed, finished: finished } = result;
        await Promise.all([
            committed || Promise.resolve(undefined),
            finished || Promise.resolve(undefined)
        ]);
    };
    #triggerIfUrlChanged = ()=>{
        const current = this[$d8eaa4236f6a5f9d$export$aff38f30cd82550];
        const currentUrl = current.toString();
        const expectedUrl = this.#navigation.currentEntry?.url;
        if (currentUrl !== expectedUrl) return this.#transitionURL(current, ()=>this.#navigation.navigate(currentUrl));
    };
    /**
     * This is needed if you have changed searchParams using its mutating methods
     *
     * TODO replace get searchParams with an observable change to auto trigger this function
     */ [$d8eaa4236f6a5f9d$export$c8abcb34577ba511]() {
        return this.#triggerIfUrlChanged();
    }
}



const $88bb943f635c0a20$var$State = Symbol.for("@virtualstate/navigation/history/state");
class $88bb943f635c0a20$export$d0b6fa7b79a9a799 extends (0, $d8eaa4236f6a5f9d$export$763f95e026c05695) {
    #options;
    #navigation;
    constructor(options){
        super(options);
        this.#options = options;
        this.#navigation = options.navigation;
    }
    get length() {
        return this.#navigation.entries().length;
    }
    scrollRestoration = "manual";
    get state() {
        const currentState = this.#navigation.currentEntry?.getState();
        if (typeof currentState === "string" || typeof currentState === "number" || typeof currentState === "boolean") return currentState;
        return this.#options[$88bb943f635c0a20$var$State] ?? undefined;
    }
    back() {
        const entries = this.#navigation.entries();
        const index = this.#navigation.currentEntry?.index ?? -1;
        const back = entries[index - 1];
        const url = back?.url;
        if (!url) throw new (0, $a52002d449639897$export$b251fc1661a3152d)("Cannot go back");
        return this[0, $d8eaa4236f6a5f9d$export$98b2bff5461efb35](url, ()=>this.#navigation.back());
    }
    forward() {
        const entries = this.#navigation.entries();
        const index = this.#navigation.currentEntry?.index ?? -1;
        const forward = entries[index + 1];
        const url = forward?.url;
        if (!url) throw new (0, $a52002d449639897$export$b251fc1661a3152d)("Cannot go forward");
        return this[0, $d8eaa4236f6a5f9d$export$98b2bff5461efb35](url, ()=>this.#navigation.forward());
    }
    go(delta) {
        if (typeof delta !== "number" || delta === 0 || isNaN(delta)) return this[0, $d8eaa4236f6a5f9d$export$405ad8fd701962f0](this.#navigation.reload());
        const entries = this.#navigation.entries();
        const { currentEntry: currentEntry } = this.#navigation;
        if (!currentEntry) throw new Error(`Could not go ${delta}`);
        const nextIndex = currentEntry.index + delta;
        const nextEntry = entries[nextIndex];
        if (!nextEntry) throw new Error(`Could not go ${delta}`);
        const nextEntryKey = nextEntry.key;
        return this[0, $d8eaa4236f6a5f9d$export$405ad8fd701962f0](this.#navigation.traverseTo(nextEntryKey));
    }
    replaceState(data, unused, url) {
        if (url) return this[0, $d8eaa4236f6a5f9d$export$98b2bff5461efb35](url, (url)=>this.#navigation.navigate(url.toString(), {
                state: data,
                history: "replace"
            }));
        else return this.#navigation.updateCurrentEntry({
            state: data
        });
    }
    pushState(data, unused, url) {
        if (url) return this[0, $d8eaa4236f6a5f9d$export$98b2bff5461efb35](url, (url)=>this.#navigation.navigate(url.toString(), {
                state: data
            }));
        else return this.#navigation.updateCurrentEntry({
            state: data
        });
    }
}
class $88bb943f635c0a20$export$194971707179c2f7 extends $88bb943f635c0a20$export$d0b6fa7b79a9a799 {
}



const $682c802550adac96$export$9689045fea27ed13 = typeof window === "undefined" ? undefined : window;


const $154d38a0624634bb$export$2f06f8d1d4981ef2 = typeof self === "undefined" ? undefined : self;



const $151c17f8fa405555$export$d56b53a21110c33a = "__@virtualstate/navigation/key";
const $151c17f8fa405555$export$24a0e8c547ac16d1 = "__@virtualstate/navigation/meta";
function $151c17f8fa405555$var$getWindowHistory(givenWindow = (0, $682c802550adac96$export$9689045fea27ed13)) {
    if (typeof givenWindow === "undefined") return undefined;
    return givenWindow.history;
}
function $151c17f8fa405555$var$getStateFromWindowHistory(givenWindow = (0, $682c802550adac96$export$9689045fea27ed13)) {
    const history = $151c17f8fa405555$var$getWindowHistory(givenWindow);
    if (!history) return undefined;
    const value = history.state;
    return (0, $7eb4e6f571ed6cae$export$e94e5ec04a02879c)(value) ? value : undefined;
}
function $151c17f8fa405555$var$isStateHistoryMeta(state) {
    return (0, $7eb4e6f571ed6cae$export$e94e5ec04a02879c)(state) && state[$151c17f8fa405555$export$24a0e8c547ac16d1] === true;
}
function $151c17f8fa405555$var$isStateHistoryWithMeta(state) {
    return (0, $7eb4e6f571ed6cae$export$e94e5ec04a02879c)(state) && $151c17f8fa405555$var$isStateHistoryMeta(state[$151c17f8fa405555$export$d56b53a21110c33a]);
}
function $151c17f8fa405555$var$disposeHistoryState(entry, persist) {
    if (!persist) return;
    if (typeof sessionStorage === "undefined") return;
    sessionStorage.removeItem(entry.key);
}
function $151c17f8fa405555$var$getEntries(navigation, limit = $151c17f8fa405555$export$cd4e898523b5d95a.limit) {
    let entries = navigation.entries();
    if (typeof limit === "number") entries = entries.slice(-limit);
    return entries.map(({ id: id, key: key, url: url, sameDocument: sameDocument })=>({
            id: id,
            key: key,
            url: url,
            sameDocument: sameDocument
        }));
}
function $151c17f8fa405555$var$getNavigationEntryMeta(navigation, entry, limit = $151c17f8fa405555$export$cd4e898523b5d95a.limit) {
    return {
        [$151c17f8fa405555$export$24a0e8c547ac16d1]: true,
        currentIndex: entry.index,
        key: entry.key,
        entries: $151c17f8fa405555$var$getEntries(navigation, limit),
        state: entry.getState()
    };
}
function $151c17f8fa405555$var$getNavigationEntryWithMeta(navigation, entry, limit = $151c17f8fa405555$export$cd4e898523b5d95a.limit) {
    return {
        [$151c17f8fa405555$export$d56b53a21110c33a]: $151c17f8fa405555$var$getNavigationEntryMeta(navigation, entry, limit)
    };
}
function $151c17f8fa405555$var$setHistoryState(navigation, history, entry, persist, limit) {
    setStateInSession();
    function getSerializableState() {
        return $151c17f8fa405555$var$getNavigationEntryWithMeta(navigation, entry, limit);
    }
    function setStateInSession() {
        if (typeof sessionStorage === "undefined") return;
        try {
            const raw = (0, $62d80cef6992b787$export$fac44ee5b035f737)(getSerializableState());
            sessionStorage.setItem(entry.key, raw);
        } catch  {}
    }
}
function $151c17f8fa405555$var$getHistoryState(history, entry) {
    return getStateFromHistoryIfMatchingKey() ?? getStateFromSession();
    function getStateFromHistoryDirectly() {
        try {
            return history.state;
        } catch  {
            return undefined;
        }
    }
    function getBaseState() {
        const value = history.originalState ?? getStateFromHistoryDirectly();
        return (0, $7eb4e6f571ed6cae$export$e94e5ec04a02879c)(value) ? value : undefined;
    }
    function getStateFromHistoryIfMatchingKey() {
        const state = getBaseState();
        if (!$151c17f8fa405555$var$isStateHistoryWithMeta(state)) return undefined;
        if (state[$151c17f8fa405555$export$d56b53a21110c33a].key !== entry.key) return undefined;
        return state[$151c17f8fa405555$export$d56b53a21110c33a].state;
    }
    function getStateFromSession() {
        if (typeof sessionStorage === "undefined") return undefined;
        try {
            const raw = sessionStorage.getItem(entry.key);
            if (!raw) return undefined;
            const state = (0, $62d80cef6992b787$export$98e6a39c04603d36)(raw);
            if (!(0, $7eb4e6f571ed6cae$export$e94e5ec04a02879c)(state)) return undefined;
            if (!$151c17f8fa405555$var$isStateHistoryWithMeta(state)) return undefined;
            return state[$151c17f8fa405555$export$d56b53a21110c33a].state;
        } catch  {
            return undefined;
        }
    }
}
const $151c17f8fa405555$export$cd4e898523b5d95a = Object.freeze({
    persist: true,
    persistState: true,
    history: true,
    limit: 50,
    patch: true,
    interceptEvents: true
});
function $151c17f8fa405555$export$c7ebf36d25ae6c25(options = $151c17f8fa405555$export$cd4e898523b5d95a) {
    const { navigation: navigation } = $151c17f8fa405555$export$b12408dc2a9b1254(options);
    return navigation;
}
function $151c17f8fa405555$var$isNavigationPolyfill(navigation) {
    return (0, $7eb4e6f571ed6cae$export$e94e5ec04a02879c)(navigation) && typeof navigation[0, $17c92abbed43f089$export$e8045dd104aa1647] === "function" && typeof navigation[0, $17c92abbed43f089$export$7dba3b6849322596] === "function";
}
function $151c17f8fa405555$var$getNavigationOnlyPolyfill(givenNavigation) {
    // When using as a polyfill, we will auto initiate a single
    // entry, but not cause an event for it
    const entries = [
        {
            key: (0, $a777f6d8c654ab05$export$afaf85bc510dd0d6)()
        }
    ];
    const navigation = givenNavigation ?? new (0, $17c92abbed43f089$export$b8a61e5c71402559)({
        entries: entries
    });
    const history = new (0, $88bb943f635c0a20$export$d0b6fa7b79a9a799)({
        navigation: navigation
    });
    return {
        navigation: navigation,
        history: history,
        apply () {
            if ($151c17f8fa405555$var$isNavigationPolyfill(givenNavigation) && !navigation.entries().length) givenNavigation[0, $17c92abbed43f089$export$e8045dd104aa1647](entries);
        }
    };
}
function $151c17f8fa405555$var$interceptWindowClicks(navigation, window) {
    function clickCallback(ev, aEl) {
        // console.log("<-- clickCallback -->");
        // TODO opt into queueMicrotask before process
        process();
        function process() {
            if (!$151c17f8fa405555$var$isAppNavigation(ev)) return;
            (0, $7eb4e6f571ed6cae$export$dcb8b3f0e2de7e49)(ev);
            const target = aEl.getAttribute("target");
            // See target detailed here
            // https://github.com/WICG/navigation-api/blob/7b2d326b8eeb75680e568dadaa67e3bb54c9ca7f/README.md?plain=1#L1465
            if (target) {
                if (target === "_blank") // Continue with default, new window
                return;
                if (target !== window.name) // Continue with default, not current window
                return;
            }
            const options = {
                history: "auto",
                [(0, $e0d3ceb9d041758f$export$a0e53803a1d175a0)]: true,
                [(0, $e0d3ceb9d041758f$export$cb6dacf1341f1dfe)]: aEl.download,
                [(0, $e0d3ceb9d041758f$export$f018627649046fa1)]: ev
            };
            navigation.navigate(aEl.href, options);
        }
    }
    function submitCallback(ev, form) {
        // console.log("<-- submitCallback -->");
        // TODO opt into queueMicrotask before process
        process();
        function process() {
            if (ev.defaultPrevented) return;
            const method = ev.submitter && 'formMethod' in ev.submitter && ev.submitter.formMethod ? ev.submitter.formMethod : form.method;
            // XXX: safe to ignore dialog method?
            if (method === 'dialog') return;
            const action = ev.submitter && 'formAction' in ev.submitter && ev.submitter.formAction ? ev.submitter.formAction : form.action;
            const target = form.getAttribute("target");
            // See target detailed here
            // https://github.com/WICG/navigation-api/blob/7b2d326b8eeb75680e568dadaa67e3bb54c9ca7f/README.md?plain=1#L1465
            if (target) {
                if (target === "_blank") // Continue with default, new window
                return;
                if (target !== window.name) // Continue with default, not current window
                return;
            }
            let formData;
            /* c8 ignore start */ try {
                formData = new FormData(form);
            } catch  {
                // For runtimes where we polyfilled the window & then evented it
                // ... for some reason
                formData = new FormData(undefined);
            }
            /* c8 ignore end */ const params = method === 'get' ? new URLSearchParams([
                ...formData
            ].map(([k, v])=>v instanceof File ? [
                    k,
                    v.name
                ] : [
                    k,
                    v
                ])) : undefined;
            const navFormData = method === 'post' ? formData : undefined;
            // action is always a fully qualified url in browsers
            const url = new URL(action, navigation.currentEntry.url);
            if (params) url.search = params.toString();
            const unknownEvent = ev;
            (0, $7eb4e6f571ed6cae$export$dcb8b3f0e2de7e49)(unknownEvent);
            const options = {
                history: "auto",
                [(0, $e0d3ceb9d041758f$export$a0e53803a1d175a0)]: true,
                [(0, $e0d3ceb9d041758f$export$1702c71b214c9253)]: navFormData,
                [(0, $e0d3ceb9d041758f$export$f018627649046fa1)]: unknownEvent
            };
            navigation.navigate(url.href, options);
        }
    }
    // console.log("click event added")
    window.addEventListener("click", (ev)=>{
        // console.log("click event", ev)
        if (ev.target?.ownerDocument === window.document) {
            const aEl = $151c17f8fa405555$var$getAnchorFromEvent(ev); // XXX: not sure what <a> tags without href do
            if ((0, $7eb4e6f571ed6cae$export$e94e5ec04a02879c)(aEl)) clickCallback(ev, aEl);
        }
    });
    window.addEventListener("submit", (ev)=>{
        // console.log("submit event")
        if (ev.target?.ownerDocument === window.document) {
            const form = $151c17f8fa405555$var$getFormFromEvent(ev);
            if ((0, $7eb4e6f571ed6cae$export$e94e5ec04a02879c)(form)) submitCallback(ev, form);
        }
    });
}
function $151c17f8fa405555$var$getAnchorFromEvent(event) {
    return $151c17f8fa405555$var$matchesAncestor($151c17f8fa405555$var$getComposedPathTarget(event), "a[href]:not([data-navigation-ignore])");
}
function $151c17f8fa405555$var$getFormFromEvent(event) {
    return $151c17f8fa405555$var$matchesAncestor($151c17f8fa405555$var$getComposedPathTarget(event), "form:not([data-navigation-ignore])");
}
function $151c17f8fa405555$var$getComposedPathTarget(event) {
    if (!event.composedPath) return event.target;
    const targets = event.composedPath();
    return targets[0] ?? event.target;
}
function $151c17f8fa405555$var$patchGlobalScope(window, history, navigation) {
    patchGlobals();
    patchPopState();
    patchHistory();
    function patchWindow(window) {
        try {
            Object.defineProperty(window, "navigation", {
                value: navigation
            });
        } catch (e) {}
        if (!window.history) try {
            Object.defineProperty(window, "history", {
                value: history
            });
        } catch (e) {}
    }
    function patchGlobals() {
        patchWindow(window);
        // If we don't have the global window, don't also patch global scope
        if (window !== (0, $682c802550adac96$export$9689045fea27ed13)) return;
        if (0, $154d38a0624634bb$export$2f06f8d1d4981ef2) try {
            Object.defineProperty((0, $154d38a0624634bb$export$2f06f8d1d4981ef2), "navigation", {
                value: navigation
            });
        } catch (e) {}
        if (typeof globalThis !== "undefined") try {
            Object.defineProperty(globalThis, "navigation", {
                value: navigation
            });
        } catch (e) {}
    }
    function patchHistory() {
        if (history instanceof (0, $88bb943f635c0a20$export$d0b6fa7b79a9a799)) // It's our polyfill, but probably externally passed to getPolyfill
        return;
        const polyfillHistory = new (0, $88bb943f635c0a20$export$d0b6fa7b79a9a799)({
            navigation: navigation
        });
        const pushState = polyfillHistory.pushState.bind(polyfillHistory);
        const replaceState = polyfillHistory.replaceState.bind(polyfillHistory);
        const go = polyfillHistory.go.bind(polyfillHistory);
        const back = polyfillHistory.back.bind(polyfillHistory);
        const forward = polyfillHistory.forward.bind(polyfillHistory);
        const prototype = Object.getPrototypeOf(history);
        const descriptor = {
            pushState: {
                ...Object.getOwnPropertyDescriptor(prototype, "pushState"),
                value: pushState
            },
            replaceState: {
                ...Object.getOwnPropertyDescriptor(prototype, "replaceState"),
                value: replaceState
            },
            go: {
                ...Object.getOwnPropertyDescriptor(prototype, "go"),
                value: go
            },
            back: {
                ...Object.getOwnPropertyDescriptor(prototype, "back"),
                value: back
            },
            forward: {
                ...Object.getOwnPropertyDescriptor(prototype, "forward"),
                value: forward
            }
        };
        Object.defineProperties(prototype, descriptor);
        const stateDescriptor = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(history), "state");
        Object.defineProperty(history, "state", {
            ...stateDescriptor,
            get () {
                // Derive history state only ever directly from navigation state
                //
                // Decouple from classic history.state
                //
                // If the original state is wanted, use history.originalState,
                // which is done on a best effort basis and may be out of alignment from
                // navigation.currentEntry.getState()
                //
                // This state will always be tied to the navigation, not the background
                // browser's history stack, which could be offset from the applications
                // expected state between moments of transition.
                //
                // The change of using navigation.currentEntry.getState()
                // in place of history.state is significant, it's shifting to a model where
                // there can be an entry only for one single operation and then replaced
                //
                // e.g.
                //
                // navigation.navigate("/1", { state: { key: 1 }});
                // navigation.navigate("/2", { state: { key: 2 }});
                // await navigation.transition?.finished;
                //
                // The above code, if ran, history.state might not keep up...
                //
                // ... In safari if we run replaceState too many times in 30 seconds
                // then we will get an exception. So, inherently we know we
                // cannot just freely make use of history.state as a deterministic like
                // reference.
                return polyfillHistory.state;
            }
        });
        Object.defineProperty(history, "originalState", {
            ...stateDescriptor
        });
    }
    function patchPopState() {
        if (!window.PopStateEvent) return;
        const popStateEventPrototype = window.PopStateEvent.prototype;
        if (!popStateEventPrototype) return;
        const descriptor = Object.getOwnPropertyDescriptor(popStateEventPrototype, "state");
        Object.defineProperty(popStateEventPrototype, "state", {
            ...descriptor,
            get () {
                const original = descriptor.get.call(this);
                if (!$151c17f8fa405555$var$isStateHistoryWithMeta(original)) return original;
                return original[$151c17f8fa405555$export$d56b53a21110c33a].state;
            }
        });
        Object.defineProperty(popStateEventPrototype, "originalState", {
            ...descriptor
        });
    }
}
function $151c17f8fa405555$export$b12408dc2a9b1254(options = $151c17f8fa405555$export$cd4e898523b5d95a) {
    const { persist: PERSIST_ENTRIES, persistState: PERSIST_ENTRIES_STATE, history: givenHistory, limit: patchLimit, patch: PATCH_HISTORY, interceptEvents: INTERCEPT_EVENTS, window: givenWindow = (0, $682c802550adac96$export$9689045fea27ed13), navigation: givenNavigation } = {
        // These are super default options, if the object de
        ...$151c17f8fa405555$export$cd4e898523b5d95a,
        ...options
    };
    // console.log({
    //   ...DEFAULT_POLYFILL_OPTIONS,
    //   ...options
    // })
    const IS_PERSIST = PERSIST_ENTRIES || PERSIST_ENTRIES_STATE;
    const window = givenWindow ?? (0, $682c802550adac96$export$9689045fea27ed13);
    const history = options.history && typeof options.history !== "boolean" ? options.history : $151c17f8fa405555$var$getWindowHistory(window);
    if (!history) return $151c17f8fa405555$var$getNavigationOnlyPolyfill();
    // console.log("POLYFILL LOADING");
    (0, $7eb4e6f571ed6cae$export$dcb8b3f0e2de7e49)(window, "window required when using polyfill with history, this shouldn't be seen");
    // Use baseHistory so that we don't initialise entries we didn't intend to
    // if we used a polyfill history
    const historyInitialState = history?.state;
    let initialMeta = {
        [$151c17f8fa405555$export$24a0e8c547ac16d1]: true,
        currentIndex: -1,
        entries: [],
        key: "",
        state: undefined
    };
    if ($151c17f8fa405555$var$isStateHistoryWithMeta(historyInitialState)) initialMeta = historyInitialState[$151c17f8fa405555$export$d56b53a21110c33a];
    let initialEntries = initialMeta.entries;
    const HISTORY_INTEGRATION = !!((givenWindow || givenHistory) && history);
    if (!initialEntries.length) {
        let url = undefined;
        if (window.location?.href) url = window.location.href;
        let state = undefined;
        if (!$151c17f8fa405555$var$isStateHistoryWithMeta(historyInitialState) && !$151c17f8fa405555$var$isStateHistoryMeta(historyInitialState)) // console.log("Using state history direct", historyInitialState, history.state);
        state = historyInitialState;
        const key = (0, $a777f6d8c654ab05$export$afaf85bc510dd0d6)();
        initialEntries = [
            {
                key: key,
                state: state,
                url: url
            }
        ];
        initialMeta.key = key;
        initialMeta.currentIndex = 0;
    }
    // console.log("Initial Entries", initialEntries)
    const navigationOptions = {
        entries: initialEntries,
        currentIndex: initialMeta?.currentIndex,
        currentKey: initialMeta?.key,
        getState (entry) {
            if (!HISTORY_INTEGRATION) return;
            return $151c17f8fa405555$var$getHistoryState(history, entry);
        },
        setState (entry) {
            // console.log({
            //   setState: entry.getState(),
            //   entry
            // })
            if (!HISTORY_INTEGRATION) return;
            if (!entry.sameDocument) return;
            $151c17f8fa405555$var$setHistoryState(navigation, history, entry, IS_PERSIST, patchLimit);
        },
        disposeState (entry) {
            if (!HISTORY_INTEGRATION) return;
            $151c17f8fa405555$var$disposeHistoryState(entry, IS_PERSIST);
        }
    };
    const navigation = givenNavigation ?? new (0, $17c92abbed43f089$export$b8a61e5c71402559)(navigationOptions);
    const pushState = history?.pushState.bind(history);
    const replaceState = history?.replaceState.bind(history);
    const historyGo = history?.go.bind(history);
    // const back = history?.back.bind(history);
    // const forward = history?.forward.bind(history);
    // const origin = typeof location === "undefined" ? "https://example.com" : location.origin;
    return {
        navigation: navigation,
        history: history,
        apply () {
            // console.log("APPLYING POLYFILL TO NAVIGATION");
            if ($151c17f8fa405555$var$isNavigationPolyfill(navigation)) // Initialise navigation options
            navigation[0, $17c92abbed43f089$export$6bf089adaaa3be72](navigationOptions);
            if (HISTORY_INTEGRATION) {
                const ignorePopState = new Set();
                const ignoreCurrentEntryChange = new Set();
                navigation.addEventListener("navigate", (event)=>{
                    if (event.destination.sameDocument) return;
                    // If the destination is not the same document, we are navigating away
                    event.intercept({
                        // Set commit after transition... and never commit!
                        commit: "after-transition",
                        async handler () {
                            // Let other tasks do something and abort if needed
                            queueMicrotask(()=>{
                                if (event.signal.aborted) return;
                                submit();
                            });
                        }
                    });
                    function submit() {
                        if ((0, $7eb4e6f571ed6cae$export$e94e5ec04a02879c)(event.originalEvent)) {
                            const anchor = $151c17f8fa405555$var$getAnchorFromEvent(event.originalEvent);
                            if (anchor) return submitAnchor(anchor);
                            else {
                                const form = $151c17f8fa405555$var$getFormFromEvent(event.originalEvent);
                                if (form) return submitForm(form);
                            }
                        }
                        // Assumption that navigation event means to navigate...
                        location.href = event.destination.url;
                    }
                    function submitAnchor(element) {
                        const cloned = element.cloneNode();
                        cloned.setAttribute("data-navigation-ignore", "1");
                        cloned.click();
                    }
                    function submitForm(element) {
                        const cloned = element.cloneNode();
                        cloned.setAttribute("data-navigation-ignore", "1");
                        cloned.submit();
                    }
                });
                navigation.addEventListener("currententrychange", ({ navigationType: navigationType, from: from })=>{
                    // console.log("<-- currententrychange event listener -->");
                    const { currentEntry: currentEntry } = navigation;
                    if (!currentEntry) return;
                    const { key: key, url: url } = currentEntry;
                    if (ignoreCurrentEntryChange.delete(key) || !currentEntry?.sameDocument) return;
                    const historyState = $151c17f8fa405555$var$getNavigationEntryWithMeta(navigation, currentEntry, patchLimit);
                    // console.log("currentEntry change", historyState);
                    switch(navigationType || "replace"){
                        case "push":
                            return pushState(historyState, "", url);
                        case "replace":
                            return replaceState(historyState, "", url);
                        case "traverse":
                            const delta = currentEntry.index - from.index;
                            ignorePopState.add(key);
                            return historyGo(delta);
                        case "reload":
                    }
                });
                window.addEventListener("popstate", (event)=>{
                    // console.log("<-- popstate event listener -->");
                    const { state: state, originalState: originalState } = event;
                    const foundState = originalState ?? state;
                    if (!$151c17f8fa405555$var$isStateHistoryWithMeta(foundState)) return;
                    const { [$151c17f8fa405555$export$d56b53a21110c33a]: { key: key } } = foundState;
                    if (ignorePopState.delete(key)) return;
                    ignoreCurrentEntryChange.add(key);
                    let committed;
                    try {
                        committed = navigation.traverseTo(key).committed;
                    } catch (error) {
                        if (error instanceof (0, $a52002d449639897$export$b251fc1661a3152d) && !PERSIST_ENTRIES) // ignore the error
                        return;
                        throw error;
                    }
                    if (PERSIST_ENTRIES || PERSIST_ENTRIES_STATE) committed.then((entry)=>{
                        const historyState = $151c17f8fa405555$var$getNavigationEntryWithMeta(navigation, entry, patchLimit);
                        replaceState(historyState, "", entry.url);
                    })// Noop catch
                    .catch(()=>{});
                });
            // window.addEventListener("hashchange", (ev) => {
            //   // TODO
            // })
            }
            if (INTERCEPT_EVENTS) $151c17f8fa405555$var$interceptWindowClicks(navigation, window);
            if (PATCH_HISTORY) $151c17f8fa405555$var$patchGlobalScope(window, history, navigation);
            if (!history.state) {
                // Initialise history state if not available
                const historyState = $151c17f8fa405555$var$getNavigationEntryWithMeta(navigation, navigation.currentEntry, patchLimit);
                replaceState(historyState, "", navigation.currentEntry.url);
            }
        }
    };
}
function $151c17f8fa405555$var$isAppNavigation(evt) {
    return evt.button === 0 && !evt.defaultPrevented && !evt.metaKey && !evt.altKey && !evt.ctrlKey && !evt.shiftKey;
}
/** Checks if this element or any of its parents matches a given `selector` */ function $151c17f8fa405555$var$matchesAncestor(givenElement, selector) {
    let element = getDefaultElement();
    // console.log({ element })
    while(element){
        if (element.matches(selector)) {
            (0, $7eb4e6f571ed6cae$export$dcb8b3f0e2de7e49)(element);
            return element;
        }
        element = element.parentElement ?? element.getRootNode()?.host;
    }
    return undefined;
    function getDefaultElement() {
        if (!givenElement) return undefined;
        if (givenElement.matches instanceof Function) return givenElement;
        return givenElement.parentElement;
    }
}




function $98b18ed598de212a$export$cedc793e7bdf3b26(options = (0, $151c17f8fa405555$export$cd4e898523b5d95a)) {
    const { apply: apply, navigation: navigation } = (0, $151c17f8fa405555$export$b12408dc2a9b1254)(options);
    apply();
    return navigation;
}
function $98b18ed598de212a$export$9f808a058b1cd0e9(navigation = (0, $1d03eab8cfde430b$export$454d28c32a19d348)()) {
    const globalThat = globalThis;
    return navigation !== (0, $179b04608e775d68$export$7cd97e17c834df02) && !Object.hasOwn(globalThat, 'navigation') && typeof window !== "undefined";
}




const $12958ccf593bead3$var$navigation = (0, $1d03eab8cfde430b$export$454d28c32a19d348)();
if ((0, $98b18ed598de212a$export$9f808a058b1cd0e9)($12958ccf593bead3$var$navigation)) try {
    (0, $98b18ed598de212a$export$cedc793e7bdf3b26)({
        navigation: $12958ccf593bead3$var$navigation
    });
} catch (error) {
    console.error("Failed to apply polyfill");
    console.error(error);
}


function $2f76402fda74d87d$export$45d76561a5302f2b() {
    const [location, setLocation] = (0, $acw62.useState)(document.location.href);
    (0, $acw62.useEffect)(()=>{
        const listener = (ev)=>{
            if (!ev.canIntercept || ev.navigationType === 'reload') return;
            ev.intercept({
                async handler () {
                    //setLocation(document.location.href) // TODO https://github.com/virtualstate/navigation/issues/40
                    setLocation(ev.destination.url);
                }
            });
        };
        window.navigation.addEventListener('navigate', listener);
        return ()=>{
            window.navigation.removeEventListener('navigate', listener);
        };
    });
    return new URL(location);
}


// src/queryOptions.ts
function $70f3af89093871ad$export$9a8e3100474fe331(options) {
    return options;
}


var $acw62 = parcelRequire("acw62");
// src/queriesObserver.ts

// src/queryObserver.ts






var $2905803326ac545c$export$a06cf8c0066f0d4c = class extends (0, $f28bf069faa02086$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.options = options;
        this.#client = client;
        this.#selectError = null;
        this.#currentThenable = (0, $f6114de20f9a4572$export$d54630db02a12b72)();
        if (!this.options.experimental_prefetchInRender) this.#currentThenable.reject(new Error("experimental_prefetchInRender feature flag is not enabled"));
        this.bindMethods();
        this.setOptions(options);
    }
    #client;
    #currentQuery = void 0;
    #currentQueryInitialState = void 0;
    #currentResult = void 0;
    #currentResultState;
    #currentResultOptions;
    #currentThenable;
    #selectError;
    #selectFn;
    #selectResult;
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    #lastQueryWithDefinedData;
    #staleTimeoutId;
    #refetchIntervalId;
    #currentRefetchInterval;
    #trackedProps = /* @__PURE__ */ new Set();
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.#currentQuery.addObserver(this);
            if ($2905803326ac545c$var$shouldFetchOnMount(this.#currentQuery, this.options)) this.#executeFetch();
            else this.updateResult();
            this.#updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $2905803326ac545c$var$shouldFetchOn(this.#currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $2905803326ac545c$var$shouldFetchOn(this.#currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        this.#clearStaleTimeout();
        this.#clearRefetchInterval();
        this.#currentQuery.removeObserver(this);
    }
    setOptions(options) {
        const prevOptions = this.options;
        const prevQuery = this.#currentQuery;
        this.options = this.#client.defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof (0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(this.options.enabled, this.#currentQuery) !== "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
        this.#updateQuery();
        this.#currentQuery.setOptions(this.options);
        if (prevOptions._defaulted && !(0, $938ae10f13d49bdc$export$3e67810a3f0e9f1c)(this.options, prevOptions)) this.#client.getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: this.#currentQuery,
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && $2905803326ac545c$var$shouldFetchOptionally(this.#currentQuery, prevQuery, this.options, prevOptions)) this.#executeFetch();
        this.updateResult();
        if (mounted && (this.#currentQuery !== prevQuery || (0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(this.options.enabled, this.#currentQuery) !== (0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(prevOptions.enabled, this.#currentQuery) || (0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(this.options.staleTime, this.#currentQuery) !== (0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(prevOptions.staleTime, this.#currentQuery))) this.#updateStaleTimeout();
        const nextRefetchInterval = this.#computeRefetchInterval();
        if (mounted && (this.#currentQuery !== prevQuery || (0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(this.options.enabled, this.#currentQuery) !== (0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(prevOptions.enabled, this.#currentQuery) || nextRefetchInterval !== this.#currentRefetchInterval)) this.#updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.#client.getQueryCache().build(this.#client, options);
        const result = this.createResult(query, options);
        if ($2905803326ac545c$var$shouldAssignObserverCurrentProperties(this, result)) {
            this.#currentResult = result;
            this.#currentResultOptions = this.options;
            this.#currentResultState = this.#currentQuery.state;
        }
        return result;
    }
    getCurrentResult() {
        return this.#currentResult;
    }
    trackResult(result, onPropTracked) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackProp(key);
                    onPropTracked?.(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    trackProp(key) {
        this.#trackedProps.add(key);
    }
    getCurrentQuery() {
        return this.#currentQuery;
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.#client.defaultQueryOptions(options);
        const query = this.#client.getQueryCache().build(this.#client, defaultedOptions);
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return this.#executeFetch({
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return this.#currentResult;
        });
    }
    #executeFetch(fetchOptions) {
        this.#updateQuery();
        let promise = this.#currentQuery.fetch(this.options, fetchOptions);
        if (!fetchOptions?.throwOnError) promise = promise.catch((0, $938ae10f13d49bdc$export$8793edee2d425525));
        return promise;
    }
    #updateStaleTimeout() {
        this.#clearStaleTimeout();
        const staleTime = (0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(this.options.staleTime, this.#currentQuery);
        if ((0, $938ae10f13d49bdc$export$6acf61af03e62db) || this.#currentResult.isStale || !(0, $938ae10f13d49bdc$export$e539f754e934e270)(staleTime)) return;
        const time = (0, $938ae10f13d49bdc$export$811b83d62bcf47f0)(this.#currentResult.dataUpdatedAt, staleTime);
        const timeout = time + 1;
        this.#staleTimeoutId = setTimeout(()=>{
            if (!this.#currentResult.isStale) this.updateResult();
        }, timeout);
    }
    #computeRefetchInterval() {
        return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(this.#currentQuery) : this.options.refetchInterval) ?? false;
    }
    #updateRefetchInterval(nextInterval) {
        this.#clearRefetchInterval();
        this.#currentRefetchInterval = nextInterval;
        if ((0, $938ae10f13d49bdc$export$6acf61af03e62db) || (0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(this.options.enabled, this.#currentQuery) === false || !(0, $938ae10f13d49bdc$export$e539f754e934e270)(this.#currentRefetchInterval) || this.#currentRefetchInterval === 0) return;
        this.#refetchIntervalId = setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, $3f1a0485b2ecb725$export$6bf54661be5b02cf).isFocused()) this.#executeFetch();
        }, this.#currentRefetchInterval);
    }
    #updateTimers() {
        this.#updateStaleTimeout();
        this.#updateRefetchInterval(this.#computeRefetchInterval());
    }
    #clearStaleTimeout() {
        if (this.#staleTimeoutId) {
            clearTimeout(this.#staleTimeoutId);
            this.#staleTimeoutId = void 0;
        }
    }
    #clearRefetchInterval() {
        if (this.#refetchIntervalId) {
            clearInterval(this.#refetchIntervalId);
            this.#refetchIntervalId = void 0;
        }
    }
    createResult(query, options) {
        const prevQuery = this.#currentQuery;
        const prevOptions = this.options;
        const prevResult = this.#currentResult;
        const prevResultState = this.#currentResultState;
        const prevResultOptions = this.#currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.#currentQueryInitialState;
        const { state: state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $2905803326ac545c$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $2905803326ac545c$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, $bbb5e4108fb61687$export$f3df9013f2b58bce)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error: error, errorUpdatedAt: errorUpdatedAt, status: status } = newState;
        if (options.select && newState.data !== void 0) {
            if (prevResult && newState.data === prevResultState?.data && options.select === this.#selectFn) data = this.#selectResult;
            else try {
                this.#selectFn = options.select;
                data = options.select(newState.data);
                data = (0, $938ae10f13d49bdc$export$17619bac5b909b23)(prevResult?.data, data, options);
                this.#selectResult = data;
                this.#selectError = null;
            } catch (selectError) {
                this.#selectError = selectError;
            }
        } else data = newState.data;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if (prevResult?.isPlaceholderData && options.placeholderData === prevResultOptions?.placeholderData) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData(this.#lastQueryWithDefinedData?.state.data, this.#lastQueryWithDefinedData) : options.placeholderData;
                if (options.select && placeholderData !== void 0) try {
                    placeholderData = options.select(placeholderData);
                    this.#selectError = null;
                } catch (selectError) {
                    this.#selectError = selectError;
                }
            }
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, $938ae10f13d49bdc$export$17619bac5b909b23)(prevResult?.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (this.#selectError) {
            error = this.#selectError;
            data = this.#selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        const result = {
            status: status,
            fetchStatus: newState.fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: newState.dataUpdateCount > 0 || newState.errorUpdateCount > 0,
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: $2905803326ac545c$var$isStale(query, options),
            refetch: this.refetch,
            promise: this.#currentThenable
        };
        const nextResult = result;
        if (this.options.experimental_prefetchInRender) {
            const finalizeThenableIfPossible = (thenable)=>{
                if (nextResult.status === "error") thenable.reject(nextResult.error);
                else if (nextResult.data !== void 0) thenable.resolve(nextResult.data);
            };
            const recreateThenable = ()=>{
                const pending = this.#currentThenable = nextResult.promise = (0, $f6114de20f9a4572$export$d54630db02a12b72)();
                finalizeThenableIfPossible(pending);
            };
            const prevThenable = this.#currentThenable;
            switch(prevThenable.status){
                case "pending":
                    if (query.queryHash === prevQuery.queryHash) finalizeThenableIfPossible(prevThenable);
                    break;
                case "fulfilled":
                    if (nextResult.status === "error" || nextResult.data !== prevThenable.value) recreateThenable();
                    break;
                case "rejected":
                    if (nextResult.status !== "error" || nextResult.error !== prevThenable.reason) recreateThenable();
                    break;
            }
        }
        return nextResult;
    }
    updateResult() {
        const prevResult = this.#currentResult;
        const nextResult = this.createResult(this.#currentQuery, this.options);
        this.#currentResultState = this.#currentQuery.state;
        this.#currentResultOptions = this.options;
        if (this.#currentResultState.data !== void 0) this.#lastQueryWithDefinedData = this.#currentQuery;
        if ((0, $938ae10f13d49bdc$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        this.#currentResult = nextResult;
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !this.#trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? this.#trackedProps);
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys(this.#currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.#currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        this.#notify({
            listeners: shouldNotifyListeners()
        });
    }
    #updateQuery() {
        const query = this.#client.getQueryCache().build(this.#client, this.options);
        if (query === this.#currentQuery) return;
        const prevQuery = this.#currentQuery;
        this.#currentQuery = query;
        this.#currentQueryInitialState = query.state;
        if (this.hasListeners()) {
            prevQuery?.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) this.#updateTimers();
    }
    #notify(notifyOptions) {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
                listener(this.#currentResult);
            });
            this.#client.getQueryCache().notify({
                query: this.#currentQuery,
                type: "observerResultsUpdated"
            });
        });
    }
};
function $2905803326ac545c$var$shouldLoadOnMount(query, options) {
    return (0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && options.retryOnMount === false);
}
function $2905803326ac545c$var$shouldFetchOnMount(query, options) {
    return $2905803326ac545c$var$shouldLoadOnMount(query, options) || query.state.data !== void 0 && $2905803326ac545c$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $2905803326ac545c$var$shouldFetchOn(query, options, field) {
    if ((0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(options.enabled, query) !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $2905803326ac545c$var$isStale(query, options);
    }
    return false;
}
function $2905803326ac545c$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || (0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && $2905803326ac545c$var$isStale(query, options);
}
function $2905803326ac545c$var$isStale(query, options) {
    return (0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(options.enabled, query) !== false && query.isStaleByTime((0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(options.staleTime, query));
}
function $2905803326ac545c$var$shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, $938ae10f13d49bdc$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}




function $0e6b9b53d3bd0029$var$difference(array1, array2) {
    return array1.filter((x)=>!array2.includes(x));
}
function $0e6b9b53d3bd0029$var$replaceAt(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
var $0e6b9b53d3bd0029$export$15352e437905ad4c = class extends (0, $f28bf069faa02086$export$d26086b469ecdbcc) {
    #client;
    #result;
    #queries;
    #options;
    #observers;
    #combinedResult;
    #lastCombine;
    #lastResult;
    #observerMatches = [];
    constructor(client, queries, options){
        super();
        this.#client = client;
        this.#options = options;
        this.#queries = [];
        this.#observers = [];
        this.#result = [];
        this.setQueries(queries);
    }
    onSubscribe() {
        if (this.listeners.size === 1) this.#observers.forEach((observer)=>{
            observer.subscribe((result)=>{
                this.#onUpdate(observer, result);
            });
        });
    }
    onUnsubscribe() {
        if (!this.listeners.size) this.destroy();
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        this.#observers.forEach((observer)=>{
            observer.destroy();
        });
    }
    setQueries(queries, options) {
        this.#queries = queries;
        this.#options = options;
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            const prevObservers = this.#observers;
            const newObserverMatches = this.#findMatchingObservers(this.#queries);
            this.#observerMatches = newObserverMatches;
            newObserverMatches.forEach((match)=>match.observer.setOptions(match.defaultedQueryOptions));
            const newObservers = newObserverMatches.map((match)=>match.observer);
            const newResult = newObservers.map((observer)=>observer.getCurrentResult());
            const hasIndexChange = newObservers.some((observer, index)=>observer !== prevObservers[index]);
            if (prevObservers.length === newObservers.length && !hasIndexChange) return;
            this.#observers = newObservers;
            this.#result = newResult;
            if (!this.hasListeners()) return;
            $0e6b9b53d3bd0029$var$difference(prevObservers, newObservers).forEach((observer)=>{
                observer.destroy();
            });
            $0e6b9b53d3bd0029$var$difference(newObservers, prevObservers).forEach((observer)=>{
                observer.subscribe((result)=>{
                    this.#onUpdate(observer, result);
                });
            });
            this.#notify();
        });
    }
    getCurrentResult() {
        return this.#result;
    }
    getQueries() {
        return this.#observers.map((observer)=>observer.getCurrentQuery());
    }
    getObservers() {
        return this.#observers;
    }
    getOptimisticResult(queries, combine) {
        const matches = this.#findMatchingObservers(queries);
        const result = matches.map((match)=>match.observer.getOptimisticResult(match.defaultedQueryOptions));
        return [
            result,
            (r)=>{
                return this.#combineResult(r ?? result, combine);
            },
            ()=>{
                return this.#trackResult(result, matches);
            }
        ];
    }
    #trackResult(result, matches) {
        return matches.map((match, index)=>{
            const observerResult = result[index];
            return !match.defaultedQueryOptions.notifyOnChangeProps ? match.observer.trackResult(observerResult, (accessedProp)=>{
                matches.forEach((m)=>{
                    m.observer.trackProp(accessedProp);
                });
            }) : observerResult;
        });
    }
    #combineResult(input, combine) {
        if (combine) {
            if (!this.#combinedResult || this.#result !== this.#lastResult || combine !== this.#lastCombine) {
                this.#lastCombine = combine;
                this.#lastResult = this.#result;
                this.#combinedResult = (0, $938ae10f13d49bdc$export$77a71fc411098696)(this.#combinedResult, combine(input));
            }
            return this.#combinedResult;
        }
        return input;
    }
    #findMatchingObservers(queries) {
        const prevObserversMap = new Map(this.#observers.map((observer)=>[
                observer.options.queryHash,
                observer
            ]));
        const observers = [];
        queries.forEach((options)=>{
            const defaultedOptions = this.#client.defaultQueryOptions(options);
            const match = prevObserversMap.get(defaultedOptions.queryHash);
            if (match) observers.push({
                defaultedQueryOptions: defaultedOptions,
                observer: match
            });
            else observers.push({
                defaultedQueryOptions: defaultedOptions,
                observer: new (0, $2905803326ac545c$export$a06cf8c0066f0d4c)(this.#client, defaultedOptions)
            });
        });
        return observers;
    }
    #onUpdate(observer, result) {
        const index = this.#observers.indexOf(observer);
        if (index !== -1) {
            this.#result = $0e6b9b53d3bd0029$var$replaceAt(this.#result, index, result);
            this.#notify();
        }
    }
    #notify() {
        if (this.hasListeners()) {
            const previousResult = this.#combinedResult;
            const newTracked = this.#trackResult(this.#result, this.#observerMatches);
            const newResult = this.#combineResult(newTracked, this.#options?.combine);
            if (previousResult !== newResult) (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
                this.listeners.forEach((listener)=>{
                    listener(this.#result);
                });
            });
        }
    }
};




var $acw62 = parcelRequire("acw62");
"use client";
var $11f42db8a0dc909f$var$IsRestoringContext = $acw62.createContext(false);
var $11f42db8a0dc909f$export$4da0178d6b5f553 = ()=>$acw62.useContext($11f42db8a0dc909f$var$IsRestoringContext);
var $11f42db8a0dc909f$export$593807d4e94f9621 = $11f42db8a0dc909f$var$IsRestoringContext.Provider;



var $acw62 = parcelRequire("acw62");

"use client";
function $3ccd03800b9b1a4a$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var $3ccd03800b9b1a4a$var$QueryErrorResetBoundaryContext = $acw62.createContext($3ccd03800b9b1a4a$var$createValue());
var $3ccd03800b9b1a4a$export$50dfac555130cafd = ()=>$acw62.useContext($3ccd03800b9b1a4a$var$QueryErrorResetBoundaryContext);
var $3ccd03800b9b1a4a$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $acw62.useState(()=>$3ccd03800b9b1a4a$var$createValue());
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($3ccd03800b9b1a4a$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};



var $acw62 = parcelRequire("acw62");

"use client";
var $b8d88d7bae8d797f$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.throwOnError || options.experimental_prefetchInRender) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var $b8d88d7bae8d797f$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $acw62.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var $b8d88d7bae8d797f$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query, suspense: suspense })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (suspense && result.data === void 0 || (0, $74646d9ca64501e8$export$2072f68e6c3507cf)(throwOnError, [
        result.error,
        query
    ]));
};


// src/suspense.ts
var $d9109c84b9b954d9$export$8bed2f8d02206063 = (_error, query)=>query.state.data === void 0;
var $d9109c84b9b954d9$export$274d2a1db5a20c09 = (defaultedOptions)=>{
    const originalStaleTime = defaultedOptions.staleTime;
    if (defaultedOptions.suspense) {
        defaultedOptions.staleTime = typeof originalStaleTime === "function" ? (...args)=>Math.max(originalStaleTime(...args), 1e3) : Math.max(originalStaleTime ?? 1e3, 1e3);
        if (typeof defaultedOptions.gcTime === "number") defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, 1e3);
    }
};
var $d9109c84b9b954d9$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var $d9109c84b9b954d9$export$88d3586dfed64df9 = (defaultedOptions, result)=>defaultedOptions?.suspense && result.isPending;
var $d9109c84b9b954d9$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });



"use client";
function $ced1a275210252b1$export$408667c6c87da1e5({ queries: queries, ...options }, queryClient) {
    const client = (0, $c780594f51309d36$export$22e77b9572c4fded)(queryClient);
    const isRestoring = (0, $11f42db8a0dc909f$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $3ccd03800b9b1a4a$export$50dfac555130cafd)();
    const defaultedQueries = $acw62.useMemo(()=>queries.map((opts)=>{
            const defaultedOptions = client.defaultQueryOptions(opts);
            defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
            return defaultedOptions;
        }), [
        queries,
        client,
        isRestoring
    ]);
    defaultedQueries.forEach((query)=>{
        (0, $d9109c84b9b954d9$export$274d2a1db5a20c09)(query);
        (0, $b8d88d7bae8d797f$export$ae8adb3de3d77633)(query, errorResetBoundary);
    });
    (0, $b8d88d7bae8d797f$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const [observer] = $acw62.useState(()=>new (0, $0e6b9b53d3bd0029$export$15352e437905ad4c)(client, defaultedQueries, options));
    const [optimisticResult, getCombinedResult, trackResult] = observer.getOptimisticResult(defaultedQueries, options.combine);
    const shouldSubscribe = !isRestoring && options.subscribed !== false;
    $acw62.useSyncExternalStore($acw62.useCallback((onStoreChange)=>shouldSubscribe ? observer.subscribe((0, $e2307e33fb454067$export$520687f44db6e1ab).batchCalls(onStoreChange)) : (0, $74646d9ca64501e8$export$8793edee2d425525), [
        observer,
        shouldSubscribe
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $acw62.useEffect(()=>{
        observer.setQueries(defaultedQueries, options);
    }, [
        defaultedQueries,
        options,
        observer
    ]);
    const shouldAtLeastOneSuspend = optimisticResult.some((result, index)=>(0, $d9109c84b9b954d9$export$88d3586dfed64df9)(defaultedQueries[index], result));
    const suspensePromises = shouldAtLeastOneSuspend ? optimisticResult.flatMap((result, index)=>{
        const opts = defaultedQueries[index];
        if (opts) {
            const queryObserver = new (0, $2905803326ac545c$export$a06cf8c0066f0d4c)(client, opts);
            if ((0, $d9109c84b9b954d9$export$88d3586dfed64df9)(opts, result)) return (0, $d9109c84b9b954d9$export$defdc11a9c9acfcf)(opts, queryObserver, errorResetBoundary);
            else if ((0, $d9109c84b9b954d9$export$e0a3f29513afe430)(result, isRestoring)) (0, $d9109c84b9b954d9$export$defdc11a9c9acfcf)(opts, queryObserver, errorResetBoundary);
        }
        return [];
    }) : [];
    if (suspensePromises.length > 0) throw Promise.all(suspensePromises);
    const firstSingleResultWhichShouldThrow = optimisticResult.find((result, index)=>{
        const query = defaultedQueries[index];
        return query && (0, $b8d88d7bae8d797f$export$1fbcf724762d607)({
            result: result,
            errorResetBoundary: errorResetBoundary,
            throwOnError: query.throwOnError,
            query: client.getQueryCache().get(query.queryHash),
            suspense: query.suspense
        });
    });
    if (firstSingleResultWhichShouldThrow?.error) throw firstSingleResultWhichShouldThrow.error;
    return getCombinedResult(trackResult());
}



var $acw62 = parcelRequire("acw62");







"use client";
function $22b97878ddf0e02d$export$fff0865807e996c5(options, Observer, queryClient) {
    const client = (0, $c780594f51309d36$export$22e77b9572c4fded)(queryClient);
    const isRestoring = (0, $11f42db8a0dc909f$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $3ccd03800b9b1a4a$export$50dfac555130cafd)();
    const defaultedOptions = client.defaultQueryOptions(options);
    client.getDefaultOptions().queries?._experimental_beforeQuery?.(defaultedOptions);
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    (0, $d9109c84b9b954d9$export$274d2a1db5a20c09)(defaultedOptions);
    (0, $b8d88d7bae8d797f$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary);
    (0, $b8d88d7bae8d797f$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const isNewCacheEntry = !client.getQueryCache().get(defaultedOptions.queryHash);
    const [observer] = $acw62.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    const shouldSubscribe = !isRestoring && options.subscribed !== false;
    $acw62.useSyncExternalStore($acw62.useCallback((onStoreChange)=>{
        const unsubscribe = shouldSubscribe ? observer.subscribe((0, $e2307e33fb454067$export$520687f44db6e1ab).batchCalls(onStoreChange)) : (0, $74646d9ca64501e8$export$8793edee2d425525);
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        shouldSubscribe
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $acw62.useEffect(()=>{
        observer.setOptions(defaultedOptions);
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $d9109c84b9b954d9$export$88d3586dfed64df9)(defaultedOptions, result)) throw (0, $d9109c84b9b954d9$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $b8d88d7bae8d797f$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: client.getQueryCache().get(defaultedOptions.queryHash),
        suspense: defaultedOptions.suspense
    })) throw result.error;
    client.getDefaultOptions().queries?._experimental_afterQuery?.(defaultedOptions, result);
    if (defaultedOptions.experimental_prefetchInRender && !(0, $938ae10f13d49bdc$export$6acf61af03e62db) && (0, $d9109c84b9b954d9$export$e0a3f29513afe430)(result, isRestoring)) {
        const promise = isNewCacheEntry ? // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
        (0, $d9109c84b9b954d9$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary) : // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
        client.getQueryCache().get(defaultedOptions.queryHash)?.promise;
        promise?.catch((0, $74646d9ca64501e8$export$8793edee2d425525)).finally(()=>{
            observer.updateResult();
        });
    }
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


"use client";
function $4cdfd80436a5bb32$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $22b97878ddf0e02d$export$fff0865807e996c5)(options, (0, $2905803326ac545c$export$a06cf8c0066f0d4c), queryClient);
}




"use client";
function $2576eb5fa225a914$export$5bf2755c0a009e74(options, queryClient) {
    return (0, $22b97878ddf0e02d$export$fff0865807e996c5)({
        ...options,
        enabled: true,
        suspense: true,
        throwOnError: (0, $d9109c84b9b954d9$export$8bed2f8d02206063),
        placeholderData: void 0
    }, (0, $2905803326ac545c$export$a06cf8c0066f0d4c), queryClient);
}


class $de2aa269f2af170d$export$62297b13309008b2 {
    constructor(_flatKey, _useFetch){
        this._flatKey = _flatKey;
        this._useFetch = _useFetch;
    }
    flatKey(...t) {
        return this._flatKey(...t);
    }
    useSetUp() {
        this._fetch = this._useFetch();
    }
    useQueryOptions() {
        const fetch = this._useFetch();
        return (t)=>(0, $70f3af89093871ad$export$9a8e3100474fe331)({
                retry: false,
                staleTime: Infinity,
                queryKey: this._flatKey(...t),
                queryFn: ({ queryKey: queryKey })=>fetch(...queryKey)
            });
    }
    use(...t) {
        const options = this.useQueryOptions();
        return (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)(options(t));
    }
    useSuspense(...t) {
        const options = this.useQueryOptions();
        return (0, $2576eb5fa225a914$export$5bf2755c0a009e74)(options(t));
    }
    useMany(ts) {
        const options = this.useQueryOptions();
        return (0, $ced1a275210252b1$export$408667c6c87da1e5)({
            queries: ts.map((t)=>options(t))
        });
    }
    noUse() {
        this.useQueryOptions();
        return (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
            staleTime: Infinity,
            queryKey: [
                'nouse'
            ],
            queryFn: ()=>null
        });
    }
    async get(qc, t) {
        if (!this._fetch) throw new Error('Use QuerySetup first!');
        return {
            data: await qc.ensureQueryData({
                staleTime: Infinity,
                queryKey: this._flatKey(...t),
                queryFn: ({ queryKey: queryKey })=>this._fetch(...queryKey)
            })
        };
    }
    setData(qc, t, data) {
        qc.setQueryData(this.flatKey(...t), data);
    }
    async patchData(qc, t, updater) {
        const queryKey = this.flatKey(...t);
        await this.get(qc, t);
        const state = qc.getQueryState(queryKey);
        if (!state || !state.data) {
            console.warn('Can`t patch a query data that`s not there.');
            qc.invalidateQueries({
                queryKey: queryKey
            });
            return;
        }
        qc.setQueryData(queryKey, updater(state.data), {
            updatedAt: state.dataUpdatedAt
        });
    }
    async invalidate(qc, t) {
        await qc.invalidateQueries({
            queryKey: this.flatKey(...t)
        });
    }
}
function $de2aa269f2af170d$export$cf926772a52f47a5({ queries: queries, children: children }) {
    for (const query of queries)query.useSetUp();
    return children;
}





/*! MIT License © Sindre Sorhus */ class $36b67ef8a3cfb321$export$aa9d629c530f62a7 extends Error {
    response;
    request;
    options;
    constructor(response, request, options){
        const code = response.status || response.status === 0 ? response.status : '';
        const title = response.statusText || '';
        const status = `${code} ${title}`.trim();
        const reason = status ? `status code ${status}` : 'an unknown error';
        super(`Request failed with ${reason}: ${request.method} ${request.url}`);
        this.name = 'HTTPError';
        this.response = response;
        this.request = request;
        this.options = options;
    }
}


class $b23217586c9b8e5d$export$66d311bf29d5c89c extends Error {
    request;
    constructor(request){
        super(`Request timed out: ${request.method} ${request.url}`);
        this.name = 'TimeoutError';
        this.request = request;
    }
}


const $1ff2fea6a6c86f37$export$d8618555562b76b7 = (()=>{
    let duplexAccessed = false;
    let hasContentType = false;
    const supportsReadableStream = typeof globalThis.ReadableStream === 'function';
    const supportsRequest = typeof globalThis.Request === 'function';
    if (supportsReadableStream && supportsRequest) try {
        hasContentType = new globalThis.Request('https://empty.invalid', {
            body: new globalThis.ReadableStream(),
            method: 'POST',
            // @ts-expect-error - Types are outdated.
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        }).headers.has('Content-Type');
    } catch (error) {
        // QQBrowser on iOS throws "unsupported BodyInit type" error (see issue #581)
        if (error instanceof Error && error.message === 'unsupported BodyInit type') return false;
        throw error;
    }
    return duplexAccessed && !hasContentType;
})();
const $1ff2fea6a6c86f37$export$6c0aacaed85a4966 = typeof globalThis.AbortController === 'function';
const $1ff2fea6a6c86f37$export$135162ac70ac2b21 = typeof globalThis.ReadableStream === 'function';
const $1ff2fea6a6c86f37$export$f1525fa7979d0aa9 = typeof globalThis.FormData === 'function';
const $1ff2fea6a6c86f37$export$fb003dbd6df95edb = [
    'get',
    'post',
    'put',
    'patch',
    'head',
    'delete'
];
const $1ff2fea6a6c86f37$var$validate = ()=>undefined;
$1ff2fea6a6c86f37$var$validate();
const $1ff2fea6a6c86f37$export$a6f212d4ee888d8c = {
    json: 'application/json',
    text: 'text/*',
    formData: 'multipart/form-data',
    arrayBuffer: '*/*',
    blob: '*/*'
};
const $1ff2fea6a6c86f37$export$9b60a72e3f70a1d2 = 2147483647;
const $1ff2fea6a6c86f37$export$23af28b03ba58178 = new TextEncoder().encode('------WebKitFormBoundaryaxpyiPgbbPti10Rw').length;
const $1ff2fea6a6c86f37$export$fa6813432f753b0d = Symbol('stop');
const $1ff2fea6a6c86f37$export$601fffa09f19102d = {
    json: true,
    parseJson: true,
    stringifyJson: true,
    searchParams: true,
    prefixUrl: true,
    retry: true,
    timeout: true,
    hooks: true,
    throwHttpErrors: true,
    onDownloadProgress: true,
    onUploadProgress: true,
    fetch: true
};
const $1ff2fea6a6c86f37$export$b2ec467665ae937d = {
    method: true,
    headers: true,
    body: true,
    mode: true,
    credentials: true,
    cache: true,
    redirect: true,
    referrer: true,
    referrerPolicy: true,
    integrity: true,
    keepalive: true,
    signal: true,
    window: true,
    dispatcher: true,
    duplex: true,
    priority: true
};


const $eac7b30d3c5d45f3$export$cefbc488a81111a3 = (body)=>{
    if (!body) return 0;
    if (body instanceof FormData) {
        // This is an approximation, as FormData size calculation is not straightforward
        let size = 0;
        for (const [key, value] of body){
            size += (0, $1ff2fea6a6c86f37$export$23af28b03ba58178);
            size += new TextEncoder().encode(`Content-Disposition: form-data; name="${key}"`).length;
            size += typeof value === 'string' ? new TextEncoder().encode(value).length : value.size;
        }
        return size;
    }
    if (body instanceof Blob) return body.size;
    if (body instanceof ArrayBuffer) return body.byteLength;
    if (typeof body === 'string') return new TextEncoder().encode(body).length;
    if (body instanceof URLSearchParams) return new TextEncoder().encode(body.toString()).length;
    if ('byteLength' in body) return body.byteLength;
    if (typeof body === 'object' && body !== null) try {
        const jsonString = JSON.stringify(body);
        return new TextEncoder().encode(jsonString).length;
    } catch  {
        return 0;
    }
    return 0; // Default case, unable to determine size
};
const $eac7b30d3c5d45f3$export$2e6c793c88b27395 = (response, onDownloadProgress)=>{
    const totalBytes = Number(response.headers.get('content-length')) || 0;
    let transferredBytes = 0;
    if (response.status === 204) {
        if (onDownloadProgress) onDownloadProgress({
            percent: 1,
            totalBytes: totalBytes,
            transferredBytes: transferredBytes
        }, new Uint8Array());
        return new Response(null, {
            status: response.status,
            statusText: response.statusText,
            headers: response.headers
        });
    }
    return new Response(new ReadableStream({
        async start (controller) {
            const reader = response.body.getReader();
            if (onDownloadProgress) onDownloadProgress({
                percent: 0,
                transferredBytes: 0,
                totalBytes: totalBytes
            }, new Uint8Array());
            async function read() {
                const { done: done, value: value } = await reader.read();
                if (done) {
                    controller.close();
                    return;
                }
                if (onDownloadProgress) {
                    transferredBytes += value.byteLength;
                    const percent = totalBytes === 0 ? 0 : transferredBytes / totalBytes;
                    onDownloadProgress({
                        percent: percent,
                        transferredBytes: transferredBytes,
                        totalBytes: totalBytes
                    }, value);
                }
                controller.enqueue(value);
                await read();
            }
            await read();
        }
    }), {
        status: response.status,
        statusText: response.statusText,
        headers: response.headers
    });
};
const $eac7b30d3c5d45f3$export$99096e10de875468 = (request, onUploadProgress)=>{
    const totalBytes = $eac7b30d3c5d45f3$export$cefbc488a81111a3(request.body);
    let transferredBytes = 0;
    return new Request(request, {
        // @ts-expect-error - Types are outdated.
        duplex: 'half',
        body: new ReadableStream({
            async start (controller) {
                const reader = request.body instanceof ReadableStream ? request.body.getReader() : new Response('').body.getReader();
                async function read() {
                    const { done: done, value: value } = await reader.read();
                    if (done) {
                        // Ensure 100% progress is reported when the upload is complete
                        if (onUploadProgress) onUploadProgress({
                            percent: 1,
                            transferredBytes: transferredBytes,
                            totalBytes: Math.max(totalBytes, transferredBytes)
                        }, new Uint8Array());
                        controller.close();
                        return;
                    }
                    transferredBytes += value.byteLength;
                    let percent = totalBytes === 0 ? 0 : transferredBytes / totalBytes;
                    if (totalBytes < transferredBytes || percent === 1) percent = 0.99;
                    if (onUploadProgress) onUploadProgress({
                        percent: Number(percent.toFixed(2)),
                        transferredBytes: transferredBytes,
                        totalBytes: totalBytes
                    }, value);
                    controller.enqueue(value);
                    await read();
                }
                await read();
            }
        })
    });
};


// eslint-disable-next-line @typescript-eslint/ban-types
const $8c078d120c1f3882$export$a6cdc56e425d0d0a = (value)=>value !== null && typeof value === 'object';


const $1354e4c7c55c83be$export$8886f5ba30bd5e0 = (...sources)=>{
    for (const source of sources){
        if ((!(0, $8c078d120c1f3882$export$a6cdc56e425d0d0a)(source) || Array.isArray(source)) && source !== undefined) throw new TypeError('The `options` argument must be an object');
    }
    return $1354e4c7c55c83be$export$6969335ea1e4e77c({}, ...sources);
};
const $1354e4c7c55c83be$export$eee1781d075786ae = (source1 = {}, source2 = {})=>{
    const result = new globalThis.Headers(source1);
    const isHeadersInstance = source2 instanceof globalThis.Headers;
    const source = new globalThis.Headers(source2);
    for (const [key, value] of source.entries())if (isHeadersInstance && value === 'undefined' || value === undefined) result.delete(key);
    else result.set(key, value);
    return result;
};
function $1354e4c7c55c83be$var$newHookValue(original, incoming, property) {
    return Object.hasOwn(incoming, property) && incoming[property] === undefined ? [] : $1354e4c7c55c83be$export$6969335ea1e4e77c(original[property] ?? [], incoming[property] ?? []);
}
const $1354e4c7c55c83be$export$3de1ffbf114b9f2d = (original = {}, incoming = {})=>({
        beforeRequest: $1354e4c7c55c83be$var$newHookValue(original, incoming, 'beforeRequest'),
        beforeRetry: $1354e4c7c55c83be$var$newHookValue(original, incoming, 'beforeRetry'),
        afterResponse: $1354e4c7c55c83be$var$newHookValue(original, incoming, 'afterResponse'),
        beforeError: $1354e4c7c55c83be$var$newHookValue(original, incoming, 'beforeError')
    });
const $1354e4c7c55c83be$export$6969335ea1e4e77c = (...sources)=>{
    let returnValue = {};
    let headers = {};
    let hooks = {};
    for (const source of sources){
        if (Array.isArray(source)) {
            if (!Array.isArray(returnValue)) returnValue = [];
            returnValue = [
                ...returnValue,
                ...source
            ];
        } else if ((0, $8c078d120c1f3882$export$a6cdc56e425d0d0a)(source)) {
            for (let [key, value] of Object.entries(source)){
                if ((0, $8c078d120c1f3882$export$a6cdc56e425d0d0a)(value) && key in returnValue) value = $1354e4c7c55c83be$export$6969335ea1e4e77c(returnValue[key], value);
                returnValue = {
                    ...returnValue,
                    [key]: value
                };
            }
            if ((0, $8c078d120c1f3882$export$a6cdc56e425d0d0a)(source.hooks)) {
                hooks = $1354e4c7c55c83be$export$3de1ffbf114b9f2d(hooks, source.hooks);
                returnValue.hooks = hooks;
            }
            if ((0, $8c078d120c1f3882$export$a6cdc56e425d0d0a)(source.headers)) {
                headers = $1354e4c7c55c83be$export$eee1781d075786ae(headers, source.headers);
                returnValue.headers = headers;
            }
        }
    }
    return returnValue;
};



const $0f62514eee248549$export$d585027d4667ffce = (input)=>(0, $1ff2fea6a6c86f37$export$fb003dbd6df95edb).includes(input) ? input.toUpperCase() : input;
const $0f62514eee248549$var$retryMethods = [
    'get',
    'put',
    'head',
    'delete',
    'options',
    'trace'
];
const $0f62514eee248549$var$retryStatusCodes = [
    408,
    413,
    429,
    500,
    502,
    503,
    504
];
const $0f62514eee248549$var$retryAfterStatusCodes = [
    413,
    429,
    503
];
const $0f62514eee248549$var$defaultRetryOptions = {
    limit: 2,
    methods: $0f62514eee248549$var$retryMethods,
    statusCodes: $0f62514eee248549$var$retryStatusCodes,
    afterStatusCodes: $0f62514eee248549$var$retryAfterStatusCodes,
    maxRetryAfter: Number.POSITIVE_INFINITY,
    backoffLimit: Number.POSITIVE_INFINITY,
    delay: (attemptCount)=>0.3 * 2 ** (attemptCount - 1) * 1000
};
const $0f62514eee248549$export$3e5471bb9440c9c1 = (retry = {})=>{
    if (typeof retry === 'number') return {
        ...$0f62514eee248549$var$defaultRetryOptions,
        limit: retry
    };
    if (retry.methods && !Array.isArray(retry.methods)) throw new Error('retry.methods must be an array');
    if (retry.statusCodes && !Array.isArray(retry.statusCodes)) throw new Error('retry.statusCodes must be an array');
    return {
        ...$0f62514eee248549$var$defaultRetryOptions,
        ...retry
    };
};



async function $f071b3ea9e26abc5$export$2e2bcd8739ae039(request, init, abortController, options) {
    return new Promise((resolve, reject)=>{
        const timeoutId = setTimeout(()=>{
            if (abortController) abortController.abort();
            reject(new (0, $b23217586c9b8e5d$export$66d311bf29d5c89c)(request));
        }, options.timeout);
        options.fetch(request, init).then(resolve).catch(reject).then(()=>{
            clearTimeout(timeoutId);
        });
    });
}


// https://github.com/sindresorhus/delay/tree/ab98ae8dfcb38e1593286c94d934e70d14a4e111
async function $089f0b9783120894$export$2e2bcd8739ae039(ms, { signal: signal }) {
    return new Promise((resolve, reject)=>{
        if (signal) {
            signal.throwIfAborted();
            signal.addEventListener('abort', abortHandler, {
                once: true
            });
        }
        function abortHandler() {
            clearTimeout(timeoutId);
            reject(signal.reason);
        }
        const timeoutId = setTimeout(()=>{
            signal?.removeEventListener('abort', abortHandler);
            resolve();
        }, ms);
    });
}



const $9336c4545dcaac68$export$95d8775889ec941f = (request, options)=>{
    const unknownOptions = {};
    for(const key in options)if (!(key in (0, $1ff2fea6a6c86f37$export$b2ec467665ae937d)) && !(key in (0, $1ff2fea6a6c86f37$export$601fffa09f19102d)) && !(key in request)) unknownOptions[key] = options[key];
    return unknownOptions;
};



class $423bd113d368b878$export$c482d6f00e170af3 {
    static create(input, options) {
        const ky = new $423bd113d368b878$export$c482d6f00e170af3(input, options);
        const function_ = async ()=>{
            if (typeof ky._options.timeout === 'number' && ky._options.timeout > (0, $1ff2fea6a6c86f37$export$9b60a72e3f70a1d2)) throw new RangeError(`The \`timeout\` option cannot be greater than ${(0, $1ff2fea6a6c86f37$export$9b60a72e3f70a1d2)}`);
            // Delay the fetch so that body method shortcuts can set the Accept header
            await Promise.resolve();
            // Before using ky.request, _fetch clones it and saves the clone for future retries to use.
            // If retry is not needed, close the cloned request's ReadableStream for memory safety.
            let response = await ky._fetch();
            for (const hook of ky._options.hooks.afterResponse){
                // eslint-disable-next-line no-await-in-loop
                const modifiedResponse = await hook(ky.request, ky._options, ky._decorateResponse(response.clone()));
                if (modifiedResponse instanceof globalThis.Response) response = modifiedResponse;
            }
            ky._decorateResponse(response);
            if (!response.ok && ky._options.throwHttpErrors) {
                let error = new (0, $36b67ef8a3cfb321$export$aa9d629c530f62a7)(response, ky.request, ky._options);
                for (const hook of ky._options.hooks.beforeError)// eslint-disable-next-line no-await-in-loop
                error = await hook(error);
                throw error;
            }
            // Now that we know a retry is not needed, close the ReadableStream of the cloned request.
            if (!ky.request.bodyUsed) await ky.request.body?.cancel();
            // If `onDownloadProgress` is passed, it uses the stream API internally
            if (ky._options.onDownloadProgress) {
                if (typeof ky._options.onDownloadProgress !== 'function') throw new TypeError('The `onDownloadProgress` option must be a function');
                if (!(0, $1ff2fea6a6c86f37$export$135162ac70ac2b21)) throw new Error('Streams are not supported in your environment. `ReadableStream` is missing.');
                return (0, $eac7b30d3c5d45f3$export$2e6c793c88b27395)(response.clone(), ky._options.onDownloadProgress);
            }
            return response;
        };
        const isRetriableMethod = ky._options.retry.methods.includes(ky.request.method.toLowerCase());
        const result = isRetriableMethod ? ky._retry(function_) : function_();
        for (const [type, mimeType] of Object.entries((0, $1ff2fea6a6c86f37$export$a6f212d4ee888d8c)))result[type] = async ()=>{
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            ky.request.headers.set('accept', ky.request.headers.get('accept') || mimeType);
            const response = await result;
            if (type === 'json') {
                if (response.status === 204) return '';
                const arrayBuffer = await response.clone().arrayBuffer();
                const responseSize = arrayBuffer.byteLength;
                if (responseSize === 0) return '';
                if (options.parseJson) return options.parseJson(await response.text());
            }
            return response[type]();
        };
        return result;
    }
    request;
    abortController;
    _retryCount = 0;
    _input;
    _options;
    // eslint-disable-next-line complexity
    constructor(input, options = {}){
        this._input = input;
        this._options = {
            ...options,
            headers: (0, $1354e4c7c55c83be$export$eee1781d075786ae)(this._input.headers, options.headers),
            hooks: (0, $1354e4c7c55c83be$export$3de1ffbf114b9f2d)({
                beforeRequest: [],
                beforeRetry: [],
                beforeError: [],
                afterResponse: []
            }, options.hooks),
            method: (0, $0f62514eee248549$export$d585027d4667ffce)(options.method ?? this._input.method ?? 'GET'),
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            prefixUrl: String(options.prefixUrl || ''),
            retry: (0, $0f62514eee248549$export$3e5471bb9440c9c1)(options.retry),
            throwHttpErrors: options.throwHttpErrors !== false,
            timeout: options.timeout ?? 10000,
            fetch: options.fetch ?? globalThis.fetch.bind(globalThis)
        };
        if (typeof this._input !== 'string' && !(this._input instanceof URL || this._input instanceof globalThis.Request)) throw new TypeError('`input` must be a string, URL, or Request');
        if (this._options.prefixUrl && typeof this._input === 'string') {
            if (this._input.startsWith('/')) throw new Error('`input` must not begin with a slash when using `prefixUrl`');
            if (!this._options.prefixUrl.endsWith('/')) this._options.prefixUrl += '/';
            this._input = this._options.prefixUrl + this._input;
        }
        if (0, $1ff2fea6a6c86f37$export$6c0aacaed85a4966) {
            const originalSignal = this._options.signal ?? this._input.signal;
            this.abortController = new globalThis.AbortController();
            this._options.signal = originalSignal ? AbortSignal.any([
                originalSignal,
                this.abortController.signal
            ]) : this.abortController.signal;
        }
        if (0, $1ff2fea6a6c86f37$export$d8618555562b76b7) // @ts-expect-error - Types are outdated.
        this._options.duplex = 'half';
        if (this._options.json !== undefined) {
            this._options.body = this._options.stringifyJson?.(this._options.json) ?? JSON.stringify(this._options.json);
            this._options.headers.set('content-type', this._options.headers.get('content-type') ?? 'application/json');
        }
        this.request = new globalThis.Request(this._input, this._options);
        if (this._options.searchParams) {
            // eslint-disable-next-line unicorn/prevent-abbreviations
            const textSearchParams = typeof this._options.searchParams === 'string' ? this._options.searchParams.replace(/^\?/, '') : new URLSearchParams(this._options.searchParams).toString();
            // eslint-disable-next-line unicorn/prevent-abbreviations
            const searchParams = '?' + textSearchParams;
            const url = this.request.url.replace(/(?:\?.*?)?(?=#|$)/, searchParams);
            // To provide correct form boundary, Content-Type header should be deleted each time when new Request instantiated from another one
            if (((0, $1ff2fea6a6c86f37$export$f1525fa7979d0aa9) && this._options.body instanceof globalThis.FormData || this._options.body instanceof URLSearchParams) && !(this._options.headers && this._options.headers['content-type'])) this.request.headers.delete('content-type');
            // The spread of `this.request` is required as otherwise it misses the `duplex` option for some reason and throws.
            this.request = new globalThis.Request(new globalThis.Request(url, {
                ...this.request
            }), this._options);
        }
        // If `onUploadProgress` is passed, it uses the stream API internally
        if (this._options.onUploadProgress) {
            if (typeof this._options.onUploadProgress !== 'function') throw new TypeError('The `onUploadProgress` option must be a function');
            if (!(0, $1ff2fea6a6c86f37$export$d8618555562b76b7)) throw new Error('Request streams are not supported in your environment. The `duplex` option for `Request` is not available.');
            const originalBody = this.request.body;
            if (originalBody) this.request = (0, $eac7b30d3c5d45f3$export$99096e10de875468)(this.request, this._options.onUploadProgress);
        }
    }
    _calculateRetryDelay(error) {
        this._retryCount++;
        if (this._retryCount > this._options.retry.limit || error instanceof (0, $b23217586c9b8e5d$export$66d311bf29d5c89c)) throw error;
        if (error instanceof (0, $36b67ef8a3cfb321$export$aa9d629c530f62a7)) {
            if (!this._options.retry.statusCodes.includes(error.response.status)) throw error;
            const retryAfter = error.response.headers.get('Retry-After') ?? error.response.headers.get('RateLimit-Reset') ?? error.response.headers.get('X-RateLimit-Reset') // GitHub
             ?? error.response.headers.get('X-Rate-Limit-Reset'); // Twitter
            if (retryAfter && this._options.retry.afterStatusCodes.includes(error.response.status)) {
                let after = Number(retryAfter) * 1000;
                if (Number.isNaN(after)) after = Date.parse(retryAfter) - Date.now();
                else if (after >= Date.parse('2024-01-01')) // A large number is treated as a timestamp (fixed threshold protects against clock skew)
                after -= Date.now();
                const max = this._options.retry.maxRetryAfter ?? after;
                return after < max ? after : max;
            }
            if (error.response.status === 413) throw error;
        }
        const retryDelay = this._options.retry.delay(this._retryCount);
        return Math.min(this._options.retry.backoffLimit, retryDelay);
    }
    _decorateResponse(response) {
        if (this._options.parseJson) response.json = async ()=>this._options.parseJson(await response.text());
        return response;
    }
    async _retry(function_) {
        try {
            return await function_();
        } catch (error) {
            const ms = Math.min(this._calculateRetryDelay(error), (0, $1ff2fea6a6c86f37$export$9b60a72e3f70a1d2));
            if (this._retryCount < 1) throw error;
            await (0, $089f0b9783120894$export$2e2bcd8739ae039)(ms, {
                signal: this._options.signal
            });
            for (const hook of this._options.hooks.beforeRetry){
                // eslint-disable-next-line no-await-in-loop
                const hookResult = await hook({
                    request: this.request,
                    options: this._options,
                    error: error,
                    retryCount: this._retryCount
                });
                // If `stop` is returned from the hook, the retry process is stopped
                if (hookResult === (0, $1ff2fea6a6c86f37$export$fa6813432f753b0d)) return;
            }
            return this._retry(function_);
        }
    }
    async _fetch() {
        for (const hook of this._options.hooks.beforeRequest){
            // eslint-disable-next-line no-await-in-loop
            const result = await hook(this.request, this._options);
            if (result instanceof Request) {
                this.request = result;
                break;
            }
            if (result instanceof Response) return result;
        }
        const nonRequestOptions = (0, $9336c4545dcaac68$export$95d8775889ec941f)(this.request, this._options);
        // Cloning is done here to prepare in advance for retries
        const mainRequest = this.request;
        this.request = mainRequest.clone();
        if (this._options.timeout === false) return this._options.fetch(mainRequest, nonRequestOptions);
        return (0, $f071b3ea9e26abc5$export$2e2bcd8739ae039)(mainRequest, nonRequestOptions, this.abortController, this._options);
    }
}






const $1a4d2bbfb6ba7df3$var$createInstance = (defaults)=>{
    // eslint-disable-next-line @typescript-eslint/promise-function-async
    const ky = (input, options)=>(0, $423bd113d368b878$export$c482d6f00e170af3).create(input, (0, $1354e4c7c55c83be$export$8886f5ba30bd5e0)(defaults, options));
    for (const method of (0, $1ff2fea6a6c86f37$export$fb003dbd6df95edb))// eslint-disable-next-line @typescript-eslint/promise-function-async
    ky[method] = (input, options)=>(0, $423bd113d368b878$export$c482d6f00e170af3).create(input, (0, $1354e4c7c55c83be$export$8886f5ba30bd5e0)(defaults, options, {
            method: method
        }));
    ky.create = (newDefaults)=>$1a4d2bbfb6ba7df3$var$createInstance((0, $1354e4c7c55c83be$export$8886f5ba30bd5e0)(newDefaults));
    ky.extend = (newDefaults)=>{
        if (typeof newDefaults === 'function') newDefaults = newDefaults(defaults ?? {});
        return $1a4d2bbfb6ba7df3$var$createInstance((0, $1354e4c7c55c83be$export$8886f5ba30bd5e0)(defaults, newDefaults));
    };
    ky.stop = (0, $1ff2fea6a6c86f37$export$fa6813432f753b0d);
    return ky;
};
const $1a4d2bbfb6ba7df3$var$ky = $1a4d2bbfb6ba7df3$var$createInstance();
var $1a4d2bbfb6ba7df3$export$2e2bcd8739ae039 = $1a4d2bbfb6ba7df3$var$ky;


const $49da1b68da864759$export$d43f2f435f160490 = "https://backend-185847439612.europe-west1.run.app" ?? 'http://localhost:8080';
const $49da1b68da864759$export$644d8ea042df96a6 = (0, $1a4d2bbfb6ba7df3$export$2e2bcd8739ae039).create({
    prefixUrl: $49da1b68da864759$export$d43f2f435f160490,
    timeout: false,
    hooks: {
        beforeRequest: [
            (request)=>{
                const token = localStorage.getItem('access_token');
                if (token) request.headers.set('authorization', `Bearer ${token}`);
            }
        ]
    }
});


var $68f710c71c5708fe$exports = {};
'use strict';
var $6360c76d2133c2eb$exports = {};
'use strict';
var $e0759ee77c011426$exports = {};
'use strict';
const $e0759ee77c011426$var$HEX = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    a: 10,
    A: 10,
    b: 11,
    B: 11,
    c: 12,
    C: 12,
    d: 13,
    D: 13,
    e: 14,
    E: 14,
    f: 15,
    F: 15
};
$e0759ee77c011426$exports = {
    HEX: $e0759ee77c011426$var$HEX
};


var $6360c76d2133c2eb$require$HEX = $e0759ee77c011426$exports.HEX;
const $6360c76d2133c2eb$var$IPV4_REG = /^(?:(?:25[0-5]|2[0-4]\d|1\d{2}|[1-9]\d|\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d{2}|[1-9]\d|\d)$/u;
function $6360c76d2133c2eb$var$normalizeIPv4(host) {
    if ($6360c76d2133c2eb$var$findToken(host, '.') < 3) return {
        host: host,
        isIPV4: false
    };
    const matches = host.match($6360c76d2133c2eb$var$IPV4_REG) || [];
    const [address] = matches;
    if (address) return {
        host: $6360c76d2133c2eb$var$stripLeadingZeros(address, '.'),
        isIPV4: true
    };
    else return {
        host: host,
        isIPV4: false
    };
}
/**
 * @param {string[]} input
 * @param {boolean} [keepZero=false]
 * @returns {string|undefined}
 */ function $6360c76d2133c2eb$var$stringArrayToHexStripped(input, keepZero = false) {
    let acc = '';
    let strip = true;
    for (const c of input){
        if ($6360c76d2133c2eb$require$HEX[c] === undefined) return undefined;
        if (c !== '0' && strip === true) strip = false;
        if (!strip) acc += c;
    }
    if (keepZero && acc.length === 0) acc = '0';
    return acc;
}
function $6360c76d2133c2eb$var$getIPV6(input) {
    let tokenCount = 0;
    const output = {
        error: false,
        address: '',
        zone: ''
    };
    const address = [];
    const buffer = [];
    let isZone = false;
    let endipv6Encountered = false;
    let endIpv6 = false;
    function consume() {
        if (buffer.length) {
            if (isZone === false) {
                const hex = $6360c76d2133c2eb$var$stringArrayToHexStripped(buffer);
                if (hex !== undefined) address.push(hex);
                else {
                    output.error = true;
                    return false;
                }
            }
            buffer.length = 0;
        }
        return true;
    }
    for(let i = 0; i < input.length; i++){
        const cursor = input[i];
        if (cursor === '[' || cursor === ']') continue;
        if (cursor === ':') {
            if (endipv6Encountered === true) endIpv6 = true;
            if (!consume()) break;
            tokenCount++;
            address.push(':');
            if (tokenCount > 7) {
                // not valid
                output.error = true;
                break;
            }
            if (i - 1 >= 0 && input[i - 1] === ':') endipv6Encountered = true;
            continue;
        } else if (cursor === '%') {
            if (!consume()) break;
            // switch to zone detection
            isZone = true;
        } else {
            buffer.push(cursor);
            continue;
        }
    }
    if (buffer.length) {
        if (isZone) output.zone = buffer.join('');
        else if (endIpv6) address.push(buffer.join(''));
        else address.push($6360c76d2133c2eb$var$stringArrayToHexStripped(buffer));
    }
    output.address = address.join('');
    return output;
}
function $6360c76d2133c2eb$var$normalizeIPv6(host) {
    if ($6360c76d2133c2eb$var$findToken(host, ':') < 2) return {
        host: host,
        isIPV6: false
    };
    const ipv6 = $6360c76d2133c2eb$var$getIPV6(host);
    if (!ipv6.error) {
        let newHost = ipv6.address;
        let escapedHost = ipv6.address;
        if (ipv6.zone) {
            newHost += '%' + ipv6.zone;
            escapedHost += '%25' + ipv6.zone;
        }
        return {
            host: newHost,
            escapedHost: escapedHost,
            isIPV6: true
        };
    } else return {
        host: host,
        isIPV6: false
    };
}
function $6360c76d2133c2eb$var$stripLeadingZeros(str, token) {
    let out = '';
    let skip = true;
    const l = str.length;
    for(let i = 0; i < l; i++){
        const c = str[i];
        if (c === '0' && skip) {
            if (i + 1 <= l && str[i + 1] === token || i + 1 === l) {
                out += c;
                skip = false;
            }
        } else {
            if (c === token) skip = true;
            else skip = false;
            out += c;
        }
    }
    return out;
}
function $6360c76d2133c2eb$var$findToken(str, token) {
    let ind = 0;
    for(let i = 0; i < str.length; i++)if (str[i] === token) ind++;
    return ind;
}
const $6360c76d2133c2eb$var$RDS1 = /^\.\.?\//u;
const $6360c76d2133c2eb$var$RDS2 = /^\/\.(?:\/|$)/u;
const $6360c76d2133c2eb$var$RDS3 = /^\/\.\.(?:\/|$)/u;
const $6360c76d2133c2eb$var$RDS5 = /^\/?(?:.|\n)*?(?=\/|$)/u;
function $6360c76d2133c2eb$var$removeDotSegments(input) {
    const output = [];
    while(input.length){
        if (input.match($6360c76d2133c2eb$var$RDS1)) input = input.replace($6360c76d2133c2eb$var$RDS1, '');
        else if (input.match($6360c76d2133c2eb$var$RDS2)) input = input.replace($6360c76d2133c2eb$var$RDS2, '/');
        else if (input.match($6360c76d2133c2eb$var$RDS3)) {
            input = input.replace($6360c76d2133c2eb$var$RDS3, '/');
            output.pop();
        } else if (input === '.' || input === '..') input = '';
        else {
            const im = input.match($6360c76d2133c2eb$var$RDS5);
            if (im) {
                const s = im[0];
                input = input.slice(s.length);
                output.push(s);
            } else throw new Error('Unexpected dot segment condition');
        }
    }
    return output.join('');
}
function $6360c76d2133c2eb$var$normalizeComponentEncoding(components, esc) {
    const func = esc !== true ? escape : unescape;
    if (components.scheme !== undefined) components.scheme = func(components.scheme);
    if (components.userinfo !== undefined) components.userinfo = func(components.userinfo);
    if (components.host !== undefined) components.host = func(components.host);
    if (components.path !== undefined) components.path = func(components.path);
    if (components.query !== undefined) components.query = func(components.query);
    if (components.fragment !== undefined) components.fragment = func(components.fragment);
    return components;
}
function $6360c76d2133c2eb$var$recomposeAuthority(components) {
    const uriTokens = [];
    if (components.userinfo !== undefined) {
        uriTokens.push(components.userinfo);
        uriTokens.push('@');
    }
    if (components.host !== undefined) {
        let host = unescape(components.host);
        const ipV4res = $6360c76d2133c2eb$var$normalizeIPv4(host);
        if (ipV4res.isIPV4) host = ipV4res.host;
        else {
            const ipV6res = $6360c76d2133c2eb$var$normalizeIPv6(ipV4res.host);
            if (ipV6res.isIPV6 === true) host = `[${ipV6res.escapedHost}]`;
            else host = components.host;
        }
        uriTokens.push(host);
    }
    if (typeof components.port === 'number' || typeof components.port === 'string') {
        uriTokens.push(':');
        uriTokens.push(String(components.port));
    }
    return uriTokens.length ? uriTokens.join('') : undefined;
}
$6360c76d2133c2eb$exports = {
    recomposeAuthority: $6360c76d2133c2eb$var$recomposeAuthority,
    normalizeComponentEncoding: $6360c76d2133c2eb$var$normalizeComponentEncoding,
    removeDotSegments: $6360c76d2133c2eb$var$removeDotSegments,
    normalizeIPv4: $6360c76d2133c2eb$var$normalizeIPv4,
    normalizeIPv6: $6360c76d2133c2eb$var$normalizeIPv6,
    stringArrayToHexStripped: $6360c76d2133c2eb$var$stringArrayToHexStripped
};


var $68f710c71c5708fe$require$normalizeIPv6 = $6360c76d2133c2eb$exports.normalizeIPv6;
var $68f710c71c5708fe$require$normalizeIPv4 = $6360c76d2133c2eb$exports.normalizeIPv4;
var $68f710c71c5708fe$require$removeDotSegments = $6360c76d2133c2eb$exports.removeDotSegments;
var $68f710c71c5708fe$require$recomposeAuthority = $6360c76d2133c2eb$exports.recomposeAuthority;
var $68f710c71c5708fe$require$normalizeComponentEncoding = $6360c76d2133c2eb$exports.normalizeComponentEncoding;
var $2898dbcd08567ca8$exports = {};
'use strict';
const $2898dbcd08567ca8$var$UUID_REG = /^[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}$/iu;
const $2898dbcd08567ca8$var$URN_REG = /([\da-z][\d\-a-z]{0,31}):((?:[\w!$'()*+,\-.:;=@]|%[\da-f]{2})+)/iu;
function $2898dbcd08567ca8$var$isSecure(wsComponents) {
    return typeof wsComponents.secure === 'boolean' ? wsComponents.secure : String(wsComponents.scheme).toLowerCase() === 'wss';
}
function $2898dbcd08567ca8$var$httpParse(components) {
    if (!components.host) components.error = components.error || 'HTTP URIs must have a host.';
    return components;
}
function $2898dbcd08567ca8$var$httpSerialize(components) {
    const secure = String(components.scheme).toLowerCase() === 'https';
    // normalize the default port
    if (components.port === (secure ? 443 : 80) || components.port === '') components.port = undefined;
    // normalize the empty path
    if (!components.path) components.path = '/';
    // NOTE: We do not parse query strings for HTTP URIs
    // as WWW Form Url Encoded query strings are part of the HTML4+ spec,
    // and not the HTTP spec.
    return components;
}
function $2898dbcd08567ca8$var$wsParse(wsComponents) {
    // indicate if the secure flag is set
    wsComponents.secure = $2898dbcd08567ca8$var$isSecure(wsComponents);
    // construct resouce name
    wsComponents.resourceName = (wsComponents.path || '/') + (wsComponents.query ? '?' + wsComponents.query : '');
    wsComponents.path = undefined;
    wsComponents.query = undefined;
    return wsComponents;
}
function $2898dbcd08567ca8$var$wsSerialize(wsComponents) {
    // normalize the default port
    if (wsComponents.port === ($2898dbcd08567ca8$var$isSecure(wsComponents) ? 443 : 80) || wsComponents.port === '') wsComponents.port = undefined;
    // ensure scheme matches secure flag
    if (typeof wsComponents.secure === 'boolean') {
        wsComponents.scheme = wsComponents.secure ? 'wss' : 'ws';
        wsComponents.secure = undefined;
    }
    // reconstruct path from resource name
    if (wsComponents.resourceName) {
        const [path, query] = wsComponents.resourceName.split('?');
        wsComponents.path = path && path !== '/' ? path : undefined;
        wsComponents.query = query;
        wsComponents.resourceName = undefined;
    }
    // forbid fragment component
    wsComponents.fragment = undefined;
    return wsComponents;
}
function $2898dbcd08567ca8$var$urnParse(urnComponents, options) {
    if (!urnComponents.path) {
        urnComponents.error = 'URN can not be parsed';
        return urnComponents;
    }
    const matches = urnComponents.path.match($2898dbcd08567ca8$var$URN_REG);
    if (matches) {
        const scheme = options.scheme || urnComponents.scheme || 'urn';
        urnComponents.nid = matches[1].toLowerCase();
        urnComponents.nss = matches[2];
        const urnScheme = `${scheme}:${options.nid || urnComponents.nid}`;
        const schemeHandler = $2898dbcd08567ca8$var$SCHEMES[urnScheme];
        urnComponents.path = undefined;
        if (schemeHandler) urnComponents = schemeHandler.parse(urnComponents, options);
    } else urnComponents.error = urnComponents.error || 'URN can not be parsed.';
    return urnComponents;
}
function $2898dbcd08567ca8$var$urnSerialize(urnComponents, options) {
    const scheme = options.scheme || urnComponents.scheme || 'urn';
    const nid = urnComponents.nid.toLowerCase();
    const urnScheme = `${scheme}:${options.nid || nid}`;
    const schemeHandler = $2898dbcd08567ca8$var$SCHEMES[urnScheme];
    if (schemeHandler) urnComponents = schemeHandler.serialize(urnComponents, options);
    const uriComponents = urnComponents;
    const nss = urnComponents.nss;
    uriComponents.path = `${nid || options.nid}:${nss}`;
    options.skipEscape = true;
    return uriComponents;
}
function $2898dbcd08567ca8$var$urnuuidParse(urnComponents, options) {
    const uuidComponents = urnComponents;
    uuidComponents.uuid = uuidComponents.nss;
    uuidComponents.nss = undefined;
    if (!options.tolerant && (!uuidComponents.uuid || !$2898dbcd08567ca8$var$UUID_REG.test(uuidComponents.uuid))) uuidComponents.error = uuidComponents.error || 'UUID is not valid.';
    return uuidComponents;
}
function $2898dbcd08567ca8$var$urnuuidSerialize(uuidComponents) {
    const urnComponents = uuidComponents;
    // normalize UUID
    urnComponents.nss = (uuidComponents.uuid || '').toLowerCase();
    return urnComponents;
}
const $2898dbcd08567ca8$var$http = {
    scheme: 'http',
    domainHost: true,
    parse: $2898dbcd08567ca8$var$httpParse,
    serialize: $2898dbcd08567ca8$var$httpSerialize
};
const $2898dbcd08567ca8$var$https = {
    scheme: 'https',
    domainHost: $2898dbcd08567ca8$var$http.domainHost,
    parse: $2898dbcd08567ca8$var$httpParse,
    serialize: $2898dbcd08567ca8$var$httpSerialize
};
const $2898dbcd08567ca8$var$ws = {
    scheme: 'ws',
    domainHost: true,
    parse: $2898dbcd08567ca8$var$wsParse,
    serialize: $2898dbcd08567ca8$var$wsSerialize
};
const $2898dbcd08567ca8$var$wss = {
    scheme: 'wss',
    domainHost: $2898dbcd08567ca8$var$ws.domainHost,
    parse: $2898dbcd08567ca8$var$ws.parse,
    serialize: $2898dbcd08567ca8$var$ws.serialize
};
const $2898dbcd08567ca8$var$urn = {
    scheme: 'urn',
    parse: $2898dbcd08567ca8$var$urnParse,
    serialize: $2898dbcd08567ca8$var$urnSerialize,
    skipNormalize: true
};
const $2898dbcd08567ca8$var$urnuuid = {
    scheme: 'urn:uuid',
    parse: $2898dbcd08567ca8$var$urnuuidParse,
    serialize: $2898dbcd08567ca8$var$urnuuidSerialize,
    skipNormalize: true
};
const $2898dbcd08567ca8$var$SCHEMES = {
    http: $2898dbcd08567ca8$var$http,
    https: $2898dbcd08567ca8$var$https,
    ws: $2898dbcd08567ca8$var$ws,
    wss: $2898dbcd08567ca8$var$wss,
    urn: $2898dbcd08567ca8$var$urn,
    'urn:uuid': $2898dbcd08567ca8$var$urnuuid
};
$2898dbcd08567ca8$exports = $2898dbcd08567ca8$var$SCHEMES;


function $68f710c71c5708fe$var$normalize(uri, options) {
    if (typeof uri === 'string') uri = $68f710c71c5708fe$var$serialize($68f710c71c5708fe$var$parse(uri, options), options);
    else if (typeof uri === 'object') uri = $68f710c71c5708fe$var$parse($68f710c71c5708fe$var$serialize(uri, options), options);
    return uri;
}
function $68f710c71c5708fe$var$resolve(baseURI, relativeURI, options) {
    const schemelessOptions = Object.assign({
        scheme: 'null'
    }, options);
    const resolved = $68f710c71c5708fe$var$resolveComponents($68f710c71c5708fe$var$parse(baseURI, schemelessOptions), $68f710c71c5708fe$var$parse(relativeURI, schemelessOptions), schemelessOptions, true);
    return $68f710c71c5708fe$var$serialize(resolved, {
        ...schemelessOptions,
        skipEscape: true
    });
}
function $68f710c71c5708fe$var$resolveComponents(base, relative, options, skipNormalization) {
    const target = {};
    if (!skipNormalization) {
        base = $68f710c71c5708fe$var$parse($68f710c71c5708fe$var$serialize(base, options), options) // normalize base components
        ;
        relative = $68f710c71c5708fe$var$parse($68f710c71c5708fe$var$serialize(relative, options), options) // normalize relative components
        ;
    }
    options = options || {};
    if (!options.tolerant && relative.scheme) {
        target.scheme = relative.scheme;
        // target.authority = relative.authority;
        target.userinfo = relative.userinfo;
        target.host = relative.host;
        target.port = relative.port;
        target.path = $68f710c71c5708fe$require$removeDotSegments(relative.path || '');
        target.query = relative.query;
    } else {
        if (relative.userinfo !== undefined || relative.host !== undefined || relative.port !== undefined) {
            // target.authority = relative.authority;
            target.userinfo = relative.userinfo;
            target.host = relative.host;
            target.port = relative.port;
            target.path = $68f710c71c5708fe$require$removeDotSegments(relative.path || '');
            target.query = relative.query;
        } else {
            if (!relative.path) {
                target.path = base.path;
                if (relative.query !== undefined) target.query = relative.query;
                else target.query = base.query;
            } else {
                if (relative.path.charAt(0) === '/') target.path = $68f710c71c5708fe$require$removeDotSegments(relative.path);
                else {
                    if ((base.userinfo !== undefined || base.host !== undefined || base.port !== undefined) && !base.path) target.path = '/' + relative.path;
                    else if (!base.path) target.path = relative.path;
                    else target.path = base.path.slice(0, base.path.lastIndexOf('/') + 1) + relative.path;
                    target.path = $68f710c71c5708fe$require$removeDotSegments(target.path);
                }
                target.query = relative.query;
            }
            // target.authority = base.authority;
            target.userinfo = base.userinfo;
            target.host = base.host;
            target.port = base.port;
        }
        target.scheme = base.scheme;
    }
    target.fragment = relative.fragment;
    return target;
}
function $68f710c71c5708fe$var$equal(uriA, uriB, options) {
    if (typeof uriA === 'string') {
        uriA = unescape(uriA);
        uriA = $68f710c71c5708fe$var$serialize($68f710c71c5708fe$require$normalizeComponentEncoding($68f710c71c5708fe$var$parse(uriA, options), true), {
            ...options,
            skipEscape: true
        });
    } else if (typeof uriA === 'object') uriA = $68f710c71c5708fe$var$serialize($68f710c71c5708fe$require$normalizeComponentEncoding(uriA, true), {
        ...options,
        skipEscape: true
    });
    if (typeof uriB === 'string') {
        uriB = unescape(uriB);
        uriB = $68f710c71c5708fe$var$serialize($68f710c71c5708fe$require$normalizeComponentEncoding($68f710c71c5708fe$var$parse(uriB, options), true), {
            ...options,
            skipEscape: true
        });
    } else if (typeof uriB === 'object') uriB = $68f710c71c5708fe$var$serialize($68f710c71c5708fe$require$normalizeComponentEncoding(uriB, true), {
        ...options,
        skipEscape: true
    });
    return uriA.toLowerCase() === uriB.toLowerCase();
}
function $68f710c71c5708fe$var$serialize(cmpts, opts) {
    const components = {
        host: cmpts.host,
        scheme: cmpts.scheme,
        userinfo: cmpts.userinfo,
        port: cmpts.port,
        path: cmpts.path,
        query: cmpts.query,
        nid: cmpts.nid,
        nss: cmpts.nss,
        uuid: cmpts.uuid,
        fragment: cmpts.fragment,
        reference: cmpts.reference,
        resourceName: cmpts.resourceName,
        secure: cmpts.secure,
        error: ''
    };
    const options = Object.assign({}, opts);
    const uriTokens = [];
    // find scheme handler
    const schemeHandler = $2898dbcd08567ca8$exports[(options.scheme || components.scheme || '').toLowerCase()];
    // perform scheme specific serialization
    if (schemeHandler && schemeHandler.serialize) schemeHandler.serialize(components, options);
    if (components.path !== undefined) {
        if (!options.skipEscape) {
            components.path = escape(components.path);
            if (components.scheme !== undefined) components.path = components.path.split('%3A').join(':');
        } else components.path = unescape(components.path);
    }
    if (options.reference !== 'suffix' && components.scheme) uriTokens.push(components.scheme, ':');
    const authority = $68f710c71c5708fe$require$recomposeAuthority(components);
    if (authority !== undefined) {
        if (options.reference !== 'suffix') uriTokens.push('//');
        uriTokens.push(authority);
        if (components.path && components.path.charAt(0) !== '/') uriTokens.push('/');
    }
    if (components.path !== undefined) {
        let s = components.path;
        if (!options.absolutePath && (!schemeHandler || !schemeHandler.absolutePath)) s = $68f710c71c5708fe$require$removeDotSegments(s);
        if (authority === undefined) s = s.replace(/^\/\//u, '/%2F') // don't allow the path to start with "//"
        ;
        uriTokens.push(s);
    }
    if (components.query !== undefined) uriTokens.push('?', components.query);
    if (components.fragment !== undefined) uriTokens.push('#', components.fragment);
    return uriTokens.join('');
}
const $68f710c71c5708fe$var$hexLookUp = Array.from({
    length: 127
}, (_v, k)=>/[^!"$&'()*+,\-.;=_`a-z{}~]/u.test(String.fromCharCode(k)));
function $68f710c71c5708fe$var$nonSimpleDomain(value) {
    let code = 0;
    for(let i = 0, len = value.length; i < len; ++i){
        code = value.charCodeAt(i);
        if (code > 126 || $68f710c71c5708fe$var$hexLookUp[code]) return true;
    }
    return false;
}
const $68f710c71c5708fe$var$URI_PARSE = /^(?:([^#/:?]+):)?(?:\/\/((?:([^#/?@]*)@)?(\[[^#/?\]]+\]|[^#/:?]*)(?::(\d*))?))?([^#?]*)(?:\?([^#]*))?(?:#((?:.|[\n\r])*))?/u;
function $68f710c71c5708fe$var$parse(uri, opts) {
    const options = Object.assign({}, opts);
    const parsed = {
        scheme: undefined,
        userinfo: undefined,
        host: '',
        port: undefined,
        path: '',
        query: undefined,
        fragment: undefined
    };
    const gotEncoding = uri.indexOf('%') !== -1;
    let isIP = false;
    if (options.reference === 'suffix') uri = (options.scheme ? options.scheme + ':' : '') + '//' + uri;
    const matches = uri.match($68f710c71c5708fe$var$URI_PARSE);
    if (matches) {
        // store each component
        parsed.scheme = matches[1];
        parsed.userinfo = matches[3];
        parsed.host = matches[4];
        parsed.port = parseInt(matches[5], 10);
        parsed.path = matches[6] || '';
        parsed.query = matches[7];
        parsed.fragment = matches[8];
        // fix port number
        if (isNaN(parsed.port)) parsed.port = matches[5];
        if (parsed.host) {
            const ipv4result = $68f710c71c5708fe$require$normalizeIPv4(parsed.host);
            if (ipv4result.isIPV4 === false) {
                const ipv6result = $68f710c71c5708fe$require$normalizeIPv6(ipv4result.host);
                parsed.host = ipv6result.host.toLowerCase();
                isIP = ipv6result.isIPV6;
            } else {
                parsed.host = ipv4result.host;
                isIP = true;
            }
        }
        if (parsed.scheme === undefined && parsed.userinfo === undefined && parsed.host === undefined && parsed.port === undefined && parsed.query === undefined && !parsed.path) parsed.reference = 'same-document';
        else if (parsed.scheme === undefined) parsed.reference = 'relative';
        else if (parsed.fragment === undefined) parsed.reference = 'absolute';
        else parsed.reference = 'uri';
        // check for reference errors
        if (options.reference && options.reference !== 'suffix' && options.reference !== parsed.reference) parsed.error = parsed.error || 'URI is not a ' + options.reference + ' reference.';
        // find scheme handler
        const schemeHandler = $2898dbcd08567ca8$exports[(options.scheme || parsed.scheme || '').toLowerCase()];
        // check if scheme can't handle IRIs
        if (!options.unicodeSupport && (!schemeHandler || !schemeHandler.unicodeSupport)) {
            // if host component is a domain name
            if (parsed.host && (options.domainHost || schemeHandler && schemeHandler.domainHost) && isIP === false && $68f710c71c5708fe$var$nonSimpleDomain(parsed.host)) // convert Unicode IDN -> ASCII IDN
            try {
                parsed.host = URL.domainToASCII(parsed.host.toLowerCase());
            } catch (e) {
                parsed.error = parsed.error || "Host's domain name can not be converted to ASCII: " + e;
            }
        // convert IRI -> URI
        }
        if (!schemeHandler || schemeHandler && !schemeHandler.skipNormalize) {
            if (gotEncoding && parsed.scheme !== undefined) parsed.scheme = unescape(parsed.scheme);
            if (gotEncoding && parsed.host !== undefined) parsed.host = unescape(parsed.host);
            if (parsed.path) parsed.path = escape(unescape(parsed.path));
            if (parsed.fragment) parsed.fragment = encodeURI(decodeURIComponent(parsed.fragment));
        }
        // perform scheme specific parsing
        if (schemeHandler && schemeHandler.parse) schemeHandler.parse(parsed, options);
    } else parsed.error = parsed.error || 'URI can not be parsed.';
    return parsed;
}
const $68f710c71c5708fe$var$fastUri = {
    SCHEMES: $2898dbcd08567ca8$exports,
    normalize: $68f710c71c5708fe$var$normalize,
    resolve: $68f710c71c5708fe$var$resolve,
    resolveComponents: $68f710c71c5708fe$var$resolveComponents,
    equal: $68f710c71c5708fe$var$equal,
    serialize: $68f710c71c5708fe$var$serialize,
    parse: $68f710c71c5708fe$var$parse
};
$68f710c71c5708fe$exports = $68f710c71c5708fe$var$fastUri;
$68f710c71c5708fe$exports.default = $68f710c71c5708fe$var$fastUri;
$68f710c71c5708fe$exports.fastUri = $68f710c71c5708fe$var$fastUri;



class $eeb6398b2a94869c$export$88ad8fe362b4552e {
    constructor({ scheme: scheme, userinfo: userinfo, host: host, port: port, path: path, query: query, fragment: fragment }){
        this.scheme = scheme;
        this.userinfo = userinfo;
        this.host = host;
        this.port = port;
        this.path = path;
        this.query = query;
        this.fragment = fragment;
    }
    static parse(uri) {
        const uriobject = (0, (/*@__PURE__*/$parcel$interopDefault($68f710c71c5708fe$exports))).parse(uri);
        if (!uriobject.scheme || typeof uriobject.port === 'string') throw new Error('not an URI');
        return new $eeb6398b2a94869c$export$88ad8fe362b4552e({
            scheme: uriobject.scheme,
            userinfo: uriobject.userinfo,
            host: uriobject.host,
            port: uriobject.port,
            path: uriobject.path || '',
            query: uriobject.query,
            fragment: uriobject.fragment
        });
    }
    toString() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($68f710c71c5708fe$exports))).serialize(this);
    }
    get username() {
        if (!this.userinfo) return;
        const colonPos = this.userinfo.indexOf(':');
        return decodeURIComponent(this.userinfo.substring(0, colonPos !== -1 ? colonPos : undefined));
    }
    get password() {
        if (!this.userinfo) return;
        const colonPos = this.userinfo.indexOf(':');
        return colonPos !== -1 ? decodeURIComponent(this.userinfo.substring(colonPos + 1)) : undefined;
    }
    get bearerToken() {
        return this.queryParams.get('access_token') ?? undefined;
    }
    get queryParams() {
        return new URLSearchParams(this.query);
    }
    get fragmentParams() {
        return new URLSearchParams(this.fragment);
    }
    get api() {
        if (!(this.scheme === 'https' || this.scheme.endsWith('+https'))) throw new Error('Invalid URI for URIObject.api() call.');
        let http_auth;
        if (this.username && this.password) http_auth = `Basic ${btoa(`${this.username}:${this.password}`)}`;
        else if (this.bearerToken) http_auth = `Bearer ${this.bearerToken}`;
        return (0, $1a4d2bbfb6ba7df3$export$2e2bcd8739ae039).extend({
            timeout: 60000,
            prefixUrl: `https://${this.host}${this.path}`,
            headers: {
                authorization: http_auth
            }
        });
    }
}


var $20de62b8c698bf4b$exports = {};
(function(e, t) {
    $20de62b8c698bf4b$exports = t();
})($20de62b8c698bf4b$exports, function() {
    "use strict";
    var e = Math.imul, t = Math.clz32;
    function i(e) {
        "@babel/helpers - typeof";
        return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e;
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, i(e);
    }
    function _(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function n(e, t) {
        for(var _, n = 0; n < t.length; n++)_ = t[n], _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(e, _.key, _);
    }
    function l(e, t, i) {
        return t && n(e.prototype, t), i && n(e, i), Object.defineProperty(e, "prototype", {
            writable: !1
        }), e;
    }
    function g(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
            constructor: {
                value: e,
                writable: !0,
                configurable: !0
            }
        }), Object.defineProperty(e, "prototype", {
            writable: !1
        }), t && u(e, t);
    }
    function a(e) {
        return a = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e);
        }, a(e);
    }
    function u(e, t) {
        return u = Object.setPrototypeOf || function(e, t) {
            return e.__proto__ = t, e;
        }, u(e, t);
    }
    function s() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
        } catch (t) {
            return !1;
        }
    }
    function r() {
        return r = s() ? Reflect.construct : function(e, t, i) {
            var _ = [
                null
            ];
            _.push.apply(_, t);
            var n = Function.bind.apply(e, _), l = new n;
            return i && u(l, i.prototype), l;
        }, r.apply(null, arguments);
    }
    function d(e) {
        return -1 !== Function.toString.call(e).indexOf("[native code]");
    }
    function h(e) {
        var t = "function" == typeof Map ? new Map : void 0;
        return h = function(e) {
            function i() {
                return r(e, arguments, a(this).constructor);
            }
            if (null === e || !d(e)) return e;
            if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
            if ("undefined" != typeof t) {
                if (t.has(e)) return t.get(e);
                t.set(e, i);
            }
            return i.prototype = Object.create(e.prototype, {
                constructor: {
                    value: i,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                }
            }), u(i, e);
        }, h(e);
    }
    function b(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
    }
    function m(e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return b(e);
    }
    function c(e) {
        var t = s();
        return function() {
            var i, _ = a(e);
            if (t) {
                var n = a(this).constructor;
                i = Reflect.construct(_, arguments, n);
            } else i = _.apply(this, arguments);
            return m(this, i);
        };
    }
    function v(e, t) {
        return y(e) || f(e, t) || D(e, t) || k();
    }
    function y(e) {
        if (Array.isArray(e)) return e;
    }
    function f(e, t) {
        var i = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null != i) {
            var _, n, l = [], g = !0, o = !1;
            try {
                for(i = i.call(e); !(g = (_ = i.next()).done) && (l.push(_.value), !(t && l.length === t)); g = !0);
            } catch (e) {
                o = !0, n = e;
            } finally{
                try {
                    g || null == i["return"] || i["return"]();
                } finally{
                    if (o) throw n;
                }
            }
            return l;
        }
    }
    function D(e, t) {
        if (e) {
            if ("string" == typeof e) return p(e, t);
            var i = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === i && e.constructor && (i = e.constructor.name), "Map" === i || "Set" === i ? Array.from(e) : "Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? p(e, t) : void 0;
        }
    }
    function p(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for(var _ = 0, n = Array(t); _ < t; _++)n[_] = e[_];
        return n;
    }
    function k() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function B(e, t) {
        var _ = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (!_) {
            if (Array.isArray(e) || (_ = D(e)) || t && e && "number" == typeof e.length) {
                _ && (e = _);
                var n = 0, l = function() {};
                return {
                    s: l,
                    n: function() {
                        return n >= e.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: e[n++]
                        };
                    },
                    e: function(t) {
                        throw t;
                    },
                    f: l
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var g, a = !0, u = !1;
        return {
            s: function() {
                _ = _.call(e);
            },
            n: function() {
                var e = _.next();
                return a = e.done, e;
            },
            e: function(t) {
                u = !0, g = t;
            },
            f: function() {
                try {
                    a || null == _.return || _.return();
                } finally{
                    if (u) throw g;
                }
            }
        };
    }
    var S = function(e) {
        var t = Math.abs, n = Math.max, o = Math.floor;
        function a(e, t) {
            var i;
            if (_(this, a), i = u.call(this, e), i.sign = t, Object.setPrototypeOf(b(i), a.prototype), e > a.__kMaxLength) throw new RangeError("Maximum BigInt size exceeded");
            return i;
        }
        g(a, e);
        var u = c(a);
        return l(a, [
            {
                key: "toDebugString",
                value: function() {
                    var e, t = [
                        "BigInt["
                    ], i = B(this);
                    try {
                        for(i.s(); !(e = i.n()).done;){
                            var _ = e.value;
                            t.push((_ ? (_ >>> 0).toString(16) : _) + ", ");
                        }
                    } catch (e) {
                        i.e(e);
                    } finally{
                        i.f();
                    }
                    return t.push("]"), t.join("");
                }
            },
            {
                key: "toString",
                value: function() {
                    var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 10;
                    if (2 > e || 36 < e) throw new RangeError("toString() radix argument must be between 2 and 36");
                    return 0 === this.length ? "0" : 0 == (e & e - 1) ? a.__toStringBasePowerOfTwo(this, e) : a.__toStringGeneric(this, e, !1);
                }
            },
            {
                key: "valueOf",
                value: function() {
                    throw new Error("Convert JSBI instances to native numbers using `toNumber`.");
                }
            },
            {
                key: "__copy",
                value: function() {
                    for(var e = new a(this.length, this.sign), t = 0; t < this.length; t++)e[t] = this[t];
                    return e;
                }
            },
            {
                key: "__trim",
                value: function() {
                    for(var e = this.length, t = this[e - 1]; 0 === t;)e--, t = this[e - 1], this.pop();
                    return 0 === e && (this.sign = !1), this;
                }
            },
            {
                key: "__initializeDigits",
                value: function() {
                    for(var e = 0; e < this.length; e++)this[e] = 0;
                }
            },
            {
                key: "__clzmsd",
                value: function() {
                    return a.__clz30(this.__digit(this.length - 1));
                }
            },
            {
                key: "__inplaceMultiplyAdd",
                value: function(e, t, _) {
                    _ > this.length && (_ = this.length);
                    for(var n = 32767 & e, l = e >>> 15, g = 0, o = t, u = 0; u < _; u++){
                        var s = this.__digit(u), r = 32767 & s, d = s >>> 15, h = a.__imul(r, n), b = a.__imul(r, l), m = a.__imul(d, n), c = a.__imul(d, l), v = o + h + g;
                        g = v >>> 30, v &= 1073741823, v += ((32767 & b) << 15) + ((32767 & m) << 15), g += v >>> 30, o = c + (b >>> 15) + (m >>> 15), this.__setDigit(u, 1073741823 & v);
                    }
                    if (0 !== g || 0 !== o) throw new Error("implementation bug");
                }
            },
            {
                key: "__inplaceAdd",
                value: function(e, t, _) {
                    for(var n, l = 0, g = 0; g < _; g++)n = this.__halfDigit(t + g) + e.__halfDigit(g) + l, l = n >>> 15, this.__setHalfDigit(t + g, 32767 & n);
                    return l;
                }
            },
            {
                key: "__inplaceSub",
                value: function(e, t, _) {
                    var n = 0;
                    if (1 & t) {
                        t >>= 1;
                        for(var l = this.__digit(t), g = 32767 & l, o = 0; o < _ - 1 >>> 1; o++){
                            var a = e.__digit(o), u = (l >>> 15) - (32767 & a) - n;
                            n = 1 & u >>> 15, this.__setDigit(t + o, (32767 & u) << 15 | 32767 & g), l = this.__digit(t + o + 1), g = (32767 & l) - (a >>> 15) - n, n = 1 & g >>> 15;
                        }
                        var s = e.__digit(o), r = (l >>> 15) - (32767 & s) - n;
                        n = 1 & r >>> 15, this.__setDigit(t + o, (32767 & r) << 15 | 32767 & g);
                        if (t + o + 1 >= this.length) throw new RangeError("out of bounds");
                        0 == (1 & _) && (l = this.__digit(t + o + 1), g = (32767 & l) - (s >>> 15) - n, n = 1 & g >>> 15, this.__setDigit(t + e.length, 1073709056 & l | 32767 & g));
                    } else {
                        t >>= 1;
                        for(var d = 0; d < e.length - 1; d++){
                            var h = this.__digit(t + d), b = e.__digit(d), m = (32767 & h) - (32767 & b) - n;
                            n = 1 & m >>> 15;
                            var c = (h >>> 15) - (b >>> 15) - n;
                            n = 1 & c >>> 15, this.__setDigit(t + d, (32767 & c) << 15 | 32767 & m);
                        }
                        var v = this.__digit(t + d), y = e.__digit(d), f = (32767 & v) - (32767 & y) - n;
                        n = 1 & f >>> 15;
                        var D = 0;
                        0 == (1 & _) && (D = (v >>> 15) - (y >>> 15) - n, n = 1 & D >>> 15), this.__setDigit(t + d, (32767 & D) << 15 | 32767 & f);
                    }
                    return n;
                }
            },
            {
                key: "__inplaceRightShift",
                value: function(e) {
                    if (0 !== e) {
                        for(var t, _ = this.__digit(0) >>> e, n = this.length - 1, l = 0; l < n; l++)t = this.__digit(l + 1), this.__setDigit(l, 1073741823 & t << 30 - e | _), _ = t >>> e;
                        this.__setDigit(n, _);
                    }
                }
            },
            {
                key: "__digit",
                value: function(e) {
                    return this[e];
                }
            },
            {
                key: "__unsignedDigit",
                value: function(e) {
                    return this[e] >>> 0;
                }
            },
            {
                key: "__setDigit",
                value: function(e, t) {
                    this[e] = 0 | t;
                }
            },
            {
                key: "__setDigitGrow",
                value: function(e, t) {
                    this[e] = 0 | t;
                }
            },
            {
                key: "__halfDigitLength",
                value: function() {
                    var e = this.length;
                    return 32767 >= this.__unsignedDigit(e - 1) ? 2 * e - 1 : 2 * e;
                }
            },
            {
                key: "__halfDigit",
                value: function(e) {
                    return 32767 & this[e >>> 1] >>> 15 * (1 & e);
                }
            },
            {
                key: "__setHalfDigit",
                value: function(e, t) {
                    var i = e >>> 1, _ = this.__digit(i), n = 1 & e ? 32767 & _ | t << 15 : 1073709056 & _ | 32767 & t;
                    this.__setDigit(i, n);
                }
            }
        ], [
            {
                key: "BigInt",
                value: function(e) {
                    var t = Number.isFinite;
                    if ("number" == typeof e) {
                        if (0 === e) return a.__zero();
                        if (a.__isOneDigitInt(e)) return 0 > e ? a.__oneDigit(-e, !0) : a.__oneDigit(e, !1);
                        if (!t(e) || o(e) !== e) throw new RangeError("The number " + e + " cannot be converted to BigInt because it is not an integer");
                        return a.__fromDouble(e);
                    }
                    if ("string" == typeof e) {
                        var _ = a.__fromString(e);
                        if (null === _) throw new SyntaxError("Cannot convert " + e + " to a BigInt");
                        return _;
                    }
                    if ("boolean" == typeof e) return !0 === e ? a.__oneDigit(1, !1) : a.__zero();
                    if ("object" === i(e)) {
                        if (e.constructor === a) return e;
                        var n = a.__toPrimitive(e);
                        return a.BigInt(n);
                    }
                    throw new TypeError("Cannot convert " + e + " to a BigInt");
                }
            },
            {
                key: "toNumber",
                value: function(e) {
                    var t = e.length;
                    if (0 === t) return 0;
                    if (1 === t) {
                        var i = e.__unsignedDigit(0);
                        return e.sign ? -i : i;
                    }
                    var _ = e.__digit(t - 1), n = a.__clz30(_), l = 30 * t - n;
                    if (1024 < l) return e.sign ? -Infinity : 1 / 0;
                    var g = l - 1, o = _, u = t - 1, s = n + 3, r = 32 === s ? 0 : o << s;
                    r >>>= 12;
                    var d = s - 12, h = 12 <= s ? 0 : o << 20 + s, b = 20 + s;
                    for(0 < d && 0 < u && (u--, o = e.__digit(u), r |= o >>> 30 - d, h = o << d + 2, b = d + 2); 0 < b && 0 < u;)u--, o = e.__digit(u), h |= 30 <= b ? o << b - 30 : o >>> 30 - b, b -= 30;
                    var m = a.__decideRounding(e, b, u, o);
                    if ((1 === m || 0 === m && 1 == (1 & h)) && (h = h + 1 >>> 0, 0 === h && (r++, 0 != r >>> 20 && (r = 0, g++, 1023 < g)))) return e.sign ? -Infinity : 1 / 0;
                    var c = e.sign ? -2147483648 : 0;
                    return g = g + 1023 << 20, a.__kBitConversionInts[1] = c | g | r, a.__kBitConversionInts[0] = h, a.__kBitConversionDouble[0];
                }
            },
            {
                key: "unaryMinus",
                value: function(e) {
                    if (0 === e.length) return e;
                    var t = e.__copy();
                    return t.sign = !e.sign, t;
                }
            },
            {
                key: "bitwiseNot",
                value: function(e) {
                    return e.sign ? a.__absoluteSubOne(e).__trim() : a.__absoluteAddOne(e, !0);
                }
            },
            {
                key: "exponentiate",
                value: function(e, t) {
                    if (t.sign) throw new RangeError("Exponent must be positive");
                    if (0 === t.length) return a.__oneDigit(1, !1);
                    if (0 === e.length) return e;
                    if (1 === e.length && 1 === e.__digit(0)) return e.sign && 0 == (1 & t.__digit(0)) ? a.unaryMinus(e) : e;
                    if (1 < t.length) throw new RangeError("BigInt too big");
                    var i = t.__unsignedDigit(0);
                    if (1 === i) return e;
                    if (i >= a.__kMaxLengthBits) throw new RangeError("BigInt too big");
                    if (1 === e.length && 2 === e.__digit(0)) {
                        var _ = 1 + (0 | i / 30), n = e.sign && 0 != (1 & i), l = new a(_, n);
                        l.__initializeDigits();
                        var g = 1 << i % 30;
                        return l.__setDigit(_ - 1, g), l;
                    }
                    var o = null, u = e;
                    for(0 != (1 & i) && (o = e), i >>= 1; 0 !== i; i >>= 1)u = a.multiply(u, u), 0 != (1 & i) && (null === o ? o = u : o = a.multiply(o, u));
                    return o;
                }
            },
            {
                key: "multiply",
                value: function(e, t) {
                    if (0 === e.length) return e;
                    if (0 === t.length) return t;
                    var _ = e.length + t.length;
                    30 <= e.__clzmsd() + t.__clzmsd() && _--;
                    var n = new a(_, e.sign !== t.sign);
                    n.__initializeDigits();
                    for(var l = 0; l < e.length; l++)a.__multiplyAccumulate(t, e.__digit(l), n, l);
                    return n.__trim();
                }
            },
            {
                key: "divide",
                value: function(e, t) {
                    if (0 === t.length) throw new RangeError("Division by zero");
                    if (0 > a.__absoluteCompare(e, t)) return a.__zero();
                    var i, _ = e.sign !== t.sign, n = t.__unsignedDigit(0);
                    if (1 === t.length && 32767 >= n) {
                        if (1 === n) return _ === e.sign ? e : a.unaryMinus(e);
                        i = a.__absoluteDivSmall(e, n, null);
                    } else i = a.__absoluteDivLarge(e, t, !0, !1);
                    return i.sign = _, i.__trim();
                }
            },
            {
                key: "remainder",
                value: function i(e, t) {
                    if (0 === t.length) throw new RangeError("Division by zero");
                    if (0 > a.__absoluteCompare(e, t)) return e;
                    var _ = t.__unsignedDigit(0);
                    if (1 === t.length && 32767 >= _) {
                        if (1 === _) return a.__zero();
                        var n = a.__absoluteModSmall(e, _);
                        return 0 === n ? a.__zero() : a.__oneDigit(n, e.sign);
                    }
                    var i = a.__absoluteDivLarge(e, t, !1, !0);
                    return i.sign = e.sign, i.__trim();
                }
            },
            {
                key: "add",
                value: function(e, t) {
                    var i = e.sign;
                    return i === t.sign ? a.__absoluteAdd(e, t, i) : 0 <= a.__absoluteCompare(e, t) ? a.__absoluteSub(e, t, i) : a.__absoluteSub(t, e, !i);
                }
            },
            {
                key: "subtract",
                value: function(e, t) {
                    var i = e.sign;
                    return i === t.sign ? 0 <= a.__absoluteCompare(e, t) ? a.__absoluteSub(e, t, i) : a.__absoluteSub(t, e, !i) : a.__absoluteAdd(e, t, i);
                }
            },
            {
                key: "leftShift",
                value: function(e, t) {
                    return 0 === t.length || 0 === e.length ? e : t.sign ? a.__rightShiftByAbsolute(e, t) : a.__leftShiftByAbsolute(e, t);
                }
            },
            {
                key: "signedRightShift",
                value: function(e, t) {
                    return 0 === t.length || 0 === e.length ? e : t.sign ? a.__leftShiftByAbsolute(e, t) : a.__rightShiftByAbsolute(e, t);
                }
            },
            {
                key: "unsignedRightShift",
                value: function() {
                    throw new TypeError("BigInts have no unsigned right shift; use >> instead");
                }
            },
            {
                key: "lessThan",
                value: function(e, t) {
                    return 0 > a.__compareToBigInt(e, t);
                }
            },
            {
                key: "lessThanOrEqual",
                value: function(e, t) {
                    return 0 >= a.__compareToBigInt(e, t);
                }
            },
            {
                key: "greaterThan",
                value: function(e, t) {
                    return 0 < a.__compareToBigInt(e, t);
                }
            },
            {
                key: "greaterThanOrEqual",
                value: function(e, t) {
                    return 0 <= a.__compareToBigInt(e, t);
                }
            },
            {
                key: "equal",
                value: function(e, t) {
                    if (e.sign !== t.sign) return !1;
                    if (e.length !== t.length) return !1;
                    for(var _ = 0; _ < e.length; _++)if (e.__digit(_) !== t.__digit(_)) return !1;
                    return !0;
                }
            },
            {
                key: "notEqual",
                value: function(e, t) {
                    return !a.equal(e, t);
                }
            },
            {
                key: "bitwiseAnd",
                value: function(e, t) {
                    if (!e.sign && !t.sign) return a.__absoluteAnd(e, t).__trim();
                    if (e.sign && t.sign) {
                        var i = n(e.length, t.length) + 1, _ = a.__absoluteSubOne(e, i), l = a.__absoluteSubOne(t);
                        return _ = a.__absoluteOr(_, l, _), a.__absoluteAddOne(_, !0, _).__trim();
                    }
                    if (e.sign) {
                        var g = [
                            t,
                            e
                        ];
                        e = g[0], t = g[1];
                    }
                    return a.__absoluteAndNot(e, a.__absoluteSubOne(t)).__trim();
                }
            },
            {
                key: "bitwiseXor",
                value: function(e, t) {
                    if (!e.sign && !t.sign) return a.__absoluteXor(e, t).__trim();
                    if (e.sign && t.sign) {
                        var i = n(e.length, t.length), _ = a.__absoluteSubOne(e, i), l = a.__absoluteSubOne(t);
                        return a.__absoluteXor(_, l, _).__trim();
                    }
                    var g = n(e.length, t.length) + 1;
                    if (e.sign) {
                        var o = [
                            t,
                            e
                        ];
                        e = o[0], t = o[1];
                    }
                    var u = a.__absoluteSubOne(t, g);
                    return u = a.__absoluteXor(u, e, u), a.__absoluteAddOne(u, !0, u).__trim();
                }
            },
            {
                key: "bitwiseOr",
                value: function(e, t) {
                    var i = n(e.length, t.length);
                    if (!e.sign && !t.sign) return a.__absoluteOr(e, t).__trim();
                    if (e.sign && t.sign) {
                        var _ = a.__absoluteSubOne(e, i), l = a.__absoluteSubOne(t);
                        return _ = a.__absoluteAnd(_, l, _), a.__absoluteAddOne(_, !0, _).__trim();
                    }
                    if (e.sign) {
                        var g = [
                            t,
                            e
                        ];
                        e = g[0], t = g[1];
                    }
                    var o = a.__absoluteSubOne(t, i);
                    return o = a.__absoluteAndNot(o, e, o), a.__absoluteAddOne(o, !0, o).__trim();
                }
            },
            {
                key: "asIntN",
                value: function(e, t) {
                    if (0 === t.length) return t;
                    if (e = o(e), 0 > e) throw new RangeError("Invalid value: not (convertible to) a safe integer");
                    if (0 === e) return a.__zero();
                    if (e >= a.__kMaxLengthBits) return t;
                    var _ = 0 | (e + 29) / 30;
                    if (t.length < _) return t;
                    var l = t.__unsignedDigit(_ - 1), g = 1 << (e - 1) % 30;
                    if (t.length === _ && l < g) return t;
                    if (!((l & g) === g)) return a.__truncateToNBits(e, t);
                    if (!t.sign) return a.__truncateAndSubFromPowerOfTwo(e, t, !0);
                    if (0 == (l & g - 1)) {
                        for(var u = _ - 2; 0 <= u; u--)if (0 !== t.__digit(u)) return a.__truncateAndSubFromPowerOfTwo(e, t, !1);
                        return t.length === _ && l === g ? t : a.__truncateToNBits(e, t);
                    }
                    return a.__truncateAndSubFromPowerOfTwo(e, t, !1);
                }
            },
            {
                key: "asUintN",
                value: function(e, t) {
                    if (0 === t.length) return t;
                    if (e = o(e), 0 > e) throw new RangeError("Invalid value: not (convertible to) a safe integer");
                    if (0 === e) return a.__zero();
                    if (t.sign) {
                        if (e > a.__kMaxLengthBits) throw new RangeError("BigInt too big");
                        return a.__truncateAndSubFromPowerOfTwo(e, t, !1);
                    }
                    if (e >= a.__kMaxLengthBits) return t;
                    var i = 0 | (e + 29) / 30;
                    if (t.length < i) return t;
                    var _ = e % 30;
                    if (t.length == i) {
                        if (0 === _) return t;
                        var l = t.__digit(i - 1);
                        if (0 == l >>> _) return t;
                    }
                    return a.__truncateToNBits(e, t);
                }
            },
            {
                key: "ADD",
                value: function(e, t) {
                    if (e = a.__toPrimitive(e), t = a.__toPrimitive(t), "string" == typeof e) return "string" != typeof t && (t = t.toString()), e + t;
                    if ("string" == typeof t) return e.toString() + t;
                    if (e = a.__toNumeric(e), t = a.__toNumeric(t), a.__isBigInt(e) && a.__isBigInt(t)) return a.add(e, t);
                    if ("number" == typeof e && "number" == typeof t) return e + t;
                    throw new TypeError("Cannot mix BigInt and other types, use explicit conversions");
                }
            },
            {
                key: "LT",
                value: function(e, t) {
                    return a.__compare(e, t, 0);
                }
            },
            {
                key: "LE",
                value: function(e, t) {
                    return a.__compare(e, t, 1);
                }
            },
            {
                key: "GT",
                value: function(e, t) {
                    return a.__compare(e, t, 2);
                }
            },
            {
                key: "GE",
                value: function(e, t) {
                    return a.__compare(e, t, 3);
                }
            },
            {
                key: "EQ",
                value: function(e, t) {
                    for(;;){
                        if (a.__isBigInt(e)) return a.__isBigInt(t) ? a.equal(e, t) : a.EQ(t, e);
                        if ("number" == typeof e) {
                            if (a.__isBigInt(t)) return a.__equalToNumber(t, e);
                            if ("object" !== i(t)) return e == t;
                            t = a.__toPrimitive(t);
                        } else if ("string" == typeof e) {
                            if (a.__isBigInt(t)) return e = a.__fromString(e), null !== e && a.equal(e, t);
                            if ("object" !== i(t)) return e == t;
                            t = a.__toPrimitive(t);
                        } else if ("boolean" == typeof e) {
                            if (a.__isBigInt(t)) return a.__equalToNumber(t, +e);
                            if ("object" !== i(t)) return e == t;
                            t = a.__toPrimitive(t);
                        } else if ("symbol" === i(e)) {
                            if (a.__isBigInt(t)) return !1;
                            if ("object" !== i(t)) return e == t;
                            t = a.__toPrimitive(t);
                        } else if ("object" === i(e)) {
                            if ("object" === i(t) && t.constructor !== a) return e == t;
                            e = a.__toPrimitive(e);
                        } else return e == t;
                    }
                }
            },
            {
                key: "NE",
                value: function(e, t) {
                    return !a.EQ(e, t);
                }
            },
            {
                key: "DataViewGetBigInt64",
                value: function(e, t) {
                    var i = !!(2 < arguments.length && void 0 !== arguments[2]) && arguments[2];
                    return a.asIntN(64, a.DataViewGetBigUint64(e, t, i));
                }
            },
            {
                key: "DataViewGetBigUint64",
                value: function(e, t) {
                    var i = !!(2 < arguments.length && void 0 !== arguments[2]) && arguments[2], _ = i ? [
                        4,
                        0
                    ] : [
                        0,
                        4
                    ], n = v(_, 2), g = n[0], o = n[1], l = e.getUint32(t + g, i), u = e.getUint32(t + o, i), s = new a(3, !1);
                    return s.__setDigit(0, 1073741823 & u), s.__setDigit(1, (268435455 & l) << 2 | u >>> 30), s.__setDigit(2, l >>> 28), s.__trim();
                }
            },
            {
                key: "DataViewSetBigInt64",
                value: function(e, t, i) {
                    var _ = !!(3 < arguments.length && void 0 !== arguments[3]) && arguments[3];
                    a.DataViewSetBigUint64(e, t, i, _);
                }
            },
            {
                key: "DataViewSetBigUint64",
                value: function(e, t, i) {
                    var _ = !!(3 < arguments.length && void 0 !== arguments[3]) && arguments[3];
                    i = a.asUintN(64, i);
                    var n = 0, g = 0;
                    if (0 < i.length && (g = i.__digit(0), 1 < i.length)) {
                        var o = i.__digit(1);
                        g |= o << 30, n = o >>> 2, 2 < i.length && (n |= i.__digit(2) << 28);
                    }
                    var u = _ ? [
                        4,
                        0
                    ] : [
                        0,
                        4
                    ], s = v(u, 2), r = s[0], d = s[1];
                    e.setUint32(t + r, n, _), e.setUint32(t + d, g, _);
                }
            },
            {
                key: "__zero",
                value: function() {
                    return new a(0, !1);
                }
            },
            {
                key: "__oneDigit",
                value: function(e, t) {
                    var i = new a(1, t);
                    return i.__setDigit(0, e), i;
                }
            },
            {
                key: "__decideRounding",
                value: function(e, t, i, _) {
                    if (0 < t) return -1;
                    var n;
                    if (0 > t) n = -t - 1;
                    else {
                        if (0 === i) return -1;
                        i--, _ = e.__digit(i), n = 29;
                    }
                    var l = 1 << n;
                    if (0 == (_ & l)) return -1;
                    if (l -= 1, 0 != (_ & l)) return 1;
                    for(; 0 < i;)if (i--, 0 !== e.__digit(i)) return 1;
                    return 0;
                }
            },
            {
                key: "__fromDouble",
                value: function(e) {
                    a.__kBitConversionDouble[0] = e;
                    var t, i = 2047 & a.__kBitConversionInts[1] >>> 20, _ = i - 1023, n = (0 | _ / 30) + 1, l = new a(n, 0 > e), g = 1048575 & a.__kBitConversionInts[1] | 1048576, o = a.__kBitConversionInts[0], u = 20, s = _ % 30, r = 0;
                    if (s < u) {
                        var d = u - s;
                        r = d + 32, t = g >>> d, g = g << 32 - d | o >>> d, o <<= 32 - d;
                    } else if (s === u) r = 32, t = g, g = o, o = 0;
                    else {
                        var h = s - u;
                        r = 32 - h, t = g << h | o >>> 32 - h, g = o << h, o = 0;
                    }
                    l.__setDigit(n - 1, t);
                    for(var b = n - 2; 0 <= b; b--)0 < r ? (r -= 30, t = g >>> 2, g = g << 30 | o >>> 2, o <<= 30) : t = 0, l.__setDigit(b, t);
                    return l.__trim();
                }
            },
            {
                key: "__isWhitespace",
                value: function(e) {
                    return !!(13 >= e && 9 <= e) || (159 >= e ? 32 == e : 131071 >= e ? 160 == e || 5760 == e : 196607 >= e ? (e &= 131071, 10 >= e || 40 == e || 41 == e || 47 == e || 95 == e || 4096 == e) : 65279 == e);
                }
            },
            {
                key: "__fromString",
                value: function(e) {
                    var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 0, i = 0, _ = e.length, n = 0;
                    if (n === _) return a.__zero();
                    for(var l = e.charCodeAt(n); a.__isWhitespace(l);){
                        if (++n === _) return a.__zero();
                        l = e.charCodeAt(n);
                    }
                    if (43 === l) {
                        if (++n === _) return null;
                        l = e.charCodeAt(n), i = 1;
                    } else if (45 === l) {
                        if (++n === _) return null;
                        l = e.charCodeAt(n), i = -1;
                    }
                    if (0 === t) {
                        if (t = 10, 48 === l) {
                            if (++n === _) return a.__zero();
                            if (l = e.charCodeAt(n), 88 === l || 120 === l) {
                                if (t = 16, ++n === _) return null;
                                l = e.charCodeAt(n);
                            } else if (79 === l || 111 === l) {
                                if (t = 8, ++n === _) return null;
                                l = e.charCodeAt(n);
                            } else if (66 === l || 98 === l) {
                                if (t = 2, ++n === _) return null;
                                l = e.charCodeAt(n);
                            }
                        }
                    } else if (16 === t && 48 === l) {
                        if (++n === _) return a.__zero();
                        if (l = e.charCodeAt(n), 88 === l || 120 === l) {
                            if (++n === _) return null;
                            l = e.charCodeAt(n);
                        }
                    }
                    if (0 !== i && 10 !== t) return null;
                    for(; 48 === l;){
                        if (++n === _) return a.__zero();
                        l = e.charCodeAt(n);
                    }
                    var g = _ - n, o = a.__kMaxBitsPerChar[t], u = a.__kBitsPerCharTableMultiplier - 1;
                    if (g > 1073741824 / o) return null;
                    var s = o * g + u >>> a.__kBitsPerCharTableShift, r = new a(0 | (s + 29) / 30, !1), h = 10 > t ? t : 10, b = 10 < t ? t - 10 : 0;
                    if (0 == (t & t - 1)) {
                        o >>= a.__kBitsPerCharTableShift;
                        var c = [], v = [], y = !1;
                        do {
                            for(var f, D = 0, p = 0;;){
                                if (f = void 0, l - 48 >>> 0 < h) f = l - 48;
                                else if ((32 | l) - 97 >>> 0 < b) f = (32 | l) - 87;
                                else {
                                    y = !0;
                                    break;
                                }
                                if (p += o, D = D << o | f, ++n === _) {
                                    y = !0;
                                    break;
                                }
                                if (l = e.charCodeAt(n), 30 < p + o) break;
                            }
                            c.push(D), v.push(p);
                        }while (!y);
                        a.__fillFromParts(r, c, v);
                    } else {
                        r.__initializeDigits();
                        var k = !1, B = 0;
                        do {
                            for(var S, C = 0, I = 1;;){
                                if (S = void 0, l - 48 >>> 0 < h) S = l - 48;
                                else if ((32 | l) - 97 >>> 0 < b) S = (32 | l) - 87;
                                else {
                                    k = !0;
                                    break;
                                }
                                var A = I * t;
                                if (1073741823 < A) break;
                                if (I = A, C = C * t + S, B++, ++n === _) {
                                    k = !0;
                                    break;
                                }
                                l = e.charCodeAt(n);
                            }
                            u = 30 * a.__kBitsPerCharTableMultiplier - 1;
                            var m = 0 | (o * B + u >>> a.__kBitsPerCharTableShift) / 30;
                            r.__inplaceMultiplyAdd(I, C, m);
                        }while (!k);
                    }
                    if (n !== _) {
                        if (!a.__isWhitespace(l)) return null;
                        for(n++; n < _; n++)if (l = e.charCodeAt(n), !a.__isWhitespace(l)) return null;
                    }
                    return r.sign = -1 === i, r.__trim();
                }
            },
            {
                key: "__fillFromParts",
                value: function(e, t, _) {
                    for(var n = 0, l = 0, g = 0, o = t.length - 1; 0 <= o; o--){
                        var a = t[o], u = _[o];
                        l |= a << g, g += u, 30 === g ? (e.__setDigit(n++, l), g = 0, l = 0) : 30 < g && (e.__setDigit(n++, 1073741823 & l), g -= 30, l = a >>> u - g);
                    }
                    if (0 !== l) {
                        if (n >= e.length) throw new Error("implementation bug");
                        e.__setDigit(n++, l);
                    }
                    for(; n < e.length; n++)e.__setDigit(n, 0);
                }
            },
            {
                key: "__toStringBasePowerOfTwo",
                value: function(e, t) {
                    var _ = e.length, n = t - 1;
                    n = (85 & n >>> 1) + (85 & n), n = (51 & n >>> 2) + (51 & n), n = (15 & n >>> 4) + (15 & n);
                    var l = n, g = t - 1, o = e.__digit(_ - 1), u = a.__clz30(o), s = 0 | (30 * _ - u + l - 1) / l;
                    if (e.sign && s++, 268435456 < s) throw new Error("string too long");
                    for(var r = Array(s), d = s - 1, h = 0, b = 0, m = 0; m < _ - 1; m++){
                        var c = e.__digit(m), v = (h | c << b) & g;
                        r[d--] = a.__kConversionChars[v];
                        var y = l - b;
                        for(h = c >>> y, b = 30 - y; b >= l;)r[d--] = a.__kConversionChars[h & g], h >>>= l, b -= l;
                    }
                    var f = (h | o << b) & g;
                    for(r[d--] = a.__kConversionChars[f], h = o >>> l - b; 0 !== h;)r[d--] = a.__kConversionChars[h & g], h >>>= l;
                    if (e.sign && (r[d--] = "-"), -1 !== d) throw new Error("implementation bug");
                    return r.join("");
                }
            },
            {
                key: "__toStringGeneric",
                value: function(e, t, _) {
                    var n = e.length;
                    if (0 === n) return "";
                    if (1 === n) {
                        var l = e.__unsignedDigit(0).toString(t);
                        return !1 === _ && e.sign && (l = "-" + l), l;
                    }
                    var g = 30 * n - a.__clz30(e.__digit(n - 1)), o = a.__kMaxBitsPerChar[t], u = o - 1, s = g * a.__kBitsPerCharTableMultiplier;
                    s += u - 1, s = 0 | s / u;
                    var r, d, h = s + 1 >> 1, b = a.exponentiate(a.__oneDigit(t, !1), a.__oneDigit(h, !1)), m = b.__unsignedDigit(0);
                    if (1 === b.length && 32767 >= m) {
                        r = new a(e.length, !1), r.__initializeDigits();
                        for(var c, v = 0, y = 2 * e.length - 1; 0 <= y; y--)c = v << 15 | e.__halfDigit(y), r.__setHalfDigit(y, 0 | c / m), v = 0 | c % m;
                        d = v.toString(t);
                    } else {
                        var f = a.__absoluteDivLarge(e, b, !0, !0);
                        r = f.quotient;
                        var D = f.remainder.__trim();
                        d = a.__toStringGeneric(D, t, !0);
                    }
                    r.__trim();
                    for(var p = a.__toStringGeneric(r, t, !0); d.length < h;)d = "0" + d;
                    return !1 === _ && e.sign && (p = "-" + p), p + d;
                }
            },
            {
                key: "__unequalSign",
                value: function(e) {
                    return e ? -1 : 1;
                }
            },
            {
                key: "__absoluteGreater",
                value: function(e) {
                    return e ? -1 : 1;
                }
            },
            {
                key: "__absoluteLess",
                value: function(e) {
                    return e ? 1 : -1;
                }
            },
            {
                key: "__compareToBigInt",
                value: function(e, t) {
                    var i = e.sign;
                    if (i !== t.sign) return a.__unequalSign(i);
                    var _ = a.__absoluteCompare(e, t);
                    return 0 < _ ? a.__absoluteGreater(i) : 0 > _ ? a.__absoluteLess(i) : 0;
                }
            },
            {
                key: "__compareToNumber",
                value: function(e, i) {
                    if (a.__isOneDigitInt(i)) {
                        var _ = e.sign, n = 0 > i;
                        if (_ !== n) return a.__unequalSign(_);
                        if (0 === e.length) {
                            if (n) throw new Error("implementation bug");
                            return 0 === i ? 0 : -1;
                        }
                        if (1 < e.length) return a.__absoluteGreater(_);
                        var l = t(i), g = e.__unsignedDigit(0);
                        return g > l ? a.__absoluteGreater(_) : g < l ? a.__absoluteLess(_) : 0;
                    }
                    return a.__compareToDouble(e, i);
                }
            },
            {
                key: "__compareToDouble",
                value: function(e, t) {
                    if (t !== t) return t;
                    if (t === 1 / 0) return -1;
                    if (t === -Infinity) return 1;
                    var i = e.sign;
                    if (i !== 0 > t) return a.__unequalSign(i);
                    if (0 === t) throw new Error("implementation bug: should be handled elsewhere");
                    if (0 === e.length) return -1;
                    a.__kBitConversionDouble[0] = t;
                    var _ = 2047 & a.__kBitConversionInts[1] >>> 20;
                    if (2047 == _) throw new Error("implementation bug: handled elsewhere");
                    var n = _ - 1023;
                    if (0 > n) return a.__absoluteGreater(i);
                    var l = e.length, g = e.__digit(l - 1), o = a.__clz30(g), u = 30 * l - o, s = n + 1;
                    if (u < s) return a.__absoluteLess(i);
                    if (u > s) return a.__absoluteGreater(i);
                    var r = 1048576 | 1048575 & a.__kBitConversionInts[1], d = a.__kBitConversionInts[0], h = 20, b = 29 - o;
                    if (b !== (0 | (u - 1) % 30)) throw new Error("implementation bug");
                    var m, c = 0;
                    if (b < h) {
                        var v = h - b;
                        c = v + 32, m = r >>> v, r = r << 32 - v | d >>> v, d <<= 32 - v;
                    } else if (b === h) c = 32, m = r, r = d, d = 0;
                    else {
                        var y = b - h;
                        c = 32 - y, m = r << y | d >>> 32 - y, r = d << y, d = 0;
                    }
                    if (g >>>= 0, m >>>= 0, g > m) return a.__absoluteGreater(i);
                    if (g < m) return a.__absoluteLess(i);
                    for(var f = l - 2; 0 <= f; f--){
                        0 < c ? (c -= 30, m = r >>> 2, r = r << 30 | d >>> 2, d <<= 30) : m = 0;
                        var D = e.__unsignedDigit(f);
                        if (D > m) return a.__absoluteGreater(i);
                        if (D < m) return a.__absoluteLess(i);
                    }
                    if (0 !== r || 0 !== d) {
                        if (0 === c) throw new Error("implementation bug");
                        return a.__absoluteLess(i);
                    }
                    return 0;
                }
            },
            {
                key: "__equalToNumber",
                value: function(e, i) {
                    return a.__isOneDigitInt(i) ? 0 === i ? 0 === e.length : 1 === e.length && e.sign === 0 > i && e.__unsignedDigit(0) === t(i) : 0 === a.__compareToDouble(e, i);
                }
            },
            {
                key: "__comparisonResultToBool",
                value: function(e, t) {
                    return 0 === t ? 0 > e : 1 === t ? 0 >= e : 2 === t ? 0 < e : 3 === t ? 0 <= e : void 0;
                }
            },
            {
                key: "__compare",
                value: function(e, t, i) {
                    if (e = a.__toPrimitive(e), t = a.__toPrimitive(t), "string" == typeof e && "string" == typeof t) switch(i){
                        case 0:
                            return e < t;
                        case 1:
                            return e <= t;
                        case 2:
                            return e > t;
                        case 3:
                            return e >= t;
                    }
                    if (a.__isBigInt(e) && "string" == typeof t) return t = a.__fromString(t), null !== t && a.__comparisonResultToBool(a.__compareToBigInt(e, t), i);
                    if ("string" == typeof e && a.__isBigInt(t)) return e = a.__fromString(e), null !== e && a.__comparisonResultToBool(a.__compareToBigInt(e, t), i);
                    if (e = a.__toNumeric(e), t = a.__toNumeric(t), a.__isBigInt(e)) {
                        if (a.__isBigInt(t)) return a.__comparisonResultToBool(a.__compareToBigInt(e, t), i);
                        if ("number" != typeof t) throw new Error("implementation bug");
                        return a.__comparisonResultToBool(a.__compareToNumber(e, t), i);
                    }
                    if ("number" != typeof e) throw new Error("implementation bug");
                    if (a.__isBigInt(t)) return a.__comparisonResultToBool(a.__compareToNumber(t, e), 2 ^ i);
                    if ("number" != typeof t) throw new Error("implementation bug");
                    return 0 === i ? e < t : 1 === i ? e <= t : 2 === i ? e > t : 3 === i ? e >= t : void 0;
                }
            },
            {
                key: "__absoluteAdd",
                value: function(e, t, _) {
                    if (e.length < t.length) return a.__absoluteAdd(t, e, _);
                    if (0 === e.length) return e;
                    if (0 === t.length) return e.sign === _ ? e : a.unaryMinus(e);
                    var n = e.length;
                    (0 === e.__clzmsd() || t.length === e.length && 0 === t.__clzmsd()) && n++;
                    for(var l, g = new a(n, _), o = 0, u = 0; u < t.length; u++)l = e.__digit(u) + t.__digit(u) + o, o = l >>> 30, g.__setDigit(u, 1073741823 & l);
                    for(; u < e.length; u++){
                        var s = e.__digit(u) + o;
                        o = s >>> 30, g.__setDigit(u, 1073741823 & s);
                    }
                    return u < g.length && g.__setDigit(u, o), g.__trim();
                }
            },
            {
                key: "__absoluteSub",
                value: function(e, t, _) {
                    if (0 === e.length) return e;
                    if (0 === t.length) return e.sign === _ ? e : a.unaryMinus(e);
                    for(var n, l = new a(e.length, _), g = 0, o = 0; o < t.length; o++)n = e.__digit(o) - t.__digit(o) - g, g = 1 & n >>> 30, l.__setDigit(o, 1073741823 & n);
                    for(; o < e.length; o++){
                        var u = e.__digit(o) - g;
                        g = 1 & u >>> 30, l.__setDigit(o, 1073741823 & u);
                    }
                    return l.__trim();
                }
            },
            {
                key: "__absoluteAddOne",
                value: function(e, t) {
                    var _ = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null, n = e.length;
                    null === _ ? _ = new a(n, t) : _.sign = t;
                    for(var l, g = 1, o = 0; o < n; o++)l = e.__digit(o) + g, g = l >>> 30, _.__setDigit(o, 1073741823 & l);
                    return 0 !== g && _.__setDigitGrow(n, 1), _;
                }
            },
            {
                key: "__absoluteSubOne",
                value: function(e, t) {
                    var _ = e.length;
                    t = t || _;
                    for(var n, l = new a(t, !1), g = 1, o = 0; o < _; o++)n = e.__digit(o) - g, g = 1 & n >>> 30, l.__setDigit(o, 1073741823 & n);
                    if (0 !== g) throw new Error("implementation bug");
                    for(var u = _; u < t; u++)l.__setDigit(u, 0);
                    return l;
                }
            },
            {
                key: "__absoluteAnd",
                value: function(e, t) {
                    var _ = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null, n = e.length, l = t.length, g = l;
                    if (n < l) {
                        g = n;
                        var o = e, u = n;
                        e = t, n = l, t = o, l = u;
                    }
                    var s = g;
                    null === _ ? _ = new a(s, !1) : s = _.length;
                    for(var r = 0; r < g; r++)_.__setDigit(r, e.__digit(r) & t.__digit(r));
                    for(; r < s; r++)_.__setDigit(r, 0);
                    return _;
                }
            },
            {
                key: "__absoluteAndNot",
                value: function(e, t) {
                    var _ = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null, n = e.length, l = t.length, g = l;
                    n < l && (g = n);
                    var o = n;
                    null === _ ? _ = new a(o, !1) : o = _.length;
                    for(var u = 0; u < g; u++)_.__setDigit(u, e.__digit(u) & ~t.__digit(u));
                    for(; u < n; u++)_.__setDigit(u, e.__digit(u));
                    for(; u < o; u++)_.__setDigit(u, 0);
                    return _;
                }
            },
            {
                key: "__absoluteOr",
                value: function(e, t) {
                    var _ = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null, n = e.length, l = t.length, g = l;
                    if (n < l) {
                        g = n;
                        var o = e, u = n;
                        e = t, n = l, t = o, l = u;
                    }
                    var s = n;
                    null === _ ? _ = new a(s, !1) : s = _.length;
                    for(var r = 0; r < g; r++)_.__setDigit(r, e.__digit(r) | t.__digit(r));
                    for(; r < n; r++)_.__setDigit(r, e.__digit(r));
                    for(; r < s; r++)_.__setDigit(r, 0);
                    return _;
                }
            },
            {
                key: "__absoluteXor",
                value: function(e, t) {
                    var _ = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null, n = e.length, l = t.length, g = l;
                    if (n < l) {
                        g = n;
                        var o = e, u = n;
                        e = t, n = l, t = o, l = u;
                    }
                    var s = n;
                    null === _ ? _ = new a(s, !1) : s = _.length;
                    for(var r = 0; r < g; r++)_.__setDigit(r, e.__digit(r) ^ t.__digit(r));
                    for(; r < n; r++)_.__setDigit(r, e.__digit(r));
                    for(; r < s; r++)_.__setDigit(r, 0);
                    return _;
                }
            },
            {
                key: "__absoluteCompare",
                value: function(e, t) {
                    var _ = e.length - t.length;
                    if (0 != _) return _;
                    for(var n = e.length - 1; 0 <= n && e.__digit(n) === t.__digit(n);)n--;
                    return 0 > n ? 0 : e.__unsignedDigit(n) > t.__unsignedDigit(n) ? 1 : -1;
                }
            },
            {
                key: "__multiplyAccumulate",
                value: function(e, t, _, n) {
                    if (0 !== t) {
                        for(var l = 32767 & t, g = t >>> 15, o = 0, u = 0, s = 0; s < e.length; s++, n++){
                            var r = _.__digit(n), d = e.__digit(s), h = 32767 & d, b = d >>> 15, m = a.__imul(h, l), c = a.__imul(h, g), v = a.__imul(b, l), y = a.__imul(b, g);
                            r += u + m + o, o = r >>> 30, r &= 1073741823, r += ((32767 & c) << 15) + ((32767 & v) << 15), o += r >>> 30, u = y + (c >>> 15) + (v >>> 15), _.__setDigit(n, 1073741823 & r);
                        }
                        for(; 0 !== o || 0 !== u; n++){
                            var f = _.__digit(n);
                            f += o + u, u = 0, o = f >>> 30, _.__setDigit(n, 1073741823 & f);
                        }
                    }
                }
            },
            {
                key: "__internalMultiplyAdd",
                value: function(e, t, _, l, g) {
                    for(var o = _, u = 0, s = 0; s < l; s++){
                        var d = e.__digit(s), h = a.__imul(32767 & d, t), b = a.__imul(d >>> 15, t), m = h + ((32767 & b) << 15) + u + o;
                        o = m >>> 30, u = b >>> 15, g.__setDigit(s, 1073741823 & m);
                    }
                    if (g.length > l) for(g.__setDigit(l++, o + u); l < g.length;)g.__setDigit(l++, 0);
                    else if (0 !== o + u) throw new Error("implementation bug");
                }
            },
            {
                key: "__absoluteDivSmall",
                value: function(e, t) {
                    var _ = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
                    null === _ && (_ = new a(e.length, !1));
                    for(var n = 0, l = 2 * e.length - 1; 0 <= l; l -= 2){
                        var g = (n << 15 | e.__halfDigit(l)) >>> 0, o = 0 | g / t;
                        n = 0 | g % t, g = (n << 15 | e.__halfDigit(l - 1)) >>> 0;
                        var u = 0 | g / t;
                        n = 0 | g % t, _.__setDigit(l >>> 1, o << 15 | u);
                    }
                    return _;
                }
            },
            {
                key: "__absoluteModSmall",
                value: function(e, t) {
                    for(var _, n = 0, l = 2 * e.length - 1; 0 <= l; l--)_ = (n << 15 | e.__halfDigit(l)) >>> 0, n = 0 | _ % t;
                    return n;
                }
            },
            {
                key: "__absoluteDivLarge",
                value: function(e, t, i, _) {
                    var l = t.__halfDigitLength(), n = t.length, g = e.__halfDigitLength() - l, o = null;
                    i && (o = new a(g + 2 >>> 1, !1), o.__initializeDigits());
                    var s = new a(l + 2 >>> 1, !1);
                    s.__initializeDigits();
                    var r = a.__clz15(t.__halfDigit(l - 1));
                    0 < r && (t = a.__specialLeftShift(t, r, 0));
                    for(var d = a.__specialLeftShift(e, r, 1), u = t.__halfDigit(l - 1), h = 0, b = g; 0 <= b; b--){
                        var m = 32767, v = d.__halfDigit(b + l);
                        if (v !== u) {
                            var y = (v << 15 | d.__halfDigit(b + l - 1)) >>> 0;
                            m = 0 | y / u;
                            for(var f = 0 | y % u, D = t.__halfDigit(l - 2), p = d.__halfDigit(b + l - 2); a.__imul(m, D) >>> 0 > (f << 16 | p) >>> 0 && (m--, f += u, !(32767 < f)););
                        }
                        a.__internalMultiplyAdd(t, m, 0, n, s);
                        var k = d.__inplaceSub(s, b, l + 1);
                        0 !== k && (k = d.__inplaceAdd(t, b, l), d.__setHalfDigit(b + l, 32767 & d.__halfDigit(b + l) + k), m--), i && (1 & b ? h = m << 15 : o.__setDigit(b >>> 1, h | m));
                    }
                    if (_) return d.__inplaceRightShift(r), i ? {
                        quotient: o,
                        remainder: d
                    } : d;
                    if (i) return o;
                    throw new Error("unreachable");
                }
            },
            {
                key: "__clz15",
                value: function(e) {
                    return a.__clz30(e) - 15;
                }
            },
            {
                key: "__specialLeftShift",
                value: function(e, t, _) {
                    var l = e.length, n = new a(l + _, !1);
                    if (0 === t) {
                        for(var g = 0; g < l; g++)n.__setDigit(g, e.__digit(g));
                        return 0 < _ && n.__setDigit(l, 0), n;
                    }
                    for(var o, u = 0, s = 0; s < l; s++)o = e.__digit(s), n.__setDigit(s, 1073741823 & o << t | u), u = o >>> 30 - t;
                    return 0 < _ && n.__setDigit(l, u), n;
                }
            },
            {
                key: "__leftShiftByAbsolute",
                value: function(e, t) {
                    var _ = a.__toShiftAmount(t);
                    if (0 > _) throw new RangeError("BigInt too big");
                    var n = 0 | _ / 30, l = _ % 30, g = e.length, o = 0 !== l && 0 != e.__digit(g - 1) >>> 30 - l, u = g + n + (o ? 1 : 0), s = new a(u, e.sign);
                    if (0 === l) {
                        for(var r = 0; r < n; r++)s.__setDigit(r, 0);
                        for(; r < u; r++)s.__setDigit(r, e.__digit(r - n));
                    } else {
                        for(var h = 0, b = 0; b < n; b++)s.__setDigit(b, 0);
                        for(var m, c = 0; c < g; c++)m = e.__digit(c), s.__setDigit(c + n, 1073741823 & m << l | h), h = m >>> 30 - l;
                        if (o) s.__setDigit(g + n, h);
                        else if (0 !== h) throw new Error("implementation bug");
                    }
                    return s.__trim();
                }
            },
            {
                key: "__rightShiftByAbsolute",
                value: function(e, t) {
                    var _ = e.length, n = e.sign, l = a.__toShiftAmount(t);
                    if (0 > l) return a.__rightShiftByMaximum(n);
                    var g = 0 | l / 30, o = l % 30, u = _ - g;
                    if (0 >= u) return a.__rightShiftByMaximum(n);
                    var s = !1;
                    if (n) {
                        if (0 != (e.__digit(g) & (1 << o) - 1)) s = !0;
                        else for(var r = 0; r < g; r++)if (0 !== e.__digit(r)) {
                            s = !0;
                            break;
                        }
                    }
                    if (s && 0 === o) {
                        var h = e.__digit(_ - 1);
                        0 == ~h && u++;
                    }
                    var b = new a(u, n);
                    if (0 === o) {
                        b.__setDigit(u - 1, 0);
                        for(var m = g; m < _; m++)b.__setDigit(m - g, e.__digit(m));
                    } else {
                        for(var c, v = e.__digit(g) >>> o, y = _ - g - 1, f = 0; f < y; f++)c = e.__digit(f + g + 1), b.__setDigit(f, 1073741823 & c << 30 - o | v), v = c >>> o;
                        b.__setDigit(y, v);
                    }
                    return s && (b = a.__absoluteAddOne(b, !0, b)), b.__trim();
                }
            },
            {
                key: "__rightShiftByMaximum",
                value: function(e) {
                    return e ? a.__oneDigit(1, !0) : a.__zero();
                }
            },
            {
                key: "__toShiftAmount",
                value: function(e) {
                    if (1 < e.length) return -1;
                    var t = e.__unsignedDigit(0);
                    return t > a.__kMaxLengthBits ? -1 : t;
                }
            },
            {
                key: "__toPrimitive",
                value: function(e) {
                    var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "default";
                    if ("object" !== i(e)) return e;
                    if (e.constructor === a) return e;
                    if ("undefined" != typeof Symbol && "symbol" === i(Symbol.toPrimitive)) {
                        var _ = e[Symbol.toPrimitive];
                        if (_) {
                            var n = _(t);
                            if ("object" !== i(n)) return n;
                            throw new TypeError("Cannot convert object to primitive value");
                        }
                    }
                    var l = e.valueOf;
                    if (l) {
                        var g = l.call(e);
                        if ("object" !== i(g)) return g;
                    }
                    var o = e.toString;
                    if (o) {
                        var u = o.call(e);
                        if ("object" !== i(u)) return u;
                    }
                    throw new TypeError("Cannot convert object to primitive value");
                }
            },
            {
                key: "__toNumeric",
                value: function(e) {
                    return a.__isBigInt(e) ? e : +e;
                }
            },
            {
                key: "__isBigInt",
                value: function(e) {
                    return "object" === i(e) && null !== e && e.constructor === a;
                }
            },
            {
                key: "__truncateToNBits",
                value: function(e, t) {
                    for(var _ = 0 | (e + 29) / 30, n = new a(_, t.sign), l = _ - 1, g = 0; g < l; g++)n.__setDigit(g, t.__digit(g));
                    var o = t.__digit(l);
                    if (0 != e % 30) {
                        var u = 32 - e % 30;
                        o = o << u >>> u;
                    }
                    return n.__setDigit(l, o), n.__trim();
                }
            },
            {
                key: "__truncateAndSubFromPowerOfTwo",
                value: function(e, t, _) {
                    for(var n = Math.min, l, g = 0 | (e + 29) / 30, o = new a(g, _), u = 0, s = g - 1, d = 0, h = n(s, t.length); u < h; u++)l = 0 - t.__digit(u) - d, d = 1 & l >>> 30, o.__setDigit(u, 1073741823 & l);
                    for(; u < s; u++)o.__setDigit(u, 0 | 1073741823 & -d);
                    var b, m = s < t.length ? t.__digit(s) : 0, c = e % 30;
                    if (0 === c) b = 0 - m - d, b &= 1073741823;
                    else {
                        var v = 32 - c;
                        m = m << v >>> v;
                        var y = 1 << 32 - v;
                        b = y - m - d, b &= y - 1;
                    }
                    return o.__setDigit(s, b), o.__trim();
                }
            },
            {
                key: "__digitPow",
                value: function(e, t) {
                    for(var i = 1; 0 < t;)1 & t && (i *= e), t >>>= 1, e *= e;
                    return i;
                }
            },
            {
                key: "__isOneDigitInt",
                value: function(e) {
                    return (1073741823 & e) === e;
                }
            }
        ]), a;
    }(h(Array));
    return S.__kMaxLength = 33554432, S.__kMaxLengthBits = S.__kMaxLength << 5, S.__kMaxBitsPerChar = [
        0,
        0,
        32,
        51,
        64,
        75,
        83,
        90,
        96,
        102,
        107,
        111,
        115,
        119,
        122,
        126,
        128,
        131,
        134,
        136,
        139,
        141,
        143,
        145,
        147,
        149,
        151,
        153,
        154,
        156,
        158,
        159,
        160,
        162,
        163,
        165,
        166
    ], S.__kBitsPerCharTableShift = 5, S.__kBitsPerCharTableMultiplier = 1 << S.__kBitsPerCharTableShift, S.__kConversionChars = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z"
    ], S.__kBitConversionBuffer = new ArrayBuffer(8), S.__kBitConversionDouble = new Float64Array(S.__kBitConversionBuffer), S.__kBitConversionInts = new Int32Array(S.__kBitConversionBuffer), S.__clz30 = t ? function(e) {
        return t(e) - 2;
    } : function(e) {
        var t = Math.LN2, i = Math.log;
        return 0 === e ? 30 : 0 | 29 - (0 | i(e >>> 0) / t);
    }, S.__imul = e || function(e, t) {
        return 0 | e * t;
    }, S;
});


const $68c609acd189a8b4$var$t = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(0), $68c609acd189a8b4$var$n = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(1), $68c609acd189a8b4$var$r = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(2), $68c609acd189a8b4$var$o = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(10), $68c609acd189a8b4$var$i = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(24), $68c609acd189a8b4$var$a = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(60), $68c609acd189a8b4$var$s = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(1e3), $68c609acd189a8b4$var$c = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(1e6), $68c609acd189a8b4$var$d = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(1e9), $68c609acd189a8b4$var$h = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).multiply((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(3600), $68c609acd189a8b4$var$d), $68c609acd189a8b4$var$u = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).multiply($68c609acd189a8b4$var$a, $68c609acd189a8b4$var$d), $68c609acd189a8b4$var$l = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).multiply($68c609acd189a8b4$var$h, $68c609acd189a8b4$var$i);
function $68c609acd189a8b4$var$m(t) {
    return "bigint" == typeof t ? (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(t.toString(10)) : t;
}
function $68c609acd189a8b4$var$f(n) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).equal((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).remainder(n, $68c609acd189a8b4$var$r), $68c609acd189a8b4$var$t);
}
function $68c609acd189a8b4$var$y(n) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).lessThan(n, $68c609acd189a8b4$var$t) ? (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).unaryMinus(n) : n;
}
function $68c609acd189a8b4$var$p(t, n) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).lessThan(t, n) ? -1 : (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).greaterThan(t, n) ? 1 : 0;
}
function $68c609acd189a8b4$var$g(t, n) {
    return {
        quotient: (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).divide(t, n),
        remainder: (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).remainder(t, n)
    };
}
var $68c609acd189a8b4$var$w, $68c609acd189a8b4$var$v;
const $68c609acd189a8b4$var$b = "slot-epochNanoSeconds", $68c609acd189a8b4$var$D = "slot-iso-date", $68c609acd189a8b4$var$T = "slot-iso-date-time", $68c609acd189a8b4$var$M = "slot-time", $68c609acd189a8b4$var$E = "slot-calendar", $68c609acd189a8b4$var$I = "slot-date-brand", $68c609acd189a8b4$var$C = "slot-year-month-brand", $68c609acd189a8b4$var$O = "slot-month-day-brand", $68c609acd189a8b4$var$$ = "slot-time-zone", $68c609acd189a8b4$var$Y = "slot-years", $68c609acd189a8b4$var$R = "slot-months", $68c609acd189a8b4$var$S = "slot-weeks", $68c609acd189a8b4$var$j = "slot-days", $68c609acd189a8b4$var$k = "slot-hours", $68c609acd189a8b4$var$N = "slot-minutes", $68c609acd189a8b4$var$x = "slot-seconds", $68c609acd189a8b4$var$L = "slot-milliseconds", $68c609acd189a8b4$var$P = "slot-microseconds", $68c609acd189a8b4$var$U = "slot-nanoseconds", $68c609acd189a8b4$var$B = "date", $68c609acd189a8b4$var$Z = "ym", $68c609acd189a8b4$var$F = "md", $68c609acd189a8b4$var$H = "time", $68c609acd189a8b4$var$z = "datetime", $68c609acd189a8b4$var$A = "instant", $68c609acd189a8b4$var$q = "original", $68c609acd189a8b4$var$W = "timezone-canonical", $68c609acd189a8b4$var$_ = "timezone-original", $68c609acd189a8b4$var$J = "calendar-id", $68c609acd189a8b4$var$G = "locale", $68c609acd189a8b4$var$K = "options", $68c609acd189a8b4$var$V = new WeakMap, $68c609acd189a8b4$var$X = Symbol.for("@@Temporal__GetSlots");
($68c609acd189a8b4$var$w = globalThis)[$68c609acd189a8b4$var$X] || ($68c609acd189a8b4$var$w[$68c609acd189a8b4$var$X] = function(e) {
    return $68c609acd189a8b4$var$V.get(e);
});
const $68c609acd189a8b4$var$Q = globalThis[$68c609acd189a8b4$var$X], $68c609acd189a8b4$var$ee = Symbol.for("@@Temporal__CreateSlots");
($68c609acd189a8b4$var$v = globalThis)[$68c609acd189a8b4$var$ee] || ($68c609acd189a8b4$var$v[$68c609acd189a8b4$var$ee] = function(e) {
    $68c609acd189a8b4$var$V.set(e, Object.create(null));
});
const $68c609acd189a8b4$var$te = globalThis[$68c609acd189a8b4$var$ee];
function $68c609acd189a8b4$var$ne(e, ...t) {
    if (!e || "object" != typeof e) return !1;
    const n = $68c609acd189a8b4$var$Q(e);
    return !!n && t.every((e)=>e in n);
}
function $68c609acd189a8b4$var$re(e, t) {
    const n = $68c609acd189a8b4$var$Q(e)?.[t];
    if (void 0 === n) throw new TypeError(`Missing internal slot ${t}`);
    return n;
}
function $68c609acd189a8b4$var$oe(e, t, n) {
    const r = $68c609acd189a8b4$var$Q(e);
    if (void 0 === r) throw new TypeError("Missing slots for the given container");
    if (r[t]) throw new TypeError(`${t} already has set`);
    r[t] = n;
}
const $68c609acd189a8b4$var$ie = {};
function $68c609acd189a8b4$var$ae(e, t) {
    Object.defineProperty(e.prototype, Symbol.toStringTag, {
        value: t,
        writable: !1,
        enumerable: !1,
        configurable: !0
    });
    const n = Object.getOwnPropertyNames(e);
    for(let t = 0; t < n.length; t++){
        const r = n[t], o = Object.getOwnPropertyDescriptor(e, r);
        o.configurable && o.enumerable && (o.enumerable = !1, Object.defineProperty(e, r, o));
    }
    const r = Object.getOwnPropertyNames(e.prototype);
    for(let t = 0; t < r.length; t++){
        const n = r[t], o = Object.getOwnPropertyDescriptor(e.prototype, n);
        o.configurable && o.enumerable && (o.enumerable = !1, Object.defineProperty(e.prototype, n, o));
    }
    $68c609acd189a8b4$var$se(t, e), $68c609acd189a8b4$var$se(`${t}.prototype`, e.prototype);
}
function $68c609acd189a8b4$var$se(e, t) {
    const n = `%${e}%`;
    if (void 0 !== $68c609acd189a8b4$var$ie[n]) throw new Error(`intrinsic ${e} already exists`);
    $68c609acd189a8b4$var$ie[n] = t;
}
function $68c609acd189a8b4$var$ce(e) {
    return $68c609acd189a8b4$var$ie[e];
}
function $68c609acd189a8b4$var$de(e, t) {
    let n = e;
    if (0 === n) return {
        div: n,
        mod: n
    };
    const r = Math.sign(n);
    n = Math.abs(n);
    const o = Math.trunc(1 + Math.log10(n));
    if (t >= o) return {
        div: 0 * r,
        mod: r * n
    };
    if (0 === t) return {
        div: r * n,
        mod: 0 * r
    };
    const i = n.toPrecision(o);
    return {
        div: r * Number.parseInt(i.slice(0, o - t), 10),
        mod: r * Number.parseInt(i.slice(o - t), 10)
    };
}
function $68c609acd189a8b4$var$he(e, t, n) {
    let r = e, o = n;
    if (0 === r) return o;
    const i = Math.sign(r) || Math.sign(o);
    r = Math.abs(r), o = Math.abs(o);
    const a = r.toPrecision(Math.trunc(1 + Math.log10(r)));
    if (0 === o) return i * Number.parseInt(a + "0".repeat(t), 10);
    const s = a + o.toPrecision(Math.trunc(1 + Math.log10(o))).padStart(t, "0");
    return i * Number.parseInt(s, 10);
}
function $68c609acd189a8b4$var$ue(e, t) {
    const n = "negative" === t;
    switch(e){
        case "ceil":
            return n ? "zero" : "infinity";
        case "floor":
            return n ? "infinity" : "zero";
        case "expand":
            return "infinity";
        case "trunc":
            return "zero";
        case "halfCeil":
            return n ? "half-zero" : "half-infinity";
        case "halfFloor":
            return n ? "half-infinity" : "half-zero";
        case "halfExpand":
            return "half-infinity";
        case "halfTrunc":
            return "half-zero";
        case "halfEven":
            return "half-even";
    }
}
function $68c609acd189a8b4$var$le(e, t, n, r, o) {
    return "zero" === o ? e : "infinity" === o ? t : n < 0 ? e : n > 0 ? t : "half-zero" === o ? e : "half-infinity" === o ? t : r ? e : t;
}
class $68c609acd189a8b4$var$TimeDuration {
    constructor(t){
        this.totalNs = $68c609acd189a8b4$var$m(t), this.sec = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).toNumber((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).divide(this.totalNs, $68c609acd189a8b4$var$d)), this.subsec = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).toNumber((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).remainder(this.totalNs, $68c609acd189a8b4$var$d));
    }
    static validateNew(t, n) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).greaterThan($68c609acd189a8b4$var$y(t), $68c609acd189a8b4$var$TimeDuration.MAX)) throw new RangeError(`${n} of duration time units cannot exceed ${$68c609acd189a8b4$var$TimeDuration.MAX} s`);
        return new $68c609acd189a8b4$var$TimeDuration(t);
    }
    static fromEpochNsDiff(t, n) {
        const r = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).subtract($68c609acd189a8b4$var$m(t), $68c609acd189a8b4$var$m(n));
        return new $68c609acd189a8b4$var$TimeDuration(r);
    }
    static fromComponents(t, n, r, o, i, a) {
        const l = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).add((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).add((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).add((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).add((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).add((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(a), (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).multiply((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(i), $68c609acd189a8b4$var$s)), (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).multiply((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(o), $68c609acd189a8b4$var$c)), (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).multiply((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(r), $68c609acd189a8b4$var$d)), (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).multiply((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(n), $68c609acd189a8b4$var$u)), (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).multiply((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(t), $68c609acd189a8b4$var$h));
        return $68c609acd189a8b4$var$TimeDuration.validateNew(l, "total");
    }
    abs() {
        return new $68c609acd189a8b4$var$TimeDuration($68c609acd189a8b4$var$y(this.totalNs));
    }
    add(t) {
        return $68c609acd189a8b4$var$TimeDuration.validateNew((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).add(this.totalNs, t.totalNs), "sum");
    }
    add24HourDays(t) {
        return $68c609acd189a8b4$var$TimeDuration.validateNew((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).add(this.totalNs, (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).multiply((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(t), $68c609acd189a8b4$var$l)), "sum");
    }
    addToEpochNs(t) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).add($68c609acd189a8b4$var$m(t), this.totalNs);
    }
    cmp(e) {
        return $68c609acd189a8b4$var$p(this.totalNs, e.totalNs);
    }
    divmod(t) {
        const { quotient: n, remainder: r } = $68c609acd189a8b4$var$g(this.totalNs, (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(t));
        return {
            quotient: (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).toNumber(n),
            remainder: new $68c609acd189a8b4$var$TimeDuration(r)
        };
    }
    fdiv(n) {
        const r = $68c609acd189a8b4$var$m(n), i = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(r);
        let { quotient: a, remainder: s } = $68c609acd189a8b4$var$g(this.totalNs, i);
        const c = [];
        let d;
        const h = ((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).lessThan(this.totalNs, $68c609acd189a8b4$var$t) ? -1 : 1) * Math.sign((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).toNumber(r));
        for(; !(0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).equal(s, $68c609acd189a8b4$var$t) && c.length < 50;)s = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).multiply(s, $68c609acd189a8b4$var$o), ({ quotient: d, remainder: s } = $68c609acd189a8b4$var$g(s, i)), c.push(Math.abs((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).toNumber(d)));
        return h * Number($68c609acd189a8b4$var$y(a).toString() + "." + c.join(""));
    }
    isZero() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).equal(this.totalNs, $68c609acd189a8b4$var$t);
    }
    round(o, i) {
        const a = $68c609acd189a8b4$var$m(o);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).equal(a, $68c609acd189a8b4$var$n)) return this;
        const { quotient: s, remainder: c } = $68c609acd189a8b4$var$g(this.totalNs, a), d = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).lessThan(this.totalNs, $68c609acd189a8b4$var$t) ? "negative" : "positive", h = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).multiply($68c609acd189a8b4$var$y(s), a), u = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).add(h, a), l = $68c609acd189a8b4$var$p($68c609acd189a8b4$var$y((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).multiply(c, $68c609acd189a8b4$var$r)), a), w = $68c609acd189a8b4$var$ue(i, d), v = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).equal($68c609acd189a8b4$var$y(this.totalNs), h) ? h : $68c609acd189a8b4$var$le(h, u, l, $68c609acd189a8b4$var$f(s), w), b = "positive" === d ? v : (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).unaryMinus(v);
        return $68c609acd189a8b4$var$TimeDuration.validateNew(b, "rounding");
    }
    sign() {
        return this.cmp(new $68c609acd189a8b4$var$TimeDuration($68c609acd189a8b4$var$t));
    }
    subtract(t) {
        return $68c609acd189a8b4$var$TimeDuration.validateNew((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).subtract(this.totalNs, t.totalNs), "difference");
    }
}
$68c609acd189a8b4$var$TimeDuration.MAX = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt("9007199254740991999999999"), $68c609acd189a8b4$var$TimeDuration.ZERO = new $68c609acd189a8b4$var$TimeDuration($68c609acd189a8b4$var$t);
const $68c609acd189a8b4$var$me = /[A-Za-z._][A-Za-z._0-9+-]*/, $68c609acd189a8b4$var$fe = new RegExp(`(?:${/(?:[+-](?:[01][0-9]|2[0-3])(?::?[0-5][0-9])?)/.source}|(?:${$68c609acd189a8b4$var$me.source})(?:\\/(?:${$68c609acd189a8b4$var$me.source}))*)`), $68c609acd189a8b4$var$ye = /(?:[+-]\d{6}|\d{4})/, $68c609acd189a8b4$var$pe = /(?:0[1-9]|1[0-2])/, $68c609acd189a8b4$var$ge = /(?:0[1-9]|[12]\d|3[01])/, $68c609acd189a8b4$var$we = new RegExp(`(${$68c609acd189a8b4$var$ye.source})(?:-(${$68c609acd189a8b4$var$pe.source})-(${$68c609acd189a8b4$var$ge.source})|(${$68c609acd189a8b4$var$pe.source})(${$68c609acd189a8b4$var$ge.source}))`), $68c609acd189a8b4$var$ve = /(\d{2})(?::(\d{2})(?::(\d{2})(?:[.,](\d{1,9}))?)?|(\d{2})(?:(\d{2})(?:[.,](\d{1,9}))?)?)?/, $68c609acd189a8b4$var$be = /((?:[+-])(?:[01][0-9]|2[0-3])(?::?(?:[0-5][0-9])(?::?(?:[0-5][0-9])(?:[.,](?:\d{1,9}))?)?)?)/, $68c609acd189a8b4$var$De = new RegExp(`([zZ])|${$68c609acd189a8b4$var$be.source}?`), $68c609acd189a8b4$var$Te = /\[(!)?([a-z_][a-z0-9_-]*)=([A-Za-z0-9]+(?:-[A-Za-z0-9]+)*)\]/g, $68c609acd189a8b4$var$Me = new RegExp([
    `^${$68c609acd189a8b4$var$we.source}`,
    `(?:(?:[tT]|\\s+)${$68c609acd189a8b4$var$ve.source}(?:${$68c609acd189a8b4$var$De.source})?)?`,
    `(?:\\[!?(${$68c609acd189a8b4$var$fe.source})\\])?`,
    `((?:${$68c609acd189a8b4$var$Te.source})*)$`
].join("")), $68c609acd189a8b4$var$Ee = new RegExp([
    `^[tT]?${$68c609acd189a8b4$var$ve.source}`,
    `(?:${$68c609acd189a8b4$var$De.source})?`,
    `(?:\\[!?${$68c609acd189a8b4$var$fe.source}\\])?`,
    `((?:${$68c609acd189a8b4$var$Te.source})*)$`
].join("")), $68c609acd189a8b4$var$Ie = new RegExp(`^(${$68c609acd189a8b4$var$ye.source})-?(${$68c609acd189a8b4$var$pe.source})(?:\\[!?${$68c609acd189a8b4$var$fe.source}\\])?((?:${$68c609acd189a8b4$var$Te.source})*)$`), $68c609acd189a8b4$var$Ce = new RegExp(`^(?:--)?(${$68c609acd189a8b4$var$pe.source})-?(${$68c609acd189a8b4$var$ge.source})(?:\\[!?${$68c609acd189a8b4$var$fe.source}\\])?((?:${$68c609acd189a8b4$var$Te.source})*)$`), $68c609acd189a8b4$var$Oe = /(\d+)(?:[.,](\d{1,9}))?/, $68c609acd189a8b4$var$$e = new RegExp(`(?:${$68c609acd189a8b4$var$Oe.source}H)?(?:${$68c609acd189a8b4$var$Oe.source}M)?(?:${$68c609acd189a8b4$var$Oe.source}S)?`), $68c609acd189a8b4$var$Ye = new RegExp(`^([+-])?P${/(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)W)?(?:(\d+)D)?/.source}(?:T(?!$)${$68c609acd189a8b4$var$$e.source})?$`, "i"), $68c609acd189a8b4$var$Re = 864e5, $68c609acd189a8b4$var$Se = 1e6 * $68c609acd189a8b4$var$Re, $68c609acd189a8b4$var$je = 6e10, $68c609acd189a8b4$var$ke = 1e8 * $68c609acd189a8b4$var$Re, $68c609acd189a8b4$var$Ne = $68c609acd189a8b4$var$xo($68c609acd189a8b4$var$ke), $68c609acd189a8b4$var$xe = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).unaryMinus($68c609acd189a8b4$var$Ne), $68c609acd189a8b4$var$Le = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).add((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).subtract($68c609acd189a8b4$var$xe, $68c609acd189a8b4$var$l), $68c609acd189a8b4$var$n), $68c609acd189a8b4$var$Pe = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).subtract((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).add($68c609acd189a8b4$var$Ne, $68c609acd189a8b4$var$l), $68c609acd189a8b4$var$n), $68c609acd189a8b4$var$Ue = 146097 * $68c609acd189a8b4$var$Re, $68c609acd189a8b4$var$Be = -271821, $68c609acd189a8b4$var$Ze = 275760, $68c609acd189a8b4$var$Fe = Date.UTC(1847, 0, 1), $68c609acd189a8b4$var$He = [
    "iso8601",
    "hebrew",
    "islamic",
    "islamic-umalqura",
    "islamic-tbla",
    "islamic-civil",
    "islamic-rgsa",
    "islamicc",
    "persian",
    "ethiopic",
    "ethioaa",
    "ethiopic-amete-alem",
    "coptic",
    "chinese",
    "dangi",
    "roc",
    "indian",
    "buddhist",
    "japanese",
    "gregory"
], $68c609acd189a8b4$var$ze = new Set([
    "ACT",
    "AET",
    "AGT",
    "ART",
    "AST",
    "BET",
    "BST",
    "CAT",
    "CNT",
    "CST",
    "CTT",
    "EAT",
    "ECT",
    "IET",
    "IST",
    "JST",
    "MIT",
    "NET",
    "NST",
    "PLT",
    "PNT",
    "PRT",
    "PST",
    "SST",
    "VST"
]);
function $68c609acd189a8b4$var$Ae(e) {
    return "object" == typeof e && null !== e || "function" == typeof e;
}
function $68c609acd189a8b4$var$qe(e) {
    if ("bigint" == typeof e) throw new TypeError("Cannot convert BigInt to number");
    return Number(e);
}
function $68c609acd189a8b4$var$We(e) {
    if ("symbol" == typeof e) throw new TypeError("Cannot convert a Symbol value to a String");
    return String(e);
}
function $68c609acd189a8b4$var$_e(e) {
    const t = $68c609acd189a8b4$var$qe(e);
    if (0 === t) return 0;
    if (Number.isNaN(t) || t === 1 / 0 || t === -1 / 0) throw new RangeError("invalid number value");
    const n = Math.trunc(t);
    return 0 === n ? 0 : n;
}
function $68c609acd189a8b4$var$Je(e, t) {
    const n = $68c609acd189a8b4$var$_e(e);
    if (n <= 0) {
        if (void 0 !== t) throw new RangeError(`property '${t}' cannot be a a number less than one`);
        throw new RangeError("Cannot convert a number less than one to a positive integer");
    }
    return n;
}
function $68c609acd189a8b4$var$Ge(e) {
    const t = $68c609acd189a8b4$var$qe(e);
    if (Number.isNaN(t)) throw new RangeError("not a number");
    if (t === 1 / 0 || t === -1 / 0) throw new RangeError("infinity is out of range");
    if (!function(e) {
        if ("number" != typeof e || Number.isNaN(e) || e === 1 / 0 || e === -1 / 0) return !1;
        const t = Math.abs(e);
        return Math.floor(t) === t;
    }(t)) throw new RangeError(`unsupported fractional value ${e}`);
    return 0 === t ? 0 : t;
}
function $68c609acd189a8b4$var$Ke(e, t) {
    return String(e).padStart(t, "0");
}
function $68c609acd189a8b4$var$Ve(e) {
    if ("string" != typeof e) throw new TypeError(`expected a string, not ${String(e)}`);
    return e;
}
function $68c609acd189a8b4$var$Xe(e, t) {
    if ($68c609acd189a8b4$var$Ae(e)) {
        const t = e?.toString();
        if ("string" == typeof t || "number" == typeof t) return t;
        throw new TypeError("Cannot convert object to primitive value");
    }
    return e;
}
const $68c609acd189a8b4$var$Qe = [
    "era",
    "eraYear",
    "year",
    "month",
    "monthCode",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond",
    "microsecond",
    "nanosecond",
    "offset",
    "timeZone"
], $68c609acd189a8b4$var$et = {
    era: $68c609acd189a8b4$var$We,
    eraYear: $68c609acd189a8b4$var$_e,
    year: $68c609acd189a8b4$var$_e,
    month: $68c609acd189a8b4$var$Je,
    monthCode: function(e) {
        const t = $68c609acd189a8b4$var$Ve($68c609acd189a8b4$var$Xe(e));
        if (t.length < 3 || t.length > 4 || "M" !== t[0] || -1 === "0123456789".indexOf(t[1]) || -1 === "0123456789".indexOf(t[2]) || t[1] + t[2] === "00" && "L" !== t[3] || "L" !== t[3] && void 0 !== t[3]) throw new RangeError(`bad month code ${t}; must match M01-M99 or M00L-M99L`);
        return t;
    },
    day: $68c609acd189a8b4$var$Je,
    hour: $68c609acd189a8b4$var$_e,
    minute: $68c609acd189a8b4$var$_e,
    second: $68c609acd189a8b4$var$_e,
    millisecond: $68c609acd189a8b4$var$_e,
    microsecond: $68c609acd189a8b4$var$_e,
    nanosecond: $68c609acd189a8b4$var$_e,
    offset: function(e) {
        const t = $68c609acd189a8b4$var$Ve($68c609acd189a8b4$var$Xe(e));
        return $68c609acd189a8b4$var$sr(t), t;
    },
    timeZone: $68c609acd189a8b4$var$Bn
}, $68c609acd189a8b4$var$tt = {
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
    microsecond: 0,
    nanosecond: 0
}, $68c609acd189a8b4$var$nt = [
    [
        "years",
        "year",
        "date"
    ],
    [
        "months",
        "month",
        "date"
    ],
    [
        "weeks",
        "week",
        "date"
    ],
    [
        "days",
        "day",
        "date"
    ],
    [
        "hours",
        "hour",
        "time"
    ],
    [
        "minutes",
        "minute",
        "time"
    ],
    [
        "seconds",
        "second",
        "time"
    ],
    [
        "milliseconds",
        "millisecond",
        "time"
    ],
    [
        "microseconds",
        "microsecond",
        "time"
    ],
    [
        "nanoseconds",
        "nanosecond",
        "time"
    ]
], $68c609acd189a8b4$var$rt = Object.fromEntries($68c609acd189a8b4$var$nt.map((e)=>[
        e[0],
        e[1]
    ])), $68c609acd189a8b4$var$ot = Object.fromEntries($68c609acd189a8b4$var$nt.map(([e, t])=>[
        t,
        e
    ])), $68c609acd189a8b4$var$it = $68c609acd189a8b4$var$nt.map(([, e])=>e), $68c609acd189a8b4$var$at = {
    day: $68c609acd189a8b4$var$Se,
    hour: 36e11,
    minute: 6e10,
    second: 1e9,
    millisecond: 1e6,
    microsecond: 1e3,
    nanosecond: 1
}, $68c609acd189a8b4$var$st = [
    "days",
    "hours",
    "microseconds",
    "milliseconds",
    "minutes",
    "months",
    "nanoseconds",
    "seconds",
    "weeks",
    "years"
], $68c609acd189a8b4$var$ct = Intl.DateTimeFormat, $68c609acd189a8b4$var$dt = new Map;
function $68c609acd189a8b4$var$ht(e) {
    const t = $68c609acd189a8b4$var$Ao(e);
    let n = $68c609acd189a8b4$var$dt.get(t);
    return void 0 === n && (n = new $68c609acd189a8b4$var$ct("en-us", {
        timeZone: t,
        hour12: !1,
        era: "short",
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
    }), $68c609acd189a8b4$var$dt.set(t, n)), n;
}
function $68c609acd189a8b4$var$ut(e) {
    return $68c609acd189a8b4$var$ne(e, $68c609acd189a8b4$var$b) && !$68c609acd189a8b4$var$ne(e, $68c609acd189a8b4$var$$, $68c609acd189a8b4$var$E);
}
function $68c609acd189a8b4$var$lt(e) {
    return $68c609acd189a8b4$var$ne(e, $68c609acd189a8b4$var$Y, $68c609acd189a8b4$var$R, $68c609acd189a8b4$var$j, $68c609acd189a8b4$var$k, $68c609acd189a8b4$var$N, $68c609acd189a8b4$var$x, $68c609acd189a8b4$var$L, $68c609acd189a8b4$var$P, $68c609acd189a8b4$var$U);
}
function $68c609acd189a8b4$var$mt(e) {
    return $68c609acd189a8b4$var$ne(e, $68c609acd189a8b4$var$I);
}
function $68c609acd189a8b4$var$ft(e) {
    return $68c609acd189a8b4$var$ne(e, $68c609acd189a8b4$var$M);
}
function $68c609acd189a8b4$var$yt(e) {
    return $68c609acd189a8b4$var$ne(e, $68c609acd189a8b4$var$T);
}
function $68c609acd189a8b4$var$pt(e) {
    return $68c609acd189a8b4$var$ne(e, $68c609acd189a8b4$var$C);
}
function $68c609acd189a8b4$var$gt(e) {
    return $68c609acd189a8b4$var$ne(e, $68c609acd189a8b4$var$O);
}
function $68c609acd189a8b4$var$wt(e) {
    return $68c609acd189a8b4$var$ne(e, $68c609acd189a8b4$var$b, $68c609acd189a8b4$var$$, $68c609acd189a8b4$var$E);
}
function $68c609acd189a8b4$var$vt(e, t) {
    if (!t(e)) throw new TypeError("invalid receiver: method called with the wrong type of this-object");
}
function $68c609acd189a8b4$var$bt(e) {
    if ($68c609acd189a8b4$var$ne(e, $68c609acd189a8b4$var$E) || $68c609acd189a8b4$var$ne(e, $68c609acd189a8b4$var$$)) throw new TypeError("with() does not support a calendar or timeZone property");
    if ($68c609acd189a8b4$var$ft(e)) throw new TypeError("with() does not accept Temporal.PlainTime, use withPlainTime() instead");
    if (void 0 !== e.calendar) throw new TypeError("with() does not support a calendar property");
    if (void 0 !== e.timeZone) throw new TypeError("with() does not support a timeZone property");
}
function $68c609acd189a8b4$var$Dt(e, t) {
    return "never" === t || "auto" === t && "iso8601" === e ? "" : `[${"critical" === t ? "!" : ""}u-ca=${e}]`;
}
function $68c609acd189a8b4$var$Tt(e) {
    let t, n, r = !1;
    for($68c609acd189a8b4$var$Te.lastIndex = 0; n = $68c609acd189a8b4$var$Te.exec(e);){
        const { 1: o, 2: i, 3: a } = n;
        if ("u-ca" === i) {
            if (void 0 === t) t = a, r = "!" === o;
            else if ("!" === o || r) throw new RangeError(`Invalid annotations in ${e}: more than one u-ca present with critical flag`);
        } else if ("!" === o) throw new RangeError(`Unrecognized annotation: !${i}=${a}`);
    }
    return t;
}
function $68c609acd189a8b4$var$Mt(e) {
    const t = $68c609acd189a8b4$var$Me.exec(e);
    if (!t) throw new RangeError(`invalid RFC 9557 string: ${e}`);
    const n = $68c609acd189a8b4$var$Tt(t[16]);
    let r = t[1];
    if ("-000000" === r) throw new RangeError(`invalid RFC 9557 string: ${e}`);
    const o = +r, i = +(t[2] ?? t[4] ?? 1), a = +(t[3] ?? t[5] ?? 1), s = void 0 !== t[6], c = +(t[6] ?? 0), d = +(t[7] ?? t[10] ?? 0);
    let h = +(t[8] ?? t[11] ?? 0);
    60 === h && (h = 59);
    const u = (t[9] ?? t[12] ?? "") + "000000000", l = +u.slice(0, 3), m = +u.slice(3, 6), f = +u.slice(6, 9);
    let y, p = !1;
    t[13] ? (y = void 0, p = !0) : t[14] && (y = t[14]);
    const g = t[15];
    return $68c609acd189a8b4$var$Ur(o, i, a, c, d, h, l, m, f), {
        year: o,
        month: i,
        day: a,
        time: s ? {
            hour: c,
            minute: d,
            second: h,
            millisecond: l,
            microsecond: m,
            nanosecond: f
        } : "start-of-day",
        tzAnnotation: g,
        offset: y,
        z: p,
        calendar: n
    };
}
function $68c609acd189a8b4$var$Et(e) {
    const t = $68c609acd189a8b4$var$Ee.exec(e);
    let n, r, o, i, a, s, c;
    if (t) {
        c = $68c609acd189a8b4$var$Tt(t[10]), n = +(t[1] ?? 0), r = +(t[2] ?? t[5] ?? 0), o = +(t[3] ?? t[6] ?? 0), 60 === o && (o = 59);
        const e = (t[4] ?? t[7] ?? "") + "000000000";
        if (i = +e.slice(0, 3), a = +e.slice(3, 6), s = +e.slice(6, 9), t[8]) throw new RangeError("Z designator not supported for PlainTime");
    } else {
        let t, d;
        if ({ time: t, z: d, calendar: c } = $68c609acd189a8b4$var$Mt(e), "start-of-day" === t) throw new RangeError(`time is missing in string: ${e}`);
        if (d) throw new RangeError("Z designator not supported for PlainTime");
        ({ hour: n, minute: r, second: o, millisecond: i, microsecond: a, nanosecond: s } = t);
    }
    if ($68c609acd189a8b4$var$Pr(n, r, o, i, a, s), /[tT ][0-9][0-9]/.test(e)) return {
        hour: n,
        minute: r,
        second: o,
        millisecond: i,
        microsecond: a,
        nanosecond: s,
        calendar: c
    };
    try {
        const { month: t, day: n } = $68c609acd189a8b4$var$Ct(e);
        $68c609acd189a8b4$var$xr(1972, t, n);
    } catch  {
        try {
            const { year: t, month: n } = $68c609acd189a8b4$var$It(e);
            $68c609acd189a8b4$var$xr(t, n, 1);
        } catch  {
            return {
                hour: n,
                minute: r,
                second: o,
                millisecond: i,
                microsecond: a,
                nanosecond: s,
                calendar: c
            };
        }
    }
    throw new RangeError(`invalid RFC 9557 time-only string ${e}; may need a T prefix`);
}
function $68c609acd189a8b4$var$It(e) {
    const t = $68c609acd189a8b4$var$Ie.exec(e);
    let n, r, o, i;
    if (t) {
        o = $68c609acd189a8b4$var$Tt(t[3]);
        let a = t[1];
        if ("-000000" === a) throw new RangeError(`invalid RFC 9557 string: ${e}`);
        if (n = +a, r = +t[2], i = 1, void 0 !== o && "iso8601" !== o) throw new RangeError("YYYY-MM format is only valid with iso8601 calendar");
    } else {
        let t;
        if ({ year: n, month: r, calendar: o, day: i, z: t } = $68c609acd189a8b4$var$Mt(e), t) throw new RangeError("Z designator not supported for PlainYearMonth");
    }
    return {
        year: n,
        month: r,
        calendar: o,
        referenceISODay: i
    };
}
function $68c609acd189a8b4$var$Ct(e) {
    const t = $68c609acd189a8b4$var$Ce.exec(e);
    let n, r, o, i;
    if (t) {
        if (o = $68c609acd189a8b4$var$Tt(t[3]), n = +t[1], r = +t[2], void 0 !== o && "iso8601" !== o) throw new RangeError("MM-DD format is only valid with iso8601 calendar");
    } else {
        let t;
        if ({ month: n, day: r, calendar: o, year: i, z: t } = $68c609acd189a8b4$var$Mt(e), t) throw new RangeError("Z designator not supported for PlainMonthDay");
    }
    return {
        month: n,
        day: r,
        calendar: o,
        referenceISOYear: i
    };
}
const $68c609acd189a8b4$var$Ot = new RegExp(`^${$68c609acd189a8b4$var$fe.source}$`, "i"), $68c609acd189a8b4$var$$t = new RegExp(`^${/([+-])([01][0-9]|2[0-3])(?::?([0-5][0-9])?)?/.source}$`);
function $68c609acd189a8b4$var$Yt(e) {
    const t = $68c609acd189a8b4$var$Wo.test(e) ? "Seconds not allowed in offset time zone" : "Invalid time zone";
    throw new RangeError(`${t}: ${e}`);
}
function $68c609acd189a8b4$var$Rt(e) {
    return $68c609acd189a8b4$var$Ot.test(e) || $68c609acd189a8b4$var$Yt(e), $68c609acd189a8b4$var$$t.test(e) ? {
        offsetMinutes: $68c609acd189a8b4$var$sr(e) / 6e10
    } : {
        tzName: e
    };
}
function $68c609acd189a8b4$var$St(e, t, n, r) {
    let o = e, i = t, a = n;
    switch(r){
        case "reject":
            $68c609acd189a8b4$var$xr(o, i, a);
            break;
        case "constrain":
            ({ year: o, month: i, day: a } = $68c609acd189a8b4$var$kr(o, i, a));
    }
    return {
        year: o,
        month: i,
        day: a
    };
}
function $68c609acd189a8b4$var$jt(e, t, n, r, o, i, a) {
    let s = e, c = t, d = n, h = r, u = o, l = i;
    switch(a){
        case "reject":
            $68c609acd189a8b4$var$Pr(s, c, d, h, u, l);
            break;
        case "constrain":
            s = $68c609acd189a8b4$var$jr(s, 0, 23), c = $68c609acd189a8b4$var$jr(c, 0, 59), d = $68c609acd189a8b4$var$jr(d, 0, 59), h = $68c609acd189a8b4$var$jr(h, 0, 999), u = $68c609acd189a8b4$var$jr(u, 0, 999), l = $68c609acd189a8b4$var$jr(l, 0, 999);
    }
    return {
        hour: s,
        minute: c,
        second: d,
        millisecond: h,
        microsecond: u,
        nanosecond: l
    };
}
function $68c609acd189a8b4$var$kt(e) {
    if (!$68c609acd189a8b4$var$Ae(e)) throw new TypeError("invalid duration-like");
    const t = {
        years: void 0,
        months: void 0,
        weeks: void 0,
        days: void 0,
        hours: void 0,
        minutes: void 0,
        seconds: void 0,
        milliseconds: void 0,
        microseconds: void 0,
        nanoseconds: void 0
    };
    let n = !1;
    for(let r = 0; r < $68c609acd189a8b4$var$st.length; r++){
        const o = $68c609acd189a8b4$var$st[r], i = e[o];
        void 0 !== i && (n = !0, t[o] = $68c609acd189a8b4$var$Ge(i));
    }
    if (!n) throw new TypeError("invalid duration-like");
    return t;
}
function $68c609acd189a8b4$var$Nt({ years: e, months: t, weeks: n, days: r }, o, i, a) {
    return {
        years: e,
        months: a ?? t,
        weeks: i ?? n,
        days: o ?? r
    };
}
function $68c609acd189a8b4$var$xt(e, t) {
    return {
        isoDate: e,
        time: t
    };
}
function $68c609acd189a8b4$var$Lt(e) {
    return $68c609acd189a8b4$var$Ho(e, "overflow", [
        "constrain",
        "reject"
    ], "constrain");
}
function $68c609acd189a8b4$var$Pt(e) {
    return $68c609acd189a8b4$var$Ho(e, "disambiguation", [
        "compatible",
        "earlier",
        "later",
        "reject"
    ], "compatible");
}
function $68c609acd189a8b4$var$Ut(e, t) {
    return $68c609acd189a8b4$var$Ho(e, "roundingMode", [
        "ceil",
        "floor",
        "expand",
        "trunc",
        "halfCeil",
        "halfFloor",
        "halfExpand",
        "halfTrunc",
        "halfEven"
    ], t);
}
function $68c609acd189a8b4$var$Bt(e, t) {
    return $68c609acd189a8b4$var$Ho(e, "offset", [
        "prefer",
        "use",
        "ignore",
        "reject"
    ], t);
}
function $68c609acd189a8b4$var$Zt(e) {
    return $68c609acd189a8b4$var$Ho(e, "calendarName", [
        "auto",
        "always",
        "never",
        "critical"
    ], "auto");
}
function $68c609acd189a8b4$var$Ft(e) {
    let t = e.roundingIncrement;
    if (void 0 === t) return 1;
    const n = $68c609acd189a8b4$var$_e(t);
    if (n < 1 || n > 1e9) throw new RangeError(`roundingIncrement must be at least 1 and at most 1e9, not ${t}`);
    return n;
}
function $68c609acd189a8b4$var$Ht(e, t, n) {
    const r = n ? t : t - 1;
    if (e > r) throw new RangeError(`roundingIncrement must be at least 1 and less than ${r}, not ${e}`);
    if (t % e != 0) throw new RangeError(`Rounding increment must divide evenly into ${t}`);
}
function $68c609acd189a8b4$var$zt(e) {
    const t = e.fractionalSecondDigits;
    if (void 0 === t) return "auto";
    if ("number" != typeof t) {
        if ("auto" !== $68c609acd189a8b4$var$We(t)) throw new RangeError(`fractionalSecondDigits must be 'auto' or 0 through 9, not ${t}`);
        return "auto";
    }
    const n = Math.floor(t);
    if (!Number.isFinite(n) || n < 0 || n > 9) throw new RangeError(`fractionalSecondDigits must be 'auto' or 0 through 9, not ${t}`);
    return n;
}
function $68c609acd189a8b4$var$At(e, t) {
    switch(e){
        case "minute":
            return {
                precision: "minute",
                unit: "minute",
                increment: 1
            };
        case "second":
            return {
                precision: 0,
                unit: "second",
                increment: 1
            };
        case "millisecond":
            return {
                precision: 3,
                unit: "millisecond",
                increment: 1
            };
        case "microsecond":
            return {
                precision: 6,
                unit: "microsecond",
                increment: 1
            };
        case "nanosecond":
            return {
                precision: 9,
                unit: "nanosecond",
                increment: 1
            };
    }
    switch(t){
        case "auto":
            return {
                precision: t,
                unit: "nanosecond",
                increment: 1
            };
        case 0:
            return {
                precision: t,
                unit: "second",
                increment: 1
            };
        case 1:
        case 2:
        case 3:
            return {
                precision: t,
                unit: "millisecond",
                increment: 10 ** (3 - t)
            };
        case 4:
        case 5:
        case 6:
            return {
                precision: t,
                unit: "microsecond",
                increment: 10 ** (6 - t)
            };
        case 7:
        case 8:
        case 9:
            return {
                precision: t,
                unit: "nanosecond",
                increment: 10 ** (9 - t)
            };
        default:
            throw new RangeError(`fractionalSecondDigits must be 'auto' or 0 through 9, not ${t}`);
    }
}
const $68c609acd189a8b4$var$qt = Symbol("~required~");
function $68c609acd189a8b4$var$Wt(e, t, n, r, o = []) {
    let i = [];
    for(let e = 0; e < $68c609acd189a8b4$var$nt.length; e++){
        const t = $68c609acd189a8b4$var$nt[e], r = t[1], o = t[2];
        "datetime" !== n && n !== o || i.push(r);
    }
    i = i.concat(o);
    let a = r;
    a === $68c609acd189a8b4$var$qt ? a = void 0 : void 0 !== a && i.push(a);
    let s = [];
    s = s.concat(i);
    for(let e = 0; e < i.length; e++){
        const t = i[e], n = $68c609acd189a8b4$var$ot[t];
        void 0 !== n && s.push(n);
    }
    let c = $68c609acd189a8b4$var$Ho(e, t, s, a);
    if (void 0 === c && r === $68c609acd189a8b4$var$qt) throw new RangeError(`${t} is required`);
    return c && c in $68c609acd189a8b4$var$rt ? $68c609acd189a8b4$var$rt[c] : c;
}
function $68c609acd189a8b4$var$_t(e) {
    const t = e.relativeTo;
    if (void 0 === t) return {};
    let n, r, o, i, a, s = "option", c = !1;
    if ($68c609acd189a8b4$var$Ae(t)) {
        if ($68c609acd189a8b4$var$wt(t)) return {
            zonedRelativeTo: t
        };
        if ($68c609acd189a8b4$var$mt(t)) return {
            plainRelativeTo: t
        };
        if ($68c609acd189a8b4$var$yt(t)) return {
            plainRelativeTo: $68c609acd189a8b4$var$pn($68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$T).isoDate, $68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$E))
        };
        o = $68c609acd189a8b4$var$Nn(t);
        const e = $68c609acd189a8b4$var$tn(o, t, [
            "year",
            "month",
            "monthCode",
            "day"
        ], [
            "hour",
            "minute",
            "second",
            "millisecond",
            "microsecond",
            "nanosecond",
            "offset",
            "timeZone"
        ], []);
        ({ isoDate: n, time: r } = $68c609acd189a8b4$var$on(o, e, "constrain")), ({ offset: a, timeZone: i } = e), void 0 === a && (s = "wall");
    } else {
        let e, d, h, u, l;
        if ({ year: h, month: u, day: l, time: r, calendar: o, tzAnnotation: e, offset: a, z: d } = $68c609acd189a8b4$var$Mt($68c609acd189a8b4$var$Ve(t)), e) i = $68c609acd189a8b4$var$Bn(e), d ? s = "exact" : a || (s = "wall"), c = !0;
        else if (d) throw new RangeError("Z designator not supported for PlainDate relativeTo; either remove the Z or add a bracketed time zone");
        o || (o = "iso8601"), o = $68c609acd189a8b4$var$zo(o), n = {
            year: h,
            month: u,
            day: l
        };
    }
    return void 0 === i ? {
        plainRelativeTo: $68c609acd189a8b4$var$pn(n, o)
    } : {
        zonedRelativeTo: $68c609acd189a8b4$var$$n($68c609acd189a8b4$var$mn(n, r, s, "option" === s ? $68c609acd189a8b4$var$sr(a) : 0, i, "compatible", "reject", c), i, o)
    };
}
function $68c609acd189a8b4$var$Jt(e) {
    return 0 !== $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$Y) ? "year" : 0 !== $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$R) ? "month" : 0 !== $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$S) ? "week" : 0 !== $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$j) ? "day" : 0 !== $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$k) ? "hour" : 0 !== $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$N) ? "minute" : 0 !== $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$x) ? "second" : 0 !== $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$L) ? "millisecond" : 0 !== $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$P) ? "microsecond" : "nanosecond";
}
function $68c609acd189a8b4$var$Gt(e, t) {
    return $68c609acd189a8b4$var$it.indexOf(e) > $68c609acd189a8b4$var$it.indexOf(t) ? t : e;
}
function $68c609acd189a8b4$var$Kt(e) {
    return "year" === e || "month" === e || "week" === e;
}
function $68c609acd189a8b4$var$Vt(e) {
    return $68c609acd189a8b4$var$Kt(e) || "day" === e ? "date" : "time";
}
function $68c609acd189a8b4$var$Xt(e) {
    return $68c609acd189a8b4$var$ce("%calendarImpl%")(e);
}
function $68c609acd189a8b4$var$Qt(e) {
    return $68c609acd189a8b4$var$ce("%calendarImpl%")($68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$E));
}
function $68c609acd189a8b4$var$en(e, t, n = "date") {
    const r = Object.create(null), o = $68c609acd189a8b4$var$Xt(e).isoToDate(t, {
        year: !0,
        monthCode: !0,
        day: !0
    });
    return r.monthCode = o.monthCode, "month-day" !== n && "date" !== n || (r.day = o.day), "year-month" !== n && "date" !== n || (r.year = o.year), r;
}
function $68c609acd189a8b4$var$tn(e, t, n, r, o) {
    const i = $68c609acd189a8b4$var$Xt(e).extraFields(n), a = n.concat(r, i), s = Object.create(null);
    let c = !1;
    a.sort();
    for(let e = 0; e < a.length; e++){
        const n = a[e], r = t[n];
        if (void 0 !== r) c = !0, s[n] = (0, $68c609acd189a8b4$var$et[n])(r);
        else if ("partial" !== o) {
            if (o.includes(n)) throw new TypeError(`required property '${n}' missing or undefined`);
            s[n] = $68c609acd189a8b4$var$tt[n];
        }
    }
    if ("partial" === o && !c) throw new TypeError("no supported properties found");
    return s;
}
function $68c609acd189a8b4$var$nn(e, t = "complete") {
    const n = [
        "hour",
        "microsecond",
        "millisecond",
        "minute",
        "nanosecond",
        "second"
    ];
    let r = !1;
    const o = Object.create(null);
    for(let i = 0; i < n.length; i++){
        const a = n[i], s = e[a];
        void 0 !== s ? (o[a] = $68c609acd189a8b4$var$_e(s), r = !0) : "complete" === t && (o[a] = 0);
    }
    if (!r) throw new TypeError("invalid time-like");
    return o;
}
function $68c609acd189a8b4$var$rn(e, t) {
    if ($68c609acd189a8b4$var$Ae(e)) {
        if ($68c609acd189a8b4$var$mt(e)) return $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(t)), $68c609acd189a8b4$var$pn($68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$D), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$E));
        if ($68c609acd189a8b4$var$wt(e)) {
            const n = $68c609acd189a8b4$var$zn($68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$$), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$b));
            return $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(t)), $68c609acd189a8b4$var$pn(n.isoDate, $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$E));
        }
        if ($68c609acd189a8b4$var$yt(e)) return $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(t)), $68c609acd189a8b4$var$pn($68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$T).isoDate, $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$E));
        const n = $68c609acd189a8b4$var$Nn(e);
        return $68c609acd189a8b4$var$pn($68c609acd189a8b4$var$Ln(n, $68c609acd189a8b4$var$tn(n, e, [
            "year",
            "month",
            "monthCode",
            "day"
        ], [], []), $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(t))), n);
    }
    let { year: n, month: r, day: o, calendar: i, z: a } = $68c609acd189a8b4$var$Mt($68c609acd189a8b4$var$Ve(e));
    if (a) throw new RangeError("Z designator not supported for PlainDate");
    return i || (i = "iso8601"), i = $68c609acd189a8b4$var$zo(i), $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(t)), $68c609acd189a8b4$var$pn({
        year: n,
        month: r,
        day: o
    }, i);
}
function $68c609acd189a8b4$var$on(e, t, n) {
    return $68c609acd189a8b4$var$xt($68c609acd189a8b4$var$Ln(e, t, n), $68c609acd189a8b4$var$jt(t.hour, t.minute, t.second, t.millisecond, t.microsecond, t.nanosecond, n));
}
function $68c609acd189a8b4$var$an(e, t) {
    let n, r, o;
    if ($68c609acd189a8b4$var$Ae(e)) {
        if ($68c609acd189a8b4$var$yt(e)) return $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(t)), $68c609acd189a8b4$var$wn($68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$T), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$E));
        if ($68c609acd189a8b4$var$wt(e)) {
            const n = $68c609acd189a8b4$var$zn($68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$$), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$b));
            return $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(t)), $68c609acd189a8b4$var$wn(n, $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$E));
        }
        if ($68c609acd189a8b4$var$mt(e)) return $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(t)), $68c609acd189a8b4$var$wn($68c609acd189a8b4$var$xt($68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$D), {
            deltaDays: 0,
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
            microsecond: 0,
            nanosecond: 0
        }), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$E));
        o = $68c609acd189a8b4$var$Nn(e);
        const i = $68c609acd189a8b4$var$tn(o, e, [
            "year",
            "month",
            "monthCode",
            "day"
        ], [
            "hour",
            "minute",
            "second",
            "millisecond",
            "microsecond",
            "nanosecond"
        ], []), a = $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(t));
        ({ isoDate: n, time: r } = $68c609acd189a8b4$var$on(o, i, a));
    } else {
        let i, a, s, c;
        if ({ year: a, month: s, day: c, time: r, calendar: o, z: i } = $68c609acd189a8b4$var$Mt($68c609acd189a8b4$var$Ve(e)), i) throw new RangeError("Z designator not supported for PlainDateTime");
        "start-of-day" === r && (r = {
            deltaDays: 0,
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
            microsecond: 0,
            nanosecond: 0
        }), $68c609acd189a8b4$var$Ur(a, s, c, r.hour, r.minute, r.second, r.millisecond, r.microsecond, r.nanosecond), o || (o = "iso8601"), o = $68c609acd189a8b4$var$zo(o), $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(t)), n = {
            year: a,
            month: s,
            day: c
        };
    }
    return $68c609acd189a8b4$var$wn($68c609acd189a8b4$var$xt(n, r), o);
}
function $68c609acd189a8b4$var$sn(e) {
    const t = $68c609acd189a8b4$var$ce("%Temporal.Duration%");
    if ($68c609acd189a8b4$var$lt(e)) return new t($68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$Y), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$R), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$S), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$j), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$k), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$N), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$x), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$L), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$P), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$U));
    if (!$68c609acd189a8b4$var$Ae(e)) return function(e) {
        const { years: t, months: n, weeks: r, days: o, hours: i, minutes: a, seconds: s, milliseconds: c, microseconds: d, nanoseconds: h } = function(e) {
            const t = $68c609acd189a8b4$var$Ye.exec(e);
            if (!t) throw new RangeError(`invalid duration: ${e}`);
            if (t.every((e, t)=>t < 2 || void 0 === e)) throw new RangeError(`invalid duration: ${e}`);
            const n = "-" === t[1] ? -1 : 1, r = void 0 === t[2] ? 0 : $68c609acd189a8b4$var$_e(t[2]) * n, o = void 0 === t[3] ? 0 : $68c609acd189a8b4$var$_e(t[3]) * n, i = void 0 === t[4] ? 0 : $68c609acd189a8b4$var$_e(t[4]) * n, a = void 0 === t[5] ? 0 : $68c609acd189a8b4$var$_e(t[5]) * n, s = void 0 === t[6] ? 0 : $68c609acd189a8b4$var$_e(t[6]) * n, c = t[7], d = t[8], h = t[9], u = t[10], l = t[11];
            let m = 0, f = 0, y = 0;
            if (void 0 !== c) {
                if (d ?? h ?? u ?? l) throw new RangeError("only the smallest unit can be fractional");
                y = 3600 * $68c609acd189a8b4$var$_e((c + "000000000").slice(0, 9)) * n;
            } else if (m = void 0 === d ? 0 : $68c609acd189a8b4$var$_e(d) * n, void 0 !== h) {
                if (u ?? l) throw new RangeError("only the smallest unit can be fractional");
                y = 60 * $68c609acd189a8b4$var$_e((h + "000000000").slice(0, 9)) * n;
            } else f = void 0 === u ? 0 : $68c609acd189a8b4$var$_e(u) * n, void 0 !== l && (y = $68c609acd189a8b4$var$_e((l + "000000000").slice(0, 9)) * n);
            const p = y % 1e3, g = Math.trunc(y / 1e3) % 1e3, w = Math.trunc(y / 1e6) % 1e3;
            return f += Math.trunc(y / 1e9) % 60, m += Math.trunc(y / 6e10), $68c609acd189a8b4$var$zr(r, o, i, a, s, m, f, w, g, p), {
                years: r,
                months: o,
                weeks: i,
                days: a,
                hours: s,
                minutes: m,
                seconds: f,
                milliseconds: w,
                microseconds: g,
                nanoseconds: p
            };
        }(e);
        return new ($68c609acd189a8b4$var$ce("%Temporal.Duration%"))(t, n, r, o, i, a, s, c, d, h);
    }($68c609acd189a8b4$var$Ve(e));
    const n = {
        years: 0,
        months: 0,
        weeks: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
        microseconds: 0,
        nanoseconds: 0
    };
    let r = $68c609acd189a8b4$var$kt(e);
    for(let e = 0; e < $68c609acd189a8b4$var$st.length; e++){
        const t = $68c609acd189a8b4$var$st[e], o = r[t];
        void 0 !== o && (n[t] = o);
    }
    return new t(n.years, n.months, n.weeks, n.days, n.hours, n.minutes, n.seconds, n.milliseconds, n.microseconds, n.nanoseconds);
}
function $68c609acd189a8b4$var$cn(e) {
    let t;
    if ($68c609acd189a8b4$var$Ae(e)) {
        if ($68c609acd189a8b4$var$ut(e) || $68c609acd189a8b4$var$wt(e)) return $68c609acd189a8b4$var$Cn($68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$b));
        t = $68c609acd189a8b4$var$Xe(e);
    } else t = e;
    const { year: n, month: r, day: o, time: i, offset: a, z: s } = function(e) {
        const t = $68c609acd189a8b4$var$Mt(e);
        if (!t.z && !t.offset) throw new RangeError("Temporal.Instant requires a time zone offset");
        return t;
    }($68c609acd189a8b4$var$Ve(t)), { hour: c = 0, minute: d = 0, second: h = 0, millisecond: u = 0, microsecond: l = 0, nanosecond: m = 0 } = "start-of-day" === i ? {} : i, f = $68c609acd189a8b4$var$$r(n, r, o, c, d, h, u, l, m - (s ? 0 : $68c609acd189a8b4$var$sr(a)));
    return $68c609acd189a8b4$var$Kr(f.isoDate), $68c609acd189a8b4$var$Cn($68c609acd189a8b4$var$pr(f));
}
function $68c609acd189a8b4$var$dn(e, t) {
    if ($68c609acd189a8b4$var$Ae(e)) {
        if ($68c609acd189a8b4$var$gt(e)) return $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(t)), $68c609acd189a8b4$var$bn($68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$D), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$E));
        let n;
        return $68c609acd189a8b4$var$ne(e, $68c609acd189a8b4$var$E) ? n = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$E) : (n = e.calendar, void 0 === n && (n = "iso8601"), n = $68c609acd189a8b4$var$kn(n)), $68c609acd189a8b4$var$bn($68c609acd189a8b4$var$Un(n, $68c609acd189a8b4$var$tn(n, e, [
            "year",
            "month",
            "monthCode",
            "day"
        ], [], []), $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(t))), n);
    }
    let { month: n, day: r, referenceISOYear: o, calendar: i } = $68c609acd189a8b4$var$Ct($68c609acd189a8b4$var$Ve(e));
    if (void 0 === i && (i = "iso8601"), i = $68c609acd189a8b4$var$zo(i), $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(t)), "iso8601" === i) return $68c609acd189a8b4$var$bn({
        year: 1972,
        month: n,
        day: r
    }, i);
    let a = {
        year: o,
        month: n,
        day: r
    };
    return $68c609acd189a8b4$var$Lr(a), a = $68c609acd189a8b4$var$Un(i, $68c609acd189a8b4$var$en(i, a, "month-day"), "constrain"), $68c609acd189a8b4$var$bn(a, i);
}
function $68c609acd189a8b4$var$hn(e, t) {
    let n;
    if ($68c609acd189a8b4$var$Ae(e)) {
        if ($68c609acd189a8b4$var$ft(e)) return $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(t)), $68c609acd189a8b4$var$Tn($68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$M));
        if ($68c609acd189a8b4$var$yt(e)) return $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(t)), $68c609acd189a8b4$var$Tn($68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$T).time);
        if ($68c609acd189a8b4$var$wt(e)) {
            const n = $68c609acd189a8b4$var$zn($68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$$), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$b));
            return $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(t)), $68c609acd189a8b4$var$Tn(n.time);
        }
        const { hour: r, minute: o, second: i, millisecond: a, microsecond: s, nanosecond: c } = $68c609acd189a8b4$var$nn(e);
        n = $68c609acd189a8b4$var$jt(r, o, i, a, s, c, $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(t)));
    } else n = $68c609acd189a8b4$var$Et($68c609acd189a8b4$var$Ve(e)), $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(t));
    return $68c609acd189a8b4$var$Tn(n);
}
function $68c609acd189a8b4$var$un(e) {
    return void 0 === e ? {
        deltaDays: 0,
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
        microsecond: 0,
        nanosecond: 0
    } : $68c609acd189a8b4$var$re($68c609acd189a8b4$var$hn(e), $68c609acd189a8b4$var$M);
}
function $68c609acd189a8b4$var$ln(e, t) {
    if ($68c609acd189a8b4$var$Ae(e)) {
        if ($68c609acd189a8b4$var$pt(e)) return $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(t)), $68c609acd189a8b4$var$En($68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$D), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$E));
        const n = $68c609acd189a8b4$var$Nn(e);
        return $68c609acd189a8b4$var$En($68c609acd189a8b4$var$Pn(n, $68c609acd189a8b4$var$tn(n, e, [
            "year",
            "month",
            "monthCode"
        ], [], []), $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(t))), n);
    }
    let { year: n, month: r, referenceISODay: o, calendar: i } = $68c609acd189a8b4$var$It($68c609acd189a8b4$var$Ve(e));
    void 0 === i && (i = "iso8601"), i = $68c609acd189a8b4$var$zo(i), $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(t));
    let a = {
        year: n,
        month: r,
        day: o
    };
    return $68c609acd189a8b4$var$Hr(a), a = $68c609acd189a8b4$var$Pn(i, $68c609acd189a8b4$var$en(i, a, "year-month"), "constrain"), $68c609acd189a8b4$var$En(a, i);
}
function $68c609acd189a8b4$var$mn(t, n, r, o, i, a, s, c) {
    if ("start-of-day" === n) return $68c609acd189a8b4$var$_n(i, t);
    const d = $68c609acd189a8b4$var$xt(t, n);
    if ("wall" === r || "ignore" === s) return $68c609acd189a8b4$var$An(i, d, a);
    if ("exact" === r || "use" === s) {
        const e = $68c609acd189a8b4$var$$r(t.year, t.month, t.day, n.hour, n.minute, n.second, n.millisecond, n.microsecond, n.nanosecond - o);
        $68c609acd189a8b4$var$Kr(e.isoDate);
        const r = $68c609acd189a8b4$var$pr(e);
        return $68c609acd189a8b4$var$Fr(r), r;
    }
    $68c609acd189a8b4$var$Kr(t);
    const h = $68c609acd189a8b4$var$pr(d), u = $68c609acd189a8b4$var$Wn(i, d);
    for(let t = 0; t < u.length; t++){
        const n = u[t], r = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).toNumber((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).subtract(h, n)), i = $68c609acd189a8b4$var$Eo(r, 6e10, "halfExpand");
        if (r === o || c && i === o) return n;
    }
    if ("reject" === s) {
        const e = $68c609acd189a8b4$var$Hn(o), t = $68c609acd189a8b4$var$nr(d, "iso8601", "auto");
        throw new RangeError(`Offset ${e} is invalid for ${t} in ${i}`);
    }
    return $68c609acd189a8b4$var$qn(u, i, d, a);
}
function $68c609acd189a8b4$var$fn(e, t) {
    let n, r, o, i, a, s, c, d = !1, h = "option";
    if ($68c609acd189a8b4$var$Ae(e)) {
        if ($68c609acd189a8b4$var$wt(e)) {
            const n = $68c609acd189a8b4$var$Zo(t);
            return $68c609acd189a8b4$var$Pt(n), $68c609acd189a8b4$var$Bt(n, "reject"), $68c609acd189a8b4$var$Lt(n), $68c609acd189a8b4$var$$n($68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$b), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$$), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$E));
        }
        a = $68c609acd189a8b4$var$Nn(e);
        const d = $68c609acd189a8b4$var$tn(a, e, [
            "year",
            "month",
            "monthCode",
            "day"
        ], [
            "hour",
            "minute",
            "second",
            "millisecond",
            "microsecond",
            "nanosecond",
            "offset",
            "timeZone"
        ], [
            "timeZone"
        ]);
        ({ offset: i, timeZone: o } = d), void 0 === i && (h = "wall");
        const u = $68c609acd189a8b4$var$Zo(t);
        s = $68c609acd189a8b4$var$Pt(u), c = $68c609acd189a8b4$var$Bt(u, "reject");
        const l = $68c609acd189a8b4$var$Lt(u);
        ({ isoDate: n, time: r } = $68c609acd189a8b4$var$on(a, d, l));
    } else {
        let u, l, m, f, y;
        ({ year: m, month: f, day: y, time: r, tzAnnotation: u, offset: i, z: l, calendar: a } = function(e) {
            const t = $68c609acd189a8b4$var$Mt(e);
            if (!t.tzAnnotation) throw new RangeError("Temporal.ZonedDateTime requires a time zone ID in brackets");
            return t;
        }($68c609acd189a8b4$var$Ve(e))), o = $68c609acd189a8b4$var$Bn(u), l ? h = "exact" : i || (h = "wall"), a || (a = "iso8601"), a = $68c609acd189a8b4$var$zo(a), d = !0;
        const p = $68c609acd189a8b4$var$Zo(t);
        s = $68c609acd189a8b4$var$Pt(p), c = $68c609acd189a8b4$var$Bt(p, "reject"), $68c609acd189a8b4$var$Lt(p), n = {
            year: m,
            month: f,
            day: y
        };
    }
    let u = 0;
    return "option" === h && (u = $68c609acd189a8b4$var$sr(i)), $68c609acd189a8b4$var$$n($68c609acd189a8b4$var$mn(n, r, h, u, o, s, c, d), o, a);
}
function $68c609acd189a8b4$var$yn(e, t, n) {
    $68c609acd189a8b4$var$Lr(t), $68c609acd189a8b4$var$te(e), $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$D, t), $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$E, n), $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$I, !0);
}
function $68c609acd189a8b4$var$pn(e, t) {
    const n = $68c609acd189a8b4$var$ce("%Temporal.PlainDate%"), r = Object.create(n.prototype);
    return $68c609acd189a8b4$var$yn(r, e, t), r;
}
function $68c609acd189a8b4$var$gn(e, t, n) {
    $68c609acd189a8b4$var$Br(t), $68c609acd189a8b4$var$te(e), $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$T, t), $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$E, n);
}
function $68c609acd189a8b4$var$wn(e, t) {
    const n = $68c609acd189a8b4$var$ce("%Temporal.PlainDateTime%"), r = Object.create(n.prototype);
    return $68c609acd189a8b4$var$gn(r, e, t), r;
}
function $68c609acd189a8b4$var$vn(e, t, n) {
    $68c609acd189a8b4$var$Lr(t), $68c609acd189a8b4$var$te(e), $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$D, t), $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$E, n), $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$O, !0);
}
function $68c609acd189a8b4$var$bn(e, t) {
    const n = $68c609acd189a8b4$var$ce("%Temporal.PlainMonthDay%"), r = Object.create(n.prototype);
    return $68c609acd189a8b4$var$vn(r, e, t), r;
}
function $68c609acd189a8b4$var$Dn(e, t) {
    $68c609acd189a8b4$var$te(e), $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$M, t);
}
function $68c609acd189a8b4$var$Tn(e) {
    const t = $68c609acd189a8b4$var$ce("%Temporal.PlainTime%"), n = Object.create(t.prototype);
    return $68c609acd189a8b4$var$Dn(n, e), n;
}
function $68c609acd189a8b4$var$Mn(e, t, n) {
    $68c609acd189a8b4$var$Hr(t), $68c609acd189a8b4$var$te(e), $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$D, t), $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$E, n), $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$C, !0);
}
function $68c609acd189a8b4$var$En(e, t) {
    const n = $68c609acd189a8b4$var$ce("%Temporal.PlainYearMonth%"), r = Object.create(n.prototype);
    return $68c609acd189a8b4$var$Mn(r, e, t), r;
}
function $68c609acd189a8b4$var$In(e, t) {
    $68c609acd189a8b4$var$Fr(t), $68c609acd189a8b4$var$te(e), $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$b, t);
}
function $68c609acd189a8b4$var$Cn(e) {
    const t = $68c609acd189a8b4$var$ce("%Temporal.Instant%"), n = Object.create(t.prototype);
    return $68c609acd189a8b4$var$In(n, e), n;
}
function $68c609acd189a8b4$var$On(e, t, n, r) {
    $68c609acd189a8b4$var$Fr(t), $68c609acd189a8b4$var$te(e), $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$b, t), $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$$, n), $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$E, r);
}
function $68c609acd189a8b4$var$$n(e, t, n = "iso8601") {
    const r = $68c609acd189a8b4$var$ce("%Temporal.ZonedDateTime%"), o = Object.create(r.prototype);
    return $68c609acd189a8b4$var$On(o, e, t, n), o;
}
function $68c609acd189a8b4$var$Yn(e) {
    return $68c609acd189a8b4$var$Qe.filter((t)=>void 0 !== e[t]);
}
function $68c609acd189a8b4$var$Rn(e, t, n) {
    const r = $68c609acd189a8b4$var$Yn(n), o = $68c609acd189a8b4$var$Xt(e).fieldKeysToIgnore(r), i = Object.create(null), a = $68c609acd189a8b4$var$Yn(t);
    for(let e = 0; e < $68c609acd189a8b4$var$Qe.length; e++){
        let s;
        const c = $68c609acd189a8b4$var$Qe[e];
        a.includes(c) && !o.includes(c) && (s = t[c]), r.includes(c) && (s = n[c]), void 0 !== s && (i[c] = s);
    }
    return i;
}
function $68c609acd189a8b4$var$Sn(e, t, n, r) {
    const o = $68c609acd189a8b4$var$Xt(e).dateAdd(t, n, r);
    return $68c609acd189a8b4$var$Lr(o), o;
}
function $68c609acd189a8b4$var$jn(e, t, n, r) {
    return $68c609acd189a8b4$var$Xt(e).dateUntil(t, n, r);
}
function $68c609acd189a8b4$var$kn(e) {
    if ($68c609acd189a8b4$var$Ae(e) && $68c609acd189a8b4$var$ne(e, $68c609acd189a8b4$var$E)) return $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$E);
    const t = $68c609acd189a8b4$var$Ve(e);
    try {
        return $68c609acd189a8b4$var$zo(t);
    } catch  {}
    let n;
    try {
        ({ calendar: n } = $68c609acd189a8b4$var$Mt(t));
    } catch  {
        try {
            ({ calendar: n } = $68c609acd189a8b4$var$Et(t));
        } catch  {
            try {
                ({ calendar: n } = $68c609acd189a8b4$var$It(t));
            } catch  {
                ({ calendar: n } = $68c609acd189a8b4$var$Ct(t));
            }
        }
    }
    return n || (n = "iso8601"), $68c609acd189a8b4$var$zo(n);
}
function $68c609acd189a8b4$var$Nn(e) {
    if ($68c609acd189a8b4$var$ne(e, $68c609acd189a8b4$var$E)) return $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$E);
    const { calendar: t } = e;
    return void 0 === t ? "iso8601" : $68c609acd189a8b4$var$kn(t);
}
function $68c609acd189a8b4$var$xn(e, t) {
    return $68c609acd189a8b4$var$zo(e) === $68c609acd189a8b4$var$zo(t);
}
function $68c609acd189a8b4$var$Ln(e, t, n) {
    const r = $68c609acd189a8b4$var$Xt(e);
    r.resolveFields(t, "date");
    const o = r.dateToISO(t, n);
    return $68c609acd189a8b4$var$Lr(o), o;
}
function $68c609acd189a8b4$var$Pn(e, t, n) {
    const r = $68c609acd189a8b4$var$Xt(e);
    r.resolveFields(t, "year-month"), t.day = 1;
    const o = r.dateToISO(t, n);
    return $68c609acd189a8b4$var$Hr(o), o;
}
function $68c609acd189a8b4$var$Un(e, t, n) {
    const r = $68c609acd189a8b4$var$Xt(e);
    r.resolveFields(t, "month-day");
    const o = r.monthDayToISOReferenceDate(t, n);
    return $68c609acd189a8b4$var$Lr(o), o;
}
function $68c609acd189a8b4$var$Bn(e) {
    if ($68c609acd189a8b4$var$Ae(e) && $68c609acd189a8b4$var$wt(e)) return $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$$);
    const t = $68c609acd189a8b4$var$Ve(e);
    if ("UTC" === t) return "UTC";
    const { tzName: n, offsetMinutes: r } = function(e) {
        const { tzAnnotation: t, offset: n, z: r } = function(e) {
            if ($68c609acd189a8b4$var$Ot.test(e)) return {
                tzAnnotation: e,
                offset: void 0,
                z: !1
            };
            try {
                const { tzAnnotation: t, offset: n, z: r } = $68c609acd189a8b4$var$Mt(e);
                if (r || t || n) return {
                    tzAnnotation: t,
                    offset: n,
                    z: r
                };
            } catch  {}
            $68c609acd189a8b4$var$Yt(e);
        }(e);
        return t ? $68c609acd189a8b4$var$Rt(t) : r ? $68c609acd189a8b4$var$Rt("UTC") : n ? $68c609acd189a8b4$var$Rt(n) : void 0;
    }(t);
    if (void 0 !== r) return $68c609acd189a8b4$var$mr(r);
    const o = $68c609acd189a8b4$var$hr(n);
    if (!o) throw new RangeError(`Unrecognized time zone ${n}`);
    return o.identifier;
}
function $68c609acd189a8b4$var$Zn(e, t) {
    if (e === t) return !0;
    const n = $68c609acd189a8b4$var$Rt(e).offsetMinutes, r = $68c609acd189a8b4$var$Rt(t).offsetMinutes;
    if (void 0 === n && void 0 === r) {
        const n = $68c609acd189a8b4$var$hr(t);
        if (!n) return !1;
        const r = $68c609acd189a8b4$var$hr(e);
        return !!r && r.primaryIdentifier === n.primaryIdentifier;
    }
    return n === r;
}
function $68c609acd189a8b4$var$Fn(e, t) {
    const n = $68c609acd189a8b4$var$Rt(e).offsetMinutes;
    return void 0 !== n ? 6e10 * n : $68c609acd189a8b4$var$lr(e, t);
}
function $68c609acd189a8b4$var$Hn(e) {
    const t = e < 0 ? "-" : "+", n = Math.abs(e), r = Math.floor(n / 36e11), o = Math.floor(n / 6e10) % 60, i = Math.floor(n / 1e9) % 60, a = n % 1e9;
    return `${t}${$68c609acd189a8b4$var$Vn(r, o, i, a, 0 === i && 0 === a ? "minute" : "auto")}`;
}
function $68c609acd189a8b4$var$zn(e, t) {
    const n = $68c609acd189a8b4$var$Fn(e, t);
    let { isoDate: { year: r, month: o, day: i }, time: { hour: a, minute: s, second: c, millisecond: d, microsecond: h, nanosecond: u } } = $68c609acd189a8b4$var$gr(t);
    return $68c609acd189a8b4$var$$r(r, o, i, a, s, c, d, h, u + n);
}
function $68c609acd189a8b4$var$An(e, t, n) {
    return $68c609acd189a8b4$var$qn($68c609acd189a8b4$var$Wn(e, t), e, t, n);
}
function $68c609acd189a8b4$var$qn(t, n, r, o) {
    const i = t.length;
    if (1 === i) return t[0];
    if (i) switch(o){
        case "compatible":
        case "earlier":
            return t[0];
        case "later":
            return t[i - 1];
        case "reject":
            throw new RangeError("multiple instants found");
    }
    if ("reject" === o) throw new RangeError("multiple instants found");
    const a = $68c609acd189a8b4$var$pr(r), s = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).subtract(a, $68c609acd189a8b4$var$l);
    $68c609acd189a8b4$var$Fr(s);
    const c = $68c609acd189a8b4$var$Fn(n, s), d = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).add(a, $68c609acd189a8b4$var$l);
    $68c609acd189a8b4$var$Fr(d);
    const h = $68c609acd189a8b4$var$Fn(n, d) - c;
    switch(o){
        case "earlier":
            {
                const e = $68c609acd189a8b4$var$TimeDuration.fromComponents(0, 0, 0, 0, 0, -h), t = $68c609acd189a8b4$var$fo(r.time, e);
                return $68c609acd189a8b4$var$Wn(n, $68c609acd189a8b4$var$xt($68c609acd189a8b4$var$Or(r.isoDate.year, r.isoDate.month, r.isoDate.day + t.deltaDays), t))[0];
            }
        case "compatible":
        case "later":
            {
                const e = $68c609acd189a8b4$var$TimeDuration.fromComponents(0, 0, 0, 0, 0, h), t = $68c609acd189a8b4$var$fo(r.time, e), o = $68c609acd189a8b4$var$Wn(n, $68c609acd189a8b4$var$xt($68c609acd189a8b4$var$Or(r.isoDate.year, r.isoDate.month, r.isoDate.day + t.deltaDays), t));
                return o[o.length - 1];
            }
    }
}
function $68c609acd189a8b4$var$Wn(t, n) {
    if ("UTC" === t) return $68c609acd189a8b4$var$Kr(n.isoDate), [
        $68c609acd189a8b4$var$pr(n)
    ];
    const r = $68c609acd189a8b4$var$Rt(t).offsetMinutes;
    if (void 0 !== r) {
        const e = $68c609acd189a8b4$var$$r(n.isoDate.year, n.isoDate.month, n.isoDate.day, n.time.hour, n.time.minute - r, n.time.second, n.time.millisecond, n.time.microsecond, n.time.nanosecond);
        $68c609acd189a8b4$var$Kr(e.isoDate);
        const t = $68c609acd189a8b4$var$pr(e);
        return $68c609acd189a8b4$var$Fr(t), [
            t
        ];
    }
    return $68c609acd189a8b4$var$Kr(n.isoDate), function(t, n) {
        let r = $68c609acd189a8b4$var$pr(n), o = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).subtract(r, $68c609acd189a8b4$var$l);
        (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).lessThan(o, $68c609acd189a8b4$var$xe) && (o = r);
        let i = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).add(r, $68c609acd189a8b4$var$l);
        (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).greaterThan(i, $68c609acd189a8b4$var$Ne) && (i = r);
        const a = $68c609acd189a8b4$var$lr(t, o), s = $68c609acd189a8b4$var$lr(t, i), c = (a === s ? [
            a
        ] : [
            a,
            s
        ]).map((o)=>{
            const i = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).subtract(r, (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(o)), a = function(e, t) {
                const { epochMilliseconds: n, time: { millisecond: r, microsecond: o, nanosecond: i } } = $68c609acd189a8b4$var$gr(t), { year: a, month: s, day: c, hour: d, minute: h, second: u } = $68c609acd189a8b4$var$br(e, n);
                return $68c609acd189a8b4$var$$r(a, s, c, d, h, u, r, o, i);
            }(t, i);
            if (0 === $68c609acd189a8b4$var$jo(n, a)) return $68c609acd189a8b4$var$Fr(i), i;
        });
        return c.filter((e)=>void 0 !== e);
    }(t, n);
}
function $68c609acd189a8b4$var$_n(t, n) {
    const r = $68c609acd189a8b4$var$xt(n, {
        deltaDays: 0,
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
        microsecond: 0,
        nanosecond: 0
    }), o = $68c609acd189a8b4$var$Wn(t, r);
    if (o.length) return o[0];
    const i = $68c609acd189a8b4$var$pr(r), a = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).subtract(i, $68c609acd189a8b4$var$l);
    return $68c609acd189a8b4$var$Fr(a), $68c609acd189a8b4$var$wr(t, a);
}
function $68c609acd189a8b4$var$Jn(e) {
    let t;
    return t = e < 0 || e > 9999 ? (e < 0 ? "-" : "+") + $68c609acd189a8b4$var$Ke(Math.abs(e), 6) : $68c609acd189a8b4$var$Ke(e, 4), t;
}
function $68c609acd189a8b4$var$Gn(e) {
    return $68c609acd189a8b4$var$Ke(e, 2);
}
function $68c609acd189a8b4$var$Kn(e, t) {
    let n;
    if ("auto" === t) {
        if (0 === e) return "";
        n = $68c609acd189a8b4$var$Ke(e, 9).replace(/0+$/, "");
    } else {
        if (0 === t) return "";
        n = $68c609acd189a8b4$var$Ke(e, 9).slice(0, t);
    }
    return `.${n}`;
}
function $68c609acd189a8b4$var$Vn(e, t, n, r, o) {
    let i = `${$68c609acd189a8b4$var$Gn(e)}:${$68c609acd189a8b4$var$Gn(t)}`;
    return "minute" === o || (i += `:${$68c609acd189a8b4$var$Gn(n)}`, i += $68c609acd189a8b4$var$Kn(r, o)), i;
}
function $68c609acd189a8b4$var$Xn(e, t, n) {
    let r = t;
    void 0 === r && (r = "UTC");
    const o = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$b), i = $68c609acd189a8b4$var$nr($68c609acd189a8b4$var$zn(r, o), "iso8601", n, "never");
    let a = "Z";
    return void 0 !== t && (a = $68c609acd189a8b4$var$fr($68c609acd189a8b4$var$Fn(r, o))), `${i}${a}`;
}
function $68c609acd189a8b4$var$Qn(e, t) {
    const n = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$Y), r = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$R), o = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$S), i = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$j), a = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$k), s = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$N), c = $68c609acd189a8b4$var$Mr(e);
    let d = "";
    0 !== n && (d += `${Math.abs(n)}Y`), 0 !== r && (d += `${Math.abs(r)}M`), 0 !== o && (d += `${Math.abs(o)}W`), 0 !== i && (d += `${Math.abs(i)}D`);
    let h = "";
    0 !== a && (h += `${Math.abs(a)}H`), 0 !== s && (h += `${Math.abs(s)}M`);
    const u = $68c609acd189a8b4$var$TimeDuration.fromComponents(0, 0, $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$x), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$L), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$P), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$U));
    u.isZero() && ![
        "second",
        "millisecond",
        "microsecond",
        "nanosecond"
    ].includes($68c609acd189a8b4$var$Jt(e)) && "auto" === t || (h += `${Math.abs(u.sec)}${$68c609acd189a8b4$var$Kn(Math.abs(u.subsec), t)}S`);
    let l = `${c < 0 ? "-" : ""}P${d}`;
    return h && (l = `${l}T${h}`), l;
}
function $68c609acd189a8b4$var$er(e, t = "auto") {
    const { year: n, month: r, day: o } = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$D);
    return `${$68c609acd189a8b4$var$Jn(n)}-${$68c609acd189a8b4$var$Gn(r)}-${$68c609acd189a8b4$var$Gn(o)}${$68c609acd189a8b4$var$Dt($68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$E), t)}`;
}
function $68c609acd189a8b4$var$tr({ hour: e, minute: t, second: n, millisecond: r, microsecond: o, nanosecond: i }, a) {
    return $68c609acd189a8b4$var$Vn(e, t, n, 1e6 * r + 1e3 * o + i, a);
}
function $68c609acd189a8b4$var$nr(e, t, n, r = "auto") {
    const { isoDate: { year: o, month: i, day: a }, time: { hour: s, minute: c, second: d, millisecond: h, microsecond: u, nanosecond: l } } = e;
    return `${$68c609acd189a8b4$var$Jn(o)}-${$68c609acd189a8b4$var$Gn(i)}-${$68c609acd189a8b4$var$Gn(a)}T${$68c609acd189a8b4$var$Vn(s, c, d, 1e6 * h + 1e3 * u + l, n)}${$68c609acd189a8b4$var$Dt(t, r)}`;
}
function $68c609acd189a8b4$var$rr(e, t = "auto") {
    const { year: n, month: r, day: o } = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$D);
    let i = `${$68c609acd189a8b4$var$Gn(r)}-${$68c609acd189a8b4$var$Gn(o)}`;
    const a = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$E);
    "always" !== t && "critical" !== t && "iso8601" === a || (i = `${$68c609acd189a8b4$var$Jn(n)}-${i}`);
    const s = $68c609acd189a8b4$var$Dt(a, t);
    return s && (i += s), i;
}
function $68c609acd189a8b4$var$or(e, t = "auto") {
    const { year: n, month: r, day: o } = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$D);
    let i = `${$68c609acd189a8b4$var$Jn(n)}-${$68c609acd189a8b4$var$Gn(r)}`;
    const a = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$E);
    "always" !== t && "critical" !== t && "iso8601" === a || (i += `-${$68c609acd189a8b4$var$Gn(o)}`);
    const s = $68c609acd189a8b4$var$Dt(a, t);
    return s && (i += s), i;
}
function $68c609acd189a8b4$var$ir(e, t, n = "auto", r = "auto", o = "auto", i) {
    let a = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$b);
    if (i) {
        const { unit: e, increment: t, roundingMode: n } = i;
        a = $68c609acd189a8b4$var$Io(a, t, e, n);
    }
    const s = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$$), c = $68c609acd189a8b4$var$Fn(s, a);
    let d = $68c609acd189a8b4$var$nr($68c609acd189a8b4$var$zn(s, a), "iso8601", t, "never");
    return "never" !== o && (d += $68c609acd189a8b4$var$fr(c)), "never" !== r && (d += `[${"critical" === r ? "!" : ""}${s}]`), d += $68c609acd189a8b4$var$Dt($68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$E), n), d;
}
function $68c609acd189a8b4$var$ar(e) {
    return $68c609acd189a8b4$var$$t.test(e);
}
function $68c609acd189a8b4$var$sr(e) {
    const t = $68c609acd189a8b4$var$_o.exec(e);
    if (!t) throw new RangeError(`invalid time zone offset: ${e}; must match \xb1HH:MM[:SS.SSSSSSSSS]`);
    return ("-" === t[1] ? -1 : 1) * (1e9 * (60 * (60 * +t[2] + +(t[3] || 0)) + +(t[4] || 0)) + +((t[5] || 0) + "000000000").slice(0, 9));
}
let $68c609acd189a8b4$var$cr;
const $68c609acd189a8b4$var$dr = Object.assign(Object.create(null), {
    "/": !0,
    "-": !0,
    _: !0
});
function $68c609acd189a8b4$var$hr(e) {
    if (void 0 === $68c609acd189a8b4$var$cr) {
        const e = Intl.supportedValuesOf?.("timeZone");
        if (e) {
            $68c609acd189a8b4$var$cr = new Map;
            for(let t = 0; t < e.length; t++){
                const n = e[t];
                $68c609acd189a8b4$var$cr.set($68c609acd189a8b4$var$Ao(n), n);
            }
        } else $68c609acd189a8b4$var$cr = null;
    }
    const t = $68c609acd189a8b4$var$Ao(e);
    let n = $68c609acd189a8b4$var$cr?.get(t);
    if (n) return {
        identifier: n,
        primaryIdentifier: n
    };
    try {
        n = $68c609acd189a8b4$var$ht(e).resolvedOptions().timeZone;
    } catch  {
        return;
    }
    if ("antarctica/south_pole" === t && (n = "Antarctica/McMurdo"), $68c609acd189a8b4$var$ze.has(e)) throw new RangeError(`${e} is a legacy time zone identifier from ICU. Use ${n} instead`);
    const r = [
        ...t
    ].map((e, n)=>0 === n || $68c609acd189a8b4$var$dr[t[n - 1]] ? e.toUpperCase() : e).join("").split("/");
    if (1 === r.length) return "gb-eire" === t ? {
        identifier: "GB-Eire",
        primaryIdentifier: n
    } : {
        identifier: t.length <= 3 || /[-0-9]/.test(t) ? t.toUpperCase() : r[0],
        primaryIdentifier: n
    };
    if ("Etc" === r[0]) return {
        identifier: `Etc/${[
            "Zulu",
            "Greenwich",
            "Universal"
        ].includes(r[1]) ? r[1] : r[1].toUpperCase()}`,
        primaryIdentifier: n
    };
    if ("Us" === r[0]) return {
        identifier: `US/${r[1]}`,
        primaryIdentifier: n
    };
    const o = new Map([
        [
            "Act",
            "ACT"
        ],
        [
            "Lhi",
            "LHI"
        ],
        [
            "Nsw",
            "NSW"
        ],
        [
            "Dar_Es_Salaam",
            "Dar_es_Salaam"
        ],
        [
            "Port_Of_Spain",
            "Port_of_Spain"
        ],
        [
            "Port-Au-Prince",
            "Port-au-Prince"
        ],
        [
            "Isle_Of_Man",
            "Isle_of_Man"
        ],
        [
            "Comodrivadavia",
            "ComodRivadavia"
        ],
        [
            "Knox_In",
            "Knox_IN"
        ],
        [
            "Dumontdurville",
            "DumontDUrville"
        ],
        [
            "Mcmurdo",
            "McMurdo"
        ],
        [
            "Denoronha",
            "DeNoronha"
        ],
        [
            "Easterisland",
            "EasterIsland"
        ],
        [
            "Bajanorte",
            "BajaNorte"
        ],
        [
            "Bajasur",
            "BajaSur"
        ]
    ]);
    return r[1] = o.get(r[1]) ?? r[1], r.length > 2 && (r[2] = o.get(r[2]) ?? r[2]), {
        identifier: r.join("/"),
        primaryIdentifier: n
    };
}
function $68c609acd189a8b4$var$ur(e, t) {
    const { year: n, month: r, day: o, hour: i, minute: a, second: s } = $68c609acd189a8b4$var$br(e, t);
    let c = t % 1e3;
    return c < 0 && (c += 1e3), 1e6 * ($68c609acd189a8b4$var$yr({
        isoDate: {
            year: n,
            month: r,
            day: o
        },
        time: {
            hour: i,
            minute: a,
            second: s,
            millisecond: c
        }
    }) - t);
}
function $68c609acd189a8b4$var$lr(e, t) {
    return $68c609acd189a8b4$var$ur(e, $68c609acd189a8b4$var$No(t, "floor"));
}
function $68c609acd189a8b4$var$mr(e) {
    const t = e < 0 ? "-" : "+", n = Math.abs(e);
    return `${t}${$68c609acd189a8b4$var$Vn(Math.floor(n / 60), n % 60, 0, 0, "minute")}`;
}
function $68c609acd189a8b4$var$fr(e) {
    return $68c609acd189a8b4$var$mr($68c609acd189a8b4$var$Eo(e, $68c609acd189a8b4$var$je, "halfExpand") / 6e10);
}
function $68c609acd189a8b4$var$yr({ isoDate: { year: e, month: t, day: n }, time: { hour: r, minute: o, second: i, millisecond: a } }) {
    const s = e % 400, c = (e - s) / 400, d = new Date;
    return d.setUTCHours(r, o, i, a), d.setUTCFullYear(s, t - 1, n), d.getTime() + $68c609acd189a8b4$var$Ue * c;
}
function $68c609acd189a8b4$var$pr(t) {
    const n = $68c609acd189a8b4$var$yr(t), r = 1e3 * t.time.microsecond + t.time.nanosecond;
    return (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).add($68c609acd189a8b4$var$xo(n), (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(r));
}
function $68c609acd189a8b4$var$gr(t) {
    let n = $68c609acd189a8b4$var$No(t, "trunc"), r = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).toNumber((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).remainder(t, $68c609acd189a8b4$var$c));
    r < 0 && (r += 1e6, n -= 1);
    const o = Math.floor(r / 1e3) % 1e3, i = r % 1e3, a = new Date(n);
    return {
        epochMilliseconds: n,
        isoDate: {
            year: a.getUTCFullYear(),
            month: a.getUTCMonth() + 1,
            day: a.getUTCDate()
        },
        time: {
            hour: a.getUTCHours(),
            minute: a.getUTCMinutes(),
            second: a.getUTCSeconds(),
            millisecond: a.getUTCMilliseconds(),
            microsecond: o,
            nanosecond: i
        }
    };
}
function $68c609acd189a8b4$var$wr(e, t) {
    if ("UTC" === e) return null;
    const n = $68c609acd189a8b4$var$No(t, "floor");
    if (n < $68c609acd189a8b4$var$Fe) return $68c609acd189a8b4$var$wr(e, $68c609acd189a8b4$var$xo($68c609acd189a8b4$var$Fe));
    const r = Date.now(), o = Math.max(n, r) + 366 * $68c609acd189a8b4$var$Re * 3;
    let i = n, a = $68c609acd189a8b4$var$ur(e, i), s = i, c = a;
    for(; a === c && i < o;){
        if (s = i + 2 * $68c609acd189a8b4$var$Re * 7, s > $68c609acd189a8b4$var$ke) return null;
        c = $68c609acd189a8b4$var$ur(e, s), a === c && (i = s);
    }
    return a === c ? null : $68c609acd189a8b4$var$xo($68c609acd189a8b4$var$Jo((t)=>$68c609acd189a8b4$var$ur(e, t), i, s, a, c));
}
function $68c609acd189a8b4$var$vr(t, n) {
    if ("UTC" === t) return null;
    const r = $68c609acd189a8b4$var$No(n, "ceil"), o = Date.now(), i = o + 366 * $68c609acd189a8b4$var$Re * 3;
    if (r > i) {
        const n = $68c609acd189a8b4$var$vr(t, $68c609acd189a8b4$var$xo(i));
        if (null === n || (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).lessThan(n, $68c609acd189a8b4$var$xo(o))) return n;
    }
    if ("Africa/Casablanca" === t || "Africa/El_Aaiun" === t) {
        const e = Date.UTC(2088, 0, 1);
        if (e < r) return $68c609acd189a8b4$var$vr(t, $68c609acd189a8b4$var$xo(e));
    }
    let a = r - 1;
    if (a < $68c609acd189a8b4$var$Fe) return null;
    let s = $68c609acd189a8b4$var$ur(t, a), c = a, d = s;
    for(; s === d && a > $68c609acd189a8b4$var$Fe;){
        if (c = a - 2 * $68c609acd189a8b4$var$Re * 7, c < $68c609acd189a8b4$var$Fe) return null;
        d = $68c609acd189a8b4$var$ur(t, c), s === d && (a = c);
    }
    return s === d ? null : $68c609acd189a8b4$var$xo($68c609acd189a8b4$var$Jo((e)=>$68c609acd189a8b4$var$ur(t, e), c, a, d, s));
}
function $68c609acd189a8b4$var$br(e, t) {
    return function(e) {
        const t = e.split(/[^\w]+/);
        if (7 !== t.length) throw new RangeError(`expected 7 parts in "${e}`);
        const n = +t[0], r = +t[1];
        let o = +t[2];
        const i = t[3];
        if ("b" === i[0] || "B" === i[0]) o = 1 - o;
        else if ("a" !== i[0] && "A" !== i[0]) throw new RangeError(`Unknown era ${i} in "${e}`);
        const a = "24" === t[4] ? 0 : +t[4], s = +t[5], c = +t[6];
        if (!(Number.isFinite(o) && Number.isFinite(n) && Number.isFinite(r) && Number.isFinite(a) && Number.isFinite(s) && Number.isFinite(c))) throw new RangeError(`Invalid number in "${e}`);
        return {
            year: o,
            month: n,
            day: r,
            hour: a,
            minute: s,
            second: c
        };
    }($68c609acd189a8b4$var$ht(e).format(t));
}
function $68c609acd189a8b4$var$Dr(e) {
    return void 0 !== e && !(e % 4 != 0 || e % 100 == 0 && e % 400 != 0);
}
function $68c609acd189a8b4$var$Tr(e, t) {
    return ({
        standard: [
            31,
            28,
            31,
            30,
            31,
            30,
            31,
            31,
            30,
            31,
            30,
            31
        ],
        leapyear: [
            31,
            29,
            31,
            30,
            31,
            30,
            31,
            31,
            30,
            31,
            30,
            31
        ]
    })[$68c609acd189a8b4$var$Dr(e) ? "leapyear" : "standard"][t - 1];
}
function $68c609acd189a8b4$var$Mr(e) {
    const t = [
        $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$Y),
        $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$R),
        $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$S),
        $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$j),
        $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$k),
        $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$N),
        $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$x),
        $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$L),
        $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$P),
        $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$U)
    ];
    for(let e = 0; e < t.length; e++){
        const n = t[e];
        if (0 !== n) return n < 0 ? -1 : 1;
    }
    return 0;
}
function $68c609acd189a8b4$var$Er(e) {
    const t = [
        "years",
        "months",
        "weeks",
        "days"
    ];
    for(let n = 0; n < t.length; n++){
        const r = e[t[n]];
        if (0 !== r) return r < 0 ? -1 : 1;
    }
    return 0;
}
function $68c609acd189a8b4$var$Ir(e) {
    const t = $68c609acd189a8b4$var$Er(e.date);
    return 0 !== t ? t : e.time.sign();
}
function $68c609acd189a8b4$var$Cr(e, t) {
    let n = e, r = t;
    if (!Number.isFinite(n) || !Number.isFinite(r)) throw new RangeError("infinity is out of range");
    return r -= 1, n += Math.floor(r / 12), r %= 12, r < 0 && (r += 12), r += 1, {
        year: n,
        month: r
    };
}
function $68c609acd189a8b4$var$Or(e, t, n) {
    let r = e, o = t, i = n;
    if (!Number.isFinite(i)) throw new RangeError("infinity is out of range");
    ({ year: r, month: o } = $68c609acd189a8b4$var$Cr(r, o));
    const a = 146097;
    if (Math.abs(i) > a) {
        const e = Math.trunc(i / a);
        r += 400 * e, i -= e * a;
    }
    let s = 0, c = o > 2 ? r : r - 1;
    for(; s = $68c609acd189a8b4$var$Dr(c) ? 366 : 365, i < -s;)r -= 1, c -= 1, i += s;
    for(c += 1; s = $68c609acd189a8b4$var$Dr(c) ? 366 : 365, i > s;)r += 1, c += 1, i -= s;
    for(; i < 1;)({ year: r, month: o } = $68c609acd189a8b4$var$Cr(r, o - 1)), i += $68c609acd189a8b4$var$Tr(r, o);
    for(; i > $68c609acd189a8b4$var$Tr(r, o);)i -= $68c609acd189a8b4$var$Tr(r, o), { year: r, month: o } = $68c609acd189a8b4$var$Cr(r, o + 1);
    return {
        year: r,
        month: o,
        day: i
    };
}
function $68c609acd189a8b4$var$$r(e, t, n, r, o, i, a, s, c) {
    const d = $68c609acd189a8b4$var$Yr(r, o, i, a, s, c);
    return $68c609acd189a8b4$var$xt($68c609acd189a8b4$var$Or(e, t, n + d.deltaDays), d);
}
function $68c609acd189a8b4$var$Yr(e, t, n, r, o, i) {
    let a, s = e, c = t, d = n, h = r, u = o, l = i;
    ({ div: a, mod: l } = $68c609acd189a8b4$var$de(l, 3)), u += a, l < 0 && (u -= 1, l += 1e3), ({ div: a, mod: u } = $68c609acd189a8b4$var$de(u, 3)), h += a, u < 0 && (h -= 1, u += 1e3), d += Math.trunc(h / 1e3), h %= 1e3, h < 0 && (d -= 1, h += 1e3), c += Math.trunc(d / 60), d %= 60, d < 0 && (c -= 1, d += 60), s += Math.trunc(c / 60), c %= 60, c < 0 && (s -= 1, c += 60);
    let m = Math.trunc(s / 24);
    return s %= 24, s < 0 && (m -= 1, s += 24), m += 0, s += 0, c += 0, d += 0, h += 0, u += 0, l += 0, {
        deltaDays: m,
        hour: s,
        minute: c,
        second: d,
        millisecond: h,
        microsecond: u,
        nanosecond: l
    };
}
function $68c609acd189a8b4$var$Rr(e, t) {
    const n = $68c609acd189a8b4$var$Nt(e, 0);
    if (0 === $68c609acd189a8b4$var$Er(n)) return e.days;
    const r = $68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$D), o = $68c609acd189a8b4$var$Sn($68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$E), r, n, "constrain"), i = $68c609acd189a8b4$var$Gr(r.year, r.month - 1, r.day), a = $68c609acd189a8b4$var$Gr(o.year, o.month - 1, o.day) - i;
    return e.days + a;
}
function $68c609acd189a8b4$var$Sr(e) {
    return new ($68c609acd189a8b4$var$ce("%Temporal.Duration%"))(-$68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$Y), -$68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$R), -$68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$S), -$68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$j), -$68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$k), -$68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$N), -$68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$x), -$68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$L), -$68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$P), -$68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$U));
}
function $68c609acd189a8b4$var$jr(e, t, n) {
    return Math.min(n, Math.max(t, e));
}
function $68c609acd189a8b4$var$kr(e, t, n) {
    const r = $68c609acd189a8b4$var$jr(t, 1, 12);
    return {
        year: e,
        month: r,
        day: $68c609acd189a8b4$var$jr(n, 1, $68c609acd189a8b4$var$Tr(e, r))
    };
}
function $68c609acd189a8b4$var$Nr(e, t, n) {
    if (e < t || e > n) throw new RangeError(`value out of range: ${t} <= ${e} <= ${n}`);
}
function $68c609acd189a8b4$var$xr(e, t, n) {
    $68c609acd189a8b4$var$Nr(t, 1, 12), $68c609acd189a8b4$var$Nr(n, 1, $68c609acd189a8b4$var$Tr(e, t));
}
function $68c609acd189a8b4$var$Lr(e) {
    $68c609acd189a8b4$var$Br($68c609acd189a8b4$var$xt(e, {
        deltaDays: 0,
        hour: 12,
        minute: 0,
        second: 0,
        millisecond: 0,
        microsecond: 0,
        nanosecond: 0
    }));
}
function $68c609acd189a8b4$var$Pr(e, t, n, r, o, i) {
    $68c609acd189a8b4$var$Nr(e, 0, 23), $68c609acd189a8b4$var$Nr(t, 0, 59), $68c609acd189a8b4$var$Nr(n, 0, 59), $68c609acd189a8b4$var$Nr(r, 0, 999), $68c609acd189a8b4$var$Nr(o, 0, 999), $68c609acd189a8b4$var$Nr(i, 0, 999);
}
function $68c609acd189a8b4$var$Ur(e, t, n, r, o, i, a, s, c) {
    $68c609acd189a8b4$var$xr(e, t, n), $68c609acd189a8b4$var$Pr(r, o, i, a, s, c);
}
function $68c609acd189a8b4$var$Br(t) {
    const n = $68c609acd189a8b4$var$pr(t);
    ((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).lessThan(n, $68c609acd189a8b4$var$Le) || (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).greaterThan(n, $68c609acd189a8b4$var$Pe)) && $68c609acd189a8b4$var$Fr(n);
}
function $68c609acd189a8b4$var$Zr(e) {
    $68c609acd189a8b4$var$pr(e);
}
function $68c609acd189a8b4$var$Fr(t) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).lessThan(t, $68c609acd189a8b4$var$xe) || (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).greaterThan(t, $68c609acd189a8b4$var$Ne)) throw new RangeError("date/time value is outside of supported range");
}
function $68c609acd189a8b4$var$Hr({ year: e, month: t }) {
    $68c609acd189a8b4$var$Nr(e, $68c609acd189a8b4$var$Be, $68c609acd189a8b4$var$Ze), e === $68c609acd189a8b4$var$Be ? $68c609acd189a8b4$var$Nr(t, 4, 12) : e === $68c609acd189a8b4$var$Ze && $68c609acd189a8b4$var$Nr(t, 1, 9);
}
function $68c609acd189a8b4$var$zr(e, t, n, r, o, i, a, s, c, d) {
    let h = 0;
    const u = [
        e,
        t,
        n,
        r,
        o,
        i,
        a,
        s,
        c,
        d
    ];
    for(let e = 0; e < u.length; e++){
        const t = u[e];
        if (t === 1 / 0 || t === -1 / 0) throw new RangeError("infinite values not allowed as duration fields");
        if (0 !== t) {
            const e = t < 0 ? -1 : 1;
            if (0 !== h && e !== h) throw new RangeError("mixed-sign values not allowed as duration fields");
            h = e;
        }
    }
    if (Math.abs(e) >= 2 ** 32 || Math.abs(t) >= 2 ** 32 || Math.abs(n) >= 2 ** 32) throw new RangeError("years, months, and weeks must be < 2\xb3\xb2");
    const l = $68c609acd189a8b4$var$de(s, 3), m = $68c609acd189a8b4$var$de(c, 6), f = $68c609acd189a8b4$var$de(d, 9), y = $68c609acd189a8b4$var$de(1e6 * l.mod + 1e3 * m.mod + f.mod, 9).div, p = 86400 * r + 3600 * o + 60 * i + a + l.div + m.div + f.div + y;
    if (!Number.isSafeInteger(p)) throw new RangeError("total of duration time units cannot exceed 9007199254740991.999999999 s");
}
function $68c609acd189a8b4$var$Ar(e) {
    return {
        date: {
            years: $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$Y),
            months: $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$R),
            weeks: $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$S),
            days: $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$j)
        },
        time: $68c609acd189a8b4$var$TimeDuration.fromComponents($68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$k), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$N), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$x), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$L), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$P), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$U))
    };
}
function $68c609acd189a8b4$var$qr(e) {
    const t = $68c609acd189a8b4$var$TimeDuration.fromComponents($68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$k), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$N), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$x), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$L), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$P), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$U)).add24HourDays($68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$j));
    return {
        date: {
            years: $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$Y),
            months: $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$R),
            weeks: $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$S),
            days: 0
        },
        time: t
    };
}
function $68c609acd189a8b4$var$Wr(e) {
    const t = $68c609acd189a8b4$var$qr(e), n = Math.trunc(t.time.sec / 86400);
    return $68c609acd189a8b4$var$zr(t.date.years, t.date.months, t.date.weeks, n, 0, 0, 0, 0, 0, 0), {
        ...t.date,
        days: n
    };
}
function $68c609acd189a8b4$var$_r(e, t) {
    const n = e.time.sign();
    let r = e.time.abs().subsec, o = 0, i = 0, a = e.time.abs().sec, s = 0, c = 0, d = 0;
    switch(t){
        case "year":
        case "month":
        case "week":
        case "day":
            o = Math.trunc(r / 1e3), r %= 1e3, i = Math.trunc(o / 1e3), o %= 1e3, a += Math.trunc(i / 1e3), i %= 1e3, s = Math.trunc(a / 60), a %= 60, c = Math.trunc(s / 60), s %= 60, d = Math.trunc(c / 24), c %= 24;
            break;
        case "hour":
            o = Math.trunc(r / 1e3), r %= 1e3, i = Math.trunc(o / 1e3), o %= 1e3, a += Math.trunc(i / 1e3), i %= 1e3, s = Math.trunc(a / 60), a %= 60, c = Math.trunc(s / 60), s %= 60;
            break;
        case "minute":
            o = Math.trunc(r / 1e3), r %= 1e3, i = Math.trunc(o / 1e3), o %= 1e3, a += Math.trunc(i / 1e3), i %= 1e3, s = Math.trunc(a / 60), a %= 60;
            break;
        case "second":
            o = Math.trunc(r / 1e3), r %= 1e3, i = Math.trunc(o / 1e3), o %= 1e3, a += Math.trunc(i / 1e3), i %= 1e3;
            break;
        case "millisecond":
            o = Math.trunc(r / 1e3), r %= 1e3, i = $68c609acd189a8b4$var$he(a, 3, Math.trunc(o / 1e3)), o %= 1e3, a = 0;
            break;
        case "microsecond":
            o = $68c609acd189a8b4$var$he(a, 6, Math.trunc(r / 1e3)), r %= 1e3, a = 0;
            break;
        case "nanosecond":
            r = $68c609acd189a8b4$var$he(a, 9, r), a = 0;
    }
    return new ($68c609acd189a8b4$var$ce("%Temporal.Duration%"))(e.date.years, e.date.months, e.date.weeks, e.date.days + n * d, n * c, n * s, n * a, n * i, n * o, n * r);
}
function $68c609acd189a8b4$var$Jr(e, t) {
    return $68c609acd189a8b4$var$Er(e), t.sign(), {
        date: e,
        time: t
    };
}
function $68c609acd189a8b4$var$Gr(e, t, n) {
    return $68c609acd189a8b4$var$yr({
        isoDate: {
            year: e,
            month: t + 1,
            day: n
        },
        time: {
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0
        }
    }) / $68c609acd189a8b4$var$Re;
}
function $68c609acd189a8b4$var$Kr({ year: e, month: t, day: n }) {
    if (Math.abs($68c609acd189a8b4$var$Gr(e, t - 1, n)) > 1e8) throw new RangeError("date/time value is outside the supported range");
}
function $68c609acd189a8b4$var$Vr(e, t) {
    const n = t.hour - e.hour, r = t.minute - e.minute, o = t.second - e.second, i = t.millisecond - e.millisecond, a = t.microsecond - e.microsecond, s = t.nanosecond - e.nanosecond;
    return $68c609acd189a8b4$var$TimeDuration.fromComponents(n, r, o, i, a, s);
}
function $68c609acd189a8b4$var$Xr(e, t, n, r, o) {
    let i = $68c609acd189a8b4$var$TimeDuration.fromEpochNsDiff(t, e);
    return i = $68c609acd189a8b4$var$$o(i, n, r, o), $68c609acd189a8b4$var$Jr({
        years: 0,
        months: 0,
        weeks: 0,
        days: 0
    }, i);
}
function $68c609acd189a8b4$var$Qr(e, t, n, r) {
    $68c609acd189a8b4$var$Zr(e), $68c609acd189a8b4$var$Zr(t);
    let o = $68c609acd189a8b4$var$Vr(e.time, t.time);
    const i = o.sign(), a = $68c609acd189a8b4$var$Ro(e.isoDate, t.isoDate);
    let s = t.isoDate;
    a === i && (s = $68c609acd189a8b4$var$Or(s.year, s.month, s.day + i), o = o.add24HourDays(-i));
    const c = $68c609acd189a8b4$var$Gt("day", r), d = $68c609acd189a8b4$var$jn(n, e.isoDate, s, c);
    return r !== c && (o = o.add24HourDays(d.days), d.days = 0), $68c609acd189a8b4$var$Jr(d, o);
}
function $68c609acd189a8b4$var$eo(n, r, o, i, a) {
    const s = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).subtract(r, n);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).equal(s, $68c609acd189a8b4$var$t)) return {
        date: {
            years: 0,
            months: 0,
            weeks: 0,
            days: 0
        },
        time: $68c609acd189a8b4$var$TimeDuration.ZERO
    };
    const c = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).lessThan(s, $68c609acd189a8b4$var$t) ? -1 : 1, d = $68c609acd189a8b4$var$zn(o, n), h = $68c609acd189a8b4$var$zn(o, r);
    let u, l = 0, m = 1 === c ? 2 : 1, f = $68c609acd189a8b4$var$Vr(d.time, h.time);
    for(f.sign() === -c && l++; l <= m; l++){
        u = $68c609acd189a8b4$var$xt($68c609acd189a8b4$var$Or(h.isoDate.year, h.isoDate.month, h.isoDate.day - l * c), d.time);
        const e = $68c609acd189a8b4$var$An(o, u, "compatible");
        if (f = $68c609acd189a8b4$var$TimeDuration.fromEpochNsDiff(r, e), f.sign() !== -c) break;
    }
    const y = $68c609acd189a8b4$var$Gt("day", a);
    return $68c609acd189a8b4$var$Jr($68c609acd189a8b4$var$jn(i, d.isoDate, u.isoDate, y), f);
}
function $68c609acd189a8b4$var$to(t, n, r, o, i, a, s, c, d) {
    let h, u, l, m, f = n;
    switch(c){
        case "year":
            {
                const e = $68c609acd189a8b4$var$Eo(f.date.years, s, "trunc");
                h = e, u = e + s * t, l = {
                    years: h,
                    months: 0,
                    weeks: 0,
                    days: 0
                }, m = {
                    ...l,
                    years: u
                };
                break;
            }
        case "month":
            {
                const e = $68c609acd189a8b4$var$Eo(f.date.months, s, "trunc");
                h = e, u = e + s * t, l = $68c609acd189a8b4$var$Nt(f.date, 0, 0, h), m = $68c609acd189a8b4$var$Nt(f.date, 0, 0, u);
                break;
            }
        case "week":
            {
                const e = $68c609acd189a8b4$var$Nt(f.date, 0, 0), n = $68c609acd189a8b4$var$Sn(a, o.isoDate, e, "constrain"), r = $68c609acd189a8b4$var$jn(a, n, $68c609acd189a8b4$var$Or(n.year, n.month, n.day + f.date.days), "week"), i = $68c609acd189a8b4$var$Eo(f.date.weeks + r.weeks, s, "trunc");
                h = i, u = i + s * t, l = $68c609acd189a8b4$var$Nt(f.date, 0, h), m = $68c609acd189a8b4$var$Nt(f.date, 0, u);
                break;
            }
        case "day":
            {
                const e = $68c609acd189a8b4$var$Eo(f.date.days, s, "trunc");
                h = e, u = e + s * t, l = $68c609acd189a8b4$var$Nt(f.date, h), m = $68c609acd189a8b4$var$Nt(f.date, u);
                break;
            }
    }
    const y = $68c609acd189a8b4$var$Sn(a, o.isoDate, l, "constrain"), p = $68c609acd189a8b4$var$Sn(a, o.isoDate, m, "constrain");
    let g, w;
    const v = $68c609acd189a8b4$var$xt(y, o.time), b = $68c609acd189a8b4$var$xt(p, o.time);
    i ? (g = $68c609acd189a8b4$var$An(i, v, "compatible"), w = $68c609acd189a8b4$var$An(i, b, "compatible")) : (g = $68c609acd189a8b4$var$pr(v), w = $68c609acd189a8b4$var$pr(b));
    const D = $68c609acd189a8b4$var$TimeDuration.fromEpochNsDiff(r, g), T = $68c609acd189a8b4$var$TimeDuration.fromEpochNsDiff(w, g), M = $68c609acd189a8b4$var$ue(d, t < 0 ? "negative" : "positive"), E = D.add(D).abs().subtract(T.abs()).sign(), I = Math.abs(h) / s % 2 == 0, C = D.isZero() ? Math.abs(h) : D.cmp(T) ? $68c609acd189a8b4$var$le(Math.abs(h), Math.abs(u), E, I, M) : Math.abs(u), O = new $68c609acd189a8b4$var$TimeDuration((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).add((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).multiply(T.totalNs, (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(h)), (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).multiply(D.totalNs, (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(s * t)))).fdiv(T.totalNs), $ = C === Math.abs(u);
    return f = {
        date: $ ? m : l,
        time: $68c609acd189a8b4$var$TimeDuration.ZERO
    }, {
        nudgeResult: {
            duration: f,
            nudgedEpochNs: $ ? w : g,
            didExpandCalendarUnit: $
        },
        total: O
    };
}
function $68c609acd189a8b4$var$no(t, n, r, o, i, a, s, c, d) {
    let h = t;
    const u = $68c609acd189a8b4$var$Kt(c) || o && "day" === c, l = $68c609acd189a8b4$var$Ir(h) < 0 ? -1 : 1;
    let m;
    return u ? { nudgeResult: m } = $68c609acd189a8b4$var$to(l, h, n, r, o, i, s, c, d) : m = o ? function(t, n, r, o, i, a, s, c) {
        let d = n;
        const h = $68c609acd189a8b4$var$Sn(i, r.isoDate, d.date, "constrain"), u = $68c609acd189a8b4$var$xt(h, r.time), l = $68c609acd189a8b4$var$xt($68c609acd189a8b4$var$Or(h.year, h.month, h.day + t), r.time), m = $68c609acd189a8b4$var$An(o, u, "compatible"), f = $68c609acd189a8b4$var$An(o, l, "compatible"), y = $68c609acd189a8b4$var$TimeDuration.fromEpochNsDiff(f, m);
        if (y.sign() !== t) throw new RangeError("time zone returned inconsistent Instants");
        const p = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt($68c609acd189a8b4$var$at[s] * a);
        let g = d.time.round(p, c);
        const w = g.subtract(y), v = w.sign() !== -t;
        let b, D;
        return v ? (b = t, g = w.round(p, c), D = g.addToEpochNs(f)) : (b = 0, D = g.addToEpochNs(m)), {
            duration: $68c609acd189a8b4$var$Jr($68c609acd189a8b4$var$Nt(d.date, d.date.days + b), g),
            nudgedEpochNs: D,
            didExpandCalendarUnit: v
        };
    }(l, h, r, o, i, s, c, d) : function(t, n, r, o, i, a) {
        let s = t;
        const c = s.time.add24HourDays(s.date.days), d = c.round((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(o * $68c609acd189a8b4$var$at[i]), a), h = d.subtract(c), { quotient: u } = c.divmod($68c609acd189a8b4$var$Se), { quotient: l } = d.divmod($68c609acd189a8b4$var$Se), m = Math.sign(l - u) === c.sign(), f = h.addToEpochNs(n);
        let y = 0, p = d;
        return "date" === $68c609acd189a8b4$var$Vt(r) && (y = l, p = d.add($68c609acd189a8b4$var$TimeDuration.fromComponents(24 * -l, 0, 0, 0, 0, 0))), {
            duration: {
                date: $68c609acd189a8b4$var$Nt(s.date, y),
                time: p
            },
            nudgedEpochNs: f,
            didExpandCalendarUnit: m
        };
    }(h, n, a, s, c, d), h = m.duration, m.didExpandCalendarUnit && "week" !== c && (h = function(e, t, n, r, o, i, a, s) {
        let c = t;
        if (s === a) return c;
        const d = $68c609acd189a8b4$var$it.indexOf(a);
        for(let t = $68c609acd189a8b4$var$it.indexOf(s) - 1; t >= d; t--){
            const s = $68c609acd189a8b4$var$it[t];
            if ("week" === s && "week" !== a) continue;
            let d;
            switch(s){
                case "year":
                    d = {
                        years: c.date.years + e,
                        months: 0,
                        weeks: 0,
                        days: 0
                    };
                    break;
                case "month":
                    {
                        const t = c.date.months + e;
                        d = $68c609acd189a8b4$var$Nt(c.date, 0, 0, t);
                        break;
                    }
                case "week":
                    {
                        const t = c.date.weeks + e;
                        d = $68c609acd189a8b4$var$Nt(c.date, 0, t);
                        break;
                    }
            }
            const h = $68c609acd189a8b4$var$xt($68c609acd189a8b4$var$Sn(i, r.isoDate, d, "constrain"), r.time);
            let u;
            if (u = o ? $68c609acd189a8b4$var$An(o, h, "compatible") : $68c609acd189a8b4$var$pr(h), $68c609acd189a8b4$var$p(n, u) === -e) break;
            c = {
                date: d,
                time: $68c609acd189a8b4$var$TimeDuration.ZERO
            };
        }
        return c;
    }(l, h, m.nudgedEpochNs, r, o, i, a, $68c609acd189a8b4$var$Gt(c, "day"))), h;
}
function $68c609acd189a8b4$var$ro(e, t, n, r, o, i) {
    return $68c609acd189a8b4$var$Kt(i) || r && "day" === i ? $68c609acd189a8b4$var$to($68c609acd189a8b4$var$Ir(e) < 0 ? -1 : 1, e, t, n, r, o, 1, i, "trunc").total : $68c609acd189a8b4$var$Yo(e.time.add24HourDays(e.date.days), i);
}
function $68c609acd189a8b4$var$oo(e, t, n, r, o, i, a) {
    if (0 == $68c609acd189a8b4$var$jo(e, t)) return {
        date: {
            years: 0,
            months: 0,
            weeks: 0,
            days: 0
        },
        time: $68c609acd189a8b4$var$TimeDuration.ZERO
    };
    $68c609acd189a8b4$var$Br(e), $68c609acd189a8b4$var$Br(t);
    const s = $68c609acd189a8b4$var$Qr(e, t, n, r);
    return "nanosecond" === i && 1 === o ? s : $68c609acd189a8b4$var$no(s, $68c609acd189a8b4$var$pr(t), e, null, n, r, o, i, a);
}
function $68c609acd189a8b4$var$io(e, t, n, r, o, i, a, s) {
    if ("time" === $68c609acd189a8b4$var$Vt(o)) return $68c609acd189a8b4$var$Xr(e, t, i, a, s);
    const c = $68c609acd189a8b4$var$eo(e, t, n, r, o);
    return "nanosecond" === a && 1 === i ? c : $68c609acd189a8b4$var$no(c, t, $68c609acd189a8b4$var$zn(n, e), n, r, o, i, a, s);
}
function $68c609acd189a8b4$var$ao(e, t, n, r, o, i) {
    const a = $68c609acd189a8b4$var$nt.reduce((e, t)=>{
        const o = t[0], i = t[1], a = t[2];
        return "datetime" !== n && a !== n || r.includes(i) || e.push(i, o), e;
    }, []);
    let s = $68c609acd189a8b4$var$Wt(t, "largestUnit", n, "auto");
    if (r.includes(s)) throw new RangeError(`largestUnit must be one of ${a.join(", ")}, not ${s}`);
    const c = $68c609acd189a8b4$var$Ft(t);
    let d = $68c609acd189a8b4$var$Ut(t, "trunc");
    "since" === e && (d = function(e) {
        switch(e){
            case "ceil":
                return "floor";
            case "floor":
                return "ceil";
            case "halfCeil":
                return "halfFloor";
            case "halfFloor":
                return "halfCeil";
            default:
                return e;
        }
    }(d));
    const h = $68c609acd189a8b4$var$Wt(t, "smallestUnit", n, o);
    if (r.includes(h)) throw new RangeError(`smallestUnit must be one of ${a.join(", ")}, not ${h}`);
    const u = $68c609acd189a8b4$var$Gt(i, h);
    if ("auto" === s && (s = u), $68c609acd189a8b4$var$Gt(s, h) !== s) throw new RangeError(`largestUnit ${s} cannot be smaller than smallestUnit ${h}`);
    const l = {
        hour: 24,
        minute: 60,
        second: 60,
        millisecond: 1e3,
        microsecond: 1e3,
        nanosecond: 1e3
    }[h];
    return void 0 !== l && $68c609acd189a8b4$var$Ht(c, l, !1), {
        largestUnit: s,
        roundingIncrement: c,
        roundingMode: d,
        smallestUnit: h
    };
}
function $68c609acd189a8b4$var$so(e, t, n, r) {
    const o = $68c609acd189a8b4$var$cn(n), i = $68c609acd189a8b4$var$ao(e, $68c609acd189a8b4$var$Zo(r), "time", [], "nanosecond", "second");
    let a = $68c609acd189a8b4$var$_r($68c609acd189a8b4$var$Xr($68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$b), $68c609acd189a8b4$var$re(o, $68c609acd189a8b4$var$b), i.roundingIncrement, i.smallestUnit, i.roundingMode), i.largestUnit);
    return "since" === e && (a = $68c609acd189a8b4$var$Sr(a)), a;
}
function $68c609acd189a8b4$var$co(e, t, n, r) {
    const o = $68c609acd189a8b4$var$rn(n), i = $68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$E), a = $68c609acd189a8b4$var$re(o, $68c609acd189a8b4$var$E);
    if (!$68c609acd189a8b4$var$xn(i, a)) throw new RangeError(`cannot compute difference between dates of ${i} and ${a} calendars`);
    const s = $68c609acd189a8b4$var$ao(e, $68c609acd189a8b4$var$Zo(r), "date", [], "day", "day"), c = $68c609acd189a8b4$var$ce("%Temporal.Duration%"), d = $68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$D), h = $68c609acd189a8b4$var$re(o, $68c609acd189a8b4$var$D);
    if (0 === $68c609acd189a8b4$var$Ro(d, h)) return new c;
    let u = {
        date: $68c609acd189a8b4$var$jn(i, d, h, s.largestUnit),
        time: $68c609acd189a8b4$var$TimeDuration.ZERO
    };
    if ("day" !== s.smallestUnit || 1 !== s.roundingIncrement) {
        const e = $68c609acd189a8b4$var$xt(d, {
            deltaDays: 0,
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
            microsecond: 0,
            nanosecond: 0
        });
        u = $68c609acd189a8b4$var$no(u, $68c609acd189a8b4$var$pr($68c609acd189a8b4$var$xt(h, {
            deltaDays: 0,
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
            microsecond: 0,
            nanosecond: 0
        })), e, null, i, s.largestUnit, s.roundingIncrement, s.smallestUnit, s.roundingMode);
    }
    let l = $68c609acd189a8b4$var$_r(u, "day");
    return "since" === e && (l = $68c609acd189a8b4$var$Sr(l)), l;
}
function $68c609acd189a8b4$var$ho(e, t, n, r) {
    const o = $68c609acd189a8b4$var$an(n), i = $68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$E), a = $68c609acd189a8b4$var$re(o, $68c609acd189a8b4$var$E);
    if (!$68c609acd189a8b4$var$xn(i, a)) throw new RangeError(`cannot compute difference between dates of ${i} and ${a} calendars`);
    const s = $68c609acd189a8b4$var$ao(e, $68c609acd189a8b4$var$Zo(r), "datetime", [], "nanosecond", "day"), c = $68c609acd189a8b4$var$ce("%Temporal.Duration%"), d = $68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$T), h = $68c609acd189a8b4$var$re(o, $68c609acd189a8b4$var$T);
    if (0 === $68c609acd189a8b4$var$jo(d, h)) return new c;
    let u = $68c609acd189a8b4$var$_r($68c609acd189a8b4$var$oo(d, h, i, s.largestUnit, s.roundingIncrement, s.smallestUnit, s.roundingMode), s.largestUnit);
    return "since" === e && (u = $68c609acd189a8b4$var$Sr(u)), u;
}
function $68c609acd189a8b4$var$uo(e, t, n, r) {
    const o = $68c609acd189a8b4$var$hn(n), i = $68c609acd189a8b4$var$ao(e, $68c609acd189a8b4$var$Zo(r), "time", [], "nanosecond", "hour");
    let a = $68c609acd189a8b4$var$Vr($68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$M), $68c609acd189a8b4$var$re(o, $68c609acd189a8b4$var$M));
    a = $68c609acd189a8b4$var$$o(a, i.roundingIncrement, i.smallestUnit, i.roundingMode);
    let s = $68c609acd189a8b4$var$_r($68c609acd189a8b4$var$Jr({
        years: 0,
        months: 0,
        weeks: 0,
        days: 0
    }, a), i.largestUnit);
    return "since" === e && (s = $68c609acd189a8b4$var$Sr(s)), s;
}
function $68c609acd189a8b4$var$lo(e, t, n, r) {
    const o = $68c609acd189a8b4$var$ln(n), i = $68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$E), a = $68c609acd189a8b4$var$re(o, $68c609acd189a8b4$var$E);
    if (!$68c609acd189a8b4$var$xn(i, a)) throw new RangeError(`cannot compute difference between months of ${i} and ${a} calendars`);
    const s = $68c609acd189a8b4$var$ao(e, $68c609acd189a8b4$var$Zo(r), "date", [
        "week",
        "day"
    ], "month", "year"), c = $68c609acd189a8b4$var$ce("%Temporal.Duration%");
    if (0 == $68c609acd189a8b4$var$Ro($68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$D), $68c609acd189a8b4$var$re(o, $68c609acd189a8b4$var$D))) return new c;
    const d = $68c609acd189a8b4$var$en(i, $68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$D), "year-month");
    d.day = 1;
    const h = $68c609acd189a8b4$var$Ln(i, d, "constrain"), u = $68c609acd189a8b4$var$en(i, $68c609acd189a8b4$var$re(o, $68c609acd189a8b4$var$D), "year-month");
    u.day = 1;
    const l = $68c609acd189a8b4$var$Ln(i, u, "constrain");
    let m = {
        date: $68c609acd189a8b4$var$Nt($68c609acd189a8b4$var$jn(i, h, l, s.largestUnit), 0, 0),
        time: $68c609acd189a8b4$var$TimeDuration.ZERO
    };
    if ("month" !== s.smallestUnit || 1 !== s.roundingIncrement) {
        const e = $68c609acd189a8b4$var$xt(h, {
            deltaDays: 0,
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
            microsecond: 0,
            nanosecond: 0
        });
        m = $68c609acd189a8b4$var$no(m, $68c609acd189a8b4$var$pr($68c609acd189a8b4$var$xt(l, {
            deltaDays: 0,
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
            microsecond: 0,
            nanosecond: 0
        })), e, null, i, s.largestUnit, s.roundingIncrement, s.smallestUnit, s.roundingMode);
    }
    let f = $68c609acd189a8b4$var$_r(m, "day");
    return "since" === e && (f = $68c609acd189a8b4$var$Sr(f)), f;
}
function $68c609acd189a8b4$var$mo(t, n, r, o) {
    const i = $68c609acd189a8b4$var$fn(r), a = $68c609acd189a8b4$var$re(n, $68c609acd189a8b4$var$E), s = $68c609acd189a8b4$var$re(i, $68c609acd189a8b4$var$E);
    if (!$68c609acd189a8b4$var$xn(a, s)) throw new RangeError(`cannot compute difference between dates of ${a} and ${s} calendars`);
    const c = $68c609acd189a8b4$var$ao(t, $68c609acd189a8b4$var$Zo(o), "datetime", [], "nanosecond", "hour"), d = $68c609acd189a8b4$var$re(n, $68c609acd189a8b4$var$b), h = $68c609acd189a8b4$var$re(i, $68c609acd189a8b4$var$b), u = $68c609acd189a8b4$var$ce("%Temporal.Duration%");
    let l;
    if ("date" !== $68c609acd189a8b4$var$Vt(c.largestUnit)) l = $68c609acd189a8b4$var$_r($68c609acd189a8b4$var$Xr(d, h, c.roundingIncrement, c.smallestUnit, c.roundingMode), c.largestUnit);
    else {
        const t = $68c609acd189a8b4$var$re(n, $68c609acd189a8b4$var$$);
        if (!$68c609acd189a8b4$var$Zn(t, $68c609acd189a8b4$var$re(i, $68c609acd189a8b4$var$$))) throw new RangeError("When calculating difference between time zones, largestUnit must be 'hours' or smaller because day lengths can vary between time zones due to DST or time zone offset changes.");
        if ((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).equal(d, h)) return new u;
        l = $68c609acd189a8b4$var$_r($68c609acd189a8b4$var$io(d, h, t, a, c.largestUnit, c.roundingIncrement, c.smallestUnit, c.roundingMode), "hour");
    }
    return "since" === t && (l = $68c609acd189a8b4$var$Sr(l)), l;
}
function $68c609acd189a8b4$var$fo({ hour: e, minute: t, second: n, millisecond: r, microsecond: o, nanosecond: i }, a) {
    let s = n, c = i;
    return s += a.sec, c += a.subsec, $68c609acd189a8b4$var$Yr(e, t, s, r, o, c);
}
function $68c609acd189a8b4$var$yo(e, t) {
    const n = t.addToEpochNs(e);
    return $68c609acd189a8b4$var$Fr(n), n;
}
function $68c609acd189a8b4$var$po(e, t, n, r, o = "constrain") {
    if (0 === $68c609acd189a8b4$var$Er(r.date)) return $68c609acd189a8b4$var$yo(e, r.time);
    const i = $68c609acd189a8b4$var$zn(t, e);
    return $68c609acd189a8b4$var$yo($68c609acd189a8b4$var$An(t, $68c609acd189a8b4$var$xt($68c609acd189a8b4$var$Sn(n, i.isoDate, r.date, o), i.time), "compatible"), r.time);
}
function $68c609acd189a8b4$var$go(e, t, n) {
    let r = $68c609acd189a8b4$var$sn(n);
    "subtract" === e && (r = $68c609acd189a8b4$var$Sr(r));
    const o = $68c609acd189a8b4$var$Gt($68c609acd189a8b4$var$Jt(t), $68c609acd189a8b4$var$Jt(r));
    if ($68c609acd189a8b4$var$Kt(o)) throw new RangeError("For years, months, or weeks arithmetic, use date arithmetic relative to a starting point");
    const i = $68c609acd189a8b4$var$qr(t), a = $68c609acd189a8b4$var$qr(r);
    return $68c609acd189a8b4$var$_r($68c609acd189a8b4$var$Jr({
        years: 0,
        months: 0,
        weeks: 0,
        days: 0
    }, i.time.add(a.time)), o);
}
function $68c609acd189a8b4$var$wo(e, t, n) {
    let r = $68c609acd189a8b4$var$sn(n);
    "subtract" === e && (r = $68c609acd189a8b4$var$Sr(r));
    const o = $68c609acd189a8b4$var$Jt(r);
    if ("date" === $68c609acd189a8b4$var$Vt(o)) throw new RangeError(`Duration field ${o} not supported by Temporal.Instant. Try Temporal.ZonedDateTime instead.`);
    const i = $68c609acd189a8b4$var$qr(r);
    return $68c609acd189a8b4$var$Cn($68c609acd189a8b4$var$yo($68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$b), i.time));
}
function $68c609acd189a8b4$var$vo(e, t, n, r) {
    const o = $68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$E);
    let i = $68c609acd189a8b4$var$sn(n);
    "subtract" === e && (i = $68c609acd189a8b4$var$Sr(i));
    const a = $68c609acd189a8b4$var$Wr(i), s = $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(r));
    return $68c609acd189a8b4$var$pn($68c609acd189a8b4$var$Sn(o, $68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$D), a, s), o);
}
function $68c609acd189a8b4$var$bo(e, t, n, r) {
    let o = $68c609acd189a8b4$var$sn(n);
    "subtract" === e && (o = $68c609acd189a8b4$var$Sr(o));
    const i = $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(r)), a = $68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$E), s = $68c609acd189a8b4$var$qr(o), c = $68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$T), d = $68c609acd189a8b4$var$fo(c.time, s.time), h = $68c609acd189a8b4$var$Nt(s.date, d.deltaDays);
    return $68c609acd189a8b4$var$zr(h.years, h.months, h.weeks, h.days, 0, 0, 0, 0, 0, 0), $68c609acd189a8b4$var$wn($68c609acd189a8b4$var$xt($68c609acd189a8b4$var$Sn(a, c.isoDate, h, i), d), a);
}
function $68c609acd189a8b4$var$Do(e, t, n) {
    let r = $68c609acd189a8b4$var$sn(n);
    "subtract" === e && (r = $68c609acd189a8b4$var$Sr(r));
    const o = $68c609acd189a8b4$var$qr(r), { hour: i, minute: a, second: s, millisecond: c, microsecond: d, nanosecond: h } = $68c609acd189a8b4$var$fo($68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$M), o.time);
    return $68c609acd189a8b4$var$Tn($68c609acd189a8b4$var$jt(i, a, s, c, d, h, "reject"));
}
function $68c609acd189a8b4$var$To(e, t, n, r) {
    let o = $68c609acd189a8b4$var$sn(n);
    "subtract" === e && (o = $68c609acd189a8b4$var$Sr(o));
    const i = $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(r)), a = $68c609acd189a8b4$var$Mr(o), s = $68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$E), c = $68c609acd189a8b4$var$en(s, $68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$D), "year-month");
    c.day = 1;
    let d = $68c609acd189a8b4$var$Ln(s, c, "constrain");
    if (a < 0) {
        const e = $68c609acd189a8b4$var$Sn(s, d, {
            months: 1
        }, "constrain");
        d = $68c609acd189a8b4$var$Or(e.year, e.month, e.day - 1);
    }
    const h = $68c609acd189a8b4$var$Wr(o);
    return $68c609acd189a8b4$var$Lr(d), $68c609acd189a8b4$var$En($68c609acd189a8b4$var$Pn(s, $68c609acd189a8b4$var$en(s, $68c609acd189a8b4$var$Sn(s, d, h, i), "year-month"), i), s);
}
function $68c609acd189a8b4$var$Mo(e, t, n, r) {
    let o = $68c609acd189a8b4$var$sn(n);
    "subtract" === e && (o = $68c609acd189a8b4$var$Sr(o));
    const i = $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(r)), a = $68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$$), s = $68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$E), c = $68c609acd189a8b4$var$Ar(o);
    return $68c609acd189a8b4$var$$n($68c609acd189a8b4$var$po($68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$b), a, s, c, i), a, s);
}
function $68c609acd189a8b4$var$Eo(e, t, n) {
    const r = Math.trunc(e / t), o = e % t, i = e < 0 ? "negative" : "positive", a = Math.abs(r), s = a + 1, c = $68c609acd189a8b4$var$Bo(Math.abs(2 * o) - t), d = a % 2 == 0, h = $68c609acd189a8b4$var$ue(n, i), u = 0 === o ? a : $68c609acd189a8b4$var$le(a, s, c, d, h);
    return t * ("positive" === i ? u : -u);
}
function $68c609acd189a8b4$var$Io(o, i, a, s) {
    const c = $68c609acd189a8b4$var$at[a] * i;
    return function(o, i, a) {
        const s = $68c609acd189a8b4$var$m(o), c = $68c609acd189a8b4$var$m(i), d = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).divide(s, c), h = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).remainder(s, c), u = $68c609acd189a8b4$var$ue(a, "positive");
        let l, g;
        (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).lessThan(s, $68c609acd189a8b4$var$t) ? (l = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).subtract(d, $68c609acd189a8b4$var$n), g = d) : (l = d, g = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).add(d, $68c609acd189a8b4$var$n));
        const w = $68c609acd189a8b4$var$p($68c609acd189a8b4$var$y((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).multiply(h, $68c609acd189a8b4$var$r)), c) * ((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).lessThan(s, $68c609acd189a8b4$var$t) ? -1 : 1) + 0, v = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).equal(h, $68c609acd189a8b4$var$t) ? d : $68c609acd189a8b4$var$le(l, g, w, $68c609acd189a8b4$var$f(l), u);
        return (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).multiply(v, c);
    }(o, (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(c), s);
}
function $68c609acd189a8b4$var$Co(e, t, n, r) {
    $68c609acd189a8b4$var$Zr(e);
    const { year: o, month: i, day: a } = e.isoDate, s = $68c609acd189a8b4$var$Oo(e.time, t, n, r);
    return $68c609acd189a8b4$var$xt($68c609acd189a8b4$var$Or(o, i, a + s.deltaDays), s);
}
function $68c609acd189a8b4$var$Oo({ hour: e, minute: t, second: n, millisecond: r, microsecond: o, nanosecond: i }, a, s, c) {
    let d;
    switch(s){
        case "day":
        case "hour":
            d = 1e3 * (1e3 * (1e3 * (60 * (60 * e + t) + n) + r) + o) + i;
            break;
        case "minute":
            d = 1e3 * (1e3 * (1e3 * (60 * t + n) + r) + o) + i;
            break;
        case "second":
            d = 1e3 * (1e3 * (1e3 * n + r) + o) + i;
            break;
        case "millisecond":
            d = 1e3 * (1e3 * r + o) + i;
            break;
        case "microsecond":
            d = 1e3 * o + i;
            break;
        case "nanosecond":
            d = i;
    }
    const h = $68c609acd189a8b4$var$at[s], u = $68c609acd189a8b4$var$Eo(d, h * a, c) / h;
    switch(s){
        case "day":
            return {
                deltaDays: u,
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
                microsecond: 0,
                nanosecond: 0
            };
        case "hour":
            return $68c609acd189a8b4$var$Yr(u, 0, 0, 0, 0, 0);
        case "minute":
            return $68c609acd189a8b4$var$Yr(e, u, 0, 0, 0, 0);
        case "second":
            return $68c609acd189a8b4$var$Yr(e, t, u, 0, 0, 0);
        case "millisecond":
            return $68c609acd189a8b4$var$Yr(e, t, n, u, 0, 0);
        case "microsecond":
            return $68c609acd189a8b4$var$Yr(e, t, n, r, u, 0);
        case "nanosecond":
            return $68c609acd189a8b4$var$Yr(e, t, n, r, o, u);
        default:
            throw new Error(`Invalid unit ${s}`);
    }
}
function $68c609acd189a8b4$var$$o(t, n, r, o) {
    const i = $68c609acd189a8b4$var$at[r];
    return t.round((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(i * n), o);
}
function $68c609acd189a8b4$var$Yo(t, n) {
    const r = $68c609acd189a8b4$var$at[n];
    return t.fdiv((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(r));
}
function $68c609acd189a8b4$var$Ro(e, t) {
    return e.year !== t.year ? $68c609acd189a8b4$var$Bo(e.year - t.year) : e.month !== t.month ? $68c609acd189a8b4$var$Bo(e.month - t.month) : e.day !== t.day ? $68c609acd189a8b4$var$Bo(e.day - t.day) : 0;
}
function $68c609acd189a8b4$var$So(e, t) {
    return e.hour !== t.hour ? $68c609acd189a8b4$var$Bo(e.hour - t.hour) : e.minute !== t.minute ? $68c609acd189a8b4$var$Bo(e.minute - t.minute) : e.second !== t.second ? $68c609acd189a8b4$var$Bo(e.second - t.second) : e.millisecond !== t.millisecond ? $68c609acd189a8b4$var$Bo(e.millisecond - t.millisecond) : e.microsecond !== t.microsecond ? $68c609acd189a8b4$var$Bo(e.microsecond - t.microsecond) : e.nanosecond !== t.nanosecond ? $68c609acd189a8b4$var$Bo(e.nanosecond - t.nanosecond) : 0;
}
function $68c609acd189a8b4$var$jo(e, t) {
    const n = $68c609acd189a8b4$var$Ro(e.isoDate, t.isoDate);
    return 0 !== n ? n : $68c609acd189a8b4$var$So(e.time, t.time);
}
function $68c609acd189a8b4$var$ko(e) {
    const t = $68c609acd189a8b4$var$Lo(e);
    return void 0 !== globalThis.BigInt ? globalThis.BigInt(t.toString(10)) : t;
}
function $68c609acd189a8b4$var$No(t, n) {
    const r = $68c609acd189a8b4$var$m(t), { quotient: o, remainder: i } = $68c609acd189a8b4$var$g(r, $68c609acd189a8b4$var$c);
    let a = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).toNumber(o);
    return "floor" === n && (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).toNumber(i) < 0 && (a -= 1), "ceil" === n && (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).toNumber(i) > 0 && (a += 1), a;
}
function $68c609acd189a8b4$var$xo(t) {
    if (!Number.isInteger(t)) throw new RangeError("epoch milliseconds must be an integer");
    return (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).multiply((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(t), $68c609acd189a8b4$var$c);
}
function $68c609acd189a8b4$var$Lo(t) {
    let n = t;
    if ("object" == typeof t) {
        const e = t[Symbol.toPrimitive];
        e && "function" == typeof e && (n = e.call(t, "number"));
    }
    if ("number" == typeof n) throw new TypeError("cannot convert number to bigint");
    return "bigint" == typeof n ? (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(n.toString(10)) : (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(n);
}
const $68c609acd189a8b4$var$Po = (()=>{
    let t = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(Date.now() % 1e6);
    return ()=>{
        const n = Date.now(), r = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(n), o = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).add($68c609acd189a8b4$var$xo(n), t);
        return t = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).remainder(r, $68c609acd189a8b4$var$c), (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).greaterThan(o, $68c609acd189a8b4$var$Ne) ? $68c609acd189a8b4$var$Ne : (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).lessThan(o, $68c609acd189a8b4$var$xe) ? $68c609acd189a8b4$var$xe : o;
    };
})();
function $68c609acd189a8b4$var$Uo() {
    return (new Intl.DateTimeFormat).resolvedOptions().timeZone;
}
function $68c609acd189a8b4$var$Bo(e) {
    return e < 0 ? -1 : e > 0 ? 1 : e;
}
function $68c609acd189a8b4$var$Zo(e) {
    if (void 0 === e) return Object.create(null);
    if ($68c609acd189a8b4$var$Ae(e) && null !== e) return e;
    throw new TypeError("Options parameter must be an object, not " + (null === e ? "null" : typeof e));
}
function $68c609acd189a8b4$var$Fo(e, t) {
    const n = Object.create(null);
    return n[e] = t, n;
}
function $68c609acd189a8b4$var$Ho(e, t, n, r) {
    let o = e[t];
    if (void 0 !== o) {
        if (o = $68c609acd189a8b4$var$We(o), !n.includes(o)) throw new RangeError(`${t} must be one of ${n.join(", ")}, not ${o}`);
        return o;
    }
    if (r === $68c609acd189a8b4$var$qt) throw new RangeError(`${t} option is required`);
    return r;
}
function $68c609acd189a8b4$var$zo(e) {
    const t = $68c609acd189a8b4$var$Ao(e);
    if (!$68c609acd189a8b4$var$He.includes($68c609acd189a8b4$var$Ao(t))) throw new RangeError(`invalid calendar identifier ${t}`);
    switch(t){
        case "ethiopic-amete-alem":
            return "ethioaa";
        case "islamicc":
            return "islamic-civil";
    }
    return t;
}
function $68c609acd189a8b4$var$Ao(e) {
    let t = "";
    for(let n = 0; n < e.length; n++){
        const r = e.charCodeAt(n);
        t += r >= 65 && r <= 90 ? String.fromCharCode(r + 32) : String.fromCharCode(r);
    }
    return t;
}
function $68c609acd189a8b4$var$qo(e) {
    throw new TypeError(`Do not use built-in arithmetic operators with Temporal objects. When comparing, use ${"PlainMonthDay" === e ? "Temporal.PlainDate.compare(obj1.toPlainDate(year), obj2.toPlainDate(year))" : `Temporal.${e}.compare(obj1, obj2)`}, not obj1 > obj2. When coercing to strings, use \`\${obj}\` or String(obj), not '' + obj. When coercing to numbers, use properties or methods of the object, not \`+obj\`. When concatenating with strings, use \`\${str}\${obj}\` or str.concat(obj), not str + obj. In React, coerce to a string before rendering a Temporal object.`);
}
const $68c609acd189a8b4$var$Wo = new RegExp(`^${$68c609acd189a8b4$var$be.source}$`), $68c609acd189a8b4$var$_o = new RegExp(`^${/([+-])([01][0-9]|2[0-3])(?::?([0-5][0-9])(?::?([0-5][0-9])(?:[.,](\d{1,9}))?)?)?/.source}$`);
function $68c609acd189a8b4$var$Jo(e, t, n, r = e(t), o = e(n)) {
    let i = t, a = n, s = r, c = o;
    for(; a - i > 1;){
        let t = Math.trunc((i + a) / 2);
        const n = e(t);
        n === s ? (i = t, s = n) : n === c && (a = t, c = n);
    }
    return a;
}
function $68c609acd189a8b4$var$Go(e) {
    return [
        ...e
    ];
}
function $68c609acd189a8b4$var$Ko(e, t) {
    if ("gregory" !== e && "iso8601" !== e) return;
    const n = $68c609acd189a8b4$var$Xo[e];
    let r = t.year;
    const { dayOfWeek: o, dayOfYear: i, daysInYear: a } = n.isoToDate(t, {
        dayOfWeek: !0,
        dayOfYear: !0,
        daysInYear: !0
    }), s = n.getFirstDayOfWeek(), c = n.getMinimalDaysInFirstWeek();
    let d = (o + 7 - s) % 7, h = (o - i + 7001 - s) % 7, u = Math.floor((i - 1 + h) / 7);
    if (7 - h >= c && ++u, 0 == u) u = function(e, t, n, r) {
        let o = (r - e - n + 1) % 7;
        o < 0 && (o += 7);
        let i = Math.floor((n + o - 1) / 7);
        return 7 - o >= t && ++i, i;
    }(s, c, i + n.isoToDate(n.dateAdd(t, {
        years: -1
    }, "constrain"), {
        daysInYear: !0
    }).daysInYear, o), r--;
    else if (i >= a - 5) {
        let e = (d + a - i) % 7;
        e < 0 && (e += 7), 6 - e >= c && i + 7 - d > a && (u = 1, r++);
    }
    return {
        week: u,
        year: r
    };
}
function $68c609acd189a8b4$var$Vo(e, t, n, r, o) {
    if (t !== o.year) {
        if (e * (t - o.year) > 0) return !0;
    } else if (n !== o.month) {
        if (e * (n - o.month) > 0) return !0;
    } else if (r !== o.day && e * (r - o.day) > 0) return !0;
    return !1;
}
const $68c609acd189a8b4$var$Xo = {};
function $68c609acd189a8b4$var$Qo(e) {
    if (!e.startsWith("M")) throw new RangeError(`Invalid month code: ${e}.  Month codes must start with M.`);
    const t = +e.slice(1);
    if (Number.isNaN(t)) throw new RangeError(`Invalid month code: ${e}`);
    return t;
}
function $68c609acd189a8b4$var$ei(e, t = !1) {
    return `M${`${e}`.padStart(2, "0")}${t ? "L" : ""}`;
}
function $68c609acd189a8b4$var$ti(e, t, n = 12) {
    let { month: r, monthCode: o } = e;
    if (void 0 === o) {
        if (void 0 === r) throw new TypeError("Either month or monthCode are required");
        "reject" === t && $68c609acd189a8b4$var$Nr(r, 1, n), "constrain" === t && (r = $68c609acd189a8b4$var$jr(r, 1, n)), o = $68c609acd189a8b4$var$ei(r);
    } else {
        const e = $68c609acd189a8b4$var$Qo(o);
        if (o !== $68c609acd189a8b4$var$ei(e)) throw new RangeError(`Invalid month code: ${o}`);
        if (void 0 !== r && r !== e) throw new RangeError(`monthCode ${o} and month ${r} must match if both are present`);
        if (r = e, r < 1 || r > n) throw new RangeError(`Invalid monthCode: ${o}`);
    }
    return {
        ...e,
        month: r,
        monthCode: o
    };
}
$68c609acd189a8b4$var$Xo.iso8601 = {
    resolveFields (e, t) {
        if (("date" === t || "year-month" === t) && void 0 === e.year) throw new TypeError("year is required");
        if (("date" === t || "month-day" === t) && void 0 === e.day) throw new TypeError("day is required");
        Object.assign(e, $68c609acd189a8b4$var$ti(e));
    },
    dateToISO: (e, t)=>$68c609acd189a8b4$var$St(e.year, e.month, e.day, t),
    monthDayToISOReferenceDate (e, t) {
        const { month: n, day: r } = $68c609acd189a8b4$var$St(e.year ?? 1972, e.month, e.day, t);
        return {
            month: n,
            day: r,
            year: 1972
        };
    },
    extraFields: ()=>[],
    fieldKeysToIgnore (e) {
        const t = new Set;
        for(let n = 0; n < e.length; n++){
            const r = e[n];
            t.add(r), "month" === r ? t.add("monthCode") : "monthCode" === r && t.add("month");
        }
        return $68c609acd189a8b4$var$Go(t);
    },
    dateAdd (e, { years: t = 0, months: n = 0, weeks: r = 0, days: o = 0 }, i) {
        let { year: a, month: s, day: c } = e;
        return a += t, s += n, { year: a, month: s } = $68c609acd189a8b4$var$Cr(a, s), { year: a, month: s, day: c } = $68c609acd189a8b4$var$St(a, s, c, i), c += o + 7 * r, $68c609acd189a8b4$var$Or(a, s, c);
    },
    dateUntil (e, t, n) {
        const r = -$68c609acd189a8b4$var$Ro(e, t);
        if (0 === r) return {
            years: 0,
            months: 0,
            weeks: 0,
            days: 0
        };
        let o, i = 0, a = 0;
        if ("year" === n || "month" === n) {
            let s = t.year - e.year;
            for(0 !== s && (s -= r); !$68c609acd189a8b4$var$Vo(r, e.year + s, e.month, e.day, t);)i = s, s += r;
            let c = r;
            for(o = $68c609acd189a8b4$var$Cr(e.year + i, e.month + c); !$68c609acd189a8b4$var$Vo(r, o.year, o.month, e.day, t);)a = c, c += r, o = $68c609acd189a8b4$var$Cr(o.year, o.month + r);
            "month" === n && (a += 12 * i, i = 0);
        }
        o = $68c609acd189a8b4$var$Cr(e.year + i, e.month + a);
        const s = $68c609acd189a8b4$var$kr(o.year, o.month, e.day);
        let c = 0, d = $68c609acd189a8b4$var$Gr(t.year, t.month - 1, t.day) - $68c609acd189a8b4$var$Gr(s.year, s.month - 1, s.day);
        return "week" === n && (c = Math.trunc(d / 7), d %= 7), {
            years: i,
            months: a,
            weeks: c,
            days: d
        };
    },
    isoToDate ({ year: e, month: t, day: n }, r) {
        const o = {
            era: void 0,
            eraYear: void 0,
            year: e,
            month: t,
            day: n,
            daysInWeek: 7,
            monthsInYear: 12
        };
        if (r.monthCode && (o.monthCode = $68c609acd189a8b4$var$ei(t)), r.dayOfWeek) {
            const r = t + (t < 3 ? 10 : -2), i = e - (t < 3 ? 1 : 0), a = Math.floor(i / 100), s = i - 100 * a, c = (n + Math.floor(2.6 * r - .2) + (s + Math.floor(s / 4)) + (Math.floor(a / 4) - 2 * a)) % 7;
            o.dayOfWeek = c + (c <= 0 ? 7 : 0);
        }
        if (r.dayOfYear) {
            let r = n;
            for(let n = t - 1; n > 0; n--)r += $68c609acd189a8b4$var$Tr(e, n);
            o.dayOfYear = r;
        }
        return r.weekOfYear && (o.weekOfYear = $68c609acd189a8b4$var$Ko("iso8601", {
            year: e,
            month: t,
            day: n
        })), r.daysInMonth && (o.daysInMonth = $68c609acd189a8b4$var$Tr(e, t)), (r.daysInYear || r.inLeapYear) && (o.inLeapYear = $68c609acd189a8b4$var$Dr(e), o.daysInYear = o.inLeapYear ? 366 : 365), o;
    },
    getFirstDayOfWeek: ()=>1,
    getMinimalDaysInFirstWeek: ()=>4
};
class $68c609acd189a8b4$var$OneObjectCache {
    constructor(e){
        if (this.map = new Map, this.calls = 0, this.hits = 0, this.misses = 0, void 0 !== e) {
            let t = 0;
            for (const n of e.map.entries()){
                if (++t > $68c609acd189a8b4$var$OneObjectCache.MAX_CACHE_ENTRIES) break;
                this.map.set(...n);
            }
        }
    }
    get(e) {
        const t = this.map.get(e);
        return t && (this.hits++, this.report()), this.calls++, t;
    }
    set(e, t) {
        this.map.set(e, t), this.misses++, this.report();
    }
    report() {}
    setObject(e) {
        if ($68c609acd189a8b4$var$OneObjectCache.objectMap.get(e)) throw new RangeError("object already cached");
        $68c609acd189a8b4$var$OneObjectCache.objectMap.set(e, this), this.report();
    }
    static getCacheForObject(e) {
        let t = $68c609acd189a8b4$var$OneObjectCache.objectMap.get(e);
        return t || (t = new $68c609acd189a8b4$var$OneObjectCache, $68c609acd189a8b4$var$OneObjectCache.objectMap.set(e, t)), t;
    }
}
function $68c609acd189a8b4$var$ni({ isoYear: e, isoMonth: t, isoDay: n }) {
    return `${$68c609acd189a8b4$var$Jn(e)}-${$68c609acd189a8b4$var$Gn(t)}-${$68c609acd189a8b4$var$Gn(n)}T00:00Z`;
}
function $68c609acd189a8b4$var$ri(e, t) {
    return {
        years: e.year - t.year,
        months: e.month - t.month,
        days: e.day - t.day
    };
}
$68c609acd189a8b4$var$OneObjectCache.objectMap = new WeakMap, $68c609acd189a8b4$var$OneObjectCache.MAX_CACHE_ENTRIES = 1e3;
class $68c609acd189a8b4$var$HelperBase {
    constructor(){
        this.eras = [], this.hasEra = !1, this.erasBeginMidYear = !1;
    }
    getFormatter() {
        return void 0 === this.formatter && (this.formatter = new Intl.DateTimeFormat(`en-US-u-ca-${this.id}`, {
            day: "numeric",
            month: "numeric",
            year: "numeric",
            era: "short",
            timeZone: "UTC"
        })), this.formatter;
    }
    getCalendarParts(e) {
        let t = this.getFormatter(), n = new Date(e);
        if ("-271821-04-19T00:00Z" === e) {
            const e = t.resolvedOptions();
            t = new Intl.DateTimeFormat(e.locale, {
                ...e,
                timeZone: "Etc/GMT+1"
            }), n = new Date("-271821-04-20T00:00Z");
        }
        try {
            return t.formatToParts(n);
        } catch (t) {
            throw new RangeError(`Invalid ISO date: ${e}`);
        }
    }
    isoToCalendarDate(e, t) {
        const { year: n, month: r, day: o } = e, i = JSON.stringify({
            func: "isoToCalendarDate",
            isoYear: n,
            isoMonth: r,
            isoDay: o,
            id: this.id
        }), a = t.get(i);
        if (a) return a;
        const s = $68c609acd189a8b4$var$ni({
            isoYear: n,
            isoMonth: r,
            isoDay: o
        }), c = this.getCalendarParts(s), d = {};
        for(let e = 0; e < c.length; e++){
            const { type: t, value: n } = c[e];
            if ("year" !== t && "relatedYear" !== t || (this.hasEra ? d.eraYear = +n : d.year = +n), "month" === t) {
                const e = /^([0-9]*)(.*?)$/.exec(n);
                if (!e || 3 != e.length || !e[1] && !e[2]) throw new RangeError(`Unexpected month: ${n}`);
                if (d.month = e[1] ? +e[1] : 1, d.month < 1) throw new RangeError(`Invalid month ${n} from ${s}[u-ca-${this.id}] (probably due to https://bugs.chromium.org/p/v8/issues/detail?id=10527)`);
                if (d.month > 13) throw new RangeError(`Invalid month ${n} from ${s}[u-ca-${this.id}] (probably due to https://bugs.chromium.org/p/v8/issues/detail?id=10529)`);
                e[2] && (d.monthExtra = e[2]);
            }
            "day" === t && (d.day = +n), this.hasEra && "era" === t && null != n && "" !== n && (d.era = n.split(" (")[0].normalize("NFD").replace(/[^-0-9 \p{L}]/gu, "").replace(/ /g, "-").toLowerCase());
        }
        if (this.hasEra && void 0 === d.eraYear) throw new RangeError(`Intl.DateTimeFormat.formatToParts lacks relatedYear in ${this.id} calendar. Try Node 14+ or modern browsers.`);
        if (this.hasEra) {
            const e = this.eras.find((e)=>d.era === e.genericName);
            e && (d.era = e.code);
        }
        if (this.reviseIntlEra) {
            const { era: t, eraYear: n } = this.reviseIntlEra(d, e);
            d.era = t, d.eraYear = n;
        }
        this.checkIcuBugs && this.checkIcuBugs(e);
        const h = this.adjustCalendarDate(d, t, "constrain", !0);
        if (void 0 === h.year) throw new RangeError(`Missing year converting ${JSON.stringify(e)}`);
        if (void 0 === h.month) throw new RangeError(`Missing month converting ${JSON.stringify(e)}`);
        if (void 0 === h.day) throw new RangeError(`Missing day converting ${JSON.stringify(e)}`);
        return t.set(i, h), [
            "constrain",
            "reject"
        ].forEach((n)=>{
            const r = JSON.stringify({
                func: "calendarToIsoDate",
                year: h.year,
                month: h.month,
                day: h.day,
                overflow: n,
                id: this.id
            });
            t.set(r, e);
        }), h;
    }
    validateCalendarDate(e) {
        const { month: t, year: n, day: r, eraYear: o, monthCode: i, monthExtra: a } = e;
        if (void 0 !== a) throw new RangeError("Unexpected `monthExtra` value");
        if (void 0 === n && void 0 === o) throw new TypeError("year or eraYear is required");
        if (void 0 === t && void 0 === i) throw new TypeError("month or monthCode is required");
        if (void 0 === r) throw new RangeError("Missing day");
        if (void 0 !== i) {
            if ("string" != typeof i) throw new RangeError("monthCode must be a string, not " + typeof i);
            if (!/^M([01]?\d)(L?)$/.test(i)) throw new RangeError(`Invalid monthCode: ${i}`);
        }
        if (this.hasEra && void 0 === e.era != (void 0 === e.eraYear)) throw new TypeError("properties era and eraYear must be provided together");
    }
    adjustCalendarDate(e, t, n = "constrain", r = !1) {
        if ("lunisolar" === this.calendarType) throw new RangeError("Override required for lunisolar calendars");
        let o = e;
        this.validateCalendarDate(o);
        const i = this.monthsInYear(o, t);
        let { month: a, monthCode: s } = o;
        return { month: a, monthCode: s } = $68c609acd189a8b4$var$ti(o, n, i), {
            ...o,
            month: a,
            monthCode: s
        };
    }
    regulateMonthDayNaive(e, t, n) {
        const r = this.monthsInYear(e, n);
        let { month: o, day: i } = e;
        return "reject" === t ? ($68c609acd189a8b4$var$Nr(o, 1, r), $68c609acd189a8b4$var$Nr(i, 1, this.maximumMonthLength(e))) : (o = $68c609acd189a8b4$var$jr(o, 1, r), i = $68c609acd189a8b4$var$jr(i, 1, this.maximumMonthLength({
            ...e,
            month: o
        }))), {
            ...e,
            month: o,
            day: i
        };
    }
    calendarToIsoDate(e, t = "constrain", n) {
        const r = e;
        let o = this.adjustCalendarDate(e, n, t, !1);
        o = this.regulateMonthDayNaive(o, t, n);
        const { year: i, month: a, day: s } = o, c = JSON.stringify({
            func: "calendarToIsoDate",
            year: i,
            month: a,
            day: s,
            overflow: t,
            id: this.id
        });
        let d, h = n.get(c);
        if (h) return h;
        if (void 0 !== r.year && void 0 !== r.month && void 0 !== r.day && (r.year !== o.year || r.month !== o.month || r.day !== o.day) && (d = JSON.stringify({
            func: "calendarToIsoDate",
            year: r.year,
            month: r.month,
            day: r.day,
            overflow: t,
            id: this.id
        }), h = n.get(d), h)) return h;
        let u = this.estimateIsoDate({
            year: i,
            month: a,
            day: s
        });
        const l = (e)=>{
            let r = this.addDaysIso(u, e);
            if (o.day > this.minimumMonthLength(o)) {
                let e = this.isoToCalendarDate(r, n);
                for(; e.month !== a || e.year !== i;){
                    if ("reject" === t) throw new RangeError(`day ${s} does not exist in month ${a} of year ${i}`);
                    r = this.addDaysIso(r, -1), e = this.isoToCalendarDate(r, n);
                }
            }
            return r;
        };
        let m = 0, f = this.isoToCalendarDate(u, n), y = $68c609acd189a8b4$var$ri(o, f);
        if (0 !== y.years || 0 !== y.months || 0 !== y.days) {
            const e = 365 * y.years + 30 * y.months + y.days;
            u = this.addDaysIso(u, e), f = this.isoToCalendarDate(u, n), y = $68c609acd189a8b4$var$ri(o, f), 0 === y.years && 0 === y.months ? u = l(y.days) : m = this.compareCalendarDates(o, f);
        }
        let p = 8;
        for(; m;){
            u = this.addDaysIso(u, m * p);
            const e = f;
            f = this.isoToCalendarDate(u, n);
            const i = m;
            if (m = this.compareCalendarDates(o, f), m) {
                if (y = $68c609acd189a8b4$var$ri(o, f), 0 === y.years && 0 === y.months) u = l(y.days), m = 0;
                else if (i && m !== i) {
                    if (p > 1) p /= 2;
                    else {
                        if ("reject" === t) throw new RangeError(`Can't find ISO date from calendar date: ${JSON.stringify({
                            ...r
                        })}`);
                        this.compareCalendarDates(f, e) > 0 && (u = this.addDaysIso(u, -1)), m = 0;
                    }
                }
            }
        }
        if (n.set(c, u), d && n.set(d, u), void 0 === o.year || void 0 === o.month || void 0 === o.day || void 0 === o.monthCode || this.hasEra && (void 0 === o.era || void 0 === o.eraYear)) throw new RangeError("Unexpected missing property");
        return u;
    }
    compareCalendarDates(e, t) {
        return e.year !== t.year ? $68c609acd189a8b4$var$Bo(e.year - t.year) : e.month !== t.month ? $68c609acd189a8b4$var$Bo(e.month - t.month) : e.day !== t.day ? $68c609acd189a8b4$var$Bo(e.day - t.day) : 0;
    }
    regulateDate(e, t = "constrain", n) {
        const r = this.calendarToIsoDate(e, t, n);
        return this.isoToCalendarDate(r, n);
    }
    addDaysIso(e, t) {
        return $68c609acd189a8b4$var$Or(e.year, e.month, e.day + t);
    }
    addDaysCalendar(e, t, n) {
        const r = this.calendarToIsoDate(e, "constrain", n), o = this.addDaysIso(r, t);
        return this.isoToCalendarDate(o, n);
    }
    addMonthsCalendar(e, t, n, r) {
        let o = e;
        const { day: i } = o;
        for(let e = 0, n = Math.abs(t); e < n; e++){
            const { month: e } = o, n = o, a = t < 0 ? -Math.max(i, this.daysInPreviousMonth(o, r)) : this.daysInMonth(o, r), s = this.calendarToIsoDate(o, "constrain", r);
            let c = this.addDaysIso(s, a);
            if (o = this.isoToCalendarDate(c, r), t > 0) {
                const t = this.monthsInYear(n, r);
                for(; o.month - 1 != e % t;)c = this.addDaysIso(c, -1), o = this.isoToCalendarDate(c, r);
            }
            o.day !== i && (o = this.regulateDate({
                ...o,
                day: i
            }, "constrain", r));
        }
        if ("reject" === n && o.day !== i) throw new RangeError(`Day ${i} does not exist in resulting calendar month`);
        return o;
    }
    addCalendar(e, { years: t = 0, months: n = 0, weeks: r = 0, days: o = 0 }, i, a) {
        const { year: s, day: c, monthCode: d } = e, h = this.adjustCalendarDate({
            year: s + t,
            monthCode: d,
            day: c
        }, a), u = this.addMonthsCalendar(h, n, i, a), l = o + 7 * r;
        return this.addDaysCalendar(u, l, a);
    }
    untilCalendar(e, t, n, r) {
        let o = 0, i = 0, a = 0, s = 0;
        switch(n){
            case "day":
                o = this.calendarDaysUntil(e, t, r);
                break;
            case "week":
                {
                    const n = this.calendarDaysUntil(e, t, r);
                    o = n % 7, i = (n - o) / 7;
                    break;
                }
            case "month":
            case "year":
                {
                    const i = this.compareCalendarDates(t, e);
                    if (!i) return {
                        years: 0,
                        months: 0,
                        weeks: 0,
                        days: 0
                    };
                    const c = t.year - e.year, d = t.day - e.day;
                    if ("year" === n && c) {
                        let n = 0;
                        t.monthCode > e.monthCode && (n = 1), t.monthCode < e.monthCode && (n = -1), n || (n = Math.sign(d)), s = n * i < 0 ? c - i : c;
                    }
                    let h, u = s ? this.addCalendar(e, {
                        years: s
                    }, "constrain", r) : e;
                    do a += i, h = u, u = this.addMonthsCalendar(h, i, "constrain", r), u.day !== e.day && (u = this.regulateDate({
                        ...u,
                        day: e.day
                    }, "constrain", r));
                    while (this.compareCalendarDates(t, u) * i >= 0);
                    a -= i, o = this.calendarDaysUntil(h, t, r);
                    break;
                }
        }
        return {
            years: s,
            months: a,
            weeks: i,
            days: o
        };
    }
    daysInMonth(e, t) {
        const { day: n } = e, r = this.maximumMonthLength(e), o = this.minimumMonthLength(e);
        if (o === r) return o;
        const i = n <= r - o ? r : o, a = this.calendarToIsoDate(e, "constrain", t), s = this.addDaysIso(a, i), c = this.isoToCalendarDate(s, t), d = this.addDaysIso(s, -c.day);
        return this.isoToCalendarDate(d, t).day;
    }
    daysInPreviousMonth(e, t) {
        const { day: n, month: r, year: o } = e;
        let i = {
            year: r > 1 ? o : o - 1,
            month: r,
            day: 1
        };
        const a = r > 1 ? r - 1 : this.monthsInYear(i, t);
        i = {
            ...i,
            month: a
        };
        const s = this.minimumMonthLength(i), c = this.maximumMonthLength(i);
        if (s === c) return c;
        const d = this.calendarToIsoDate(e, "constrain", t), h = this.addDaysIso(d, -n);
        return this.isoToCalendarDate(h, t).day;
    }
    startOfCalendarYear(e) {
        return {
            year: e.year,
            month: 1,
            monthCode: "M01",
            day: 1
        };
    }
    startOfCalendarMonth(e) {
        return {
            year: e.year,
            month: e.month,
            day: 1
        };
    }
    calendarDaysUntil(e, t, n) {
        const r = this.calendarToIsoDate(e, "constrain", n), o = this.calendarToIsoDate(t, "constrain", n);
        return $68c609acd189a8b4$var$Gr(o.year, o.month - 1, o.day) - $68c609acd189a8b4$var$Gr(r.year, r.month - 1, r.day);
    }
    monthDaySearchStartYear(e, t) {
        return 1972;
    }
    monthDayFromFields(e, t, n) {
        let r, o, i, a, s, { era: c, eraYear: d, year: h, month: u, monthCode: l, day: m } = e;
        if (void 0 !== u && void 0 === h && (!this.hasEra || void 0 === c || void 0 === d)) throw new TypeError("when month is present, year (or era and eraYear) are required");
        (void 0 === l || void 0 !== h || this.hasEra && void 0 !== d) && ({ monthCode: l, day: m } = this.isoToCalendarDate(this.calendarToIsoDate(e, t, n), n));
        const f = {
            year: this.monthDaySearchStartYear(l, m),
            month: 12,
            day: 31
        }, y = this.isoToCalendarDate(f, n), p = y.monthCode > l || y.monthCode === l && y.day >= m ? y.year : y.year - 1;
        for(let e = 0; e < 20; e++){
            const c = this.adjustCalendarDate({
                day: m,
                monthCode: l,
                year: p - e
            }, n), d = this.calendarToIsoDate(c, "constrain", n), h = this.isoToCalendarDate(d, n);
            if ({ year: r, month: o, day: i } = d, h.monthCode === l && h.day === m) return {
                month: o,
                day: i,
                year: r
            };
            if ("constrain" === t) {
                const e = this.maxLengthOfMonthCodeInAnyYear(h.monthCode);
                if (h.monthCode === l && h.day === e && m > e) return {
                    month: o,
                    day: i,
                    year: r
                };
                (void 0 === a || h.monthCode === a.monthCode && h.day > a.day) && (a = h, s = d);
            }
        }
        if ("constrain" === t && void 0 !== s) return s;
        throw new RangeError(`No recent ${this.id} year with monthCode ${l} and day ${m}`);
    }
    getFirstDayOfWeek() {}
    getMinimalDaysInFirstWeek() {}
}
class $68c609acd189a8b4$var$HebrewHelper extends $68c609acd189a8b4$var$HelperBase {
    constructor(){
        super(...arguments), this.id = "hebrew", this.calendarType = "lunisolar", this.months = {
            Tishri: {
                leap: 1,
                regular: 1,
                monthCode: "M01",
                days: 30
            },
            Heshvan: {
                leap: 2,
                regular: 2,
                monthCode: "M02",
                days: {
                    min: 29,
                    max: 30
                }
            },
            Kislev: {
                leap: 3,
                regular: 3,
                monthCode: "M03",
                days: {
                    min: 29,
                    max: 30
                }
            },
            Tevet: {
                leap: 4,
                regular: 4,
                monthCode: "M04",
                days: 29
            },
            Shevat: {
                leap: 5,
                regular: 5,
                monthCode: "M05",
                days: 30
            },
            Adar: {
                leap: void 0,
                regular: 6,
                monthCode: "M06",
                days: 29
            },
            "Adar I": {
                leap: 6,
                regular: void 0,
                monthCode: "M05L",
                days: 30
            },
            "Adar II": {
                leap: 7,
                regular: void 0,
                monthCode: "M06",
                days: 29
            },
            Nisan: {
                leap: 8,
                regular: 7,
                monthCode: "M07",
                days: 30
            },
            Iyar: {
                leap: 9,
                regular: 8,
                monthCode: "M08",
                days: 29
            },
            Sivan: {
                leap: 10,
                regular: 9,
                monthCode: "M09",
                days: 30
            },
            Tamuz: {
                leap: 11,
                regular: 10,
                monthCode: "M10",
                days: 29
            },
            Av: {
                leap: 12,
                regular: 11,
                monthCode: "M11",
                days: 30
            },
            Elul: {
                leap: 13,
                regular: 12,
                monthCode: "M12",
                days: 29
            }
        };
    }
    inLeapYear(e) {
        const { year: t } = e;
        return (7 * t + 1) % 19 < 7;
    }
    monthsInYear(e) {
        return this.inLeapYear(e) ? 13 : 12;
    }
    minimumMonthLength(e) {
        return this.minMaxMonthLength(e, "min");
    }
    maximumMonthLength(e) {
        return this.minMaxMonthLength(e, "max");
    }
    minMaxMonthLength(e, t) {
        const { month: n, year: r } = e, o = this.getMonthCode(r, n), i = Object.entries(this.months).find((e)=>e[1].monthCode === o);
        if (void 0 === i) throw new RangeError(`unmatched Hebrew month: ${n}`);
        const a = i[1].days;
        return "number" == typeof a ? a : a[t];
    }
    maxLengthOfMonthCodeInAnyYear(e) {
        return [
            "M04",
            "M06",
            "M08",
            "M10",
            "M12"
        ].includes(e) ? 29 : 30;
    }
    estimateIsoDate(e) {
        const { year: t } = e;
        return {
            year: t - 3760,
            month: 1,
            day: 1
        };
    }
    getMonthCode(e, t) {
        return this.inLeapYear({
            year: e
        }) ? 6 === t ? $68c609acd189a8b4$var$ei(5, !0) : $68c609acd189a8b4$var$ei(t < 6 ? t : t - 1) : $68c609acd189a8b4$var$ei(t);
    }
    adjustCalendarDate(e, t, n = "constrain", r = !1) {
        let { year: o, month: i, monthCode: a, day: s, monthExtra: c } = e;
        if (void 0 === o) throw new TypeError("Missing property: year");
        if (r) {
            if (c) {
                const e = this.months[c];
                if (!e) throw new RangeError(`Unrecognized month from formatToParts: ${c}`);
                i = this.inLeapYear({
                    year: o
                }) ? e.leap : e.regular;
            }
            return a = this.getMonthCode(o, i), {
                year: o,
                month: i,
                day: s,
                monthCode: a
            };
        }
        if (this.validateCalendarDate(e), void 0 === i) {
            if (a.endsWith("L")) {
                if ("M05L" !== a) throw new RangeError(`Hebrew leap month must have monthCode M05L, not ${a}`);
                if (i = 6, !this.inLeapYear({
                    year: o
                })) {
                    if ("reject" === n) throw new RangeError(`Hebrew monthCode M05L is invalid in year ${o} which is not a leap year`);
                    i = 6, a = "M06";
                }
            } else {
                i = $68c609acd189a8b4$var$Qo(a), this.inLeapYear({
                    year: o
                }) && i >= 6 && i++;
                const e = this.monthsInYear({
                    year: o
                });
                if (i < 1 || i > e) throw new RangeError(`Invalid monthCode: ${a}`);
            }
        } else if ("reject" === n ? ($68c609acd189a8b4$var$Nr(i, 1, this.monthsInYear({
            year: o
        })), $68c609acd189a8b4$var$Nr(s, 1, this.maximumMonthLength({
            year: o,
            month: i
        }))) : (i = $68c609acd189a8b4$var$jr(i, 1, this.monthsInYear({
            year: o
        })), s = $68c609acd189a8b4$var$jr(s, 1, this.maximumMonthLength({
            year: o,
            month: i
        }))), void 0 === a) a = this.getMonthCode(o, i);
        else if (this.getMonthCode(o, i) !== a) throw new RangeError(`monthCode ${a} doesn't correspond to month ${i} in Hebrew year ${o}`);
        return {
            ...e,
            day: s,
            month: i,
            monthCode: a,
            year: o
        };
    }
}
class $68c609acd189a8b4$var$IslamicBaseHelper extends $68c609acd189a8b4$var$HelperBase {
    constructor(){
        super(...arguments), this.calendarType = "lunar", this.DAYS_PER_ISLAMIC_YEAR = 354 + 11 / 30, this.DAYS_PER_ISO_YEAR = 365.2425;
    }
    inLeapYear(e, t) {
        const n = {
            year: e.year,
            month: 1,
            monthCode: "M01",
            day: 1
        }, r = {
            year: e.year + 1,
            month: 1,
            monthCode: "M01",
            day: 1
        };
        return 355 === this.calendarDaysUntil(n, r, t);
    }
    monthsInYear() {
        return 12;
    }
    minimumMonthLength() {
        return 29;
    }
    maximumMonthLength() {
        return 30;
    }
    maxLengthOfMonthCodeInAnyYear() {
        return 30;
    }
    estimateIsoDate(e) {
        const { year: t } = this.adjustCalendarDate(e);
        return {
            year: Math.floor(t * this.DAYS_PER_ISLAMIC_YEAR / this.DAYS_PER_ISO_YEAR) + 622,
            month: 1,
            day: 1
        };
    }
}
class $68c609acd189a8b4$var$IslamicHelper extends $68c609acd189a8b4$var$IslamicBaseHelper {
    constructor(){
        super(...arguments), this.id = "islamic";
    }
}
class $68c609acd189a8b4$var$IslamicUmalquraHelper extends $68c609acd189a8b4$var$IslamicBaseHelper {
    constructor(){
        super(...arguments), this.id = "islamic-umalqura";
    }
}
class $68c609acd189a8b4$var$IslamicTblaHelper extends $68c609acd189a8b4$var$IslamicBaseHelper {
    constructor(){
        super(...arguments), this.id = "islamic-tbla";
    }
}
class $68c609acd189a8b4$var$IslamicCivilHelper extends $68c609acd189a8b4$var$IslamicBaseHelper {
    constructor(){
        super(...arguments), this.id = "islamic-civil";
    }
}
class $68c609acd189a8b4$var$IslamicRgsaHelper extends $68c609acd189a8b4$var$IslamicBaseHelper {
    constructor(){
        super(...arguments), this.id = "islamic-rgsa";
    }
}
class $68c609acd189a8b4$var$IslamicCcHelper extends $68c609acd189a8b4$var$IslamicBaseHelper {
    constructor(){
        super(...arguments), this.id = "islamicc";
    }
}
class $68c609acd189a8b4$var$PersianHelper extends $68c609acd189a8b4$var$HelperBase {
    constructor(){
        super(...arguments), this.id = "persian", this.calendarType = "solar";
    }
    inLeapYear(e, t) {
        return 30 === this.daysInMonth({
            year: e.year,
            month: 12,
            day: 1
        }, t);
    }
    monthsInYear() {
        return 12;
    }
    minimumMonthLength(e) {
        const { month: t } = e;
        return 12 === t ? 29 : t <= 6 ? 31 : 30;
    }
    maximumMonthLength(e) {
        const { month: t } = e;
        return 12 === t ? 30 : t <= 6 ? 31 : 30;
    }
    maxLengthOfMonthCodeInAnyYear(e) {
        return $68c609acd189a8b4$var$Qo(e) <= 6 ? 31 : 30;
    }
    estimateIsoDate(e) {
        const { year: t } = this.adjustCalendarDate(e);
        return {
            year: t + 621,
            month: 1,
            day: 1
        };
    }
}
class $68c609acd189a8b4$var$IndianHelper extends $68c609acd189a8b4$var$HelperBase {
    constructor(){
        super(...arguments), this.id = "indian", this.calendarType = "solar", this.months = {
            1: {
                length: 30,
                month: 3,
                day: 22,
                leap: {
                    length: 31,
                    month: 3,
                    day: 21
                }
            },
            2: {
                length: 31,
                month: 4,
                day: 21
            },
            3: {
                length: 31,
                month: 5,
                day: 22
            },
            4: {
                length: 31,
                month: 6,
                day: 22
            },
            5: {
                length: 31,
                month: 7,
                day: 23
            },
            6: {
                length: 31,
                month: 8,
                day: 23
            },
            7: {
                length: 30,
                month: 9,
                day: 23
            },
            8: {
                length: 30,
                month: 10,
                day: 23
            },
            9: {
                length: 30,
                month: 11,
                day: 22
            },
            10: {
                length: 30,
                month: 12,
                day: 22
            },
            11: {
                length: 30,
                month: 1,
                nextYear: !0,
                day: 21
            },
            12: {
                length: 30,
                month: 2,
                nextYear: !0,
                day: 20
            }
        }, this.vulnerableToBceBug = "10/11/-79 Saka" !== new Date("0000-01-01T00:00Z").toLocaleDateString("en-US-u-ca-indian", {
            timeZone: "UTC"
        });
    }
    inLeapYear(e) {
        return $68c609acd189a8b4$var$oi(e.year + 78);
    }
    monthsInYear() {
        return 12;
    }
    minimumMonthLength(e) {
        return this.getMonthInfo(e).length;
    }
    maximumMonthLength(e) {
        return this.getMonthInfo(e).length;
    }
    maxLengthOfMonthCodeInAnyYear(e) {
        const t = $68c609acd189a8b4$var$Qo(e);
        let n = this.months[t];
        return n = n.leap ?? n, n.length;
    }
    getMonthInfo(e) {
        const { month: t } = e;
        let n = this.months[t];
        if (void 0 === n) throw new RangeError(`Invalid month: ${t}`);
        return this.inLeapYear(e) && n.leap && (n = n.leap), n;
    }
    estimateIsoDate(e) {
        const t = this.adjustCalendarDate(e), n = this.getMonthInfo(t);
        return $68c609acd189a8b4$var$Or(t.year + 78 + (n.nextYear ? 1 : 0), n.month, n.day + t.day - 1);
    }
    checkIcuBugs(e) {
        if (this.vulnerableToBceBug && e.year < 1) throw new RangeError(`calendar '${this.id}' is broken for ISO dates before 0001-01-01 (see https://bugs.chromium.org/p/v8/issues/detail?id=10529)`);
    }
}
function $68c609acd189a8b4$var$oi(e) {
    return e % 4 == 0 && (e % 100 != 0 || e % 400 == 0);
}
class $68c609acd189a8b4$var$GregorianBaseHelperFixedEpoch extends $68c609acd189a8b4$var$HelperBase {
    constructor(e, t){
        super(), this.calendarType = "solar", this.id = e, this.isoEpoch = t;
    }
    inLeapYear(e) {
        const { year: t } = this.estimateIsoDate({
            month: 1,
            day: 1,
            year: e.year
        });
        return $68c609acd189a8b4$var$oi(t);
    }
    monthsInYear() {
        return 12;
    }
    minimumMonthLength(e) {
        const { month: t } = e;
        return 2 === t ? this.inLeapYear(e) ? 29 : 28 : [
            4,
            6,
            9,
            11
        ].indexOf(t) >= 0 ? 30 : 31;
    }
    maximumMonthLength(e) {
        return this.minimumMonthLength(e);
    }
    maxLengthOfMonthCodeInAnyYear(e) {
        return [
            31,
            29,
            31,
            30,
            31,
            30,
            31,
            31,
            30,
            31,
            30,
            31
        ][$68c609acd189a8b4$var$Qo(e) - 1];
    }
    estimateIsoDate(e) {
        const t = this.adjustCalendarDate(e);
        return $68c609acd189a8b4$var$St(t.year + this.isoEpoch.year, t.month + this.isoEpoch.month, t.day + this.isoEpoch.day, "constrain");
    }
}
class $68c609acd189a8b4$var$GregorianBaseHelper extends $68c609acd189a8b4$var$HelperBase {
    constructor(e, t){
        super(), this.hasEra = !0, this.calendarType = "solar", this.id = e;
        const { eras: n, anchorEra: r } = function(e) {
            let t, n = e;
            if (0 === n.length) throw new RangeError("Invalid era data: eras are required");
            if (1 === n.length && n[0].reverseOf) throw new RangeError("Invalid era data: anchor era cannot count years backwards");
            if (1 === n.length && !n[0].code) throw new RangeError("Invalid era data: at least one named era is required");
            if (n.filter((e)=>null != e.reverseOf).length > 1) throw new RangeError("Invalid era data: only one era can count years backwards");
            n.forEach((e)=>{
                if (e.isAnchor || !e.anchorEpoch && !e.reverseOf) {
                    if (t) throw new RangeError("Invalid era data: cannot have multiple anchor eras");
                    t = e, e.anchorEpoch = {
                        year: e.hasYearZero ? 0 : 1
                    };
                } else if (!e.code) throw new RangeError("If era name is blank, it must be the anchor era");
            }), n = n.filter((e)=>e.code), n.forEach((e)=>{
                const { reverseOf: t } = e;
                if (t) {
                    const r = n.find((e)=>e.code === t);
                    if (void 0 === r) throw new RangeError(`Invalid era data: unmatched reverseOf era: ${t}`);
                    e.reverseOf = r, e.anchorEpoch = r.anchorEpoch, e.isoEpoch = r.isoEpoch;
                }
                void 0 === e.anchorEpoch.month && (e.anchorEpoch.month = 1), void 0 === e.anchorEpoch.day && (e.anchorEpoch.day = 1);
            }), n.sort((e, t)=>{
                if (e.reverseOf) return 1;
                if (t.reverseOf) return -1;
                if (!e.isoEpoch || !t.isoEpoch) throw new RangeError("Invalid era data: missing ISO epoch");
                return t.isoEpoch.year - e.isoEpoch.year;
            });
            const r = n[n.length - 1].reverseOf;
            if (r && r !== n[n.length - 2]) throw new RangeError("Invalid era data: invalid reverse-sign era");
            return n.forEach((e, t)=>{
                e.genericName = "era" + (n.length - 1 - t);
            }), {
                eras: n,
                anchorEra: t || n[0]
            };
        }(t);
        this.anchorEra = r, this.eras = n;
    }
    inLeapYear(e) {
        const { year: t } = this.estimateIsoDate({
            month: 1,
            day: 1,
            year: e.year
        });
        return $68c609acd189a8b4$var$oi(t);
    }
    monthsInYear() {
        return 12;
    }
    minimumMonthLength(e) {
        const { month: t } = e;
        return 2 === t ? this.inLeapYear(e) ? 29 : 28 : [
            4,
            6,
            9,
            11
        ].indexOf(t) >= 0 ? 30 : 31;
    }
    maximumMonthLength(e) {
        return this.minimumMonthLength(e);
    }
    maxLengthOfMonthCodeInAnyYear(e) {
        return [
            31,
            29,
            31,
            30,
            31,
            30,
            31,
            31,
            30,
            31,
            30,
            31
        ][$68c609acd189a8b4$var$Qo(e) - 1];
    }
    completeEraYear(e) {
        const t = (t, n, r)=>{
            const o = e[t];
            if (null != o && o != n && !(r || []).includes(o)) {
                const e = r?.[0];
                throw new RangeError(`Input ${t} ${o} doesn't match calculated value ${e ? `${n} (also called ${e})` : n}`);
            }
        }, n = (t)=>{
            let n;
            const r = {
                ...e,
                year: t
            }, o = this.eras.find((e, o)=>{
                if (o === this.eras.length - 1) {
                    if (e.reverseOf) {
                        if (t > 0) throw new RangeError(`Signed year ${t} is invalid for era ${e.code}`);
                        return n = e.anchorEpoch.year - t, !0;
                    }
                    return n = t - e.anchorEpoch.year + (e.hasYearZero ? 0 : 1), !0;
                }
                return this.compareCalendarDates(r, e.anchorEpoch) >= 0 && (n = t - e.anchorEpoch.year + (e.hasYearZero ? 0 : 1), !0);
            });
            if (!o) throw new RangeError(`Year ${t} was not matched by any era`);
            return {
                eraYear: n,
                era: o.code,
                eraNames: o.names
            };
        };
        let { year: r, eraYear: o, era: i } = e;
        if (null != r) {
            const e = n(r);
            ({ eraYear: o, era: i } = e), t("era", i, e?.eraNames), t("eraYear", o);
        } else {
            if (null == o) throw new RangeError("Either year or eraYear and era are required");
            {
                if (void 0 === i) throw new RangeError("era and eraYear must be provided together");
                const e = this.eras.find(({ code: e, names: t = [] })=>e === i || t.includes(i));
                if (!e) throw new RangeError(`Era ${i} (ISO year ${o}) was not matched by any era`);
                r = e.reverseOf ? e.anchorEpoch.year - o : o + e.anchorEpoch.year - (e.hasYearZero ? 0 : 1), t("year", r), { eraYear: o, era: i } = n(r);
            }
        }
        return {
            ...e,
            year: r,
            eraYear: o,
            era: i
        };
    }
    adjustCalendarDate(e, t, n = "constrain") {
        let r = e;
        const { month: o, monthCode: i } = r;
        return void 0 === o && (r = {
            ...r,
            month: $68c609acd189a8b4$var$Qo(i)
        }), this.validateCalendarDate(r), r = this.completeEraYear(r), super.adjustCalendarDate(r, t, n);
    }
    estimateIsoDate(e) {
        const t = this.adjustCalendarDate(e), { year: n, month: r, day: o } = t, { anchorEra: i } = this;
        return $68c609acd189a8b4$var$St(n + i.isoEpoch.year - (i.hasYearZero ? 0 : 1), r, o, "constrain");
    }
}
class $68c609acd189a8b4$var$SameMonthDayAsGregorianBaseHelper extends $68c609acd189a8b4$var$GregorianBaseHelper {
    constructor(e, t){
        super(e, t);
    }
    isoToCalendarDate(e) {
        const { year: t, month: n, day: r } = e, o = $68c609acd189a8b4$var$ei(n), i = t - this.anchorEra.isoEpoch.year + 1;
        return this.completeEraYear({
            year: i,
            month: n,
            monthCode: o,
            day: r
        });
    }
}
const $68c609acd189a8b4$var$ii = {
    inLeapYear (e) {
        const { year: t } = e;
        return (t + 1) % 4 == 0;
    },
    monthsInYear: ()=>13,
    minimumMonthLength (e) {
        const { month: t } = e;
        return 13 === t ? this.inLeapYear(e) ? 6 : 5 : 30;
    },
    maximumMonthLength (e) {
        return this.minimumMonthLength(e);
    },
    maxLengthOfMonthCodeInAnyYear: (e)=>"M13" === e ? 6 : 30
};
class $68c609acd189a8b4$var$OrthodoxBaseHelperFixedEpoch extends $68c609acd189a8b4$var$GregorianBaseHelperFixedEpoch {
    constructor(e, t){
        super(e, t), this.inLeapYear = $68c609acd189a8b4$var$ii.inLeapYear, this.monthsInYear = $68c609acd189a8b4$var$ii.monthsInYear, this.minimumMonthLength = $68c609acd189a8b4$var$ii.minimumMonthLength, this.maximumMonthLength = $68c609acd189a8b4$var$ii.maximumMonthLength, this.maxLengthOfMonthCodeInAnyYear = $68c609acd189a8b4$var$ii.maxLengthOfMonthCodeInAnyYear;
    }
}
class $68c609acd189a8b4$var$OrthodoxBaseHelper extends $68c609acd189a8b4$var$GregorianBaseHelper {
    constructor(e, t){
        super(e, t), this.inLeapYear = $68c609acd189a8b4$var$ii.inLeapYear, this.monthsInYear = $68c609acd189a8b4$var$ii.monthsInYear, this.minimumMonthLength = $68c609acd189a8b4$var$ii.minimumMonthLength, this.maximumMonthLength = $68c609acd189a8b4$var$ii.maximumMonthLength, this.maxLengthOfMonthCodeInAnyYear = $68c609acd189a8b4$var$ii.maxLengthOfMonthCodeInAnyYear;
    }
}
class $68c609acd189a8b4$var$EthioaaHelper extends $68c609acd189a8b4$var$OrthodoxBaseHelperFixedEpoch {
    constructor(){
        super("ethioaa", {
            year: -5492,
            month: 7,
            day: 17
        });
    }
}
class $68c609acd189a8b4$var$CopticHelper extends $68c609acd189a8b4$var$OrthodoxBaseHelper {
    constructor(){
        super("coptic", [
            {
                code: "coptic",
                isoEpoch: {
                    year: 284,
                    month: 8,
                    day: 29
                }
            },
            {
                code: "coptic-inverse",
                reverseOf: "coptic"
            }
        ]);
    }
}
class $68c609acd189a8b4$var$EthiopicHelper extends $68c609acd189a8b4$var$OrthodoxBaseHelper {
    constructor(){
        super("ethiopic", [
            {
                code: "ethioaa",
                names: [
                    "ethiopic-amete-alem",
                    "mundi"
                ],
                isoEpoch: {
                    year: -5492,
                    month: 7,
                    day: 17
                }
            },
            {
                code: "ethiopic",
                names: [
                    "incar"
                ],
                isoEpoch: {
                    year: 8,
                    month: 8,
                    day: 27
                },
                anchorEpoch: {
                    year: 5501
                }
            }
        ]);
    }
}
class $68c609acd189a8b4$var$RocHelper extends $68c609acd189a8b4$var$SameMonthDayAsGregorianBaseHelper {
    constructor(){
        super("roc", [
            {
                code: "roc",
                names: [
                    "minguo"
                ],
                isoEpoch: {
                    year: 1912,
                    month: 1,
                    day: 1
                }
            },
            {
                code: "roc-inverse",
                names: [
                    "before-roc"
                ],
                reverseOf: "roc"
            }
        ]);
    }
}
class $68c609acd189a8b4$var$BuddhistHelper extends $68c609acd189a8b4$var$GregorianBaseHelperFixedEpoch {
    constructor(){
        super("buddhist", {
            year: -543,
            month: 1,
            day: 1
        });
    }
}
class $68c609acd189a8b4$var$GregoryHelper extends $68c609acd189a8b4$var$SameMonthDayAsGregorianBaseHelper {
    constructor(){
        super("gregory", [
            {
                code: "gregory",
                names: [
                    "ad",
                    "ce"
                ],
                isoEpoch: {
                    year: 1,
                    month: 1,
                    day: 1
                }
            },
            {
                code: "gregory-inverse",
                names: [
                    "be",
                    "bce"
                ],
                reverseOf: "gregory"
            }
        ]);
    }
    reviseIntlEra(e) {
        let { era: t, eraYear: n } = e;
        return "b" === t && (t = "gregory-inverse"), "a" === t && (t = "gregory"), {
            era: t,
            eraYear: n
        };
    }
    getFirstDayOfWeek() {
        return 1;
    }
    getMinimalDaysInFirstWeek() {
        return 1;
    }
}
class $68c609acd189a8b4$var$JapaneseHelper extends $68c609acd189a8b4$var$SameMonthDayAsGregorianBaseHelper {
    constructor(){
        super("japanese", [
            {
                code: "reiwa",
                isoEpoch: {
                    year: 2019,
                    month: 5,
                    day: 1
                },
                anchorEpoch: {
                    year: 2019,
                    month: 5,
                    day: 1
                }
            },
            {
                code: "heisei",
                isoEpoch: {
                    year: 1989,
                    month: 1,
                    day: 8
                },
                anchorEpoch: {
                    year: 1989,
                    month: 1,
                    day: 8
                }
            },
            {
                code: "showa",
                isoEpoch: {
                    year: 1926,
                    month: 12,
                    day: 25
                },
                anchorEpoch: {
                    year: 1926,
                    month: 12,
                    day: 25
                }
            },
            {
                code: "taisho",
                isoEpoch: {
                    year: 1912,
                    month: 7,
                    day: 30
                },
                anchorEpoch: {
                    year: 1912,
                    month: 7,
                    day: 30
                }
            },
            {
                code: "meiji",
                isoEpoch: {
                    year: 1868,
                    month: 9,
                    day: 8
                },
                anchorEpoch: {
                    year: 1868,
                    month: 9,
                    day: 8
                }
            },
            {
                code: "japanese",
                names: [
                    "japanese",
                    "gregory",
                    "ad",
                    "ce"
                ],
                isoEpoch: {
                    year: 1,
                    month: 1,
                    day: 1
                }
            },
            {
                code: "japanese-inverse",
                names: [
                    "japanese-inverse",
                    "gregory-inverse",
                    "bc",
                    "bce"
                ],
                reverseOf: "japanese"
            }
        ]), this.erasBeginMidYear = !0;
    }
    reviseIntlEra(e, t) {
        const { era: n, eraYear: r } = e, { year: o } = t;
        return this.eras.find((e)=>e.code === n) ? {
            era: n,
            eraYear: r
        } : o < 1 ? {
            era: "japanese-inverse",
            eraYear: 1 - o
        } : {
            era: "japanese",
            eraYear: o
        };
    }
}
class $68c609acd189a8b4$var$ChineseBaseHelper extends $68c609acd189a8b4$var$HelperBase {
    constructor(){
        super(...arguments), this.calendarType = "lunisolar";
    }
    inLeapYear(e, t) {
        const n = this.getMonthList(e.year, t);
        return 13 === Object.entries(n).length;
    }
    monthsInYear(e, t) {
        return this.inLeapYear(e, t) ? 13 : 12;
    }
    minimumMonthLength() {
        return 29;
    }
    maximumMonthLength() {
        return 30;
    }
    maxLengthOfMonthCodeInAnyYear(e) {
        return [
            "M01L",
            "M09L",
            "M10L",
            "M11L",
            "M12L"
        ].includes(e) ? 29 : 30;
    }
    monthDaySearchStartYear(e, t) {
        const n = {
            M01L: [
                1651,
                1651
            ],
            M02L: [
                1947,
                1765
            ],
            M03L: [
                1966,
                1955
            ],
            M04L: [
                1963,
                1944
            ],
            M05L: [
                1971,
                1952
            ],
            M06L: [
                1960,
                1941
            ],
            M07L: [
                1968,
                1938
            ],
            M08L: [
                1957,
                1718
            ],
            M09L: [
                1832,
                1832
            ],
            M10L: [
                1870,
                1870
            ],
            M11L: [
                1814,
                1814
            ],
            M12L: [
                1890,
                1890
            ]
        }[e] ?? [
            1972,
            1972
        ];
        return t < 30 ? n[0] : n[1];
    }
    getMonthList(e, t) {
        if (void 0 === e) throw new TypeError("Missing year");
        const n = JSON.stringify({
            func: "getMonthList",
            calendarYear: e,
            id: this.id
        }), r = t.get(n);
        if (r) return r;
        const o = this.getFormatter(), i = (e, t)=>{
            const n = $68c609acd189a8b4$var$ni({
                isoYear: e,
                isoMonth: 2,
                isoDay: 1
            }), r = new Date(n);
            r.setUTCDate(t + 1);
            const i = o.formatToParts(r), a = i.find((e)=>"month" === e.type).value, s = +i.find((e)=>"day" === e.type).value, c = i.find((e)=>"relatedYear" === e.type);
            let d;
            if (void 0 === c) throw new RangeError(`Intl.DateTimeFormat.formatToParts lacks relatedYear in ${this.id} calendar. Try Node 14+ or modern browsers.`);
            return d = +c.value, {
                calendarMonthString: a,
                calendarDay: s,
                calendarYearToVerify: d
            };
        };
        let a = 17, { calendarMonthString: s, calendarDay: c, calendarYearToVerify: d } = i(e, a);
        "1" !== s && (a += 29, { calendarMonthString: s, calendarDay: c } = i(e, a)), a -= c - 5;
        const h = {};
        let u, l, m = 1, f = !1;
        do ({ calendarMonthString: s, calendarDay: c, calendarYearToVerify: d } = i(e, a)), u && (h[l].daysInMonth = u + 30 - c), d !== e ? f = !0 : (h[s] = {
            monthIndex: m++
        }, a += 30), u = c, l = s;
        while (!f);
        return h[l].daysInMonth = u + 30 - c, t.set(n, h), h;
    }
    estimateIsoDate(e) {
        const { year: t, month: n } = e;
        return {
            year: t,
            month: n >= 12 ? 12 : n + 1,
            day: 1
        };
    }
    adjustCalendarDate(e, t, n = "constrain", r = !1) {
        let { year: o, month: i, monthExtra: a, day: s, monthCode: c } = e;
        if (void 0 === o) throw new TypeError("Missing property: year");
        if (r) {
            if (a && "bis" !== a) throw new RangeError(`Unexpected leap month suffix: ${a}`);
            const e = $68c609acd189a8b4$var$ei(i, void 0 !== a), n = `${i}${a || ""}`, r = this.getMonthList(o, t)[n];
            if (void 0 === r) throw new RangeError(`Unmatched month ${n} in Chinese year ${o}`);
            return i = r.monthIndex, {
                year: o,
                month: i,
                day: s,
                monthCode: e
            };
        }
        if (this.validateCalendarDate(e), void 0 === i) {
            const e = this.getMonthList(o, t);
            let r = c.replace(/^M|L$/g, (e)=>"L" === e ? "bis" : "");
            "0" === r[0] && (r = r.slice(1));
            let a = e[r];
            if (i = a && a.monthIndex, void 0 === i && c.endsWith("L") && "M13L" != c && "constrain" === n) {
                const t = +c.replace(/^M0?|L$/g, "");
                a = e[t], a && (i = a.monthIndex, c = $68c609acd189a8b4$var$ei(t));
            }
            if (void 0 === i) throw new RangeError(`Unmatched month ${c} in Chinese year ${o}`);
        } else if (void 0 === c) {
            const e = this.getMonthList(o, t), r = Object.entries(e), a = r.length;
            "reject" === n ? ($68c609acd189a8b4$var$Nr(i, 1, a), $68c609acd189a8b4$var$Nr(s, 1, this.maximumMonthLength())) : (i = $68c609acd189a8b4$var$jr(i, 1, a), s = $68c609acd189a8b4$var$jr(s, 1, this.maximumMonthLength()));
            const d = r.find((e)=>e[1].monthIndex === i);
            if (void 0 === d) throw new RangeError(`Invalid month ${i} in Chinese year ${o}`);
            c = $68c609acd189a8b4$var$ei(+d[0].replace("bis", ""), -1 !== d[0].indexOf("bis"));
        } else {
            const e = this.getMonthList(o, t);
            let n = c.replace(/^M|L$/g, (e)=>"L" === e ? "bis" : "");
            "0" === n[0] && (n = n.slice(1));
            const r = e[n];
            if (!r) throw new RangeError(`Unmatched monthCode ${c} in Chinese year ${o}`);
            if (i !== r.monthIndex) throw new RangeError(`monthCode ${c} doesn't correspond to month ${i} in Chinese year ${o}`);
        }
        return {
            ...e,
            year: o,
            month: i,
            monthCode: c,
            day: s
        };
    }
}
class $68c609acd189a8b4$var$ChineseHelper extends $68c609acd189a8b4$var$ChineseBaseHelper {
    constructor(){
        super(...arguments), this.id = "chinese";
    }
}
class $68c609acd189a8b4$var$DangiHelper extends $68c609acd189a8b4$var$ChineseBaseHelper {
    constructor(){
        super(...arguments), this.id = "dangi";
    }
}
class $68c609acd189a8b4$var$NonIsoCalendar {
    constructor(e){
        this.helper = e;
    }
    extraFields(e) {
        return this.helper.hasEra && e.includes("year") ? [
            "era",
            "eraYear"
        ] : [];
    }
    resolveFields(e) {
        if ("lunisolar" !== this.helper.calendarType) {
            const t = new $68c609acd189a8b4$var$OneObjectCache;
            $68c609acd189a8b4$var$ti(e, void 0, this.helper.monthsInYear({
                year: e.year ?? 1972
            }, t));
        }
    }
    dateToISO(e, t) {
        const n = new $68c609acd189a8b4$var$OneObjectCache, r = this.helper.calendarToIsoDate(e, t, n);
        return n.setObject(r), r;
    }
    monthDayToISOReferenceDate(e, t) {
        const n = new $68c609acd189a8b4$var$OneObjectCache, r = this.helper.monthDayFromFields(e, t, n);
        return n.setObject(r), r;
    }
    fieldKeysToIgnore(e) {
        const t = new Set;
        for(let n = 0; n < e.length; n++){
            const r = e[n];
            switch(t.add(r), r){
                case "era":
                    t.add("eraYear"), t.add("year");
                    break;
                case "eraYear":
                    t.add("era"), t.add("year");
                    break;
                case "year":
                    t.add("era"), t.add("eraYear");
                    break;
                case "month":
                    t.add("monthCode"), this.helper.erasBeginMidYear && (t.add("era"), t.add("eraYear"));
                    break;
                case "monthCode":
                    t.add("month"), this.helper.erasBeginMidYear && (t.add("era"), t.add("eraYear"));
                    break;
                case "day":
                    this.helper.erasBeginMidYear && (t.add("era"), t.add("eraYear"));
            }
        }
        return $68c609acd189a8b4$var$Go(t);
    }
    dateAdd(e, { years: t, months: n, weeks: r, days: o }, i) {
        const a = $68c609acd189a8b4$var$OneObjectCache.getCacheForObject(e), s = this.helper.isoToCalendarDate(e, a), c = this.helper.addCalendar(s, {
            years: t,
            months: n,
            weeks: r,
            days: o
        }, i, a), d = this.helper.calendarToIsoDate(c, "constrain", a);
        return $68c609acd189a8b4$var$OneObjectCache.getCacheForObject(d) || new $68c609acd189a8b4$var$OneObjectCache(a).setObject(d), d;
    }
    dateUntil(e, t, n) {
        const r = $68c609acd189a8b4$var$OneObjectCache.getCacheForObject(e), o = $68c609acd189a8b4$var$OneObjectCache.getCacheForObject(t), i = this.helper.isoToCalendarDate(e, r), a = this.helper.isoToCalendarDate(t, o);
        return this.helper.untilCalendar(i, a, n, r);
    }
    isoToDate(e, t) {
        const n = $68c609acd189a8b4$var$OneObjectCache.getCacheForObject(e), r = this.helper.isoToCalendarDate(e, n);
        if (t.dayOfWeek && (r.dayOfWeek = $68c609acd189a8b4$var$Xo.iso8601.isoToDate(e, {
            dayOfWeek: !0
        }).dayOfWeek), t.dayOfYear) {
            const e = this.helper.startOfCalendarYear(r), t = this.helper.calendarDaysUntil(e, r, n);
            r.dayOfYear = t + 1;
        }
        if (t.weekOfYear && (r.weekOfYear = $68c609acd189a8b4$var$Ko(this.helper.id, e)), r.daysInWeek = 7, t.daysInMonth && (r.daysInMonth = this.helper.daysInMonth(r, n)), t.daysInYear) {
            const e = this.helper.startOfCalendarYear(r), t = this.helper.addCalendar(e, {
                years: 1
            }, "constrain", n);
            r.daysInYear = this.helper.calendarDaysUntil(e, t, n);
        }
        return t.monthsInYear && (r.monthsInYear = this.helper.monthsInYear(r, n)), t.inLeapYear && (r.inLeapYear = this.helper.inLeapYear(r, n)), r;
    }
    getFirstDayOfWeek() {
        return this.helper.getFirstDayOfWeek();
    }
    getMinimalDaysInFirstWeek() {
        return this.helper.getMinimalDaysInFirstWeek();
    }
}
for (const e of [
    $68c609acd189a8b4$var$HebrewHelper,
    $68c609acd189a8b4$var$PersianHelper,
    $68c609acd189a8b4$var$EthiopicHelper,
    $68c609acd189a8b4$var$EthioaaHelper,
    $68c609acd189a8b4$var$CopticHelper,
    $68c609acd189a8b4$var$ChineseHelper,
    $68c609acd189a8b4$var$DangiHelper,
    $68c609acd189a8b4$var$RocHelper,
    $68c609acd189a8b4$var$IndianHelper,
    $68c609acd189a8b4$var$BuddhistHelper,
    $68c609acd189a8b4$var$GregoryHelper,
    $68c609acd189a8b4$var$JapaneseHelper,
    $68c609acd189a8b4$var$IslamicHelper,
    $68c609acd189a8b4$var$IslamicUmalquraHelper,
    $68c609acd189a8b4$var$IslamicTblaHelper,
    $68c609acd189a8b4$var$IslamicCivilHelper,
    $68c609acd189a8b4$var$IslamicRgsaHelper,
    $68c609acd189a8b4$var$IslamicCcHelper
]){
    const t = new e;
    $68c609acd189a8b4$var$Xo[t.id] = new $68c609acd189a8b4$var$NonIsoCalendar(t);
}
$68c609acd189a8b4$var$se("calendarImpl", function(e) {
    return $68c609acd189a8b4$var$Xo[e];
});
const $68c609acd189a8b4$var$ai = Intl.DateTimeFormat;
function $68c609acd189a8b4$var$si(e, t) {
    let n = $68c609acd189a8b4$var$re(e, t);
    return "function" == typeof n && (n = new $68c609acd189a8b4$var$ai($68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$G), n($68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$K))), function(e, t, n) {
        const r = $68c609acd189a8b4$var$Q(e);
        if (void 0 === r) throw new TypeError("Missing slots for the given container");
        if (void 0 === r[t]) throw new TypeError(`tried to reset ${t} which was not set`);
        r[t] = n;
    }(e, t, n)), n;
}
function $68c609acd189a8b4$var$ci(e) {
    return $68c609acd189a8b4$var$ne(e, $68c609acd189a8b4$var$q);
}
class $68c609acd189a8b4$var$DateTimeFormatImpl {
    constructor(e, t){
        !function(e, t, n) {
            const r = void 0 !== n;
            let o;
            if (r) {
                const e = [
                    "localeMatcher",
                    "calendar",
                    "numberingSystem",
                    "hour12",
                    "hourCycle",
                    "timeZone",
                    "weekday",
                    "era",
                    "year",
                    "month",
                    "day",
                    "dayPeriod",
                    "hour",
                    "minute",
                    "second",
                    "fractionalSecondDigits",
                    "timeZoneName",
                    "formatMatcher",
                    "dateStyle",
                    "timeStyle"
                ];
                o = function(e) {
                    if (null == e) throw new TypeError(`Expected object not ${e}`);
                    return Object(e);
                }(n);
                const t = Object.create(null);
                for(let n = 0; n < e.length; n++){
                    const r = e[n];
                    Object.prototype.hasOwnProperty.call(o, r) && (t[r] = o[r]);
                }
                o = t;
            } else o = Object.create(null);
            const i = new $68c609acd189a8b4$var$ai(t, o), a = i.resolvedOptions();
            if ($68c609acd189a8b4$var$te(e), r) {
                const t = Object.assign(Object.create(null), a);
                for(const e in t)Object.prototype.hasOwnProperty.call(o, e) || delete t[e];
                t.hour12 = o.hour12, t.hourCycle = o.hourCycle, $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$K, t);
            } else $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$K, o);
            $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$G, a.locale), $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$q, i), $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$W, a.timeZone), $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$J, a.calendar), $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$B, $68c609acd189a8b4$var$vi), $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$Z, $68c609acd189a8b4$var$gi), $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$F, $68c609acd189a8b4$var$wi), $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$H, $68c609acd189a8b4$var$pi), $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$z, $68c609acd189a8b4$var$bi), $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$A, $68c609acd189a8b4$var$Di);
            const s = r ? o.timeZone : void 0;
            if (void 0 === s) $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$_, a.timeZone);
            else {
                const t = $68c609acd189a8b4$var$We(s);
                if (t.startsWith("\u2212")) throw new RangeError("Unicode minus (U+2212) is not supported in time zone offsets");
                $68c609acd189a8b4$var$oe(e, $68c609acd189a8b4$var$_, $68c609acd189a8b4$var$Bn(t));
            }
        }(this, e, t);
    }
    get format() {
        $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ci);
        const e = $68c609acd189a8b4$var$ui.bind(this);
        return Object.defineProperties(e, {
            length: {
                value: 1,
                enumerable: !1,
                writable: !1,
                configurable: !0
            },
            name: {
                value: "",
                enumerable: !1,
                writable: !1,
                configurable: !0
            }
        }), e;
    }
    formatRange(e, t) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ci), $68c609acd189a8b4$var$mi.call(this, e, t);
    }
    formatToParts(e, ...t) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ci), $68c609acd189a8b4$var$li.call(this, e, ...t);
    }
    formatRangeToParts(e, t) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ci), $68c609acd189a8b4$var$fi.call(this, e, t);
    }
    resolvedOptions() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ci), $68c609acd189a8b4$var$hi.call(this);
    }
}
"formatToParts" in $68c609acd189a8b4$var$ai.prototype || delete $68c609acd189a8b4$var$DateTimeFormatImpl.prototype.formatToParts, "formatRangeToParts" in $68c609acd189a8b4$var$ai.prototype || delete $68c609acd189a8b4$var$DateTimeFormatImpl.prototype.formatRangeToParts;
const $68c609acd189a8b4$var$di = function(e, t) {
    return new $68c609acd189a8b4$var$DateTimeFormatImpl(e, t);
};
function $68c609acd189a8b4$var$hi() {
    const e = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$q).resolvedOptions();
    return e.timeZone = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$_), e;
}
function $68c609acd189a8b4$var$ui(e, ...t) {
    let n, r, o = $68c609acd189a8b4$var$$i(e, this);
    return o.formatter ? (n = o.formatter, r = [
        $68c609acd189a8b4$var$No(o.epochNs, "floor")
    ]) : (n = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$q), r = [
        e,
        ...t
    ]), n.format(...r);
}
function $68c609acd189a8b4$var$li(e, ...t) {
    let n, r, o = $68c609acd189a8b4$var$$i(e, this);
    return o.formatter ? (n = o.formatter, r = [
        $68c609acd189a8b4$var$No(o.epochNs, "floor")
    ]) : (n = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$q), r = [
        e,
        ...t
    ]), n.formatToParts(...r);
}
function $68c609acd189a8b4$var$mi(e, t) {
    if (void 0 === e || void 0 === t) throw new TypeError("Intl.DateTimeFormat.formatRange requires two values");
    const n = $68c609acd189a8b4$var$Ci(e), r = $68c609acd189a8b4$var$Ci(t);
    let o, i = [
        n,
        r
    ];
    if ($68c609acd189a8b4$var$Ii(n) !== $68c609acd189a8b4$var$Ii(r)) throw new TypeError("Intl.DateTimeFormat.formatRange accepts two values of the same type");
    if ($68c609acd189a8b4$var$Ii(n)) {
        if (!$68c609acd189a8b4$var$Oi(n, r)) throw new TypeError("Intl.DateTimeFormat.formatRange accepts two values of the same type");
        const { epochNs: e, formatter: t } = $68c609acd189a8b4$var$$i(n, this), { epochNs: a, formatter: s } = $68c609acd189a8b4$var$$i(r, this);
        t && (o = t, i = [
            $68c609acd189a8b4$var$No(e, "floor"),
            $68c609acd189a8b4$var$No(a, "floor")
        ]);
    }
    return o || (o = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$q)), o.formatRange(...i);
}
function $68c609acd189a8b4$var$fi(e, t) {
    if (void 0 === e || void 0 === t) throw new TypeError("Intl.DateTimeFormat.formatRange requires two values");
    const n = $68c609acd189a8b4$var$Ci(e), r = $68c609acd189a8b4$var$Ci(t);
    let o, i = [
        n,
        r
    ];
    if ($68c609acd189a8b4$var$Ii(n) !== $68c609acd189a8b4$var$Ii(r)) throw new TypeError("Intl.DateTimeFormat.formatRangeToParts accepts two values of the same type");
    if ($68c609acd189a8b4$var$Ii(n)) {
        if (!$68c609acd189a8b4$var$Oi(n, r)) throw new TypeError("Intl.DateTimeFormat.formatRangeToParts accepts two values of the same type");
        const { epochNs: e, formatter: t } = $68c609acd189a8b4$var$$i(n, this), { epochNs: a, formatter: s } = $68c609acd189a8b4$var$$i(r, this);
        t && (o = t, i = [
            $68c609acd189a8b4$var$No(e, "floor"),
            $68c609acd189a8b4$var$No(a, "floor")
        ]);
    }
    return o || (o = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$q)), o.formatRangeToParts(...i);
}
function $68c609acd189a8b4$var$yi(e = {}, t = {}) {
    const n = Object.assign({}, e), r = [
        "year",
        "month",
        "day",
        "hour",
        "minute",
        "second",
        "weekday",
        "dayPeriod",
        "timeZoneName",
        "dateStyle",
        "timeStyle"
    ];
    for(let e = 0; e < r.length; e++){
        const o = r[e];
        n[o] = o in t ? t[o] : n[o], !1 !== n[o] && void 0 !== n[o] || delete n[o];
    }
    return n;
}
function $68c609acd189a8b4$var$pi(e) {
    const t = $68c609acd189a8b4$var$yi(e, {
        year: !1,
        month: !1,
        day: !1,
        weekday: !1,
        timeZoneName: !1,
        dateStyle: !1
    });
    if ("long" !== t.timeStyle && "full" !== t.timeStyle || (delete t.timeStyle, Object.assign(t, {
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit"
    })), !$68c609acd189a8b4$var$Mi(t)) {
        if ($68c609acd189a8b4$var$Ei(e)) throw new TypeError(`cannot format Temporal.PlainTime with options [${Object.keys(e)}]`);
        Object.assign(t, {
            hour: "numeric",
            minute: "numeric",
            second: "numeric"
        });
    }
    return t;
}
function $68c609acd189a8b4$var$gi(e) {
    const t = {
        short: {
            year: "2-digit",
            month: "numeric"
        },
        medium: {
            year: "numeric",
            month: "short"
        },
        long: {
            year: "numeric",
            month: "long"
        },
        full: {
            year: "numeric",
            month: "long"
        }
    }, n = $68c609acd189a8b4$var$yi(e, {
        day: !1,
        hour: !1,
        minute: !1,
        second: !1,
        weekday: !1,
        dayPeriod: !1,
        timeZoneName: !1,
        timeStyle: !1
    });
    if ("dateStyle" in n && n.dateStyle) {
        const e = n.dateStyle;
        delete n.dateStyle, Object.assign(n, t[e]);
    }
    if (!("year" in n || "month" in n || "era" in n)) {
        if ($68c609acd189a8b4$var$Ei(e)) throw new TypeError(`cannot format PlainYearMonth with options [${Object.keys(e)}]`);
        Object.assign(n, {
            year: "numeric",
            month: "numeric"
        });
    }
    return n;
}
function $68c609acd189a8b4$var$wi(e) {
    const t = {
        short: {
            month: "numeric",
            day: "numeric"
        },
        medium: {
            month: "short",
            day: "numeric"
        },
        long: {
            month: "long",
            day: "numeric"
        },
        full: {
            month: "long",
            day: "numeric"
        }
    }, n = $68c609acd189a8b4$var$yi(e, {
        year: !1,
        hour: !1,
        minute: !1,
        second: !1,
        weekday: !1,
        dayPeriod: !1,
        timeZoneName: !1,
        timeStyle: !1
    });
    if ("dateStyle" in n && n.dateStyle) {
        const e = n.dateStyle;
        delete n.dateStyle, Object.assign(n, t[e]);
    }
    if (!("month" in n) && !("day" in n)) {
        if ($68c609acd189a8b4$var$Ei(e)) throw new TypeError(`cannot format PlainMonthDay with options [${Object.keys(e)}]`);
        Object.assign(n, {
            month: "numeric",
            day: "numeric"
        });
    }
    return n;
}
function $68c609acd189a8b4$var$vi(e) {
    const t = $68c609acd189a8b4$var$yi(e, {
        hour: !1,
        minute: !1,
        second: !1,
        dayPeriod: !1,
        timeZoneName: !1,
        timeStyle: !1
    });
    if (!$68c609acd189a8b4$var$Ti(t)) {
        if ($68c609acd189a8b4$var$Ei(e)) throw new TypeError(`cannot format PlainDate with options [${Object.keys(e)}]`);
        Object.assign(t, {
            year: "numeric",
            month: "numeric",
            day: "numeric"
        });
    }
    return t;
}
function $68c609acd189a8b4$var$bi(e) {
    const t = $68c609acd189a8b4$var$yi(e, {
        timeZoneName: !1
    });
    if (("long" === t.timeStyle || "full" === t.timeStyle) && (delete t.timeStyle, Object.assign(t, {
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit"
    }), t.dateStyle)) {
        const e = {
            short: {
                year: "numeric",
                month: "numeric",
                day: "numeric"
            },
            medium: {
                year: "numeric",
                month: "short",
                day: "numeric"
            },
            long: {
                year: "numeric",
                month: "long",
                day: "numeric"
            },
            full: {
                year: "numeric",
                month: "long",
                day: "numeric",
                weekday: "long"
            }
        };
        Object.assign(t, e[t.dateStyle]), delete t.dateStyle;
    }
    if (!$68c609acd189a8b4$var$Mi(t) && !$68c609acd189a8b4$var$Ti(t)) {
        if ($68c609acd189a8b4$var$Ei(e)) throw new TypeError(`cannot format PlainDateTime with options [${Object.keys(e)}]`);
        Object.assign(t, {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric"
        });
    }
    return t;
}
function $68c609acd189a8b4$var$Di(e) {
    let t = e;
    return $68c609acd189a8b4$var$Mi(t) || $68c609acd189a8b4$var$Ti(t) || (t = Object.assign({}, t, {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
    })), t;
}
function $68c609acd189a8b4$var$Ti(e) {
    return "year" in e || "month" in e || "day" in e || "weekday" in e || "dateStyle" in e || "era" in e;
}
function $68c609acd189a8b4$var$Mi(e) {
    return "hour" in e || "minute" in e || "second" in e || "timeStyle" in e || "dayPeriod" in e || "fractionalSecondDigits" in e;
}
function $68c609acd189a8b4$var$Ei(e) {
    return $68c609acd189a8b4$var$Ti(e) || $68c609acd189a8b4$var$Mi(e) || "dateStyle" in e || "timeStyle" in e || "timeZoneName" in e;
}
function $68c609acd189a8b4$var$Ii(e) {
    return $68c609acd189a8b4$var$mt(e) || $68c609acd189a8b4$var$ft(e) || $68c609acd189a8b4$var$yt(e) || $68c609acd189a8b4$var$wt(e) || $68c609acd189a8b4$var$pt(e) || $68c609acd189a8b4$var$gt(e) || $68c609acd189a8b4$var$ut(e);
}
function $68c609acd189a8b4$var$Ci(e) {
    return $68c609acd189a8b4$var$Ii(e) ? e : $68c609acd189a8b4$var$qe(e);
}
function $68c609acd189a8b4$var$Oi(e, t) {
    return !(!$68c609acd189a8b4$var$Ii(e) || !$68c609acd189a8b4$var$Ii(t) || $68c609acd189a8b4$var$ft(e) && !$68c609acd189a8b4$var$ft(t) || $68c609acd189a8b4$var$mt(e) && !$68c609acd189a8b4$var$mt(t) || $68c609acd189a8b4$var$yt(e) && !$68c609acd189a8b4$var$yt(t) || $68c609acd189a8b4$var$wt(e) && !$68c609acd189a8b4$var$wt(t) || $68c609acd189a8b4$var$pt(e) && !$68c609acd189a8b4$var$pt(t) || $68c609acd189a8b4$var$gt(e) && !$68c609acd189a8b4$var$gt(t) || $68c609acd189a8b4$var$ut(e) && !$68c609acd189a8b4$var$ut(t));
}
function $68c609acd189a8b4$var$$i(e, t) {
    if ($68c609acd189a8b4$var$ft(e)) {
        const n = {
            isoDate: {
                year: 1970,
                month: 1,
                day: 1
            },
            time: $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$M)
        };
        return {
            epochNs: $68c609acd189a8b4$var$An($68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$W), n, "compatible"),
            formatter: $68c609acd189a8b4$var$si(t, $68c609acd189a8b4$var$H)
        };
    }
    if ($68c609acd189a8b4$var$pt(e)) {
        const n = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$E), r = $68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$J);
        if (n !== r) throw new RangeError(`cannot format PlainYearMonth with calendar ${n} in locale with calendar ${r}`);
        const o = $68c609acd189a8b4$var$xt($68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$D), {
            deltaDays: 0,
            hour: 12,
            minute: 0,
            second: 0,
            millisecond: 0,
            microsecond: 0,
            nanosecond: 0
        });
        return {
            epochNs: $68c609acd189a8b4$var$An($68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$W), o, "compatible"),
            formatter: $68c609acd189a8b4$var$si(t, $68c609acd189a8b4$var$Z)
        };
    }
    if ($68c609acd189a8b4$var$gt(e)) {
        const n = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$E), r = $68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$J);
        if (n !== r) throw new RangeError(`cannot format PlainMonthDay with calendar ${n} in locale with calendar ${r}`);
        const o = $68c609acd189a8b4$var$xt($68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$D), {
            deltaDays: 0,
            hour: 12,
            minute: 0,
            second: 0,
            millisecond: 0,
            microsecond: 0,
            nanosecond: 0
        });
        return {
            epochNs: $68c609acd189a8b4$var$An($68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$W), o, "compatible"),
            formatter: $68c609acd189a8b4$var$si(t, $68c609acd189a8b4$var$F)
        };
    }
    if ($68c609acd189a8b4$var$mt(e)) {
        const n = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$E), r = $68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$J);
        if ("iso8601" !== n && n !== r) throw new RangeError(`cannot format PlainDate with calendar ${n} in locale with calendar ${r}`);
        const o = $68c609acd189a8b4$var$xt($68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$D), {
            deltaDays: 0,
            hour: 12,
            minute: 0,
            second: 0,
            millisecond: 0,
            microsecond: 0,
            nanosecond: 0
        });
        return {
            epochNs: $68c609acd189a8b4$var$An($68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$W), o, "compatible"),
            formatter: $68c609acd189a8b4$var$si(t, $68c609acd189a8b4$var$B)
        };
    }
    if ($68c609acd189a8b4$var$yt(e)) {
        const n = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$E), r = $68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$J);
        if ("iso8601" !== n && n !== r) throw new RangeError(`cannot format PlainDateTime with calendar ${n} in locale with calendar ${r}`);
        const o = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$T);
        return {
            epochNs: $68c609acd189a8b4$var$An($68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$W), o, "compatible"),
            formatter: $68c609acd189a8b4$var$si(t, $68c609acd189a8b4$var$z)
        };
    }
    if ($68c609acd189a8b4$var$wt(e)) throw new TypeError("Temporal.ZonedDateTime not supported in DateTimeFormat methods. Use toLocaleString() instead.");
    return $68c609acd189a8b4$var$ut(e) ? {
        epochNs: $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$b),
        formatter: $68c609acd189a8b4$var$si(t, $68c609acd189a8b4$var$A)
    } : {};
}
function $68c609acd189a8b4$var$Yi(e) {
    const t = Object.create(null);
    return t.years = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$Y), t.months = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$R), t.weeks = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$S), t.days = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$j), t.hours = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$k), t.minutes = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$N), t.seconds = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$x), t.milliseconds = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$L), t.microseconds = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$P), t.nanoseconds = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$U), t;
}
$68c609acd189a8b4$var$DateTimeFormatImpl.prototype.constructor = $68c609acd189a8b4$var$di, Object.defineProperty($68c609acd189a8b4$var$di, "prototype", {
    value: $68c609acd189a8b4$var$DateTimeFormatImpl.prototype,
    writable: !1,
    enumerable: !1,
    configurable: !1
}), $68c609acd189a8b4$var$di.supportedLocalesOf = $68c609acd189a8b4$var$ai.supportedLocalesOf, $68c609acd189a8b4$var$ae($68c609acd189a8b4$var$di, "Intl.DateTimeFormat");
const { format: $68c609acd189a8b4$var$Ri, formatToParts: $68c609acd189a8b4$var$Si } = Intl.DurationFormat?.prototype ?? Object.create(null);
function $68c609acd189a8b4$var$ji(e) {
    Intl.DurationFormat.prototype.resolvedOptions.call(this);
    const t = $68c609acd189a8b4$var$Yi($68c609acd189a8b4$var$sn(e));
    return $68c609acd189a8b4$var$Ri.call(this, t);
}
Intl.DurationFormat?.prototype && (Intl.DurationFormat.prototype.format = $68c609acd189a8b4$var$ji, Intl.DurationFormat.prototype.formatToParts = function(e) {
    Intl.DurationFormat.prototype.resolvedOptions.call(this);
    const t = $68c609acd189a8b4$var$Yi($68c609acd189a8b4$var$sn(e));
    return $68c609acd189a8b4$var$Si.call(this, t);
});
var $68c609acd189a8b4$export$9e14854d4807bb3e = Object.freeze({
    __proto__: null,
    DateTimeFormat: $68c609acd189a8b4$var$di,
    ModifiedIntlDurationFormatPrototypeFormat: $68c609acd189a8b4$var$ji
});
class $68c609acd189a8b4$var$Instant {
    constructor(e){
        if (arguments.length < 1) throw new TypeError("missing argument: epochNanoseconds is required");
        $68c609acd189a8b4$var$In(this, $68c609acd189a8b4$var$Lo(e));
    }
    get epochMilliseconds() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ut), $68c609acd189a8b4$var$No($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$b), "floor");
    }
    get epochNanoseconds() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ut), $68c609acd189a8b4$var$ko((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$b)));
    }
    add(e) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ut), $68c609acd189a8b4$var$wo("add", this, e);
    }
    subtract(e) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ut), $68c609acd189a8b4$var$wo("subtract", this, e);
    }
    until(e, t) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ut), $68c609acd189a8b4$var$so("until", this, e, t);
    }
    since(e, t) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ut), $68c609acd189a8b4$var$so("since", this, e, t);
    }
    round(e) {
        if ($68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ut), void 0 === e) throw new TypeError("options parameter is required");
        const t = "string" == typeof e ? $68c609acd189a8b4$var$Fo("smallestUnit", e) : $68c609acd189a8b4$var$Zo(e), n = $68c609acd189a8b4$var$Ft(t), r = $68c609acd189a8b4$var$Ut(t, "halfExpand"), o = $68c609acd189a8b4$var$Wt(t, "smallestUnit", "time", $68c609acd189a8b4$var$qt);
        return $68c609acd189a8b4$var$Ht(n, {
            hour: 24,
            minute: 1440,
            second: 86400,
            millisecond: 864e5,
            microsecond: 864e8,
            nanosecond: 864e11
        }[o], !0), $68c609acd189a8b4$var$Cn($68c609acd189a8b4$var$Io($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$b), n, o, r));
    }
    equals(t) {
        $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ut);
        const n = $68c609acd189a8b4$var$cn(t), r = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$b), o = $68c609acd189a8b4$var$re(n, $68c609acd189a8b4$var$b);
        return (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).equal((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(r), (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(o));
    }
    toString(e) {
        $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ut);
        const t = $68c609acd189a8b4$var$Zo(e), n = $68c609acd189a8b4$var$zt(t), r = $68c609acd189a8b4$var$Ut(t, "trunc"), o = $68c609acd189a8b4$var$Wt(t, "smallestUnit", "time", void 0);
        if ("hour" === o) throw new RangeError('smallestUnit must be a time unit other than "hour"');
        let i = t.timeZone;
        void 0 !== i && (i = $68c609acd189a8b4$var$Bn(i));
        const { precision: a, unit: s, increment: c } = $68c609acd189a8b4$var$At(o, n);
        return $68c609acd189a8b4$var$Xn($68c609acd189a8b4$var$Cn($68c609acd189a8b4$var$Io($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$b), c, s, r)), i, a);
    }
    toJSON() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ut), $68c609acd189a8b4$var$Xn(this, void 0, "auto");
    }
    toLocaleString(e, t) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ut), new $68c609acd189a8b4$var$di(e, t).format(this);
    }
    valueOf() {
        $68c609acd189a8b4$var$qo("Instant");
    }
    toZonedDateTimeISO(e) {
        $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ut);
        const t = $68c609acd189a8b4$var$Bn(e);
        return $68c609acd189a8b4$var$$n($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$b), t, "iso8601");
    }
    static fromEpochMilliseconds(e) {
        return $68c609acd189a8b4$var$Cn($68c609acd189a8b4$var$xo($68c609acd189a8b4$var$qe(e)));
    }
    static fromEpochNanoseconds(e) {
        return $68c609acd189a8b4$var$Cn($68c609acd189a8b4$var$Lo(e));
    }
    static from(e) {
        return $68c609acd189a8b4$var$cn(e);
    }
    static compare(t, n) {
        const r = $68c609acd189a8b4$var$cn(t), o = $68c609acd189a8b4$var$cn(n), i = $68c609acd189a8b4$var$re(r, $68c609acd189a8b4$var$b), a = $68c609acd189a8b4$var$re(o, $68c609acd189a8b4$var$b);
        return (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).lessThan(i, a) ? -1 : (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).greaterThan(i, a) ? 1 : 0;
    }
}
$68c609acd189a8b4$var$ae($68c609acd189a8b4$var$Instant, "Temporal.Instant");
class $68c609acd189a8b4$var$PlainDate {
    constructor(e, t, n, r = "iso8601"){
        const o = $68c609acd189a8b4$var$_e(e), i = $68c609acd189a8b4$var$_e(t), a = $68c609acd189a8b4$var$_e(n), s = $68c609acd189a8b4$var$zo(void 0 === r ? "iso8601" : $68c609acd189a8b4$var$Ve(r));
        $68c609acd189a8b4$var$xr(o, i, a), $68c609acd189a8b4$var$yn(this, {
            year: o,
            month: i,
            day: a
        }, s);
    }
    get calendarId() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$mt), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E);
    }
    get era() {
        return $68c609acd189a8b4$var$Ni(this, "era");
    }
    get eraYear() {
        return $68c609acd189a8b4$var$Ni(this, "eraYear");
    }
    get year() {
        return $68c609acd189a8b4$var$Ni(this, "year");
    }
    get month() {
        return $68c609acd189a8b4$var$Ni(this, "month");
    }
    get monthCode() {
        return $68c609acd189a8b4$var$Ni(this, "monthCode");
    }
    get day() {
        return $68c609acd189a8b4$var$Ni(this, "day");
    }
    get dayOfWeek() {
        return $68c609acd189a8b4$var$Ni(this, "dayOfWeek");
    }
    get dayOfYear() {
        return $68c609acd189a8b4$var$Ni(this, "dayOfYear");
    }
    get weekOfYear() {
        return $68c609acd189a8b4$var$Ni(this, "weekOfYear")?.week;
    }
    get yearOfWeek() {
        return $68c609acd189a8b4$var$Ni(this, "weekOfYear")?.year;
    }
    get daysInWeek() {
        return $68c609acd189a8b4$var$Ni(this, "daysInWeek");
    }
    get daysInMonth() {
        return $68c609acd189a8b4$var$Ni(this, "daysInMonth");
    }
    get daysInYear() {
        return $68c609acd189a8b4$var$Ni(this, "daysInYear");
    }
    get monthsInYear() {
        return $68c609acd189a8b4$var$Ni(this, "monthsInYear");
    }
    get inLeapYear() {
        return $68c609acd189a8b4$var$Ni(this, "inLeapYear");
    }
    with(e, t) {
        if ($68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$mt), !$68c609acd189a8b4$var$Ae(e)) throw new TypeError("invalid argument");
        $68c609acd189a8b4$var$bt(e);
        const n = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E);
        let r = $68c609acd189a8b4$var$en(n, $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$D));
        return r = $68c609acd189a8b4$var$Rn(n, r, $68c609acd189a8b4$var$tn(n, e, [
            "year",
            "month",
            "monthCode",
            "day"
        ], [], "partial")), $68c609acd189a8b4$var$pn($68c609acd189a8b4$var$Ln(n, r, $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(t))), n);
    }
    withCalendar(e) {
        $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$mt);
        const t = $68c609acd189a8b4$var$kn(e);
        return $68c609acd189a8b4$var$pn($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$D), t);
    }
    add(e, t) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$mt), $68c609acd189a8b4$var$vo("add", this, e, t);
    }
    subtract(e, t) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$mt), $68c609acd189a8b4$var$vo("subtract", this, e, t);
    }
    until(e, t) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$mt), $68c609acd189a8b4$var$co("until", this, e, t);
    }
    since(e, t) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$mt), $68c609acd189a8b4$var$co("since", this, e, t);
    }
    equals(e) {
        $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$mt);
        const t = $68c609acd189a8b4$var$rn(e);
        return 0 === $68c609acd189a8b4$var$Ro($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$D), $68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$D)) && $68c609acd189a8b4$var$xn($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E), $68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$E));
    }
    toString(e) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$mt), $68c609acd189a8b4$var$er(this, $68c609acd189a8b4$var$Zt($68c609acd189a8b4$var$Zo(e)));
    }
    toJSON() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$mt), $68c609acd189a8b4$var$er(this);
    }
    toLocaleString(e, t) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$mt), new $68c609acd189a8b4$var$di(e, t).format(this);
    }
    valueOf() {
        $68c609acd189a8b4$var$qo("PlainDate");
    }
    toPlainDateTime(e) {
        $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$mt);
        const t = $68c609acd189a8b4$var$un(e);
        return $68c609acd189a8b4$var$wn($68c609acd189a8b4$var$xt($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$D), t), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E));
    }
    toZonedDateTime(e) {
        let t, n;
        if ($68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$mt), $68c609acd189a8b4$var$Ae(e)) {
            const r = e.timeZone;
            void 0 === r ? t = $68c609acd189a8b4$var$Bn(e) : (t = $68c609acd189a8b4$var$Bn(r), n = e.plainTime);
        } else t = $68c609acd189a8b4$var$Bn(e);
        const r = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$D);
        let o;
        return void 0 === n ? o = $68c609acd189a8b4$var$_n(t, r) : (n = $68c609acd189a8b4$var$hn(n), o = $68c609acd189a8b4$var$An(t, $68c609acd189a8b4$var$xt(r, $68c609acd189a8b4$var$re(n, $68c609acd189a8b4$var$M)), "compatible")), $68c609acd189a8b4$var$$n(o, t, $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E));
    }
    toPlainYearMonth() {
        $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$mt);
        const e = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E);
        return $68c609acd189a8b4$var$En($68c609acd189a8b4$var$Pn(e, $68c609acd189a8b4$var$en(e, $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$D)), "constrain"), e);
    }
    toPlainMonthDay() {
        $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$mt);
        const e = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E);
        return $68c609acd189a8b4$var$bn($68c609acd189a8b4$var$Un(e, $68c609acd189a8b4$var$en(e, $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$D)), "constrain"), e);
    }
    static from(e, t) {
        return $68c609acd189a8b4$var$rn(e, t);
    }
    static compare(e, t) {
        const n = $68c609acd189a8b4$var$rn(e), r = $68c609acd189a8b4$var$rn(t);
        return $68c609acd189a8b4$var$Ro($68c609acd189a8b4$var$re(n, $68c609acd189a8b4$var$D), $68c609acd189a8b4$var$re(r, $68c609acd189a8b4$var$D));
    }
}
function $68c609acd189a8b4$var$Ni(e, t) {
    $68c609acd189a8b4$var$vt(e, $68c609acd189a8b4$var$mt);
    const n = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$D);
    return $68c609acd189a8b4$var$Qt(e).isoToDate(n, {
        [t]: !0
    })[t];
}
$68c609acd189a8b4$var$ae($68c609acd189a8b4$var$PlainDate, "Temporal.PlainDate");
class $68c609acd189a8b4$var$PlainDateTime {
    constructor(e, t, n, r = 0, o = 0, i = 0, a = 0, s = 0, c = 0, d = "iso8601"){
        const h = $68c609acd189a8b4$var$_e(e), u = $68c609acd189a8b4$var$_e(t), l = $68c609acd189a8b4$var$_e(n), m = void 0 === r ? 0 : $68c609acd189a8b4$var$_e(r), f = void 0 === o ? 0 : $68c609acd189a8b4$var$_e(o), y = void 0 === i ? 0 : $68c609acd189a8b4$var$_e(i), p = void 0 === a ? 0 : $68c609acd189a8b4$var$_e(a), g = void 0 === s ? 0 : $68c609acd189a8b4$var$_e(s), w = void 0 === c ? 0 : $68c609acd189a8b4$var$_e(c), v = $68c609acd189a8b4$var$zo(void 0 === d ? "iso8601" : $68c609acd189a8b4$var$Ve(d));
        $68c609acd189a8b4$var$Ur(h, u, l, m, f, y, p, g, w), $68c609acd189a8b4$var$gn(this, {
            isoDate: {
                year: h,
                month: u,
                day: l
            },
            time: {
                hour: m,
                minute: f,
                second: y,
                millisecond: p,
                microsecond: g,
                nanosecond: w
            }
        }, v);
    }
    get calendarId() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$yt), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E);
    }
    get year() {
        return $68c609acd189a8b4$var$xi(this, "year");
    }
    get month() {
        return $68c609acd189a8b4$var$xi(this, "month");
    }
    get monthCode() {
        return $68c609acd189a8b4$var$xi(this, "monthCode");
    }
    get day() {
        return $68c609acd189a8b4$var$xi(this, "day");
    }
    get hour() {
        return $68c609acd189a8b4$var$Li(this, "hour");
    }
    get minute() {
        return $68c609acd189a8b4$var$Li(this, "minute");
    }
    get second() {
        return $68c609acd189a8b4$var$Li(this, "second");
    }
    get millisecond() {
        return $68c609acd189a8b4$var$Li(this, "millisecond");
    }
    get microsecond() {
        return $68c609acd189a8b4$var$Li(this, "microsecond");
    }
    get nanosecond() {
        return $68c609acd189a8b4$var$Li(this, "nanosecond");
    }
    get era() {
        return $68c609acd189a8b4$var$xi(this, "era");
    }
    get eraYear() {
        return $68c609acd189a8b4$var$xi(this, "eraYear");
    }
    get dayOfWeek() {
        return $68c609acd189a8b4$var$xi(this, "dayOfWeek");
    }
    get dayOfYear() {
        return $68c609acd189a8b4$var$xi(this, "dayOfYear");
    }
    get weekOfYear() {
        return $68c609acd189a8b4$var$xi(this, "weekOfYear")?.week;
    }
    get yearOfWeek() {
        return $68c609acd189a8b4$var$xi(this, "weekOfYear")?.year;
    }
    get daysInWeek() {
        return $68c609acd189a8b4$var$xi(this, "daysInWeek");
    }
    get daysInYear() {
        return $68c609acd189a8b4$var$xi(this, "daysInYear");
    }
    get daysInMonth() {
        return $68c609acd189a8b4$var$xi(this, "daysInMonth");
    }
    get monthsInYear() {
        return $68c609acd189a8b4$var$xi(this, "monthsInYear");
    }
    get inLeapYear() {
        return $68c609acd189a8b4$var$xi(this, "inLeapYear");
    }
    with(e, t) {
        if ($68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$yt), !$68c609acd189a8b4$var$Ae(e)) throw new TypeError("invalid argument");
        $68c609acd189a8b4$var$bt(e);
        const n = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E), r = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$T);
        let o = {
            ...$68c609acd189a8b4$var$en(n, r.isoDate),
            ...r.time
        };
        return o = $68c609acd189a8b4$var$Rn(n, o, $68c609acd189a8b4$var$tn(n, e, [
            "year",
            "month",
            "monthCode",
            "day"
        ], [
            "hour",
            "minute",
            "second",
            "millisecond",
            "microsecond",
            "nanosecond"
        ], "partial")), $68c609acd189a8b4$var$wn($68c609acd189a8b4$var$on(n, o, $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(t))), n);
    }
    withPlainTime(e) {
        $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$yt);
        const t = $68c609acd189a8b4$var$un(e);
        return $68c609acd189a8b4$var$wn($68c609acd189a8b4$var$xt($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$T).isoDate, t), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E));
    }
    withCalendar(e) {
        $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$yt);
        const t = $68c609acd189a8b4$var$kn(e);
        return $68c609acd189a8b4$var$wn($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$T), t);
    }
    add(e, t) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$yt), $68c609acd189a8b4$var$bo("add", this, e, t);
    }
    subtract(e, t) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$yt), $68c609acd189a8b4$var$bo("subtract", this, e, t);
    }
    until(e, t) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$yt), $68c609acd189a8b4$var$ho("until", this, e, t);
    }
    since(e, t) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$yt), $68c609acd189a8b4$var$ho("since", this, e, t);
    }
    round(e) {
        if ($68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$yt), void 0 === e) throw new TypeError("options parameter is required");
        const t = "string" == typeof e ? $68c609acd189a8b4$var$Fo("smallestUnit", e) : $68c609acd189a8b4$var$Zo(e), n = $68c609acd189a8b4$var$Ft(t), r = $68c609acd189a8b4$var$Ut(t, "halfExpand"), o = $68c609acd189a8b4$var$Wt(t, "smallestUnit", "time", $68c609acd189a8b4$var$qt, [
            "day"
        ]), i = {
            day: 1,
            hour: 24,
            minute: 60,
            second: 60,
            millisecond: 1e3,
            microsecond: 1e3,
            nanosecond: 1e3
        }[o];
        $68c609acd189a8b4$var$Ht(n, i, 1 === i);
        const a = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$T);
        return $68c609acd189a8b4$var$wn(1 === n && "nanosecond" === o ? a : $68c609acd189a8b4$var$Co(a, n, o, r), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E));
    }
    equals(e) {
        $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$yt);
        const t = $68c609acd189a8b4$var$an(e);
        return 0 === $68c609acd189a8b4$var$jo($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$T), $68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$T)) && $68c609acd189a8b4$var$xn($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E), $68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$E));
    }
    toString(e) {
        $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$yt);
        const t = $68c609acd189a8b4$var$Zo(e), n = $68c609acd189a8b4$var$Zt(t), r = $68c609acd189a8b4$var$zt(t), o = $68c609acd189a8b4$var$Ut(t, "trunc"), i = $68c609acd189a8b4$var$Wt(t, "smallestUnit", "time", void 0);
        if ("hour" === i) throw new RangeError('smallestUnit must be a time unit other than "hour"');
        const { precision: a, unit: s, increment: c } = $68c609acd189a8b4$var$At(i, r), d = $68c609acd189a8b4$var$Co($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$T), c, s, o);
        return $68c609acd189a8b4$var$Br(d), $68c609acd189a8b4$var$nr(d, $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E), a, n);
    }
    toJSON() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$yt), $68c609acd189a8b4$var$nr($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$T), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E), "auto");
    }
    toLocaleString(e, t) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$yt), new $68c609acd189a8b4$var$di(e, t).format(this);
    }
    valueOf() {
        $68c609acd189a8b4$var$qo("PlainDateTime");
    }
    toZonedDateTime(e, t) {
        $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$yt);
        const n = $68c609acd189a8b4$var$Bn(e), r = $68c609acd189a8b4$var$Pt($68c609acd189a8b4$var$Zo(t));
        return $68c609acd189a8b4$var$$n($68c609acd189a8b4$var$An(n, $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$T), r), n, $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E));
    }
    toPlainDate() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$yt), $68c609acd189a8b4$var$pn($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$T).isoDate, $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E));
    }
    toPlainTime() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$yt), $68c609acd189a8b4$var$Tn($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$T).time);
    }
    static from(e, t) {
        return $68c609acd189a8b4$var$an(e, t);
    }
    static compare(e, t) {
        const n = $68c609acd189a8b4$var$an(e), r = $68c609acd189a8b4$var$an(t);
        return $68c609acd189a8b4$var$jo($68c609acd189a8b4$var$re(n, $68c609acd189a8b4$var$T), $68c609acd189a8b4$var$re(r, $68c609acd189a8b4$var$T));
    }
}
function $68c609acd189a8b4$var$xi(e, t) {
    $68c609acd189a8b4$var$vt(e, $68c609acd189a8b4$var$yt);
    const n = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$T).isoDate;
    return $68c609acd189a8b4$var$Qt(e).isoToDate(n, {
        [t]: !0
    })[t];
}
function $68c609acd189a8b4$var$Li(e, t) {
    return $68c609acd189a8b4$var$vt(e, $68c609acd189a8b4$var$yt), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$T).time[t];
}
$68c609acd189a8b4$var$ae($68c609acd189a8b4$var$PlainDateTime, "Temporal.PlainDateTime");
class $68c609acd189a8b4$var$Duration {
    constructor(e = 0, t = 0, n = 0, r = 0, o = 0, i = 0, a = 0, s = 0, c = 0, d = 0){
        const h = void 0 === e ? 0 : $68c609acd189a8b4$var$Ge(e), u = void 0 === t ? 0 : $68c609acd189a8b4$var$Ge(t), l = void 0 === n ? 0 : $68c609acd189a8b4$var$Ge(n), m = void 0 === r ? 0 : $68c609acd189a8b4$var$Ge(r), f = void 0 === o ? 0 : $68c609acd189a8b4$var$Ge(o), y = void 0 === i ? 0 : $68c609acd189a8b4$var$Ge(i), p = void 0 === a ? 0 : $68c609acd189a8b4$var$Ge(a), g = void 0 === s ? 0 : $68c609acd189a8b4$var$Ge(s), w = void 0 === c ? 0 : $68c609acd189a8b4$var$Ge(c), v = void 0 === d ? 0 : $68c609acd189a8b4$var$Ge(d);
        $68c609acd189a8b4$var$zr(h, u, l, m, f, y, p, g, w, v), $68c609acd189a8b4$var$te(this), $68c609acd189a8b4$var$oe(this, $68c609acd189a8b4$var$Y, h), $68c609acd189a8b4$var$oe(this, $68c609acd189a8b4$var$R, u), $68c609acd189a8b4$var$oe(this, $68c609acd189a8b4$var$S, l), $68c609acd189a8b4$var$oe(this, $68c609acd189a8b4$var$j, m), $68c609acd189a8b4$var$oe(this, $68c609acd189a8b4$var$k, f), $68c609acd189a8b4$var$oe(this, $68c609acd189a8b4$var$N, y), $68c609acd189a8b4$var$oe(this, $68c609acd189a8b4$var$x, p), $68c609acd189a8b4$var$oe(this, $68c609acd189a8b4$var$L, g), $68c609acd189a8b4$var$oe(this, $68c609acd189a8b4$var$P, w), $68c609acd189a8b4$var$oe(this, $68c609acd189a8b4$var$U, v);
    }
    get years() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$lt), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$Y);
    }
    get months() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$lt), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$R);
    }
    get weeks() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$lt), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$S);
    }
    get days() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$lt), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$j);
    }
    get hours() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$lt), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$k);
    }
    get minutes() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$lt), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$N);
    }
    get seconds() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$lt), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$x);
    }
    get milliseconds() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$lt), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$L);
    }
    get microseconds() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$lt), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$P);
    }
    get nanoseconds() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$lt), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$U);
    }
    get sign() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$lt), $68c609acd189a8b4$var$Mr(this);
    }
    get blank() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$lt), 0 === $68c609acd189a8b4$var$Mr(this);
    }
    with(e) {
        $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$lt);
        const t = $68c609acd189a8b4$var$kt(e), { years: n = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$Y), months: r = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$R), weeks: o = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$S), days: i = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$j), hours: a = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$k), minutes: s = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$N), seconds: c = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$x), milliseconds: d = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$L), microseconds: h = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$P), nanoseconds: u = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$U) } = t;
        return new $68c609acd189a8b4$var$Duration(n, r, o, i, a, s, c, d, h, u);
    }
    negated() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$lt), $68c609acd189a8b4$var$Sr(this);
    }
    abs() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$lt), new $68c609acd189a8b4$var$Duration(Math.abs($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$Y)), Math.abs($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$R)), Math.abs($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$S)), Math.abs($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$j)), Math.abs($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$k)), Math.abs($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$N)), Math.abs($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$x)), Math.abs($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$L)), Math.abs($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$P)), Math.abs($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$U)));
    }
    add(e) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$lt), $68c609acd189a8b4$var$go("add", this, e);
    }
    subtract(e) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$lt), $68c609acd189a8b4$var$go("subtract", this, e);
    }
    round(e) {
        if ($68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$lt), void 0 === e) throw new TypeError("options parameter is required");
        const t = $68c609acd189a8b4$var$Jt(this), n = "string" == typeof e ? $68c609acd189a8b4$var$Fo("smallestUnit", e) : $68c609acd189a8b4$var$Zo(e);
        let r = $68c609acd189a8b4$var$Wt(n, "largestUnit", "datetime", void 0, [
            "auto"
        ]), { plainRelativeTo: o, zonedRelativeTo: i } = $68c609acd189a8b4$var$_t(n);
        const a = $68c609acd189a8b4$var$Ft(n), s = $68c609acd189a8b4$var$Ut(n, "halfExpand");
        let c = $68c609acd189a8b4$var$Wt(n, "smallestUnit", "datetime", void 0), d = !0;
        c || (d = !1, c = "nanosecond");
        const h = $68c609acd189a8b4$var$Gt(t, c);
        let u = !0;
        if (r || (u = !1, r = h), "auto" === r && (r = h), !d && !u) throw new RangeError("at least one of smallestUnit or largestUnit is required");
        if ($68c609acd189a8b4$var$Gt(r, c) !== r) throw new RangeError(`largestUnit ${r} cannot be smaller than smallestUnit ${c}`);
        const l = {
            hour: 24,
            minute: 60,
            second: 60,
            millisecond: 1e3,
            microsecond: 1e3,
            nanosecond: 1e3
        }[c];
        if (void 0 !== l && $68c609acd189a8b4$var$Ht(a, l, !1), a > 1 && "date" === $68c609acd189a8b4$var$Vt(c) && r !== c) throw new RangeError("For calendar units with roundingIncrement > 1, use largestUnit = smallestUnit");
        if (i) {
            let e = $68c609acd189a8b4$var$Ar(this);
            const t = $68c609acd189a8b4$var$re(i, $68c609acd189a8b4$var$$), n = $68c609acd189a8b4$var$re(i, $68c609acd189a8b4$var$E), o = $68c609acd189a8b4$var$re(i, $68c609acd189a8b4$var$b);
            return e = $68c609acd189a8b4$var$io(o, $68c609acd189a8b4$var$po(o, t, n, e), t, n, r, a, c, s), "date" === $68c609acd189a8b4$var$Vt(r) && (r = "hour"), $68c609acd189a8b4$var$_r(e, r);
        }
        if (o) {
            let e = $68c609acd189a8b4$var$qr(this);
            const t = $68c609acd189a8b4$var$fo({
                deltaDays: 0,
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
                microsecond: 0,
                nanosecond: 0
            }, e.time), n = $68c609acd189a8b4$var$re(o, $68c609acd189a8b4$var$D), i = $68c609acd189a8b4$var$re(o, $68c609acd189a8b4$var$E), d = $68c609acd189a8b4$var$Sn(i, n, $68c609acd189a8b4$var$Nt(e.date, t.deltaDays), "constrain");
            return e = $68c609acd189a8b4$var$oo($68c609acd189a8b4$var$xt(n, {
                deltaDays: 0,
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
                microsecond: 0,
                nanosecond: 0
            }), $68c609acd189a8b4$var$xt(d, t), i, r, a, c, s), $68c609acd189a8b4$var$_r(e, r);
        }
        if ($68c609acd189a8b4$var$Kt(t)) throw new RangeError(`a starting point is required for ${t}s balancing`);
        if ($68c609acd189a8b4$var$Kt(r)) throw new RangeError(`a starting point is required for ${r}s balancing`);
        let m = $68c609acd189a8b4$var$qr(this);
        if ("day" === c) {
            const { quotient: e, remainder: t } = m.time.divmod($68c609acd189a8b4$var$Se);
            let n = m.date.days + e + $68c609acd189a8b4$var$Yo(t, "day");
            n = $68c609acd189a8b4$var$Eo(n, a, s), m = $68c609acd189a8b4$var$Jr({
                years: 0,
                months: 0,
                weeks: 0,
                days: n
            }, $68c609acd189a8b4$var$TimeDuration.ZERO);
        } else m = $68c609acd189a8b4$var$Jr({
            years: 0,
            months: 0,
            weeks: 0,
            days: 0
        }, $68c609acd189a8b4$var$$o(m.time, a, c, s));
        return $68c609acd189a8b4$var$_r(m, r);
    }
    total(t) {
        if ($68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$lt), void 0 === t) throw new TypeError("options argument is required");
        const n = "string" == typeof t ? $68c609acd189a8b4$var$Fo("unit", t) : $68c609acd189a8b4$var$Zo(t);
        let { plainRelativeTo: r, zonedRelativeTo: o } = $68c609acd189a8b4$var$_t(n);
        const i = $68c609acd189a8b4$var$Wt(n, "unit", "datetime", $68c609acd189a8b4$var$qt);
        if (o) {
            const e = $68c609acd189a8b4$var$Ar(this), t = $68c609acd189a8b4$var$re(o, $68c609acd189a8b4$var$$), n = $68c609acd189a8b4$var$re(o, $68c609acd189a8b4$var$E), r = $68c609acd189a8b4$var$re(o, $68c609acd189a8b4$var$b);
            return function(e, t, n, r, o) {
                return "time" === $68c609acd189a8b4$var$Vt(o) ? $68c609acd189a8b4$var$Yo($68c609acd189a8b4$var$TimeDuration.fromEpochNsDiff(t, e), o) : $68c609acd189a8b4$var$ro($68c609acd189a8b4$var$eo(e, t, n, r, o), t, $68c609acd189a8b4$var$zn(n, e), n, r, o);
            }(r, $68c609acd189a8b4$var$po(r, t, n, e), t, n, i);
        }
        if (r) {
            const t = $68c609acd189a8b4$var$qr(this);
            let n = $68c609acd189a8b4$var$fo({
                deltaDays: 0,
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
                microsecond: 0,
                nanosecond: 0
            }, t.time);
            const o = $68c609acd189a8b4$var$re(r, $68c609acd189a8b4$var$D), a = $68c609acd189a8b4$var$re(r, $68c609acd189a8b4$var$E), s = $68c609acd189a8b4$var$Sn(a, o, $68c609acd189a8b4$var$Nt(t.date, n.deltaDays), "constrain");
            return function(t, n, r, o) {
                if (0 == $68c609acd189a8b4$var$jo(t, n)) return 0;
                $68c609acd189a8b4$var$Br(t), $68c609acd189a8b4$var$Br(n);
                const i = $68c609acd189a8b4$var$Qr(t, n, r, o);
                return "nanosecond" === o ? (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).toNumber(i.time.totalNs) : $68c609acd189a8b4$var$ro(i, $68c609acd189a8b4$var$pr(n), t, null, r, o);
            }($68c609acd189a8b4$var$xt(o, {
                deltaDays: 0,
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
                microsecond: 0,
                nanosecond: 0
            }), $68c609acd189a8b4$var$xt(s, n), a, i);
        }
        const a = $68c609acd189a8b4$var$Jt(this);
        if ($68c609acd189a8b4$var$Kt(a)) throw new RangeError(`a starting point is required for ${a}s total`);
        if ($68c609acd189a8b4$var$Kt(i)) throw new RangeError(`a starting point is required for ${i}s total`);
        return $68c609acd189a8b4$var$Yo($68c609acd189a8b4$var$qr(this).time, i);
    }
    toString(e) {
        $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$lt);
        const t = $68c609acd189a8b4$var$Zo(e), n = $68c609acd189a8b4$var$zt(t), r = $68c609acd189a8b4$var$Ut(t, "trunc"), o = $68c609acd189a8b4$var$Wt(t, "smallestUnit", "time", void 0);
        if ("hour" === o || "minute" === o) throw new RangeError('smallestUnit must be a time unit other than "hours" or "minutes"');
        const { precision: i, unit: a, increment: s } = $68c609acd189a8b4$var$At(o, n);
        if ("nanosecond" === a && 1 === s) return $68c609acd189a8b4$var$Qn(this, i);
        const c = $68c609acd189a8b4$var$Jt(this);
        let d = $68c609acd189a8b4$var$Ar(this);
        const h = $68c609acd189a8b4$var$$o(d.time, s, a, r);
        return d = $68c609acd189a8b4$var$Jr(d.date, h), $68c609acd189a8b4$var$Qn($68c609acd189a8b4$var$_r(d, $68c609acd189a8b4$var$Gt(c, "second")), i);
    }
    toJSON() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$lt), $68c609acd189a8b4$var$Qn(this, "auto");
    }
    toLocaleString(e, t) {
        if ($68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$lt), "function" == typeof Intl.DurationFormat) {
            const n = new Intl.DurationFormat(e, t);
            return $68c609acd189a8b4$var$ji.call(n, this);
        }
        return console.warn("Temporal.Duration.prototype.toLocaleString() requires Intl.DurationFormat."), $68c609acd189a8b4$var$Qn(this, "auto");
    }
    valueOf() {
        $68c609acd189a8b4$var$qo("Duration");
    }
    static from(e) {
        return $68c609acd189a8b4$var$sn(e);
    }
    static compare(t, n, r) {
        const o = $68c609acd189a8b4$var$sn(t), i = $68c609acd189a8b4$var$sn(n), a = $68c609acd189a8b4$var$Zo(r), { plainRelativeTo: s, zonedRelativeTo: c } = $68c609acd189a8b4$var$_t(a);
        if ($68c609acd189a8b4$var$re(o, $68c609acd189a8b4$var$Y) === $68c609acd189a8b4$var$re(i, $68c609acd189a8b4$var$Y) && $68c609acd189a8b4$var$re(o, $68c609acd189a8b4$var$R) === $68c609acd189a8b4$var$re(i, $68c609acd189a8b4$var$R) && $68c609acd189a8b4$var$re(o, $68c609acd189a8b4$var$S) === $68c609acd189a8b4$var$re(i, $68c609acd189a8b4$var$S) && $68c609acd189a8b4$var$re(o, $68c609acd189a8b4$var$j) === $68c609acd189a8b4$var$re(i, $68c609acd189a8b4$var$j) && $68c609acd189a8b4$var$re(o, $68c609acd189a8b4$var$k) === $68c609acd189a8b4$var$re(i, $68c609acd189a8b4$var$k) && $68c609acd189a8b4$var$re(o, $68c609acd189a8b4$var$N) === $68c609acd189a8b4$var$re(i, $68c609acd189a8b4$var$N) && $68c609acd189a8b4$var$re(o, $68c609acd189a8b4$var$x) === $68c609acd189a8b4$var$re(i, $68c609acd189a8b4$var$x) && $68c609acd189a8b4$var$re(o, $68c609acd189a8b4$var$L) === $68c609acd189a8b4$var$re(i, $68c609acd189a8b4$var$L) && $68c609acd189a8b4$var$re(o, $68c609acd189a8b4$var$P) === $68c609acd189a8b4$var$re(i, $68c609acd189a8b4$var$P) && $68c609acd189a8b4$var$re(o, $68c609acd189a8b4$var$U) === $68c609acd189a8b4$var$re(i, $68c609acd189a8b4$var$U)) return 0;
        const d = $68c609acd189a8b4$var$Jt(o), h = $68c609acd189a8b4$var$Jt(i), u = $68c609acd189a8b4$var$Ar(o), l = $68c609acd189a8b4$var$Ar(i);
        if (c && ("date" === $68c609acd189a8b4$var$Vt(d) || "date" === $68c609acd189a8b4$var$Vt(h))) {
            const t = $68c609acd189a8b4$var$re(c, $68c609acd189a8b4$var$$), n = $68c609acd189a8b4$var$re(c, $68c609acd189a8b4$var$E), r = $68c609acd189a8b4$var$re(c, $68c609acd189a8b4$var$b), o = $68c609acd189a8b4$var$po(r, t, n, u), i = $68c609acd189a8b4$var$po(r, t, n, l);
            return $68c609acd189a8b4$var$Bo((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).toNumber((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).subtract(o, i)));
        }
        let m = u.date.days, f = l.date.days;
        if ($68c609acd189a8b4$var$Kt(d) || $68c609acd189a8b4$var$Kt(h)) {
            if (!s) throw new RangeError("A starting point is required for years, months, or weeks comparison");
            m = $68c609acd189a8b4$var$Rr(u.date, s), f = $68c609acd189a8b4$var$Rr(l.date, s);
        }
        const y = u.time.add24HourDays(m), p = l.time.add24HourDays(f);
        return y.cmp(p);
    }
}
$68c609acd189a8b4$var$ae($68c609acd189a8b4$var$Duration, "Temporal.Duration");
class $68c609acd189a8b4$var$PlainMonthDay {
    constructor(e, t, n = "iso8601", r = 1972){
        const o = $68c609acd189a8b4$var$_e(e), i = $68c609acd189a8b4$var$_e(t), a = $68c609acd189a8b4$var$zo(void 0 === n ? "iso8601" : $68c609acd189a8b4$var$Ve(n)), s = $68c609acd189a8b4$var$_e(r);
        $68c609acd189a8b4$var$xr(s, o, i), $68c609acd189a8b4$var$vn(this, {
            year: s,
            month: o,
            day: i
        }, a);
    }
    get monthCode() {
        return $68c609acd189a8b4$var$Pi(this, "monthCode");
    }
    get day() {
        return $68c609acd189a8b4$var$Pi(this, "day");
    }
    get calendarId() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$gt), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E);
    }
    with(e, t) {
        if ($68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$gt), !$68c609acd189a8b4$var$Ae(e)) throw new TypeError("invalid argument");
        $68c609acd189a8b4$var$bt(e);
        const n = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E);
        let r = $68c609acd189a8b4$var$en(n, $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$D), "month-day");
        return r = $68c609acd189a8b4$var$Rn(n, r, $68c609acd189a8b4$var$tn(n, e, [
            "year",
            "month",
            "monthCode",
            "day"
        ], [], "partial")), $68c609acd189a8b4$var$bn($68c609acd189a8b4$var$Un(n, r, $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(t))), n);
    }
    equals(e) {
        $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$gt);
        const t = $68c609acd189a8b4$var$dn(e);
        return 0 === $68c609acd189a8b4$var$Ro($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$D), $68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$D)) && $68c609acd189a8b4$var$xn($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E), $68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$E));
    }
    toString(e) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$gt), $68c609acd189a8b4$var$rr(this, $68c609acd189a8b4$var$Zt($68c609acd189a8b4$var$Zo(e)));
    }
    toJSON() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$gt), $68c609acd189a8b4$var$rr(this);
    }
    toLocaleString(e, t) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$gt), new $68c609acd189a8b4$var$di(e, t).format(this);
    }
    valueOf() {
        $68c609acd189a8b4$var$qo("PlainMonthDay");
    }
    toPlainDate(e) {
        if ($68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$gt), !$68c609acd189a8b4$var$Ae(e)) throw new TypeError("argument should be an object");
        const t = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E);
        return $68c609acd189a8b4$var$pn($68c609acd189a8b4$var$Ln(t, $68c609acd189a8b4$var$Rn(t, $68c609acd189a8b4$var$en(t, $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$D), "month-day"), $68c609acd189a8b4$var$tn(t, e, [
            "year"
        ], [], [])), "constrain"), t);
    }
    static from(e, t) {
        return $68c609acd189a8b4$var$dn(e, t);
    }
}
function $68c609acd189a8b4$var$Pi(e, t) {
    $68c609acd189a8b4$var$vt(e, $68c609acd189a8b4$var$gt);
    const n = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$D);
    return $68c609acd189a8b4$var$Qt(e).isoToDate(n, {
        [t]: !0
    })[t];
}
function $68c609acd189a8b4$var$Ui(e) {
    return $68c609acd189a8b4$var$zn(e, $68c609acd189a8b4$var$Po());
}
$68c609acd189a8b4$var$ae($68c609acd189a8b4$var$PlainMonthDay, "Temporal.PlainMonthDay");
const $68c609acd189a8b4$var$Bi = {
    instant: ()=>$68c609acd189a8b4$var$Cn($68c609acd189a8b4$var$Po()),
    plainDateTimeISO: (e = $68c609acd189a8b4$var$Uo())=>$68c609acd189a8b4$var$wn($68c609acd189a8b4$var$Ui($68c609acd189a8b4$var$Bn(e)), "iso8601"),
    plainDateISO: (e = $68c609acd189a8b4$var$Uo())=>$68c609acd189a8b4$var$pn($68c609acd189a8b4$var$Ui($68c609acd189a8b4$var$Bn(e)).isoDate, "iso8601"),
    plainTimeISO: (e = $68c609acd189a8b4$var$Uo())=>$68c609acd189a8b4$var$Tn($68c609acd189a8b4$var$Ui($68c609acd189a8b4$var$Bn(e)).time),
    timeZoneId: ()=>$68c609acd189a8b4$var$Uo(),
    zonedDateTimeISO: (e = $68c609acd189a8b4$var$Uo())=>{
        const t = $68c609acd189a8b4$var$Bn(e);
        return $68c609acd189a8b4$var$$n($68c609acd189a8b4$var$Po(), t, "iso8601");
    },
    [Symbol.toStringTag]: "Temporal.Now"
};
Object.defineProperty($68c609acd189a8b4$var$Bi, Symbol.toStringTag, {
    value: "Temporal.Now",
    writable: !1,
    enumerable: !1,
    configurable: !0
});
class $68c609acd189a8b4$var$PlainTime {
    constructor(e = 0, t = 0, n = 0, r = 0, o = 0, i = 0){
        const a = void 0 === e ? 0 : $68c609acd189a8b4$var$_e(e), s = void 0 === t ? 0 : $68c609acd189a8b4$var$_e(t), c = void 0 === n ? 0 : $68c609acd189a8b4$var$_e(n), d = void 0 === r ? 0 : $68c609acd189a8b4$var$_e(r), h = void 0 === o ? 0 : $68c609acd189a8b4$var$_e(o), u = void 0 === i ? 0 : $68c609acd189a8b4$var$_e(i);
        $68c609acd189a8b4$var$Pr(a, s, c, d, h, u), $68c609acd189a8b4$var$Dn(this, {
            hour: a,
            minute: s,
            second: c,
            millisecond: d,
            microsecond: h,
            nanosecond: u
        });
    }
    get hour() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ft), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$M).hour;
    }
    get minute() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ft), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$M).minute;
    }
    get second() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ft), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$M).second;
    }
    get millisecond() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ft), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$M).millisecond;
    }
    get microsecond() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ft), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$M).microsecond;
    }
    get nanosecond() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ft), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$M).nanosecond;
    }
    with(e, t) {
        if ($68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ft), !$68c609acd189a8b4$var$Ae(e)) throw new TypeError("invalid argument");
        $68c609acd189a8b4$var$bt(e);
        const n = $68c609acd189a8b4$var$nn(e, "partial"), r = $68c609acd189a8b4$var$nn(this);
        let { hour: o, minute: i, second: a, millisecond: s, microsecond: c, nanosecond: d } = Object.assign(r, n);
        const h = $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(t));
        return { hour: o, minute: i, second: a, millisecond: s, microsecond: c, nanosecond: d } = $68c609acd189a8b4$var$jt(o, i, a, s, c, d, h), new $68c609acd189a8b4$var$PlainTime(o, i, a, s, c, d);
    }
    add(e) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ft), $68c609acd189a8b4$var$Do("add", this, e);
    }
    subtract(e) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ft), $68c609acd189a8b4$var$Do("subtract", this, e);
    }
    until(e, t) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ft), $68c609acd189a8b4$var$uo("until", this, e, t);
    }
    since(e, t) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ft), $68c609acd189a8b4$var$uo("since", this, e, t);
    }
    round(e) {
        if ($68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ft), void 0 === e) throw new TypeError("options parameter is required");
        const t = "string" == typeof e ? $68c609acd189a8b4$var$Fo("smallestUnit", e) : $68c609acd189a8b4$var$Zo(e), n = $68c609acd189a8b4$var$Ft(t), r = $68c609acd189a8b4$var$Ut(t, "halfExpand"), o = $68c609acd189a8b4$var$Wt(t, "smallestUnit", "time", $68c609acd189a8b4$var$qt);
        return $68c609acd189a8b4$var$Ht(n, {
            hour: 24,
            minute: 60,
            second: 60,
            millisecond: 1e3,
            microsecond: 1e3,
            nanosecond: 1e3
        }[o], !1), $68c609acd189a8b4$var$Tn($68c609acd189a8b4$var$Oo($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$M), n, o, r));
    }
    equals(e) {
        $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ft);
        const t = $68c609acd189a8b4$var$hn(e);
        return 0 === $68c609acd189a8b4$var$So($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$M), $68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$M));
    }
    toString(e) {
        $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ft);
        const t = $68c609acd189a8b4$var$Zo(e), n = $68c609acd189a8b4$var$zt(t), r = $68c609acd189a8b4$var$Ut(t, "trunc"), o = $68c609acd189a8b4$var$Wt(t, "smallestUnit", "time", void 0);
        if ("hour" === o) throw new RangeError('smallestUnit must be a time unit other than "hour"');
        const { precision: i, unit: a, increment: s } = $68c609acd189a8b4$var$At(o, n);
        return $68c609acd189a8b4$var$tr($68c609acd189a8b4$var$Oo($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$M), s, a, r), i);
    }
    toJSON() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ft), $68c609acd189a8b4$var$tr($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$M), "auto");
    }
    toLocaleString(e, t) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$ft), new $68c609acd189a8b4$var$di(e, t).format(this);
    }
    valueOf() {
        $68c609acd189a8b4$var$qo("PlainTime");
    }
    static from(e, t) {
        return $68c609acd189a8b4$var$hn(e, t);
    }
    static compare(e, t) {
        const n = $68c609acd189a8b4$var$hn(e), r = $68c609acd189a8b4$var$hn(t);
        return $68c609acd189a8b4$var$So($68c609acd189a8b4$var$re(n, $68c609acd189a8b4$var$M), $68c609acd189a8b4$var$re(r, $68c609acd189a8b4$var$M));
    }
}
$68c609acd189a8b4$var$ae($68c609acd189a8b4$var$PlainTime, "Temporal.PlainTime");
class $68c609acd189a8b4$var$PlainYearMonth {
    constructor(e, t, n = "iso8601", r = 1){
        const o = $68c609acd189a8b4$var$_e(e), i = $68c609acd189a8b4$var$_e(t), a = $68c609acd189a8b4$var$zo(void 0 === n ? "iso8601" : $68c609acd189a8b4$var$Ve(n)), s = $68c609acd189a8b4$var$_e(r);
        $68c609acd189a8b4$var$xr(o, i, s), $68c609acd189a8b4$var$Mn(this, {
            year: o,
            month: i,
            day: s
        }, a);
    }
    get year() {
        return $68c609acd189a8b4$var$Zi(this, "year");
    }
    get month() {
        return $68c609acd189a8b4$var$Zi(this, "month");
    }
    get monthCode() {
        return $68c609acd189a8b4$var$Zi(this, "monthCode");
    }
    get calendarId() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$pt), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E);
    }
    get era() {
        return $68c609acd189a8b4$var$Zi(this, "era");
    }
    get eraYear() {
        return $68c609acd189a8b4$var$Zi(this, "eraYear");
    }
    get daysInMonth() {
        return $68c609acd189a8b4$var$Zi(this, "daysInMonth");
    }
    get daysInYear() {
        return $68c609acd189a8b4$var$Zi(this, "daysInYear");
    }
    get monthsInYear() {
        return $68c609acd189a8b4$var$Zi(this, "monthsInYear");
    }
    get inLeapYear() {
        return $68c609acd189a8b4$var$Zi(this, "inLeapYear");
    }
    with(e, t) {
        if ($68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$pt), !$68c609acd189a8b4$var$Ae(e)) throw new TypeError("invalid argument");
        $68c609acd189a8b4$var$bt(e);
        const n = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E);
        let r = $68c609acd189a8b4$var$en(n, $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$D), "year-month");
        return r = $68c609acd189a8b4$var$Rn(n, r, $68c609acd189a8b4$var$tn(n, e, [
            "year",
            "month",
            "monthCode"
        ], [], "partial")), $68c609acd189a8b4$var$En($68c609acd189a8b4$var$Pn(n, r, $68c609acd189a8b4$var$Lt($68c609acd189a8b4$var$Zo(t))), n);
    }
    add(e, t) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$pt), $68c609acd189a8b4$var$To("add", this, e, t);
    }
    subtract(e, t) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$pt), $68c609acd189a8b4$var$To("subtract", this, e, t);
    }
    until(e, t) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$pt), $68c609acd189a8b4$var$lo("until", this, e, t);
    }
    since(e, t) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$pt), $68c609acd189a8b4$var$lo("since", this, e, t);
    }
    equals(e) {
        $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$pt);
        const t = $68c609acd189a8b4$var$ln(e);
        return 0 === $68c609acd189a8b4$var$Ro($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$D), $68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$D)) && $68c609acd189a8b4$var$xn($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E), $68c609acd189a8b4$var$re(t, $68c609acd189a8b4$var$E));
    }
    toString(e) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$pt), $68c609acd189a8b4$var$or(this, $68c609acd189a8b4$var$Zt($68c609acd189a8b4$var$Zo(e)));
    }
    toJSON() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$pt), $68c609acd189a8b4$var$or(this);
    }
    toLocaleString(e, t) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$pt), new $68c609acd189a8b4$var$di(e, t).format(this);
    }
    valueOf() {
        $68c609acd189a8b4$var$qo("PlainYearMonth");
    }
    toPlainDate(e) {
        if ($68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$pt), !$68c609acd189a8b4$var$Ae(e)) throw new TypeError("argument should be an object");
        const t = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E);
        return $68c609acd189a8b4$var$pn($68c609acd189a8b4$var$Ln(t, $68c609acd189a8b4$var$Rn(t, $68c609acd189a8b4$var$en(t, $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$D), "year-month"), $68c609acd189a8b4$var$tn(t, e, [
            "day"
        ], [], [])), "constrain"), t);
    }
    static from(e, t) {
        return $68c609acd189a8b4$var$ln(e, t);
    }
    static compare(e, t) {
        const n = $68c609acd189a8b4$var$ln(e), r = $68c609acd189a8b4$var$ln(t);
        return $68c609acd189a8b4$var$Ro($68c609acd189a8b4$var$re(n, $68c609acd189a8b4$var$D), $68c609acd189a8b4$var$re(r, $68c609acd189a8b4$var$D));
    }
}
function $68c609acd189a8b4$var$Zi(e, t) {
    $68c609acd189a8b4$var$vt(e, $68c609acd189a8b4$var$pt);
    const n = $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$D);
    return $68c609acd189a8b4$var$Qt(e).isoToDate(n, {
        [t]: !0
    })[t];
}
$68c609acd189a8b4$var$ae($68c609acd189a8b4$var$PlainYearMonth, "Temporal.PlainYearMonth");
const $68c609acd189a8b4$var$Fi = $68c609acd189a8b4$var$di.prototype.resolvedOptions;
class $68c609acd189a8b4$var$ZonedDateTime {
    constructor(e, t, n = "iso8601"){
        if (arguments.length < 1) throw new TypeError("missing argument: epochNanoseconds is required");
        const r = $68c609acd189a8b4$var$Lo(e);
        let o = $68c609acd189a8b4$var$Ve(t);
        const { tzName: i, offsetMinutes: a } = $68c609acd189a8b4$var$Rt(o);
        if (void 0 === a) {
            const e = $68c609acd189a8b4$var$hr(i);
            if (!e) throw new RangeError(`unknown time zone ${i}`);
            o = e.identifier;
        } else o = $68c609acd189a8b4$var$mr(a);
        $68c609acd189a8b4$var$On(this, r, o, $68c609acd189a8b4$var$zo(void 0 === n ? "iso8601" : $68c609acd189a8b4$var$Ve(n)));
    }
    get calendarId() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$wt), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E);
    }
    get timeZoneId() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$wt), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$$);
    }
    get year() {
        return $68c609acd189a8b4$var$zi(this, "year");
    }
    get month() {
        return $68c609acd189a8b4$var$zi(this, "month");
    }
    get monthCode() {
        return $68c609acd189a8b4$var$zi(this, "monthCode");
    }
    get day() {
        return $68c609acd189a8b4$var$zi(this, "day");
    }
    get hour() {
        return $68c609acd189a8b4$var$Ai(this, "hour");
    }
    get minute() {
        return $68c609acd189a8b4$var$Ai(this, "minute");
    }
    get second() {
        return $68c609acd189a8b4$var$Ai(this, "second");
    }
    get millisecond() {
        return $68c609acd189a8b4$var$Ai(this, "millisecond");
    }
    get microsecond() {
        return $68c609acd189a8b4$var$Ai(this, "microsecond");
    }
    get nanosecond() {
        return $68c609acd189a8b4$var$Ai(this, "nanosecond");
    }
    get era() {
        return $68c609acd189a8b4$var$zi(this, "era");
    }
    get eraYear() {
        return $68c609acd189a8b4$var$zi(this, "eraYear");
    }
    get epochMilliseconds() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$wt), $68c609acd189a8b4$var$No($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$b), "floor");
    }
    get epochNanoseconds() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$wt), $68c609acd189a8b4$var$ko($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$b));
    }
    get dayOfWeek() {
        return $68c609acd189a8b4$var$zi(this, "dayOfWeek");
    }
    get dayOfYear() {
        return $68c609acd189a8b4$var$zi(this, "dayOfYear");
    }
    get weekOfYear() {
        return $68c609acd189a8b4$var$zi(this, "weekOfYear")?.week;
    }
    get yearOfWeek() {
        return $68c609acd189a8b4$var$zi(this, "weekOfYear")?.year;
    }
    get hoursInDay() {
        $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$wt);
        const e = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$$), t = $68c609acd189a8b4$var$Hi(this).isoDate, n = $68c609acd189a8b4$var$Or(t.year, t.month, t.day + 1), r = $68c609acd189a8b4$var$_n(e, t), o = $68c609acd189a8b4$var$_n(e, n);
        return $68c609acd189a8b4$var$Yo($68c609acd189a8b4$var$TimeDuration.fromEpochNsDiff(o, r), "hour");
    }
    get daysInWeek() {
        return $68c609acd189a8b4$var$zi(this, "daysInWeek");
    }
    get daysInMonth() {
        return $68c609acd189a8b4$var$zi(this, "daysInMonth");
    }
    get daysInYear() {
        return $68c609acd189a8b4$var$zi(this, "daysInYear");
    }
    get monthsInYear() {
        return $68c609acd189a8b4$var$zi(this, "monthsInYear");
    }
    get inLeapYear() {
        return $68c609acd189a8b4$var$zi(this, "inLeapYear");
    }
    get offset() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$wt), $68c609acd189a8b4$var$Hn($68c609acd189a8b4$var$Fn($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$$), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$b)));
    }
    get offsetNanoseconds() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$wt), $68c609acd189a8b4$var$Fn($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$$), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$b));
    }
    with(e, t) {
        if ($68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$wt), !$68c609acd189a8b4$var$Ae(e)) throw new TypeError("invalid zoned-date-time-like");
        $68c609acd189a8b4$var$bt(e);
        const n = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E), r = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$$), o = $68c609acd189a8b4$var$Fn(r, $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$b)), i = $68c609acd189a8b4$var$Hi(this);
        let a = {
            ...$68c609acd189a8b4$var$en(n, i.isoDate),
            ...i.time,
            offset: $68c609acd189a8b4$var$Hn(o)
        };
        a = $68c609acd189a8b4$var$Rn(n, a, $68c609acd189a8b4$var$tn(n, e, [
            "year",
            "month",
            "monthCode",
            "day"
        ], [
            "hour",
            "minute",
            "second",
            "millisecond",
            "microsecond",
            "nanosecond",
            "offset"
        ], "partial"));
        const s = $68c609acd189a8b4$var$Zo(t), c = $68c609acd189a8b4$var$Pt(s), d = $68c609acd189a8b4$var$Bt(s, "prefer"), h = $68c609acd189a8b4$var$on(n, a, $68c609acd189a8b4$var$Lt(s)), u = $68c609acd189a8b4$var$sr(a.offset);
        return $68c609acd189a8b4$var$$n($68c609acd189a8b4$var$mn(h.isoDate, h.time, "option", u, r, c, d, !1), r, n);
    }
    withPlainTime(e) {
        $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$wt);
        const t = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$$), n = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E), r = $68c609acd189a8b4$var$Hi(this).isoDate;
        let o;
        return o = void 0 === e ? $68c609acd189a8b4$var$_n(t, r) : $68c609acd189a8b4$var$An(t, $68c609acd189a8b4$var$xt(r, $68c609acd189a8b4$var$re($68c609acd189a8b4$var$hn(e), $68c609acd189a8b4$var$M)), "compatible"), $68c609acd189a8b4$var$$n(o, t, n);
    }
    withTimeZone(e) {
        $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$wt);
        const t = $68c609acd189a8b4$var$Bn(e);
        return $68c609acd189a8b4$var$$n($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$b), t, $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E));
    }
    withCalendar(e) {
        $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$wt);
        const t = $68c609acd189a8b4$var$kn(e);
        return $68c609acd189a8b4$var$$n($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$b), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$$), t);
    }
    add(e, t) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$wt), $68c609acd189a8b4$var$Mo("add", this, e, t);
    }
    subtract(e, t) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$wt), $68c609acd189a8b4$var$Mo("subtract", this, e, t);
    }
    until(e, t) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$wt), $68c609acd189a8b4$var$mo("until", this, e, t);
    }
    since(e, t) {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$wt), $68c609acd189a8b4$var$mo("since", this, e, t);
    }
    round(t) {
        if ($68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$wt), void 0 === t) throw new TypeError("options parameter is required");
        const n = "string" == typeof t ? $68c609acd189a8b4$var$Fo("smallestUnit", t) : $68c609acd189a8b4$var$Zo(t), r = $68c609acd189a8b4$var$Ft(n), o = $68c609acd189a8b4$var$Ut(n, "halfExpand"), i = $68c609acd189a8b4$var$Wt(n, "smallestUnit", "time", $68c609acd189a8b4$var$qt, [
            "day"
        ]), a = {
            day: 1,
            hour: 24,
            minute: 60,
            second: 60,
            millisecond: 1e3,
            microsecond: 1e3,
            nanosecond: 1e3
        }[i];
        if ($68c609acd189a8b4$var$Ht(r, a, 1 === a), "nanosecond" === i && 1 === r) return $68c609acd189a8b4$var$$n($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$b), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$$), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E));
        const s = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$$), c = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$b), d = $68c609acd189a8b4$var$Hi(this);
        let h;
        if ("day" === i) {
            const t = d.isoDate, n = $68c609acd189a8b4$var$Or(t.year, t.month, t.day + 1), r = $68c609acd189a8b4$var$_n(s, t), i = $68c609acd189a8b4$var$_n(s, n), a = (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).subtract(i, r);
            h = $68c609acd189a8b4$var$TimeDuration.fromEpochNsDiff(c, r).round(a, o).addToEpochNs(r);
        } else {
            const e = $68c609acd189a8b4$var$Co(d, r, i, o), t = $68c609acd189a8b4$var$Fn(s, c);
            h = $68c609acd189a8b4$var$mn(e.isoDate, e.time, "option", t, s, "compatible", "prefer", !1);
        }
        return $68c609acd189a8b4$var$$n(h, s, $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E));
    }
    equals(t) {
        $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$wt);
        const n = $68c609acd189a8b4$var$fn(t), r = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$b), o = $68c609acd189a8b4$var$re(n, $68c609acd189a8b4$var$b);
        return !!(0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).equal((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(r), (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(o)) && !!$68c609acd189a8b4$var$Zn($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$$), $68c609acd189a8b4$var$re(n, $68c609acd189a8b4$var$$)) && $68c609acd189a8b4$var$xn($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E), $68c609acd189a8b4$var$re(n, $68c609acd189a8b4$var$E));
    }
    toString(e) {
        $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$wt);
        const t = $68c609acd189a8b4$var$Zo(e), n = $68c609acd189a8b4$var$Zt(t), r = $68c609acd189a8b4$var$zt(t), o = function(e) {
            return $68c609acd189a8b4$var$Ho(e, "offset", [
                "auto",
                "never"
            ], "auto");
        }(t), i = $68c609acd189a8b4$var$Ut(t, "trunc"), a = $68c609acd189a8b4$var$Wt(t, "smallestUnit", "time", void 0);
        if ("hour" === a) throw new RangeError('smallestUnit must be a time unit other than "hour"');
        const s = function(e) {
            return $68c609acd189a8b4$var$Ho(e, "timeZoneName", [
                "auto",
                "never",
                "critical"
            ], "auto");
        }(t), { precision: c, unit: d, increment: h } = $68c609acd189a8b4$var$At(a, r);
        return $68c609acd189a8b4$var$ir(this, c, n, s, o, {
            unit: d,
            increment: h,
            roundingMode: i
        });
    }
    toLocaleString(e, t) {
        $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$wt);
        const n = $68c609acd189a8b4$var$Zo(t), r = Object.create(null);
        if (function(e, t, n, r) {
            if (null == t) return;
            const o = Reflect.ownKeys(t);
            for(let i = 0; i < o.length; i++){
                const a = o[i];
                if (!n.some((e)=>Object.is(e, a)) && Object.prototype.propertyIsEnumerable.call(t, a)) {
                    const n = t[a];
                    r, e[a] = n;
                }
            }
        }(r, n, [
            "timeZone"
        ]), void 0 !== n.timeZone) throw new TypeError("ZonedDateTime toLocaleString does not accept a timeZone option");
        if (void 0 === r.year && void 0 === r.month && void 0 === r.day && void 0 === r.era && void 0 === r.weekday && void 0 === r.dateStyle && void 0 === r.hour && void 0 === r.minute && void 0 === r.second && void 0 === r.fractionalSecondDigits && void 0 === r.timeStyle && void 0 === r.dayPeriod && void 0 === r.timeZoneName && (r.timeZoneName = "short"), r.timeZone = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$$), $68c609acd189a8b4$var$ar(r.timeZone)) throw new RangeError("toLocaleString does not currently support offset time zones");
        const o = new $68c609acd189a8b4$var$di(e, r), i = $68c609acd189a8b4$var$Fi.call(o).calendar, a = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E);
        if ("iso8601" !== a && "iso8601" !== i && !$68c609acd189a8b4$var$xn(i, a)) throw new RangeError(`cannot format ZonedDateTime with calendar ${a} in locale with calendar ${i}`);
        return o.format($68c609acd189a8b4$var$Cn($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$b)));
    }
    toJSON() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$wt), $68c609acd189a8b4$var$ir(this, "auto");
    }
    valueOf() {
        $68c609acd189a8b4$var$qo("ZonedDateTime");
    }
    startOfDay() {
        $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$wt);
        const e = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$$);
        return $68c609acd189a8b4$var$$n($68c609acd189a8b4$var$_n(e, $68c609acd189a8b4$var$Hi(this).isoDate), e, $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E));
    }
    getTimeZoneTransition(e) {
        $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$wt);
        const t = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$$);
        if (void 0 === e) throw new TypeError("options parameter is required");
        const n = $68c609acd189a8b4$var$Ho("string" == typeof e ? $68c609acd189a8b4$var$Fo("direction", e) : $68c609acd189a8b4$var$Zo(e), "direction", [
            "next",
            "previous"
        ], $68c609acd189a8b4$var$qt);
        if (void 0 === n) throw new TypeError("direction option is required");
        if ($68c609acd189a8b4$var$ar(t) || "UTC" === t) return null;
        const r = $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$b), o = "next" === n ? $68c609acd189a8b4$var$wr(t, r) : $68c609acd189a8b4$var$vr(t, r);
        return null === o ? null : $68c609acd189a8b4$var$$n(o, t, $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E));
    }
    toInstant() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$wt), $68c609acd189a8b4$var$Cn($68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$b));
    }
    toPlainDate() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$wt), $68c609acd189a8b4$var$pn($68c609acd189a8b4$var$Hi(this).isoDate, $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E));
    }
    toPlainTime() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$wt), $68c609acd189a8b4$var$Tn($68c609acd189a8b4$var$Hi(this).time);
    }
    toPlainDateTime() {
        return $68c609acd189a8b4$var$vt(this, $68c609acd189a8b4$var$wt), $68c609acd189a8b4$var$wn($68c609acd189a8b4$var$Hi(this), $68c609acd189a8b4$var$re(this, $68c609acd189a8b4$var$E));
    }
    static from(e, t) {
        return $68c609acd189a8b4$var$fn(e, t);
    }
    static compare(t, n) {
        const r = $68c609acd189a8b4$var$fn(t), o = $68c609acd189a8b4$var$fn(n), i = $68c609acd189a8b4$var$re(r, $68c609acd189a8b4$var$b), a = $68c609acd189a8b4$var$re(o, $68c609acd189a8b4$var$b);
        return (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).lessThan((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(i), (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(a)) ? -1 : (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).greaterThan((0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(i), (0, (/*@__PURE__*/$parcel$interopDefault($20de62b8c698bf4b$exports))).BigInt(a)) ? 1 : 0;
    }
}
function $68c609acd189a8b4$var$Hi(e) {
    return $68c609acd189a8b4$var$zn($68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$$), $68c609acd189a8b4$var$re(e, $68c609acd189a8b4$var$b));
}
function $68c609acd189a8b4$var$zi(e, t) {
    $68c609acd189a8b4$var$vt(e, $68c609acd189a8b4$var$wt);
    const n = $68c609acd189a8b4$var$Hi(e).isoDate;
    return $68c609acd189a8b4$var$Qt(e).isoToDate(n, {
        [t]: !0
    })[t];
}
function $68c609acd189a8b4$var$Ai(e, t) {
    return $68c609acd189a8b4$var$vt(e, $68c609acd189a8b4$var$wt), $68c609acd189a8b4$var$Hi(e).time[t];
}
$68c609acd189a8b4$var$ae($68c609acd189a8b4$var$ZonedDateTime, "Temporal.ZonedDateTime");
var $68c609acd189a8b4$export$336849d529cb05e5 = Object.freeze({
    __proto__: null,
    Duration: $68c609acd189a8b4$var$Duration,
    Instant: $68c609acd189a8b4$var$Instant,
    Now: $68c609acd189a8b4$var$Bi,
    PlainDate: $68c609acd189a8b4$var$PlainDate,
    PlainDateTime: $68c609acd189a8b4$var$PlainDateTime,
    PlainMonthDay: $68c609acd189a8b4$var$PlainMonthDay,
    PlainTime: $68c609acd189a8b4$var$PlainTime,
    PlainYearMonth: $68c609acd189a8b4$var$PlainYearMonth,
    ZonedDateTime: $68c609acd189a8b4$var$ZonedDateTime
});
const $68c609acd189a8b4$export$e7fad8854a4bc1a3 = (class LegacyDateImpl {
    toTemporalInstant() {
        return $68c609acd189a8b4$var$Cn($68c609acd189a8b4$var$xo(Date.prototype.valueOf.call(this)));
    }
}).prototype.toTemporalInstant, $68c609acd189a8b4$var$_i = [
    $68c609acd189a8b4$var$Instant,
    $68c609acd189a8b4$var$PlainDate,
    $68c609acd189a8b4$var$PlainDateTime,
    $68c609acd189a8b4$var$Duration,
    $68c609acd189a8b4$var$PlainMonthDay,
    $68c609acd189a8b4$var$PlainTime,
    $68c609acd189a8b4$var$PlainYearMonth,
    $68c609acd189a8b4$var$ZonedDateTime
];
for (const e of $68c609acd189a8b4$var$_i){
    const t = Object.getOwnPropertyDescriptor(e, "prototype");
    (t.configurable || t.enumerable || t.writable) && (t.configurable = !1, t.enumerable = !1, t.writable = !1, Object.defineProperty(e, "prototype", t));
}





const $5d669742300defa8$export$336849d529cb05e5 = (0, $68c609acd189a8b4$export$336849d529cb05e5);
const $5d669742300defa8$export$6f65e24018a3869f = (0, $1a4d2bbfb6ba7df3$export$2e2bcd8739ae039);
const $5d669742300defa8$export$aa9d629c530f62a7 = (0, $36b67ef8a3cfb321$export$aa9d629c530f62a7);


class $f4c42a65ed23eb7a$export$f9c837a54db411d extends Error {
}
const $f4c42a65ed23eb7a$export$f1e53f710478ceb4 = 'TITLE';
const $f4c42a65ed23eb7a$export$aca53469ff012f69 = 'HEADING_1';
const $f4c42a65ed23eb7a$export$8af5e2d4f952c9f0 = 'HEADING_2';
const $f4c42a65ed23eb7a$export$58d6de174a4025df = 'NORMAL_TEXT';
class $f4c42a65ed23eb7a$export$b55edb69cfa7ac57 {
    constructor(it){
        this._it = it;
        this._next();
    }
    _next() {
        this.current = this._it.next().value;
    }
    match(prefix, text) {
        if (!(this.current?.class === prefix && this.current?.text === text)) throw new $f4c42a65ed23eb7a$export$f9c837a54db411d();
        this._next();
    }
    tryMatch(prefix, text) {
        if (!(this.current?.class === prefix && this.current?.text === text)) return undefined;
        this._next();
        return true;
    }
    matchClass(prefix) {
        if (!(this.current?.class === prefix)) throw new $f4c42a65ed23eb7a$export$f9c837a54db411d();
        const content = this.current.text;
        this._next();
        return content;
    }
    tryMatchClass(prefix) {
        if (!(this.current?.class === prefix)) return undefined;
        const content = this.current.text;
        this._next();
        return content;
    }
    consumePlainContent() {
        const content = [];
        let line;
        while(line = this.tryMatchClass($f4c42a65ed23eb7a$export$58d6de174a4025df))content.push(line);
        return content.join('\n');
    }
}



const $1f6bdcc50d2f8f34$var$TherapyID__Brand = Symbol();
const $1f6bdcc50d2f8f34$export$636c46b14d68a88c = 'imago.gaht.fht';
const $1f6bdcc50d2f8f34$export$ff7266e2a45c33f7 = 'imago.gaht.mht';
const $1f6bdcc50d2f8f34$export$a5e6eb70bf0071ab = [
    'full blood count',
    'liver function tests',
    'lipids',
    'testosterone and estradiol',
    'prolactin',
    'LH and FSH',
    'urea and electrolytes',
    'fasting glucose',
    'blood presure reading',
    'kidney function tests (creatinine and cystatin C)'
];
const $1f6bdcc50d2f8f34$var$therapyNames = new Map([
    [
        $1f6bdcc50d2f8f34$export$636c46b14d68a88c,
        'FHT'
    ],
    [
        $1f6bdcc50d2f8f34$export$ff7266e2a45c33f7,
        'MHT'
    ]
]);
const $1f6bdcc50d2f8f34$var$therapiesByName = new Map([
    ...$1f6bdcc50d2f8f34$var$therapyNames
].map(([id, name])=>[
        name,
        id
    ]));
function $1f6bdcc50d2f8f34$export$1e2a67406b324c17(pc) {
    return [
        ...pc.therapy ? [
            {
                class: (0, $f4c42a65ed23eb7a$export$58d6de174a4025df),
                text: `Therapy: ${$1f6bdcc50d2f8f34$var$therapyNames.get(pc.therapy)}`
            }
        ] : [],
        ...pc.advice ? [
            {
                class: (0, $f4c42a65ed23eb7a$export$8af5e2d4f952c9f0),
                text: "Advice"
            },
            {
                class: (0, $f4c42a65ed23eb7a$export$58d6de174a4025df),
                text: pc.advice
            }
        ] : [],
        ...pc.items.flatMap((item)=>[
                {
                    class: (0, $f4c42a65ed23eb7a$export$8af5e2d4f952c9f0),
                    text: item.title
                },
                {
                    class: (0, $f4c42a65ed23eb7a$export$58d6de174a4025df),
                    text: item.dosageRegimen
                },
                {
                    class: (0, $f4c42a65ed23eb7a$export$58d6de174a4025df),
                    text: `Supply ${item.quantity}`
                }
            ]),
        ...pc.reviewIn ? [
            {
                class: (0, $f4c42a65ed23eb7a$export$8af5e2d4f952c9f0),
                text: "Review"
            },
            {
                class: (0, $f4c42a65ed23eb7a$export$58d6de174a4025df),
                text: `Review in: ${pc.reviewIn}`
            },
            {
                class: (0, $f4c42a65ed23eb7a$export$58d6de174a4025df),
                text: `Required tests: ${pc.reviewRequiredTests.join(', ')}`
            },
            {
                class: (0, $f4c42a65ed23eb7a$export$58d6de174a4025df),
                text: `${pc.reviewNotes}`
            }
        ] : []
    ];
}
function $1f6bdcc50d2f8f34$var$shiftMatching(lines, prefix) {
    for(let i = 0; i < lines.length; ++i){
        const line = lines[i];
        if (line.startsWith(prefix)) {
            lines.splice(i, 1);
            return line.substring(prefix.length);
        }
    }
}
function $1f6bdcc50d2f8f34$export$1176b0f83ea388b9(ts) {
    let advice = "";
    let reviewIn = "";
    let reviewRequiredTests = "";
    let reviewNotes = "";
    let items = [];
    const content = ts.consumePlainContent().split('\n');
    const therapyName = $1f6bdcc50d2f8f34$var$shiftMatching(content, 'Therapy: ') ?? '';
    const therapy = $1f6bdcc50d2f8f34$var$therapiesByName.get(therapyName);
    let heading;
    while(heading = ts.tryMatchClass((0, $f4c42a65ed23eb7a$export$8af5e2d4f952c9f0))){
        const content = ts.consumePlainContent().split('\n');
        if (heading === "Advice") advice = content.join('\n');
        else if (heading === "Review") {
            if (!content[0].startsWith('Review in: ')) {
                // Legacy syntax
                reviewIn = content[0];
                continue;
            }
            reviewIn = $1f6bdcc50d2f8f34$var$shiftMatching(content, 'Review in: ') ?? '';
            reviewRequiredTests = $1f6bdcc50d2f8f34$var$shiftMatching(content, 'Required tests: ') ?? '';
            reviewNotes = content.join('\n');
        } else items.push({
            title: heading,
            quantity: $1f6bdcc50d2f8f34$var$shiftMatching(content, 'Supply ') ?? '',
            dosageRegimen: content.join('\n')
        });
    }
    return {
        therapy: therapy,
        advice: advice,
        items: items,
        reviewIn: reviewIn,
        reviewRequiredTests: reviewRequiredTests.split(', '),
        reviewNotes: reviewNotes
    };
}


const $0eecc90764142418$export$4f73034ca74a060d = 'imago.migrated';
const $0eecc90764142418$export$64fb8ef928532180 = 'imago.welcome-call';
const $0eecc90764142418$export$f56c6b421960e728 = 'imago.welcome-call';
const $0eecc90764142418$var$Welcome_Scheduled_ID = $0eecc90764142418$export$f56c6b421960e728 + ':scheduled';
const $0eecc90764142418$var$Welcome_Cancelled_ID = $0eecc90764142418$export$f56c6b421960e728 + ':cancelled';
const $0eecc90764142418$var$Welcome_NoShow_ID = $0eecc90764142418$export$f56c6b421960e728 + ':no-show';
const $0eecc90764142418$var$Welcome_WithWelcomed_ID = 'imago.welcomed';
const $0eecc90764142418$export$2c5eb80d7ad70118 = 'imago.gaht.transfer-call';
const $0eecc90764142418$export$b4f1735772031582 = 'imago.gaht.setup-call';
const $0eecc90764142418$export$6c221e692231ecb4 = 'imago.gaht.setup-call';
const $0eecc90764142418$var$GAHTSetup_Scheduled_ID = $0eecc90764142418$export$6c221e692231ecb4 + ':scheduled';
const $0eecc90764142418$var$GAHTSetup_Cancelled_ID = $0eecc90764142418$export$6c221e692231ecb4 + ':cancelled';
const $0eecc90764142418$var$GAHTSetup_Ready_ID = $0eecc90764142418$export$6c221e692231ecb4 + ':ready';
const $0eecc90764142418$var$GAHTSetup_NoShow_ID = $0eecc90764142418$export$6c221e692231ecb4 + ':no-show';
const $0eecc90764142418$var$GAHTSetup_Done_ID = $0eecc90764142418$export$6c221e692231ecb4 + '';
const $0eecc90764142418$var$GAHTSetup_Closed_WithRecommendation_ID = 'imago.gaht.prescription-draft';
const $0eecc90764142418$export$4bd440df2fb64094 = 'imago.gaht.treatment-review';
const $0eecc90764142418$var$GAHTReview_Scheduled_ID = $0eecc90764142418$export$4bd440df2fb64094 + ':scheduled';
const $0eecc90764142418$var$GAHTReview_Ready_ID = $0eecc90764142418$export$4bd440df2fb64094 + ':ready';
const $0eecc90764142418$var$GAHTReview_WithRecommendation_ID = $0eecc90764142418$export$4bd440df2fb64094 + ':with-prescription-draft';
const $0eecc90764142418$var$GAHTReview_Closed_WithRecommendation_ID = $0eecc90764142418$export$4bd440df2fb64094 + ':closed:with-prescription-draft';
const $0eecc90764142418$var$REPORT_STATUSES = new Map([
    [
        $0eecc90764142418$var$Welcome_Scheduled_ID,
        'scheduled'
    ],
    [
        $0eecc90764142418$var$Welcome_Cancelled_ID,
        'cancelled'
    ],
    [
        $0eecc90764142418$var$Welcome_NoShow_ID,
        'no-show'
    ],
    [
        $0eecc90764142418$var$Welcome_WithWelcomed_ID,
        'done'
    ],
    [
        $0eecc90764142418$var$GAHTSetup_Scheduled_ID,
        'scheduled'
    ],
    [
        $0eecc90764142418$var$GAHTSetup_Cancelled_ID,
        'cancelled'
    ],
    [
        $0eecc90764142418$var$GAHTSetup_Ready_ID,
        'ready'
    ],
    [
        $0eecc90764142418$var$GAHTSetup_NoShow_ID,
        'no-show'
    ],
    [
        $0eecc90764142418$var$GAHTSetup_Done_ID,
        'done'
    ],
    [
        $0eecc90764142418$var$GAHTSetup_Closed_WithRecommendation_ID,
        'done'
    ],
    [
        $0eecc90764142418$var$GAHTReview_Scheduled_ID,
        'scheduled'
    ],
    [
        $0eecc90764142418$var$GAHTReview_Ready_ID,
        'ready'
    ],
    [
        $0eecc90764142418$var$GAHTReview_WithRecommendation_ID,
        'done'
    ],
    [
        $0eecc90764142418$var$GAHTReview_Closed_WithRecommendation_ID,
        'closed'
    ]
]);
const $0eecc90764142418$var$REPORT_TYPES = new Map([
    [
        $0eecc90764142418$var$Welcome_Scheduled_ID,
        $0eecc90764142418$export$f56c6b421960e728
    ],
    [
        $0eecc90764142418$var$Welcome_Cancelled_ID,
        $0eecc90764142418$export$f56c6b421960e728
    ],
    [
        $0eecc90764142418$var$Welcome_NoShow_ID,
        $0eecc90764142418$export$f56c6b421960e728
    ],
    [
        $0eecc90764142418$var$Welcome_WithWelcomed_ID,
        $0eecc90764142418$export$f56c6b421960e728
    ],
    [
        $0eecc90764142418$var$GAHTSetup_Scheduled_ID,
        $0eecc90764142418$export$6c221e692231ecb4
    ],
    [
        $0eecc90764142418$var$GAHTSetup_Cancelled_ID,
        $0eecc90764142418$export$6c221e692231ecb4
    ],
    [
        $0eecc90764142418$var$GAHTSetup_Ready_ID,
        $0eecc90764142418$export$6c221e692231ecb4
    ],
    [
        $0eecc90764142418$var$GAHTSetup_NoShow_ID,
        $0eecc90764142418$export$6c221e692231ecb4
    ],
    [
        $0eecc90764142418$var$GAHTSetup_Done_ID,
        $0eecc90764142418$export$6c221e692231ecb4
    ],
    [
        $0eecc90764142418$var$GAHTSetup_Closed_WithRecommendation_ID,
        $0eecc90764142418$export$6c221e692231ecb4
    ],
    [
        $0eecc90764142418$var$GAHTReview_Scheduled_ID,
        $0eecc90764142418$export$4bd440df2fb64094
    ],
    [
        $0eecc90764142418$var$GAHTReview_Ready_ID,
        $0eecc90764142418$export$4bd440df2fb64094
    ],
    [
        $0eecc90764142418$var$GAHTReview_WithRecommendation_ID,
        $0eecc90764142418$export$4bd440df2fb64094
    ],
    [
        $0eecc90764142418$var$GAHTReview_Closed_WithRecommendation_ID,
        $0eecc90764142418$export$4bd440df2fb64094
    ]
]);
const $0eecc90764142418$export$61aa0c644b9b3a9a = {
    [$0eecc90764142418$export$f56c6b421960e728]: {
        scheduled: $0eecc90764142418$var$Welcome_Scheduled_ID,
        noshow: $0eecc90764142418$var$Welcome_NoShow_ID,
        cancelled: $0eecc90764142418$var$Welcome_Cancelled_ID,
        done: $0eecc90764142418$var$Welcome_WithWelcomed_ID
    },
    [$0eecc90764142418$export$6c221e692231ecb4]: {
        scheduled: $0eecc90764142418$var$GAHTSetup_Scheduled_ID,
        ready: $0eecc90764142418$var$GAHTSetup_Ready_ID,
        noshow: $0eecc90764142418$var$GAHTSetup_NoShow_ID,
        cancelled: $0eecc90764142418$var$GAHTSetup_Cancelled_ID,
        done: $0eecc90764142418$var$GAHTSetup_Closed_WithRecommendation_ID
    },
    [$0eecc90764142418$export$4bd440df2fb64094]: {
        scheduled: $0eecc90764142418$var$GAHTReview_Scheduled_ID,
        ready: $0eecc90764142418$var$GAHTReview_Ready_ID,
        done: $0eecc90764142418$var$GAHTReview_WithRecommendation_ID,
        closed: $0eecc90764142418$var$GAHTReview_Closed_WithRecommendation_ID
    }
};
const $0eecc90764142418$export$3898d0a994db9a38 = new Map([
    [
        $0eecc90764142418$export$f56c6b421960e728,
        "Welcome Call Report"
    ],
    [
        $0eecc90764142418$export$6c221e692231ecb4,
        "GAHT Setup Call Report"
    ],
    [
        $0eecc90764142418$export$4bd440df2fb64094,
        "GAHT Treatment Review Report"
    ]
]);
function $0eecc90764142418$export$260e4fd7df9c643d(kindID) {
    return {
        type: $0eecc90764142418$var$REPORT_TYPES.get(kindID) ?? kindID,
        callStatus: $0eecc90764142418$var$REPORT_STATUSES.get(kindID),
        hasWelcomed: kindID === $0eecc90764142418$var$Welcome_WithWelcomed_ID,
        hasRecommendation: kindID === $0eecc90764142418$var$GAHTSetup_Closed_WithRecommendation_ID || kindID === $0eecc90764142418$var$GAHTReview_WithRecommendation_ID || kindID === $0eecc90764142418$var$GAHTReview_Closed_WithRecommendation_ID
    };
}
// Staff hand-create these to mark bookable slots; YCBM reads them to offer times. They're not encounters.
const $0eecc90764142418$var$AVAILABILITY_TITLE = 'available';
function $0eecc90764142418$export$f41207d85ffab199(ce) {
    return !ce.summary || ce.summary.trim().toLowerCase() === $0eecc90764142418$var$AVAILABILITY_TITLE;
}
function $0eecc90764142418$export$6e7c0593493f7a2b(ce) {
    const summary = ce.summary;
    if (!summary) // Never classify an untitled event as a call - it must not reach the default below.
    return {
        participantName: undefined,
        topic: '',
        type: undefined
    };
    let participantName, topic;
    let splitSummary = summary.split(' / ');
    if (!splitSummary[1]) splitSummary = summary.split(' and ');
    if (splitSummary[1]) {
        participantName = splitSummary[0];
        topic = splitSummary[1].replace('Imago ', '');
    } else topic = summary;
    if (topic.startsWith('TEST ')) topic = topic.substring(5);
    if (topic === 'doctor') topic = 'GAHT setup call';
    if (topic === 'introductory call') topic = 'welcome call';
    const lowertopic = topic.toLowerCase();
    const service = lowertopic === 'welcome call' ? $0eecc90764142418$export$64fb8ef928532180 : lowertopic === 'gaht setup call' ? $0eecc90764142418$export$b4f1735772031582 : lowertopic === 'gaht transfer call' ? $0eecc90764142418$export$2c5eb80d7ad70118 : lowertopic === 'call with zofia' ? $0eecc90764142418$export$64fb8ef928532180 : $0eecc90764142418$export$b4f1735772031582 // TODO we default to GAHT Setup Call, for now
    ;
    const type = service === $0eecc90764142418$export$64fb8ef928532180 ? $0eecc90764142418$export$f56c6b421960e728 : service === $0eecc90764142418$export$b4f1735772031582 ? $0eecc90764142418$export$6c221e692231ecb4 : service === $0eecc90764142418$export$2c5eb80d7ad70118 ? $0eecc90764142418$export$6c221e692231ecb4 : undefined;
    return {
        participantName: participantName,
        topic: topic,
        type: type
    };
}
const $0eecc90764142418$var$docifyType = $0eecc90764142418$export$3898d0a994db9a38;
const $0eecc90764142418$var$parseType = new Map([
    ...$0eecc90764142418$var$docifyType.entries()
].map(([t, s])=>[
        s,
        t
    ]));
function $0eecc90764142418$export$fa808c685b05236e(report) {
    const title = $0eecc90764142418$var$docifyType.get(report.type);
    if (!title) throw new TypeError('Invalid report');
    return [
        {
            class: (0, $f4c42a65ed23eb7a$export$f1e53f710478ceb4),
            text: title
        },
        {
            class: (0, $f4c42a65ed23eb7a$export$58d6de174a4025df),
            text: report.notes
        },
        ...report.messageForAssistant ? [
            {
                class: (0, $f4c42a65ed23eb7a$export$aca53469ff012f69),
                text: "Message for an assistant"
            },
            {
                class: (0, $f4c42a65ed23eb7a$export$58d6de174a4025df),
                text: report.messageForAssistant
            }
        ] : [],
        ...report.recommendation ? [
            {
                class: (0, $f4c42a65ed23eb7a$export$aca53469ff012f69),
                text: "Recommendation"
            },
            ...(0, $1f6bdcc50d2f8f34$export$1e2a67406b324c17)(report.recommendation)
        ] : [],
        ...report.preliminaryNotes ? [
            {
                class: (0, $f4c42a65ed23eb7a$export$aca53469ff012f69),
                text: "Preliminary notes"
            },
            {
                class: (0, $f4c42a65ed23eb7a$export$58d6de174a4025df),
                text: report.preliminaryNotes
            }
        ] : []
    ];
}
function $0eecc90764142418$export$3b77c836013f3e48(md) {
    const ts = new (0, $f4c42a65ed23eb7a$export$b55edb69cfa7ac57)(md[Symbol.iterator]());
    const title = ts.matchClass((0, $f4c42a65ed23eb7a$export$f1e53f710478ceb4));
    const type = $0eecc90764142418$var$parseType.get(title);
    if (!type) throw new (0, $f4c42a65ed23eb7a$export$f9c837a54db411d)();
    const notes = ts.consumePlainContent();
    const report = {
        type: type,
        notes: notes
    };
    while(true){
        if (ts.tryMatch((0, $f4c42a65ed23eb7a$export$aca53469ff012f69), "Prescription draft") || ts.tryMatch((0, $f4c42a65ed23eb7a$export$aca53469ff012f69), "Recommendation")) {
            report.recommendation = (0, $1f6bdcc50d2f8f34$export$1176b0f83ea388b9)(ts);
            continue;
        }
        if (ts.tryMatch((0, $f4c42a65ed23eb7a$export$aca53469ff012f69), "Message for an assistant")) {
            report.messageForAssistant = ts.consumePlainContent();
            continue;
        }
        if (ts.tryMatch((0, $f4c42a65ed23eb7a$export$aca53469ff012f69), "Preliminary notes")) {
            report.preliminaryNotes = ts.consumePlainContent();
            continue;
        }
        break;
    }
    return report;
}


const $52954878a4aa76d6$export$e1967e2dae18c4ac = 'imago.gaht.onboarding';
const $52954878a4aa76d6$var$ServiceID__Brand = Symbol();
const $52954878a4aa76d6$var$ProductID__Brand = Symbol();
function $52954878a4aa76d6$export$ab21a1e7bed2882e(ps) {
    return ps.duration !== undefined;
}
function $52954878a4aa76d6$export$52050d339844a41f(ps) {
    return ps.price !== undefined;
}
function $52954878a4aa76d6$export$936c43b2a62a7e7e(ps) {
    return $52954878a4aa76d6$export$ab21a1e7bed2882e(ps) && $52954878a4aa76d6$export$52050d339844a41f(ps);
}


const $e1e31c6aafe0d6d0$export$fb747e25b6eacff1 = [
    {
        ID: (0, $0eecc90764142418$export$64fb8ef928532180),
        title: 'Welcome call',
        duration: (0, $5d669742300defa8$export$336849d529cb05e5).Duration.from({
            minutes: 15
        }),
        freezeTime: (0, $5d669742300defa8$export$336849d529cb05e5).Duration.from({
            hours: 24
        })
    },
    {
        ID: (0, $52954878a4aa76d6$export$e1967e2dae18c4ac),
        title: 'GAHT onboarding',
        price: "\u20AC250"
    },
    {
        ID: (0, $0eecc90764142418$export$b4f1735772031582),
        title: 'GAHT setup call',
        duration: (0, $5d669742300defa8$export$336849d529cb05e5).Duration.from({
            minutes: 45
        }),
        freezeTime: (0, $5d669742300defa8$export$336849d529cb05e5).Duration.from({
            hours: 24
        })
    },
    {
        ID: (0, $0eecc90764142418$export$2c5eb80d7ad70118),
        title: 'GAHT transfer call',
        duration: (0, $5d669742300defa8$export$336849d529cb05e5).Duration.from({
            minutes: 15
        }),
        freezeTime: (0, $5d669742300defa8$export$336849d529cb05e5).Duration.from({
            hours: 24
        })
    },
    {
        ID: 'imago.services.mental-health-counselling-amanda',
        title: 'Mental health counselling (with Amanda, for under 18s)',
        duration: (0, $5d669742300defa8$export$336849d529cb05e5).Duration.from({
            minutes: 60
        }),
        freezeTime: (0, $5d669742300defa8$export$336849d529cb05e5).Duration.from({
            hours: 24
        }),
        price: "\u20AC60",
        description: `<p>Tame the demons tormenting your psyche.</p>`,
        bio: `<p><b>Amanda Comet</b> (she/her) has a broad experience in psychiatry, giving counselling for suicidal ideation, trauma, substance abuse, and personality syndromes as well as everyday challenges related to executive dysfunction, anxiety, ADHD, and autism. Together with you, she will develop tools and strategies to navigate your issues as well as stabilize and improve your mental wellbeing. Amanda is fluent in Swedish and English and have life experience as a transperson with a visual disability. <a href="https://www.imago.tg/blog/introducing-imago-s-mental-health-support/">Read Amanda\u{2019}s letter of introduction</a></p>`
    },
    {
        ID: 'imago.services.mental-health-counselling',
        title: 'Mental health counselling (with Rhea)',
        duration: (0, $5d669742300defa8$export$336849d529cb05e5).Duration.from({
            minutes: 60
        }),
        freezeTime: (0, $5d669742300defa8$export$336849d529cb05e5).Duration.from({
            hours: 24
        }),
        price: "\u20AC85",
        description: `<p>Reclaim the agency to shape your own way forward.</p>`,
        bio: `<p><b>Rhea</b> (she/her) is an integrative, person-centred psychotherapist who favours an existential-humanistic approach. In her experience \u{2013} the power and agency of the individual to instigate change is often overlooked, which is where the development of a greater self-awareness is also central to the therapeutic process.<br/><br/>Rhea is a transgender woman, and strives to normalise and educate on the spectrums of gender identity and sexuality.<br/><br/>She believes that a non-judgemental, empathic environment is paramount, in order for real change to begin; and, after that, the path towards living your best life becomes a more realistic possibility.</p>`
    },
    {
        ID: 'imago.services.vocal-coaching',
        title: 'Vocal coaching',
        duration: (0, $5d669742300defa8$export$336849d529cb05e5).Duration.from({
            minutes: 50
        }),
        freezeTime: (0, $5d669742300defa8$export$336849d529cb05e5).Duration.from({
            hours: 24
        }),
        price: "\u20AC65",
        description: `<p>Find your authentic voice and vocal autonomy with our vocal dysphoria coach!</p>`,
        bio: "<p><b>Mateo Milicevic</b> (he/him) is a voice and communication coach offering gender-affirming voice work \u2014 voice feminization and masculinization \u2014 alongside therapy for functional voice issues such as vocal nodules. His background is in Clinical Phonetics and Applied Linguistics, and his master\u2019s thesis, a case study on voice therapy with a trans woman, became the first peer-reviewed paper of its kind in a Croatian speech sciences journal. His approach is highly individualized and built around self-listening: getting you tuned in to how your own voice works, sounds, and feels, so that once you can hear it, you can change it. He is also involved with a Croatian NGO working on trans rights.</p>"
    },
    {
        ID: 'imago.services.fertility-counselling',
        title: 'Fertility counselling',
        duration: (0, $5d669742300defa8$export$336849d529cb05e5).Duration.from({
            minutes: 40
        }),
        freezeTime: (0, $5d669742300defa8$export$336849d529cb05e5).Duration.from({
            hours: 24
        }),
        price: "\u20AC50",
        description: `<p>Do you need advice regarding GAHT\u{2019}s effect on fertility, perhaps you want to store your gametes?</p>`
    }
];
const $e1e31c6aafe0d6d0$export$156cd55153e5b58 = $e1e31c6aafe0d6d0$export$fb747e25b6eacff1.filter((service)=>service.ID === 'imago.services.mental-health-counselling' || service.ID === 'imago.services.vocal-coaching');
const $e1e31c6aafe0d6d0$var$TestUserTemplateID__Brand = Symbol();
const $e1e31c6aafe0d6d0$export$76eaf902870ebb73 = [
    {
        ID: 'adam',
        shortName: "Adam",
        description: "a new user"
    },
    {
        ID: 'eve',
        shortName: "Eve",
        description: "an onboarding user"
    },
    {
        ID: 'kasia',
        shortName: "Kasia",
        description: "a greenlighted user"
    },
    {
        ID: 'beata',
        shortName: "Beata",
        description: "a long-time user"
    }
];





const $a6bd29d179726531$export$60ec5c1a48ca2d46 = 'application/vnd.google-apps.folder';
const $a6bd29d179726531$export$dee9bc6d63772856 = 'application/vnd.google-apps.document';
const $a6bd29d179726531$var$UserID__Brand = Symbol();
const $a6bd29d179726531$var$FileID__Brand = Symbol();
const $a6bd29d179726531$var$EMRKindID__Brand = Symbol();
const $a6bd29d179726531$var$EMRTypeID__Brand = Symbol();
function $a6bd29d179726531$export$f47d8e4f75080825(ID) {
    const v = ID.split('/');
    return {
        patientID: v[0],
        fileID: v[1]
    };
}
function $a6bd29d179726531$export$6d6ec28c156c0c98(emr) {
    return {
        ...emr,
        timestamp: emr.timestamp.toString()
    };
}
function $a6bd29d179726531$export$e873c868599413f1(emr) {
    return {
        ...emr,
        timestamp: (0, $5d669742300defa8$export$336849d529cb05e5).Instant.from(emr.timestamp)
    };
}



function $0b9c0d30ea04a097$export$514c75f87bc083f8(app) {
    return {
        ...app,
        start: !app.start ? app.start : app.start.toString(),
        end: !app.end ? app.end : app.end.toString(),
        duration: !app.duration ? app.duration : app.duration.toString()
    };
}
function $0b9c0d30ea04a097$export$a448061180d3d489(app) {
    return {
        ...app,
        start: !app.start ? app.start : (0, $5d669742300defa8$export$336849d529cb05e5).ZonedDateTime.from(app.start),
        end: !app.end ? app.end : (0, $5d669742300defa8$export$336849d529cb05e5).ZonedDateTime.from(app.end),
        duration: !app.duration ? app.duration : (0, $5d669742300defa8$export$336849d529cb05e5).Duration.from(app.duration)
    };
}




function $08faf53332908574$export$4451871831e8d478(invoice) {
    return {
        ...invoice,
        periodStart: invoice.periodStart.toString(),
        periodEnd: invoice.periodEnd.toString(),
        dueBy: invoice.dueBy.toString(),
        nextAttemptOn: invoice.nextAttemptOn === null ? null : invoice.nextAttemptOn.toString()
    };
}
function $08faf53332908574$export$d0b8d2f6421a968f(invoice) {
    return {
        ...invoice,
        periodStart: (0, $5d669742300defa8$export$336849d529cb05e5).Instant.from(invoice.periodStart),
        periodEnd: (0, $5d669742300defa8$export$336849d529cb05e5).Instant.from(invoice.periodEnd),
        dueBy: (0, $5d669742300defa8$export$336849d529cb05e5).Instant.from(invoice.dueBy),
        nextAttemptOn: invoice.nextAttemptOn === null ? null : (0, $5d669742300defa8$export$336849d529cb05e5).Instant.from(invoice.nextAttemptOn)
    };
}


function $c807ce24aebffc65$export$ade94c65c272a613(care) {
    return {
        ...care,
        terminated: care.terminated === null ? null : care.terminated.toString(),
        nextCharge: care.nextCharge === null ? null : care.nextCharge.toString(),
        unpaidInvoices: care.unpaidInvoices.map((0, $08faf53332908574$export$4451871831e8d478))
    };
}
function $c807ce24aebffc65$export$2ebf5e41bf4e3780(care) {
    return {
        ...care,
        terminated: care.terminated === null ? null : (0, $5d669742300defa8$export$336849d529cb05e5).Instant.from(care.terminated),
        nextCharge: care.nextCharge === null ? null : (0, $5d669742300defa8$export$336849d529cb05e5).Instant.from(care.nextCharge),
        unpaidInvoices: care.unpaidInvoices.map((0, $08faf53332908574$export$d0b8d2f6421a968f))
    };
}







const $8fdb24a91a7eb479$export$c74ee46d64b0e84 = 'imago.user-profile';
function $8fdb24a91a7eb479$export$54cbe7c5756cc989(userProfile) {
    return !userProfile ? userProfile : {
        ...userProfile,
        dateOfBirth: userProfile.dateOfBirth.toString()
    };
}
function $8fdb24a91a7eb479$export$8889a2cec7b072e0(userProfile) {
    return {
        ...userProfile,
        dateOfBirth: (0, $5d669742300defa8$export$336849d529cb05e5).PlainDate.from(userProfile.dateOfBirth)
    };
}
function $8fdb24a91a7eb479$export$a5430ebbb660f6f6(md) {
    const blocks = md.map((block)=>({
            ...block,
            text: block.text.trim()
        })).filter((block)=>block.text.length > 0);
    const ts = new (0, $f4c42a65ed23eb7a$export$b55edb69cfa7ac57)(blocks[Symbol.iterator]());
    ts.match("TITLE", "User profile");
    const content = ts.consumePlainContent();
    const profile = {};
    for (const line of content.split('\n')){
        if (!line.trim()) continue;
        const sepPos = line.indexOf(':');
        const key = line.substring(0, sepPos).trim();
        const value = line.substring(sepPos + 1).trim();
        if (key === 'Short name') profile.shortName = value;
        else if (key === 'Pronouns') profile.pronouns = value;
        else if (key === 'Legal name') profile.legalName = value;
        else if (key === 'Date of birth') profile.dateOfBirth = (0, $5d669742300defa8$export$336849d529cb05e5).PlainDate.from(value);
        else console.warn(`Unknown profile key: ${key}`);
    }
    return profile;
}
function $8fdb24a91a7eb479$export$2ba87b5269770a7e(profile) {
    return [
        {
            class: 'TITLE',
            text: "User profile"
        },
        {
            class: 'NORMAL_TEXT',
            text: `Short name: ${profile.shortName}`
        },
        {
            class: 'NORMAL_TEXT',
            text: `Pronouns: ${profile.pronouns}`
        },
        {
            class: 'NORMAL_TEXT',
            text: `Legal name: ${profile.legalName}`
        },
        {
            class: 'NORMAL_TEXT',
            text: `Date of birth: ${profile.dateOfBirth.toString()}`
        }
    ];
}



const $49546e8ba8030a20$export$831bc2e92899aeeb = 'imago.user-surgery-interest';
function $49546e8ba8030a20$export$be7ce84842d80d94(userSurgeryInterest) {
    return {
        ...userSurgeryInterest,
        procedures: new Set(userSurgeryInterest.procedures)
    };
}
function $49546e8ba8030a20$export$92df1a515756d078(userSurgeryInterest) {
    return !userSurgeryInterest ? userSurgeryInterest : {
        ...userSurgeryInterest,
        procedures: [
            ...userSurgeryInterest.procedures
        ]
    };
}
function $49546e8ba8030a20$export$240158805f7ab005(md) {
    const ts = new (0, $f4c42a65ed23eb7a$export$b55edb69cfa7ac57)(md[Symbol.iterator]());
    ts.match("TITLE", "User surgery interest");
    const content = ts.consumePlainContent();
    const interest = {
        procedures: new Set(),
        totalPrice: '',
        when: ''
    };
    for (const line of content.split('\n')){
        if (!line) continue;
        if (line.startsWith('- ')) interest.procedures.add(line.substring(2));
        else {
            const sepPos = line.indexOf(': ');
            const key = line.substring(0, sepPos);
            const value = line.substring(sepPos + 2);
            if (key === 'Total price') interest.totalPrice = value;
            else if (key === 'When') interest.when = value;
            else console.warn(`Unknown profile key: ${key}`);
        }
    }
    return interest;
}
function $49546e8ba8030a20$export$554048d3073c36bd(interest) {
    return [
        {
            class: 'TITLE',
            text: "User surgery interest"
        },
        ...[
            ...interest.procedures
        ].map((surg)=>({
                class: 'NORMAL_TEXT',
                text: `- ${surg}`
            })),
        {
            class: 'NORMAL_TEXT',
            text: `Total price: ${interest.totalPrice}`
        },
        {
            class: 'NORMAL_TEXT',
            text: `When: ${interest.when}`
        }
    ];
}


function $4179c4b78b9a4d6d$export$8ba740db0bbec05(data) {
    return {
        ...data,
        userProfile: !data.userProfile ? data.userProfile : (0, $8fdb24a91a7eb479$export$54cbe7c5756cc989)(data.userProfile),
        userSurgeryInterest: !data.userSurgeryInterest ? data.userSurgeryInterest : (0, $49546e8ba8030a20$export$92df1a515756d078)(data.userSurgeryInterest),
        appointments: !data.appointments ? data.appointments : data.appointments.map((0, $0b9c0d30ea04a097$export$514c75f87bc083f8)),
        care: !data.care ? data.care : (0, $c807ce24aebffc65$export$ade94c65c272a613)(data.care),
        emrs: !data.emrs ? data.emrs : data.emrs.map((0, $a6bd29d179726531$export$6d6ec28c156c0c98))
    };
}
function $4179c4b78b9a4d6d$export$300b7a990d5c168a(data) {
    return {
        ...data,
        userProfile: !data.userProfile ? data.userProfile : (0, $8fdb24a91a7eb479$export$8889a2cec7b072e0)(data.userProfile),
        userSurgeryInterest: !data.userSurgeryInterest ? data.userSurgeryInterest : (0, $49546e8ba8030a20$export$be7ce84842d80d94)(data.userSurgeryInterest),
        appointments: !data.appointments ? data.appointments : data.appointments.map((0, $0b9c0d30ea04a097$export$a448061180d3d489)),
        care: !data.care ? data.care : (0, $c807ce24aebffc65$export$2ebf5e41bf4e3780)(data.care),
        emrs: !data.emrs ? data.emrs : data.emrs.map((0, $a6bd29d179726531$export$e873c868599413f1))
    };
}


const $d627ceabbb20b82f$export$e0e809ea946fc91 = 'imago.gaht.blood-results';


const $b052d1f0285c58fa$export$e4f044c2fd9cdd6a = 'imago.gaht.fht-consent';
const $b052d1f0285c58fa$export$293a15f1e074a8e8 = 'imago.gaht.mht-consent';


const $7de83232caba786b$export$4c4b23d7b53b8b73 = 'imago.gaht.intake-form';


const $59d988fc10ac8442$export$5c5a1d1aa9bb9b = 'imago.gaht.gaht-termination';


const $9e37c2be928a604b$export$d1b599eed051e134 = 'imago.gaht.treatment-feedback';
const $9e37c2be928a604b$var$GAHTTreatmentFeedbackContent__Brand = Symbol();
function $9e37c2be928a604b$export$558b6f64938d76f2(feedback) {
    return [
        {
            class: 'TITLE',
            text: "GAHT Treatment Feedback"
        },
        ...feedback
    ];
}



const $a11b3a4284856e6f$export$493714e6e81c8c15 = 'imago.legal.terms-of-use-accepted';
const $a11b3a4284856e6f$export$f25e47034c9f0b43 = 'imago.legal.privacy-policy-accepted';
const $a11b3a4284856e6f$export$391796957e05e69c = 'imago.legal.withdrawal-waiver-accepted';
const $a11b3a4284856e6f$export$d6607e9b6ee447ba = '2026-05-31';
const $a11b3a4284856e6f$export$d2a62eda671b594a = '2026-05-31';
const $a11b3a4284856e6f$export$8a0c961f422c2c74 = '2026-08-06';
const $a11b3a4284856e6f$export$c19841d3ea487acd = {
    termsOfUseVersion: $a11b3a4284856e6f$export$d6607e9b6ee447ba,
    privacyPolicyVersion: $a11b3a4284856e6f$export$d2a62eda671b594a,
    withdrawalWaiverVersion: $a11b3a4284856e6f$export$8a0c961f422c2c74
};






const $382ebe9a262c830a$export$16b957e35d0b5f20 = 'imago.user-pinned-note';
function $382ebe9a262c830a$export$8999310bfd8dc0d(pn) {
    return [
        {
            class: (0, $f4c42a65ed23eb7a$export$f1e53f710478ceb4),
            text: "Pinned Note"
        },
        {
            class: (0, $f4c42a65ed23eb7a$export$58d6de174a4025df),
            text: pn.notes
        }
    ];
}
function $382ebe9a262c830a$export$ed99c7e8b7457fb0(md) {
    const ts = new (0, $f4c42a65ed23eb7a$export$b55edb69cfa7ac57)(md[Symbol.iterator]());
    ts.match((0, $f4c42a65ed23eb7a$export$f1e53f710478ceb4), "Pinned Note");
    const notes = ts.consumePlainContent();
    const pn = {
        notes: notes
    };
    return pn;
}



const $271ce736e7659b02$export$41382d71a2bb9c1 = 'imago.user-services-request';
function $271ce736e7659b02$export$9b9411586c44193d(request) {
    return {
        services: new Set(request.services)
    };
}
function $271ce736e7659b02$export$5c8b607c3bfc3ce1(request) {
    return !request ? request : {
        services: [
            ...request.services
        ]
    };
}
function $271ce736e7659b02$export$2e7390b170a23089(request) {
    return [
        {
            class: 'TITLE',
            text: "User services request"
        },
        ...[
            ...request.services
        ].map((service)=>({
                class: 'NORMAL_TEXT',
                text: `- ${service}`
            }))
    ];
}




const $93f393cc36b347a9$export$697954dcdca0d17e = 'imago.user-surgery-request';
function $93f393cc36b347a9$export$62a81b22dc760e92(userSurgeryRequest) {
    return {
        ...userSurgeryRequest,
        quote: (0, $49546e8ba8030a20$export$be7ce84842d80d94)(userSurgeryRequest.quote)
    };
}
function $93f393cc36b347a9$export$90d8848701dcee14(userSurgeryRequest) {
    return !userSurgeryRequest ? userSurgeryRequest : {
        ...userSurgeryRequest,
        quote: (0, $49546e8ba8030a20$export$92df1a515756d078)(userSurgeryRequest.quote)
    };
}
function $93f393cc36b347a9$export$5e6b1e2cbe50f70e(request) {
    const interest = request.quote;
    return [
        {
            class: 'TITLE',
            text: "User surgery request"
        },
        ...[
            ...interest.procedures
        ].map((surg)=>({
                class: 'NORMAL_TEXT',
                text: `- ${surg}`
            })),
        {
            class: 'NORMAL_TEXT',
            text: `Total price: ${interest.totalPrice}`
        },
        {
            class: 'NORMAL_TEXT',
            text: `When: ${interest.when}`
        },
        {
            class: 'HEADING_1',
            text: 'Comments'
        },
        {
            class: 'NORMAL_TEXT',
            text: request.comments
        },
        {
            class: 'HEADING_1',
            text: 'Patient details'
        },
        {
            class: 'NORMAL_TEXT',
            text: `Name: ${request.patient.shortName}`
        },
        {
            class: 'NORMAL_TEXT',
            text: `Pronouns: ${request.patient.pronouns}`
        },
        {
            class: 'NORMAL_TEXT',
            text: `Email: ${request.patient.email}`
        },
        {
            class: 'NORMAL_TEXT',
            text: `Phone: ${request.patient.phone}`
        }
    ];
}




var $1c66380376aa2c89$exports = {};
'use strict';
var $e5dd19a945a45bbb$exports = {};
'use strict';
var $08e53d4ef2e1f8ef$exports = {};
'use strict';
var $aaa4be976b2d27a3$exports = {};
'use strict';
/** @type {import('./type')} */ $aaa4be976b2d27a3$exports = TypeError;


var $a48090c7c3dfd2b6$exports = {};
var $a48090c7c3dfd2b6$var$hasMap = typeof Map === 'function' && Map.prototype;
var $a48090c7c3dfd2b6$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $a48090c7c3dfd2b6$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $a48090c7c3dfd2b6$var$mapSize = $a48090c7c3dfd2b6$var$hasMap && $a48090c7c3dfd2b6$var$mapSizeDescriptor && typeof $a48090c7c3dfd2b6$var$mapSizeDescriptor.get === 'function' ? $a48090c7c3dfd2b6$var$mapSizeDescriptor.get : null;
var $a48090c7c3dfd2b6$var$mapForEach = $a48090c7c3dfd2b6$var$hasMap && Map.prototype.forEach;
var $a48090c7c3dfd2b6$var$hasSet = typeof Set === 'function' && Set.prototype;
var $a48090c7c3dfd2b6$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $a48090c7c3dfd2b6$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $a48090c7c3dfd2b6$var$setSize = $a48090c7c3dfd2b6$var$hasSet && $a48090c7c3dfd2b6$var$setSizeDescriptor && typeof $a48090c7c3dfd2b6$var$setSizeDescriptor.get === 'function' ? $a48090c7c3dfd2b6$var$setSizeDescriptor.get : null;
var $a48090c7c3dfd2b6$var$setForEach = $a48090c7c3dfd2b6$var$hasSet && Set.prototype.forEach;
var $a48090c7c3dfd2b6$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $a48090c7c3dfd2b6$var$weakMapHas = $a48090c7c3dfd2b6$var$hasWeakMap ? WeakMap.prototype.has : null;
var $a48090c7c3dfd2b6$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $a48090c7c3dfd2b6$var$weakSetHas = $a48090c7c3dfd2b6$var$hasWeakSet ? WeakSet.prototype.has : null;
var $a48090c7c3dfd2b6$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $a48090c7c3dfd2b6$var$weakRefDeref = $a48090c7c3dfd2b6$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $a48090c7c3dfd2b6$var$booleanValueOf = Boolean.prototype.valueOf;
var $a48090c7c3dfd2b6$var$objectToString = Object.prototype.toString;
var $a48090c7c3dfd2b6$var$functionToString = Function.prototype.toString;
var $a48090c7c3dfd2b6$var$$match = String.prototype.match;
var $a48090c7c3dfd2b6$var$$slice = String.prototype.slice;
var $a48090c7c3dfd2b6$var$$replace = String.prototype.replace;
var $a48090c7c3dfd2b6$var$$toUpperCase = String.prototype.toUpperCase;
var $a48090c7c3dfd2b6$var$$toLowerCase = String.prototype.toLowerCase;
var $a48090c7c3dfd2b6$var$$test = RegExp.prototype.test;
var $a48090c7c3dfd2b6$var$$concat = Array.prototype.concat;
var $a48090c7c3dfd2b6$var$$join = Array.prototype.join;
var $a48090c7c3dfd2b6$var$$arrSlice = Array.prototype.slice;
var $a48090c7c3dfd2b6$var$$floor = Math.floor;
var $a48090c7c3dfd2b6$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $a48090c7c3dfd2b6$var$gOPS = Object.getOwnPropertySymbols;
var $a48090c7c3dfd2b6$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $a48090c7c3dfd2b6$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $a48090c7c3dfd2b6$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $a48090c7c3dfd2b6$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $a48090c7c3dfd2b6$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $a48090c7c3dfd2b6$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $a48090c7c3dfd2b6$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $a48090c7c3dfd2b6$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$a48090c7c3dfd2b6$var$$floor(-num) : $a48090c7c3dfd2b6$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $a48090c7c3dfd2b6$var$$slice.call(str, intStr.length + 1);
            return $a48090c7c3dfd2b6$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $a48090c7c3dfd2b6$var$$replace.call($a48090c7c3dfd2b6$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $a48090c7c3dfd2b6$var$$replace.call(str, sepRegex, '$&_');
}
var $eca075ad100d834d$exports = {};
"use strict";


var $a48090c7c3dfd2b6$var$inspectCustom = $eca075ad100d834d$exports.custom;
var $a48090c7c3dfd2b6$var$inspectSymbol = $a48090c7c3dfd2b6$var$isSymbol($a48090c7c3dfd2b6$var$inspectCustom) ? $a48090c7c3dfd2b6$var$inspectCustom : null;
var $a48090c7c3dfd2b6$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $a48090c7c3dfd2b6$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
$a48090c7c3dfd2b6$exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($a48090c7c3dfd2b6$var$has(opts, 'quoteStyle') && !$a48090c7c3dfd2b6$var$has($a48090c7c3dfd2b6$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($a48090c7c3dfd2b6$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $a48090c7c3dfd2b6$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($a48090c7c3dfd2b6$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($a48090c7c3dfd2b6$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $a48090c7c3dfd2b6$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $a48090c7c3dfd2b6$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $a48090c7c3dfd2b6$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $a48090c7c3dfd2b6$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $a48090c7c3dfd2b6$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($a48090c7c3dfd2b6$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $a48090c7c3dfd2b6$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($a48090c7c3dfd2b6$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$a48090c7c3dfd2b6$var$isRegExp(obj)) {
        var name = $a48090c7c3dfd2b6$var$nameOf(obj);
        var keys = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $a48090c7c3dfd2b6$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($a48090c7c3dfd2b6$var$isSymbol(obj)) {
        var symString = $a48090c7c3dfd2b6$var$hasShammedSymbols ? $a48090c7c3dfd2b6$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $a48090c7c3dfd2b6$var$symToString.call(obj);
        return typeof obj === 'object' && !$a48090c7c3dfd2b6$var$hasShammedSymbols ? $a48090c7c3dfd2b6$var$markBoxed(symString) : symString;
    }
    if ($a48090c7c3dfd2b6$var$isElement(obj)) {
        var s = '<' + $a48090c7c3dfd2b6$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $a48090c7c3dfd2b6$var$wrapQuotes($a48090c7c3dfd2b6$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $a48090c7c3dfd2b6$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($a48090c7c3dfd2b6$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        if (indent && !$a48090c7c3dfd2b6$var$singleLineValues(xs)) return '[' + $a48090c7c3dfd2b6$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $a48090c7c3dfd2b6$var$$join.call(xs, ', ') + ' ]';
    }
    if ($a48090c7c3dfd2b6$var$isError(obj)) {
        var parts = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$a48090c7c3dfd2b6$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $a48090c7c3dfd2b6$var$$join.call($a48090c7c3dfd2b6$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $a48090c7c3dfd2b6$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($a48090c7c3dfd2b6$var$inspectSymbol && typeof obj[$a48090c7c3dfd2b6$var$inspectSymbol] === 'function' && $eca075ad100d834d$exports) return $eca075ad100d834d$exports(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($a48090c7c3dfd2b6$var$isMap(obj)) {
        var mapParts = [];
        if ($a48090c7c3dfd2b6$var$mapForEach) $a48090c7c3dfd2b6$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $a48090c7c3dfd2b6$var$collectionOf('Map', $a48090c7c3dfd2b6$var$mapSize.call(obj), mapParts, indent);
    }
    if ($a48090c7c3dfd2b6$var$isSet(obj)) {
        var setParts = [];
        if ($a48090c7c3dfd2b6$var$setForEach) $a48090c7c3dfd2b6$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $a48090c7c3dfd2b6$var$collectionOf('Set', $a48090c7c3dfd2b6$var$setSize.call(obj), setParts, indent);
    }
    if ($a48090c7c3dfd2b6$var$isWeakMap(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf('WeakMap');
    if ($a48090c7c3dfd2b6$var$isWeakSet(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf('WeakSet');
    if ($a48090c7c3dfd2b6$var$isWeakRef(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf('WeakRef');
    if ($a48090c7c3dfd2b6$var$isNumber(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect(Number(obj)));
    if ($a48090c7c3dfd2b6$var$isBigInt(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect($a48090c7c3dfd2b6$var$bigIntValueOf.call(obj)));
    if ($a48090c7c3dfd2b6$var$isBoolean(obj)) return $a48090c7c3dfd2b6$var$markBoxed($a48090c7c3dfd2b6$var$booleanValueOf.call(obj));
    if ($a48090c7c3dfd2b6$var$isString(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$a48090c7c3dfd2b6$var$isDate(obj) && !$a48090c7c3dfd2b6$var$isRegExp(obj)) {
        var ys = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        var isPlainObject = $a48090c7c3dfd2b6$var$gPO ? $a48090c7c3dfd2b6$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $a48090c7c3dfd2b6$var$toStringTag && Object(obj) === obj && $a48090c7c3dfd2b6$var$toStringTag in obj ? $a48090c7c3dfd2b6$var$$slice.call($a48090c7c3dfd2b6$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $a48090c7c3dfd2b6$var$$join.call($a48090c7c3dfd2b6$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $a48090c7c3dfd2b6$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $a48090c7c3dfd2b6$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $a48090c7c3dfd2b6$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $a48090c7c3dfd2b6$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $a48090c7c3dfd2b6$var$quote(s) {
    return $a48090c7c3dfd2b6$var$$replace.call(String(s), /"/g, '&quot;');
}
function $a48090c7c3dfd2b6$var$canTrustToString(obj) {
    return !$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === 'object' && ($a48090c7c3dfd2b6$var$toStringTag in obj || typeof obj[$a48090c7c3dfd2b6$var$toStringTag] !== 'undefined'));
}
function $a48090c7c3dfd2b6$var$isArray(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === '[object Array]' && $a48090c7c3dfd2b6$var$canTrustToString(obj);
}
function $a48090c7c3dfd2b6$var$isDate(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === '[object Date]' && $a48090c7c3dfd2b6$var$canTrustToString(obj);
}
function $a48090c7c3dfd2b6$var$isRegExp(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === '[object RegExp]' && $a48090c7c3dfd2b6$var$canTrustToString(obj);
}
function $a48090c7c3dfd2b6$var$isError(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === '[object Error]' && $a48090c7c3dfd2b6$var$canTrustToString(obj);
}
function $a48090c7c3dfd2b6$var$isString(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === '[object String]' && $a48090c7c3dfd2b6$var$canTrustToString(obj);
}
function $a48090c7c3dfd2b6$var$isNumber(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === '[object Number]' && $a48090c7c3dfd2b6$var$canTrustToString(obj);
}
function $a48090c7c3dfd2b6$var$isBoolean(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === '[object Boolean]' && $a48090c7c3dfd2b6$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $a48090c7c3dfd2b6$var$isSymbol(obj) {
    if ($a48090c7c3dfd2b6$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$a48090c7c3dfd2b6$var$symToString) return false;
    try {
        $a48090c7c3dfd2b6$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$a48090c7c3dfd2b6$var$bigIntValueOf) return false;
    try {
        $a48090c7c3dfd2b6$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $a48090c7c3dfd2b6$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $a48090c7c3dfd2b6$var$has(obj, key) {
    return $a48090c7c3dfd2b6$var$hasOwn.call(obj, key);
}
function $a48090c7c3dfd2b6$var$toStr(obj) {
    return $a48090c7c3dfd2b6$var$objectToString.call(obj);
}
function $a48090c7c3dfd2b6$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $a48090c7c3dfd2b6$var$$match.call($a48090c7c3dfd2b6$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $a48090c7c3dfd2b6$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $a48090c7c3dfd2b6$var$isMap(x) {
    if (!$a48090c7c3dfd2b6$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $a48090c7c3dfd2b6$var$mapSize.call(x);
        try {
            $a48090c7c3dfd2b6$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakMap(x) {
    if (!$a48090c7c3dfd2b6$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $a48090c7c3dfd2b6$var$weakMapHas.call(x, $a48090c7c3dfd2b6$var$weakMapHas);
        try {
            $a48090c7c3dfd2b6$var$weakSetHas.call(x, $a48090c7c3dfd2b6$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakRef(x) {
    if (!$a48090c7c3dfd2b6$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $a48090c7c3dfd2b6$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isSet(x) {
    if (!$a48090c7c3dfd2b6$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $a48090c7c3dfd2b6$var$setSize.call(x);
        try {
            $a48090c7c3dfd2b6$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakSet(x) {
    if (!$a48090c7c3dfd2b6$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $a48090c7c3dfd2b6$var$weakSetHas.call(x, $a48090c7c3dfd2b6$var$weakSetHas);
        try {
            $a48090c7c3dfd2b6$var$weakMapHas.call(x, $a48090c7c3dfd2b6$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $a48090c7c3dfd2b6$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $a48090c7c3dfd2b6$var$inspectString($a48090c7c3dfd2b6$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $a48090c7c3dfd2b6$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $a48090c7c3dfd2b6$var$$replace.call($a48090c7c3dfd2b6$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $a48090c7c3dfd2b6$var$lowbyte);
    return $a48090c7c3dfd2b6$var$wrapQuotes(s, 'single', opts);
}
function $a48090c7c3dfd2b6$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $a48090c7c3dfd2b6$var$$toUpperCase.call(n.toString(16));
}
function $a48090c7c3dfd2b6$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $a48090c7c3dfd2b6$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $a48090c7c3dfd2b6$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $a48090c7c3dfd2b6$var$indentedJoin(entries, indent) : $a48090c7c3dfd2b6$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $a48090c7c3dfd2b6$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($a48090c7c3dfd2b6$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $a48090c7c3dfd2b6$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $a48090c7c3dfd2b6$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $a48090c7c3dfd2b6$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $a48090c7c3dfd2b6$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $a48090c7c3dfd2b6$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect) {
    var isArr = $a48090c7c3dfd2b6$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $a48090c7c3dfd2b6$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $a48090c7c3dfd2b6$var$gOPS === 'function' ? $a48090c7c3dfd2b6$var$gOPS(obj) : [];
    var symMap;
    if ($a48090c7c3dfd2b6$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$a48090c7c3dfd2b6$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($a48090c7c3dfd2b6$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($a48090c7c3dfd2b6$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $a48090c7c3dfd2b6$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($a48090c7c3dfd2b6$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}


var $52bc36570c76608b$exports = {};
'use strict';


/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $52bc36570c76608b$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $52bc36570c76608b$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $52bc36570c76608b$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $52bc36570c76608b$var$listSet = function(objects, key, value) {
    var node = $52bc36570c76608b$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $52bc36570c76608b$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$52bc36570c76608b$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $52bc36570c76608b$var$listDelete = function(objects, key) {
    if (objects) return $52bc36570c76608b$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ $52bc36570c76608b$exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $aaa4be976b2d27a3$exports('Side channel does not contain ' + $a48090c7c3dfd2b6$exports(key));
        },
        'delete': function(key) {
            var root = $o && $o.next;
            var deletedNode = $52bc36570c76608b$var$listDelete($o, key);
            if (deletedNode && root && root === deletedNode) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $52bc36570c76608b$var$listGet($o, key);
        },
        has: function(key) {
            return $52bc36570c76608b$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $52bc36570c76608b$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};


var $8043468335131548$exports = {};
'use strict';
var $3e3932b3a4c4daea$exports = {};
'use strict';
var $3e3932b3a4c4daea$var$undefined1;
var $68f77cfee0d91ea0$exports = {};
'use strict';
/** @type {import('.')} */ $68f77cfee0d91ea0$exports = Object;


var $41038844aec6eaa2$exports = {};
'use strict';
/** @type {import('.')} */ $41038844aec6eaa2$exports = Error;


var $cd6d4b204c89f4f4$exports = {};
'use strict';
/** @type {import('./eval')} */ $cd6d4b204c89f4f4$exports = EvalError;


var $72e6a4e026a755bb$exports = {};
'use strict';
/** @type {import('./range')} */ $72e6a4e026a755bb$exports = RangeError;


var $1e478fcc3e34e216$exports = {};
'use strict';
/** @type {import('./ref')} */ $1e478fcc3e34e216$exports = ReferenceError;


var $43bb4ccdc6568bcf$exports = {};
'use strict';
/** @type {import('./syntax')} */ $43bb4ccdc6568bcf$exports = SyntaxError;



var $cde0c3ef12944098$exports = {};
'use strict';
/** @type {import('./uri')} */ $cde0c3ef12944098$exports = URIError;


var $829c6ad74b893335$exports = {};
'use strict';
/** @type {import('./abs')} */ $829c6ad74b893335$exports = Math.abs;


var $a0167fb8027efc6c$exports = {};
'use strict';
/** @type {import('./floor')} */ $a0167fb8027efc6c$exports = Math.floor;


var $59437e5dc9fc2c61$exports = {};
'use strict';
/** @type {import('./max')} */ $59437e5dc9fc2c61$exports = Math.max;


var $328f401f1e19f003$exports = {};
'use strict';
/** @type {import('./min')} */ $328f401f1e19f003$exports = Math.min;


var $8560e7c6d4e34f2f$exports = {};
'use strict';
/** @type {import('./pow')} */ $8560e7c6d4e34f2f$exports = Math.pow;


var $10e5f4d8a4a1ed83$exports = {};
'use strict';
/** @type {import('./round')} */ $10e5f4d8a4a1ed83$exports = Math.round;


var $37113bd5f1fb3cc6$exports = {};
'use strict';
var $3327ce1cf537a5ae$exports = {};
'use strict';
/** @type {import('./isNaN')} */ $3327ce1cf537a5ae$exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};


/** @type {import('./sign')} */ $37113bd5f1fb3cc6$exports = function sign(number) {
    if ($3327ce1cf537a5ae$exports(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};


var $3e3932b3a4c4daea$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $3e3932b3a4c4daea$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $3e3932b3a4c4daea$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};
var $a2d7d74e83f6c3ed$exports = {};
'use strict';
var $985031ced66f900d$exports = {};
'use strict';
/** @type {import('./gOPD')} */ $985031ced66f900d$exports = Object.getOwnPropertyDescriptor;


var $a2d7d74e83f6c3ed$require$$gOPD = $985031ced66f900d$exports;
if ($a2d7d74e83f6c3ed$require$$gOPD) try {
    $a2d7d74e83f6c3ed$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $a2d7d74e83f6c3ed$require$$gOPD = null;
}
$a2d7d74e83f6c3ed$exports = $a2d7d74e83f6c3ed$require$$gOPD;


var $a0368664cdb0e5d1$exports = {};
'use strict';
/** @type {import('.')} */ var $a0368664cdb0e5d1$var$$defineProperty = Object.defineProperty || false;
if ($a0368664cdb0e5d1$var$$defineProperty) try {
    $a0368664cdb0e5d1$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $a0368664cdb0e5d1$var$$defineProperty = false;
}
$a0368664cdb0e5d1$exports = $a0368664cdb0e5d1$var$$defineProperty;


var $3e3932b3a4c4daea$var$throwTypeError = function() {
    throw new $aaa4be976b2d27a3$exports();
};
var $3e3932b3a4c4daea$var$ThrowTypeError = $a2d7d74e83f6c3ed$exports ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $3e3932b3a4c4daea$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $a2d7d74e83f6c3ed$exports(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $3e3932b3a4c4daea$var$throwTypeError;
        }
    }
}() : $3e3932b3a4c4daea$var$throwTypeError;

var $3e3932b3a4c4daea$var$hasSymbols = (parcelRequire("24qIq"))();
var $2a9ec54411859bd9$exports = {};
'use strict';
var $0a6f5f26ef0609b6$exports = {};
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ $0a6f5f26ef0609b6$exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;


var $a683e9a1df37ed0e$exports = {};
'use strict';

/** @type {import('./Object.getPrototypeOf')} */ $a683e9a1df37ed0e$exports = $68f77cfee0d91ea0$exports.getPrototypeOf || null;


var $55566fcac2c38fe4$exports = {};
'use strict';
var $e3cb45ba87de93fe$exports = {};
'use strict';
var $c0378745895dc03c$exports = {};
'use strict';
var $efd80b1d7fbb2850$exports = {};
'use strict';
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$max = Math.max;
var $efd80b1d7fbb2850$var$funcType = '[object Function]';
var $efd80b1d7fbb2850$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $efd80b1d7fbb2850$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $efd80b1d7fbb2850$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
$efd80b1d7fbb2850$exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $efd80b1d7fbb2850$var$toStr.apply(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $efd80b1d7fbb2850$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $efd80b1d7fbb2850$var$concatty(args, arguments));
    };
    var boundLength = $efd80b1d7fbb2850$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $efd80b1d7fbb2850$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};


$c0378745895dc03c$exports = Function.prototype.bind || $efd80b1d7fbb2850$exports;



var $6da1bf1c46eb4156$exports = {};
'use strict';
/** @type {import('./functionCall')} */ $6da1bf1c46eb4156$exports = Function.prototype.call;


var $2e4f98706b21e7c9$exports = {};
'use strict';

var $0658b6e5d2101996$exports = {};
'use strict';
/** @type {import('./functionApply')} */ $0658b6e5d2101996$exports = Function.prototype.apply;



var $623e642332342b72$exports = {};
'use strict';
/** @type {import('./reflectApply')} */ $623e642332342b72$exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/** @type {import('./actualApply')} */ $2e4f98706b21e7c9$exports = $623e642332342b72$exports || $c0378745895dc03c$exports.call($6da1bf1c46eb4156$exports, $0658b6e5d2101996$exports);


/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ $e3cb45ba87de93fe$exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $aaa4be976b2d27a3$exports('a function is required');
    return $2e4f98706b21e7c9$exports($c0378745895dc03c$exports, $6da1bf1c46eb4156$exports, args);
};



var $55566fcac2c38fe4$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $55566fcac2c38fe4$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $55566fcac2c38fe4$var$desc = !!$55566fcac2c38fe4$var$hasProtoAccessor && $a2d7d74e83f6c3ed$exports && $a2d7d74e83f6c3ed$exports(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $55566fcac2c38fe4$var$$Object = Object;
var $55566fcac2c38fe4$var$$getPrototypeOf = $55566fcac2c38fe4$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ $55566fcac2c38fe4$exports = $55566fcac2c38fe4$var$desc && typeof $55566fcac2c38fe4$var$desc.get === 'function' ? $e3cb45ba87de93fe$exports([
    $55566fcac2c38fe4$var$desc.get
]) : typeof $55566fcac2c38fe4$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $55566fcac2c38fe4$var$$getPrototypeOf(value == null ? value : $55566fcac2c38fe4$var$$Object(value));
} : false;


/** @type {import('.')} */ $2a9ec54411859bd9$exports = $0a6f5f26ef0609b6$exports ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $0a6f5f26ef0609b6$exports(O);
} : $a683e9a1df37ed0e$exports ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $a683e9a1df37ed0e$exports(O);
} : $55566fcac2c38fe4$exports ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $55566fcac2c38fe4$exports(O);
} : null;






var $3e3932b3a4c4daea$var$needsEval = {};
var $3e3932b3a4c4daea$var$TypedArray = typeof Uint8Array === 'undefined' || !$2a9ec54411859bd9$exports ? undefined : $2a9ec54411859bd9$exports(Uint8Array);
var $3e3932b3a4c4daea$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $3e3932b3a4c4daea$var$hasSymbols && $2a9ec54411859bd9$exports ? $2a9ec54411859bd9$exports([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $3e3932b3a4c4daea$var$needsEval,
    '%AsyncGenerator%': $3e3932b3a4c4daea$var$needsEval,
    '%AsyncGeneratorFunction%': $3e3932b3a4c4daea$var$needsEval,
    '%AsyncIteratorPrototype%': $3e3932b3a4c4daea$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $41038844aec6eaa2$exports,
    '%eval%': eval,
    '%EvalError%': $cd6d4b204c89f4f4$exports,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $3e3932b3a4c4daea$var$$Function,
    '%GeneratorFunction%': $3e3932b3a4c4daea$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $3e3932b3a4c4daea$var$hasSymbols && $2a9ec54411859bd9$exports ? $2a9ec54411859bd9$exports($2a9ec54411859bd9$exports([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$3e3932b3a4c4daea$var$hasSymbols || !$2a9ec54411859bd9$exports ? undefined : $2a9ec54411859bd9$exports(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $68f77cfee0d91ea0$exports,
    '%Object.getOwnPropertyDescriptor%': $a2d7d74e83f6c3ed$exports,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $72e6a4e026a755bb$exports,
    '%ReferenceError%': $1e478fcc3e34e216$exports,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$3e3932b3a4c4daea$var$hasSymbols || !$2a9ec54411859bd9$exports ? undefined : $2a9ec54411859bd9$exports(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $3e3932b3a4c4daea$var$hasSymbols && $2a9ec54411859bd9$exports ? $2a9ec54411859bd9$exports(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $3e3932b3a4c4daea$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $43bb4ccdc6568bcf$exports,
    '%ThrowTypeError%': $3e3932b3a4c4daea$var$ThrowTypeError,
    '%TypedArray%': $3e3932b3a4c4daea$var$TypedArray,
    '%TypeError%': $aaa4be976b2d27a3$exports,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $cde0c3ef12944098$exports,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $6da1bf1c46eb4156$exports,
    '%Function.prototype.apply%': $0658b6e5d2101996$exports,
    '%Object.defineProperty%': $a0368664cdb0e5d1$exports,
    '%Object.getPrototypeOf%': $a683e9a1df37ed0e$exports,
    '%Math.abs%': $829c6ad74b893335$exports,
    '%Math.floor%': $a0167fb8027efc6c$exports,
    '%Math.max%': $59437e5dc9fc2c61$exports,
    '%Math.min%': $328f401f1e19f003$exports,
    '%Math.pow%': $8560e7c6d4e34f2f$exports,
    '%Math.round%': $10e5f4d8a4a1ed83$exports,
    '%Math.sign%': $37113bd5f1fb3cc6$exports,
    '%Reflect.getPrototypeOf%': $0a6f5f26ef0609b6$exports
};
if ($2a9ec54411859bd9$exports) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $3e3932b3a4c4daea$var$errorProto = $2a9ec54411859bd9$exports($2a9ec54411859bd9$exports(e));
    $3e3932b3a4c4daea$var$INTRINSICS['%Error.prototype%'] = $3e3932b3a4c4daea$var$errorProto;
}
var $3e3932b3a4c4daea$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $3e3932b3a4c4daea$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $3e3932b3a4c4daea$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $3e3932b3a4c4daea$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $2a9ec54411859bd9$exports) value = $2a9ec54411859bd9$exports(gen.prototype);
    }
    $3e3932b3a4c4daea$var$INTRINSICS[name] = value;
    return value;
};
var $3e3932b3a4c4daea$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $30dbf79dbae6c725$exports = {};
'use strict';
var $30dbf79dbae6c725$var$call = Function.prototype.call;
var $30dbf79dbae6c725$var$$hasOwn = Object.prototype.hasOwnProperty;

/** @type {import('.')} */ $30dbf79dbae6c725$exports = $c0378745895dc03c$exports.call($30dbf79dbae6c725$var$call, $30dbf79dbae6c725$var$$hasOwn);


var $3e3932b3a4c4daea$var$$concat = $c0378745895dc03c$exports.call($6da1bf1c46eb4156$exports, Array.prototype.concat);
var $3e3932b3a4c4daea$var$$spliceApply = $c0378745895dc03c$exports.call($0658b6e5d2101996$exports, Array.prototype.splice);
var $3e3932b3a4c4daea$var$$replace = $c0378745895dc03c$exports.call($6da1bf1c46eb4156$exports, String.prototype.replace);
var $3e3932b3a4c4daea$var$$strSlice = $c0378745895dc03c$exports.call($6da1bf1c46eb4156$exports, String.prototype.slice);
var $3e3932b3a4c4daea$var$$exec = $c0378745895dc03c$exports.call($6da1bf1c46eb4156$exports, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $3e3932b3a4c4daea$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $3e3932b3a4c4daea$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $3e3932b3a4c4daea$var$stringToPath = function stringToPath(string) {
    var first = $3e3932b3a4c4daea$var$$strSlice(string, 0, 1);
    var last = $3e3932b3a4c4daea$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $43bb4ccdc6568bcf$exports('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $43bb4ccdc6568bcf$exports('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $3e3932b3a4c4daea$var$$replace(string, $3e3932b3a4c4daea$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $3e3932b3a4c4daea$var$$replace(subString, $3e3932b3a4c4daea$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $3e3932b3a4c4daea$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($30dbf79dbae6c725$exports($3e3932b3a4c4daea$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $3e3932b3a4c4daea$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($30dbf79dbae6c725$exports($3e3932b3a4c4daea$var$INTRINSICS, intrinsicName)) {
        var value = $3e3932b3a4c4daea$var$INTRINSICS[intrinsicName];
        if (value === $3e3932b3a4c4daea$var$needsEval) value = $3e3932b3a4c4daea$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $aaa4be976b2d27a3$exports('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $43bb4ccdc6568bcf$exports('intrinsic ' + name + ' does not exist!');
};
$3e3932b3a4c4daea$exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $aaa4be976b2d27a3$exports('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $aaa4be976b2d27a3$exports('"allowMissing" argument must be a boolean');
    if ($3e3932b3a4c4daea$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $43bb4ccdc6568bcf$exports('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $3e3932b3a4c4daea$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $3e3932b3a4c4daea$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $3e3932b3a4c4daea$var$$spliceApply(parts, $3e3932b3a4c4daea$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $3e3932b3a4c4daea$var$$strSlice(part, 0, 1);
        var last = $3e3932b3a4c4daea$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $43bb4ccdc6568bcf$exports('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($30dbf79dbae6c725$exports($3e3932b3a4c4daea$var$INTRINSICS, intrinsicRealName)) value = $3e3932b3a4c4daea$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $aaa4be976b2d27a3$exports('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($a2d7d74e83f6c3ed$exports && i + 1 >= parts.length) {
                var desc = $a2d7d74e83f6c3ed$exports(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $30dbf79dbae6c725$exports(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $3e3932b3a4c4daea$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};


var $adf8ebd7229df60a$exports = {};
'use strict';
var $5f5b9977eebd6fef$exports = {};
'use strict';
var $5f5b9977eebd6fef$var$undefined1;















var $5f5b9977eebd6fef$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $5f5b9977eebd6fef$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $5f5b9977eebd6fef$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $bbe48bbd9149c147$exports = {};
'use strict';
/** @type {import('.')} */ var $bbe48bbd9149c147$var$$defineProperty = Object.defineProperty || false;
if ($bbe48bbd9149c147$var$$defineProperty) try {
    $bbe48bbd9149c147$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $bbe48bbd9149c147$var$$defineProperty = false;
}
$bbe48bbd9149c147$exports = $bbe48bbd9149c147$var$$defineProperty;


var $5f5b9977eebd6fef$var$throwTypeError = function() {
    throw new $aaa4be976b2d27a3$exports();
};
var $5f5b9977eebd6fef$var$ThrowTypeError = $a2d7d74e83f6c3ed$exports ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $5f5b9977eebd6fef$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $a2d7d74e83f6c3ed$exports(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $5f5b9977eebd6fef$var$throwTypeError;
        }
    }
}() : $5f5b9977eebd6fef$var$throwTypeError;

var $5f5b9977eebd6fef$var$hasSymbols = (parcelRequire("24qIq"))();





var $5f5b9977eebd6fef$var$needsEval = {};
var $5f5b9977eebd6fef$var$TypedArray = typeof Uint8Array === 'undefined' || !$2a9ec54411859bd9$exports ? undefined : $2a9ec54411859bd9$exports(Uint8Array);
var $5f5b9977eebd6fef$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $5f5b9977eebd6fef$var$hasSymbols && $2a9ec54411859bd9$exports ? $2a9ec54411859bd9$exports([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $5f5b9977eebd6fef$var$needsEval,
    '%AsyncGenerator%': $5f5b9977eebd6fef$var$needsEval,
    '%AsyncGeneratorFunction%': $5f5b9977eebd6fef$var$needsEval,
    '%AsyncIteratorPrototype%': $5f5b9977eebd6fef$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $41038844aec6eaa2$exports,
    '%eval%': eval,
    '%EvalError%': $cd6d4b204c89f4f4$exports,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $5f5b9977eebd6fef$var$$Function,
    '%GeneratorFunction%': $5f5b9977eebd6fef$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $5f5b9977eebd6fef$var$hasSymbols && $2a9ec54411859bd9$exports ? $2a9ec54411859bd9$exports($2a9ec54411859bd9$exports([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$5f5b9977eebd6fef$var$hasSymbols || !$2a9ec54411859bd9$exports ? undefined : $2a9ec54411859bd9$exports(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $68f77cfee0d91ea0$exports,
    '%Object.getOwnPropertyDescriptor%': $a2d7d74e83f6c3ed$exports,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $72e6a4e026a755bb$exports,
    '%ReferenceError%': $1e478fcc3e34e216$exports,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$5f5b9977eebd6fef$var$hasSymbols || !$2a9ec54411859bd9$exports ? undefined : $2a9ec54411859bd9$exports(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $5f5b9977eebd6fef$var$hasSymbols && $2a9ec54411859bd9$exports ? $2a9ec54411859bd9$exports(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $5f5b9977eebd6fef$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $43bb4ccdc6568bcf$exports,
    '%ThrowTypeError%': $5f5b9977eebd6fef$var$ThrowTypeError,
    '%TypedArray%': $5f5b9977eebd6fef$var$TypedArray,
    '%TypeError%': $aaa4be976b2d27a3$exports,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $cde0c3ef12944098$exports,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $6da1bf1c46eb4156$exports,
    '%Function.prototype.apply%': $0658b6e5d2101996$exports,
    '%Object.defineProperty%': $bbe48bbd9149c147$exports,
    '%Object.getPrototypeOf%': $a683e9a1df37ed0e$exports,
    '%Math.abs%': $829c6ad74b893335$exports,
    '%Math.floor%': $a0167fb8027efc6c$exports,
    '%Math.max%': $59437e5dc9fc2c61$exports,
    '%Math.min%': $328f401f1e19f003$exports,
    '%Math.pow%': $8560e7c6d4e34f2f$exports,
    '%Math.round%': $10e5f4d8a4a1ed83$exports,
    '%Math.sign%': $37113bd5f1fb3cc6$exports,
    '%Reflect.getPrototypeOf%': $0a6f5f26ef0609b6$exports
};
if ($2a9ec54411859bd9$exports) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $5f5b9977eebd6fef$var$errorProto = $2a9ec54411859bd9$exports($2a9ec54411859bd9$exports(e));
    $5f5b9977eebd6fef$var$INTRINSICS['%Error.prototype%'] = $5f5b9977eebd6fef$var$errorProto;
}
var $5f5b9977eebd6fef$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $5f5b9977eebd6fef$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $5f5b9977eebd6fef$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $5f5b9977eebd6fef$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $2a9ec54411859bd9$exports) value = $2a9ec54411859bd9$exports(gen.prototype);
    }
    $5f5b9977eebd6fef$var$INTRINSICS[name] = value;
    return value;
};
var $5f5b9977eebd6fef$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};


var $5f5b9977eebd6fef$var$$concat = $c0378745895dc03c$exports.call($6da1bf1c46eb4156$exports, Array.prototype.concat);
var $5f5b9977eebd6fef$var$$spliceApply = $c0378745895dc03c$exports.call($0658b6e5d2101996$exports, Array.prototype.splice);
var $5f5b9977eebd6fef$var$$replace = $c0378745895dc03c$exports.call($6da1bf1c46eb4156$exports, String.prototype.replace);
var $5f5b9977eebd6fef$var$$strSlice = $c0378745895dc03c$exports.call($6da1bf1c46eb4156$exports, String.prototype.slice);
var $5f5b9977eebd6fef$var$$exec = $c0378745895dc03c$exports.call($6da1bf1c46eb4156$exports, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $5f5b9977eebd6fef$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $5f5b9977eebd6fef$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $5f5b9977eebd6fef$var$stringToPath = function stringToPath(string) {
    var first = $5f5b9977eebd6fef$var$$strSlice(string, 0, 1);
    var last = $5f5b9977eebd6fef$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $43bb4ccdc6568bcf$exports('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $43bb4ccdc6568bcf$exports('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $5f5b9977eebd6fef$var$$replace(string, $5f5b9977eebd6fef$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $5f5b9977eebd6fef$var$$replace(subString, $5f5b9977eebd6fef$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $5f5b9977eebd6fef$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($30dbf79dbae6c725$exports($5f5b9977eebd6fef$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $5f5b9977eebd6fef$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($30dbf79dbae6c725$exports($5f5b9977eebd6fef$var$INTRINSICS, intrinsicName)) {
        var value = $5f5b9977eebd6fef$var$INTRINSICS[intrinsicName];
        if (value === $5f5b9977eebd6fef$var$needsEval) value = $5f5b9977eebd6fef$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $aaa4be976b2d27a3$exports('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $43bb4ccdc6568bcf$exports('intrinsic ' + name + ' does not exist!');
};
$5f5b9977eebd6fef$exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $aaa4be976b2d27a3$exports('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $aaa4be976b2d27a3$exports('"allowMissing" argument must be a boolean');
    if ($5f5b9977eebd6fef$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $43bb4ccdc6568bcf$exports('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $5f5b9977eebd6fef$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $5f5b9977eebd6fef$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $5f5b9977eebd6fef$var$$spliceApply(parts, $5f5b9977eebd6fef$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $5f5b9977eebd6fef$var$$strSlice(part, 0, 1);
        var last = $5f5b9977eebd6fef$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $43bb4ccdc6568bcf$exports('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($30dbf79dbae6c725$exports($5f5b9977eebd6fef$var$INTRINSICS, intrinsicRealName)) value = $5f5b9977eebd6fef$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $aaa4be976b2d27a3$exports('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($a2d7d74e83f6c3ed$exports && i + 1 >= parts.length) {
                var desc = $a2d7d74e83f6c3ed$exports(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $30dbf79dbae6c725$exports(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $5f5b9977eebd6fef$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};



/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $adf8ebd7229df60a$var$$indexOf = $e3cb45ba87de93fe$exports([
    $5f5b9977eebd6fef$exports('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ $adf8ebd7229df60a$exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $5f5b9977eebd6fef$exports(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $adf8ebd7229df60a$var$$indexOf(name, '.prototype.') > -1) return $e3cb45ba87de93fe$exports(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};




var $8043468335131548$var$$Map = $3e3932b3a4c4daea$exports('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $8043468335131548$var$$mapGet = $adf8ebd7229df60a$exports('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $8043468335131548$var$$mapSet = $adf8ebd7229df60a$exports('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $8043468335131548$var$$mapHas = $adf8ebd7229df60a$exports('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $8043468335131548$var$$mapDelete = $adf8ebd7229df60a$exports('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $8043468335131548$var$$mapSize = $adf8ebd7229df60a$exports('Map.prototype.size', true);
/** @type {import('.')} */ $8043468335131548$exports = !!$8043468335131548$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $aaa4be976b2d27a3$exports('Side channel does not contain ' + $a48090c7c3dfd2b6$exports(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $8043468335131548$var$$mapDelete($m, key);
                if ($8043468335131548$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $8043468335131548$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $8043468335131548$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $8043468335131548$var$$Map();
            $8043468335131548$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};


var $591d8612c5fec170$exports = {};
'use strict';
var $982d24b61fe3d553$exports = {};
'use strict';
var $982d24b61fe3d553$var$undefined1;















var $982d24b61fe3d553$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $982d24b61fe3d553$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $982d24b61fe3d553$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $abeda5b4f729df3f$exports = {};
'use strict';
/** @type {import('.')} */ var $abeda5b4f729df3f$var$$defineProperty = Object.defineProperty || false;
if ($abeda5b4f729df3f$var$$defineProperty) try {
    $abeda5b4f729df3f$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $abeda5b4f729df3f$var$$defineProperty = false;
}
$abeda5b4f729df3f$exports = $abeda5b4f729df3f$var$$defineProperty;


var $982d24b61fe3d553$var$throwTypeError = function() {
    throw new $aaa4be976b2d27a3$exports();
};
var $982d24b61fe3d553$var$ThrowTypeError = $a2d7d74e83f6c3ed$exports ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $982d24b61fe3d553$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $a2d7d74e83f6c3ed$exports(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $982d24b61fe3d553$var$throwTypeError;
        }
    }
}() : $982d24b61fe3d553$var$throwTypeError;

var $982d24b61fe3d553$var$hasSymbols = (parcelRequire("24qIq"))();





var $982d24b61fe3d553$var$needsEval = {};
var $982d24b61fe3d553$var$TypedArray = typeof Uint8Array === 'undefined' || !$2a9ec54411859bd9$exports ? undefined : $2a9ec54411859bd9$exports(Uint8Array);
var $982d24b61fe3d553$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $982d24b61fe3d553$var$hasSymbols && $2a9ec54411859bd9$exports ? $2a9ec54411859bd9$exports([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $982d24b61fe3d553$var$needsEval,
    '%AsyncGenerator%': $982d24b61fe3d553$var$needsEval,
    '%AsyncGeneratorFunction%': $982d24b61fe3d553$var$needsEval,
    '%AsyncIteratorPrototype%': $982d24b61fe3d553$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $41038844aec6eaa2$exports,
    '%eval%': eval,
    '%EvalError%': $cd6d4b204c89f4f4$exports,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $982d24b61fe3d553$var$$Function,
    '%GeneratorFunction%': $982d24b61fe3d553$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $982d24b61fe3d553$var$hasSymbols && $2a9ec54411859bd9$exports ? $2a9ec54411859bd9$exports($2a9ec54411859bd9$exports([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$982d24b61fe3d553$var$hasSymbols || !$2a9ec54411859bd9$exports ? undefined : $2a9ec54411859bd9$exports(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $68f77cfee0d91ea0$exports,
    '%Object.getOwnPropertyDescriptor%': $a2d7d74e83f6c3ed$exports,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $72e6a4e026a755bb$exports,
    '%ReferenceError%': $1e478fcc3e34e216$exports,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$982d24b61fe3d553$var$hasSymbols || !$2a9ec54411859bd9$exports ? undefined : $2a9ec54411859bd9$exports(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $982d24b61fe3d553$var$hasSymbols && $2a9ec54411859bd9$exports ? $2a9ec54411859bd9$exports(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $982d24b61fe3d553$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $43bb4ccdc6568bcf$exports,
    '%ThrowTypeError%': $982d24b61fe3d553$var$ThrowTypeError,
    '%TypedArray%': $982d24b61fe3d553$var$TypedArray,
    '%TypeError%': $aaa4be976b2d27a3$exports,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $cde0c3ef12944098$exports,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $6da1bf1c46eb4156$exports,
    '%Function.prototype.apply%': $0658b6e5d2101996$exports,
    '%Object.defineProperty%': $abeda5b4f729df3f$exports,
    '%Object.getPrototypeOf%': $a683e9a1df37ed0e$exports,
    '%Math.abs%': $829c6ad74b893335$exports,
    '%Math.floor%': $a0167fb8027efc6c$exports,
    '%Math.max%': $59437e5dc9fc2c61$exports,
    '%Math.min%': $328f401f1e19f003$exports,
    '%Math.pow%': $8560e7c6d4e34f2f$exports,
    '%Math.round%': $10e5f4d8a4a1ed83$exports,
    '%Math.sign%': $37113bd5f1fb3cc6$exports,
    '%Reflect.getPrototypeOf%': $0a6f5f26ef0609b6$exports
};
if ($2a9ec54411859bd9$exports) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $982d24b61fe3d553$var$errorProto = $2a9ec54411859bd9$exports($2a9ec54411859bd9$exports(e));
    $982d24b61fe3d553$var$INTRINSICS['%Error.prototype%'] = $982d24b61fe3d553$var$errorProto;
}
var $982d24b61fe3d553$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $982d24b61fe3d553$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $982d24b61fe3d553$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $982d24b61fe3d553$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $2a9ec54411859bd9$exports) value = $2a9ec54411859bd9$exports(gen.prototype);
    }
    $982d24b61fe3d553$var$INTRINSICS[name] = value;
    return value;
};
var $982d24b61fe3d553$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};


var $982d24b61fe3d553$var$$concat = $c0378745895dc03c$exports.call($6da1bf1c46eb4156$exports, Array.prototype.concat);
var $982d24b61fe3d553$var$$spliceApply = $c0378745895dc03c$exports.call($0658b6e5d2101996$exports, Array.prototype.splice);
var $982d24b61fe3d553$var$$replace = $c0378745895dc03c$exports.call($6da1bf1c46eb4156$exports, String.prototype.replace);
var $982d24b61fe3d553$var$$strSlice = $c0378745895dc03c$exports.call($6da1bf1c46eb4156$exports, String.prototype.slice);
var $982d24b61fe3d553$var$$exec = $c0378745895dc03c$exports.call($6da1bf1c46eb4156$exports, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $982d24b61fe3d553$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $982d24b61fe3d553$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $982d24b61fe3d553$var$stringToPath = function stringToPath(string) {
    var first = $982d24b61fe3d553$var$$strSlice(string, 0, 1);
    var last = $982d24b61fe3d553$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $43bb4ccdc6568bcf$exports('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $43bb4ccdc6568bcf$exports('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $982d24b61fe3d553$var$$replace(string, $982d24b61fe3d553$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $982d24b61fe3d553$var$$replace(subString, $982d24b61fe3d553$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $982d24b61fe3d553$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($30dbf79dbae6c725$exports($982d24b61fe3d553$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $982d24b61fe3d553$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($30dbf79dbae6c725$exports($982d24b61fe3d553$var$INTRINSICS, intrinsicName)) {
        var value = $982d24b61fe3d553$var$INTRINSICS[intrinsicName];
        if (value === $982d24b61fe3d553$var$needsEval) value = $982d24b61fe3d553$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $aaa4be976b2d27a3$exports('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $43bb4ccdc6568bcf$exports('intrinsic ' + name + ' does not exist!');
};
$982d24b61fe3d553$exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $aaa4be976b2d27a3$exports('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $aaa4be976b2d27a3$exports('"allowMissing" argument must be a boolean');
    if ($982d24b61fe3d553$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $43bb4ccdc6568bcf$exports('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $982d24b61fe3d553$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $982d24b61fe3d553$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $982d24b61fe3d553$var$$spliceApply(parts, $982d24b61fe3d553$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $982d24b61fe3d553$var$$strSlice(part, 0, 1);
        var last = $982d24b61fe3d553$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $43bb4ccdc6568bcf$exports('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($30dbf79dbae6c725$exports($982d24b61fe3d553$var$INTRINSICS, intrinsicRealName)) value = $982d24b61fe3d553$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $aaa4be976b2d27a3$exports('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($a2d7d74e83f6c3ed$exports && i + 1 >= parts.length) {
                var desc = $a2d7d74e83f6c3ed$exports(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $30dbf79dbae6c725$exports(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $982d24b61fe3d553$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};






var $591d8612c5fec170$var$$WeakMap = $982d24b61fe3d553$exports('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $591d8612c5fec170$var$$weakMapGet = $adf8ebd7229df60a$exports('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $591d8612c5fec170$var$$weakMapSet = $adf8ebd7229df60a$exports('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $591d8612c5fec170$var$$weakMapHas = $adf8ebd7229df60a$exports('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $591d8612c5fec170$var$$weakMapDelete = $adf8ebd7229df60a$exports('WeakMap.prototype.delete', true);
/** @type {import('.')} */ $591d8612c5fec170$exports = $591d8612c5fec170$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $aaa4be976b2d27a3$exports('Side channel does not contain ' + $a48090c7c3dfd2b6$exports(key));
        },
        'delete': function(key) {
            if ($591d8612c5fec170$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $591d8612c5fec170$var$$weakMapDelete($wm, key);
            } else if ($8043468335131548$exports) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($591d8612c5fec170$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $591d8612c5fec170$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($591d8612c5fec170$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $591d8612c5fec170$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($591d8612c5fec170$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $591d8612c5fec170$var$$WeakMap();
                $591d8612c5fec170$var$$weakMapSet($wm, key, value);
            } else if ($8043468335131548$exports) {
                if (!$m) $m = $8043468335131548$exports();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $8043468335131548$exports;


var $08e53d4ef2e1f8ef$var$makeChannel = $591d8612c5fec170$exports || $8043468335131548$exports || $52bc36570c76608b$exports;
/** @type {import('.')} */ $08e53d4ef2e1f8ef$exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $aaa4be976b2d27a3$exports('Side channel does not contain ' + $a48090c7c3dfd2b6$exports(key));
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $08e53d4ef2e1f8ef$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};


var $d8a7e190fdc9c6e7$exports = {};
'use strict';
var $d1f90adf4e1eece6$exports = {};
'use strict';
var $d1f90adf4e1eece6$var$replace = String.prototype.replace;
var $d1f90adf4e1eece6$var$percentTwenties = /%20/g;
var $d1f90adf4e1eece6$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
$d1f90adf4e1eece6$exports = {
    'default': $d1f90adf4e1eece6$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $d1f90adf4e1eece6$var$replace.call(value, $d1f90adf4e1eece6$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $d1f90adf4e1eece6$var$Format.RFC1738,
    RFC3986: $d1f90adf4e1eece6$var$Format.RFC3986
};



var $d8a7e190fdc9c6e7$var$has = Object.prototype.hasOwnProperty;
var $d8a7e190fdc9c6e7$var$isArray = Array.isArray;
// Track objects created from arrayLimit overflow using side-channel
// Stores the current max numeric index for O(1) lookup
var $d8a7e190fdc9c6e7$var$overflowChannel = $08e53d4ef2e1f8ef$exports();
var $d8a7e190fdc9c6e7$var$markOverflow = function markOverflow(obj, maxIndex) {
    $d8a7e190fdc9c6e7$var$overflowChannel.set(obj, maxIndex);
    return obj;
};
var $d8a7e190fdc9c6e7$var$isOverflow = function isOverflow(obj) {
    return $d8a7e190fdc9c6e7$var$overflowChannel.has(obj);
};
var $d8a7e190fdc9c6e7$var$getMaxIndex = function getMaxIndex(obj) {
    return $d8a7e190fdc9c6e7$var$overflowChannel.get(obj);
};
var $d8a7e190fdc9c6e7$var$setMaxIndex = function setMaxIndex(obj, maxIndex) {
    $d8a7e190fdc9c6e7$var$overflowChannel.set(obj, maxIndex);
};
var $d8a7e190fdc9c6e7$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    return array;
}();
var $d8a7e190fdc9c6e7$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($d8a7e190fdc9c6e7$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $d8a7e190fdc9c6e7$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $d8a7e190fdc9c6e7$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($d8a7e190fdc9c6e7$var$isArray(target)) target.push(source);
        else if (target && typeof target === 'object') {
            if ($d8a7e190fdc9c6e7$var$isOverflow(target)) {
                // Add at next numeric index for overflow objects
                var newIndex = $d8a7e190fdc9c6e7$var$getMaxIndex(target) + 1;
                target[newIndex] = source;
                $d8a7e190fdc9c6e7$var$setMaxIndex(target, newIndex);
            } else if (options && (options.plainObjects || options.allowPrototypes) || !$d8a7e190fdc9c6e7$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') {
        if ($d8a7e190fdc9c6e7$var$isOverflow(source)) {
            // Create new object with target at 0, source values shifted by 1
            var sourceKeys = Object.keys(source);
            var result = options && options.plainObjects ? {
                __proto__: null,
                0: target
            } : {
                0: target
            };
            for(var m = 0; m < sourceKeys.length; m++){
                var oldKey = parseInt(sourceKeys[m], 10);
                result[oldKey + 1] = source[sourceKeys[m]];
            }
            return $d8a7e190fdc9c6e7$var$markOverflow(result, $d8a7e190fdc9c6e7$var$getMaxIndex(source) + 1);
        }
        return [
            target
        ].concat(source);
    }
    var mergeTarget = target;
    if ($d8a7e190fdc9c6e7$var$isArray(target) && !$d8a7e190fdc9c6e7$var$isArray(source)) mergeTarget = $d8a7e190fdc9c6e7$var$arrayToObject(target, options);
    if ($d8a7e190fdc9c6e7$var$isArray(target) && $d8a7e190fdc9c6e7$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($d8a7e190fdc9c6e7$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($d8a7e190fdc9c6e7$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $d8a7e190fdc9c6e7$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $d8a7e190fdc9c6e7$var$decode = function(str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $d8a7e190fdc9c6e7$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $d8a7e190fdc9c6e7$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var j = 0; j < string.length; j += $d8a7e190fdc9c6e7$var$limit){
        var segment = string.length >= $d8a7e190fdc9c6e7$var$limit ? string.slice(j, j + $d8a7e190fdc9c6e7$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $d1f90adf4e1eece6$exports.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[0xC0 | c >> 6] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[0xE0 | c >> 12] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 6 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[0xF0 | c >> 18] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 12 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 6 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var $d8a7e190fdc9c6e7$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $d8a7e190fdc9c6e7$var$compactQueue(queue);
    return value;
};
var $d8a7e190fdc9c6e7$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $d8a7e190fdc9c6e7$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $d8a7e190fdc9c6e7$var$combine = function combine(a, b, arrayLimit, plainObjects) {
    // If 'a' is already an overflow object, add to it
    if ($d8a7e190fdc9c6e7$var$isOverflow(a)) {
        var newIndex = $d8a7e190fdc9c6e7$var$getMaxIndex(a) + 1;
        a[newIndex] = b;
        $d8a7e190fdc9c6e7$var$setMaxIndex(a, newIndex);
        return a;
    }
    var result = [].concat(a, b);
    if (result.length > arrayLimit) return $d8a7e190fdc9c6e7$var$markOverflow($d8a7e190fdc9c6e7$var$arrayToObject(result, {
        plainObjects: plainObjects
    }), result.length - 1);
    return result;
};
var $d8a7e190fdc9c6e7$var$maybeMap = function maybeMap(val, fn) {
    if ($d8a7e190fdc9c6e7$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
$d8a7e190fdc9c6e7$exports = {
    arrayToObject: $d8a7e190fdc9c6e7$var$arrayToObject,
    assign: $d8a7e190fdc9c6e7$var$assign,
    combine: $d8a7e190fdc9c6e7$var$combine,
    compact: $d8a7e190fdc9c6e7$var$compact,
    decode: $d8a7e190fdc9c6e7$var$decode,
    encode: $d8a7e190fdc9c6e7$var$encode,
    isBuffer: $d8a7e190fdc9c6e7$var$isBuffer,
    isOverflow: $d8a7e190fdc9c6e7$var$isOverflow,
    isRegExp: $d8a7e190fdc9c6e7$var$isRegExp,
    maybeMap: $d8a7e190fdc9c6e7$var$maybeMap,
    merge: $d8a7e190fdc9c6e7$var$merge
};



var $e5dd19a945a45bbb$var$has = Object.prototype.hasOwnProperty;
var $e5dd19a945a45bbb$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $e5dd19a945a45bbb$var$isArray = Array.isArray;
var $e5dd19a945a45bbb$var$push = Array.prototype.push;
var $e5dd19a945a45bbb$var$pushToArray = function(arr, valueOrArray) {
    $e5dd19a945a45bbb$var$push.apply(arr, $e5dd19a945a45bbb$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $e5dd19a945a45bbb$var$toISO = Date.prototype.toISOString;
var $e5dd19a945a45bbb$var$defaultFormat = $d1f90adf4e1eece6$exports.default;
var $e5dd19a945a45bbb$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: $d8a7e190fdc9c6e7$exports.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $e5dd19a945a45bbb$var$defaultFormat,
    formatter: $d1f90adf4e1eece6$exports.formatters[$e5dd19a945a45bbb$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $e5dd19a945a45bbb$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $e5dd19a945a45bbb$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $e5dd19a945a45bbb$var$sentinel = {};
var $e5dd19a945a45bbb$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($e5dd19a945a45bbb$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($e5dd19a945a45bbb$var$sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $e5dd19a945a45bbb$var$isArray(obj)) obj = $d8a7e190fdc9c6e7$exports.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $e5dd19a945a45bbb$var$defaults.encoder, charset, 'key', format) : prefix;
        obj = '';
    }
    if ($e5dd19a945a45bbb$var$isNonNullishPrimitive(obj) || $d8a7e190fdc9c6e7$exports.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $e5dd19a945a45bbb$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $e5dd19a945a45bbb$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $e5dd19a945a45bbb$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $d8a7e190fdc9c6e7$exports.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($e5dd19a945a45bbb$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
    var adjustedPrefix = commaRoundTrip && $e5dd19a945a45bbb$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $e5dd19a945a45bbb$var$isArray(obj) && obj.length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $e5dd19a945a45bbb$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $08e53d4ef2e1f8ef$exports();
        valueSideChannel.set($e5dd19a945a45bbb$var$sentinel, sideChannel);
        $e5dd19a945a45bbb$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $e5dd19a945a45bbb$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $e5dd19a945a45bbb$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $e5dd19a945a45bbb$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $e5dd19a945a45bbb$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $d1f90adf4e1eece6$exports.default;
    if (typeof opts.format !== 'undefined') {
        if (!$e5dd19a945a45bbb$var$has.call($d1f90adf4e1eece6$exports.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $d1f90adf4e1eece6$exports.formatters[format];
    var filter = $e5dd19a945a45bbb$var$defaults.filter;
    if (typeof opts.filter === 'function' || $e5dd19a945a45bbb$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $e5dd19a945a45bbb$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $e5dd19a945a45bbb$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $e5dd19a945a45bbb$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $e5dd19a945a45bbb$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $e5dd19a945a45bbb$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $e5dd19a945a45bbb$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $e5dd19a945a45bbb$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $e5dd19a945a45bbb$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $e5dd19a945a45bbb$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $e5dd19a945a45bbb$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $e5dd19a945a45bbb$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $e5dd19a945a45bbb$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $e5dd19a945a45bbb$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $e5dd19a945a45bbb$var$defaults.strictNullHandling
    };
};
$e5dd19a945a45bbb$exports = function(object, opts) {
    var obj = object;
    var options = $e5dd19a945a45bbb$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($e5dd19a945a45bbb$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $e5dd19a945a45bbb$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $08e53d4ef2e1f8ef$exports();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        $e5dd19a945a45bbb$var$pushToArray(keys, $e5dd19a945a45bbb$var$stringify(value, key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
    }
    return joined.length > 0 ? prefix + joined : '';
};


var $8ec5fc0fdc198ba4$exports = {};
'use strict';

var $8ec5fc0fdc198ba4$var$has = Object.prototype.hasOwnProperty;
var $8ec5fc0fdc198ba4$var$isArray = Array.isArray;
var $8ec5fc0fdc198ba4$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $d8a7e190fdc9c6e7$exports.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $8ec5fc0fdc198ba4$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $8ec5fc0fdc198ba4$var$parseArrayValue = function(val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) return val.split(',');
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $8ec5fc0fdc198ba4$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $8ec5fc0fdc198ba4$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $8ec5fc0fdc198ba4$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $8ec5fc0fdc198ba4$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $8ec5fc0fdc198ba4$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $8ec5fc0fdc198ba4$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $8ec5fc0fdc198ba4$var$defaults.decoder, charset, 'key');
            if (key !== null) val = $d8a7e190fdc9c6e7$exports.maybeMap($8ec5fc0fdc198ba4$var$parseArrayValue(part.slice(pos + 1), options, $8ec5fc0fdc198ba4$var$isArray(obj[key]) ? obj[key].length : 0), function(encodedVal) {
                return options.decoder(encodedVal, $8ec5fc0fdc198ba4$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $8ec5fc0fdc198ba4$var$interpretNumericEntities(String(val));
        if (part.indexOf('[]=') > -1) val = $8ec5fc0fdc198ba4$var$isArray(val) ? [
            val
        ] : val;
        if (key !== null) {
            var existing = $8ec5fc0fdc198ba4$var$has.call(obj, key);
            if (existing && options.duplicates === 'combine') obj[key] = $d8a7e190fdc9c6e7$exports.combine(obj[key], val, options.arrayLimit, options.plainObjects);
            else if (!existing || options.duplicates === 'last') obj[key] = val;
        }
    }
    return obj;
};
var $8ec5fc0fdc198ba4$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $8ec5fc0fdc198ba4$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) {
            if ($d8a7e190fdc9c6e7$exports.isOverflow(leaf)) // leaf is already an overflow object, preserve it
            obj = leaf;
            else obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $d8a7e190fdc9c6e7$exports.combine([], leaf, options.arrayLimit, options.plainObjects);
        } else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $8ec5fc0fdc198ba4$var$splitKeyIntoSegments = function splitKeyIntoSegments(givenKey, options) {
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
    if (options.depth <= 0) {
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, key)) {
            if (!options.allowPrototypes) return;
        }
        return [
            key
        ];
    }
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    var keys = [];
    if (parent) {
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    var i = 0;
    while((segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        var segmentContent = segment[1].slice(1, -1);
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, segmentContent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    if (segment) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        keys.push('[' + key.slice(segment.index) + ']');
    }
    return keys;
};
var $8ec5fc0fdc198ba4$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    var keys = $8ec5fc0fdc198ba4$var$splitKeyIntoSegments(givenKey, options);
    if (!keys) return;
    return $8ec5fc0fdc198ba4$var$parseObject(keys, val, options, valuesParsed);
};
var $8ec5fc0fdc198ba4$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $8ec5fc0fdc198ba4$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $8ec5fc0fdc198ba4$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $8ec5fc0fdc198ba4$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $8ec5fc0fdc198ba4$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $8ec5fc0fdc198ba4$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $8ec5fc0fdc198ba4$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $8ec5fc0fdc198ba4$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $8ec5fc0fdc198ba4$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $8ec5fc0fdc198ba4$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $8ec5fc0fdc198ba4$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $8ec5fc0fdc198ba4$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $8ec5fc0fdc198ba4$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $d8a7e190fdc9c6e7$exports.isRegExp(opts.delimiter) ? opts.delimiter : $8ec5fc0fdc198ba4$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $8ec5fc0fdc198ba4$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $8ec5fc0fdc198ba4$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $8ec5fc0fdc198ba4$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $8ec5fc0fdc198ba4$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $8ec5fc0fdc198ba4$var$defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $8ec5fc0fdc198ba4$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
$8ec5fc0fdc198ba4$exports = function(str, opts) {
    var options = $8ec5fc0fdc198ba4$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $8ec5fc0fdc198ba4$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $8ec5fc0fdc198ba4$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $d8a7e190fdc9c6e7$exports.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $d8a7e190fdc9c6e7$exports.compact(obj);
};



$1c66380376aa2c89$exports = {
    formats: $d1f90adf4e1eece6$exports,
    parse: $8ec5fc0fdc198ba4$exports,
    stringify: $e5dd19a945a45bbb$exports
};


var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


const $f9518090947873ad$var$OPTIONS_KEYS = [
    'apiKey',
    'idempotencyKey',
    'stripeAccount',
    'apiVersion',
    'maxNetworkRetries',
    'timeout',
    'host',
    'authenticator',
    'stripeContext',
    'additionalHeaders',
    'streaming'
];
function $f9518090947873ad$export$f71a72f8975a3c(o) {
    return o && typeof o === 'object' && $f9518090947873ad$var$OPTIONS_KEYS.some((prop)=>Object.prototype.hasOwnProperty.call(o, prop));
}
function $f9518090947873ad$export$ee3e7678add00de3(data, apiMode) {
    return $1c66380376aa2c89$exports.stringify(data, {
        serializeDate: (d)=>Math.floor(d.getTime() / 1000).toString(),
        // Always use indexed format for arrays
        arrayFormat: 'indices'
    })// Don't use strict form encoding by changing the square bracket control
    // characters back to their literals. This is fine by the server, and
    // makes these parameter strings easier to read.
    .replace(/%5B/g, '[').replace(/%5D/g, ']');
}
const $f9518090947873ad$export$27bb0b6fde69b6c1 = (()=>{
    const rc = {
        '\n': '\\n',
        '"': '\\"',
        '\u2028': '\\u2028',
        '\u2029': '\\u2029'
    };
    return (str)=>{
        const cleanString = str.replace(/["\n\r\u2028\u2029]/g, ($0)=>rc[$0]);
        return (outputs)=>{
            return cleanString.replace(/\{([\s\S]+?)\}/g, ($0, $1)=>{
                const output = outputs[$1];
                if ($f9518090947873ad$var$isValidEncodeUriComponentType(output)) return encodeURIComponent(output);
                return '';
            });
        };
    };
})();
function $f9518090947873ad$var$isValidEncodeUriComponentType(value) {
    return [
        'number',
        'string',
        'boolean'
    ].includes(typeof value);
}
function $f9518090947873ad$export$3a2c52552915690c(path) {
    const params = path.match(/\{\w+\}/g);
    if (!params) return [];
    return params.map((param)=>param.replace(/[{}]/g, ''));
}
function $f9518090947873ad$export$ffdc9c53a9d431ae(args) {
    if (!Array.isArray(args) || !args[0] || typeof args[0] !== 'object') return {};
    if (!$f9518090947873ad$export$f71a72f8975a3c(args[0])) return args.shift();
    const argKeys = Object.keys(args[0]);
    const optionKeysInArgs = argKeys.filter((key)=>$f9518090947873ad$var$OPTIONS_KEYS.includes(key));
    // In some cases options may be the provided as the first argument.
    // Here we're detecting a case where there are two distinct arguments
    // (the first being args and the second options) and with known
    // option keys in the first so that we can warn the user about it.
    if (optionKeysInArgs.length > 0 && optionKeysInArgs.length !== argKeys.length) $f9518090947873ad$export$76ee40922b2f96c0(`Options found in arguments (${optionKeysInArgs.join(', ')}). Did you mean to pass an options object? See https://github.com/stripe/stripe-node/wiki/Passing-Options.`);
    return {};
}
function $f9518090947873ad$export$af7e4789946d118b(args) {
    const opts = {
        host: null,
        headers: {},
        settings: {},
        streaming: false
    };
    if (args.length > 0) {
        const arg = args[args.length - 1];
        if (typeof arg === 'string') opts.authenticator = $f9518090947873ad$export$5260ee7b699e9b50(args.pop());
        else if ($f9518090947873ad$export$f71a72f8975a3c(arg)) {
            const params = Object.assign({}, args.pop());
            const extraKeys = Object.keys(params).filter((key)=>!$f9518090947873ad$var$OPTIONS_KEYS.includes(key));
            if (extraKeys.length) $f9518090947873ad$export$76ee40922b2f96c0(`Invalid options found (${extraKeys.join(', ')}); ignoring.`);
            if (params.apiKey) opts.authenticator = $f9518090947873ad$export$5260ee7b699e9b50(params.apiKey);
            if (params.idempotencyKey) opts.headers['Idempotency-Key'] = params.idempotencyKey;
            if (params.stripeAccount) opts.headers['Stripe-Account'] = params.stripeAccount;
            if (params.stripeContext) {
                if (opts.headers['Stripe-Account']) throw new Error("Can't specify both stripeAccount and stripeContext.");
                opts.headers['Stripe-Context'] = params.stripeContext;
            }
            if (params.apiVersion) opts.headers['Stripe-Version'] = params.apiVersion;
            if (Number.isInteger(params.maxNetworkRetries)) opts.settings.maxNetworkRetries = params.maxNetworkRetries;
            if (Number.isInteger(params.timeout)) opts.settings.timeout = params.timeout;
            if (params.host) opts.host = params.host;
            if (params.authenticator) {
                if (params.apiKey) throw new Error("Can't specify both apiKey and authenticator.");
                if (typeof params.authenticator !== 'function') throw new Error("The authenticator must be a function receiving a request as the first parameter.");
                opts.authenticator = params.authenticator;
            }
            if (params.additionalHeaders) opts.headers = params.additionalHeaders;
            if (params.streaming) opts.streaming = true;
        }
    }
    return opts;
}
function $f9518090947873ad$export$7466dd6e40823310(sub) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const Super = this;
    const Constructor = Object.prototype.hasOwnProperty.call(sub, 'constructor') ? sub.constructor : function(...args) {
        Super.apply(this, args);
    };
    // This initialization logic is somewhat sensitive to be compatible with
    // divergent JS implementations like the one found in Qt. See here for more
    // context:
    //
    // https://github.com/stripe/stripe-node/pull/334
    Object.assign(Constructor, Super);
    Constructor.prototype = Object.create(Super.prototype);
    Object.assign(Constructor.prototype, sub);
    return Constructor;
}
function $f9518090947873ad$export$6399545f0684c71f(obj) {
    if (typeof obj !== 'object') throw new Error('Argument must be an object');
    return Object.keys(obj).reduce((result, key)=>{
        if (obj[key] != null) result[key] = obj[key];
        return result;
    }, {});
}
function $f9518090947873ad$export$a89b99466b0866f2(obj) {
    if (!(obj && typeof obj === 'object')) return obj;
    return Object.keys(obj).reduce((result, header)=>{
        result[$f9518090947873ad$export$dbba84898e512c96(header)] = obj[header];
        return result;
    }, {});
}
function $f9518090947873ad$export$dbba84898e512c96(header) {
    return header.split('-').map((text)=>text.charAt(0).toUpperCase() + text.substr(1).toLowerCase()).join('-');
}
function $f9518090947873ad$export$a193763689ef14b2(promise, callback) {
    if (callback) // Ensure callback is called outside of promise stack.
    return promise.then((res)=>{
        setTimeout(()=>{
            callback(null, res);
        }, 0);
    }, (err)=>{
        setTimeout(()=>{
            callback(err, null);
        }, 0);
    });
    return promise;
}
function $f9518090947873ad$export$696df76c11680caa(name) {
    if (name === 'OAuth') return 'oauth';
    else return name[0].toLowerCase() + name.substring(1);
}
function $f9518090947873ad$export$76ee40922b2f96c0(warning) {
    if (typeof $cfae44f0dfdf62c0$exports.emitWarning !== 'function') return console.warn(`Stripe: ${warning}`); /* eslint-disable-line no-console */ 
    return $cfae44f0dfdf62c0$exports.emitWarning(warning, 'Stripe');
}
function $f9518090947873ad$export$a6cdc56e425d0d0a(obj) {
    const type = typeof obj;
    return (type === 'function' || type === 'object') && !!obj;
}
function $f9518090947873ad$export$d07a6a7cdfc04afd(data) {
    const result = {};
    const step = (obj, prevKey)=>{
        Object.entries(obj).forEach(([key, value])=>{
            const newKey = prevKey ? `${prevKey}[${key}]` : key;
            if ($f9518090947873ad$export$a6cdc56e425d0d0a(value)) {
                if (!(value instanceof Uint8Array) && !Object.prototype.hasOwnProperty.call(value, 'data')) // Non-buffer non-file Objects are recursively flattened
                return step(value, newKey);
                else // Buffers and file objects are stored without modification
                result[newKey] = value;
            } else // Primitives are converted to strings
            result[newKey] = String(value);
        });
    };
    step(data, null);
    return result;
}
function $f9518090947873ad$export$ffa3b1cd345d970(name, n, defaultVal) {
    if (!Number.isInteger(n)) {
        if (defaultVal !== undefined) return defaultVal;
        else throw new Error(`${name} must be an integer`);
    }
    return n;
}
function $f9518090947873ad$export$c437f6e26746c6ee() {
    return {};
}
function $f9518090947873ad$export$5260ee7b699e9b50(apiKey) {
    const authenticator = (request)=>{
        request.headers.Authorization = 'Bearer ' + apiKey;
        return Promise.resolve();
    };
    // For testing
    authenticator._apiKey = apiKey;
    return authenticator;
}
function $f9518090947873ad$export$ee1b3e54f0441b22(arrays) {
    const totalLength = arrays.reduce((len, array)=>len + array.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    arrays.forEach((array)=>{
        merged.set(array, offset);
        offset += array.length;
    });
    return merged;
}
/**
 * Replaces Date objects with Unix timestamps
 */ function $f9518090947873ad$var$dateTimeReplacer(key, value) {
    if (this[key] instanceof Date) return Math.floor(this[key].getTime() / 1000).toString();
    return value;
}
function $f9518090947873ad$export$cf495d1cb7e3c8af(data) {
    return JSON.stringify(data, $f9518090947873ad$var$dateTimeReplacer);
}
function $f9518090947873ad$export$6cecdede54eaa80d(path) {
    if (!path) return 'v1';
    return path.startsWith('/v2') ? 'v2' : 'v1';
}
function $f9518090947873ad$export$8e70eb61c7c97f0a(header) {
    if (Array.isArray(header)) return header.join(', ');
    return String(header);
}
function $f9518090947873ad$export$a534077c39afec16(header) {
    const number = Array.isArray(header) ? header[0] : header;
    return Number(number);
}
function $f9518090947873ad$export$41ce2310f7b76b3d(headers) {
    return Object.entries(headers).map(([key, value])=>{
        return [
            key,
            $f9518090947873ad$export$8e70eb61c7c97f0a(value)
        ];
    });
}


/**
 * Encapsulates the logic for issuing a request to the Stripe API.
 *
 * A custom HTTP client should should implement:
 * 1. A response class which extends HttpClientResponse and wraps around their
 *    own internal representation of a response.
 * 2. A client class which extends HttpClient and implements all methods,
 *    returning their own response class when making requests.
 */ class $22250c6fcb187bc7$export$8c6ee871e681f0f4 {
    /** The client name used for diagnostics. */ getClientName() {
        throw new Error('getClientName not implemented.');
    }
    makeRequest(host, port, path, method, headers, requestData, protocol, timeout) {
        throw new Error('makeRequest not implemented.');
    }
    /** Helper to make a consistent timeout error across implementations. */ static makeTimeoutError() {
        const timeoutErr = new TypeError($22250c6fcb187bc7$export$8c6ee871e681f0f4.TIMEOUT_ERROR_CODE);
        timeoutErr.code = $22250c6fcb187bc7$export$8c6ee871e681f0f4.TIMEOUT_ERROR_CODE;
        return timeoutErr;
    }
}
// Public API accessible via Stripe.HttpClient
$22250c6fcb187bc7$export$8c6ee871e681f0f4.CONNECTION_CLOSED_ERROR_CODES = [
    'ECONNRESET',
    'EPIPE'
];
$22250c6fcb187bc7$export$8c6ee871e681f0f4.TIMEOUT_ERROR_CODE = 'ETIMEDOUT';
class $22250c6fcb187bc7$export$7a420d61f4599d58 {
    constructor(statusCode, headers){
        this._statusCode = statusCode;
        this._headers = headers;
    }
    getStatusCode() {
        return this._statusCode;
    }
    getHeaders() {
        return this._headers;
    }
    getRawResponse() {
        throw new Error('getRawResponse not implemented.');
    }
    toStream(streamCompleteCallback) {
        throw new Error('toStream not implemented.');
    }
    toJSON() {
        throw new Error('toJSON not implemented.');
    }
}


class $2a0b1bcf14a2f867$export$1b51ed6f7c8f947b extends (0, $22250c6fcb187bc7$export$8c6ee871e681f0f4) {
    constructor(fetchFn){
        super();
        // Default to global fetch if available
        if (!fetchFn) {
            if (!globalThis.fetch) throw new Error("fetch() function not provided and is not defined in the global scope. You must provide a fetch implementation.");
            fetchFn = globalThis.fetch;
        }
        // Both timeout behaviors differs from Node:
        // - Fetch uses a single timeout for the entire length of the request.
        // - Node is more fine-grained and resets the timeout after each stage of the request.
        if (globalThis.AbortController) // Utilise native AbortController if available
        // AbortController was added in Node v15.0.0, v14.17.0
        this._fetchFn = $2a0b1bcf14a2f867$export$1b51ed6f7c8f947b.makeFetchWithAbortTimeout(fetchFn);
        else // Fall back to racing against a timeout promise if not available in the runtime
        // This does not actually cancel the underlying fetch operation or resources
        this._fetchFn = $2a0b1bcf14a2f867$export$1b51ed6f7c8f947b.makeFetchWithRaceTimeout(fetchFn);
    }
    static makeFetchWithRaceTimeout(fetchFn) {
        return (url, init, timeout)=>{
            let pendingTimeoutId;
            const timeoutPromise = new Promise((_, reject)=>{
                pendingTimeoutId = setTimeout(()=>{
                    pendingTimeoutId = null;
                    reject((0, $22250c6fcb187bc7$export$8c6ee871e681f0f4).makeTimeoutError());
                }, timeout);
            });
            const fetchPromise = fetchFn(url, init);
            return Promise.race([
                fetchPromise,
                timeoutPromise
            ]).finally(()=>{
                if (pendingTimeoutId) clearTimeout(pendingTimeoutId);
            });
        };
    }
    static makeFetchWithAbortTimeout(fetchFn) {
        return async (url, init, timeout)=>{
            // Use AbortController because AbortSignal.timeout() was added later in Node v17.3.0, v16.14.0
            const abort = new AbortController();
            let timeoutId = setTimeout(()=>{
                timeoutId = null;
                abort.abort((0, $22250c6fcb187bc7$export$8c6ee871e681f0f4).makeTimeoutError());
            }, timeout);
            try {
                return await fetchFn(url, Object.assign(Object.assign({}, init), {
                    signal: abort.signal
                }));
            } catch (err) {
                // Some implementations, like node-fetch, do not respect the reason passed to AbortController.abort()
                // and instead it always throws an AbortError
                // We catch this case to normalise all timeout errors
                if (err.name === 'AbortError') throw (0, $22250c6fcb187bc7$export$8c6ee871e681f0f4).makeTimeoutError();
                else throw err;
            } finally{
                if (timeoutId) clearTimeout(timeoutId);
            }
        };
    }
    /** @override. */ getClientName() {
        return 'fetch';
    }
    async makeRequest(host, port, path, method, headers, requestData, protocol, timeout) {
        const isInsecureConnection = protocol === 'http';
        const url = new URL(path, `${isInsecureConnection ? 'http' : 'https'}://${host}`);
        url.port = port;
        // For methods which expect payloads, we should always pass a body value
        // even when it is empty. Without this, some JS runtimes (eg. Deno) will
        // inject a second Content-Length header. See https://github.com/stripe/stripe-node/issues/1519
        // for more details.
        const methodHasPayload = method == 'POST' || method == 'PUT' || method == 'PATCH';
        const body = requestData || (methodHasPayload ? '' : undefined);
        const res = await this._fetchFn(url.toString(), {
            method: method,
            headers: (0, $f9518090947873ad$export$41ce2310f7b76b3d)(headers),
            body: body
        }, timeout);
        return new $2a0b1bcf14a2f867$export$444b9980faaac899(res);
    }
}
class $2a0b1bcf14a2f867$export$444b9980faaac899 extends (0, $22250c6fcb187bc7$export$7a420d61f4599d58) {
    constructor(res){
        super(res.status, $2a0b1bcf14a2f867$export$444b9980faaac899._transformHeadersToObject(res.headers));
        this._res = res;
    }
    getRawResponse() {
        return this._res;
    }
    toStream(streamCompleteCallback) {
        // Unfortunately `fetch` does not have event handlers for when the stream is
        // completely read. We therefore invoke the streamCompleteCallback right
        // away. This callback emits a response event with metadata and completes
        // metrics, so it's ok to do this without waiting for the stream to be
        // completely read.
        streamCompleteCallback();
        // Fetch's `body` property is expected to be a readable stream of the body.
        return this._res.body;
    }
    toJSON() {
        return this._res.json();
    }
    static _transformHeadersToObject(headers) {
        // Fetch uses a Headers instance so this must be converted to a barebones
        // JS object to meet the HttpClient interface.
        const headersObj = {};
        for (const entry of headers){
            if (!Array.isArray(entry) || entry.length != 2) throw new Error('Response objects produced by the fetch function given to FetchHttpClient do not have an iterable headers map. Response#headers should be an iterable object.');
            headersObj[entry[0]] = entry[1];
        }
        return headersObj;
    }
}


/**
 * Interface encapsulating the various crypto computations used by the library,
 * allowing pluggable underlying crypto implementations.
 */ class $0c14d973ee69192a$export$745d7c3e16d29f1c {
    /**
     * Computes a SHA-256 HMAC given a secret and a payload (encoded in UTF-8).
     * The output HMAC should be encoded in hexadecimal.
     *
     * Sample values for implementations:
     * - computeHMACSignature('', 'test_secret') => 'f7f9bd47fb987337b5796fdc1fdb9ba221d0d5396814bfcaf9521f43fd8927fd'
     * - computeHMACSignature('\ud83d\ude00', 'test_secret') => '837da296d05c4fe31f61d5d7ead035099d9585a5bcde87de952012a78f0b0c43
     */ computeHMACSignature(payload, secret) {
        throw new Error('computeHMACSignature not implemented.');
    }
    /**
     * Asynchronous version of `computeHMACSignature`. Some implementations may
     * only allow support async signature computation.
     *
     * Computes a SHA-256 HMAC given a secret and a payload (encoded in UTF-8).
     * The output HMAC should be encoded in hexadecimal.
     *
     * Sample values for implementations:
     * - computeHMACSignature('', 'test_secret') => 'f7f9bd47fb987337b5796fdc1fdb9ba221d0d5396814bfcaf9521f43fd8927fd'
     * - computeHMACSignature('\ud83d\ude00', 'test_secret') => '837da296d05c4fe31f61d5d7ead035099d9585a5bcde87de952012a78f0b0c43
     */ computeHMACSignatureAsync(payload, secret) {
        throw new Error('computeHMACSignatureAsync not implemented.');
    }
    /**
     * Computes a SHA-256 hash of the data.
     */ computeSHA256Async(data) {
        throw new Error('computeSHA256 not implemented.');
    }
}
class $0c14d973ee69192a$export$6df866e461d96a12 extends Error {
}


class $68b6c5d67997473c$export$68584d78f0ee757b extends (0, $0c14d973ee69192a$export$745d7c3e16d29f1c) {
    constructor(subtleCrypto){
        super();
        // If no subtle crypto is interface, default to the global namespace. This
        // is to allow custom interfaces (eg. using the Node webcrypto interface in
        // tests).
        this.subtleCrypto = subtleCrypto || crypto.subtle;
    }
    /** @override */ computeHMACSignature(payload, secret) {
        throw new (0, $0c14d973ee69192a$export$6df866e461d96a12)('SubtleCryptoProvider cannot be used in a synchronous context.');
    }
    /** @override */ async computeHMACSignatureAsync(payload, secret) {
        const encoder = new TextEncoder();
        const key = await this.subtleCrypto.importKey('raw', encoder.encode(secret), {
            name: 'HMAC',
            hash: {
                name: 'SHA-256'
            }
        }, false, [
            'sign'
        ]);
        const signatureBuffer = await this.subtleCrypto.sign('hmac', key, encoder.encode(payload));
        // crypto.subtle returns the signature in base64 format. This must be
        // encoded in hex to match the CryptoProvider contract. We map each byte in
        // the buffer to its corresponding hex octet and then combine into a string.
        const signatureBytes = new Uint8Array(signatureBuffer);
        const signatureHexCodes = new Array(signatureBytes.length);
        for(let i = 0; i < signatureBytes.length; i++)signatureHexCodes[i] = $68b6c5d67997473c$var$byteHexMapping[signatureBytes[i]];
        return signatureHexCodes.join('');
    }
    /** @override */ async computeSHA256Async(data) {
        return new Uint8Array(await this.subtleCrypto.digest('SHA-256', data));
    }
}
// Cached mapping of byte to hex representation. We do this once to avoid re-
// computing every time we need to convert the result of a signature to hex.
const $68b6c5d67997473c$var$byteHexMapping = new Array(256);
for(let i = 0; i < $68b6c5d67997473c$var$byteHexMapping.length; i++)$68b6c5d67997473c$var$byteHexMapping[i] = i.toString(16).padStart(2, '0');


class $1047f552003e980d$export$c62a75c9244c220f {
    constructor(){
        this._fetchFn = null;
        this._agent = null;
    }
    /**
     * Gets uname with Node's built-in `exec` function, if available.
     */ getUname() {
        throw new Error('getUname not implemented.');
    }
    /**
     * Generates a v4 UUID. See https://stackoverflow.com/a/2117523
     */ uuid4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    }
    /**
     * Compares strings in constant time.
     */ secureCompare(a, b) {
        // return early here if buffer lengths are not equal
        if (a.length !== b.length) return false;
        const len = a.length;
        let result = 0;
        for(let i = 0; i < len; ++i)result |= a.charCodeAt(i) ^ b.charCodeAt(i);
        return result === 0;
    }
    /**
     * Creates an event emitter.
     */ createEmitter() {
        throw new Error('createEmitter not implemented.');
    }
    /**
     * Checks if the request data is a stream. If so, read the entire stream
     * to a buffer and return the buffer.
     */ tryBufferData(data) {
        throw new Error('tryBufferData not implemented.');
    }
    /**
     * Creates an HTTP client which uses the Node `http` and `https` packages
     * to issue requests.
     */ createNodeHttpClient(agent) {
        throw new Error('createNodeHttpClient not implemented.');
    }
    /**
     * Creates an HTTP client for issuing Stripe API requests which uses the Web
     * Fetch API.
     *
     * A fetch function can optionally be passed in as a parameter. If none is
     * passed, will default to the default `fetch` function in the global scope.
     */ createFetchHttpClient(fetchFn) {
        return new (0, $2a0b1bcf14a2f867$export$1b51ed6f7c8f947b)(fetchFn);
    }
    /**
     * Creates an HTTP client using runtime-specific APIs.
     */ createDefaultHttpClient() {
        throw new Error('createDefaultHttpClient not implemented.');
    }
    /**
     * Creates a CryptoProvider which uses the Node `crypto` package for its computations.
     */ createNodeCryptoProvider() {
        throw new Error('createNodeCryptoProvider not implemented.');
    }
    /**
     * Creates a CryptoProvider which uses the SubtleCrypto interface of the Web Crypto API.
     */ createSubtleCryptoProvider(subtleCrypto) {
        return new (0, $68b6c5d67997473c$export$68584d78f0ee757b)(subtleCrypto);
    }
    createDefaultCryptoProvider() {
        throw new Error('createDefaultCryptoProvider not implemented.');
    }
}


/**
 * @private
 * (For internal use in stripe-node.)
 * Wrapper around the Event Web API.
 */ class $9e277c23cafa518b$var$_StripeEvent extends Event {
    constructor(eventName, data){
        super(eventName);
        this.data = data;
    }
}
class $9e277c23cafa518b$export$6c7279670bfaddcf {
    constructor(){
        this.eventTarget = new EventTarget();
        this.listenerMapping = new Map();
    }
    on(eventName, listener) {
        const listenerWrapper = (event)=>{
            listener(event.data);
        };
        this.listenerMapping.set(listener, listenerWrapper);
        return this.eventTarget.addEventListener(eventName, listenerWrapper);
    }
    removeListener(eventName, listener) {
        const listenerWrapper = this.listenerMapping.get(listener);
        this.listenerMapping.delete(listener);
        return this.eventTarget.removeEventListener(eventName, listenerWrapper);
    }
    once(eventName, listener) {
        const listenerWrapper = (event)=>{
            listener(event.data);
        };
        this.listenerMapping.set(listener, listenerWrapper);
        return this.eventTarget.addEventListener(eventName, listenerWrapper, {
            once: true
        });
    }
    emit(eventName, data) {
        return this.eventTarget.dispatchEvent(new $9e277c23cafa518b$var$_StripeEvent(eventName, data));
    }
}


class $7ad6b2871a85e55d$export$f6dd6b087620cf03 extends (0, $1047f552003e980d$export$c62a75c9244c220f) {
    /** @override */ getUname() {
        return Promise.resolve(null);
    }
    /** @override */ createEmitter() {
        return new (0, $9e277c23cafa518b$export$6c7279670bfaddcf)();
    }
    /** @override */ tryBufferData(data) {
        if (data.file.data instanceof ReadableStream) throw new Error('Uploading a file as a stream is not supported in non-Node environments. Please open or upvote an issue at github.com/stripe/stripe-node if you use this, detailing your use-case.');
        return Promise.resolve(data);
    }
    /** @override */ createNodeHttpClient() {
        throw new Error('Stripe: `createNodeHttpClient()` is not available in non-Node environments. Please use `createFetchHttpClient()` instead.');
    }
    /** @override */ createDefaultHttpClient() {
        return super.createFetchHttpClient();
    }
    /** @override */ createNodeCryptoProvider() {
        throw new Error('Stripe: `createNodeCryptoProvider()` is not available in non-Node environments. Please use `createSubtleCryptoProvider()` instead.');
    }
    /** @override */ createDefaultCryptoProvider() {
        return this.createSubtleCryptoProvider();
    }
}


var $7dd63d24cadb0282$exports = {};

$parcel$export($7dd63d24cadb0282$exports, "generateV1Error", () => $7dd63d24cadb0282$export$2d1b622bf1bd2cd8);
$parcel$export($7dd63d24cadb0282$exports, "StripeCardError", () => $7dd63d24cadb0282$export$4c208bff4e14c97d);
$parcel$export($7dd63d24cadb0282$exports, "StripeInvalidRequestError", () => $7dd63d24cadb0282$export$6af0f82d3259ca0f);
$parcel$export($7dd63d24cadb0282$exports, "StripeAPIError", () => $7dd63d24cadb0282$export$76ec20179fd99642);
$parcel$export($7dd63d24cadb0282$exports, "StripeAuthenticationError", () => $7dd63d24cadb0282$export$58689542aa04bf8d);
$parcel$export($7dd63d24cadb0282$exports, "StripeRateLimitError", () => $7dd63d24cadb0282$export$a56520c648817af9);
$parcel$export($7dd63d24cadb0282$exports, "StripeIdempotencyError", () => $7dd63d24cadb0282$export$c8be28287f9c88db);
$parcel$export($7dd63d24cadb0282$exports, "StripeInvalidGrantError", () => $7dd63d24cadb0282$export$d8db36f43ea9967a);
$parcel$export($7dd63d24cadb0282$exports, "StripeUnknownError", () => $7dd63d24cadb0282$export$dad511f7bf3f0991);
$parcel$export($7dd63d24cadb0282$exports, "generateV2Error", () => $7dd63d24cadb0282$export$ea12b5d3f3cff421);
$parcel$export($7dd63d24cadb0282$exports, "TemporarySessionExpiredError", () => $7dd63d24cadb0282$export$4ceec90f6a136b79);
$parcel$export($7dd63d24cadb0282$exports, "StripeError", () => $7dd63d24cadb0282$export$4627d23f26d15ec0);
$parcel$export($7dd63d24cadb0282$exports, "StripePermissionError", () => $7dd63d24cadb0282$export$e9509420fd7e43c0);
$parcel$export($7dd63d24cadb0282$exports, "StripeConnectionError", () => $7dd63d24cadb0282$export$632911809a084c44);
$parcel$export($7dd63d24cadb0282$exports, "StripeSignatureVerificationError", () => $7dd63d24cadb0282$export$9bd7fbbf50391137);
/* eslint-disable camelcase */ /* eslint-disable no-warning-comments */ const $7dd63d24cadb0282$export$2d1b622bf1bd2cd8 = (rawStripeError)=>{
    switch(rawStripeError.type){
        case 'card_error':
            return new $7dd63d24cadb0282$export$4c208bff4e14c97d(rawStripeError);
        case 'invalid_request_error':
            return new $7dd63d24cadb0282$export$6af0f82d3259ca0f(rawStripeError);
        case 'api_error':
            return new $7dd63d24cadb0282$export$76ec20179fd99642(rawStripeError);
        case 'authentication_error':
            return new $7dd63d24cadb0282$export$58689542aa04bf8d(rawStripeError);
        case 'rate_limit_error':
            return new $7dd63d24cadb0282$export$a56520c648817af9(rawStripeError);
        case 'idempotency_error':
            return new $7dd63d24cadb0282$export$c8be28287f9c88db(rawStripeError);
        case 'invalid_grant':
            return new $7dd63d24cadb0282$export$d8db36f43ea9967a(rawStripeError);
        default:
            return new $7dd63d24cadb0282$export$dad511f7bf3f0991(rawStripeError);
    }
};
const $7dd63d24cadb0282$export$ea12b5d3f3cff421 = (rawStripeError)=>{
    switch(rawStripeError.type){
        // switchCases: The beginning of the section generated from our OpenAPI spec
        case 'temporary_session_expired':
            return new $7dd63d24cadb0282$export$4ceec90f6a136b79(rawStripeError);
    }
    // Special handling for requests with missing required fields in V2 APIs.
    // invalid_field response in V2 APIs returns the field 'code' instead of 'type'.
    switch(rawStripeError.code){
        case 'invalid_fields':
            return new $7dd63d24cadb0282$export$6af0f82d3259ca0f(rawStripeError);
    }
    return $7dd63d24cadb0282$export$2d1b622bf1bd2cd8(rawStripeError);
};
class $7dd63d24cadb0282$export$4627d23f26d15ec0 extends Error {
    constructor(raw = {}, type = null){
        var _a;
        super(raw.message);
        this.type = type || this.constructor.name;
        this.raw = raw;
        this.rawType = raw.type;
        this.code = raw.code;
        this.doc_url = raw.doc_url;
        this.param = raw.param;
        this.detail = raw.detail;
        this.headers = raw.headers;
        this.requestId = raw.requestId;
        this.statusCode = raw.statusCode;
        this.message = (_a = raw.message) !== null && _a !== void 0 ? _a : '';
        this.userMessage = raw.user_message;
        this.charge = raw.charge;
        this.decline_code = raw.decline_code;
        this.payment_intent = raw.payment_intent;
        this.payment_method = raw.payment_method;
        this.payment_method_type = raw.payment_method_type;
        this.setup_intent = raw.setup_intent;
        this.source = raw.source;
    }
}
/**
 * Helper factory which takes raw stripe errors and outputs wrapping instances
 */ $7dd63d24cadb0282$export$4627d23f26d15ec0.generate = $7dd63d24cadb0282$export$2d1b622bf1bd2cd8;
class $7dd63d24cadb0282$export$4c208bff4e14c97d extends $7dd63d24cadb0282$export$4627d23f26d15ec0 {
    constructor(raw = {}){
        super(raw, 'StripeCardError');
    }
}
class $7dd63d24cadb0282$export$6af0f82d3259ca0f extends $7dd63d24cadb0282$export$4627d23f26d15ec0 {
    constructor(raw = {}){
        super(raw, 'StripeInvalidRequestError');
    }
}
class $7dd63d24cadb0282$export$76ec20179fd99642 extends $7dd63d24cadb0282$export$4627d23f26d15ec0 {
    constructor(raw = {}){
        super(raw, 'StripeAPIError');
    }
}
class $7dd63d24cadb0282$export$58689542aa04bf8d extends $7dd63d24cadb0282$export$4627d23f26d15ec0 {
    constructor(raw = {}){
        super(raw, 'StripeAuthenticationError');
    }
}
class $7dd63d24cadb0282$export$e9509420fd7e43c0 extends $7dd63d24cadb0282$export$4627d23f26d15ec0 {
    constructor(raw = {}){
        super(raw, 'StripePermissionError');
    }
}
class $7dd63d24cadb0282$export$a56520c648817af9 extends $7dd63d24cadb0282$export$4627d23f26d15ec0 {
    constructor(raw = {}){
        super(raw, 'StripeRateLimitError');
    }
}
class $7dd63d24cadb0282$export$632911809a084c44 extends $7dd63d24cadb0282$export$4627d23f26d15ec0 {
    constructor(raw = {}){
        super(raw, 'StripeConnectionError');
    }
}
class $7dd63d24cadb0282$export$9bd7fbbf50391137 extends $7dd63d24cadb0282$export$4627d23f26d15ec0 {
    constructor(header, payload, raw = {}){
        super(raw, 'StripeSignatureVerificationError');
        this.header = header;
        this.payload = payload;
    }
}
class $7dd63d24cadb0282$export$c8be28287f9c88db extends $7dd63d24cadb0282$export$4627d23f26d15ec0 {
    constructor(raw = {}){
        super(raw, 'StripeIdempotencyError');
    }
}
class $7dd63d24cadb0282$export$d8db36f43ea9967a extends $7dd63d24cadb0282$export$4627d23f26d15ec0 {
    constructor(raw = {}){
        super(raw, 'StripeInvalidGrantError');
    }
}
class $7dd63d24cadb0282$export$dad511f7bf3f0991 extends $7dd63d24cadb0282$export$4627d23f26d15ec0 {
    constructor(raw = {}){
        super(raw, 'StripeUnknownError');
    }
}
class $7dd63d24cadb0282$export$4ceec90f6a136b79 extends $7dd63d24cadb0282$export$4627d23f26d15ec0 {
    constructor(rawStripeError = {}){
        super(rawStripeError, 'TemporarySessionExpiredError');
    }
} // classDefinitions: The end of the section generated from our OpenAPI spec





const $05b8a1b47abc2dac$var$MAX_RETRY_AFTER_WAIT = 60;
class $05b8a1b47abc2dac$export$196c27f83356e260 {
    constructor(stripe, maxBufferedRequestMetric){
        this._stripe = stripe;
        this._maxBufferedRequestMetric = maxBufferedRequestMetric;
    }
    _normalizeStripeContext(optsContext, clientContext) {
        if (optsContext) return optsContext.toString() || null; // return null for empty strings
        return (clientContext === null || clientContext === void 0 ? void 0 : clientContext.toString()) || null; // return null for empty strings
    }
    _addHeadersDirectlyToObject(obj, headers) {
        // For convenience, make some headers easily accessible on
        // lastResponse.
        // NOTE: Stripe responds with lowercase header names/keys.
        obj.requestId = headers['request-id'];
        obj.stripeAccount = obj.stripeAccount || headers['stripe-account'];
        obj.apiVersion = obj.apiVersion || headers['stripe-version'];
        obj.idempotencyKey = obj.idempotencyKey || headers['idempotency-key'];
    }
    _makeResponseEvent(requestEvent, statusCode, headers) {
        const requestEndTime = Date.now();
        const requestDurationMs = requestEndTime - requestEvent.request_start_time;
        return (0, $f9518090947873ad$export$6399545f0684c71f)({
            api_version: headers['stripe-version'],
            account: headers['stripe-account'],
            idempotency_key: headers['idempotency-key'],
            method: requestEvent.method,
            path: requestEvent.path,
            status: statusCode,
            request_id: this._getRequestId(headers),
            elapsed: requestDurationMs,
            request_start_time: requestEvent.request_start_time,
            request_end_time: requestEndTime
        });
    }
    _getRequestId(headers) {
        return headers['request-id'];
    }
    /**
     * Used by methods with spec.streaming === true. For these methods, we do not
     * buffer successful responses into memory or do parse them into stripe
     * objects, we delegate that all of that to the user and pass back the raw
     * http.Response object to the callback.
     *
     * (Unsuccessful responses shouldn't make it here, they should
     * still be buffered/parsed and handled by _jsonResponseHandler -- see
     * makeRequest)
     */ _streamingResponseHandler(requestEvent, usage, callback) {
        return (res)=>{
            const headers = res.getHeaders();
            const streamCompleteCallback = ()=>{
                const responseEvent = this._makeResponseEvent(requestEvent, res.getStatusCode(), headers);
                this._stripe._emitter.emit('response', responseEvent);
                this._recordRequestMetrics(this._getRequestId(headers), responseEvent.elapsed, usage);
            };
            const stream = res.toStream(streamCompleteCallback);
            // This is here for backwards compatibility, as the stream is a raw
            // HTTP response in Node and the legacy behavior was to mutate this
            // response.
            this._addHeadersDirectlyToObject(stream, headers);
            return callback(null, stream);
        };
    }
    /**
     * Default handler for Stripe responses. Buffers the response into memory,
     * parses the JSON and returns it (i.e. passes it to the callback) if there
     * is no "error" field. Otherwise constructs/passes an appropriate Error.
     */ _jsonResponseHandler(requestEvent, apiMode, usage, callback) {
        return (res)=>{
            const headers = res.getHeaders();
            const requestId = this._getRequestId(headers);
            const statusCode = res.getStatusCode();
            const responseEvent = this._makeResponseEvent(requestEvent, statusCode, headers);
            this._stripe._emitter.emit('response', responseEvent);
            res.toJSON().then((jsonResponse)=>{
                if (jsonResponse.error) {
                    let err;
                    // Convert OAuth error responses into a standard format
                    // so that the rest of the error logic can be shared
                    if (typeof jsonResponse.error === 'string') jsonResponse.error = {
                        type: jsonResponse.error,
                        message: jsonResponse.error_description
                    };
                    jsonResponse.error.headers = headers;
                    jsonResponse.error.statusCode = statusCode;
                    jsonResponse.error.requestId = requestId;
                    if (statusCode === 401) err = new (0, $7dd63d24cadb0282$export$58689542aa04bf8d)(jsonResponse.error);
                    else if (statusCode === 403) err = new (0, $7dd63d24cadb0282$export$e9509420fd7e43c0)(jsonResponse.error);
                    else if (statusCode === 429) err = new (0, $7dd63d24cadb0282$export$a56520c648817af9)(jsonResponse.error);
                    else if (apiMode === 'v2') err = (0, $7dd63d24cadb0282$export$ea12b5d3f3cff421)(jsonResponse.error);
                    else err = (0, $7dd63d24cadb0282$export$2d1b622bf1bd2cd8)(jsonResponse.error);
                    throw err;
                }
                return jsonResponse;
            }, (e)=>{
                throw new (0, $7dd63d24cadb0282$export$76ec20179fd99642)({
                    message: 'Invalid JSON received from the Stripe API',
                    exception: e,
                    requestId: headers['request-id']
                });
            }).then((jsonResponse)=>{
                this._recordRequestMetrics(requestId, responseEvent.elapsed, usage);
                // Expose raw response object.
                const rawResponse = res.getRawResponse();
                this._addHeadersDirectlyToObject(rawResponse, headers);
                Object.defineProperty(jsonResponse, 'lastResponse', {
                    enumerable: false,
                    writable: false,
                    value: rawResponse
                });
                callback(null, jsonResponse);
            }, (e)=>callback(e, null));
        };
    }
    static _generateConnectionErrorMessage(requestRetries) {
        return `An error occurred with our connection to Stripe.${requestRetries > 0 ? ` Request was retried ${requestRetries} times.` : ''}`;
    }
    // For more on when and how to retry API requests, see https://stripe.com/docs/error-handling#safely-retrying-requests-with-idempotency
    static _shouldRetry(res, numRetries, maxRetries, error) {
        if (error && numRetries === 0 && (0, $22250c6fcb187bc7$export$8c6ee871e681f0f4).CONNECTION_CLOSED_ERROR_CODES.includes(error.code)) return true;
        // Do not retry if we are out of retries.
        if (numRetries >= maxRetries) return false;
        // Retry on connection error.
        if (!res) return true;
        // The API may ask us not to retry (e.g., if doing so would be a no-op)
        // or advise us to retry (e.g., in cases of lock timeouts); we defer to that.
        if (res.getHeaders()['stripe-should-retry'] === 'false') return false;
        if (res.getHeaders()['stripe-should-retry'] === 'true') return true;
        // Retry on conflict errors.
        if (res.getStatusCode() === 409) return true;
        // Retry on 500, 503, and other internal errors.
        //
        // Note that we expect the stripe-should-retry header to be false
        // in most cases when a 500 is returned, since our idempotency framework
        // would typically replay it anyway.
        if (res.getStatusCode() >= 500) return true;
        return false;
    }
    _getSleepTimeInMS(numRetries, retryAfter = null) {
        const initialNetworkRetryDelay = this._stripe.getInitialNetworkRetryDelay();
        const maxNetworkRetryDelay = this._stripe.getMaxNetworkRetryDelay();
        // Apply exponential backoff with initialNetworkRetryDelay on the
        // number of numRetries so far as inputs. Do not allow the number to exceed
        // maxNetworkRetryDelay.
        let sleepSeconds = Math.min(initialNetworkRetryDelay * Math.pow(2, numRetries - 1), maxNetworkRetryDelay);
        // Apply some jitter by randomizing the value in the range of
        // (sleepSeconds / 2) to (sleepSeconds).
        sleepSeconds *= 0.5 * (1 + Math.random());
        // But never sleep less than the base sleep seconds.
        sleepSeconds = Math.max(initialNetworkRetryDelay, sleepSeconds);
        // And never sleep less than the time the API asks us to wait, assuming it's a reasonable ask.
        if (Number.isInteger(retryAfter) && retryAfter <= $05b8a1b47abc2dac$var$MAX_RETRY_AFTER_WAIT) sleepSeconds = Math.max(sleepSeconds, retryAfter);
        return sleepSeconds * 1000;
    }
    // Max retries can be set on a per request basis. Favor those over the global setting
    _getMaxNetworkRetries(settings = {}) {
        return settings.maxNetworkRetries !== undefined && Number.isInteger(settings.maxNetworkRetries) ? settings.maxNetworkRetries : this._stripe.getMaxNetworkRetries();
    }
    _defaultIdempotencyKey(method, settings, apiMode) {
        // If this is a POST and we allow multiple retries, ensure an idempotency key.
        const maxRetries = this._getMaxNetworkRetries(settings);
        const genKey = ()=>`stripe-node-retry-${this._stripe._platformFunctions.uuid4()}`;
        // more verbose than it needs to be, but gives clear separation between V1 and V2 behavior
        if (apiMode === 'v2') {
            if (method === 'POST' || method === 'DELETE') return genKey();
        } else if (apiMode === 'v1') {
            if (method === 'POST' && maxRetries > 0) return genKey();
        }
        return null;
    }
    _makeHeaders({ contentType: contentType, contentLength: contentLength, apiVersion: apiVersion, clientUserAgent: clientUserAgent, method: method, userSuppliedHeaders: userSuppliedHeaders, userSuppliedSettings: userSuppliedSettings, stripeAccount: stripeAccount, stripeContext: stripeContext, apiMode: apiMode }) {
        const defaultHeaders = {
            Accept: 'application/json',
            'Content-Type': contentType,
            'User-Agent': this._getUserAgentString(apiMode),
            'X-Stripe-Client-User-Agent': clientUserAgent,
            'X-Stripe-Client-Telemetry': this._getTelemetryHeader(),
            'Stripe-Version': apiVersion,
            'Stripe-Account': stripeAccount,
            'Stripe-Context': stripeContext,
            'Idempotency-Key': this._defaultIdempotencyKey(method, userSuppliedSettings, apiMode)
        };
        // As per https://datatracker.ietf.org/doc/html/rfc7230#section-3.3.2:
        //   A user agent SHOULD send a Content-Length in a request message when
        //   no Transfer-Encoding is sent and the request method defines a meaning
        //   for an enclosed payload body.  For example, a Content-Length header
        //   field is normally sent in a POST request even when the value is 0
        //   (indicating an empty payload body).  A user agent SHOULD NOT send a
        //   Content-Length header field when the request message does not contain
        //   a payload body and the method semantics do not anticipate such a
        //   body.
        //
        // These method types are expected to have bodies and so we should always
        // include a Content-Length.
        const methodHasPayload = method == 'POST' || method == 'PUT' || method == 'PATCH';
        // If a content length was specified, we always include it regardless of
        // whether the method semantics anticipate such a body. This keeps us
        // consistent with historical behavior. We do however want to warn on this
        // and fix these cases as they are semantically incorrect.
        if (methodHasPayload || contentLength) {
            if (!methodHasPayload) (0, $f9518090947873ad$export$76ee40922b2f96c0)(`${method} method had non-zero contentLength but no payload is expected for this verb`);
            defaultHeaders['Content-Length'] = contentLength;
        }
        return Object.assign((0, $f9518090947873ad$export$6399545f0684c71f)(defaultHeaders), // If the user supplied, say 'idempotency-key', override instead of appending by ensuring caps are the same.
        (0, $f9518090947873ad$export$a89b99466b0866f2)(userSuppliedHeaders));
    }
    _getUserAgentString(apiMode) {
        const packageVersion = this._stripe.getConstant('PACKAGE_VERSION');
        const appInfo = this._stripe._appInfo ? this._stripe.getAppInfoAsString() : '';
        return `Stripe/${apiMode} NodeBindings/${packageVersion} ${appInfo}`.trim();
    }
    _getTelemetryHeader() {
        if (this._stripe.getTelemetryEnabled() && this._stripe._prevRequestMetrics.length > 0) {
            const metrics = this._stripe._prevRequestMetrics.shift();
            return JSON.stringify({
                last_request_metrics: metrics
            });
        }
    }
    _recordRequestMetrics(requestId, requestDurationMs, usage) {
        if (this._stripe.getTelemetryEnabled() && requestId) {
            if (this._stripe._prevRequestMetrics.length > this._maxBufferedRequestMetric) (0, $f9518090947873ad$export$76ee40922b2f96c0)('Request metrics buffer is full, dropping telemetry message.');
            else {
                const m = {
                    request_id: requestId,
                    request_duration_ms: requestDurationMs
                };
                if (usage && usage.length > 0) m.usage = usage;
                this._stripe._prevRequestMetrics.push(m);
            }
        }
    }
    _rawRequest(method, path, params, options, usage) {
        const requestPromise = new Promise((resolve, reject)=>{
            let opts;
            try {
                const requestMethod = method.toUpperCase();
                if (requestMethod !== 'POST' && params && Object.keys(params).length !== 0) throw new Error('rawRequest only supports params on POST requests. Please pass null and add your parameters to path.');
                const args = [].slice.call([
                    params,
                    options
                ]);
                // Pull request data and options (headers, auth) from args.
                const dataFromArgs = (0, $f9518090947873ad$export$ffdc9c53a9d431ae)(args);
                const data = requestMethod === 'POST' ? Object.assign({}, dataFromArgs) : null;
                const calculatedOptions = (0, $f9518090947873ad$export$af7e4789946d118b)(args);
                const headers = calculatedOptions.headers;
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const authenticator = calculatedOptions.authenticator;
                opts = {
                    requestMethod: requestMethod,
                    requestPath: path,
                    bodyData: data,
                    queryData: {},
                    authenticator: authenticator,
                    headers: headers,
                    host: calculatedOptions.host,
                    streaming: !!calculatedOptions.streaming,
                    settings: {},
                    // We use this for thin event internals, so we should record the more specific `usage`, when available
                    usage: usage || [
                        'raw_request'
                    ]
                };
            } catch (err) {
                reject(err);
                return;
            }
            function requestCallback(err, response) {
                if (err) reject(err);
                else resolve(response);
            }
            const { headers: headers, settings: settings } = opts;
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const authenticator = opts.authenticator;
            this._request(opts.requestMethod, opts.host, path, opts.bodyData, authenticator, {
                headers: headers,
                settings: settings,
                streaming: opts.streaming
            }, opts.usage, requestCallback);
        });
        return requestPromise;
    }
    _getContentLength(data) {
        // if we calculate this wrong, the server treats it as invalid json
        // or if content length is too big, the request never finishes and it
        // times out.
        return typeof data === 'string' ? new TextEncoder().encode(data).length : data.length;
    }
    _request(method, host, path, data, authenticator, options, usage = [], callback, requestDataProcessor = null) {
        var _a;
        let requestData;
        authenticator = (_a = authenticator !== null && authenticator !== void 0 ? authenticator : this._stripe._authenticator) !== null && _a !== void 0 ? _a : null;
        const apiMode = (0, $f9518090947873ad$export$6cecdede54eaa80d)(path);
        const retryRequest = (requestFn, apiVersion, headers, requestRetries, retryAfter)=>{
            return setTimeout(requestFn, this._getSleepTimeInMS(requestRetries, retryAfter), apiVersion, headers, requestRetries + 1);
        };
        const makeRequest = (apiVersion, headers, numRetries)=>{
            // timeout can be set on a per-request basis. Favor that over the global setting
            const timeout = options.settings && options.settings.timeout && Number.isInteger(options.settings.timeout) && options.settings.timeout >= 0 ? options.settings.timeout : this._stripe.getApiField('timeout');
            const request = {
                host: host || this._stripe.getApiField('host'),
                port: this._stripe.getApiField('port'),
                path: path,
                method: method,
                headers: Object.assign({}, headers),
                body: requestData,
                protocol: this._stripe.getApiField('protocol')
            };
            authenticator(request).then(()=>{
                const req = this._stripe.getApiField('httpClient').makeRequest(request.host, request.port, request.path, request.method, request.headers, request.body, request.protocol, timeout);
                const requestStartTime = Date.now();
                const requestEvent = (0, $f9518090947873ad$export$6399545f0684c71f)({
                    api_version: apiVersion,
                    account: (0, $f9518090947873ad$export$8e70eb61c7c97f0a)(headers['Stripe-Account']),
                    idempotency_key: (0, $f9518090947873ad$export$8e70eb61c7c97f0a)(headers['Idempotency-Key']),
                    method: method,
                    path: path,
                    request_start_time: requestStartTime
                });
                const requestRetries = numRetries || 0;
                const maxRetries = this._getMaxNetworkRetries(options.settings || {});
                this._stripe._emitter.emit('request', requestEvent);
                req.then((res)=>{
                    if ($05b8a1b47abc2dac$export$196c27f83356e260._shouldRetry(res, requestRetries, maxRetries)) return retryRequest(makeRequest, apiVersion, headers, requestRetries, (0, $f9518090947873ad$export$a534077c39afec16)(res.getHeaders()['retry-after']));
                    else if (options.streaming && res.getStatusCode() < 400) return this._streamingResponseHandler(requestEvent, usage, callback)(res);
                    else return this._jsonResponseHandler(requestEvent, apiMode, usage, callback)(res);
                }).catch((error)=>{
                    if ($05b8a1b47abc2dac$export$196c27f83356e260._shouldRetry(null, requestRetries, maxRetries, error)) return retryRequest(makeRequest, apiVersion, headers, requestRetries, null);
                    else {
                        const isTimeoutError = error.code && error.code === (0, $22250c6fcb187bc7$export$8c6ee871e681f0f4).TIMEOUT_ERROR_CODE;
                        return callback(new (0, $7dd63d24cadb0282$export$632911809a084c44)({
                            message: isTimeoutError ? `Request aborted due to timeout being reached (${timeout}ms)` : $05b8a1b47abc2dac$export$196c27f83356e260._generateConnectionErrorMessage(requestRetries),
                            detail: error
                        }));
                    }
                });
            }).catch((e)=>{
                throw new (0, $7dd63d24cadb0282$export$4627d23f26d15ec0)({
                    message: 'Unable to authenticate the request',
                    exception: e
                });
            });
        };
        const prepareAndMakeRequest = (error, data)=>{
            if (error) return callback(error);
            requestData = data;
            this._stripe.getClientUserAgent((clientUserAgent)=>{
                var _a, _b, _c;
                const apiVersion = this._stripe.getApiField('version');
                const headers = this._makeHeaders({
                    contentType: apiMode == 'v2' ? 'application/json' : 'application/x-www-form-urlencoded',
                    contentLength: this._getContentLength(data),
                    apiVersion: apiVersion,
                    clientUserAgent: clientUserAgent,
                    method: method,
                    // other callers expect null, but .headers being optional means it's undefined if not supplied. So we normalize to null.
                    userSuppliedHeaders: (_a = options.headers) !== null && _a !== void 0 ? _a : null,
                    userSuppliedSettings: (_b = options.settings) !== null && _b !== void 0 ? _b : {},
                    stripeAccount: (_c = options.stripeAccount) !== null && _c !== void 0 ? _c : this._stripe.getApiField('stripeAccount'),
                    stripeContext: this._normalizeStripeContext(options.stripeContext, this._stripe.getApiField('stripeContext')),
                    apiMode: apiMode
                });
                makeRequest(apiVersion, headers, 0);
            });
        };
        if (requestDataProcessor) requestDataProcessor(method, data, options.headers, prepareAndMakeRequest);
        else {
            let stringifiedData;
            if (apiMode == 'v2') stringifiedData = data ? (0, $f9518090947873ad$export$cf495d1cb7e3c8af)(data) : '';
            else stringifiedData = (0, $f9518090947873ad$export$ee3e7678add00de3)(data || {}, apiMode);
            prepareAndMakeRequest(null, stringifiedData);
        }
    }
}





class $5733539ce501515a$var$V1Iterator {
    constructor(firstPagePromise, requestArgs, spec, stripeResource){
        this.index = 0;
        this.pagePromise = firstPagePromise;
        this.promiseCache = {
            currentPromise: null
        };
        this.requestArgs = requestArgs;
        this.spec = spec;
        this.stripeResource = stripeResource;
    }
    async iterate(pageResult) {
        if (!(pageResult && pageResult.data && typeof pageResult.data.length === 'number')) throw Error('Unexpected: Stripe API response does not have a well-formed `data` array.');
        const reverseIteration = $5733539ce501515a$var$isReverseIteration(this.requestArgs);
        if (this.index < pageResult.data.length) {
            const idx = reverseIteration ? pageResult.data.length - 1 - this.index : this.index;
            const value = pageResult.data[idx];
            this.index += 1;
            return {
                value: value,
                done: false
            };
        } else if (pageResult.has_more) {
            // Reset counter, request next page, and recurse.
            this.index = 0;
            this.pagePromise = this.getNextPage(pageResult);
            const nextPageResult = await this.pagePromise;
            return this.iterate(nextPageResult);
        }
        return {
            done: true,
            value: undefined
        };
    }
    /** @abstract */ getNextPage(_pageResult) {
        throw new Error('Unimplemented');
    }
    async _next() {
        return this.iterate(await this.pagePromise);
    }
    next() {
        /**
         * If a user calls `.next()` multiple times in parallel,
         * return the same result until something has resolved
         * to prevent page-turning race conditions.
         */ if (this.promiseCache.currentPromise) return this.promiseCache.currentPromise;
        const nextPromise = (async ()=>{
            const ret = await this._next();
            this.promiseCache.currentPromise = null;
            return ret;
        })();
        this.promiseCache.currentPromise = nextPromise;
        return nextPromise;
    }
}
class $5733539ce501515a$var$V1ListIterator extends $5733539ce501515a$var$V1Iterator {
    getNextPage(pageResult) {
        const reverseIteration = $5733539ce501515a$var$isReverseIteration(this.requestArgs);
        const lastId = $5733539ce501515a$var$getLastId(pageResult, reverseIteration);
        return this.stripeResource._makeRequest(this.requestArgs, this.spec, {
            [reverseIteration ? 'ending_before' : 'starting_after']: lastId
        });
    }
}
class $5733539ce501515a$var$V1SearchIterator extends $5733539ce501515a$var$V1Iterator {
    getNextPage(pageResult) {
        if (!pageResult.next_page) throw Error('Unexpected: Stripe API response does not have a well-formed `next_page` field, but `has_more` was true.');
        return this.stripeResource._makeRequest(this.requestArgs, this.spec, {
            page: pageResult.next_page
        });
    }
}
class $5733539ce501515a$var$V2ListIterator {
    constructor(firstPagePromise, requestArgs, spec, stripeResource){
        this.currentPageIterator = (async ()=>{
            const page = await firstPagePromise;
            return page.data[Symbol.iterator]();
        })();
        this.nextPageUrl = (async ()=>{
            const page = await firstPagePromise;
            return page.next_page_url || null;
        })();
        this.requestArgs = requestArgs;
        this.spec = spec;
        this.stripeResource = stripeResource;
    }
    async turnPage() {
        const nextPageUrl = await this.nextPageUrl;
        if (!nextPageUrl) return null;
        this.spec.fullPath = nextPageUrl;
        const page = await this.stripeResource._makeRequest([], this.spec, {});
        this.nextPageUrl = Promise.resolve(page.next_page_url);
        this.currentPageIterator = Promise.resolve(page.data[Symbol.iterator]());
        return this.currentPageIterator;
    }
    async next() {
        {
            const result = (await this.currentPageIterator).next();
            if (!result.done) return {
                done: false,
                value: result.value
            };
        }
        const nextPageIterator = await this.turnPage();
        if (!nextPageIterator) return {
            done: true,
            value: undefined
        };
        const result = nextPageIterator.next();
        if (!result.done) return {
            done: false,
            value: result.value
        };
        return {
            done: true,
            value: undefined
        };
    }
}
const $5733539ce501515a$export$fa4c192804415f68 = (stripeResource, requestArgs, spec, firstPagePromise)=>{
    const apiMode = (0, $f9518090947873ad$export$6cecdede54eaa80d)(spec.fullPath || spec.path);
    if (apiMode !== 'v2' && spec.methodType === 'search') return $5733539ce501515a$var$makeAutoPaginationMethodsFromIterator(new $5733539ce501515a$var$V1SearchIterator(firstPagePromise, requestArgs, spec, stripeResource));
    if (apiMode !== 'v2' && spec.methodType === 'list') return $5733539ce501515a$var$makeAutoPaginationMethodsFromIterator(new $5733539ce501515a$var$V1ListIterator(firstPagePromise, requestArgs, spec, stripeResource));
    if (apiMode === 'v2' && spec.methodType === 'list') return $5733539ce501515a$var$makeAutoPaginationMethodsFromIterator(new $5733539ce501515a$var$V2ListIterator(firstPagePromise, requestArgs, spec, stripeResource));
    return null;
};
const $5733539ce501515a$var$makeAutoPaginationMethodsFromIterator = (iterator)=>{
    const autoPagingEach = $5733539ce501515a$var$makeAutoPagingEach((...args)=>iterator.next(...args));
    const autoPagingToArray = $5733539ce501515a$var$makeAutoPagingToArray(autoPagingEach);
    const autoPaginationMethods = {
        autoPagingEach: autoPagingEach,
        autoPagingToArray: autoPagingToArray,
        // Async iterator functions:
        next: ()=>iterator.next(),
        return: ()=>{
            // This is required for `break`.
            return {};
        },
        [$5733539ce501515a$var$getAsyncIteratorSymbol()]: ()=>{
            return autoPaginationMethods;
        }
    };
    return autoPaginationMethods;
};
/**
 * ----------------
 * Private Helpers:
 * ----------------
 */ function $5733539ce501515a$var$getAsyncIteratorSymbol() {
    if (typeof Symbol !== 'undefined' && Symbol.asyncIterator) return Symbol.asyncIterator;
    // Follow the convention from libraries like iterall: https://github.com/leebyron/iterall#asynciterator-1
    return '@@asyncIterator';
}
function $5733539ce501515a$var$getDoneCallback(args) {
    if (args.length < 2) return null;
    const onDone = args[1];
    if (typeof onDone !== 'function') throw Error(`The second argument to autoPagingEach, if present, must be a callback function; received ${typeof onDone}`);
    return onDone;
}
/**
 * We allow four forms of the `onItem` callback (the middle two being equivalent),
 *
 *   1. `.autoPagingEach((item) => { doSomething(item); return false; });`
 *   2. `.autoPagingEach(async (item) => { await doSomething(item); return false; });`
 *   3. `.autoPagingEach((item) => doSomething(item).then(() => false));`
 *   4. `.autoPagingEach((item, next) => { doSomething(item); next(false); });`
 *
 * In addition to standard validation, this helper
 * coalesces the former forms into the latter form.
 */ function $5733539ce501515a$var$getItemCallback(args) {
    if (args.length === 0) return undefined;
    const onItem = args[0];
    if (typeof onItem !== 'function') throw Error(`The first argument to autoPagingEach, if present, must be a callback function; received ${typeof onItem}`);
    // 4. `.autoPagingEach((item, next) => { doSomething(item); next(false); });`
    if (onItem.length === 2) return onItem;
    if (onItem.length > 2) throw Error(`The \`onItem\` callback function passed to autoPagingEach must accept at most two arguments; got ${onItem}`);
    // This magically handles all three of these usecases (the latter two being functionally identical):
    // 1. `.autoPagingEach((item) => { doSomething(item); return false; });`
    // 2. `.autoPagingEach(async (item) => { await doSomething(item); return false; });`
    // 3. `.autoPagingEach((item) => doSomething(item).then(() => false));`
    return function _onItem(item, next) {
        const shouldContinue = onItem(item);
        next(shouldContinue);
    };
}
function $5733539ce501515a$var$getLastId(listResult, reverseIteration) {
    const lastIdx = reverseIteration ? 0 : listResult.data.length - 1;
    const lastItem = listResult.data[lastIdx];
    const lastId = lastItem && lastItem.id;
    if (!lastId) throw Error('Unexpected: No `id` found on the last item while auto-paging a list.');
    return lastId;
}
function $5733539ce501515a$var$makeAutoPagingEach(asyncIteratorNext) {
    return function autoPagingEach() {
        const args = [].slice.call(arguments);
        const onItem = $5733539ce501515a$var$getItemCallback(args);
        const onDone = $5733539ce501515a$var$getDoneCallback(args);
        if (args.length > 2) throw Error(`autoPagingEach takes up to two arguments; received ${args}`);
        const autoPagePromise = $5733539ce501515a$var$wrapAsyncIteratorWithCallback(asyncIteratorNext, // @ts-ignore we might need a null check
        onItem);
        return (0, $f9518090947873ad$export$a193763689ef14b2)(autoPagePromise, onDone);
    };
}
function $5733539ce501515a$var$makeAutoPagingToArray(autoPagingEach) {
    return function autoPagingToArray(opts, onDone) {
        const limit = opts && opts.limit;
        if (!limit) throw Error('You must pass a `limit` option to autoPagingToArray, e.g., `autoPagingToArray({limit: 1000});`.');
        if (limit > 10000) throw Error('You cannot specify a limit of more than 10,000 items to fetch in `autoPagingToArray`; use `autoPagingEach` to iterate through longer lists.');
        const promise = new Promise((resolve, reject)=>{
            const items = [];
            autoPagingEach((item)=>{
                items.push(item);
                if (items.length >= limit) return false;
            }).then(()=>{
                resolve(items);
            }).catch(reject);
        });
        // @ts-ignore
        return (0, $f9518090947873ad$export$a193763689ef14b2)(promise, onDone);
    };
}
function $5733539ce501515a$var$wrapAsyncIteratorWithCallback(asyncIteratorNext, onItem) {
    return new Promise((resolve, reject)=>{
        function handleIteration(iterResult) {
            if (iterResult.done) {
                resolve();
                return;
            }
            const item = iterResult.value;
            return new Promise((next)=>{
                // Bit confusing, perhaps; we pass a `resolve` fn
                // to the user, so they can decide when and if to continue.
                // They can return false, or a promise which resolves to false, to break.
                onItem(item, next);
            }).then((shouldContinue)=>{
                if (shouldContinue === false) return handleIteration({
                    done: true,
                    value: undefined
                });
                else return asyncIteratorNext().then(handleIteration);
            });
        }
        asyncIteratorNext().then(handleIteration).catch(reject);
    });
}
function $5733539ce501515a$var$isReverseIteration(requestArgs) {
    const args = [].slice.call(requestArgs);
    const dataFromArgs = (0, $f9518090947873ad$export$ffdc9c53a9d431ae)(args);
    return !!dataFromArgs.ending_before;
}


function $764c33334af13e0e$export$d5e3427cf79b11ed(spec) {
    if (spec.path !== undefined && spec.fullPath !== undefined) throw new Error(`Method spec specified both a 'path' (${spec.path}) and a 'fullPath' (${spec.fullPath}).`);
    return function(...args) {
        const callback = typeof args[args.length - 1] == 'function' && args.pop();
        spec.urlParams = (0, $f9518090947873ad$export$3a2c52552915690c)(spec.fullPath || this.createResourcePathWithSymbols(spec.path || ''));
        const requestPromise = (0, $f9518090947873ad$export$a193763689ef14b2)(this._makeRequest(args, spec, {}), callback);
        Object.assign(requestPromise, (0, $5733539ce501515a$export$fa4c192804415f68)(this, args, spec, requestPromise));
        return requestPromise;
    };
}


// Provide extension mechanism for Stripe Resource Sub-Classes
$7f2478bb1c7170aa$export$dc31a0a82b15e597.extend = (0, $f9518090947873ad$export$7466dd6e40823310);
// Expose method-creator
$7f2478bb1c7170aa$export$dc31a0a82b15e597.method = (0, $764c33334af13e0e$export$d5e3427cf79b11ed);
$7f2478bb1c7170aa$export$dc31a0a82b15e597.MAX_BUFFERED_REQUEST_METRICS = 100;
/**
 * Encapsulates request logic for a Stripe Resource
 */ function $7f2478bb1c7170aa$export$dc31a0a82b15e597(stripe, deprecatedUrlData) {
    this._stripe = stripe;
    if (deprecatedUrlData) throw new Error('Support for curried url params was dropped in stripe-node v7.0.0. Instead, pass two ids.');
    this.basePath = (0, $f9518090947873ad$export$27bb0b6fde69b6c1)(// @ts-ignore changing type of basePath
    this.basePath || stripe.getApiField('basePath'));
    // @ts-ignore changing type of path
    this.resourcePath = this.path;
    // @ts-ignore changing type of path
    this.path = (0, $f9518090947873ad$export$27bb0b6fde69b6c1)(this.path);
    this.initialize(...arguments);
}
$7f2478bb1c7170aa$export$dc31a0a82b15e597.prototype = {
    _stripe: null,
    // @ts-ignore the type of path changes in ctor
    path: '',
    resourcePath: '',
    // Methods that don't use the API's default '/v1' path can override it with this setting.
    basePath: null,
    initialize () {},
    // Function to override the default data processor. This allows full control
    // over how a StripeResource's request data will get converted into an HTTP
    // body. This is useful for non-standard HTTP requests. The function should
    // take method name, data, and headers as arguments.
    requestDataProcessor: null,
    // Function to add a validation checks before sending the request, errors should
    // be thrown, and they will be passed to the callback/promise.
    validateRequest: null,
    createFullPath (commandPath, urlData) {
        const urlParts = [
            this.basePath(urlData),
            this.path(urlData)
        ];
        if (typeof commandPath === 'function') {
            const computedCommandPath = commandPath(urlData);
            // If we have no actual command path, we just omit it to avoid adding a
            // trailing slash. This is important for top-level listing requests, which
            // do not have a command path.
            if (computedCommandPath) urlParts.push(computedCommandPath);
        } else urlParts.push(commandPath);
        return this._joinUrlParts(urlParts);
    },
    // Creates a relative resource path with symbols left in (unlike
    // createFullPath which takes some data to replace them with). For example it
    // might produce: /invoices/{id}
    createResourcePathWithSymbols (pathWithSymbols) {
        // If there is no path beyond the resource path, we want to produce just
        // /<resource path> rather than /<resource path>/.
        if (pathWithSymbols) return `/${this._joinUrlParts([
            this.resourcePath,
            pathWithSymbols
        ])}`;
        else return `/${this.resourcePath}`;
    },
    _joinUrlParts (parts) {
        // Replace any accidentally doubled up slashes. This previously used
        // path.join, which would do this as well. Unfortunately we need to do this
        // as the functions for creating paths are technically part of the public
        // interface and so we need to preserve backwards compatibility.
        return parts.join('/').replace(/\/{2,}/g, '/');
    },
    _getRequestOpts (requestArgs, spec, overrideData) {
        var _a;
        // Extract spec values with defaults.
        const requestMethod = (spec.method || 'GET').toUpperCase();
        const usage = spec.usage || [];
        const urlParams = spec.urlParams || [];
        const encode = spec.encode || ((data)=>data);
        const isUsingFullPath = !!spec.fullPath;
        const commandPath = (0, $f9518090947873ad$export$27bb0b6fde69b6c1)(isUsingFullPath ? spec.fullPath : spec.path || '');
        // When using fullPath, we ignore the resource path as it should already be
        // fully qualified.
        const path = isUsingFullPath ? spec.fullPath : this.createResourcePathWithSymbols(spec.path);
        // Don't mutate args externally.
        const args = [].slice.call(requestArgs);
        // Generate and validate url params.
        const urlData = urlParams.reduce((urlData, param)=>{
            const arg = args.shift();
            if (typeof arg !== 'string') throw new Error(`Stripe: Argument "${param}" must be a string, but got: ${arg} (on API request to \`${requestMethod} ${path}\`)`);
            urlData[param] = arg;
            return urlData;
        }, {});
        // Pull request data and options (headers, auth) from args.
        const dataFromArgs = (0, $f9518090947873ad$export$ffdc9c53a9d431ae)(args);
        const data = encode(Object.assign({}, dataFromArgs, overrideData));
        const options = (0, $f9518090947873ad$export$af7e4789946d118b)(args);
        const host = options.host || spec.host;
        const streaming = !!spec.streaming || !!options.streaming;
        // Validate that there are no more args.
        if (args.filter((x)=>x != null).length) throw new Error(`Stripe: Unknown arguments (${args}). Did you mean to pass an options object? See https://github.com/stripe/stripe-node/wiki/Passing-Options. (on API request to ${requestMethod} \`${path}\`)`);
        // When using full path, we can just invoke the URL interpolator directly
        // as we don't need to use the resource to create a full path.
        const requestPath = isUsingFullPath ? commandPath(urlData) : this.createFullPath(commandPath, urlData);
        const headers = Object.assign(options.headers, spec.headers);
        if (spec.validator) spec.validator(data, {
            headers: headers
        });
        const dataInQuery = spec.method === 'GET' || spec.method === 'DELETE';
        const bodyData = dataInQuery ? null : data;
        const queryData = dataInQuery ? data : {};
        return {
            requestMethod: requestMethod,
            requestPath: requestPath,
            bodyData: bodyData,
            queryData: queryData,
            authenticator: (_a = options.authenticator) !== null && _a !== void 0 ? _a : null,
            headers: headers,
            host: host !== null && host !== void 0 ? host : null,
            streaming: streaming,
            settings: options.settings,
            usage: usage
        };
    },
    _makeRequest (requestArgs, spec, overrideData) {
        return new Promise((resolve, reject)=>{
            var _a;
            let opts;
            try {
                opts = this._getRequestOpts(requestArgs, spec, overrideData);
            } catch (err) {
                reject(err);
                return;
            }
            function requestCallback(err, response) {
                if (err) reject(err);
                else resolve(spec.transformResponseData ? spec.transformResponseData(response) : response);
            }
            const emptyQuery = Object.keys(opts.queryData).length === 0;
            const path = [
                opts.requestPath,
                emptyQuery ? '' : '?',
                (0, $f9518090947873ad$export$ee3e7678add00de3)(opts.queryData, (0, $f9518090947873ad$export$6cecdede54eaa80d)(opts.requestPath))
            ].join('');
            const { headers: headers, settings: settings } = opts;
            this._stripe._requestSender._request(opts.requestMethod, opts.host, path, opts.bodyData, opts.authenticator, {
                headers: headers,
                settings: settings,
                streaming: opts.streaming
            }, opts.usage, requestCallback, (_a = this.requestDataProcessor) === null || _a === void 0 ? void 0 : _a.bind(this));
        });
    }
};


/**
 * The StripeContext class provides an immutable container and convenience methods for interacting with the `Stripe-Context` header. All methods return a new instance of StripeContext.
 * You can use it whenever you're initializing a `Stripe` instance or sending `stripeContext` with a request. It's also found in the `EventNotification.context` property.
 */ class $613bdb80064c6477$export$bdc250ccffdc5290 {
    /**
     * Creates a new StripeContext with the given segments.
     */ constructor(segments = []){
        this._segments = [
            ...segments
        ];
    }
    /**
     * Gets a copy of the segments of this Context.
     */ get segments() {
        return [
            ...this._segments
        ];
    }
    /**
     * Creates a new StripeContext with an additional segment appended.
     */ push(segment) {
        if (!segment) throw new Error('Segment cannot be null or undefined');
        return new $613bdb80064c6477$export$bdc250ccffdc5290([
            ...this._segments,
            segment
        ]);
    }
    /**
     * Creates a new StripeContext with the last segment removed.
     * If there are no segments, throws an error.
     */ pop() {
        if (this._segments.length === 0) throw new Error('Cannot pop from an empty context');
        return new $613bdb80064c6477$export$bdc250ccffdc5290(this._segments.slice(0, -1));
    }
    /**
     * Converts this context to its string representation.
     */ toString() {
        return this._segments.join('/');
    }
    /**
     * Parses a context string into a StripeContext instance.
     */ static parse(contextStr) {
        if (!contextStr) return new $613bdb80064c6477$export$bdc250ccffdc5290([]);
        return new $613bdb80064c6477$export$bdc250ccffdc5290(contextStr.split('/'));
    }
}




function $2b5fa3cda468fcd8$export$b88c523063979268(platformFunctions) {
    const Webhook = {
        DEFAULT_TOLERANCE: 300,
        signature: null,
        constructEvent (payload, header, secret, tolerance, cryptoProvider, receivedAt) {
            try {
                if (!this.signature) throw new Error('ERR: missing signature helper, unable to verify');
                this.signature.verifyHeader(payload, header, secret, tolerance || Webhook.DEFAULT_TOLERANCE, cryptoProvider, receivedAt);
            } catch (e) {
                if (e instanceof (0, $0c14d973ee69192a$export$6df866e461d96a12)) e.message += '\nUse `await constructEventAsync(...)` instead of `constructEvent(...)`';
                throw e;
            }
            const jsonPayload = payload instanceof Uint8Array ? JSON.parse(new TextDecoder('utf8').decode(payload)) : JSON.parse(payload);
            return jsonPayload;
        },
        async constructEventAsync (payload, header, secret, tolerance, cryptoProvider, receivedAt) {
            if (!this.signature) throw new Error('ERR: missing signature helper, unable to verify');
            await this.signature.verifyHeaderAsync(payload, header, secret, tolerance || Webhook.DEFAULT_TOLERANCE, cryptoProvider, receivedAt);
            const jsonPayload = payload instanceof Uint8Array ? JSON.parse(new TextDecoder('utf8').decode(payload)) : JSON.parse(payload);
            return jsonPayload;
        },
        /**
         * Generates a header to be used for webhook mocking
         *
         * @typedef {object} opts
         * @property {number} timestamp - Timestamp of the header. Defaults to Date.now()
         * @property {string} payload - JSON stringified payload object, containing the 'id' and 'object' parameters
         * @property {string} secret - Stripe webhook secret 'whsec_...'
         * @property {string} scheme - Version of API to hit. Defaults to 'v1'.
         * @property {string} signature - Computed webhook signature
         * @property {CryptoProvider} cryptoProvider - Crypto provider to use for computing the signature if none was provided. Defaults to NodeCryptoProvider.
         */ generateTestHeaderString: function(opts) {
            const preparedOpts = prepareOptions(opts);
            const signature = preparedOpts.signature || preparedOpts.cryptoProvider.computeHMACSignature(preparedOpts.payloadString, preparedOpts.secret);
            return preparedOpts.generateHeaderString(signature);
        },
        generateTestHeaderStringAsync: async function(opts) {
            const preparedOpts = prepareOptions(opts);
            const signature = preparedOpts.signature || await preparedOpts.cryptoProvider.computeHMACSignatureAsync(preparedOpts.payloadString, preparedOpts.secret);
            return preparedOpts.generateHeaderString(signature);
        }
    };
    const signature = {
        EXPECTED_SCHEME: 'v1',
        verifyHeader (encodedPayload, encodedHeader, secret, tolerance, cryptoProvider, receivedAt) {
            const { decodedHeader: header, decodedPayload: payload, details: details, suspectPayloadType: suspectPayloadType } = parseEventDetails(encodedPayload, encodedHeader, this.EXPECTED_SCHEME);
            const secretContainsWhitespace = /\s/.test(secret);
            cryptoProvider = cryptoProvider || getCryptoProvider();
            const expectedSignature = cryptoProvider.computeHMACSignature(makeHMACContent(payload, details), secret);
            validateComputedSignature(payload, header, details, expectedSignature, tolerance, suspectPayloadType, secretContainsWhitespace, receivedAt);
            return true;
        },
        async verifyHeaderAsync (encodedPayload, encodedHeader, secret, tolerance, cryptoProvider, receivedAt) {
            const { decodedHeader: header, decodedPayload: payload, details: details, suspectPayloadType: suspectPayloadType } = parseEventDetails(encodedPayload, encodedHeader, this.EXPECTED_SCHEME);
            const secretContainsWhitespace = /\s/.test(secret);
            cryptoProvider = cryptoProvider || getCryptoProvider();
            const expectedSignature = await cryptoProvider.computeHMACSignatureAsync(makeHMACContent(payload, details), secret);
            return validateComputedSignature(payload, header, details, expectedSignature, tolerance, suspectPayloadType, secretContainsWhitespace, receivedAt);
        }
    };
    function makeHMACContent(payload, details) {
        return `${details.timestamp}.${payload}`;
    }
    function parseEventDetails(encodedPayload, encodedHeader, expectedScheme) {
        if (!encodedPayload) throw new (0, $7dd63d24cadb0282$export$9bd7fbbf50391137)(encodedHeader, encodedPayload, {
            message: 'No webhook payload was provided.'
        });
        const suspectPayloadType = typeof encodedPayload != 'string' && !(encodedPayload instanceof Uint8Array);
        const textDecoder = new TextDecoder('utf8');
        const decodedPayload = encodedPayload instanceof Uint8Array ? textDecoder.decode(encodedPayload) : encodedPayload;
        // Express's type for `Request#headers` is `string | []string`
        // which is because the `set-cookie` header is an array,
        // but no other headers are an array (docs: https://nodejs.org/api/http.html#http_message_headers)
        // (Express's Request class is an extension of http.IncomingMessage, and doesn't appear to be relevantly modified: https://github.com/expressjs/express/blob/master/lib/request.js#L31)
        if (Array.isArray(encodedHeader)) throw new Error('Unexpected: An array was passed as a header, which should not be possible for the stripe-signature header.');
        if (encodedHeader == null || encodedHeader == '') throw new (0, $7dd63d24cadb0282$export$9bd7fbbf50391137)(encodedHeader, encodedPayload, {
            message: 'No stripe-signature header value was provided.'
        });
        const decodedHeader = encodedHeader instanceof Uint8Array ? textDecoder.decode(encodedHeader) : encodedHeader;
        const details = parseHeader(decodedHeader, expectedScheme);
        if (!details || details.timestamp === -1) throw new (0, $7dd63d24cadb0282$export$9bd7fbbf50391137)(decodedHeader, decodedPayload, {
            message: 'Unable to extract timestamp and signatures from header'
        });
        if (!details.signatures.length) throw new (0, $7dd63d24cadb0282$export$9bd7fbbf50391137)(decodedHeader, decodedPayload, {
            message: 'No signatures found with expected scheme'
        });
        return {
            decodedPayload: decodedPayload,
            decodedHeader: decodedHeader,
            details: details,
            suspectPayloadType: suspectPayloadType
        };
    }
    function validateComputedSignature(payload, header, details, expectedSignature, tolerance, suspectPayloadType, secretContainsWhitespace, receivedAt) {
        const signatureFound = !!details.signatures.filter(platformFunctions.secureCompare.bind(platformFunctions, expectedSignature)).length;
        const docsLocation = "\nLearn more about webhook signing and explore webhook integration examples for various frameworks at https://docs.stripe.com/webhooks/signature";
        const whitespaceMessage = secretContainsWhitespace ? '\n\nNote: The provided signing secret contains whitespace. This often indicates an extra newline or space is in the value' : '';
        if (!signatureFound) {
            if (suspectPayloadType) throw new (0, $7dd63d24cadb0282$export$9bd7fbbf50391137)(header, payload, {
                message: "Webhook payload must be provided as a string or a Buffer (https://nodejs.org/api/buffer.html) instance representing the _raw_ request body.Payload was provided as a parsed JavaScript object instead. \nSignature verification is impossible without access to the original signed material. \n" + docsLocation + '\n' + whitespaceMessage
            });
            throw new (0, $7dd63d24cadb0282$export$9bd7fbbf50391137)(header, payload, {
                message: "No signatures found matching the expected signature for payload. Are you passing the raw request body you received from Stripe? \n If a webhook request is being forwarded by a third-party tool, ensure that the exact request body, including JSON formatting and new line style, is preserved.\n" + docsLocation + '\n' + whitespaceMessage
            });
        }
        const timestampAge = Math.floor((typeof receivedAt === 'number' ? receivedAt : Date.now()) / 1000) - details.timestamp;
        if (tolerance > 0 && timestampAge > tolerance) throw new (0, $7dd63d24cadb0282$export$9bd7fbbf50391137)(header, payload, {
            message: 'Timestamp outside the tolerance zone'
        });
        return true;
    }
    function parseHeader(header, scheme) {
        if (typeof header !== 'string') return null;
        return header.split(',').reduce((accum, item)=>{
            const kv = item.split('=');
            if (kv[0] === 't') accum.timestamp = parseInt(kv[1], 10);
            if (kv[0] === scheme) accum.signatures.push(kv[1]);
            return accum;
        }, {
            timestamp: -1,
            signatures: []
        });
    }
    let webhooksCryptoProviderInstance = null;
    /**
     * Lazily instantiate a CryptoProvider instance. This is a stateless object
     * so a singleton can be used here.
     */ function getCryptoProvider() {
        if (!webhooksCryptoProviderInstance) webhooksCryptoProviderInstance = platformFunctions.createDefaultCryptoProvider();
        return webhooksCryptoProviderInstance;
    }
    function prepareOptions(opts) {
        if (!opts) throw new (0, $7dd63d24cadb0282$export$4627d23f26d15ec0)({
            message: 'Options are required'
        });
        const timestamp = Math.floor(opts.timestamp) || Math.floor(Date.now() / 1000);
        const scheme = opts.scheme || signature.EXPECTED_SCHEME;
        const cryptoProvider = opts.cryptoProvider || getCryptoProvider();
        const payloadString = `${timestamp}.${opts.payload}`;
        const generateHeaderString = (signature)=>{
            return `t=${timestamp},${scheme}=${signature}`;
        };
        return Object.assign(Object.assign({}, opts), {
            timestamp: timestamp,
            scheme: scheme,
            cryptoProvider: cryptoProvider,
            payloadString: payloadString,
            generateHeaderString: generateHeaderString
        });
    }
    Webhook.signature = signature;
    return Webhook;
}


// File generated from our OpenAPI spec
const $87a079047d785cdf$export$4e8808c19cff877 = '2025-12-15.clover';
const $87a079047d785cdf$export$26622fd6daa288f = 'clover';




var $e7e21ae886e376fe$exports = {};

$parcel$export($e7e21ae886e376fe$exports, "Apps", () => $e7e21ae886e376fe$export$1ba5735493686b70);
$parcel$export($e7e21ae886e376fe$exports, "Billing", () => $e7e21ae886e376fe$export$156dc96109f460f);
$parcel$export($e7e21ae886e376fe$exports, "BillingPortal", () => $e7e21ae886e376fe$export$daf496b0401253e8);
$parcel$export($e7e21ae886e376fe$exports, "Checkout", () => $e7e21ae886e376fe$export$1f60ba4ec72508a0);
$parcel$export($e7e21ae886e376fe$exports, "Climate", () => $e7e21ae886e376fe$export$de8b4e85901a043d);
$parcel$export($e7e21ae886e376fe$exports, "Entitlements", () => $e7e21ae886e376fe$export$2dd6ceaca38aed5c);
$parcel$export($e7e21ae886e376fe$exports, "FinancialConnections", () => $e7e21ae886e376fe$export$bd7d4ee0fae3520f);
$parcel$export($e7e21ae886e376fe$exports, "Forwarding", () => $e7e21ae886e376fe$export$ae2400c968399c46);
$parcel$export($e7e21ae886e376fe$exports, "Identity", () => $e7e21ae886e376fe$export$544bf02140fa9a77);
$parcel$export($e7e21ae886e376fe$exports, "Issuing", () => $e7e21ae886e376fe$export$f4556e8213269c58);
$parcel$export($e7e21ae886e376fe$exports, "Radar", () => $e7e21ae886e376fe$export$bace472c466fdd25);
$parcel$export($e7e21ae886e376fe$exports, "Reporting", () => $e7e21ae886e376fe$export$a480e00c4abae531);
$parcel$export($e7e21ae886e376fe$exports, "Sigma", () => $e7e21ae886e376fe$export$79e850ed2864d13d);
$parcel$export($e7e21ae886e376fe$exports, "Tax", () => $e7e21ae886e376fe$export$90e19d350e059ba5);
$parcel$export($e7e21ae886e376fe$exports, "Terminal", () => $e7e21ae886e376fe$export$8dd80f06eb58bfe1);
$parcel$export($e7e21ae886e376fe$exports, "TestHelpers", () => $e7e21ae886e376fe$export$33417988280e7310);
$parcel$export($e7e21ae886e376fe$exports, "Treasury", () => $e7e21ae886e376fe$export$202f17a618ffb938);
$parcel$export($e7e21ae886e376fe$exports, "V2", () => $e7e21ae886e376fe$export$9b589fb896e0ad32);
$parcel$export($e7e21ae886e376fe$exports, "Account", () => $62dd35909e7090b5$export$104d3e2565f73818);
$parcel$export($e7e21ae886e376fe$exports, "AccountLinks", () => $63737856f4a5d578$export$2957e9f5c8fc6751);
$parcel$export($e7e21ae886e376fe$exports, "AccountSessions", () => $343cee5d9dd21b48$export$220247f7e334b783);
$parcel$export($e7e21ae886e376fe$exports, "Accounts", () => $62dd35909e7090b5$export$104d3e2565f73818);
$parcel$export($e7e21ae886e376fe$exports, "ApplePayDomains", () => $24e1d8f522b7ca3b$export$20b8bc21d7fe47ce);
$parcel$export($e7e21ae886e376fe$exports, "ApplicationFees", () => $da2a6547b900dd5c$export$6cbeb4144c432637);
$parcel$export($e7e21ae886e376fe$exports, "Balance", () => $4287f0710af86a36$export$276e99f8b64146b2);
$parcel$export($e7e21ae886e376fe$exports, "BalanceSettings", () => $3ade0b644e60acee$export$ac7f7c95f9c7d58d);
$parcel$export($e7e21ae886e376fe$exports, "BalanceTransactions", () => $440a46950d5dfc05$export$99921e59b6ec94b1);
$parcel$export($e7e21ae886e376fe$exports, "Charges", () => $9bebd5b6d50e8a2e$export$c4bff1c28c16a7fa);
$parcel$export($e7e21ae886e376fe$exports, "ConfirmationTokens", () => $a4ee23e0f0b9a547$export$38f73a8adfe17c92);
$parcel$export($e7e21ae886e376fe$exports, "CountrySpecs", () => $6feae837d0b9263a$export$13f7fdaba466b579);
$parcel$export($e7e21ae886e376fe$exports, "Coupons", () => $0e9125aeb4caf44c$export$5bfd1e04f85a73fd);
$parcel$export($e7e21ae886e376fe$exports, "CreditNotes", () => $d47e593b7378befc$export$5f4b8bd087071feb);
$parcel$export($e7e21ae886e376fe$exports, "CustomerSessions", () => $78ffb6919f6c5542$export$abb3331690c12153);
$parcel$export($e7e21ae886e376fe$exports, "Customers", () => $77bdb02d3d46ad03$export$d697df66e097e160);
$parcel$export($e7e21ae886e376fe$exports, "Disputes", () => $05b1491ff5426336$export$e155801aca45aa33);
$parcel$export($e7e21ae886e376fe$exports, "EphemeralKeys", () => $700b1ad27ed10663$export$a6fc4ea6562d8008);
$parcel$export($e7e21ae886e376fe$exports, "Events", () => $292e6a5062f14e15$export$ada873a34909da65);
$parcel$export($e7e21ae886e376fe$exports, "ExchangeRates", () => $7dff4874cc5fc62a$export$b8984eec9de4b7c2);
$parcel$export($e7e21ae886e376fe$exports, "FileLinks", () => $d84731af53088e02$export$e7322491c2f024a7);
$parcel$export($e7e21ae886e376fe$exports, "Files", () => $e359a4f1a87ab575$export$9330ab61a7e5c11b);
$parcel$export($e7e21ae886e376fe$exports, "InvoiceItems", () => $700f4f998ffa1146$export$62428237918915ea);
$parcel$export($e7e21ae886e376fe$exports, "InvoicePayments", () => $ee62b4846ecf9aef$export$d2780499546107ac);
$parcel$export($e7e21ae886e376fe$exports, "InvoiceRenderingTemplates", () => $9c4ab4a319da136f$export$4db6742e6e85c587);
$parcel$export($e7e21ae886e376fe$exports, "Invoices", () => $e787de705a10852e$export$6771d21b060ba156);
$parcel$export($e7e21ae886e376fe$exports, "Mandates", () => $444048d6459d7eed$export$715e30177b02d9f2);
$parcel$export($e7e21ae886e376fe$exports, "OAuth", () => $8f5d48c015916b22$export$79dd73309e90dfd0);
$parcel$export($e7e21ae886e376fe$exports, "PaymentAttemptRecords", () => $acc358825cdd9a7b$export$82cbc172165e95d7);
$parcel$export($e7e21ae886e376fe$exports, "PaymentIntents", () => $a85eedc2941b85a1$export$aa6105e8e42bd89b);
$parcel$export($e7e21ae886e376fe$exports, "PaymentLinks", () => $606a4d25c73e5dde$export$3d12b74173f96106);
$parcel$export($e7e21ae886e376fe$exports, "PaymentMethodConfigurations", () => $1b60c2c17a9fb2f9$export$81c7a7bf02f8e0f7);
$parcel$export($e7e21ae886e376fe$exports, "PaymentMethodDomains", () => $fb1c24ec9549c406$export$e67d97ab27c7afe8);
$parcel$export($e7e21ae886e376fe$exports, "PaymentMethods", () => $53c62d64a6bbd0c6$export$ab218e41b1f3d913);
$parcel$export($e7e21ae886e376fe$exports, "PaymentRecords", () => $1c559286d7ecf75b$export$246dcd951a0f38db);
$parcel$export($e7e21ae886e376fe$exports, "Payouts", () => $ad3cf825ba9a1d01$export$872b8d34b32dd7ed);
$parcel$export($e7e21ae886e376fe$exports, "Plans", () => $ab110c2401da1d59$export$fa027c23da0a12ea);
$parcel$export($e7e21ae886e376fe$exports, "Prices", () => $d81dde8d0add6da2$export$33460e2abaa8d5c4);
$parcel$export($e7e21ae886e376fe$exports, "Products", () => $49496c4253e5a3eb$export$92e44ea1079b9ec6);
$parcel$export($e7e21ae886e376fe$exports, "PromotionCodes", () => $685f0f0d9fb353aa$export$8057bfe8313be655);
$parcel$export($e7e21ae886e376fe$exports, "Quotes", () => $ff427cdc44452ea4$export$d459179d2c3ffa58);
$parcel$export($e7e21ae886e376fe$exports, "Refunds", () => $fa079d99d93f71e8$export$288a1c67e4a6ee20);
$parcel$export($e7e21ae886e376fe$exports, "Reviews", () => $cd8f16d22118c536$export$90a3bc3cf352b893);
$parcel$export($e7e21ae886e376fe$exports, "SetupAttempts", () => $ec69e4375149414d$export$3562a94568b1df7b);
$parcel$export($e7e21ae886e376fe$exports, "SetupIntents", () => $47a0a6136ec692a4$export$434ac1dc49f01e33);
$parcel$export($e7e21ae886e376fe$exports, "ShippingRates", () => $77522ea8f79eb988$export$6e6615fb63746f2a);
$parcel$export($e7e21ae886e376fe$exports, "Sources", () => $a14ad8c918561ffc$export$40467b362aa82ae);
$parcel$export($e7e21ae886e376fe$exports, "SubscriptionItems", () => $44b23b1fae3d136b$export$87896a4d7f73647e);
$parcel$export($e7e21ae886e376fe$exports, "SubscriptionSchedules", () => $6bd29c3d1d507b1f$export$8c7bda97ba598335);
$parcel$export($e7e21ae886e376fe$exports, "Subscriptions", () => $ad5abf01a490c84a$export$d73dcc2e0bdfb5bd);
$parcel$export($e7e21ae886e376fe$exports, "TaxCodes", () => $9091f27345e2aeeb$export$e9743ffc8daab2d3);
$parcel$export($e7e21ae886e376fe$exports, "TaxIds", () => $7e0054e7bd436529$export$762d87534be6b718);
$parcel$export($e7e21ae886e376fe$exports, "TaxRates", () => $3e62a589604688da$export$a1472a7587304615);
$parcel$export($e7e21ae886e376fe$exports, "Tokens", () => $de20950f40b8d1ec$export$8e1e81ac145e31be);
$parcel$export($e7e21ae886e376fe$exports, "Topups", () => $56885fc6cdc18b0c$export$ada7dca29335d106);
$parcel$export($e7e21ae886e376fe$exports, "Transfers", () => $96269ed75ff29288$export$68997731bcbd545c);
$parcel$export($e7e21ae886e376fe$exports, "WebhookEndpoints", () => $20ef02a024905d87$export$8f795df01c573962);
// File generated from our OpenAPI spec
// ResourceNamespace allows you to create nested resources, i.e. `stripe.issuing.cards`.
// It also works recursively, so you could do i.e. `stripe.billing.invoicing.pay`.
function $7c23e0f65c18bdb1$var$ResourceNamespace(stripe, resources) {
    for(const name in resources){
        if (!Object.prototype.hasOwnProperty.call(resources, name)) continue;
        const camelCaseName = name[0].toLowerCase() + name.substring(1);
        const resource = new resources[name](stripe);
        this[camelCaseName] = resource;
    }
}
function $7c23e0f65c18bdb1$export$39180f984d46a93e(namespace, resources) {
    return function(stripe) {
        return new $7c23e0f65c18bdb1$var$ResourceNamespace(stripe, resources);
    };
}


// File generated from our OpenAPI spec

const $5d53e86eef88a496$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $5d53e86eef88a496$export$2957e9f5c8fc6751 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $5d53e86eef88a496$var$stripeMethod({
        method: 'POST',
        fullPath: '/v2/core/account_links'
    })
});


// File generated from our OpenAPI spec

const $74bfc906ff3bb988$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $74bfc906ff3bb988$export$b9e3a6742a74c6b0 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $74bfc906ff3bb988$var$stripeMethod({
        method: 'POST',
        fullPath: '/v2/core/account_tokens'
    }),
    retrieve: $74bfc906ff3bb988$var$stripeMethod({
        method: 'GET',
        fullPath: '/v2/core/account_tokens/{id}'
    })
});


// File generated from our OpenAPI spec

const $c73beb07c8819be5$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $c73beb07c8819be5$export$104d3e2565f73818 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $c73beb07c8819be5$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/financial_connections/accounts/{account}'
    }),
    list: $c73beb07c8819be5$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/financial_connections/accounts',
        methodType: 'list'
    }),
    disconnect: $c73beb07c8819be5$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/financial_connections/accounts/{account}/disconnect'
    }),
    listOwners: $c73beb07c8819be5$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/financial_connections/accounts/{account}/owners',
        methodType: 'list'
    }),
    refresh: $c73beb07c8819be5$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/financial_connections/accounts/{account}/refresh'
    }),
    subscribe: $c73beb07c8819be5$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/financial_connections/accounts/{account}/subscribe'
    }),
    unsubscribe: $c73beb07c8819be5$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/financial_connections/accounts/{account}/unsubscribe'
    })
});


// File generated from our OpenAPI spec

// File generated from our OpenAPI spec

const $69d294574b9bab1d$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $69d294574b9bab1d$export$374a1d548b602b8b = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $69d294574b9bab1d$var$stripeMethod({
        method: 'POST',
        fullPath: '/v2/core/accounts/{account_id}/persons'
    }),
    retrieve: $69d294574b9bab1d$var$stripeMethod({
        method: 'GET',
        fullPath: '/v2/core/accounts/{account_id}/persons/{id}'
    }),
    update: $69d294574b9bab1d$var$stripeMethod({
        method: 'POST',
        fullPath: '/v2/core/accounts/{account_id}/persons/{id}'
    }),
    list: $69d294574b9bab1d$var$stripeMethod({
        method: 'GET',
        fullPath: '/v2/core/accounts/{account_id}/persons',
        methodType: 'list'
    }),
    del: $69d294574b9bab1d$var$stripeMethod({
        method: 'DELETE',
        fullPath: '/v2/core/accounts/{account_id}/persons/{id}'
    })
});


// File generated from our OpenAPI spec

const $8f82a52efa4b34db$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $8f82a52efa4b34db$export$823976d73fc237bc = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $8f82a52efa4b34db$var$stripeMethod({
        method: 'POST',
        fullPath: '/v2/core/accounts/{account_id}/person_tokens'
    }),
    retrieve: $8f82a52efa4b34db$var$stripeMethod({
        method: 'GET',
        fullPath: '/v2/core/accounts/{account_id}/person_tokens/{id}'
    })
});


const $98accc04c45254a3$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $98accc04c45254a3$export$104d3e2565f73818 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    constructor: function(...args) {
        (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).apply(this, args);
        this.persons = new (0, $69d294574b9bab1d$export$374a1d548b602b8b)(...args);
        this.personTokens = new (0, $8f82a52efa4b34db$export$823976d73fc237bc)(...args);
    },
    create: $98accc04c45254a3$var$stripeMethod({
        method: 'POST',
        fullPath: '/v2/core/accounts'
    }),
    retrieve: $98accc04c45254a3$var$stripeMethod({
        method: 'GET',
        fullPath: '/v2/core/accounts/{id}'
    }),
    update: $98accc04c45254a3$var$stripeMethod({
        method: 'POST',
        fullPath: '/v2/core/accounts/{id}'
    }),
    list: $98accc04c45254a3$var$stripeMethod({
        method: 'GET',
        fullPath: '/v2/core/accounts',
        methodType: 'list'
    }),
    close: $98accc04c45254a3$var$stripeMethod({
        method: 'POST',
        fullPath: '/v2/core/accounts/{id}/close'
    })
});


// File generated from our OpenAPI spec

const $20c7522db82e551f$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $20c7522db82e551f$export$24590d03ff21603f = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $20c7522db82e551f$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/entitlements/active_entitlements/{id}'
    }),
    list: $20c7522db82e551f$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/entitlements/active_entitlements',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $ce80880e2fc25be7$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $ce80880e2fc25be7$export$7a76bf180c86084f = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $ce80880e2fc25be7$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/billing/alerts'
    }),
    retrieve: $ce80880e2fc25be7$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/billing/alerts/{id}'
    }),
    list: $ce80880e2fc25be7$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/billing/alerts',
        methodType: 'list'
    }),
    activate: $ce80880e2fc25be7$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/billing/alerts/{id}/activate'
    }),
    archive: $ce80880e2fc25be7$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/billing/alerts/{id}/archive'
    }),
    deactivate: $ce80880e2fc25be7$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/billing/alerts/{id}/deactivate'
    })
});


// File generated from our OpenAPI spec

const $d8e40608964b11d7$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $d8e40608964b11d7$export$20dba3a29c89afa4 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    find: $d8e40608964b11d7$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/tax/associations/find'
    })
});


// File generated from our OpenAPI spec

const $4c2579f3d6107d49$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $4c2579f3d6107d49$export$780b7dfb505106b6 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $4c2579f3d6107d49$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/issuing/authorizations/{authorization}'
    }),
    update: $4c2579f3d6107d49$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/issuing/authorizations/{authorization}'
    }),
    list: $4c2579f3d6107d49$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/issuing/authorizations',
        methodType: 'list'
    }),
    approve: $4c2579f3d6107d49$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/issuing/authorizations/{authorization}/approve'
    }),
    decline: $4c2579f3d6107d49$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/issuing/authorizations/{authorization}/decline'
    })
});


// File generated from our OpenAPI spec

const $4e007f704661b933$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $4e007f704661b933$export$780b7dfb505106b6 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $4e007f704661b933$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/issuing/authorizations'
    }),
    capture: $4e007f704661b933$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/issuing/authorizations/{authorization}/capture'
    }),
    expire: $4e007f704661b933$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/issuing/authorizations/{authorization}/expire'
    }),
    finalizeAmount: $4e007f704661b933$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/issuing/authorizations/{authorization}/finalize_amount'
    }),
    increment: $4e007f704661b933$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/issuing/authorizations/{authorization}/increment'
    }),
    respond: $4e007f704661b933$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/issuing/authorizations/{authorization}/fraud_challenges/respond'
    }),
    reverse: $4e007f704661b933$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/issuing/authorizations/{authorization}/reverse'
    })
});


// File generated from our OpenAPI spec

const $80e1a78921f7d403$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $80e1a78921f7d403$export$1270c16ec3b4f45a = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $80e1a78921f7d403$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/tax/calculations'
    }),
    retrieve: $80e1a78921f7d403$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/tax/calculations/{calculation}'
    }),
    listLineItems: $80e1a78921f7d403$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/tax/calculations/{calculation}/line_items',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $581f87adfc324e85$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $581f87adfc324e85$export$3561884d9c92eedd = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $581f87adfc324e85$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/issuing/cardholders'
    }),
    retrieve: $581f87adfc324e85$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/issuing/cardholders/{cardholder}'
    }),
    update: $581f87adfc324e85$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/issuing/cardholders/{cardholder}'
    }),
    list: $581f87adfc324e85$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/issuing/cardholders',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $2b61e59dc4a9cfee$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $2b61e59dc4a9cfee$export$c8d38e0dcc0f5a1 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $2b61e59dc4a9cfee$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/issuing/cards'
    }),
    retrieve: $2b61e59dc4a9cfee$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/issuing/cards/{card}'
    }),
    update: $2b61e59dc4a9cfee$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/issuing/cards/{card}'
    }),
    list: $2b61e59dc4a9cfee$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/issuing/cards',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $850659383892da5a$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $850659383892da5a$export$c8d38e0dcc0f5a1 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    deliverCard: $850659383892da5a$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/issuing/cards/{card}/shipping/deliver'
    }),
    failCard: $850659383892da5a$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/issuing/cards/{card}/shipping/fail'
    }),
    returnCard: $850659383892da5a$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/issuing/cards/{card}/shipping/return'
    }),
    shipCard: $850659383892da5a$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/issuing/cards/{card}/shipping/ship'
    }),
    submitCard: $850659383892da5a$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/issuing/cards/{card}/shipping/submit'
    })
});


// File generated from our OpenAPI spec

const $79b83f657166f201$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $79b83f657166f201$export$8a7c38bd6e0afaba = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $79b83f657166f201$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/billing_portal/configurations'
    }),
    retrieve: $79b83f657166f201$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/billing_portal/configurations/{configuration}'
    }),
    update: $79b83f657166f201$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/billing_portal/configurations/{configuration}'
    }),
    list: $79b83f657166f201$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/billing_portal/configurations',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $9f6780bf7bbc3dac$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $9f6780bf7bbc3dac$export$8a7c38bd6e0afaba = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $9f6780bf7bbc3dac$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/terminal/configurations'
    }),
    retrieve: $9f6780bf7bbc3dac$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/terminal/configurations/{configuration}'
    }),
    update: $9f6780bf7bbc3dac$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/terminal/configurations/{configuration}'
    }),
    list: $9f6780bf7bbc3dac$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/terminal/configurations',
        methodType: 'list'
    }),
    del: $9f6780bf7bbc3dac$var$stripeMethod({
        method: 'DELETE',
        fullPath: '/v1/terminal/configurations/{configuration}'
    })
});


// File generated from our OpenAPI spec

const $dbebde9096b3109a$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $dbebde9096b3109a$export$38f73a8adfe17c92 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $dbebde9096b3109a$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/confirmation_tokens'
    })
});


// File generated from our OpenAPI spec

const $f975931546337af8$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $f975931546337af8$export$68dad2bdcb5860e6 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $f975931546337af8$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/terminal/connection_tokens'
    })
});


// File generated from our OpenAPI spec

const $f89f7d639bd4575e$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $f89f7d639bd4575e$export$b21e6ea17ccb5e9d = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $f89f7d639bd4575e$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/billing/credit_balance_summary'
    })
});


// File generated from our OpenAPI spec

const $65241b9e44b5b220$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $65241b9e44b5b220$export$9fc7dee76bb3ffe8 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $65241b9e44b5b220$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/billing/credit_balance_transactions/{id}'
    }),
    list: $65241b9e44b5b220$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/billing/credit_balance_transactions',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $a264a7adb6f9729c$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $a264a7adb6f9729c$export$e3e715035bceff1d = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $a264a7adb6f9729c$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/billing/credit_grants'
    }),
    retrieve: $a264a7adb6f9729c$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/billing/credit_grants/{id}'
    }),
    update: $a264a7adb6f9729c$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/billing/credit_grants/{id}'
    }),
    list: $a264a7adb6f9729c$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/billing/credit_grants',
        methodType: 'list'
    }),
    expire: $a264a7adb6f9729c$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/billing/credit_grants/{id}/expire'
    }),
    voidGrant: $a264a7adb6f9729c$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/billing/credit_grants/{id}/void'
    })
});


// File generated from our OpenAPI spec

const $b72a3a8041226bab$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $b72a3a8041226bab$export$2b33e47c4cc267ed = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $b72a3a8041226bab$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/treasury/credit_reversals'
    }),
    retrieve: $b72a3a8041226bab$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/treasury/credit_reversals/{credit_reversal}'
    }),
    list: $b72a3a8041226bab$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/treasury/credit_reversals',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $b1f34bb5043fc322$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $b1f34bb5043fc322$export$d697df66e097e160 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    fundCashBalance: $b1f34bb5043fc322$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/customers/{customer}/fund_cash_balance'
    })
});


// File generated from our OpenAPI spec

const $889ca903e1a983d4$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $889ca903e1a983d4$export$7567f2a6f4cdc0c2 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $889ca903e1a983d4$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/treasury/debit_reversals'
    }),
    retrieve: $889ca903e1a983d4$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/treasury/debit_reversals/{debit_reversal}'
    }),
    list: $889ca903e1a983d4$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/treasury/debit_reversals',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $7c7bdb974a6996ef$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $7c7bdb974a6996ef$export$e155801aca45aa33 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $7c7bdb974a6996ef$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/issuing/disputes'
    }),
    retrieve: $7c7bdb974a6996ef$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/issuing/disputes/{dispute}'
    }),
    update: $7c7bdb974a6996ef$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/issuing/disputes/{dispute}'
    }),
    list: $7c7bdb974a6996ef$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/issuing/disputes',
        methodType: 'list'
    }),
    submit: $7c7bdb974a6996ef$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/issuing/disputes/{dispute}/submit'
    })
});


// File generated from our OpenAPI spec

const $b486ba10ea49d9c0$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $b486ba10ea49d9c0$export$3a0c27d59728c846 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $b486ba10ea49d9c0$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/radar/early_fraud_warnings/{early_fraud_warning}'
    }),
    list: $b486ba10ea49d9c0$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/radar/early_fraud_warnings',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $13be0065d53d50af$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $13be0065d53d50af$export$a98becb95dd01dd = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $13be0065d53d50af$var$stripeMethod({
        method: 'POST',
        fullPath: '/v2/core/event_destinations'
    }),
    retrieve: $13be0065d53d50af$var$stripeMethod({
        method: 'GET',
        fullPath: '/v2/core/event_destinations/{id}'
    }),
    update: $13be0065d53d50af$var$stripeMethod({
        method: 'POST',
        fullPath: '/v2/core/event_destinations/{id}'
    }),
    list: $13be0065d53d50af$var$stripeMethod({
        method: 'GET',
        fullPath: '/v2/core/event_destinations',
        methodType: 'list'
    }),
    del: $13be0065d53d50af$var$stripeMethod({
        method: 'DELETE',
        fullPath: '/v2/core/event_destinations/{id}'
    }),
    disable: $13be0065d53d50af$var$stripeMethod({
        method: 'POST',
        fullPath: '/v2/core/event_destinations/{id}/disable'
    }),
    enable: $13be0065d53d50af$var$stripeMethod({
        method: 'POST',
        fullPath: '/v2/core/event_destinations/{id}/enable'
    }),
    ping: $13be0065d53d50af$var$stripeMethod({
        method: 'POST',
        fullPath: '/v2/core/event_destinations/{id}/ping'
    })
});


// This file is manually maintained

const $e3677164c2d86d9b$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $e3677164c2d86d9b$export$ada873a34909da65 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve (...args) {
        const transformResponseData = (response)=>{
            return this.addFetchRelatedObjectIfNeeded(response);
        };
        return $e3677164c2d86d9b$var$stripeMethod({
            method: 'GET',
            fullPath: '/v2/core/events/{id}',
            transformResponseData: transformResponseData
        }).apply(this, args);
    },
    list (...args) {
        const transformResponseData = (response)=>{
            return Object.assign(Object.assign({}, response), {
                data: response.data.map(this.addFetchRelatedObjectIfNeeded.bind(this))
            });
        };
        return $e3677164c2d86d9b$var$stripeMethod({
            method: 'GET',
            fullPath: '/v2/core/events',
            methodType: 'list',
            transformResponseData: transformResponseData
        }).apply(this, args);
    },
    /**
     * @private
     *
     * For internal use in stripe-node.
     *
     * @param pulledEvent The retrieved event object
     * @returns The retrieved event object with a fetchRelatedObject method,
     * if pulledEvent.related_object is valid (non-null and has a url)
     */ addFetchRelatedObjectIfNeeded (pulledEvent) {
        if (!pulledEvent.related_object || !pulledEvent.related_object.url) return pulledEvent;
        return Object.assign(Object.assign({}, pulledEvent), {
            fetchRelatedObject: ()=>// call stripeMethod with 'this' resource to fetch
                // the related object. 'this' is needed to construct
                // and send the request, but the method spec controls
                // the url endpoint and method, so it doesn't matter
                // that 'this' is an Events resource object here
                $e3677164c2d86d9b$var$stripeMethod({
                    method: 'GET',
                    fullPath: pulledEvent.related_object.url
                }).apply(this, [
                    {
                        stripeContext: pulledEvent.context
                    }
                ])
        });
    }
});


// File generated from our OpenAPI spec

const $ed3ccfe99d187b23$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $ed3ccfe99d187b23$export$617d79dae526d2cf = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $ed3ccfe99d187b23$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/entitlements/features'
    }),
    retrieve: $ed3ccfe99d187b23$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/entitlements/features/{id}'
    }),
    update: $ed3ccfe99d187b23$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/entitlements/features/{id}'
    }),
    list: $ed3ccfe99d187b23$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/entitlements/features',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $858e349f66f471f1$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $858e349f66f471f1$export$90ec7b042c4c4fdc = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $858e349f66f471f1$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/treasury/financial_accounts'
    }),
    retrieve: $858e349f66f471f1$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/treasury/financial_accounts/{financial_account}'
    }),
    update: $858e349f66f471f1$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/treasury/financial_accounts/{financial_account}'
    }),
    list: $858e349f66f471f1$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/treasury/financial_accounts',
        methodType: 'list'
    }),
    close: $858e349f66f471f1$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/treasury/financial_accounts/{financial_account}/close'
    }),
    retrieveFeatures: $858e349f66f471f1$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/treasury/financial_accounts/{financial_account}/features'
    }),
    updateFeatures: $858e349f66f471f1$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/treasury/financial_accounts/{financial_account}/features'
    })
});


// File generated from our OpenAPI spec

const $14ad55f0258f4e30$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $14ad55f0258f4e30$export$fabf99bf25efd32d = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    fail: $14ad55f0258f4e30$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/treasury/inbound_transfers/{id}/fail'
    }),
    returnInboundTransfer: $14ad55f0258f4e30$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/treasury/inbound_transfers/{id}/return'
    }),
    succeed: $14ad55f0258f4e30$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/treasury/inbound_transfers/{id}/succeed'
    })
});


// File generated from our OpenAPI spec

const $374823ee9177a387$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $374823ee9177a387$export$fabf99bf25efd32d = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $374823ee9177a387$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/treasury/inbound_transfers'
    }),
    retrieve: $374823ee9177a387$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/treasury/inbound_transfers/{id}'
    }),
    list: $374823ee9177a387$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/treasury/inbound_transfers',
        methodType: 'list'
    }),
    cancel: $374823ee9177a387$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/treasury/inbound_transfers/{inbound_transfer}/cancel'
    })
});


// File generated from our OpenAPI spec

const $469bcfdeab4646dd$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $469bcfdeab4646dd$export$2dceb80d0af9bf60 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $469bcfdeab4646dd$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/terminal/locations'
    }),
    retrieve: $469bcfdeab4646dd$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/terminal/locations/{location}'
    }),
    update: $469bcfdeab4646dd$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/terminal/locations/{location}'
    }),
    list: $469bcfdeab4646dd$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/terminal/locations',
        methodType: 'list'
    }),
    del: $469bcfdeab4646dd$var$stripeMethod({
        method: 'DELETE',
        fullPath: '/v1/terminal/locations/{location}'
    })
});


// File generated from our OpenAPI spec

const $f5d3f13cb2747717$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $f5d3f13cb2747717$export$b7f88946c8b3227d = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $f5d3f13cb2747717$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/billing/meter_event_adjustments'
    })
});


// File generated from our OpenAPI spec

const $e960f0b831740391$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $e960f0b831740391$export$b7f88946c8b3227d = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $e960f0b831740391$var$stripeMethod({
        method: 'POST',
        fullPath: '/v2/billing/meter_event_adjustments'
    })
});


// File generated from our OpenAPI spec

const $a30d71604e4190cb$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $a30d71604e4190cb$export$65b0325d56fce31f = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $a30d71604e4190cb$var$stripeMethod({
        method: 'POST',
        fullPath: '/v2/billing/meter_event_session'
    })
});


// File generated from our OpenAPI spec

const $a38e1b00c98bb876$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $a38e1b00c98bb876$export$2944b2107bc37e07 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $a38e1b00c98bb876$var$stripeMethod({
        method: 'POST',
        fullPath: '/v2/billing/meter_event_stream',
        host: 'meter-events.stripe.com'
    })
});


// File generated from our OpenAPI spec

const $f73f6c24e30ee2c8$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $f73f6c24e30ee2c8$export$2f67a09251226a38 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $f73f6c24e30ee2c8$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/billing/meter_events'
    })
});


// File generated from our OpenAPI spec

const $a33dc145ef154dfc$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $a33dc145ef154dfc$export$2f67a09251226a38 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $a33dc145ef154dfc$var$stripeMethod({
        method: 'POST',
        fullPath: '/v2/billing/meter_events'
    })
});


// File generated from our OpenAPI spec

const $c9b4a846220a9b64$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $c9b4a846220a9b64$export$e208a249bf08a830 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $c9b4a846220a9b64$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/billing/meters'
    }),
    retrieve: $c9b4a846220a9b64$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/billing/meters/{id}'
    }),
    update: $c9b4a846220a9b64$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/billing/meters/{id}'
    }),
    list: $c9b4a846220a9b64$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/billing/meters',
        methodType: 'list'
    }),
    deactivate: $c9b4a846220a9b64$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/billing/meters/{id}/deactivate'
    }),
    listEventSummaries: $c9b4a846220a9b64$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/billing/meters/{id}/event_summaries',
        methodType: 'list'
    }),
    reactivate: $c9b4a846220a9b64$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/billing/meters/{id}/reactivate'
    })
});


// File generated from our OpenAPI spec

const $a8ef9a8151ea1ed2$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $a8ef9a8151ea1ed2$export$5045cdd5612307eb = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $a8ef9a8151ea1ed2$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/terminal/onboarding_links'
    })
});


// File generated from our OpenAPI spec

const $16b5a758f93ae19d$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $16b5a758f93ae19d$export$ed0df17bf864fd7b = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $16b5a758f93ae19d$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/climate/orders'
    }),
    retrieve: $16b5a758f93ae19d$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/climate/orders/{order}'
    }),
    update: $16b5a758f93ae19d$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/climate/orders/{order}'
    }),
    list: $16b5a758f93ae19d$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/climate/orders',
        methodType: 'list'
    }),
    cancel: $16b5a758f93ae19d$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/climate/orders/{order}/cancel'
    })
});


// File generated from our OpenAPI spec

const $a509b6b36cc99f34$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $a509b6b36cc99f34$export$52701ee3b8eab96c = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    update: $a509b6b36cc99f34$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/treasury/outbound_payments/{id}'
    }),
    fail: $a509b6b36cc99f34$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/treasury/outbound_payments/{id}/fail'
    }),
    post: $a509b6b36cc99f34$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/treasury/outbound_payments/{id}/post'
    }),
    returnOutboundPayment: $a509b6b36cc99f34$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/treasury/outbound_payments/{id}/return'
    })
});


// File generated from our OpenAPI spec

const $aef1f67efbe29365$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $aef1f67efbe29365$export$52701ee3b8eab96c = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $aef1f67efbe29365$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/treasury/outbound_payments'
    }),
    retrieve: $aef1f67efbe29365$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/treasury/outbound_payments/{id}'
    }),
    list: $aef1f67efbe29365$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/treasury/outbound_payments',
        methodType: 'list'
    }),
    cancel: $aef1f67efbe29365$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/treasury/outbound_payments/{id}/cancel'
    })
});


// File generated from our OpenAPI spec

const $752631b5b1d96fbd$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $752631b5b1d96fbd$export$f385dd25bcef3dcc = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    update: $752631b5b1d96fbd$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/treasury/outbound_transfers/{outbound_transfer}'
    }),
    fail: $752631b5b1d96fbd$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/treasury/outbound_transfers/{outbound_transfer}/fail'
    }),
    post: $752631b5b1d96fbd$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/treasury/outbound_transfers/{outbound_transfer}/post'
    }),
    returnOutboundTransfer: $752631b5b1d96fbd$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/treasury/outbound_transfers/{outbound_transfer}/return'
    })
});


// File generated from our OpenAPI spec

const $cd6001fafcc61b8a$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $cd6001fafcc61b8a$export$f385dd25bcef3dcc = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $cd6001fafcc61b8a$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/treasury/outbound_transfers'
    }),
    retrieve: $cd6001fafcc61b8a$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/treasury/outbound_transfers/{outbound_transfer}'
    }),
    list: $cd6001fafcc61b8a$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/treasury/outbound_transfers',
        methodType: 'list'
    }),
    cancel: $cd6001fafcc61b8a$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/treasury/outbound_transfers/{outbound_transfer}/cancel'
    })
});


// File generated from our OpenAPI spec

const $e339b8e7d0b952f3$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $e339b8e7d0b952f3$export$668962564dcec028 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $e339b8e7d0b952f3$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/issuing/personalization_designs'
    }),
    retrieve: $e339b8e7d0b952f3$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/issuing/personalization_designs/{personalization_design}'
    }),
    update: $e339b8e7d0b952f3$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/issuing/personalization_designs/{personalization_design}'
    }),
    list: $e339b8e7d0b952f3$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/issuing/personalization_designs',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $e0a3537df5a99ee4$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $e0a3537df5a99ee4$export$668962564dcec028 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    activate: $e0a3537df5a99ee4$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/issuing/personalization_designs/{personalization_design}/activate'
    }),
    deactivate: $e0a3537df5a99ee4$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/issuing/personalization_designs/{personalization_design}/deactivate'
    }),
    reject: $e0a3537df5a99ee4$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/issuing/personalization_designs/{personalization_design}/reject'
    })
});


// File generated from our OpenAPI spec

const $695f8659cc248247$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $695f8659cc248247$export$7e925fe8086f6f18 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $695f8659cc248247$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/issuing/physical_bundles/{physical_bundle}'
    }),
    list: $695f8659cc248247$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/issuing/physical_bundles',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $2c0ff310d6fae3fc$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $2c0ff310d6fae3fc$export$92e44ea1079b9ec6 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $2c0ff310d6fae3fc$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/climate/products/{product}'
    }),
    list: $2c0ff310d6fae3fc$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/climate/products',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $6060543d786c29f7$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $6060543d786c29f7$export$df935bc2312a795f = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $6060543d786c29f7$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/terminal/readers'
    }),
    retrieve: $6060543d786c29f7$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/terminal/readers/{reader}'
    }),
    update: $6060543d786c29f7$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/terminal/readers/{reader}'
    }),
    list: $6060543d786c29f7$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/terminal/readers',
        methodType: 'list'
    }),
    del: $6060543d786c29f7$var$stripeMethod({
        method: 'DELETE',
        fullPath: '/v1/terminal/readers/{reader}'
    }),
    cancelAction: $6060543d786c29f7$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/terminal/readers/{reader}/cancel_action'
    }),
    collectInputs: $6060543d786c29f7$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/terminal/readers/{reader}/collect_inputs'
    }),
    collectPaymentMethod: $6060543d786c29f7$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/terminal/readers/{reader}/collect_payment_method'
    }),
    confirmPaymentIntent: $6060543d786c29f7$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/terminal/readers/{reader}/confirm_payment_intent'
    }),
    processPaymentIntent: $6060543d786c29f7$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/terminal/readers/{reader}/process_payment_intent'
    }),
    processSetupIntent: $6060543d786c29f7$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/terminal/readers/{reader}/process_setup_intent'
    }),
    refundPayment: $6060543d786c29f7$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/terminal/readers/{reader}/refund_payment'
    }),
    setReaderDisplay: $6060543d786c29f7$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/terminal/readers/{reader}/set_reader_display'
    })
});


// File generated from our OpenAPI spec

const $c7cea4436b6a029b$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $c7cea4436b6a029b$export$df935bc2312a795f = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    presentPaymentMethod: $c7cea4436b6a029b$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/terminal/readers/{reader}/present_payment_method'
    }),
    succeedInputCollection: $c7cea4436b6a029b$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/terminal/readers/{reader}/succeed_input_collection'
    }),
    timeoutInputCollection: $c7cea4436b6a029b$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/terminal/readers/{reader}/timeout_input_collection'
    })
});


// File generated from our OpenAPI spec

const $8c7a1a0bb8a7c598$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $8c7a1a0bb8a7c598$export$b3c98ef9e3b034ea = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $8c7a1a0bb8a7c598$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/treasury/received_credits'
    })
});


// File generated from our OpenAPI spec

const $4a4bc7c7f73315af$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $4a4bc7c7f73315af$export$b3c98ef9e3b034ea = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $4a4bc7c7f73315af$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/treasury/received_credits/{id}'
    }),
    list: $4a4bc7c7f73315af$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/treasury/received_credits',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $92a0e7f778e809cd$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $92a0e7f778e809cd$export$93656d040691bb72 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $92a0e7f778e809cd$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/treasury/received_debits'
    })
});


// File generated from our OpenAPI spec

const $ce560e8d1da3c5a1$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $ce560e8d1da3c5a1$export$93656d040691bb72 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $ce560e8d1da3c5a1$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/treasury/received_debits/{id}'
    }),
    list: $ce560e8d1da3c5a1$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/treasury/received_debits',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $5c0f8e7773d5ffd8$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $5c0f8e7773d5ffd8$export$288a1c67e4a6ee20 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    expire: $5c0f8e7773d5ffd8$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/refunds/{refund}/expire'
    })
});


// File generated from our OpenAPI spec

const $90c2c1a396933167$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $90c2c1a396933167$export$35e91f0e79fa7752 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $90c2c1a396933167$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/tax/registrations'
    }),
    retrieve: $90c2c1a396933167$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/tax/registrations/{id}'
    }),
    update: $90c2c1a396933167$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/tax/registrations/{id}'
    }),
    list: $90c2c1a396933167$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/tax/registrations',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $fe7143913d869b6c$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $fe7143913d869b6c$export$f215120ca5e88069 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $fe7143913d869b6c$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/reporting/report_runs'
    }),
    retrieve: $fe7143913d869b6c$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/reporting/report_runs/{report_run}'
    }),
    list: $fe7143913d869b6c$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/reporting/report_runs',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $acd48eef5ef608b0$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $acd48eef5ef608b0$export$c74cb6e60557c635 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $acd48eef5ef608b0$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/reporting/report_types/{report_type}'
    }),
    list: $acd48eef5ef608b0$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/reporting/report_types',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $c12f13521aaadf17$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $c12f13521aaadf17$export$9840c1777639b595 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $c12f13521aaadf17$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/forwarding/requests'
    }),
    retrieve: $c12f13521aaadf17$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/forwarding/requests/{id}'
    }),
    list: $c12f13521aaadf17$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/forwarding/requests',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $b25cdf2edfa7f0c3$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $b25cdf2edfa7f0c3$export$22d5e60e46830654 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $b25cdf2edfa7f0c3$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/sigma/scheduled_query_runs/{scheduled_query_run}'
    }),
    list: $b25cdf2edfa7f0c3$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/sigma/scheduled_query_runs',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $7a895120c2658ddf$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $7a895120c2658ddf$export$d461bab147da6da1 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $7a895120c2658ddf$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/apps/secrets'
    }),
    list: $7a895120c2658ddf$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/apps/secrets',
        methodType: 'list'
    }),
    deleteWhere: $7a895120c2658ddf$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/apps/secrets/delete'
    }),
    find: $7a895120c2658ddf$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/apps/secrets/find'
    })
});


// File generated from our OpenAPI spec

const $e2cc8c5c8fbbc1a1$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $e2cc8c5c8fbbc1a1$export$c8d7e81b9a544c06 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $e2cc8c5c8fbbc1a1$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/billing_portal/sessions'
    })
});


// File generated from our OpenAPI spec

const $535fce1f92491d22$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $535fce1f92491d22$export$c8d7e81b9a544c06 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $535fce1f92491d22$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/checkout/sessions'
    }),
    retrieve: $535fce1f92491d22$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/checkout/sessions/{session}'
    }),
    update: $535fce1f92491d22$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/checkout/sessions/{session}'
    }),
    list: $535fce1f92491d22$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/checkout/sessions',
        methodType: 'list'
    }),
    expire: $535fce1f92491d22$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/checkout/sessions/{session}/expire'
    }),
    listLineItems: $535fce1f92491d22$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/checkout/sessions/{session}/line_items',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $95817d5d9b348806$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $95817d5d9b348806$export$c8d7e81b9a544c06 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $95817d5d9b348806$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/financial_connections/sessions'
    }),
    retrieve: $95817d5d9b348806$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/financial_connections/sessions/{session}'
    })
});


// File generated from our OpenAPI spec

const $9faf0c42eb7670ed$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $9faf0c42eb7670ed$export$c72f6eaae7b9adff = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $9faf0c42eb7670ed$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/tax/settings'
    }),
    update: $9faf0c42eb7670ed$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/tax/settings'
    })
});


// File generated from our OpenAPI spec

const $28a6584905e943d1$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $28a6584905e943d1$export$d284c91060f4524e = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $28a6584905e943d1$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/climate/suppliers/{supplier}'
    }),
    list: $28a6584905e943d1$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/climate/suppliers',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $efebdf5bccbd09b2$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $efebdf5bccbd09b2$export$d7ba70c86937ac5b = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $efebdf5bccbd09b2$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/test_clocks'
    }),
    retrieve: $efebdf5bccbd09b2$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/test_helpers/test_clocks/{test_clock}'
    }),
    list: $efebdf5bccbd09b2$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/test_helpers/test_clocks',
        methodType: 'list'
    }),
    del: $efebdf5bccbd09b2$var$stripeMethod({
        method: 'DELETE',
        fullPath: '/v1/test_helpers/test_clocks/{test_clock}'
    }),
    advance: $efebdf5bccbd09b2$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/test_clocks/{test_clock}/advance'
    })
});


// File generated from our OpenAPI spec

const $d6f6c63465c03d5b$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $d6f6c63465c03d5b$export$8e1e81ac145e31be = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $d6f6c63465c03d5b$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/issuing/tokens/{token}'
    }),
    update: $d6f6c63465c03d5b$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/issuing/tokens/{token}'
    }),
    list: $d6f6c63465c03d5b$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/issuing/tokens',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $0ee46bfaf17d9f92$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $0ee46bfaf17d9f92$export$62ca4dd76ac545f5 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $0ee46bfaf17d9f92$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/treasury/transaction_entries/{id}'
    }),
    list: $0ee46bfaf17d9f92$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/treasury/transaction_entries',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $3d3c832d3c97d345$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $3d3c832d3c97d345$export$7d08f46ba5d226c9 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $3d3c832d3c97d345$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/financial_connections/transactions/{transaction}'
    }),
    list: $3d3c832d3c97d345$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/financial_connections/transactions',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $1165907de692e9db$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $1165907de692e9db$export$7d08f46ba5d226c9 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $1165907de692e9db$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/issuing/transactions/{transaction}'
    }),
    update: $1165907de692e9db$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/issuing/transactions/{transaction}'
    }),
    list: $1165907de692e9db$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/issuing/transactions',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $6b2bc9976739e0eb$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $6b2bc9976739e0eb$export$7d08f46ba5d226c9 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $6b2bc9976739e0eb$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/tax/transactions/{transaction}'
    }),
    createFromCalculation: $6b2bc9976739e0eb$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/tax/transactions/create_from_calculation'
    }),
    createReversal: $6b2bc9976739e0eb$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/tax/transactions/create_reversal'
    }),
    listLineItems: $6b2bc9976739e0eb$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/tax/transactions/{transaction}/line_items',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $902d1e2539342e28$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $902d1e2539342e28$export$7d08f46ba5d226c9 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    createForceCapture: $902d1e2539342e28$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/issuing/transactions/create_force_capture'
    }),
    createUnlinkedRefund: $902d1e2539342e28$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/issuing/transactions/create_unlinked_refund'
    }),
    refund: $902d1e2539342e28$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/test_helpers/issuing/transactions/{transaction}/refund'
    })
});


// File generated from our OpenAPI spec

const $faa2fc635c7ae2af$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $faa2fc635c7ae2af$export$7d08f46ba5d226c9 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $faa2fc635c7ae2af$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/treasury/transactions/{id}'
    }),
    list: $faa2fc635c7ae2af$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/treasury/transactions',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $9269811bf9e71b8a$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $9269811bf9e71b8a$export$82a31c0f8bcbcfa7 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $9269811bf9e71b8a$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/radar/value_list_items'
    }),
    retrieve: $9269811bf9e71b8a$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/radar/value_list_items/{item}'
    }),
    list: $9269811bf9e71b8a$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/radar/value_list_items',
        methodType: 'list'
    }),
    del: $9269811bf9e71b8a$var$stripeMethod({
        method: 'DELETE',
        fullPath: '/v1/radar/value_list_items/{item}'
    })
});


// File generated from our OpenAPI spec

const $57584bc717476302$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $57584bc717476302$export$4a70a1c1d396d5d6 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $57584bc717476302$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/radar/value_lists'
    }),
    retrieve: $57584bc717476302$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/radar/value_lists/{value_list}'
    }),
    update: $57584bc717476302$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/radar/value_lists/{value_list}'
    }),
    list: $57584bc717476302$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/radar/value_lists',
        methodType: 'list'
    }),
    del: $57584bc717476302$var$stripeMethod({
        method: 'DELETE',
        fullPath: '/v1/radar/value_lists/{value_list}'
    })
});


// File generated from our OpenAPI spec

const $d9586ef04643fb77$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $d9586ef04643fb77$export$75c63648bd0f8573 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $d9586ef04643fb77$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/identity/verification_reports/{report}'
    }),
    list: $d9586ef04643fb77$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/identity/verification_reports',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $24f253ac123711bf$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $24f253ac123711bf$export$d15e2d602fc5b4fe = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $24f253ac123711bf$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/identity/verification_sessions'
    }),
    retrieve: $24f253ac123711bf$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/identity/verification_sessions/{session}'
    }),
    update: $24f253ac123711bf$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/identity/verification_sessions/{session}'
    }),
    list: $24f253ac123711bf$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/identity/verification_sessions',
        methodType: 'list'
    }),
    cancel: $24f253ac123711bf$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/identity/verification_sessions/{session}/cancel'
    }),
    redact: $24f253ac123711bf$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/identity/verification_sessions/{session}/redact'
    })
});


// File generated from our OpenAPI spec

const $62dd35909e7090b5$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $62dd35909e7090b5$export$104d3e2565f73818 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $62dd35909e7090b5$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/accounts'
    }),
    retrieve (id, ...args) {
        // No longer allow an api key to be passed as the first string to this function due to ambiguity between
        // old account ids and api keys. To request the account for an api key, send null as the id
        if (typeof id === 'string') return $62dd35909e7090b5$var$stripeMethod({
            method: 'GET',
            fullPath: '/v1/accounts/{id}'
        }).apply(this, [
            id,
            ...args
        ]);
        else {
            if (id === null || id === undefined) // Remove id as stripeMethod would complain of unexpected argument
            [].shift.apply([
                id,
                ...args
            ]);
            return $62dd35909e7090b5$var$stripeMethod({
                method: 'GET',
                fullPath: '/v1/account'
            }).apply(this, [
                id,
                ...args
            ]);
        }
    },
    update: $62dd35909e7090b5$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/accounts/{account}'
    }),
    list: $62dd35909e7090b5$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/accounts',
        methodType: 'list'
    }),
    del: $62dd35909e7090b5$var$stripeMethod({
        method: 'DELETE',
        fullPath: '/v1/accounts/{account}'
    }),
    createExternalAccount: $62dd35909e7090b5$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/accounts/{account}/external_accounts'
    }),
    createLoginLink: $62dd35909e7090b5$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/accounts/{account}/login_links'
    }),
    createPerson: $62dd35909e7090b5$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/accounts/{account}/persons'
    }),
    deleteExternalAccount: $62dd35909e7090b5$var$stripeMethod({
        method: 'DELETE',
        fullPath: '/v1/accounts/{account}/external_accounts/{id}'
    }),
    deletePerson: $62dd35909e7090b5$var$stripeMethod({
        method: 'DELETE',
        fullPath: '/v1/accounts/{account}/persons/{person}'
    }),
    listCapabilities: $62dd35909e7090b5$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/accounts/{account}/capabilities',
        methodType: 'list'
    }),
    listExternalAccounts: $62dd35909e7090b5$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/accounts/{account}/external_accounts',
        methodType: 'list'
    }),
    listPersons: $62dd35909e7090b5$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/accounts/{account}/persons',
        methodType: 'list'
    }),
    reject: $62dd35909e7090b5$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/accounts/{account}/reject'
    }),
    retrieveCurrent: $62dd35909e7090b5$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/account'
    }),
    retrieveCapability: $62dd35909e7090b5$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/accounts/{account}/capabilities/{capability}'
    }),
    retrieveExternalAccount: $62dd35909e7090b5$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/accounts/{account}/external_accounts/{id}'
    }),
    retrievePerson: $62dd35909e7090b5$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/accounts/{account}/persons/{person}'
    }),
    updateCapability: $62dd35909e7090b5$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/accounts/{account}/capabilities/{capability}'
    }),
    updateExternalAccount: $62dd35909e7090b5$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/accounts/{account}/external_accounts/{id}'
    }),
    updatePerson: $62dd35909e7090b5$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/accounts/{account}/persons/{person}'
    })
});


// File generated from our OpenAPI spec

const $63737856f4a5d578$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $63737856f4a5d578$export$2957e9f5c8fc6751 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $63737856f4a5d578$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/account_links'
    })
});


// File generated from our OpenAPI spec

const $343cee5d9dd21b48$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $343cee5d9dd21b48$export$220247f7e334b783 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $343cee5d9dd21b48$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/account_sessions'
    })
});


// File generated from our OpenAPI spec

const $24e1d8f522b7ca3b$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $24e1d8f522b7ca3b$export$20b8bc21d7fe47ce = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $24e1d8f522b7ca3b$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/apple_pay/domains'
    }),
    retrieve: $24e1d8f522b7ca3b$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/apple_pay/domains/{domain}'
    }),
    list: $24e1d8f522b7ca3b$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/apple_pay/domains',
        methodType: 'list'
    }),
    del: $24e1d8f522b7ca3b$var$stripeMethod({
        method: 'DELETE',
        fullPath: '/v1/apple_pay/domains/{domain}'
    })
});


// File generated from our OpenAPI spec

const $da2a6547b900dd5c$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $da2a6547b900dd5c$export$6cbeb4144c432637 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $da2a6547b900dd5c$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/application_fees/{id}'
    }),
    list: $da2a6547b900dd5c$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/application_fees',
        methodType: 'list'
    }),
    createRefund: $da2a6547b900dd5c$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/application_fees/{id}/refunds'
    }),
    listRefunds: $da2a6547b900dd5c$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/application_fees/{id}/refunds',
        methodType: 'list'
    }),
    retrieveRefund: $da2a6547b900dd5c$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/application_fees/{fee}/refunds/{id}'
    }),
    updateRefund: $da2a6547b900dd5c$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/application_fees/{fee}/refunds/{id}'
    })
});


// File generated from our OpenAPI spec

const $4287f0710af86a36$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $4287f0710af86a36$export$276e99f8b64146b2 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $4287f0710af86a36$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/balance'
    })
});


// File generated from our OpenAPI spec

const $3ade0b644e60acee$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $3ade0b644e60acee$export$ac7f7c95f9c7d58d = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $3ade0b644e60acee$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/balance_settings'
    }),
    update: $3ade0b644e60acee$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/balance_settings'
    })
});


// File generated from our OpenAPI spec

const $440a46950d5dfc05$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $440a46950d5dfc05$export$99921e59b6ec94b1 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $440a46950d5dfc05$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/balance_transactions/{id}'
    }),
    list: $440a46950d5dfc05$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/balance_transactions',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $9bebd5b6d50e8a2e$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $9bebd5b6d50e8a2e$export$c4bff1c28c16a7fa = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $9bebd5b6d50e8a2e$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/charges'
    }),
    retrieve: $9bebd5b6d50e8a2e$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/charges/{charge}'
    }),
    update: $9bebd5b6d50e8a2e$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/charges/{charge}'
    }),
    list: $9bebd5b6d50e8a2e$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/charges',
        methodType: 'list'
    }),
    capture: $9bebd5b6d50e8a2e$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/charges/{charge}/capture'
    }),
    search: $9bebd5b6d50e8a2e$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/charges/search',
        methodType: 'search'
    })
});


// File generated from our OpenAPI spec

const $a4ee23e0f0b9a547$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $a4ee23e0f0b9a547$export$38f73a8adfe17c92 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $a4ee23e0f0b9a547$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/confirmation_tokens/{confirmation_token}'
    })
});


// File generated from our OpenAPI spec

const $6feae837d0b9263a$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $6feae837d0b9263a$export$13f7fdaba466b579 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $6feae837d0b9263a$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/country_specs/{country}'
    }),
    list: $6feae837d0b9263a$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/country_specs',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $0e9125aeb4caf44c$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $0e9125aeb4caf44c$export$5bfd1e04f85a73fd = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $0e9125aeb4caf44c$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/coupons'
    }),
    retrieve: $0e9125aeb4caf44c$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/coupons/{coupon}'
    }),
    update: $0e9125aeb4caf44c$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/coupons/{coupon}'
    }),
    list: $0e9125aeb4caf44c$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/coupons',
        methodType: 'list'
    }),
    del: $0e9125aeb4caf44c$var$stripeMethod({
        method: 'DELETE',
        fullPath: '/v1/coupons/{coupon}'
    })
});


// File generated from our OpenAPI spec

const $d47e593b7378befc$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $d47e593b7378befc$export$5f4b8bd087071feb = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $d47e593b7378befc$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/credit_notes'
    }),
    retrieve: $d47e593b7378befc$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/credit_notes/{id}'
    }),
    update: $d47e593b7378befc$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/credit_notes/{id}'
    }),
    list: $d47e593b7378befc$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/credit_notes',
        methodType: 'list'
    }),
    listLineItems: $d47e593b7378befc$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/credit_notes/{credit_note}/lines',
        methodType: 'list'
    }),
    listPreviewLineItems: $d47e593b7378befc$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/credit_notes/preview/lines',
        methodType: 'list'
    }),
    preview: $d47e593b7378befc$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/credit_notes/preview'
    }),
    voidCreditNote: $d47e593b7378befc$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/credit_notes/{id}/void'
    })
});


// File generated from our OpenAPI spec

const $78ffb6919f6c5542$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $78ffb6919f6c5542$export$abb3331690c12153 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $78ffb6919f6c5542$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/customer_sessions'
    })
});


// File generated from our OpenAPI spec

const $77bdb02d3d46ad03$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $77bdb02d3d46ad03$export$d697df66e097e160 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $77bdb02d3d46ad03$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/customers'
    }),
    retrieve: $77bdb02d3d46ad03$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/customers/{customer}'
    }),
    update: $77bdb02d3d46ad03$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/customers/{customer}'
    }),
    list: $77bdb02d3d46ad03$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/customers',
        methodType: 'list'
    }),
    del: $77bdb02d3d46ad03$var$stripeMethod({
        method: 'DELETE',
        fullPath: '/v1/customers/{customer}'
    }),
    createBalanceTransaction: $77bdb02d3d46ad03$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/customers/{customer}/balance_transactions'
    }),
    createFundingInstructions: $77bdb02d3d46ad03$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/customers/{customer}/funding_instructions'
    }),
    createSource: $77bdb02d3d46ad03$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/customers/{customer}/sources'
    }),
    createTaxId: $77bdb02d3d46ad03$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/customers/{customer}/tax_ids'
    }),
    deleteDiscount: $77bdb02d3d46ad03$var$stripeMethod({
        method: 'DELETE',
        fullPath: '/v1/customers/{customer}/discount'
    }),
    deleteSource: $77bdb02d3d46ad03$var$stripeMethod({
        method: 'DELETE',
        fullPath: '/v1/customers/{customer}/sources/{id}'
    }),
    deleteTaxId: $77bdb02d3d46ad03$var$stripeMethod({
        method: 'DELETE',
        fullPath: '/v1/customers/{customer}/tax_ids/{id}'
    }),
    listBalanceTransactions: $77bdb02d3d46ad03$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/customers/{customer}/balance_transactions',
        methodType: 'list'
    }),
    listCashBalanceTransactions: $77bdb02d3d46ad03$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/customers/{customer}/cash_balance_transactions',
        methodType: 'list'
    }),
    listPaymentMethods: $77bdb02d3d46ad03$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/customers/{customer}/payment_methods',
        methodType: 'list'
    }),
    listSources: $77bdb02d3d46ad03$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/customers/{customer}/sources',
        methodType: 'list'
    }),
    listTaxIds: $77bdb02d3d46ad03$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/customers/{customer}/tax_ids',
        methodType: 'list'
    }),
    retrieveBalanceTransaction: $77bdb02d3d46ad03$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/customers/{customer}/balance_transactions/{transaction}'
    }),
    retrieveCashBalance: $77bdb02d3d46ad03$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/customers/{customer}/cash_balance'
    }),
    retrieveCashBalanceTransaction: $77bdb02d3d46ad03$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/customers/{customer}/cash_balance_transactions/{transaction}'
    }),
    retrievePaymentMethod: $77bdb02d3d46ad03$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/customers/{customer}/payment_methods/{payment_method}'
    }),
    retrieveSource: $77bdb02d3d46ad03$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/customers/{customer}/sources/{id}'
    }),
    retrieveTaxId: $77bdb02d3d46ad03$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/customers/{customer}/tax_ids/{id}'
    }),
    search: $77bdb02d3d46ad03$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/customers/search',
        methodType: 'search'
    }),
    updateBalanceTransaction: $77bdb02d3d46ad03$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/customers/{customer}/balance_transactions/{transaction}'
    }),
    updateCashBalance: $77bdb02d3d46ad03$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/customers/{customer}/cash_balance'
    }),
    updateSource: $77bdb02d3d46ad03$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/customers/{customer}/sources/{id}'
    }),
    verifySource: $77bdb02d3d46ad03$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/customers/{customer}/sources/{id}/verify'
    })
});


// File generated from our OpenAPI spec

const $05b1491ff5426336$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $05b1491ff5426336$export$e155801aca45aa33 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $05b1491ff5426336$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/disputes/{dispute}'
    }),
    update: $05b1491ff5426336$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/disputes/{dispute}'
    }),
    list: $05b1491ff5426336$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/disputes',
        methodType: 'list'
    }),
    close: $05b1491ff5426336$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/disputes/{dispute}/close'
    })
});


// File generated from our OpenAPI spec

const $700b1ad27ed10663$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $700b1ad27ed10663$export$a6fc4ea6562d8008 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $700b1ad27ed10663$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/ephemeral_keys',
        validator: (data, options)=>{
            if (!options.headers || !options.headers['Stripe-Version']) throw new Error('Passing apiVersion in a separate options hash is required to create an ephemeral key. See https://stripe.com/docs/api/versioning?lang=node');
        }
    }),
    del: $700b1ad27ed10663$var$stripeMethod({
        method: 'DELETE',
        fullPath: '/v1/ephemeral_keys/{key}'
    })
});


// File generated from our OpenAPI spec

const $292e6a5062f14e15$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $292e6a5062f14e15$export$ada873a34909da65 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $292e6a5062f14e15$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/events/{id}'
    }),
    list: $292e6a5062f14e15$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/events',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $7dff4874cc5fc62a$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $7dff4874cc5fc62a$export$b8984eec9de4b7c2 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $7dff4874cc5fc62a$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/exchange_rates/{rate_id}'
    }),
    list: $7dff4874cc5fc62a$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/exchange_rates',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $d84731af53088e02$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $d84731af53088e02$export$e7322491c2f024a7 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $d84731af53088e02$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/file_links'
    }),
    retrieve: $d84731af53088e02$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/file_links/{link}'
    }),
    update: $d84731af53088e02$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/file_links/{link}'
    }),
    list: $d84731af53088e02$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/file_links',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

// Method for formatting HTTP body for the multipart/form-data specification
// Mostly taken from Fermata.js
// https://github.com/natevw/fermata/blob/5d9732a33d776ce925013a265935facd1626cc88/fermata.js#L315-L343
const $2d20a0a5d74aa425$var$multipartDataGenerator = (method, data, headers)=>{
    const segno = (Math.round(Math.random() * 1e16) + Math.round(Math.random() * 1e16)).toString();
    headers['Content-Type'] = `multipart/form-data; boundary=${segno}`;
    const textEncoder = new TextEncoder();
    let buffer = new Uint8Array(0);
    const endBuffer = textEncoder.encode('\r\n');
    function push(l) {
        const prevBuffer = buffer;
        const newBuffer = l instanceof Uint8Array ? l : new Uint8Array(textEncoder.encode(l));
        buffer = new Uint8Array(prevBuffer.length + newBuffer.length + 2);
        buffer.set(prevBuffer);
        buffer.set(newBuffer, prevBuffer.length);
        buffer.set(endBuffer, buffer.length - 2);
    }
    function q(s) {
        return `"${s.replace(/"|"/g, '%22').replace(/\r\n|\r|\n/g, ' ')}"`;
    }
    const flattenedData = (0, $f9518090947873ad$export$d07a6a7cdfc04afd)(data);
    for(const k in flattenedData){
        if (!Object.prototype.hasOwnProperty.call(flattenedData, k)) continue;
        const v = flattenedData[k];
        push(`--${segno}`);
        if (Object.prototype.hasOwnProperty.call(v, 'data')) {
            const typedEntry = v;
            push(`Content-Disposition: form-data; name=${q(k)}; filename=${q(typedEntry.name || 'blob')}`);
            push(`Content-Type: ${typedEntry.type || 'application/octet-stream'}`);
            push('');
            push(typedEntry.data);
        } else {
            push(`Content-Disposition: form-data; name=${q(k)}`);
            push('');
            push(v);
        }
    }
    push(`--${segno}--`);
    return buffer;
};
function $2d20a0a5d74aa425$export$12e8a8cf7bf4c510(method, data, headers, callback) {
    data = data || {};
    if (method !== 'POST') return callback(null, (0, $f9518090947873ad$export$ee3e7678add00de3)(data));
    this._stripe._platformFunctions.tryBufferData(data).then((bufferedData)=>{
        const buffer = $2d20a0a5d74aa425$var$multipartDataGenerator(method, bufferedData, headers);
        return callback(null, buffer);
    }).catch((err)=>callback(err, null));
}



const $e359a4f1a87ab575$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $e359a4f1a87ab575$export$9330ab61a7e5c11b = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $e359a4f1a87ab575$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/files',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        host: 'files.stripe.com'
    }),
    retrieve: $e359a4f1a87ab575$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/files/{file}'
    }),
    list: $e359a4f1a87ab575$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/files',
        methodType: 'list'
    }),
    requestDataProcessor: (0, $2d20a0a5d74aa425$export$12e8a8cf7bf4c510)
});


// File generated from our OpenAPI spec

const $700f4f998ffa1146$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $700f4f998ffa1146$export$62428237918915ea = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $700f4f998ffa1146$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/invoiceitems'
    }),
    retrieve: $700f4f998ffa1146$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/invoiceitems/{invoiceitem}'
    }),
    update: $700f4f998ffa1146$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/invoiceitems/{invoiceitem}'
    }),
    list: $700f4f998ffa1146$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/invoiceitems',
        methodType: 'list'
    }),
    del: $700f4f998ffa1146$var$stripeMethod({
        method: 'DELETE',
        fullPath: '/v1/invoiceitems/{invoiceitem}'
    })
});


// File generated from our OpenAPI spec

const $ee62b4846ecf9aef$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $ee62b4846ecf9aef$export$d2780499546107ac = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $ee62b4846ecf9aef$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/invoice_payments/{invoice_payment}'
    }),
    list: $ee62b4846ecf9aef$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/invoice_payments',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $9c4ab4a319da136f$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $9c4ab4a319da136f$export$4db6742e6e85c587 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $9c4ab4a319da136f$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/invoice_rendering_templates/{template}'
    }),
    list: $9c4ab4a319da136f$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/invoice_rendering_templates',
        methodType: 'list'
    }),
    archive: $9c4ab4a319da136f$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/invoice_rendering_templates/{template}/archive'
    }),
    unarchive: $9c4ab4a319da136f$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/invoice_rendering_templates/{template}/unarchive'
    })
});


// File generated from our OpenAPI spec

const $e787de705a10852e$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $e787de705a10852e$export$6771d21b060ba156 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $e787de705a10852e$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/invoices'
    }),
    retrieve: $e787de705a10852e$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/invoices/{invoice}'
    }),
    update: $e787de705a10852e$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/invoices/{invoice}'
    }),
    list: $e787de705a10852e$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/invoices',
        methodType: 'list'
    }),
    del: $e787de705a10852e$var$stripeMethod({
        method: 'DELETE',
        fullPath: '/v1/invoices/{invoice}'
    }),
    addLines: $e787de705a10852e$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/invoices/{invoice}/add_lines'
    }),
    attachPayment: $e787de705a10852e$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/invoices/{invoice}/attach_payment'
    }),
    createPreview: $e787de705a10852e$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/invoices/create_preview'
    }),
    finalizeInvoice: $e787de705a10852e$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/invoices/{invoice}/finalize'
    }),
    listLineItems: $e787de705a10852e$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/invoices/{invoice}/lines',
        methodType: 'list'
    }),
    markUncollectible: $e787de705a10852e$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/invoices/{invoice}/mark_uncollectible'
    }),
    pay: $e787de705a10852e$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/invoices/{invoice}/pay'
    }),
    removeLines: $e787de705a10852e$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/invoices/{invoice}/remove_lines'
    }),
    search: $e787de705a10852e$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/invoices/search',
        methodType: 'search'
    }),
    sendInvoice: $e787de705a10852e$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/invoices/{invoice}/send'
    }),
    updateLines: $e787de705a10852e$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/invoices/{invoice}/update_lines'
    }),
    updateLineItem: $e787de705a10852e$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/invoices/{invoice}/lines/{line_item_id}'
    }),
    voidInvoice: $e787de705a10852e$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/invoices/{invoice}/void'
    })
});


// File generated from our OpenAPI spec

const $444048d6459d7eed$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $444048d6459d7eed$export$715e30177b02d9f2 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $444048d6459d7eed$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/mandates/{mandate}'
    })
});




'use strict';
const $8f5d48c015916b22$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $8f5d48c015916b22$var$oAuthHost = 'connect.stripe.com';
const $8f5d48c015916b22$export$79dd73309e90dfd0 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    basePath: '/',
    authorizeUrl (params, options) {
        params = params || {};
        options = options || {};
        let path = 'oauth/authorize';
        // For Express accounts, the path changes
        if (options.express) path = `express/${path}`;
        if (!params.response_type) params.response_type = 'code';
        if (!params.client_id) params.client_id = this._stripe.getClientId();
        if (!params.scope) params.scope = 'read_write';
        return `https://${$8f5d48c015916b22$var$oAuthHost}/${path}?${(0, $f9518090947873ad$export$ee3e7678add00de3)(params)}`;
    },
    token: $8f5d48c015916b22$var$stripeMethod({
        method: 'POST',
        path: 'oauth/token',
        host: $8f5d48c015916b22$var$oAuthHost
    }),
    deauthorize (spec, ...args) {
        if (!spec.client_id) spec.client_id = this._stripe.getClientId();
        return $8f5d48c015916b22$var$stripeMethod({
            method: 'POST',
            path: 'oauth/deauthorize',
            host: $8f5d48c015916b22$var$oAuthHost
        }).apply(this, [
            spec,
            ...args
        ]);
    }
});


// File generated from our OpenAPI spec

const $acc358825cdd9a7b$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $acc358825cdd9a7b$export$82cbc172165e95d7 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $acc358825cdd9a7b$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/payment_attempt_records/{id}'
    }),
    list: $acc358825cdd9a7b$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/payment_attempt_records',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $a85eedc2941b85a1$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $a85eedc2941b85a1$export$aa6105e8e42bd89b = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $a85eedc2941b85a1$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payment_intents'
    }),
    retrieve: $a85eedc2941b85a1$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/payment_intents/{intent}'
    }),
    update: $a85eedc2941b85a1$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payment_intents/{intent}'
    }),
    list: $a85eedc2941b85a1$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/payment_intents',
        methodType: 'list'
    }),
    applyCustomerBalance: $a85eedc2941b85a1$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payment_intents/{intent}/apply_customer_balance'
    }),
    cancel: $a85eedc2941b85a1$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payment_intents/{intent}/cancel'
    }),
    capture: $a85eedc2941b85a1$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payment_intents/{intent}/capture'
    }),
    confirm: $a85eedc2941b85a1$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payment_intents/{intent}/confirm'
    }),
    incrementAuthorization: $a85eedc2941b85a1$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payment_intents/{intent}/increment_authorization'
    }),
    listAmountDetailsLineItems: $a85eedc2941b85a1$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/payment_intents/{intent}/amount_details_line_items',
        methodType: 'list'
    }),
    search: $a85eedc2941b85a1$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/payment_intents/search',
        methodType: 'search'
    }),
    verifyMicrodeposits: $a85eedc2941b85a1$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payment_intents/{intent}/verify_microdeposits'
    })
});


// File generated from our OpenAPI spec

const $606a4d25c73e5dde$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $606a4d25c73e5dde$export$3d12b74173f96106 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $606a4d25c73e5dde$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payment_links'
    }),
    retrieve: $606a4d25c73e5dde$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/payment_links/{payment_link}'
    }),
    update: $606a4d25c73e5dde$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payment_links/{payment_link}'
    }),
    list: $606a4d25c73e5dde$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/payment_links',
        methodType: 'list'
    }),
    listLineItems: $606a4d25c73e5dde$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/payment_links/{payment_link}/line_items',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $1b60c2c17a9fb2f9$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $1b60c2c17a9fb2f9$export$81c7a7bf02f8e0f7 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $1b60c2c17a9fb2f9$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payment_method_configurations'
    }),
    retrieve: $1b60c2c17a9fb2f9$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/payment_method_configurations/{configuration}'
    }),
    update: $1b60c2c17a9fb2f9$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payment_method_configurations/{configuration}'
    }),
    list: $1b60c2c17a9fb2f9$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/payment_method_configurations',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $fb1c24ec9549c406$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $fb1c24ec9549c406$export$e67d97ab27c7afe8 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $fb1c24ec9549c406$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payment_method_domains'
    }),
    retrieve: $fb1c24ec9549c406$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/payment_method_domains/{payment_method_domain}'
    }),
    update: $fb1c24ec9549c406$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payment_method_domains/{payment_method_domain}'
    }),
    list: $fb1c24ec9549c406$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/payment_method_domains',
        methodType: 'list'
    }),
    validate: $fb1c24ec9549c406$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payment_method_domains/{payment_method_domain}/validate'
    })
});


// File generated from our OpenAPI spec

const $53c62d64a6bbd0c6$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $53c62d64a6bbd0c6$export$ab218e41b1f3d913 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $53c62d64a6bbd0c6$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payment_methods'
    }),
    retrieve: $53c62d64a6bbd0c6$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/payment_methods/{payment_method}'
    }),
    update: $53c62d64a6bbd0c6$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payment_methods/{payment_method}'
    }),
    list: $53c62d64a6bbd0c6$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/payment_methods',
        methodType: 'list'
    }),
    attach: $53c62d64a6bbd0c6$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payment_methods/{payment_method}/attach'
    }),
    detach: $53c62d64a6bbd0c6$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payment_methods/{payment_method}/detach'
    })
});


// File generated from our OpenAPI spec

const $1c559286d7ecf75b$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $1c559286d7ecf75b$export$246dcd951a0f38db = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $1c559286d7ecf75b$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/payment_records/{id}'
    }),
    reportPayment: $1c559286d7ecf75b$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payment_records/report_payment'
    }),
    reportPaymentAttempt: $1c559286d7ecf75b$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payment_records/{id}/report_payment_attempt'
    }),
    reportPaymentAttemptCanceled: $1c559286d7ecf75b$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payment_records/{id}/report_payment_attempt_canceled'
    }),
    reportPaymentAttemptFailed: $1c559286d7ecf75b$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payment_records/{id}/report_payment_attempt_failed'
    }),
    reportPaymentAttemptGuaranteed: $1c559286d7ecf75b$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payment_records/{id}/report_payment_attempt_guaranteed'
    }),
    reportPaymentAttemptInformational: $1c559286d7ecf75b$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payment_records/{id}/report_payment_attempt_informational'
    }),
    reportRefund: $1c559286d7ecf75b$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payment_records/{id}/report_refund'
    })
});


// File generated from our OpenAPI spec

const $ad3cf825ba9a1d01$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $ad3cf825ba9a1d01$export$872b8d34b32dd7ed = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $ad3cf825ba9a1d01$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payouts'
    }),
    retrieve: $ad3cf825ba9a1d01$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/payouts/{payout}'
    }),
    update: $ad3cf825ba9a1d01$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payouts/{payout}'
    }),
    list: $ad3cf825ba9a1d01$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/payouts',
        methodType: 'list'
    }),
    cancel: $ad3cf825ba9a1d01$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payouts/{payout}/cancel'
    }),
    reverse: $ad3cf825ba9a1d01$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/payouts/{payout}/reverse'
    })
});


// File generated from our OpenAPI spec

const $ab110c2401da1d59$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $ab110c2401da1d59$export$fa027c23da0a12ea = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $ab110c2401da1d59$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/plans'
    }),
    retrieve: $ab110c2401da1d59$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/plans/{plan}'
    }),
    update: $ab110c2401da1d59$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/plans/{plan}'
    }),
    list: $ab110c2401da1d59$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/plans',
        methodType: 'list'
    }),
    del: $ab110c2401da1d59$var$stripeMethod({
        method: 'DELETE',
        fullPath: '/v1/plans/{plan}'
    })
});


// File generated from our OpenAPI spec

const $d81dde8d0add6da2$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $d81dde8d0add6da2$export$33460e2abaa8d5c4 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $d81dde8d0add6da2$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/prices'
    }),
    retrieve: $d81dde8d0add6da2$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/prices/{price}'
    }),
    update: $d81dde8d0add6da2$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/prices/{price}'
    }),
    list: $d81dde8d0add6da2$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/prices',
        methodType: 'list'
    }),
    search: $d81dde8d0add6da2$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/prices/search',
        methodType: 'search'
    })
});


// File generated from our OpenAPI spec

const $49496c4253e5a3eb$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $49496c4253e5a3eb$export$92e44ea1079b9ec6 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $49496c4253e5a3eb$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/products'
    }),
    retrieve: $49496c4253e5a3eb$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/products/{id}'
    }),
    update: $49496c4253e5a3eb$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/products/{id}'
    }),
    list: $49496c4253e5a3eb$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/products',
        methodType: 'list'
    }),
    del: $49496c4253e5a3eb$var$stripeMethod({
        method: 'DELETE',
        fullPath: '/v1/products/{id}'
    }),
    createFeature: $49496c4253e5a3eb$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/products/{product}/features'
    }),
    deleteFeature: $49496c4253e5a3eb$var$stripeMethod({
        method: 'DELETE',
        fullPath: '/v1/products/{product}/features/{id}'
    }),
    listFeatures: $49496c4253e5a3eb$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/products/{product}/features',
        methodType: 'list'
    }),
    retrieveFeature: $49496c4253e5a3eb$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/products/{product}/features/{id}'
    }),
    search: $49496c4253e5a3eb$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/products/search',
        methodType: 'search'
    })
});


// File generated from our OpenAPI spec

const $685f0f0d9fb353aa$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $685f0f0d9fb353aa$export$8057bfe8313be655 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $685f0f0d9fb353aa$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/promotion_codes'
    }),
    retrieve: $685f0f0d9fb353aa$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/promotion_codes/{promotion_code}'
    }),
    update: $685f0f0d9fb353aa$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/promotion_codes/{promotion_code}'
    }),
    list: $685f0f0d9fb353aa$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/promotion_codes',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $ff427cdc44452ea4$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $ff427cdc44452ea4$export$d459179d2c3ffa58 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $ff427cdc44452ea4$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/quotes'
    }),
    retrieve: $ff427cdc44452ea4$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/quotes/{quote}'
    }),
    update: $ff427cdc44452ea4$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/quotes/{quote}'
    }),
    list: $ff427cdc44452ea4$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/quotes',
        methodType: 'list'
    }),
    accept: $ff427cdc44452ea4$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/quotes/{quote}/accept'
    }),
    cancel: $ff427cdc44452ea4$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/quotes/{quote}/cancel'
    }),
    finalizeQuote: $ff427cdc44452ea4$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/quotes/{quote}/finalize'
    }),
    listComputedUpfrontLineItems: $ff427cdc44452ea4$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/quotes/{quote}/computed_upfront_line_items',
        methodType: 'list'
    }),
    listLineItems: $ff427cdc44452ea4$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/quotes/{quote}/line_items',
        methodType: 'list'
    }),
    pdf: $ff427cdc44452ea4$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/quotes/{quote}/pdf',
        host: 'files.stripe.com',
        streaming: true
    })
});


// File generated from our OpenAPI spec

const $fa079d99d93f71e8$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $fa079d99d93f71e8$export$288a1c67e4a6ee20 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $fa079d99d93f71e8$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/refunds'
    }),
    retrieve: $fa079d99d93f71e8$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/refunds/{refund}'
    }),
    update: $fa079d99d93f71e8$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/refunds/{refund}'
    }),
    list: $fa079d99d93f71e8$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/refunds',
        methodType: 'list'
    }),
    cancel: $fa079d99d93f71e8$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/refunds/{refund}/cancel'
    })
});


// File generated from our OpenAPI spec

const $cd8f16d22118c536$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $cd8f16d22118c536$export$90a3bc3cf352b893 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $cd8f16d22118c536$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/reviews/{review}'
    }),
    list: $cd8f16d22118c536$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/reviews',
        methodType: 'list'
    }),
    approve: $cd8f16d22118c536$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/reviews/{review}/approve'
    })
});


// File generated from our OpenAPI spec

const $ec69e4375149414d$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $ec69e4375149414d$export$3562a94568b1df7b = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    list: $ec69e4375149414d$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/setup_attempts',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $47a0a6136ec692a4$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $47a0a6136ec692a4$export$434ac1dc49f01e33 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $47a0a6136ec692a4$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/setup_intents'
    }),
    retrieve: $47a0a6136ec692a4$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/setup_intents/{intent}'
    }),
    update: $47a0a6136ec692a4$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/setup_intents/{intent}'
    }),
    list: $47a0a6136ec692a4$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/setup_intents',
        methodType: 'list'
    }),
    cancel: $47a0a6136ec692a4$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/setup_intents/{intent}/cancel'
    }),
    confirm: $47a0a6136ec692a4$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/setup_intents/{intent}/confirm'
    }),
    verifyMicrodeposits: $47a0a6136ec692a4$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/setup_intents/{intent}/verify_microdeposits'
    })
});


// File generated from our OpenAPI spec

const $77522ea8f79eb988$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $77522ea8f79eb988$export$6e6615fb63746f2a = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $77522ea8f79eb988$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/shipping_rates'
    }),
    retrieve: $77522ea8f79eb988$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/shipping_rates/{shipping_rate_token}'
    }),
    update: $77522ea8f79eb988$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/shipping_rates/{shipping_rate_token}'
    }),
    list: $77522ea8f79eb988$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/shipping_rates',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $a14ad8c918561ffc$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $a14ad8c918561ffc$export$40467b362aa82ae = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $a14ad8c918561ffc$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/sources'
    }),
    retrieve: $a14ad8c918561ffc$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/sources/{source}'
    }),
    update: $a14ad8c918561ffc$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/sources/{source}'
    }),
    listSourceTransactions: $a14ad8c918561ffc$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/sources/{source}/source_transactions',
        methodType: 'list'
    }),
    verify: $a14ad8c918561ffc$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/sources/{source}/verify'
    })
});


// File generated from our OpenAPI spec

const $44b23b1fae3d136b$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $44b23b1fae3d136b$export$87896a4d7f73647e = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $44b23b1fae3d136b$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/subscription_items'
    }),
    retrieve: $44b23b1fae3d136b$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/subscription_items/{item}'
    }),
    update: $44b23b1fae3d136b$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/subscription_items/{item}'
    }),
    list: $44b23b1fae3d136b$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/subscription_items',
        methodType: 'list'
    }),
    del: $44b23b1fae3d136b$var$stripeMethod({
        method: 'DELETE',
        fullPath: '/v1/subscription_items/{item}'
    })
});


// File generated from our OpenAPI spec

const $6bd29c3d1d507b1f$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $6bd29c3d1d507b1f$export$8c7bda97ba598335 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $6bd29c3d1d507b1f$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/subscription_schedules'
    }),
    retrieve: $6bd29c3d1d507b1f$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/subscription_schedules/{schedule}'
    }),
    update: $6bd29c3d1d507b1f$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/subscription_schedules/{schedule}'
    }),
    list: $6bd29c3d1d507b1f$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/subscription_schedules',
        methodType: 'list'
    }),
    cancel: $6bd29c3d1d507b1f$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/subscription_schedules/{schedule}/cancel'
    }),
    release: $6bd29c3d1d507b1f$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/subscription_schedules/{schedule}/release'
    })
});


// File generated from our OpenAPI spec

const $ad5abf01a490c84a$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $ad5abf01a490c84a$export$d73dcc2e0bdfb5bd = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $ad5abf01a490c84a$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/subscriptions'
    }),
    retrieve: $ad5abf01a490c84a$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/subscriptions/{subscription_exposed_id}'
    }),
    update: $ad5abf01a490c84a$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/subscriptions/{subscription_exposed_id}'
    }),
    list: $ad5abf01a490c84a$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/subscriptions',
        methodType: 'list'
    }),
    cancel: $ad5abf01a490c84a$var$stripeMethod({
        method: 'DELETE',
        fullPath: '/v1/subscriptions/{subscription_exposed_id}'
    }),
    deleteDiscount: $ad5abf01a490c84a$var$stripeMethod({
        method: 'DELETE',
        fullPath: '/v1/subscriptions/{subscription_exposed_id}/discount'
    }),
    migrate: $ad5abf01a490c84a$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/subscriptions/{subscription}/migrate'
    }),
    resume: $ad5abf01a490c84a$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/subscriptions/{subscription}/resume'
    }),
    search: $ad5abf01a490c84a$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/subscriptions/search',
        methodType: 'search'
    })
});


// File generated from our OpenAPI spec

const $9091f27345e2aeeb$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $9091f27345e2aeeb$export$e9743ffc8daab2d3 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    retrieve: $9091f27345e2aeeb$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/tax_codes/{id}'
    }),
    list: $9091f27345e2aeeb$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/tax_codes',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $7e0054e7bd436529$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $7e0054e7bd436529$export$762d87534be6b718 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $7e0054e7bd436529$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/tax_ids'
    }),
    retrieve: $7e0054e7bd436529$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/tax_ids/{id}'
    }),
    list: $7e0054e7bd436529$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/tax_ids',
        methodType: 'list'
    }),
    del: $7e0054e7bd436529$var$stripeMethod({
        method: 'DELETE',
        fullPath: '/v1/tax_ids/{id}'
    })
});


// File generated from our OpenAPI spec

const $3e62a589604688da$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $3e62a589604688da$export$a1472a7587304615 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $3e62a589604688da$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/tax_rates'
    }),
    retrieve: $3e62a589604688da$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/tax_rates/{tax_rate}'
    }),
    update: $3e62a589604688da$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/tax_rates/{tax_rate}'
    }),
    list: $3e62a589604688da$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/tax_rates',
        methodType: 'list'
    })
});


// File generated from our OpenAPI spec

const $de20950f40b8d1ec$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $de20950f40b8d1ec$export$8e1e81ac145e31be = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $de20950f40b8d1ec$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/tokens'
    }),
    retrieve: $de20950f40b8d1ec$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/tokens/{token}'
    })
});


// File generated from our OpenAPI spec

const $56885fc6cdc18b0c$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $56885fc6cdc18b0c$export$ada7dca29335d106 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $56885fc6cdc18b0c$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/topups'
    }),
    retrieve: $56885fc6cdc18b0c$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/topups/{topup}'
    }),
    update: $56885fc6cdc18b0c$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/topups/{topup}'
    }),
    list: $56885fc6cdc18b0c$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/topups',
        methodType: 'list'
    }),
    cancel: $56885fc6cdc18b0c$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/topups/{topup}/cancel'
    })
});


// File generated from our OpenAPI spec

const $96269ed75ff29288$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $96269ed75ff29288$export$68997731bcbd545c = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $96269ed75ff29288$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/transfers'
    }),
    retrieve: $96269ed75ff29288$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/transfers/{transfer}'
    }),
    update: $96269ed75ff29288$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/transfers/{transfer}'
    }),
    list: $96269ed75ff29288$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/transfers',
        methodType: 'list'
    }),
    createReversal: $96269ed75ff29288$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/transfers/{id}/reversals'
    }),
    listReversals: $96269ed75ff29288$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/transfers/{id}/reversals',
        methodType: 'list'
    }),
    retrieveReversal: $96269ed75ff29288$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/transfers/{transfer}/reversals/{id}'
    }),
    updateReversal: $96269ed75ff29288$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/transfers/{transfer}/reversals/{id}'
    })
});


// File generated from our OpenAPI spec

const $20ef02a024905d87$var$stripeMethod = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).method;
const $20ef02a024905d87$export$8f795df01c573962 = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).extend({
    create: $20ef02a024905d87$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/webhook_endpoints'
    }),
    retrieve: $20ef02a024905d87$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/webhook_endpoints/{webhook_endpoint}'
    }),
    update: $20ef02a024905d87$var$stripeMethod({
        method: 'POST',
        fullPath: '/v1/webhook_endpoints/{webhook_endpoint}'
    }),
    list: $20ef02a024905d87$var$stripeMethod({
        method: 'GET',
        fullPath: '/v1/webhook_endpoints',
        methodType: 'list'
    }),
    del: $20ef02a024905d87$var$stripeMethod({
        method: 'DELETE',
        fullPath: '/v1/webhook_endpoints/{webhook_endpoint}'
    })
});


const $e7e21ae886e376fe$export$1ba5735493686b70 = (0, $7c23e0f65c18bdb1$export$39180f984d46a93e)('apps', {
    Secrets: (0, $7a895120c2658ddf$export$d461bab147da6da1)
});
const $e7e21ae886e376fe$export$156dc96109f460f = (0, $7c23e0f65c18bdb1$export$39180f984d46a93e)('billing', {
    Alerts: (0, $ce80880e2fc25be7$export$7a76bf180c86084f),
    CreditBalanceSummary: (0, $f89f7d639bd4575e$export$b21e6ea17ccb5e9d),
    CreditBalanceTransactions: (0, $65241b9e44b5b220$export$9fc7dee76bb3ffe8),
    CreditGrants: (0, $a264a7adb6f9729c$export$e3e715035bceff1d),
    MeterEventAdjustments: (0, $f5d3f13cb2747717$export$b7f88946c8b3227d),
    MeterEvents: (0, $f73f6c24e30ee2c8$export$2f67a09251226a38),
    Meters: (0, $c9b4a846220a9b64$export$e208a249bf08a830)
});
const $e7e21ae886e376fe$export$daf496b0401253e8 = (0, $7c23e0f65c18bdb1$export$39180f984d46a93e)('billingPortal', {
    Configurations: (0, $79b83f657166f201$export$8a7c38bd6e0afaba),
    Sessions: (0, $e2cc8c5c8fbbc1a1$export$c8d7e81b9a544c06)
});
const $e7e21ae886e376fe$export$1f60ba4ec72508a0 = (0, $7c23e0f65c18bdb1$export$39180f984d46a93e)('checkout', {
    Sessions: (0, $535fce1f92491d22$export$c8d7e81b9a544c06)
});
const $e7e21ae886e376fe$export$de8b4e85901a043d = (0, $7c23e0f65c18bdb1$export$39180f984d46a93e)('climate', {
    Orders: (0, $16b5a758f93ae19d$export$ed0df17bf864fd7b),
    Products: (0, $2c0ff310d6fae3fc$export$92e44ea1079b9ec6),
    Suppliers: (0, $28a6584905e943d1$export$d284c91060f4524e)
});
const $e7e21ae886e376fe$export$2dd6ceaca38aed5c = (0, $7c23e0f65c18bdb1$export$39180f984d46a93e)('entitlements', {
    ActiveEntitlements: (0, $20c7522db82e551f$export$24590d03ff21603f),
    Features: (0, $ed3ccfe99d187b23$export$617d79dae526d2cf)
});
const $e7e21ae886e376fe$export$bd7d4ee0fae3520f = (0, $7c23e0f65c18bdb1$export$39180f984d46a93e)('financialConnections', {
    Accounts: (0, $c73beb07c8819be5$export$104d3e2565f73818),
    Sessions: (0, $95817d5d9b348806$export$c8d7e81b9a544c06),
    Transactions: (0, $3d3c832d3c97d345$export$7d08f46ba5d226c9)
});
const $e7e21ae886e376fe$export$ae2400c968399c46 = (0, $7c23e0f65c18bdb1$export$39180f984d46a93e)('forwarding', {
    Requests: (0, $c12f13521aaadf17$export$9840c1777639b595)
});
const $e7e21ae886e376fe$export$544bf02140fa9a77 = (0, $7c23e0f65c18bdb1$export$39180f984d46a93e)('identity', {
    VerificationReports: (0, $d9586ef04643fb77$export$75c63648bd0f8573),
    VerificationSessions: (0, $24f253ac123711bf$export$d15e2d602fc5b4fe)
});
const $e7e21ae886e376fe$export$f4556e8213269c58 = (0, $7c23e0f65c18bdb1$export$39180f984d46a93e)('issuing', {
    Authorizations: (0, $4c2579f3d6107d49$export$780b7dfb505106b6),
    Cardholders: (0, $581f87adfc324e85$export$3561884d9c92eedd),
    Cards: (0, $2b61e59dc4a9cfee$export$c8d38e0dcc0f5a1),
    Disputes: (0, $7c7bdb974a6996ef$export$e155801aca45aa33),
    PersonalizationDesigns: (0, $e339b8e7d0b952f3$export$668962564dcec028),
    PhysicalBundles: (0, $695f8659cc248247$export$7e925fe8086f6f18),
    Tokens: (0, $d6f6c63465c03d5b$export$8e1e81ac145e31be),
    Transactions: (0, $1165907de692e9db$export$7d08f46ba5d226c9)
});
const $e7e21ae886e376fe$export$bace472c466fdd25 = (0, $7c23e0f65c18bdb1$export$39180f984d46a93e)('radar', {
    EarlyFraudWarnings: (0, $b486ba10ea49d9c0$export$3a0c27d59728c846),
    ValueListItems: (0, $9269811bf9e71b8a$export$82a31c0f8bcbcfa7),
    ValueLists: (0, $57584bc717476302$export$4a70a1c1d396d5d6)
});
const $e7e21ae886e376fe$export$a480e00c4abae531 = (0, $7c23e0f65c18bdb1$export$39180f984d46a93e)('reporting', {
    ReportRuns: (0, $fe7143913d869b6c$export$f215120ca5e88069),
    ReportTypes: (0, $acd48eef5ef608b0$export$c74cb6e60557c635)
});
const $e7e21ae886e376fe$export$79e850ed2864d13d = (0, $7c23e0f65c18bdb1$export$39180f984d46a93e)('sigma', {
    ScheduledQueryRuns: (0, $b25cdf2edfa7f0c3$export$22d5e60e46830654)
});
const $e7e21ae886e376fe$export$90e19d350e059ba5 = (0, $7c23e0f65c18bdb1$export$39180f984d46a93e)('tax', {
    Associations: (0, $d8e40608964b11d7$export$20dba3a29c89afa4),
    Calculations: (0, $80e1a78921f7d403$export$1270c16ec3b4f45a),
    Registrations: (0, $90c2c1a396933167$export$35e91f0e79fa7752),
    Settings: (0, $9faf0c42eb7670ed$export$c72f6eaae7b9adff),
    Transactions: (0, $6b2bc9976739e0eb$export$7d08f46ba5d226c9)
});
const $e7e21ae886e376fe$export$8dd80f06eb58bfe1 = (0, $7c23e0f65c18bdb1$export$39180f984d46a93e)('terminal', {
    Configurations: (0, $9f6780bf7bbc3dac$export$8a7c38bd6e0afaba),
    ConnectionTokens: (0, $f975931546337af8$export$68dad2bdcb5860e6),
    Locations: (0, $469bcfdeab4646dd$export$2dceb80d0af9bf60),
    OnboardingLinks: (0, $a8ef9a8151ea1ed2$export$5045cdd5612307eb),
    Readers: (0, $6060543d786c29f7$export$df935bc2312a795f)
});
const $e7e21ae886e376fe$export$33417988280e7310 = (0, $7c23e0f65c18bdb1$export$39180f984d46a93e)('testHelpers', {
    ConfirmationTokens: (0, $dbebde9096b3109a$export$38f73a8adfe17c92),
    Customers: (0, $b1f34bb5043fc322$export$d697df66e097e160),
    Refunds: (0, $5c0f8e7773d5ffd8$export$288a1c67e4a6ee20),
    TestClocks: (0, $efebdf5bccbd09b2$export$d7ba70c86937ac5b),
    Issuing: (0, $7c23e0f65c18bdb1$export$39180f984d46a93e)('issuing', {
        Authorizations: (0, $4e007f704661b933$export$780b7dfb505106b6),
        Cards: (0, $850659383892da5a$export$c8d38e0dcc0f5a1),
        PersonalizationDesigns: (0, $e0a3537df5a99ee4$export$668962564dcec028),
        Transactions: (0, $902d1e2539342e28$export$7d08f46ba5d226c9)
    }),
    Terminal: (0, $7c23e0f65c18bdb1$export$39180f984d46a93e)('terminal', {
        Readers: (0, $c7cea4436b6a029b$export$df935bc2312a795f)
    }),
    Treasury: (0, $7c23e0f65c18bdb1$export$39180f984d46a93e)('treasury', {
        InboundTransfers: (0, $14ad55f0258f4e30$export$fabf99bf25efd32d),
        OutboundPayments: (0, $a509b6b36cc99f34$export$52701ee3b8eab96c),
        OutboundTransfers: (0, $752631b5b1d96fbd$export$f385dd25bcef3dcc),
        ReceivedCredits: (0, $8c7a1a0bb8a7c598$export$b3c98ef9e3b034ea),
        ReceivedDebits: (0, $92a0e7f778e809cd$export$93656d040691bb72)
    })
});
const $e7e21ae886e376fe$export$202f17a618ffb938 = (0, $7c23e0f65c18bdb1$export$39180f984d46a93e)('treasury', {
    CreditReversals: (0, $b72a3a8041226bab$export$2b33e47c4cc267ed),
    DebitReversals: (0, $889ca903e1a983d4$export$7567f2a6f4cdc0c2),
    FinancialAccounts: (0, $858e349f66f471f1$export$90ec7b042c4c4fdc),
    InboundTransfers: (0, $374823ee9177a387$export$fabf99bf25efd32d),
    OutboundPayments: (0, $aef1f67efbe29365$export$52701ee3b8eab96c),
    OutboundTransfers: (0, $cd6001fafcc61b8a$export$f385dd25bcef3dcc),
    ReceivedCredits: (0, $4a4bc7c7f73315af$export$b3c98ef9e3b034ea),
    ReceivedDebits: (0, $ce560e8d1da3c5a1$export$93656d040691bb72),
    TransactionEntries: (0, $0ee46bfaf17d9f92$export$62ca4dd76ac545f5),
    Transactions: (0, $faa2fc635c7ae2af$export$7d08f46ba5d226c9)
});
const $e7e21ae886e376fe$export$9b589fb896e0ad32 = (0, $7c23e0f65c18bdb1$export$39180f984d46a93e)('v2', {
    Billing: (0, $7c23e0f65c18bdb1$export$39180f984d46a93e)('billing', {
        MeterEventAdjustments: (0, $e960f0b831740391$export$b7f88946c8b3227d),
        MeterEventSession: (0, $a30d71604e4190cb$export$65b0325d56fce31f),
        MeterEventStream: (0, $a38e1b00c98bb876$export$2944b2107bc37e07),
        MeterEvents: (0, $a33dc145ef154dfc$export$2f67a09251226a38)
    }),
    Core: (0, $7c23e0f65c18bdb1$export$39180f984d46a93e)('core', {
        AccountLinks: (0, $5d53e86eef88a496$export$2957e9f5c8fc6751),
        AccountTokens: (0, $74bfc906ff3bb988$export$b9e3a6742a74c6b0),
        Accounts: (0, $98accc04c45254a3$export$104d3e2565f73818),
        EventDestinations: (0, $13be0065d53d50af$export$a98becb95dd01dd),
        Events: (0, $e3677164c2d86d9b$export$ada873a34909da65)
    })
});



const $11550340e8fbde05$var$DEFAULT_HOST = 'api.stripe.com';
const $11550340e8fbde05$var$DEFAULT_PORT = '443';
const $11550340e8fbde05$var$DEFAULT_BASE_PATH = '/v1/';
const $11550340e8fbde05$var$DEFAULT_API_VERSION = (0, $87a079047d785cdf$export$4e8808c19cff877);
const $11550340e8fbde05$var$DEFAULT_TIMEOUT = 80000;
const $11550340e8fbde05$var$MAX_NETWORK_RETRY_DELAY_SEC = 5;
const $11550340e8fbde05$var$INITIAL_NETWORK_RETRY_DELAY_SEC = 0.5;
const $11550340e8fbde05$var$APP_INFO_PROPERTIES = [
    'name',
    'version',
    'url',
    'partner_id'
];
const $11550340e8fbde05$var$ALLOWED_CONFIG_PROPERTIES = [
    'authenticator',
    'apiVersion',
    'typescript',
    'maxNetworkRetries',
    'httpAgent',
    'httpClient',
    'timeout',
    'host',
    'port',
    'protocol',
    'telemetry',
    'appInfo',
    'stripeAccount',
    'stripeContext'
];
const $11550340e8fbde05$var$defaultRequestSenderFactory = (stripe)=>new (0, $05b8a1b47abc2dac$export$196c27f83356e260)(stripe, (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597).MAX_BUFFERED_REQUEST_METRICS);
function $11550340e8fbde05$export$559f48a7f7271adf(platformFunctions, requestSender = $11550340e8fbde05$var$defaultRequestSenderFactory) {
    Stripe.PACKAGE_VERSION = '20.2.0';
    Stripe.API_VERSION = (0, $87a079047d785cdf$export$4e8808c19cff877);
    Stripe.USER_AGENT = Object.assign({
        bindings_version: Stripe.PACKAGE_VERSION,
        lang: 'node',
        publisher: 'stripe',
        uname: null,
        typescript: false
    }, (0, $f9518090947873ad$export$c437f6e26746c6ee)());
    Stripe.StripeResource = (0, $7f2478bb1c7170aa$export$dc31a0a82b15e597);
    Stripe.StripeContext = (0, $613bdb80064c6477$export$bdc250ccffdc5290);
    Stripe.resources = $e7e21ae886e376fe$exports;
    Stripe.HttpClient = (0, $22250c6fcb187bc7$export$8c6ee871e681f0f4);
    Stripe.HttpClientResponse = (0, $22250c6fcb187bc7$export$7a420d61f4599d58);
    Stripe.CryptoProvider = (0, $0c14d973ee69192a$export$745d7c3e16d29f1c);
    Stripe.webhooks = (0, $2b5fa3cda468fcd8$export$b88c523063979268)(platformFunctions);
    function Stripe(key, config = {}) {
        if (!(this instanceof Stripe)) return new Stripe(key, config);
        const props = this._getPropsFromConfig(config);
        this._platformFunctions = platformFunctions;
        Object.defineProperty(this, '_emitter', {
            value: this._platformFunctions.createEmitter(),
            enumerable: false,
            configurable: false,
            writable: false
        });
        this.VERSION = Stripe.PACKAGE_VERSION;
        this.on = this._emitter.on.bind(this._emitter);
        this.once = this._emitter.once.bind(this._emitter);
        this.off = this._emitter.removeListener.bind(this._emitter);
        const agent = props.httpAgent || null;
        this._api = {
            host: props.host || $11550340e8fbde05$var$DEFAULT_HOST,
            port: props.port || $11550340e8fbde05$var$DEFAULT_PORT,
            protocol: props.protocol || 'https',
            basePath: $11550340e8fbde05$var$DEFAULT_BASE_PATH,
            version: props.apiVersion || $11550340e8fbde05$var$DEFAULT_API_VERSION,
            timeout: (0, $f9518090947873ad$export$ffa3b1cd345d970)('timeout', props.timeout, $11550340e8fbde05$var$DEFAULT_TIMEOUT),
            maxNetworkRetries: (0, $f9518090947873ad$export$ffa3b1cd345d970)('maxNetworkRetries', props.maxNetworkRetries, 2),
            agent: agent,
            httpClient: props.httpClient || (agent ? this._platformFunctions.createNodeHttpClient(agent) : this._platformFunctions.createDefaultHttpClient()),
            dev: false,
            stripeAccount: props.stripeAccount || null,
            stripeContext: props.stripeContext || null
        };
        const typescript = props.typescript || false;
        if (typescript !== Stripe.USER_AGENT.typescript) // The mutation here is uncomfortable, but likely fastest;
        // serializing the user agent involves shelling out to the system,
        // and given some users may instantiate the library many times without switching between TS and non-TS,
        // we only want to incur the performance hit when that actually happens.
        Stripe.USER_AGENT.typescript = typescript;
        if (props.appInfo) this._setAppInfo(props.appInfo);
        this._prepResources();
        this._setAuthenticator(key, props.authenticator);
        this.errors = $7dd63d24cadb0282$exports;
        this.webhooks = Stripe.webhooks;
        this._prevRequestMetrics = [];
        this._enableTelemetry = props.telemetry !== false;
        this._requestSender = requestSender(this);
        // Expose StripeResource on the instance too
        // @ts-ignore
        this.StripeResource = Stripe.StripeResource;
    }
    Stripe.errors = $7dd63d24cadb0282$exports;
    Stripe.createNodeHttpClient = platformFunctions.createNodeHttpClient;
    /**
     * Creates an HTTP client for issuing Stripe API requests which uses the Web
     * Fetch API.
     *
     * A fetch function can optionally be passed in as a parameter. If none is
     * passed, will default to the default `fetch` function in the global scope.
     */ Stripe.createFetchHttpClient = platformFunctions.createFetchHttpClient;
    /**
     * Create a CryptoProvider which uses the built-in Node crypto libraries for
     * its crypto operations.
     */ Stripe.createNodeCryptoProvider = platformFunctions.createNodeCryptoProvider;
    /**
     * Creates a CryptoProvider which uses the Subtle Crypto API from the Web
     * Crypto API spec for its crypto operations.
     *
     * A SubtleCrypto interface can optionally be passed in as a parameter. If none
     * is passed, will default to the default `crypto.subtle` object in the global
     * scope.
     */ Stripe.createSubtleCryptoProvider = platformFunctions.createSubtleCryptoProvider;
    Stripe.prototype = {
        // Properties are set in the constructor above
        _appInfo: undefined,
        on: null,
        off: null,
        once: null,
        VERSION: null,
        StripeResource: null,
        webhooks: null,
        errors: null,
        _api: null,
        _prevRequestMetrics: null,
        _emitter: null,
        _enableTelemetry: null,
        _requestSender: null,
        _platformFunctions: null,
        rawRequest (method, path, params, options) {
            return this._requestSender._rawRequest(method, path, params, options);
        },
        /**
         * @private
         */ _setAuthenticator (key, authenticator) {
            if (key && authenticator) throw new Error("Can't specify both apiKey and authenticator");
            if (!key && !authenticator) throw new Error('Neither apiKey nor config.authenticator provided');
            this._authenticator = key ? (0, $f9518090947873ad$export$5260ee7b699e9b50)(key) : authenticator;
        },
        /**
         * @private
         * This may be removed in the future.
         */ _setAppInfo (info) {
            if (info && typeof info !== 'object') throw new Error('AppInfo must be an object.');
            if (info && !info.name) throw new Error('AppInfo.name is required');
            info = info || {};
            this._appInfo = $11550340e8fbde05$var$APP_INFO_PROPERTIES.reduce((accum, prop)=>{
                if (typeof info[prop] == 'string') {
                    accum = accum || {};
                    accum[prop] = info[prop];
                }
                return accum;
            }, {});
        },
        /**
         * @private
         * This may be removed in the future.
         */ _setApiField (key, value) {
            this._api[key] = value;
        },
        /**
         * @private
         * Please open or upvote an issue at github.com/stripe/stripe-node
         * if you use this, detailing your use-case.
         *
         * It may be deprecated and removed in the future.
         */ getApiField (key) {
            return this._api[key];
        },
        setClientId (clientId) {
            this._clientId = clientId;
        },
        getClientId () {
            return this._clientId;
        },
        /**
         * @private
         * Please open or upvote an issue at github.com/stripe/stripe-node
         * if you use this, detailing your use-case.
         *
         * It may be deprecated and removed in the future.
         */ getConstant: (c)=>{
            switch(c){
                case 'DEFAULT_HOST':
                    return $11550340e8fbde05$var$DEFAULT_HOST;
                case 'DEFAULT_PORT':
                    return $11550340e8fbde05$var$DEFAULT_PORT;
                case 'DEFAULT_BASE_PATH':
                    return $11550340e8fbde05$var$DEFAULT_BASE_PATH;
                case 'DEFAULT_API_VERSION':
                    return $11550340e8fbde05$var$DEFAULT_API_VERSION;
                case 'DEFAULT_TIMEOUT':
                    return $11550340e8fbde05$var$DEFAULT_TIMEOUT;
                case 'MAX_NETWORK_RETRY_DELAY_SEC':
                    return $11550340e8fbde05$var$MAX_NETWORK_RETRY_DELAY_SEC;
                case 'INITIAL_NETWORK_RETRY_DELAY_SEC':
                    return $11550340e8fbde05$var$INITIAL_NETWORK_RETRY_DELAY_SEC;
            }
            return Stripe[c];
        },
        getMaxNetworkRetries () {
            return this.getApiField('maxNetworkRetries');
        },
        /**
         * @private
         * This may be removed in the future.
         */ _setApiNumberField (prop, n, defaultVal) {
            const val = (0, $f9518090947873ad$export$ffa3b1cd345d970)(prop, n, defaultVal);
            this._setApiField(prop, val);
        },
        getMaxNetworkRetryDelay () {
            return $11550340e8fbde05$var$MAX_NETWORK_RETRY_DELAY_SEC;
        },
        getInitialNetworkRetryDelay () {
            return $11550340e8fbde05$var$INITIAL_NETWORK_RETRY_DELAY_SEC;
        },
        /**
         * @private
         * Please open or upvote an issue at github.com/stripe/stripe-node
         * if you use this, detailing your use-case.
         *
         * It may be deprecated and removed in the future.
         *
         * Gets a JSON version of a User-Agent and uses a cached version for a slight
         * speed advantage.
         */ getClientUserAgent (cb) {
            return this.getClientUserAgentSeeded(Stripe.USER_AGENT, cb);
        },
        /**
         * @private
         * Please open or upvote an issue at github.com/stripe/stripe-node
         * if you use this, detailing your use-case.
         *
         * It may be deprecated and removed in the future.
         *
         * Gets a JSON version of a User-Agent by encoding a seeded object and
         * fetching a uname from the system.
         */ getClientUserAgentSeeded (seed, cb) {
            this._platformFunctions.getUname().then((uname)=>{
                var _a;
                const userAgent = {};
                for(const field in seed){
                    if (!Object.prototype.hasOwnProperty.call(seed, field)) continue;
                    userAgent[field] = encodeURIComponent((_a = seed[field]) !== null && _a !== void 0 ? _a : 'null');
                }
                // URI-encode in case there are unusual characters in the system's uname.
                userAgent.uname = encodeURIComponent(uname || 'UNKNOWN');
                const client = this.getApiField('httpClient');
                if (client) userAgent.httplib = encodeURIComponent(client.getClientName());
                if (this._appInfo) userAgent.application = this._appInfo;
                cb(JSON.stringify(userAgent));
            });
        },
        /**
         * @private
         * Please open or upvote an issue at github.com/stripe/stripe-node
         * if you use this, detailing your use-case.
         *
         * It may be deprecated and removed in the future.
         */ getAppInfoAsString () {
            if (!this._appInfo) return '';
            let formatted = this._appInfo.name;
            if (this._appInfo.version) formatted += `/${this._appInfo.version}`;
            if (this._appInfo.url) formatted += ` (${this._appInfo.url})`;
            return formatted;
        },
        getTelemetryEnabled () {
            return this._enableTelemetry;
        },
        /**
         * @private
         * This may be removed in the future.
         */ _prepResources () {
            for(const name in $e7e21ae886e376fe$exports){
                if (!Object.prototype.hasOwnProperty.call($e7e21ae886e376fe$exports, name)) continue;
                // @ts-ignore
                this[(0, $f9518090947873ad$export$696df76c11680caa)(name)] = new $e7e21ae886e376fe$exports[name](this);
            }
        },
        /**
         * @private
         * This may be removed in the future.
         */ _getPropsFromConfig (config) {
            // If config is null or undefined, just bail early with no props
            if (!config) return {};
            // config can be an object or a string
            const isString = typeof config === 'string';
            const isObject = config === Object(config) && !Array.isArray(config);
            if (!isObject && !isString) throw new Error('Config must either be an object or a string');
            // If config is a string, we assume the old behavior of passing in a string representation of the api version
            if (isString) return {
                apiVersion: config
            };
            // If config is an object, we assume the new behavior and make sure it doesn't contain any unexpected values
            const values = Object.keys(config).filter((value)=>!$11550340e8fbde05$var$ALLOWED_CONFIG_PROPERTIES.includes(value));
            if (values.length > 0) throw new Error(`Config object may only contain the following: ${$11550340e8fbde05$var$ALLOWED_CONFIG_PROPERTIES.join(', ')}`);
            return config;
        },
        parseEventNotification (payload, header, secret, tolerance, cryptoProvider, receivedAt) {
            // parses and validates the event payload all in one go
            const eventNotification = this.webhooks.constructEvent(payload, header, secret, tolerance, cryptoProvider, receivedAt);
            // Parse string context into StripeContext object if present
            if (eventNotification.context) eventNotification.context = (0, $613bdb80064c6477$export$bdc250ccffdc5290).parse(eventNotification.context);
            eventNotification.fetchEvent = ()=>{
                return this._requestSender._rawRequest('GET', `/v2/core/events/${eventNotification.id}`, undefined, {
                    stripeContext: eventNotification.context
                }, [
                    'fetch_event'
                ]);
            };
            eventNotification.fetchRelatedObject = ()=>{
                if (!eventNotification.related_object) return Promise.resolve(null);
                return this._requestSender._rawRequest('GET', eventNotification.related_object.url, undefined, {
                    stripeContext: eventNotification.context
                }, [
                    'fetch_related_object'
                ]);
            };
            return eventNotification;
        }
    };
    return Stripe;
}


const $e38c8a8c4d9c8b09$export$3c7919ca4c48cda4 = (0, $11550340e8fbde05$export$559f48a7f7271adf)(new (0, $7ad6b2871a85e55d$export$f6dd6b087620cf03)());
var $e38c8a8c4d9c8b09$export$2e2bcd8739ae039 = $e38c8a8c4d9c8b09$export$3c7919ca4c48cda4;


const $d702e022429a9cf6$export$4c208bff4e14c97d = (0, $e38c8a8c4d9c8b09$export$2e2bcd8739ae039).errors.StripeCardError;
const $d702e022429a9cf6$export$a56520c648817af9 = (0, $e38c8a8c4d9c8b09$export$2e2bcd8739ae039).errors.StripeRateLimitError;
const $d702e022429a9cf6$var$Stripe_ID__Brand = Symbol();
function $d702e022429a9cf6$export$5cac783f88caf86d(ID) {
    return ID.startsWith('pi_');
}
function $d702e022429a9cf6$export$ca907b77acf31a71(value) {
    return `"${value.replaceAll('"', '\"')}"`;
}
class $d702e022429a9cf6$export$f51e1679539cc7f7 {
    constructor(uri){
        this.uri = uri;
    }
    get stripe() {
        return new (0, $e38c8a8c4d9c8b09$export$2e2bcd8739ae039)(this.uri.password);
    }
    get publishableKey() {
        return this.uri.username;
    }
    get paymentMethodConfigurationID() {
        return this.uri.queryParams.get('payment_method_configuration') ?? undefined;
    }
}
async function $d702e022429a9cf6$export$5833138360233d58(stripe) {
    return await $d702e022429a9cf6$var$getWholeList((x)=>stripe.stripe.customers.list(x));
}
async function $d702e022429a9cf6$export$882903408fef3ce(stripe, id) {
    return await stripe.stripe.customers.retrieve(id, {
        expand: [
            'test_clock'
        ]
    });
}
async function $d702e022429a9cf6$export$b00b1e9350640caf(stripe, id, info) {
    return await stripe.stripe.customers.update(id, {
        ...info,
        expand: [
            'test_clock'
        ]
    });
}
async function $d702e022429a9cf6$export$ca966129191cd60e(stripe, { limit: limit, ...params }) {
    return await $d702e022429a9cf6$var$getList((x)=>stripe.stripe.subscriptions.list({
            ...x,
            ...params
        }), limit);
}
async function $d702e022429a9cf6$export$64acf82a8f6bf13(stripe, id, info) {
    return await stripe.stripe.subscriptions.update(id, info);
}
async function $d702e022429a9cf6$export$aa915035d7414c61(stripe, id, info) {
    return await stripe.stripe.subscriptions.cancel(id, info);
}
async function $d702e022429a9cf6$export$de226100c798a56a(stripe, { limit: limit, ...params }) {
    return await $d702e022429a9cf6$var$getList((x)=>stripe.stripe.invoices.list({
            ...x,
            ...params,
            expand: [
                'data.payments'
            ]
        }), limit);
}
async function $d702e022429a9cf6$export$6ca2039f5f9bd7f4(stripe, id, params = {}) {
    return await stripe.stripe.invoices.voidInvoice(id, {
        ...params,
        expand: [
            'payments'
        ]
    });
}
async function $d702e022429a9cf6$export$4f39837099f989b6(stripe, { limit: limit, ...params }) {
    return await $d702e022429a9cf6$var$getList((x)=>stripe.stripe.paymentIntents.list({
            ...x,
            ...params,
            expand: [
                'data.latest_charge'
            ]
        }), limit);
}
async function $d702e022429a9cf6$export$ba543b6d4f8ab161(stripe, { limit: limit, ...params }) {
    return await $d702e022429a9cf6$var$getList((x)=>stripe.stripe.paymentIntents.search({
            ...x,
            ...params,
            expand: [
                'data.latest_charge'
            ]
        }), limit);
}
async function $d702e022429a9cf6$export$bc3ab60ceb61a7d0(stripe, id, info) {
    return await stripe.stripe.paymentIntents.update(id, info);
}
async function $d702e022429a9cf6$export$631881b833f7e81a(stripe) {
    return await $d702e022429a9cf6$var$getWholeList((x)=>stripe.stripe.checkout.sessions.list({
            ...x,
            expand: [
                'data.line_items'
            ]
        }));
}
async function $d702e022429a9cf6$var$getList(list, limit) {
    if (limit === 1 / 0) return await $d702e022429a9cf6$var$getWholeList(list);
    else return (await list({
        limit: limit
    })).data;
}
async function $d702e022429a9cf6$var$getWholeList(list) {
    const items = new Array();
    let i = 0;
    for await (const item of list({
        limit: 100
    })){
        items.push(item);
        ++i;
        if (i % 100 === 0) console.debug(i);
    }
    return items;
}
function $d702e022429a9cf6$export$51b3ec1733aae517(c) {
    return {
        ...c,
        kind: 'Customer',
        metadata: c.metadata,
        test_clock: c.test_clock
    };
}
function $d702e022429a9cf6$export$5b983dddb6ffb4(s) {
    return {
        ...s,
        kind: 'Subscription',
        customer: undefined,
        recorded_customer_id: s.customer,
        metadata: s.metadata
    };
}
function $d702e022429a9cf6$export$3650aaa6602f50e0(i) {
    return {
        ...i,
        kind: 'Invoice',
        customer: undefined,
        recorded_customer_id: i.customer,
        metadata: i.metadata
    };
}
function $d702e022429a9cf6$export$5250b97dca85f2d5(p) {
    return {
        ...p,
        kind: 'PaymentIntent',
        customer: undefined,
        recorded_customer_id: p.customer,
        metadata: p.metadata
    };
}


const $3e9faaf63779509d$export$dcef2510e0f7dc8a = (0, $d702e022429a9cf6$export$51b3ec1733aae517);
const $3e9faaf63779509d$export$e0f7ca1e2b2be2ef = (0, $d702e022429a9cf6$export$5250b97dca85f2d5);
function $3e9faaf63779509d$export$fce947bb9210c35a(p) {
    // TODO move this somewhere else
    if (p.metadata.amount_refunded) {
        p.latest_charge.amount_refunded = parseInt(p.metadata.amount_refunded);
        delete p.metadata.amount_refunded;
    }
    return p.status === 'succeeded' && p.latest_charge.amount_refunded === 0;
}
const $3e9faaf63779509d$export$819247d08e2f5403 = (0, $d702e022429a9cf6$export$3650aaa6602f50e0);
const $3e9faaf63779509d$export$2810675458ec02da = (0, $d702e022429a9cf6$export$5b983dddb6ffb4);




function $ce07c05cf9893d37$export$3e736a89006565a0({ myPayments: myPayments }) {
    return [
        ...myPayments.values().map((p)=>p.metadata?.buy).filter((pid)=>pid !== undefined)
    ];
}
function $ce07c05cf9893d37$export$a4034b0bac9332d7({ myOpenInvoices: myOpenInvoices }) {
    return [
        ...myOpenInvoices.values().map((invoice)=>{
            return {
                ID: invoice.id,
                number: invoice.number,
                dueBy: invoice.due_date ? (0, $5d669742300defa8$export$336849d529cb05e5).Instant.fromEpochMilliseconds(invoice.due_date * 1000) : (0, $5d669742300defa8$export$336849d529cb05e5).Instant.fromEpochMilliseconds(invoice.effective_at * 1000),
                periodStart: (0, $5d669742300defa8$export$336849d529cb05e5).Instant.fromEpochMilliseconds(invoice.lines.data[0].period.start * 1000),
                periodEnd: (0, $5d669742300defa8$export$336849d529cb05e5).Instant.fromEpochMilliseconds(invoice.lines.data[0].period.end * 1000),
                amountRemaining: invoice.amount_remaining / 100,
                nextAttemptOn: invoice.next_payment_attempt ? (0, $5d669742300defa8$export$336849d529cb05e5).Instant.fromEpochMilliseconds(invoice.next_payment_attempt * 1000) : null
            };
        })
    ];
}
function $ce07c05cf9893d37$export$b33718705eb6916e({ myRecords: myRecords, myCustomer: myCustomer, myAliveCareSubscription: myAliveCareSubscription, myOpenInvoices: myOpenInvoices }) {
    const wantsToCharge = myAliveCareSubscription && !myAliveCareSubscription.cancel_at_period_end;
    const willCharge = wantsToCharge && (myAliveCareSubscription.collection_method === 'charge_automatically' ? myAliveCareSubscription.default_payment_method ?? (myCustomer && myCustomer.invoice_settings?.default_payment_method) : true);
    const nextCharge = willCharge ? (0, $5d669742300defa8$export$336849d529cb05e5).Instant.fromEpochMilliseconds(myAliveCareSubscription.items.data[0].current_period_end * 1000) : null;
    const lastTerminationTS = myRecords.flatMap((record)=>record.type === (0, $59d988fc10ac8442$export$5c5a1d1aa9bb9b) ? [
            record.timestamp
        ] : []).toSorted((a, b)=>-(0, $5d669742300defa8$export$336849d529cb05e5).Instant.compare(a, b))[0] ?? null;
    const unpaidInvoices = $ce07c05cf9893d37$export$a4034b0bac9332d7({
        myOpenInvoices: myOpenInvoices
    });
    return nextCharge ? {
        terminated: null,
        nextCharge: nextCharge,
        unpaidInvoices: unpaidInvoices
    } : {
        terminated: lastTerminationTS,
        nextCharge: nextCharge,
        unpaidInvoices: unpaidInvoices
    };
}




const $e4d6cc265973b6bf$var$Instant__Brand = Symbol();
const $e4d6cc265973b6bf$var$googleEpoch = (0, $5d669742300defa8$export$336849d529cb05e5).Instant.from('1899-12-30T00:00:00Z');
function $e4d6cc265973b6bf$export$74bd20bbe0ff0cee(val) {
    if (val === undefined) return undefined;
    return $e4d6cc265973b6bf$var$googleEpoch.add({
        seconds: Math.round(val.numberValue * 86400)
    });
}
function $e4d6cc265973b6bf$export$e5a118b8056fd8d9(sheet, parseGInfo) {
    const rows = sheet.data[0].rowData;
    const rawHeader = rows.shift();
    const header = rawHeader.values.map((v)=>v.formattedValue ?? '');
    header[0] = 'id';
    return rows.map((row)=>row.values.map((value)=>value.effectiveValue)).filter((row)=>row[0]).map((row)=>parseGInfo(Object.fromEntries(header.map((h, i)=>[
                h,
                row[i]
            ]))));
}


const $39d30af4ce9385fe$export$6050db5bdb599278 = new Set([
    'Onboarding'
]);
const $39d30af4ce9385fe$export$63d792b7911d2f6c = new Set([
    'Subscription creation',
    'Subscription update',
    'Payment for Invoice'
]);
const $39d30af4ce9385fe$export$317a61243c29498 = [
    'id',
    'customer-id',
    'patient-id',
    'patient-email',
    'created',
    'amount',
    'currency',
    'description',
    'recorded-customer-id',
    'recorded-email'
];
function $39d30af4ce9385fe$var$parsePaymentGInfo(row) {
    return {
        ID: row['id'].stringValue,
        customerID: row['customer-id']?.stringValue,
        patientID: row['patient-id']?.stringValue,
        patientEmail: row['patient-email']?.stringValue,
        created: (0, $e4d6cc265973b6bf$export$74bd20bbe0ff0cee)(row['created']),
        amount: row['amount'].numberValue,
        currency: row['currency'].stringValue,
        description: row['description']?.stringValue,
        recordedCustomerID: row['recorded-customer-id']?.stringValue,
        recordedEmail: row['recorded-email']?.stringValue
    };
}
function $39d30af4ce9385fe$export$4c0404a1207507a4(sheet) {
    return (0, $e4d6cc265973b6bf$export$e5a118b8056fd8d9)(sheet, $39d30af4ce9385fe$var$parsePaymentGInfo);
}


const $c6222f96562fd135$export$51384c9687b05bdc = [
    {
        from: (0, $5d669742300defa8$export$336849d529cb05e5).ZonedDateTime.from('1970-01-01T00:00:00[Europe/Malta]'),
        EURcentsPerMonth: 2000
    },
    {
        from: (0, $5d669742300defa8$export$336849d529cb05e5).ZonedDateTime.from('2026-05-31T00:00:00[Europe/Malta]'),
        EURcentsPerMonth: 2200
    }
];
const $c6222f96562fd135$export$28e0fe47c8d059f5 = $c6222f96562fd135$export$51384c9687b05bdc[$c6222f96562fd135$export$51384c9687b05bdc.length - 1].EURcentsPerMonth;
function $c6222f96562fd135$var$addMonths(date, months) {
    // Temporal.Duration does not support decimal months :(
    const integerMonths = Math.floor(months);
    const remainingMonths = months - integerMonths;
    const thisMonth = date.add({
        months: integerMonths
    });
    const secondsUntilNextMonth = date.add({
        months: integerMonths + 1
    }).since(thisMonth).total('seconds');
    const remainingSeconds = Math.floor(remainingMonths * secondsUntilNextMonth);
    return thisMonth.add({
        seconds: remainingSeconds
    });
}
function $c6222f96562fd135$var$carePriceAt(date) {
    return $c6222f96562fd135$export$51384c9687b05bdc.toReversed().find((price)=>(0, $5d669742300defa8$export$336849d529cb05e5).ZonedDateTime.compare(price.from, date) <= 0);
}
function $c6222f96562fd135$var$nextCarePriceChangeAfter(date) {
    return $c6222f96562fd135$export$51384c9687b05bdc.find((price)=>(0, $5d669742300defa8$export$336849d529cb05e5).ZonedDateTime.compare(price.from, date) > 0)?.from;
}
function $c6222f96562fd135$var$minZonedDateTime(a, b) {
    return (0, $5d669742300defa8$export$336849d529cb05e5).ZonedDateTime.compare(a, b) <= 0 ? a : b;
}
function $c6222f96562fd135$var$getCareWaiverEURcents(customer) {
    const rawWaiver = customer?.metadata.careWaiverEURcents;
    if (rawWaiver === undefined || rawWaiver === '') return 0;
    if (!/^\d+$/.test(rawWaiver)) throw new Error(`Invalid careWaiverEURcents: ${rawWaiver}`);
    const waiver = Number(rawWaiver);
    if (!Number.isSafeInteger(waiver)) throw new Error(`Invalid careWaiverEURcents: ${rawWaiver}`);
    return waiver;
}
function $c6222f96562fd135$var$rawCarePriceEURcentsForPeriod(start, end) {
    let cursor = start;
    let total = 0;
    while((0, $5d669742300defa8$export$336849d529cb05e5).ZonedDateTime.compare(cursor, end) < 0){
        const segmentEnd = $c6222f96562fd135$var$nextCarePriceChangeAfter(cursor);
        const periodEnd = segmentEnd ? $c6222f96562fd135$var$minZonedDateTime(segmentEnd, end) : end;
        total += periodEnd.since(cursor).total({
            unit: 'months',
            relativeTo: cursor
        }) * $c6222f96562fd135$var$carePriceAt(cursor).EURcentsPerMonth;
        cursor = periodEnd;
    }
    return total;
}
function $c6222f96562fd135$export$ae1248c925e9101d(start, end) {
    return Math.floor($c6222f96562fd135$var$rawCarePriceEURcentsForPeriod(start, end));
}
function $c6222f96562fd135$var$addMoney(date, { EURcents: EURcents }) {
    let cursor = date;
    let remaining = EURcents;
    while(remaining > 0){
        const price = $c6222f96562fd135$var$carePriceAt(cursor).EURcentsPerMonth;
        const nextChange = $c6222f96562fd135$var$nextCarePriceChangeAfter(cursor);
        if (!nextChange) return $c6222f96562fd135$var$addMonths(cursor, remaining / price).round({
            smallestUnit: 'second',
            roundingMode: 'trunc'
        });
        const costUntilNextChange = $c6222f96562fd135$var$rawCarePriceEURcentsForPeriod(cursor, nextChange);
        if (remaining < costUntilNextChange) return $c6222f96562fd135$var$addMonths(cursor, remaining / price).round({
            smallestUnit: 'second',
            roundingMode: 'trunc'
        });
        remaining -= costUntilNextChange;
        cursor = nextChange;
    }
    return cursor.round({
        smallestUnit: 'second',
        roundingMode: 'trunc'
    });
}
const $c6222f96562fd135$var$skipIDs = new Set([
    '1TEvdvcXLY98z3MRY2tMIbARUjtS1CESf',
    '1PBhhY4RtEzSl3NHGdPYZvmDUokKVimMc',
    '1yTCOteikgZV6Q7amlvxYZw6_CBnc3aUS',
    '1kBFTvggFZXHj12EIfLlw0-SiVp6dq01P',
    '1KQ_wMj5CseEjzq0NVgUtCxV1i4jCMu10',
    '1IMwbICqXxy9PITioQFbGVvKzAO9tLrv1',
    '1c1RG-H-9ggT6jTE21udtrQZcK2ZYY8ZL',
    '1CWYgnp5NQOg363HqLYz0nwLfoZ9WPmO3',
    '1TQeDQ51b1mC8TmeyNgkRQ5mHaZRRi7Ot',
    '1mvRWoVkK_vDaWSSZO3Sa9rjDKOdF340F',
    '1-mMcXUmGjRC9Yrx0pu7vqWw7tDs8iCn8',
    '1kcufAJLUBP-42KKAjq0TaF-iN_8yDMAw',
    '1dU6KKhc5rol8Iw8h-8mq4cTqFukxJRnB',
    '1-RPYRWxh8gQ1s2olBSoLNoExyn3LKe9p',
    '1COFDUoJBveh-aReci28Kx5SewD_usjqp',
    '1eDPxZVobohG7mmPEI5EjbkJhypv20ola',
    '1qSn9cC4MR4kABbwZANd54vAKiemGllc7',
    '1X_-aW9IoGCSp0aS2JwYxvZlaouuTGU5d',
    '14TcaKn3FOgxP4Ss-zXBDDBbPYKlYD_hj',
    '1DAqMrfu4m_wjV0b2fiyoZPu9_yIYph7C',
    '1rpjYAZO7jJHLzMaZA-H65-LgKu2Oi4nV',
    '1u9bkbxIr1ihAS6azJY8IjJR5yLhhQNjB',
    '1fDspPuykzWq0jfbVRM0IwROCUhT71ZNp'
]);
function $c6222f96562fd135$export$3e8f8cfffee10008({ myCareTS: myCareTS, myCareTerminatedTS: myCareTerminatedTS, myCustomer: myCustomer, myPayments: myPayments, myOpenInvoices: myOpenInvoices, myNextChargeTS: myNextChargeTS, nowTS: nowTS, withMyJustStatedIntentToBeUnderCare: withMyJustStatedIntentToBeUnderCare }) {
    if ([
        ...myOpenInvoices.values().filter((i)=>i.recorded_customer_id !== myCustomer.id)
    ].length) throw new Error('myOpenInvoices should be only directly recorded invoices!');
    const myCareStarted = myCareTS.toZonedDateTimeISO('Europe/Malta').round({
        smallestUnit: 'second',
        roundingMode: 'trunc'
    });
    const iCouldHaveHadFreeMonth = (0, $5d669742300defa8$export$336849d529cb05e5).ZonedDateTime.compare(myCareStarted, (0, $5d669742300defa8$export$336849d529cb05e5).ZonedDateTime.from('2025-09-01T00:00:00[Europe/Malta]')) < 0;
    const myCareFreeMonthEnded = iCouldHaveHadFreeMonth ? myCareStarted.add({
        months: 1
    }) : myCareStarted;
    const myCarePayments = [
        ...myPayments.values().filter((p)=>p.description && (0, $39d30af4ce9385fe$export$63d792b7911d2f6c).has(p.description))
    ];
    const myCarePaymentsSum = myCarePayments.map((p)=>p.amount).reduce((acc, v)=>acc + v, 0);
    const myCarePaidUntil = $c6222f96562fd135$var$addMoney(myCareFreeMonthEnded, {
        EURcents: myCarePaymentsSum
    }).round({
        smallestUnit: 'second',
        roundingMode: 'trunc'
    });
    const myCareInvoicesSum = myOpenInvoices.values().map((p)=>p.amount_remaining).reduce((acc, v)=>acc + v, 0);
    const myCareWaiverSum = $c6222f96562fd135$var$getCareWaiverEURcents(myCustomer);
    const paidOrInvoicedSum = myCarePaymentsSum + myCareInvoicesSum + myCareWaiverSum;
    const myCareInvoicedUntil = $c6222f96562fd135$var$addMoney(myCareFreeMonthEnded, {
        EURcents: paidOrInvoicedSum
    });
    const myCareNextCharge = myNextChargeTS?.toZonedDateTimeISO('Europe/Malta') ?? null;
    const myCareTerminated = withMyJustStatedIntentToBeUnderCare ? null : myCareTerminatedTS?.toZonedDateTimeISO('Europe/Malta') ?? null;
    // Subtract 10 seconds from now, because Stripe crashes if backdate_start_time = now.
    const now = nowTS.toZonedDateTimeISO('Europe/Malta').round({
        smallestUnit: 'second',
        roundingMode: 'trunc'
    }).subtract({
        seconds: 10
    });
    const myCareOrderedUntil = myCareTerminated ?? myCareNextCharge ?? now;
    const correctSum = $c6222f96562fd135$export$ae1248c925e9101d(myCareFreeMonthEnded, myCareOrderedUntil);
    const unallocatedSum = correctSum - paidOrInvoicedSum;
    const totalUnallocatedDays = myCareOrderedUntil.since(myCareInvoicedUntil).total({
        unit: 'days',
        relativeTo: myCareInvoicedUntil
    });
    const totalUnallocatedMonths = myCareOrderedUntil.since(myCareInvoicedUntil).total({
        unit: 'months',
        relativeTo: myCareInvoicedUntil
    });
    const myPastInvoices = new Array();
    let invoicedBefore = {
        EURcents: 0
    };
    for (const payment of myCarePayments.toSorted((a, b)=>a.latest_charge.created - b.latest_charge.created)){
        const invoicedWithThisOne = {
            EURcents: invoicedBefore.EURcents + payment.amount
        };
        myPastInvoices.push({
            start: $c6222f96562fd135$var$addMoney(myCareFreeMonthEnded, invoicedBefore),
            end: $c6222f96562fd135$var$addMoney(myCareFreeMonthEnded, invoicedWithThisOne),
            EURcents: payment.amount,
            paidOn: (0, $5d669742300defa8$export$336849d529cb05e5).Instant.fromEpochMilliseconds(payment.latest_charge.created * 1000).toZonedDateTimeISO('Europe/Malta')
        });
        invoicedBefore = invoicedWithThisOne;
    }
    for (const openInvoice of myOpenInvoices.values()){
        const invoicedWithThisOne = {
            EURcents: invoicedBefore.EURcents + openInvoice.amount_due
        };
        myPastInvoices.push({
            start: $c6222f96562fd135$var$addMoney(myCareFreeMonthEnded, invoicedBefore),
            end: $c6222f96562fd135$var$addMoney(myCareFreeMonthEnded, invoicedWithThisOne),
            EURcents: openInvoice.amount_due,
            paidOn: null
        });
    }
    const breakdown = {
        started: myCareStarted,
        terminated: myCareTerminated,
        freeMonthEnded: myCareFreeMonthEnded,
        paidUntil: myCarePaidUntil,
        invoicedUntil: myCareInvoicedUntil,
        nextCharge: myCareNextCharge,
        today: now,
        pastInvoices: myPastInvoices
    };
    if (totalUnallocatedMonths <= 0) // They were overcharged (ie. voluntarily subscribed for more time than they're under care)
    // No problem for us :P
    return {
        breakdown: breakdown,
        status: `overcharged`,
        overchargedMonths: -totalUnallocatedMonths,
        issueSubscription: !myCareTerminated && !myNextChargeTS ? {} : undefined
    };
    else if (!myCareTerminated && !myNextChargeTS && totalUnallocatedDays < 20) // We can fix that by moving the next charge.
    return {
        breakdown: breakdown,
        status: `move the next charge`,
        overchargedMonths: -totalUnallocatedMonths,
        issueSubscription: {
            start: myCareInvoicedUntil
        }
    };
    else if (totalUnallocatedDays < 20) // We don't want to trouble people when it's not worth it.
    return {
        breakdown: breakdown,
        status: `give a free lunch`,
        overchargedMonths: -totalUnallocatedMonths
    };
    else if (!withMyJustStatedIntentToBeUnderCare && !myNextChargeTS && totalUnallocatedMonths < 1.2) // If somebody has not set up auto payments, we should just message them every month.
    // Note that this is not yet implemented.
    // Still, there is no point in going thru this path for them.
    return {
        breakdown: breakdown,
        status: `give a free lunch (for now)`,
        overchargedMonths: -totalUnallocatedMonths
    };
    else if (!withMyJustStatedIntentToBeUnderCare && totalUnallocatedMonths < 1.2) // Will handle them in the next wave.
    return {
        breakdown: breakdown,
        status: `give a free lunch (for now)`,
        overchargedMonths: -totalUnallocatedMonths
    };
    else if (!withMyJustStatedIntentToBeUnderCare && myCareTerminated) // TODO handle terminated care
    return {
        breakdown: breakdown,
        status: `give a free lunch (because terminated)`,
        overchargedMonths: -totalUnallocatedMonths
    };
    else if (!withMyJustStatedIntentToBeUnderCare && myCustomer && $c6222f96562fd135$var$skipIDs.has(myCustomer.metadata.userID)) return {
        breakdown: breakdown,
        status: `give a free lunch (because status unknown)`,
        overchargedMonths: -totalUnallocatedMonths
    };
    else {
        // We need to issue an invoice for the unpaid time.
        const invoiceFor = unallocatedSum;
        const myCareWillBeInvoicedUntil = $c6222f96562fd135$var$addMoney(myCareFreeMonthEnded, {
            EURcents: paidOrInvoicedSum + invoiceFor
        });
        if (Math.abs(myCareWillBeInvoicedUntil.since(breakdown.terminated ?? breakdown.nextCharge ?? breakdown.today).total('hours')) >= 1) throw new Error(`Programming error`);
        return {
            breakdown: breakdown,
            status: `issue an invoice`,
            overchargedMonths: -totalUnallocatedMonths,
            issueInvoice: {
                start: myCareInvoicedUntil,
                end: myCareWillBeInvoicedUntil,
                EURcents: invoiceFor,
                paidOn: null
            },
            issueSubscription: !myCareTerminated && !myNextChargeTS ? {
                start: myCareWillBeInvoicedUntil
            } : undefined
        };
    }
}



const $621f9fc433cf952f$var$gahtConsentTypes = new Set([
    (0, $b052d1f0285c58fa$export$e4f044c2fd9cdd6a),
    (0, $b052d1f0285c58fa$export$293a15f1e074a8e8)
]);
function $621f9fc433cf952f$var$getMyCareConsent({ myRecords: myRecords }) {
    return myRecords.filter((r)=>$621f9fc433cf952f$var$gahtConsentTypes.has(r.type)).toReversed()[0];
}
function $621f9fc433cf952f$export$38e4ab857e6223db({ myRecords: myRecords }) {
    return $621f9fc433cf952f$var$getMyCareConsent({
        myRecords: myRecords
    })?.timestamp ?? null;
}
function $621f9fc433cf952f$export$ecd48802b214faa4({ myRecords: myRecords }) {
    const myConsent = $621f9fc433cf952f$var$getMyCareConsent({
        myRecords: myRecords
    });
    if (!myConsent) return null;
    return myConsent.type === (0, $b052d1f0285c58fa$export$e4f044c2fd9cdd6a) ? 'FHT' : myConsent.type === (0, $b052d1f0285c58fa$export$293a15f1e074a8e8) ? 'MHT' : undefined;
}








var $acw62 = parcelRequire("acw62");


"use client";
function $e8df1924a4e3fb84$export$32cc39cf62abf4fc(filters, queryClient) {
    const client = (0, $c780594f51309d36$export$22e77b9572c4fded)(queryClient);
    return $e8df1924a4e3fb84$export$29ea95f3fea1dc1c({
        filters: {
            ...filters,
            status: "pending"
        }
    }, client).length;
}
function $e8df1924a4e3fb84$var$getResult(mutationCache, options) {
    return mutationCache.findAll(options.filters).map((mutation)=>options.select ? options.select(mutation) : mutation.state);
}
function $e8df1924a4e3fb84$export$29ea95f3fea1dc1c(options = {}, queryClient) {
    const mutationCache = (0, $c780594f51309d36$export$22e77b9572c4fded)(queryClient).getMutationCache();
    const optionsRef = $acw62.useRef(options);
    const result = $acw62.useRef(null);
    if (!result.current) result.current = $e8df1924a4e3fb84$var$getResult(mutationCache, options);
    $acw62.useEffect(()=>{
        optionsRef.current = options;
    });
    return $acw62.useSyncExternalStore($acw62.useCallback((onStoreChange)=>mutationCache.subscribe(()=>{
            const nextResult = (0, $938ae10f13d49bdc$export$77a71fc411098696)(result.current, $e8df1924a4e3fb84$var$getResult(mutationCache, optionsRef.current));
            if (result.current !== nextResult) {
                result.current = nextResult;
                (0, $e2307e33fb454067$export$520687f44db6e1ab).schedule(onStoreChange);
            }
        }), [
        mutationCache
    ]), ()=>result.current, ()=>result.current);
}



async function $989eaa2e942acd1a$export$451942af9381149c(values) {
    const settlements = await Promise.allSettled(values);
    const errored = settlements.filter((s)=>s.status === 'rejected');
    if (errored.length) throw new AggregateError(errored.flatMap((s)=>s.reason instanceof AggregateError ? s.reason.errors : [
            s.reason
        ]));
    // @ts-ignore
    return settlements.map((s)=>s.value);
}
async function $989eaa2e942acd1a$export$9bcbdb1129349910(values) {
    const settlements = await Promise.allSettled(values);
    const errored = settlements.filter((s)=>s.status === 'rejected');
    if (errored.length) for (const s of errored){
        console.warn(`${s.reason.constructor.name}: ${s.reason}`);
        if (s.reason instanceof AggregateError) for (const error of s.reason.errors)console.warn(`\t${error.constructor.name}: ${error}`);
    }
    // @ts-ignore
    return settlements.map((s)=>s.value);
}













var $c8736404e08bec8e$export$e53ecad5b005a671 = class extends EventTarget {
    dispatchTypedEvent(s, t) {
        return super.dispatchEvent(t);
    }
};


class $7f07014abde66a80$export$6b10c3ba8ac112c2 extends (0, $c8736404e08bec8e$export$e53ecad5b005a671) {
    constructor(clientID, { hd: hd } = {}){
        super();
        this.clientID = clientID;
        this.hd = hd;
        const storedAuth = localStorage.getItem('auth');
        if (storedAuth) this.lastAuthResult = JSON.parse(storedAuth);
    }
    async getNewAccessToken({ prompt: prompt } = {}) {
        let listener = undefined;
        try {
            return await new Promise((resolve, reject)=>{
                let done = false;
                const now = (0, $5d669742300defa8$export$336849d529cb05e5).Now.instant();
                const requestId = 'auth' + Math.round(Math.random() * 1000000);
                listener = (ev)=>{
                    if (ev.origin !== "https://accounts.google.com") return;
                    const data = JSON.parse(ev.data);
                    if (!(data.method === 'fireIdpEvent' && data.params.id === requestId && data.params.type === 'authResult' && data.params.authResult)) return;
                    this.lastAuthResult = {
                        ...data.params.authResult,
                        expires_at: now.add({
                            seconds: data.params.authResult.expires_in
                        }).toString()
                    };
                    localStorage.setItem('auth', JSON.stringify(this.lastAuthResult));
                    this.dispatchTypedEvent('auth', new Event('auth'));
                    done = true;
                    resolve();
                };
                window.addEventListener('message', listener);
                const popup = window.open('https://accounts.google.com/o/oauth2/v2/auth?' + new URLSearchParams({
                    gsiwebsdk: '3',
                    client_id: this.clientID,
                    scope: 'openid profile email https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/spreadsheets.readonly https://www.googleapis.com/auth/calendar.readonly https://www.googleapis.com/auth/calendar.events',
                    redirect_uri: `storagerelay://${location.protocol.substring(0, location.protocol.length - 1)}/${location.host}?id=${requestId}`,
                    prompt: prompt ?? 'none',
                    ...this.hd ? {
                        hd: this.hd
                    } : {},
                    response_type: 'token',
                    include_granted_scopes: 'true'
                }), 'g_auth_token_window', 'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=no,resizable=no,copyhistory=no,width=500,height=550');
                if (!popup) {
                    reject(new Error('Cannot open popup.'));
                    return;
                }
                setTimeout(()=>{
                    if (!done) return;
                    reject(new Error('Auth timeout'));
                }, 30000);
            });
        } finally{
            if (listener) window.removeEventListener('message', listener);
        }
    }
    get hasReadyAccessToken() {
        return this.lastAuthResult !== undefined && (0, $5d669742300defa8$export$336849d529cb05e5).Instant.compare(this.lastAuthResult.expires_at, (0, $5d669742300defa8$export$336849d529cb05e5).Now.instant().add({
            seconds: 60
        })) > 0;
    }
    isSignedIn() {
        return this.hasReadyAccessToken;
    }
    async signIn() {
        await this.getNewAccessToken({
            prompt: 'select_account'
        });
    }
    async getAuth() {
        if (!this.hasReadyAccessToken) await this.getNewAccessToken();
        if (!this.lastAuthResult) throw new Error('Not authenticated');
        return {
            accessToken: this.lastAuthResult.access_token
        };
    }
    async getUserInfo() {
        try {
            return await (await fetch('https://openidconnect.googleapis.com/v1/userinfo', {
                headers: {
                    'Authorization': `Bearer ${(await this.getAuth()).accessToken}`
                }
            })).json();
        } catch (e) {
            console.error(e);
            return null;
        }
    }
}



function $591dab673385be00$export$27742a954190631b(value) {
    if (value === '') throw new Error('Resource ID required');
    return encodeURIComponent(value).replaceAll('.', '%2E');
}
function $591dab673385be00$var$JSON_blobify(data) {
    return new Blob([
        JSON.stringify(data)
    ], {
        type: 'application/json; charset=UTF-8'
    });
}
function $591dab673385be00$var$makeMultipartRelated(parts) {
    const boundary = crypto.randomUUID();
    const type = `multipart/related; boundary=${boundary}`;
    const body = [];
    for (const part of parts){
        body.push(`--${boundary}\r\ncontent-type: ${part.type}\r\n\r\n`);
        body.push(part);
        body.push('\r\n');
    }
    body.push(`--${boundary}--`);
    return new Blob(body, {
        type: type
    });
}
class $591dab673385be00$export$e84700daae7c81c1 {
    constructor(urlPrefix, uploadUrlPrefix, defaultOptions = {}){
        this.urlPrefix = urlPrefix;
        this.uploadUrlPrefix = uploadUrlPrefix;
        this.defaultOptions = defaultOptions;
    }
    async call(remote, method, path, options, data, alt) {
        const hooks = {
            beforeRequest: [
                async (request)=>{
                    const auth = await remote.getAuth();
                    if (auth?.accessToken) request.headers.set('authorization', `Bearer ${auth.accessToken}`);
                    if (auth?.quotaProjectId) request.headers.set('X-Goog-User-Project', auth.quotaProjectId);
                }
            ]
        };
        const _api = (0, $5d669742300defa8$export$6f65e24018a3869f).extend({
            timeout: false,
            prefixUrl: this.urlPrefix,
            hooks: hooks
        });
        const _upload_api = this.uploadUrlPrefix ? (0, $5d669742300defa8$export$6f65e24018a3869f).extend({
            timeout: false,
            prefixUrl: this.uploadUrlPrefix,
            hooks: hooks
        }) : undefined;
        options = {
            ...this.defaultOptions,
            ...options
        };
        let result;
        if (data && data.media) {
            if (!_upload_api) throw new Error('API does not support file upload.');
            const metadata = {
                ...data
            };
            delete metadata.media;
            result = _upload_api(path, {
                method: method,
                searchParams: {
                    ...options,
                    uploadType: 'multipart'
                },
                body: $591dab673385be00$var$makeMultipartRelated([
                    $591dab673385be00$var$JSON_blobify(metadata),
                    data.media
                ])
            });
        } else result = _api(path, {
            method: method,
            searchParams: Object.entries(options).flatMap(([k, v])=>v === undefined ? [] : v instanceof Array ? v.map((vv)=>[
                        k,
                        vv
                    ]) : [
                    [
                        k,
                        v
                    ]
                ]),
            json: data
        });
        try {
            return alt === 'media' ? await result.blob() : await result.json();
        } catch (e) {
            if (e instanceof (0, $5d669742300defa8$export$aa9d629c530f62a7)) e.message += ` (${await e.response.text()})`;
            throw e;
        }
    }
}


const $674a246c452a54b1$var$CalendarV3API = new (0, $591dab673385be00$export$e84700daae7c81c1)('https://www.googleapis.com/calendar/v3/');
async function $674a246c452a54b1$export$bdbca84c84e85f89(remote, calendarID, options = {} // TODO add those options
) {
    return await $674a246c452a54b1$var$CalendarV3API.call(remote, 'GET', `calendars/${(0, $591dab673385be00$export$27742a954190631b)(calendarID)}/events`, options);
}
async function $674a246c452a54b1$export$cd20eeaf55d7856c(remote, calendarID, ID, options = {}) {
    return await $674a246c452a54b1$var$CalendarV3API.call(remote, 'GET', `calendars/${(0, $591dab673385be00$export$27742a954190631b)(calendarID)}/events/${(0, $591dab673385be00$export$27742a954190631b)(ID)}`, options);
}
async function $674a246c452a54b1$export$8f2334781e6e3992(remote, calendarID, ID, data, options = {}) {
    return await $674a246c452a54b1$var$CalendarV3API.call(remote, 'PATCH', `calendars/${(0, $591dab673385be00$export$27742a954190631b)(calendarID)}/events/${(0, $591dab673385be00$export$27742a954190631b)(ID)}`, options, data);
}
async function $674a246c452a54b1$export$e811d060c48241f4(remote, options = {}) {
    return await $674a246c452a54b1$var$CalendarV3API.call(remote, 'GET', `users/me/calendarList`, options);
}



const $64fb5a5723ffc591$var$DocsV1API = new (0, $591dab673385be00$export$e84700daae7c81c1)('https://docs.googleapis.com/v1/');
async function $64fb5a5723ffc591$export$79cf471d28f5e9d3(remote, data, options) {
    return await $64fb5a5723ffc591$var$DocsV1API.call(remote, 'POST', `documents`, options, data);
}
async function $64fb5a5723ffc591$export$eab0734e0bd40e96(remote, ID, options) {
    return await $64fb5a5723ffc591$var$DocsV1API.call(remote, 'GET', `documents/${(0, $591dab673385be00$export$27742a954190631b)(ID)}`, options);
}
async function $64fb5a5723ffc591$export$81298279596ae034(remote, ID, data, options = {}) {
    return await $64fb5a5723ffc591$var$DocsV1API.call(remote, 'POST', `documents/${(0, $591dab673385be00$export$27742a954190631b)(ID)}:batchUpdate`, options, data);
}



const $b71d318ae011068f$var$DriveV3A_API = new (0, $591dab673385be00$export$e84700daae7c81c1)('https://www.googleapis.com/drive/v3/', 'https://www.googleapis.com/upload/drive/v3/', {
    supportsAllDrives: true
});
async function $b71d318ae011068f$export$539548fd26079e3e(remote, options) {
    return await $b71d318ae011068f$var$DriveV3A_API.call(remote, 'GET', `files`, options);
}
async function $b71d318ae011068f$export$387558b1c859aae9(remote, data, options) {
    return await $b71d318ae011068f$var$DriveV3A_API.call(remote, 'POST', `files`, options, data);
}
async function $b71d318ae011068f$export$f1e56a5ba79f7a5a(remote, ID, options) {
    return await $b71d318ae011068f$var$DriveV3A_API.call(remote, 'GET', `files/${(0, $591dab673385be00$export$27742a954190631b)(ID)}`, options);
}
async function $b71d318ae011068f$export$31049559fc23634d(remote, ID, options = {}) {
    return await $b71d318ae011068f$var$DriveV3A_API.call(remote, 'GET', `files/${(0, $591dab673385be00$export$27742a954190631b)(ID)}`, options, undefined, 'media');
}
async function $b71d318ae011068f$export$6e42d74b115f8e58(remote, ID, data, options) {
    return await $b71d318ae011068f$var$DriveV3A_API.call(remote, 'PATCH', `files/${(0, $591dab673385be00$export$27742a954190631b)(ID)}`, options, data);
}



const $ecea853f1255779d$var$SheetsV4API = new (0, $591dab673385be00$export$e84700daae7c81c1)('https://sheets.googleapis.com/v4/');
async function $ecea853f1255779d$export$e38d6af62551bd32(remote, ID, options = {}) {
    return await $ecea853f1255779d$var$SheetsV4API.call(remote, 'GET', `spreadsheets/${(0, $591dab673385be00$export$27742a954190631b)(ID)}`, options);
}
async function $ecea853f1255779d$export$9a1940e903247a57(remote, ID, data, options = {}) {
    return await $ecea853f1255779d$var$SheetsV4API.call(remote, 'POST', `spreadsheets/${(0, $591dab673385be00$export$27742a954190631b)(ID)}:batchUpdate`, options, data);
}
async function $ecea853f1255779d$export$f63027a81daa1bd3(remote, ID, range, data, options = {}) {
    return await $ecea853f1255779d$var$SheetsV4API.call(remote, 'PUT', `spreadsheets/${(0, $591dab673385be00$export$27742a954190631b)(ID)}/values/${(0, $591dab673385be00$export$27742a954190631b)(range)}`, options, data);
}


const $e01873896c1bb36a$var$MimeType__Brand = Symbol();
const $e01873896c1bb36a$var$GDrive_FileID__Brand = Symbol();
const $e01873896c1bb36a$var$GDrive_FolderID__Brand = Symbol();
const $e01873896c1bb36a$var$GDrive_DocumentID__Brand = Symbol();
const $e01873896c1bb36a$var$GCalendar_CalendarID__Brand = Symbol();
const $e01873896c1bb36a$var$GCalendar_EventID__Brand = Symbol();


async function $8b68db5f04c132bd$export$edb39d31be1d67d6(remote, fileID) {
    const file = await (0, $b71d318ae011068f$export$f1e56a5ba79f7a5a)(remote.google, fileID, {
        fields: 'name,parents,mimeType'
    });
    return {
        ...file,
        id: fileID,
        parents: [
            file.parents[0]
        ],
        name: file.name,
        mimeType: file.mimeType
    };
}
async function $8b68db5f04c132bd$var$_SimpleDriveV1_Files_list(remote, folderID, additionalFields) {
    let pageToken = '';
    let files = new Array();
    do {
        const resp = await (0, $b71d318ae011068f$export$539548fd26079e3e)(remote.google, {
            includeItemsFromAllDrives: true,
            corpora: 'drive',
            driveId: remote.driveID,
            pageSize: 1000,
            q: `trashed = false and ${$8b68db5f04c132bd$export$6369087a786c5d89(folderID)} in parents`,
            fields: `files(id,name,mimeType${additionalFields}),incompleteSearch,nextPageToken`,
            pageToken: pageToken
        });
        if (resp.incompleteSearch) console.warn('Incomplete search!');
        pageToken = resp.nextPageToken;
        files.push(...resp.files);
        console.debug(files.length);
    }while (pageToken);
    return files.map((file)=>({
            ...file,
            id: file.id,
            parents: [
                folderID
            ],
            name: file.name,
            mimeType: file.mimeType
        }));
}
async function $8b68db5f04c132bd$export$fa16cd2ab40dfa51(remote, folderID) {
    return await $8b68db5f04c132bd$var$_SimpleDriveV1_Files_list(remote, folderID, '');
}
async function $8b68db5f04c132bd$export$63ec6b13ac00c09b(remote, folderID) {
    return await $8b68db5f04c132bd$var$_SimpleDriveV1_Files_list(remote, folderID, ',createdTime');
}
async function $8b68db5f04c132bd$export$ae11c61b42cbf7c(remote, folderID, name, properties) {
    const file = await (0, $b71d318ae011068f$export$387558b1c859aae9)(remote.google, {
        name: name,
        parents: [
            folderID
        ],
        mimeType: 'application/octet-stream',
        ...properties ? {
            properties: properties
        } : {}
    }, {
        fields: 'id,name,mimeType'
    });
    return {
        id: file.id,
        parents: [
            folderID
        ],
        name: file.name,
        mimeType: file.mimeType
    };
}
async function $8b68db5f04c132bd$export$116829b5e1958be6(remote, folderID, name, content) {
    const file = await (0, $b71d318ae011068f$export$387558b1c859aae9)(remote.google, {
        name: name,
        parents: [
            folderID
        ],
        media: content
    }, {
        fields: 'id,name,mimeType'
    });
    return {
        id: file.id,
        parents: [
            folderID
        ],
        name: file.name,
        mimeType: file.mimeType
    };
}
async function $8b68db5f04c132bd$export$659d9af87daeda5e(remote, ID, name) {
    const file = await (0, $b71d318ae011068f$export$6e42d74b115f8e58)(remote.google, ID, {
        name: name
    }, {
        fields: 'id,parents,name,mimeType'
    });
    return {
        id: file.id,
        parents: [
            file.parents[0]
        ],
        name: file.name,
        mimeType: file.mimeType
    };
}
async function $8b68db5f04c132bd$export$59e6ea71664d9b38(remote, ID) {
    const file = await (0, $b71d318ae011068f$export$6e42d74b115f8e58)(remote.google, ID, {
        trashed: true
    }, {
        fields: 'id,parents,name,mimeType'
    });
    return {
        id: file.id,
        parents: [
            file.parents[0]
        ],
        name: file.name,
        mimeType: file.mimeType
    };
}
async function $8b68db5f04c132bd$export$da97a12ce96b5a24(remote, folderID, name, content) {
    const file = await (0, $b71d318ae011068f$export$387558b1c859aae9)(remote.google, {
        name: name,
        parents: [
            remote.tmpFolderID
        ],
        mimeType: 'application/vnd.google-apps.folder'
    }, {
        fields: 'id'
    });
    const ID = file.id;
    await $8b68db5f04c132bd$export$eaaafcd585a45022(remote, ID, content);
    await (0, $b71d318ae011068f$export$6e42d74b115f8e58)(remote.google, ID, {}, {
        addParents: folderID,
        removeParents: remote.tmpFolderID,
        fields: ''
    });
    return {
        id: ID,
        parents: [
            folderID
        ],
        name: name,
        mimeType: 'application/vnd.google-apps.folder'
    };
}
async function $8b68db5f04c132bd$export$a2c5422e021d55ec(remote, folderID, name) {
    const file = await (0, $b71d318ae011068f$export$387558b1c859aae9)(remote.google, {
        name: name,
        parents: [
            folderID
        ],
        mimeType: 'application/vnd.google-apps.folder'
    }, {
        fields: 'id'
    });
    const ID = file.id;
    return {
        id: ID,
        parents: [
            folderID
        ],
        name: name,
        mimeType: 'application/vnd.google-apps.folder'
    };
}
async function $8b68db5f04c132bd$export$d8ee87d45d77d574(remote, ID) {
    const files = await $8b68db5f04c132bd$export$fa16cd2ab40dfa51(remote, ID);
    const contents = await Promise.all(files.map(async (file)=>[
            file.name,
            await (0, $b71d318ae011068f$export$31049559fc23634d)(remote.google, file.id)
        ]));
    return new Map(contents);
}
async function $8b68db5f04c132bd$export$eaaafcd585a45022(remote, ID, files) {
    await Promise.all([
        ...files
    ].map(async ([name, blob])=>await (0, $b71d318ae011068f$export$387558b1c859aae9)(remote.google, {
            name: name,
            parents: [
                ID
            ],
            media: blob
        }, {
            fields: ''
        })));
}
async function $8b68db5f04c132bd$export$684971a2a095b68f(remote, folderID, name, content) {
    const file = await (0, $b71d318ae011068f$export$387558b1c859aae9)(remote.google, {
        name: name,
        parents: [
            remote.tmpFolderID
        ],
        mimeType: 'application/vnd.google-apps.document'
    }, {
        fields: 'id'
    });
    const ID = file.id;
    await $8b68db5f04c132bd$export$57ce861e003a7dc(remote, ID, content);
    await (0, $b71d318ae011068f$export$6e42d74b115f8e58)(remote.google, ID, {}, {
        addParents: folderID,
        removeParents: remote.tmpFolderID,
        fields: ''
    });
    return {
        id: ID,
        parents: [
            folderID
        ],
        name: name,
        mimeType: 'application/vnd.google-apps.document'
    };
}
async function $8b68db5f04c132bd$export$b0cb5a3918671d3a(remote, folderID, name) {
    const file = await (0, $b71d318ae011068f$export$387558b1c859aae9)(remote.google, {
        name: name,
        parents: [
            folderID
        ],
        mimeType: 'application/vnd.google-apps.document'
    }, {
        fields: 'id'
    });
    const ID = file.id;
    return {
        id: ID,
        parents: [
            folderID
        ],
        name: name,
        mimeType: 'application/vnd.google-apps.document'
    };
}
async function $8b68db5f04c132bd$export$9d81db4d0bbc7d2d(remote, ID) {
    const doc = await (0, $64fb5a5723ffc591$export$eab0734e0bd40e96)(remote.google, ID, {
        fields: 'body'
    });
    const body = doc.body;
    return body.content?.map((x)=>x.paragraph).filter((para)=>para !== undefined).map((para)=>{
        const textWithNewline = para.elements?.map((y)=>y.textRun?.content).filter((y)=>y).join('') || '\n';
        if (textWithNewline[textWithNewline.length - 1] != '\n') throw new Error('Newline expected');
        const text = textWithNewline.substring(0, textWithNewline.length - 1);
        return {
            class: para.paragraphStyle?.namedStyleType ?? 'NORMAL_TEXT',
            text: text.replaceAll('\v', '\n')
        };
    }) ?? [];
}
async function $8b68db5f04c132bd$export$57ce861e003a7dc(remote, ID, blocks) {
    const doc = await (0, $64fb5a5723ffc591$export$eab0734e0bd40e96)(remote.google, ID, {
        fields: 'body'
    });
    const body = doc.body;
    const endIndex = (body.content?.pop()?.endIndex || 1) - 1;
    const vBlocks = blocks.map((block)=>{
        return {
            class: block.class,
            text: block.text.replaceAll('\n', '\v').replaceAll('\r', '')
        };
    });
    const requests = Array();
    if (endIndex > 1) requests.push({
        deleteContentRange: {
            range: {
                startIndex: 1,
                endIndex: endIndex
            }
        }
    });
    if (vBlocks.length) {
        const insertText = {
            text: '',
            endOfSegmentLocation: {}
        };
        requests.push({
            insertText: insertText
        });
        for (const line of vBlocks){
            requests.push({
                updateParagraphStyle: {
                    paragraphStyle: {
                        namedStyleType: line.class
                    },
                    fields: 'namedStyleType',
                    range: {
                        startIndex: insertText.text.length + 1,
                        endIndex: insertText.text.length + 2
                    }
                }
            });
            insertText.text += line.text + '\n';
        }
        insertText.text = insertText.text.substring(0, insertText.text.length - 1);
    }
    if (requests.length) await (0, $64fb5a5723ffc591$export$81298279596ae034)(remote.google, ID, {
        requests: requests
    });
}
function $8b68db5f04c132bd$export$6369087a786c5d89(text) {
    return `'${text.replaceAll('\\', '\\\\').replaceAll('\'', '\\\'')}'`;
}


function $5a8e851e08d041f0$var$str_partition(haystack, sep) {
    const index = haystack.indexOf(sep);
    if (index === -1) return [
        haystack,
        '',
        ''
    ];
    return [
        haystack.substring(0, index),
        sep,
        haystack.substring(index + sep.length)
    ];
}
function $5a8e851e08d041f0$export$b849b2e25cbe4685(file) {
    const [rawTimestamp, sep, name] = $5a8e851e08d041f0$var$str_partition(file.name.trim(), ' ');
    if (!sep) return;
    let timestamp;
    try {
        timestamp = (0, $5d669742300defa8$export$336849d529cb05e5).Instant.from(rawTimestamp);
    } catch (e) {
        return;
    }
    let kindID = name.trim();
    if (!file.parents) throw new TypeError();
    return $5a8e851e08d041f0$export$1559c6534f9d45c8({
        patientID: file.parents[0],
        fileID: file.id,
        timestamp: timestamp,
        kindID: kindID,
        mimeType: file.mimeType
    });
}
function $5a8e851e08d041f0$export$1559c6534f9d45c8({ patientID: patientID, fileID: fileID, timestamp: timestamp, kindID: kindID, mimeType: mimeType }) {
    return {
        ID: `${patientID}/${fileID}`,
        timestamp: timestamp,
        ...(0, $0eecc90764142418$export$260e4fd7df9c643d)(kindID),
        kindID: kindID,
        mimeType: mimeType,
        patientID: patientID,
        fileID: fileID
    };
}
async function $5a8e851e08d041f0$export$fe70143cfa068ef4(remote, folderID) {
    return (await (0, $8b68db5f04c132bd$export$edb39d31be1d67d6)(remote, folderID)).name.trim();
}
async function $5a8e851e08d041f0$export$2e53f596fa2eebb0(remote, folderID) {
    const files = await (0, $8b68db5f04c132bd$export$fa16cd2ab40dfa51)(remote, folderID);
    return files.map($5a8e851e08d041f0$export$b849b2e25cbe4685).filter((EMR)=>EMR !== undefined).toSorted((a, b)=>-(0, $5d669742300defa8$export$336849d529cb05e5).Instant.compare(a.timestamp, b.timestamp));
}
async function $5a8e851e08d041f0$export$a4435067ceb255c6(remote, folderID, timestamp, kindID, properties) {
    const file = await (0, $8b68db5f04c132bd$export$ae11c61b42cbf7c)(remote, folderID, `${timestamp.toString()} ${kindID}`, properties);
    return $5a8e851e08d041f0$export$b849b2e25cbe4685(file);
}
async function $5a8e851e08d041f0$export$5767482a167cb395(remote, folderID, timestamp, kindID) {
    const file = await (0, $8b68db5f04c132bd$export$b0cb5a3918671d3a)(remote, folderID, `${timestamp.toString()} ${kindID}`);
    return $5a8e851e08d041f0$export$b849b2e25cbe4685(file);
}
async function $5a8e851e08d041f0$export$9b9f6c803a88e73d(remote, ID) {
    const readable = await (0, $8b68db5f04c132bd$export$9d81db4d0bbc7d2d)(remote, (0, $a6bd29d179726531$export$f47d8e4f75080825)(ID).fileID);
    return readable.filter((block)=>block.text.length >= 1);
}
async function $5a8e851e08d041f0$export$70f83815d6b76014(remote, ID, readable) {
    await (0, $8b68db5f04c132bd$export$57ce861e003a7dc)(remote, (0, $a6bd29d179726531$export$f47d8e4f75080825)(ID).fileID, readable);
}
async function $5a8e851e08d041f0$export$9aeb6d478bb5d7c4(remote, folderID, timestamp, kindID, readable) {
    const file = await (0, $8b68db5f04c132bd$export$684971a2a095b68f)(remote, folderID, `${timestamp.toString()} ${kindID}`, readable);
    return $5a8e851e08d041f0$export$b849b2e25cbe4685(file);
}
async function $5a8e851e08d041f0$export$ea8def09733cf266(remote, fileID, timestamp, kindID) {
    const file = await (0, $8b68db5f04c132bd$export$659d9af87daeda5e)(remote, fileID, `${timestamp.round('seconds').toString()} ${kindID}`);
    return $5a8e851e08d041f0$export$b849b2e25cbe4685(file);
}
async function $5a8e851e08d041f0$export$8971016bb1d65df9(remote, fileID) {
    await (0, $8b68db5f04c132bd$export$59e6ea71664d9b38)(remote, fileID);
}
async function $5a8e851e08d041f0$export$5cad627e9c5ce179(remote, folderID, timestamp, kindID, content) {
    const file = await (0, $8b68db5f04c132bd$export$da97a12ce96b5a24)(remote, folderID, `${timestamp.toString()} ${kindID}`, content);
    return $5a8e851e08d041f0$export$b849b2e25cbe4685(file);
}











var $acw62 = parcelRequire("acw62");
function $95adfbcee8b79b25$var$roundedNow(roundTo) {
    return (0, $5d669742300defa8$export$336849d529cb05e5).Now.zonedDateTimeISO().round(roundTo).toString();
}
function $95adfbcee8b79b25$export$3a404aece3dff2fa(roundTo) {
    const [now, setNow] = (0, $acw62.useState)($95adfbcee8b79b25$var$roundedNow(roundTo));
    (0, $acw62.useEffect)(()=>{
        const timer = setInterval(()=>{
            setNow($95adfbcee8b79b25$var$roundedNow(roundTo));
        }, 1000);
        return ()=>clearInterval(timer);
    }, []);
    return (0, $5d669742300defa8$export$336849d529cb05e5).ZonedDateTime.from(now);
}



function $1068f99e90f736b6$export$b3611e87cd5ba6ce() {
    const fatUser = (0, $24d88c360a400e92$export$3eee12522424252).use().data;
    return fatUser?.appConfig;
}



function $77084bc593d5d3be$export$20f482f1568a6215() {
    return new Map((0, $e1e31c6aafe0d6d0$export$fb747e25b6eacff1).filter((ps)=>(0, $52954878a4aa76d6$export$ab21a1e7bed2882e)(ps)).map((s)=>[
            s.ID,
            s
        ]));
}
function $77084bc593d5d3be$export$964e8498268f0fe3() {
    return new Map((0, $e1e31c6aafe0d6d0$export$fb747e25b6eacff1).filter((ps)=>(0, $52954878a4aa76d6$export$52050d339844a41f)(ps)).map((p)=>[
            p.ID,
            p
        ]));
}
function $77084bc593d5d3be$export$3e5abc7a70ed919f() {
    return new Map((0, $e1e31c6aafe0d6d0$export$fb747e25b6eacff1).filter((ps)=>(0, $52954878a4aa76d6$export$936c43b2a62a7e7e)(ps)).map((s)=>[
            s.ID,
            s
        ]));
}
function $77084bc593d5d3be$var$getById(map, k, error) {
    if (map === undefined || k === undefined) return undefined;
    const v = map.get(k);
    if (v === undefined) throw error();
    return v;
}
function $77084bc593d5d3be$export$6de4685a6c88b4e9(ID) {
    return $77084bc593d5d3be$var$getById($77084bc593d5d3be$export$20f482f1568a6215(), ID, ()=>new Error('Invalid service ID.'));
}
function $77084bc593d5d3be$export$7d7dab0d475ba5fb(ID) {
    return $77084bc593d5d3be$var$getById($77084bc593d5d3be$export$964e8498268f0fe3(), ID, ()=>new Error('Invalid product ID.'));
}
function $77084bc593d5d3be$export$a8d288f9af175dd(ID) {
    return $77084bc593d5d3be$var$getById($77084bc593d5d3be$export$3e5abc7a70ed919f(), ID, ()=>new Error('Invalid service product ID.'));
}









const $f25923ec82ebad6a$var$YCBM_AccountID_Brand = Symbol();
const $f25923ec82ebad6a$var$YCBM_Subdomain_Brand = Symbol();
const $f25923ec82ebad6a$var$YCBM_ProfileID_Brand = Symbol();
const $f25923ec82ebad6a$var$YCBM_RefRaw_Brand = Symbol();
const $f25923ec82ebad6a$var$YCBM_RefFormatted_Brand = Symbol();
const $f25923ec82ebad6a$var$YCBM_IntentSecret__Brand = Symbol();
function $f25923ec82ebad6a$export$3fa038a88db231a(ref) {
    if (ref.length != 12) throw new Error();
    return `${ref.substring(0, 4)}-${ref.substring(4, 8)}-${ref.substring(8, 12)}`;
}
class $f25923ec82ebad6a$export$eea6003d3edffe75 {
    constructor(uri){
        this.uri = uri;
    }
    get api() {
        return this.uri.api;
    }
    get accountID() {
        return this.uri.username;
    }
}
async function $f25923ec82ebad6a$export$4934d4d7fdee6006(ycbm) {
    const profiles = new Array();
    const data = await ycbm.api.get(`v1/profiles?ownerId=${ycbm.accountID}`).json();
    profiles.push(...data);
    return profiles;
}
async function $f25923ec82ebad6a$export$ebb7de9fe3078768(ycbm, params) {
    return await ycbm.api.post(`v1/intents`, {
        json: params
    }).json();
}
async function $f25923ec82ebad6a$export$149b7d4b6d20e6fb(ycbm, intentSecret) {
    const date1 = (0, $5d669742300defa8$export$336849d529cb05e5).Now.plainDateISO('UTC').subtract({
        days: 1
    });
    const date2 = date1.add({
        days: 30
    });
    const dates = [
        date1,
        date2
    ];
    return [
        ...new Set((await Promise.all(dates.map(async (date)=>{
            const keyresponse = await ycbm.api.get(`v1/intents/${intentSecret}/availabilitykey?startSearchAt=${date}`).json();
            const avresponse = await ycbm.api.get(`v1/availabilities/${keyresponse.key}`).json();
            return avresponse.slots;
        }))).flatMap((ss)=>ss.map((s)=>s.startsAt)).toSorted())
    ].map((slot)=>(0, $5d669742300defa8$export$336849d529cb05e5).Instant.fromEpochMilliseconds(parseInt(slot)));
}
async function $f25923ec82ebad6a$export$1e6ab54f38824d7c(ycbm, intentSecret, params) {
    return await ycbm.api.patch(`v1/intents/${intentSecret}/selections`, {
        json: params
    }).json();
}
async function $f25923ec82ebad6a$export$2e1b04f4c63a5c3c(ycbm, intentSecret, params) {
    return await ycbm.api.patch(`v1/intents/${intentSecret}/selections`, {
        json: params
    }).json();
}
async function $f25923ec82ebad6a$export$1d3ba8ce73ddd7b4(ycbm, intentSecret, params = {}) {
    return await ycbm.api.patch(`v1/intents/${intentSecret}/confirm`, {
        json: params
    }).json();
}
async function $f25923ec82ebad6a$export$34579ac8461a6d6e(ycbm, intentSecret) {
    await ycbm.api.patch(`v1/intents/${intentSecret}/booking/cancel`, {
        json: {}
    });
}
async function $f25923ec82ebad6a$export$df25eed184cbf611(ycbm, { search: search } = {}) {
    const bookings = new Array();
    let resp = await ycbm.api.get(`v1/${ycbm.accountID}/bookings`, {
        searchParams: {
            ...search !== undefined ? {
                search: search
            } : {},
            from: '2000-01-01T00:00:00Z',
            direction: 'forwards',
            fields: '*,answers.code,answers.string'
        }
    });
    let data = await resp.json();
    while(resp && data.length){
        bookings.push(...data);
        console.debug(bookings.length);
        const links = $f25923ec82ebad6a$var$parseLinkHeaders(resp.headers.get('link') ?? '');
        const next = links.get('next');
        if (next) {
            resp = await ycbm.api.get(next, {
                prefixUrl: ''
            });
            data = await resp.json();
        } else {
            resp = null;
            data = [];
        }
    }
    return bookings;
}
function $f25923ec82ebad6a$var$parseLinkHeaders(linkHeaders) {
    return new Map(linkHeaders.split(',').map((linkHeader)=>{
        const segments = linkHeader.split(';').map((seg)=>seg.trim());
        const rawUri = segments.shift();
        if (rawUri[0] !== '<' || rawUri[rawUri.length - 1] !== '>') throw new Error('Invalid link header');
        const uri = decodeURIComponent(rawUri.substring(1, rawUri.length - 1));
        const params = new Map(segments.map((p)=>{
            const eqPos = $f25923ec82ebad6a$var$indexOf(p, '=');
            const key = p.substring(0, eqPos ?? undefined).trim();
            const rawValue = eqPos ? p.substring(eqPos + 1).trim() : '';
            const value = rawValue[0] === '"' ? rawValue.substring(1, rawValue.length - 1) : rawValue;
            return [
                key,
                value
            ];
        }));
        return [
            params.get('rel') ?? '',
            uri
        ];
    }));
}
function $f25923ec82ebad6a$var$indexOf(haystack, s) {
    const pos = haystack.indexOf(s);
    if (pos === -1) return null;
    return pos;
}



const $61899bf53dd757a9$var$writeToYCBM = true;
const $61899bf53dd757a9$var$ycbm = new (0, $f25923ec82ebad6a$export$eea6003d3edffe75)((0, $eeb6398b2a94869c$export$88ad8fe362b4552e).parse('https://api.youcanbook.me'));
const $61899bf53dd757a9$var$AppointmentsQuery = {
    use () {
        const appointments = (0, $24d88c360a400e92$export$3eee12522424252).use().data?.appointments;
        const config = (0, $1068f99e90f736b6$export$b3611e87cd5ba6ce)();
        if (config.testMode) {
            const welcomed = (0, $8608494418c9c764$export$9c0070fa2f1576ef)();
            if (welcomed === true) return {
                data: appointments?.filter((app)=>app.serviceID != (0, $0eecc90764142418$export$64fb8ef928532180))
            };
        }
        return {
            data: appointments
        };
    },
    async add (qc, result) {
        await (0, $24d88c360a400e92$export$3eee12522424252).patchData(qc, [], (old)=>({
                ...old,
                appointments: [
                    ...old.appointments || [],
                    result
                ]
            }));
    },
    async remove (qc, cached) {
        await (0, $24d88c360a400e92$export$3eee12522424252).patchData(qc, [], (old)=>({
                ...old,
                appointments: old.appointments.filter((app)=>app.ycbm_secret != cached.ycbm_secret)
            }));
    },
    async invalidate (qc, t) {
        await (0, $24d88c360a400e92$export$3eee12522424252).invalidate(qc, []);
    }
};
function $61899bf53dd757a9$export$68768993c27c832b() {
    return $61899bf53dd757a9$var$AppointmentsQuery.use().data;
}
function $61899bf53dd757a9$export$597f86bf439bd7d0(serviceID) {
    const appointments = $61899bf53dd757a9$export$68768993c27c832b();
    if (serviceID === undefined || appointments === undefined) return;
    const filtered = appointments.filter((app)=>app.serviceID === serviceID);
    return filtered.length > 0 ? filtered[0] : null;
}
const $61899bf53dd757a9$var$bookableSlotsMap = new Map();
function $61899bf53dd757a9$export$b5219305ced749f4(intent) {
    if (!$61899bf53dd757a9$var$bookableSlotsMap.get(intent)) $61899bf53dd757a9$var$bookableSlotsMap.set(intent, (async ()=>{
        const ycbmIntentID = (await intent).ycbm_secret;
        return (await (0, $f25923ec82ebad6a$export$149b7d4b6d20e6fb)($61899bf53dd757a9$var$ycbm, ycbmIntentID)).map((slot)=>slot.toZonedDateTimeISO((0, $5d669742300defa8$export$336849d529cb05e5).Now.timeZoneId()));
    })());
    return $61899bf53dd757a9$var$bookableSlotsMap.get(intent);
}
function $61899bf53dd757a9$export$9e0427a0fb3a2f99({ service: service, intent: intent }) {
    const isIntentBooked = $61899bf53dd757a9$export$597f86bf439bd7d0(service.ID);
    if (isIntentBooked) throw new Error('Already booked');
    const qc = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const mutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: async ({ slot: slot })=>{
            const ycbmIntentID = (await intent).ycbm_secret;
            try {
                if ($61899bf53dd757a9$var$writeToYCBM) {
                    await (0, $f25923ec82ebad6a$export$1e6ab54f38824d7c)($61899bf53dd757a9$var$ycbm, ycbmIntentID, {
                        startsAt: slot.toInstant().epochMilliseconds,
                        timeZone: slot.timeZoneId
                    });
                    await (0, $f25923ec82ebad6a$export$2e1b04f4c63a5c3c)($61899bf53dd757a9$var$ycbm, ycbmIntentID, {
                        teamMemberId: "AUTO"
                    });
                    await (0, $f25923ec82ebad6a$export$1d3ba8ce73ddd7b4)($61899bf53dd757a9$var$ycbm, ycbmIntentID);
                }
                const appointment = {
                    serviceID: service.ID,
                    duration: service.duration,
                    start: slot,
                    end: slot.add(service.duration),
                    ycbm_secret: ycbmIntentID
                };
                $61899bf53dd757a9$var$AppointmentsQuery.add(qc, appointment);
                return appointment;
            } finally{
                $61899bf53dd757a9$var$AppointmentsQuery.invalidate(qc, []);
            }
        }
    });
    if (isIntentBooked === undefined) return;
    return mutation;
}
function $61899bf53dd757a9$export$2c5cdb5ac2ac9b3f({ appointment: appointment }) {
    const ycbmIntentID = appointment?.ycbm_secret;
    const isIntentBooked = $61899bf53dd757a9$export$597f86bf439bd7d0(appointment?.serviceID);
    const qc = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const mutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: async ()=>{
            try {
                if ($61899bf53dd757a9$var$writeToYCBM) await (0, $f25923ec82ebad6a$export$34579ac8461a6d6e)($61899bf53dd757a9$var$ycbm, ycbmIntentID);
                $61899bf53dd757a9$var$AppointmentsQuery.remove(qc, appointment);
            } finally{
                $61899bf53dd757a9$var$AppointmentsQuery.invalidate(qc, []);
            }
        }
    });
    if (ycbmIntentID === undefined || isIntentBooked === undefined) return;
    return isIntentBooked ? mutation : null;
}






async function $b65e8c04b9a293c5$export$81fad94074969359(request) {
    return await (0, $49da1b68da864759$export$644d8ea042df96a6).post('intents/', {
        json: request
    }).json();
}
function $b65e8c04b9a293c5$export$4d093cbddae87bf2(request) {
    return {
        request: request,
        ...(0, $25f3549ac7b3cc04$export$7c29c638d2663c7c)(()=>$b65e8c04b9a293c5$export$81fad94074969359(request))
    };
}



const $7c7ab1995ec5d09f$export$8b9a6efd03876208 = {
    use () {
        return {
            data: (0, $24d88c360a400e92$export$3eee12522424252).use().data?.inventory
        };
    },
    async setData (qc, k, inventory) {
        await (0, $24d88c360a400e92$export$3eee12522424252).patchData(qc, [], (old)=>({
                ...old,
                inventory: inventory
            }));
    },
    async invalidate (qc, k) {
        await (0, $24d88c360a400e92$export$3eee12522424252).invalidate(qc, []);
    }
};
function $7c7ab1995ec5d09f$var$useInventory() {
    return $7c7ab1995ec5d09f$export$8b9a6efd03876208.use().data;
}
function $7c7ab1995ec5d09f$export$b98a657d45c03d6f(productID) {
    const inventory = $7c7ab1995ec5d09f$var$useInventory();
    return inventory?.includes(productID);
}








const $d7de34ca5c825acf$var$ProfileQuery = {
    use () {
        return {
            data: (0, $24d88c360a400e92$export$3eee12522424252).use().data?.userProfile
        };
    },
    async setData (qc, k, userProfile) {
        await (0, $24d88c360a400e92$export$3eee12522424252).patchData(qc, [], (old)=>({
                ...old,
                userProfile: userProfile
            }));
    },
    async invalidate (qc, k) {
        await (0, $24d88c360a400e92$export$3eee12522424252).invalidate(qc, []);
    }
};
function $d7de34ca5c825acf$export$73fc7af4ef9455f4() {
    return $d7de34ca5c825acf$var$ProfileQuery.use().data;
}
function $d7de34ca5c825acf$export$493bff358814b51e() {
    const now = (0, $95adfbcee8b79b25$export$3a404aece3dff2fa)('hour');
    const profile = $d7de34ca5c825acf$export$73fc7af4ef9455f4();
    if (profile === undefined || profile === null) return;
    return (0, $5d669742300defa8$export$336849d529cb05e5).PlainDate.compare(now.toPlainDate(), profile.dateOfBirth.add({
        years: 18
    })) >= 0;
}
function $d7de34ca5c825acf$export$9b3562d446df4d7d() {
    const qc = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const mutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: async (profile)=>{
            try {
                await (0, $49da1b68da864759$export$644d8ea042df96a6).put('user-profile/', {
                    json: (0, $8fdb24a91a7eb479$export$54cbe7c5756cc989)(profile)
                });
                $d7de34ca5c825acf$var$ProfileQuery.setData(qc, [], profile);
            } catch (e) {
                $d7de34ca5c825acf$var$ProfileQuery.invalidate(qc, []);
                throw e;
            }
        }
    });
    return mutation;
}






const $aa2f325cf629321d$var$SurgeryInterestQuery = {
    use () {
        return {
            data: (0, $24d88c360a400e92$export$3eee12522424252).use().data?.userSurgeryInterest
        };
    },
    async setData (qc, k, userSurgeryInterest) {
        await (0, $24d88c360a400e92$export$3eee12522424252).patchData(qc, [], (old)=>({
                ...old,
                userSurgeryInterest: userSurgeryInterest
            }));
    },
    async invalidate (qc, k) {
        await (0, $24d88c360a400e92$export$3eee12522424252).invalidate(qc, []);
    }
};
function $aa2f325cf629321d$export$269468d81568067d() {
    return $aa2f325cf629321d$var$SurgeryInterestQuery.use().data;
}
function $aa2f325cf629321d$export$7e3023a240541932() {
    const qc = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const mutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: async (surgeryInterest)=>{
            try {
                await (0, $49da1b68da864759$export$644d8ea042df96a6).put('user-surgery-interest/', {
                    json: (0, $49546e8ba8030a20$export$92df1a515756d078)(surgeryInterest)
                });
                $aa2f325cf629321d$var$SurgeryInterestQuery.setData(qc, [], surgeryInterest);
            } catch (e) {
                $aa2f325cf629321d$var$SurgeryInterestQuery.invalidate(qc, []);
                throw e;
            }
        }
    });
    return mutation;
}
function $aa2f325cf629321d$export$ed440454d2008047() {
    const mutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: async (surgeryRequest)=>{
            await (0, $49da1b68da864759$export$644d8ea042df96a6).put('user-surgery-request/', {
                json: (0, $93f393cc36b347a9$export$90d8848701dcee14)(surgeryRequest)
            });
        }
    });
    return mutation;
}



const $79bc64e05e8d2c0f$var$oldInvoices = new Map();
function $79bc64e05e8d2c0f$export$4e8008831e5d1d5c(ID) {
    if (ID === undefined) return;
    const care = (0, $e2ed673c8add7fd1$export$edf4a2eb8cf50264)();
    if (care === undefined) return;
    const { unpaidInvoices: unpaidInvoices } = care;
    const invoice = unpaidInvoices.filter((i)=>i.ID === ID)[0];
    if (!invoice) {
        const oldInvoice = $79bc64e05e8d2c0f$var$oldInvoices.get(ID);
        if (!oldInvoice) throw new Error('Invalid invoice ID');
        oldInvoice.amountRemaining = 0;
        return oldInvoice;
    }
    $79bc64e05e8d2c0f$var$oldInvoices.set(invoice.ID, invoice);
    return invoice;
}











var $acw62 = parcelRequire("acw62");




const $3a6539ac03d750fd$var$locale = 'en-GB';
function $3a6539ac03d750fd$var$CalendarTable({ weeks: weeks, selectedDay: selectedDay, availableDays: availableDays, onDaySelected: onDaySelected }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
        className: "calendar",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "M"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "T"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "W"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "T"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "F"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "S"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "S"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                children: weeks.map((week, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                        children: week.map((day, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                "data-done": day && (0, $5d669742300defa8$export$336849d529cb05e5).PlainDate.compare(day, (0, $5d669742300defa8$export$336849d529cb05e5).Now.plainDateISO()) < 0 ? true : undefined,
                                "data-active": day && selectedDay && day.equals(selectedDay) ? true : undefined,
                                "data-today": day && day.equals((0, $5d669742300defa8$export$336849d529cb05e5).Now.plainDateISO()) ? true : undefined,
                                onClick: (ev)=>{
                                    if (!day || (0, $5d669742300defa8$export$336849d529cb05e5).PlainDate.compare(day, (0, $5d669742300defa8$export$336849d529cb05e5).Now.plainDateISO()) < 0) return;
                                    ev.preventDefault();
                                    onDaySelected(day);
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    disabled: !day || !availableDays.has(day.toString()) ? true : undefined,
                                    children: day?.day ?? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: "\xa0"
                                    })
                                })
                            }, index))
                    }, index))
            })
        ]
    });
}
function $3a6539ac03d750fd$var$CalendarMonthView({ month: month, selectedDay: selectedDay, availableDays: availableDays, onMonthSelected: onMonthSelected, onDaySelected: onDaySelected }) {
    const firstDay = month.toPlainDate({
        day: 1
    });
    const lastDay = month.add({
        months: 1
    }).toPlainDate({
        day: 1
    }).subtract({
        days: 1
    });
    const weeks = Array();
    let week = Array();
    for(let i = 1; i < firstDay.dayOfWeek; ++i)week.push(undefined);
    for(let day = firstDay; (0, $5d669742300defa8$export$336849d529cb05e5).PlainDate.compare(day, lastDay) <= 0; day = day.add({
        days: 1
    })){
        week.push(day);
        if (day.dayOfWeek == 7) {
            weeks.push(week);
            week = [];
        }
    }
    for(let i = 7; i > lastDay.dayOfWeek; --i)week.push(undefined);
    if (week) weeks.push(week);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "month",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("hgroup", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                        className: "display-small",
                        children: month.toLocaleString($3a6539ac03d750fd$var$locale, {
                            month: 'long',
                            year: 'numeric',
                            calendar: 'iso8601'
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        role: "toolbar",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: (ev)=>{
                                    ev.preventDefault();
                                    onMonthSelected(month.subtract({
                                        months: 1
                                    }));
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "material-symbols-outlined",
                                    children: "keyboard_arrow_up"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: (ev)=>{
                                    ev.preventDefault();
                                    onMonthSelected(month.add({
                                        months: 1
                                    }));
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "material-symbols-outlined",
                                    children: "keyboard_arrow_down"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3a6539ac03d750fd$var$CalendarTable, {
                weeks: weeks,
                selectedDay: selectedDay,
                onDaySelected: onDaySelected,
                availableDays: availableDays
            })
        ]
    });
}
function $3a6539ac03d750fd$var$CalendarDayView({ day: day, availableDays: availableDays, availableTimes: availableTimes, onDaySelected: onDaySelected, onTimeSelected: onTimeSelected }) {
    const firstWeekDay = day.subtract({
        days: day.dayOfWeek - 1
    });
    const week = [];
    for(let i = 0; i < 7; ++i)week.push(firstWeekDay.add({
        days: i
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "week",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3a6539ac03d750fd$var$CalendarTable, {
                    weeks: [
                        week
                    ],
                    selectedDay: day,
                    onDaySelected: onDaySelected,
                    availableDays: availableDays
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "day",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("hgroup", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                className: "display-small",
                                children: day.toLocaleString($3a6539ac03d750fd$var$locale, {
                                    month: "short",
                                    day: "numeric",
                                    weekday: "short"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                role: "toolbar",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: (ev)=>{
                                            ev.preventDefault();
                                            onDaySelected(undefined);
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "material-symbols-outlined",
                                            children: "calendar_month"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        disabled: (0, $5d669742300defa8$export$336849d529cb05e5).PlainDate.compare(day.subtract({
                                            days: 1
                                        }), (0, $5d669742300defa8$export$336849d529cb05e5).Now.plainDateISO()) < 0 ? true : undefined,
                                        onClick: (ev)=>{
                                            ev.preventDefault();
                                            onDaySelected(day.subtract({
                                                days: 1
                                            }));
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "material-symbols-outlined",
                                            children: "keyboard_arrow_left"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: (ev)=>{
                                            ev.preventDefault();
                                            onDaySelected(day.add({
                                                days: 1
                                            }));
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "material-symbols-outlined",
                                            children: "keyboard_arrow_right"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "scrollable",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "radio-pool",
                            children: [
                                [
                                    ...availableTimes
                                ].map((t)=>{
                                    const time = (0, $5d669742300defa8$export$336849d529cb05e5).PlainTime.from(t);
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: (ev)=>{
                                            ev.preventDefault();
                                            onTimeSelected(time);
                                        },
                                        children: time.toLocaleString($3a6539ac03d750fd$var$locale, {
                                            timeStyle: 'short'
                                        })
                                    }, t);
                                }),
                                availableTimes.size ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: "No free time slots on this day."
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
function $3a6539ac03d750fd$var$Calendar({ intent: intent, onSlotSelected: onSlotSelected }) {
    const bookableSlots = (0, $acw62.use)((0, $61899bf53dd757a9$export$b5219305ced749f4)(intent));
    return bookableSlots.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "Sorry, there are no times available right now. Please check again later."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    "You may also contact our support team at ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        href: "mailto:support@imago.tg",
                        children: "support@imago.tg"
                    }),
                    "."
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3a6539ac03d750fd$var$_Calendar, {
        bookableSlots: bookableSlots,
        onSlotSelected: onSlotSelected
    });
}
function $3a6539ac03d750fd$var$_Calendar({ bookableSlots: bookableSlots, onSlotSelected: onSlotSelected }) {
    if (!bookableSlots[0]) throw new Error('Programming error');
    const [month, _setMonth] = (0, $acw62.useState)(bookableSlots[0].toPlainDate().toPlainYearMonth());
    const [day, _setDay] = (0, $acw62.useState)();
    function setMonth(month) {
        _setMonth(month);
    }
    function setDay(day) {
        _setDay(day);
        if (day) _setMonth(day.toPlainYearMonth());
    }
    function setTime(time) {
        if (!day) throw new Error();
        onSlotSelected(day.toPlainDateTime(time).toZonedDateTime((0, $5d669742300defa8$export$336849d529cb05e5).Now.timeZoneId()));
    }
    const availableSlots = bookableSlots ? [
        ...Map.groupBy(bookableSlots, (slot)=>slot.toPlainDate().toString())
    ].map(([date, slots])=>{
        return {
            day: (0, $5d669742300defa8$export$336849d529cb05e5).PlainDate.from(date),
            slots: slots.map((slot)=>slot.toPlainTime())
        };
    }) : [];
    const availableDays = new Set(availableSlots.map((ad)=>ad.day.toString()));
    const availableTimes = new Set(day ? Array().concat(...availableSlots.filter((ad)=>ad.day.equals(day)).map((ad)=>ad.slots.map((time)=>time.toString()))) : []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: day ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3a6539ac03d750fd$var$CalendarDayView, {
            day: day,
            onDaySelected: setDay,
            availableDays: availableDays,
            availableTimes: availableTimes,
            onTimeSelected: setTime
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3a6539ac03d750fd$var$CalendarMonthView, {
            month: month,
            selectedDay: undefined,
            onMonthSelected: setMonth,
            onDaySelected: setDay,
            availableDays: availableDays
        })
    });
}
function $3a6539ac03d750fd$export$2e6a7cb81fe42451({ appointment: appointment, draft: draft, service: serviceParam, showTips: showTips = false }) {
    const service = (0, $77084bc593d5d3be$export$6de4685a6c88b4e9)(appointment?.serviceID) ?? serviceParam;
    const cancel = (0, $61899bf53dd757a9$export$2c5cdb5ac2ac9b3f)({
        appointment: appointment
    });
    const now = (0, $95adfbcee8b79b25$export$3a404aece3dff2fa)('minute');
    const confirmed = appointment && draft !== true;
    const reschedulable = confirmed && service !== undefined ? (0, $5d669742300defa8$export$336849d529cb05e5).ZonedDateTime.compare(appointment.start.subtract(service.freezeTime), now) > 0 : false;
    const joinable = confirmed ? (0, $5d669742300defa8$export$336849d529cb05e5).ZonedDateTime.compare(appointment.start.subtract({
        minutes: 30
    }), now) < 0 : false;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                className: "appointment",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                        children: service?.title
                    }),
                    appointment ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                        children: "Date:"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                        children: appointment.start.toLocaleString($3a6539ac03d750fd$var$locale, {
                                            dateStyle: "full"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                        children: "Time:"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dd", {
                                        children: [
                                            appointment.start.toLocaleString($3a6539ac03d750fd$var$locale, {
                                                hour: "numeric",
                                                minute: "numeric"
                                            }),
                                            " - ",
                                            appointment.end.toLocaleString($3a6539ac03d750fd$var$locale, {
                                                hour: "numeric",
                                                minute: "numeric"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                                children: [
                                                    "(",
                                                    appointment.start.timeZoneId,
                                                    ")"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                children: "Duration:"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                children: (appointment ?? service).duration.toLocaleString($3a6539ac03d750fd$var$locale, {
                                    style: 'long'
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                children: "App:"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                children: "Google Meet"
                            })
                        ]
                    }),
                    confirmed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "row",
                                style: {
                                    justifyContent: "end"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$857ebcebc4ae5918), {
                                        disabledBecause: !reschedulable ? `The call can only be rescheduled ${service?.freezeTime.hours} hours before or earlier.` : undefined,
                                        mutation: cancel,
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$cda51eb07c9d035c), {
                                        className: "primary",
                                        disabledBecause: !joinable ? `The call is not ready yet. Please come back nearer the start time.` : undefined,
                                        href: appointment.googleMeetLink ?? null,
                                        children: "Join call"
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                ]
            }),
            showTips ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    service ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                            children: [
                                "The call can only be rescheduled or cancelled at\xa0least\xa0",
                                service.freezeTime.hours,
                                "\xa0hours in advance."
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    confirmed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                            children: "The join button becomes active half an hour before."
                        })
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
        ]
    });
}
function $3a6539ac03d750fd$export$71540c2ebad0fa07({ mutation: mutation }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $25f3549ac7b3cc04$export$3ddf2d174ce01153), {
        mutation: mutation,
        children: mutation.intent === null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3a6539ac03d750fd$var$Book, {
            request: mutation.request,
            intent: mutation.intent
        })
    });
}
function $3a6539ac03d750fd$var$Book({ request: request, intent: intent }) {
    const service = (0, $77084bc593d5d3be$export$6de4685a6c88b4e9)(request.serviceID);
    const [selectedSlot, setSelectedSlot] = (0, $acw62.useState)();
    const draftAppointment = selectedSlot ? {
        serviceID: service.ID,
        duration: service.duration,
        start: selectedSlot,
        end: selectedSlot.add(service.duration)
    } : undefined;
    const book = (0, $61899bf53dd757a9$export$9e0427a0fb3a2f99)({
        service: service,
        intent: intent
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
        children: [
            draftAppointment ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                children: "Confirm your booking"
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                children: "Book your call"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3a6539ac03d750fd$export$2e6a7cb81fe42451, {
                        draft: true,
                        appointment: draftAppointment,
                        service: service,
                        showTips: true
                    }),
                    !draftAppointment ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                        children: "Choose a time that works for you"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3a6539ac03d750fd$var$Calendar, {
                                        intent: intent,
                                        onSlotSelected: setSelectedSlot
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$8b7b7cdfb85d78c5), {
                        mutation: book,
                        disabledBecause: !draftAppointment ? 'Choose a time' : undefined,
                        vars: (data)=>({
                                slot: draftAppointment.start
                            }),
                        onSuccess: (0, $25f3549ac7b3cc04$export$d8e990c7994e01bd),
                        children: "Confirm"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $25f3549ac7b3cc04$export$488fee190faedb43), {
                        children: "Cancel"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                "data-total": true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("aside", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                        children: [
                            "Time zone: ",
                            (0, $5d669742300defa8$export$336849d529cb05e5).Now.timeZoneId(),
                            " (",
                            (0, $5d669742300defa8$export$336849d529cb05e5).Now.plainTimeISO().toLocaleString($3a6539ac03d750fd$var$locale, {
                                timeStyle: 'short'
                            }),
                            ")"
                        ]
                    })
                })
            })
        ]
    });
}
function $3a6539ac03d750fd$export$a2838450ef33c04b({ serviceID: serviceID }) {
    return (0, $b65e8c04b9a293c5$export$4d093cbddae87bf2)({
        verb: 'book',
        serviceID: serviceID
    });
}




function $664142bc47862dbd$var$BookACall() {
    const bookSetup = (0, $3a6539ac03d750fd$export$a2838450ef33c04b)({
        serviceID: (0, $0eecc90764142418$export$b4f1735772031582)
    });
    const bookTransfer = (0, $3a6539ac03d750fd$export$a2838450ef33c04b)({
        serviceID: (0, $0eecc90764142418$export$2c5eb80d7ad70118)
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$8b7b7cdfb85d78c5), {
                        mutation: bookSetup,
                        vars: (data)=>{},
                        children: "I want to start GAHT"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$8b7b7cdfb85d78c5), {
                        mutation: bookTransfer,
                        vars: (data)=>{},
                        children: "I\u2019m already on GAHT, I want to move to Imago"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a6539ac03d750fd$export$71540c2ebad0fa07), {
                mutation: bookSetup
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a6539ac03d750fd$export$71540c2ebad0fa07), {
                mutation: bookTransfer
            })
        ]
    });
}
function $664142bc47862dbd$export$298e455caafaaa94() {
    const setupAppointment = (0, $61899bf53dd757a9$export$597f86bf439bd7d0)((0, $0eecc90764142418$export$b4f1735772031582));
    const transferAppointment = (0, $61899bf53dd757a9$export$597f86bf439bd7d0)((0, $0eecc90764142418$export$2c5eb80d7ad70118));
    const appointment = setupAppointment === undefined || transferAppointment === undefined ? undefined : setupAppointment ?? transferAppointment;
    return appointment;
}
function $664142bc47862dbd$export$e9b34cf4e83b7771({ allowed: allowed }) {
    const appointment = $664142bc47862dbd$export$298e455caafaaa94();
    const service = (0, $77084bc593d5d3be$export$6de4685a6c88b4e9)(appointment?.serviceID);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                children: "Talk with our physician"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "Our physician will tell you everything you need to know about the Gender-Affirming Hormone Therapy, and will answer your questions. They\u2019ll also review your medical history and blood tests, to ensure that the therapy is safe and efficient."
            }),
            appointment ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a6539ac03d750fd$export$2e6a7cb81fe42451), {
                    appointment: appointment,
                    service: service,
                    showTips: true
                })
            }) : allowed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($664142bc47862dbd$var$BookACall, {})
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    children: "To book a call - please finish the above steps first."
                })
            })
        ]
    });
}


const $8608494418c9c764$var$EMRsQuery = {
    use () {
        return {
            data: (0, $24d88c360a400e92$export$3eee12522424252).use().data?.emrs?.toSorted((a, b)=>(0, $5d669742300defa8$export$336849d529cb05e5).Instant.compare(a.timestamp, b.timestamp))
        };
    },
    async add (qc, result) {
        await (0, $24d88c360a400e92$export$3eee12522424252).patchData(qc, [], (old)=>({
                ...old,
                emrs: [
                    result,
                    ...old.emrs || []
                ]
            }));
    },
    async fake (qc, kindID) {
        await this.add(qc, (0, $5a8e851e08d041f0$export$1559c6534f9d45c8)({
            patientID: '',
            fileID: 'dummy',
            timestamp: (0, $5d669742300defa8$export$336849d529cb05e5).Now.instant(),
            kindID: kindID,
            mimeType: 'whatever'
        }));
    },
    async invalidate (qc, t) {
        await (0, $24d88c360a400e92$export$3eee12522424252).invalidate(qc, []);
    }
};
function $8608494418c9c764$var$useLatestEMRThat(predicate) {
    const emrs = $8608494418c9c764$var$EMRsQuery.use().data;
    if (emrs === undefined) return;
    return emrs.toReversed().filter(predicate)[0] ?? null;
}
function $8608494418c9c764$var$useLatestEMROfType(types) {
    return $8608494418c9c764$var$useLatestEMRThat((emr)=>types.has(emr.type));
}
function $8608494418c9c764$export$9c0070fa2f1576ef() {
    const lastWelcomed = $8608494418c9c764$var$useLatestEMRThat((emr)=>emr.hasWelcomed);
    if (lastWelcomed === undefined) return;
    return lastWelcomed ? true : false;
}
function $8608494418c9c764$export$d99dd18eda00f4fd() {
    const lastResults = $8608494418c9c764$var$useLatestEMROfType(new Set([
        (0, $d627ceabbb20b82f$export$e0e809ea946fc91)
    ]));
    if (lastResults === undefined) return;
    return lastResults ? lastResults.timestamp : null;
}
function $8608494418c9c764$export$4d33773808142541() {
    const lastFeedback = $8608494418c9c764$var$useLatestEMROfType(new Set([
        (0, $9e37c2be928a604b$export$d1b599eed051e134)
    ]));
    if (lastFeedback === undefined) return;
    return lastFeedback ? lastFeedback.timestamp : null;
}
function $8608494418c9c764$export$b55ed848e06e10f2() {
    const lastIntake = $8608494418c9c764$var$useLatestEMROfType(new Set([
        (0, $7de83232caba786b$export$4c4b23d7b53b8b73)
    ]));
    if (lastIntake === undefined) return;
    return lastIntake ? true : false;
}
function $8608494418c9c764$export$ef2d3d39368d9bc0() {
    const myRecords = $8608494418c9c764$var$EMRsQuery.use().data;
    const setupAppointment = (0, $664142bc47862dbd$export$298e455caafaaa94)();
    if (myRecords === undefined) return;
    const myCareStartedOn = (0, $621f9fc433cf952f$export$38e4ab857e6223db)({
        myRecords: myRecords
    });
    if (myCareStartedOn) return myCareStartedOn;
    const setupAppointmentWasALongTimeAgo = setupAppointment ? (0, $5d669742300defa8$export$336849d529cb05e5).Instant.compare(setupAppointment.end.toInstant(), (0, $5d669742300defa8$export$336849d529cb05e5).Instant.from('2025-01-01T00:00:00+02:00')) < 0 : false;
    // TODO XXX remove after we backfill consents
    if (setupAppointment && setupAppointmentWasALongTimeAgo) return setupAppointment.end.toInstant();
    return null;
}
function $8608494418c9c764$export$e7ad86e57e128243() {
    const qc = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const mutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: async (data)=>{
            try {
                const result = await (0, $49da1b68da864759$export$644d8ea042df96a6).post('', {
                    json: {
                        gahtTreatmentFeedback: data.gahtTreatmentFeedback,
                        userServicesRequest: (0, $271ce736e7659b02$export$5c8b607c3bfc3ce1)(data.userServicesRequest),
                        userSurgeryRequest: (0, $93f393cc36b347a9$export$90d8848701dcee14)(data.userSurgeryRequest)
                    }
                }).json();
                await (0, $989eaa2e942acd1a$export$451942af9381149c)(result.map((emr)=>$8608494418c9c764$var$EMRsQuery.add(qc, (0, $a6bd29d179726531$export$e873c868599413f1)(emr))));
            } catch (e) {
                $8608494418c9c764$var$EMRsQuery.invalidate(qc, []);
                throw e;
            }
        }
    });
    return mutation;
}
function $8608494418c9c764$export$15bc16b7d42c8de9() {
    const qc = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const mutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: async ({ form: form, response: response })=>{
            try {
                const emr = (0, $a6bd29d179726531$export$e873c868599413f1)(await (0, $49da1b68da864759$export$644d8ea042df96a6).post('typeform/', {
                    json: {
                        form: form,
                        response: response
                    }
                }).json());
                await $8608494418c9c764$var$EMRsQuery.add(qc, emr);
            } catch (e) {
                $8608494418c9c764$var$EMRsQuery.invalidate(qc, []);
                throw e;
            }
        }
    });
    return mutation;
}
function $8608494418c9c764$export$df7a2a42fca09185() {
    const qc = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const mutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: async ({ files: files })=>{
            try {
                const data = new FormData();
                let i = 0;
                for (const file of files){
                    data.append(`file${i}`, file, file.name);
                    i += 1;
                }
                const result = (0, $a6bd29d179726531$export$e873c868599413f1)(await (0, $49da1b68da864759$export$644d8ea042df96a6).post('gaht/blood-results/', {
                    body: data
                }).json());
                $8608494418c9c764$var$EMRsQuery.add(qc, result);
            } catch (e) {
                $8608494418c9c764$var$EMRsQuery.invalidate(qc, []);
                throw e;
            }
        }
    });
    return mutation;
}
function $8608494418c9c764$export$7f2e4386c7f3fda4() {
    const config = (0, $1068f99e90f736b6$export$b3611e87cd5ba6ce)();
    const qc = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const mutation = {
        mutateAsync: async ()=>await $8608494418c9c764$var$EMRsQuery.fake(qc, (0, $d627ceabbb20b82f$export$e0e809ea946fc91)),
        isPending: false
    };
    return config.testMode ? mutation : null;
}
function $8608494418c9c764$export$64aca93ace2eaec0() {
    const config = (0, $1068f99e90f736b6$export$b3611e87cd5ba6ce)();
    const qc = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const mutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: async ()=>{
            try {
                const result = (0, $a6bd29d179726531$export$e873c868599413f1)(await (0, $49da1b68da864759$export$644d8ea042df96a6).put('TEST/welcomed/').json());
                $8608494418c9c764$var$EMRsQuery.add(qc, result);
            } catch (e) {
                $8608494418c9c764$var$EMRsQuery.invalidate(qc, []);
                throw e;
            }
        }
    });
    return config.testMode ? mutation : null;
}


const $e2ed673c8add7fd1$export$88e7f1c97b0d0a28 = {
    use () {
        return {
            data: (0, $24d88c360a400e92$export$3eee12522424252).use().data?.care
        };
    },
    async setData (qc, k, care) {
        await (0, $24d88c360a400e92$export$3eee12522424252).patchData(qc, [], (old)=>({
                ...old,
                care: care
            }));
    },
    async invalidate (qc, k) {
        await (0, $24d88c360a400e92$export$3eee12522424252).invalidate(qc, []);
    }
};
function $e2ed673c8add7fd1$export$cda57cea25dea114(invoice) {
    const tz = (0, $5d669742300defa8$export$336849d529cb05e5).Now.timeZoneId();
    return {
        ID: invoice.ID,
        number: invoice.number,
        periodStart: invoice.periodStart.toZonedDateTimeISO(tz),
        periodEnd: invoice.periodEnd.toZonedDateTimeISO(tz),
        amountRemaining: invoice.amountRemaining,
        dueBy: invoice.dueBy.toZonedDateTimeISO(tz),
        nextAttemptOn: invoice.nextAttemptOn?.toZonedDateTimeISO(tz) ?? null
    };
}
function $e2ed673c8add7fd1$export$a5df9815515d84a3(care) {
    const tz = (0, $5d669742300defa8$export$336849d529cb05e5).Now.timeZoneId();
    return {
        started: care.started?.toZonedDateTimeISO(tz) ?? null,
        terminated: care.terminated?.toZonedDateTimeISO(tz) ?? null,
        nextCharge: care.nextCharge?.toZonedDateTimeISO(tz) ?? null,
        unpaidInvoices: care.unpaidInvoices.map($e2ed673c8add7fd1$export$cda57cea25dea114)
    };
}
function $e2ed673c8add7fd1$export$edf4a2eb8cf50264() {
    const care = $e2ed673c8add7fd1$export$88e7f1c97b0d0a28.use().data;
    const started = (0, $8608494418c9c764$export$ef2d3d39368d9bc0)();
    if (care === undefined || started === undefined) return;
    return $e2ed673c8add7fd1$export$a5df9815515d84a3({
        ...care,
        started: started
    });
}
function $e2ed673c8add7fd1$export$c5a08e8c0195a2e5() {
    const qc = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const mutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: async ()=>{
            try {
                const data = await (0, $49da1b68da864759$export$644d8ea042df96a6).post('care/').json();
                $e2ed673c8add7fd1$export$88e7f1c97b0d0a28.setData(qc, [], (0, $c807ce24aebffc65$export$2ebf5e41bf4e3780)(data.care));
                return {
                    intent: data.intent
                };
            } catch (e) {
                $e2ed673c8add7fd1$export$88e7f1c97b0d0a28.invalidate(qc, []);
                throw e;
            }
        }
    });
    return mutation;
}
function $e2ed673c8add7fd1$export$a3d54307af0de6b0() {
    const qc = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const mutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: async ()=>{
            try {
                const data = await (0, $49da1b68da864759$export$644d8ea042df96a6).delete('care/').json();
                $e2ed673c8add7fd1$export$88e7f1c97b0d0a28.setData(qc, [], (0, $c807ce24aebffc65$export$2ebf5e41bf4e3780)(data.care));
            } catch (e) {
                $e2ed673c8add7fd1$export$88e7f1c97b0d0a28.invalidate(qc, []);
                throw e;
            }
        }
    });
    return mutation;
}



class $196d349a3b911925$export$88c2b21b54b3243f extends Error {
}
$196d349a3b911925$export$88c2b21b54b3243f.prototype.name = 'PaymentError';
function $196d349a3b911925$export$4e7f6be20927607d() {
    const mutation = $196d349a3b911925$export$e4ed0cee43b6a619();
    return {
        mutate: ({ paymentIntent: paymentIntent, redirectStatus: redirectStatus })=>{
            const intent = paymentIntent;
            if (intent && redirectStatus === 'succeeded') mutation.mutate({
                intent: intent
            });
        }
    };
}
function $196d349a3b911925$export$e4ed0cee43b6a619() {
    const qc = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const mutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationKey: [
            'finalize-stripe'
        ],
        mutationFn: async ({ intent: intent })=>{
            try {
                const patch = (0, $4179c4b78b9a4d6d$export$300b7a990d5c168a)(await (0, $49da1b68da864759$export$644d8ea042df96a6).post('stripe/', {
                    json: {
                        intent: intent
                    }
                }).json());
                await (0, $989eaa2e942acd1a$export$451942af9381149c)([
                    (0, $e2ed673c8add7fd1$export$88e7f1c97b0d0a28).setData(qc, [], patch.care),
                    (0, $7c7ab1995ec5d09f$export$8b9a6efd03876208).setData(qc, [], patch.inventory)
                ]);
            } catch (e) {
                if (e instanceof (0, $36b67ef8a3cfb321$export$aa9d629c530f62a7)) {
                    if (e.response.status === 422) {
                        const error = await e.response.json();
                        throw new $196d349a3b911925$export$88c2b21b54b3243f(error.message, {
                            cause: error
                        });
                    }
                }
                (0, $e2ed673c8add7fd1$export$88e7f1c97b0d0a28).invalidate(qc, []);
                (0, $7c7ab1995ec5d09f$export$8b9a6efd03876208).invalidate(qc, []);
                throw e;
            }
        }
    });
    return mutation;
}
function $196d349a3b911925$export$c709d1de87a53c48() {
    const mutations = (0, $e8df1924a4e3fb84$export$29ea95f3fea1dc1c)({
        filters: {
            mutationKey: [
                'finalize-stripe'
            ],
            status: 'pending'
        }
    });
    return {
        isPending: mutations.length ? true : false
    };
}


const $24d88c360a400e92$export$3eee12522424252 = new (0, $de2aa269f2af170d$export$62297b13309008b2)(()=>[
        'fat-user'
    ], ()=>{
    const finalizeStripe = (0, $196d349a3b911925$export$4e7f6be20927607d)();
    return async (_)=>{
        const hashParams = new URLSearchParams(document.location.hash.substring(1));
        const searchParams = new URLSearchParams(document.location.search.substring(1));
        const idToken = hashParams.get('id_token');
        const nonces = localStorage.getItem('nonces') || '';
        if (idToken) try {
            const { access_token: accessToken } = await (0, $49da1b68da864759$export$644d8ea042df96a6).put('auth/session/', {
                json: {
                    id_token: idToken,
                    nonces: nonces
                }
            }).json();
            localStorage.setItem('access_token', accessToken);
        } catch (e) {
            try {
                if (e instanceof (0, $36b67ef8a3cfb321$export$aa9d629c530f62a7)) console.error('Sign-in failed.', (await e.response.json()).message);
                else console.error('Sign-in failed.', e);
            } catch (ee) {
                console.error('Sign-in failed.', e);
                console.warn(ee);
            }
        }
        const paymentIntent = searchParams.get('payment_intent') ?? '';
        const redirectStatus = searchParams.get('redirect_status') ?? '';
        finalizeStripe.mutate({
            paymentIntent: paymentIntent,
            redirectStatus: redirectStatus
        });
        searchParams.delete('payment_intent');
        searchParams.delete('redirect_status');
        const url = new URL(document.location.href);
        url.search = searchParams.toString();
        url.hash = hashParams.toString();
        if (document.location.href != url.toString()) window.history.replaceState(null, '', url);
        let data;
        try {
            data = (0, $4179c4b78b9a4d6d$export$300b7a990d5c168a)(await (0, $49da1b68da864759$export$644d8ea042df96a6).get('').json());
        } catch (e) {
            if (e instanceof (0, $36b67ef8a3cfb321$export$aa9d629c530f62a7)) {
                if (e.response.status === 401) return null;
            }
            throw e;
        }
        if (data) {
            const url = new URL(document.location.href);
            url.search = '';
            url.hash = '';
            if (document.location.href != url.toString()) window.history.replaceState(null, '', url);
        }
        return data;
    };
});



function $f80eb65c55aee8de$export$352d3be0a3f23d6d() {
    return (0, $6a05afbd57376433$export$609860bf8b0084c)({
        async mutationFn ({ email: email }) {
            const nonce = crypto.randomUUID();
            localStorage.setItem('nonces', nonce);
            await (0, $49da1b68da864759$export$644d8ea042df96a6).post('auth/by-email/', {
                json: {
                    email: email,
                    nonce: nonce
                }
            });
            return {
                email: email
            };
        }
    });
}
function $f80eb65c55aee8de$export$509d1303b8ce1e78() {
    const config = (0, $1068f99e90f736b6$export$b3611e87cd5ba6ce)();
    const mutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        async mutationFn ({ templateID: templateID }) {
            localStorage.setItem('nonces', 'test');
            window.location.href = `${0, $49da1b68da864759$export$d43f2f435f160490}/auth/sign-in-as-a-test-user/?templateID=${templateID}&nonce=test`;
        }
    });
    return config.testMode ? mutation : null;
}
function $f80eb65c55aee8de$export$d3a00f9e0caaa235() {
    const fatUser = (0, $24d88c360a400e92$export$3eee12522424252).useSuspense().data;
    return fatUser ? true : false;
}
function $f80eb65c55aee8de$export$68089b5bbafb026b() {
    const qc = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    return (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: async ()=>{
            await (0, $49da1b68da864759$export$644d8ea042df96a6).delete('auth/session/');
            localStorage.removeItem('access_token');
            localStorage.removeItem('nonces');
            (0, $24d88c360a400e92$export$3eee12522424252).setData(qc, [], null);
        }
    });
}




var $acw62 = parcelRequire("acw62");




var $70e10692f0bcbb5e$exports = {};
$70e10692f0bcbb5e$exports = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20xml%3Aspace%3D%22preserve%22%20width%3D%22241.648%22%20height%3D%22127.48%22%20viewBox%3D%220%200%2063.936%2033.729%22%3E%3Cdefs%3E%3ClinearGradient%20id%3D%22b%22%3E%3Cstop%20offset%3D%220%22%20stop-color%3D%22%23efbade%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23ffdbed%22%20stop-opacity%3D%220%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22a%22%3E%3Cstop%20offset%3D%220%22%20stop-color%3D%22%237acfff%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23ff8fc6%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22l%22%20x1%3D%22163.38%22%20x2%3D%22108.03%22%20y1%3D%22128.3%22%20y2%3D%22128.69%22%20gradientTransform%3D%22matrix%28-.98287%20.00744%20.43378%201.0468%20151.82%20-6.786%29%22%20gradientUnits%3D%22userSpaceOnUse%22%3E%3Cstop%20offset%3D%220%22%20stop-color%3D%22%23b7e4ff%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23ffd0e5%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20xlink%3Ahref%3D%22%23a%22%20id%3D%22k%22%20x1%3D%2290.031%22%20x2%3D%2292.437%22%20y1%3D%22137.59%22%20y2%3D%22132.84%22%20gradientTransform%3D%22matrix%28.7627%20-1.6444%201.6444%20.7627%20-158.66%20180.3%29%22%20gradientUnits%3D%22userSpaceOnUse%22%2F%3E%3ClinearGradient%20xlink%3Ahref%3D%22%23a%22%20id%3D%22j%22%20x1%3D%2294.072%22%20x2%3D%2291.783%22%20y1%3D%22133.1%22%20y2%3D%22128.39%22%20gradientTransform%3D%22matrix%28.7627%20-1.6444%201.6444%20.7627%20-158.66%20180.3%29%22%20gradientUnits%3D%22userSpaceOnUse%22%2F%3E%3ClinearGradient%20xlink%3Ahref%3D%22%23a%22%20id%3D%22i%22%20x1%3D%22100.03%22%20x2%3D%22100.13%22%20y1%3D%22148.43%22%20y2%3D%22138.09%22%20gradientTransform%3D%22rotate%28-21.764%2094.382%2045.725%29%22%20gradientUnits%3D%22userSpaceOnUse%22%2F%3E%3ClinearGradient%20xlink%3Ahref%3D%22%23a%22%20id%3D%22h%22%20x1%3D%22105.36%22%20x2%3D%2298.4%22%20y1%3D%22141.05%22%20y2%3D%22130.84%22%20gradientTransform%3D%22rotate%28-21.764%2094.382%2045.725%29%22%20gradientUnits%3D%22userSpaceOnUse%22%2F%3E%3ClinearGradient%20id%3D%22d%22%20x1%3D%22147.41%22%20x2%3D%2282.556%22%20y1%3D%22128.79%22%20y2%3D%22129.25%22%20gradientTransform%3D%22matrix%28-.98287%20.00744%20.43378%201.0468%20151.82%20-6.786%29%22%20gradientUnits%3D%22userSpaceOnUse%22%3E%3Cstop%20offset%3D%220%22%20stop-color%3D%22%23c1cff1%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23d7effc%22%20stop-opacity%3D%220%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22c%22%20x1%3D%22110.88%22%20x2%3D%22110.88%22%20y1%3D%22115.5%22%20y2%3D%22137.52%22%20gradientTransform%3D%22translate%28-14.025%20-15.931%29scale%281.1172%29%22%20gradientUnits%3D%22userSpaceOnUse%22%3E%3Cstop%20offset%3D%220%22%20stop-color%3D%22%2329b0ff%22%2F%3E%3Cstop%20offset%3D%22.504%22%20stop-color%3D%22%237c54bd%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20xlink%3Ahref%3D%22%23b%22%20id%3D%22f%22%20x1%3D%22117.87%22%20x2%3D%22130.74%22%20y1%3D%22124.38%22%20y2%3D%22124.29%22%20gradientTransform%3D%22matrix%28-.98287%20.00744%20.43378%201.0468%20151.82%20-6.786%29%22%20gradientUnits%3D%22userSpaceOnUse%22%2F%3E%3ClinearGradient%20xlink%3Ahref%3D%22%23b%22%20id%3D%22e%22%20x1%3D%22117.87%22%20x2%3D%22132.28%22%20y1%3D%22124.38%22%20y2%3D%22124.28%22%20gradientTransform%3D%22matrix%28-.98287%20.00744%20.43378%201.0468%20151.82%20-6.786%29%22%20gradientUnits%3D%22userSpaceOnUse%22%2F%3E%3C%2Fdefs%3E%3Cpath%20fill%3D%22url%28%27%23c%27%29%22%20d%3D%22M111.14%20132.87c-.02.018-.05.121-.095.294-.158.613-.032%201.908.254%202.593.207.5.535.915.96%201.236q1.221.029%202.43.029c-1.681-.325-2.854-1.062-3.288-2.089-.108-.255-.203-.87-.21-1.368-.009-.517-.017-.725-.051-.695%22%20transform%3D%22translate%28-77.467%20-103.98%29%22%2F%3E%3Cpath%20fill%3D%22url%28%27%23l%27%29%22%20d%3D%22M87.169%20117.64c-1.742%209.852-21.432%203.397-24.36%2011.489l2.755%206.647c2.928-8.093%2022.618-1.638%2024.36-11.49z%22%20style%3D%22-inkscape-stroke%3Anone%3Bfont-variation-settings%3Anormal%22%20transform%3D%22translate%28-62.808%20-110.615%29%22%2F%3E%3Cpath%20fill%3D%22%23fff%22%20d%3D%22M67.079%20113.79a.6.6%200%200%200-.224.048c-1.48.64-2.125%203.615%203.605%2021.377%206.576%202.383%2011.851%202.864%2013.432%201.802%201.581-1.063%201.24-2.562%201.47-3.551s1.053-2.264-.289-3.437c-.423-.37-1.218-.495-2.364-.335.311-.294.618-.613.942-.973%202.37-2.63-.634-3.374-2.079-6.546-1.444-3.172-1.226-8.202-4.196-5.88-1.462%201.142-2.811%202.723-3.977%205.521a29%2029%200%200%201-1.585-1.984c-1.964-2.71-3.583-6.05-4.735-6.042z%22%20style%3D%22-inkscape-stroke%3Anone%3Bfont-variation-settings%3Anormal%3Bmix-blend-mode%3Anormal%22%20transform%3D%22translate%28-62.808%20-113.79%29%22%2F%3E%3Cpath%20fill%3D%22url%28%27%23k%27%29%22%20d%3D%22M133.14%20128.32c1.04%201.021%201.35%202.18%201.754%203.112.42.967%201.31%202.394%201.367%203.78.065%201.578-2.6%202.677-9.529%201.473%203.39-8.366%205.314-9.44%206.408-8.365%22%20opacity%3D%22.9%22%20style%3D%22-inkscape-stroke%3Anone%3Bfont-variation-settings%3Anormal%3Bmix-blend-mode%3Anormal%22%20transform%3D%22translate%28-119.082%20-115.257%29%22%2F%3E%3Cpath%20fill%3D%22url%28%27%23j%27%29%22%20d%3D%22M126.73%20136.68c-5.73-17.761-5.085-20.737-3.605-21.377%201.161-.502%202.864%203.104%204.959%205.995%202.07%202.858%203.703%203.812%203.863%205.818.195%202.458-.209%203.098-5.217%209.564%22%20opacity%3D%22.9%22%20style%3D%22-inkscape-stroke%3Anone%3Bfont-variation-settings%3Anormal%3Bmix-blend-mode%3Anormal%22%20transform%3D%22translate%28-119.082%20-115.257%29%22%2F%3E%3Cpath%20fill%3D%22url%28%27%23h%27%29%22%20d%3D%22M126.73%20136.68c1.443-12.486%203.947-16.599%206.916-18.92s2.751%202.709%204.196%205.881%204.448%203.917%202.079%206.546-3.768%203.19-13.191%206.493z%22%20opacity%3D%22.9%22%20style%3D%22-inkscape-stroke%3Anone%3Bfont-variation-settings%3Anormal%3Bmix-blend-mode%3Anormal%22%20transform%3D%22translate%28-119.082%20-115.257%29%22%2F%3E%3Cpath%20fill%3D%22url%28%27%23i%27%29%22%20d%3D%22M141.35%20131.5c1.342%201.173.518%202.448.289%203.437s.111%202.487-1.47%203.55-6.856.581-13.432-1.802c8.206-5.078%2013.271-6.358%2014.612-5.185z%22%20opacity%3D%22.9%22%20style%3D%22-inkscape-stroke%3Anone%3Bfont-variation-settings%3Anormal%3Bmix-blend-mode%3Anormal%22%20transform%3D%22translate%28-119.082%20-115.257%29%22%2F%3E%3Cpath%20fill%3D%22url%28%27%23d%27%29%22%20d%3D%22m62.809%20129.13%202.754%206.647c8.893%208.796%2049.905%207.867%2058.427-.562l2.755-6.647c-5.393%205.334-51.365%2012.996-63.936.562z%22%20opacity%3D%22.8%22%20style%3D%22-inkscape-stroke%3Anone%3Bfont-variation-settings%3Anormal%22%20transform%3D%22translate%28-62.808%20-110.615%29%22%2F%3E%3Cpath%20fill%3D%22url%28%27%23f%27%29%22%20d%3D%22M65.832%20113.84v6.113c8.23%201.957%2017.315-1.311%2024.091%204.335l-2.754-6.646c-6.027-5.023-13.881-2.658-21.336-3.802z%22%20opacity%3D%22.8%22%20style%3D%22-inkscape-stroke%3Anone%3Bfont-variation-settings%3Anormal%22%20transform%3D%22translate%28-62.808%20-110.615%29%22%2F%3E%3Cpath%20fill%3D%22url%28%27%23e%27%29%22%20d%3D%22M65.832%20110.66v6.113c8.23%201.957%2017.315%201.864%2024.091%207.51l-2.754-6.646c-6.027-5.023-13.881-5.833-21.336-6.977z%22%20opacity%3D%22.8%22%20style%3D%22-inkscape-stroke%3Anone%3Bfont-variation-settings%3Anormal%22%20transform%3D%22translate%28-62.808%20-110.615%29%22%2F%3E%3Cpath%20fill%3D%22url%28%27%23d%27%29%22%20d%3D%22m62.809%20129.13%202.754%206.647c8.893%208.796%2049.905%2011.042%2058.427%202.613l2.755-6.647c-5.393%205.334-51.365%209.82-63.936-2.613z%22%20opacity%3D%22.8%22%20style%3D%22-inkscape-stroke%3Anone%3Bfont-variation-settings%3Anormal%22%20transform%3D%22translate%28-62.808%20-110.615%29%22%2F%3E%3Cpath%20fill%3D%22%2356408b%22%20d%3D%22M34.523%208.93a.6.6%200%200%200-.167.03c-.143.037-1.033.113-1.978.168-.944.056-1.738.167-1.764.246-.03.09.331.126.96.096.81-.038%201.026-.004%201.095.177.235.61-4.32%208.261-6.025%2010.12l-.615.672.71-.096c.392-.052.848-.185%201.014-.294.382-.25%202.68-3.925%204.54-7.26.782-1.403%201.605-2.81%201.828-3.127.399-.565.503-.722.402-.732zm20.248%203.99c-.15-.05-.414.238-.749.847-.417.759-.528.865-.91.868-1.038.008-2.362.972-3.475%202.532-1.184%201.66-3.322%203.37-4.211%203.37-.436%200-.646-.37-.554-.973.046-.296.546-1.463%201.111-2.592l1.029-2.052.528-.022c.435-.018.458-.032.132-.082-.444-.067-.456-.09-.247-.482.216-.402-.12-.365-.725.081-.269.198-.658.36-.864.36-1.099%200-3.283%201.742-4.243%203.383-.944%201.613-2.877%203.01-3.477%202.512-.392-.325-.153-1.182.946-3.397.565-1.137.988-2.132.939-2.21-.245-.397-1.29.22-2.78%201.643l-.908.867.296-.69c.373-.87.388-1.387.04-1.387-.353%200-.825.335-1.804%201.281l-.836.807.61-1.157c.585-1.11.683-1.755.239-1.57-.272.114-2.995%204.868-2.995%205.23%200%20.585.384.3%201.19-.882.953-1.397%202.772-3.263%202.979-3.055.182.182-.356%201.498-1.144%202.804-.556.919-.665%201.44-.302%201.44.174%200%20.6-.6%201.022-1.44.36-.717%201.277-1.764%202.368-2.702%201.258-1.082%201.257-.791-.007%201.858-1.032%202.164-1.094%202.602-.403%202.865.616.234%201.636-.145%202.723-1.013l.576-.46.073.41c.055.314.162.42.458.454.563.065%201.213-.325%202.332-1.399.975-.936.986-.941.702-.374-.451.9-.53%201.468-.261%201.878.484.74%201.913.317%203.624-1.072l.879-.712-.23.638c-.27.75-.127%201.114.462%201.185.393.047%201.251-.698%202.455-2.133.3-.357.516-.584.481-.505-.264.61-5.17%209.563-5.644%2010.3-2.37%203.685-5.502%205.446-8.737%204.914-.083-.014-.159-.033-.24-.049q-1.209%200-2.43-.028c.399.302.883.52%201.442.64.727.154%202.546.07%203.505-.162%202.684-.65%204.919-2.476%207.037-5.748%203.356-5.184%208.137-13.62%208.137-14.358%200-.278-.05-.43-.14-.461zm5.253.997q-.101.005-.28.051a.62.62%200%200%200-.454.45c-.059.233-.198.363-.399.374-.22.012-.24.035-.071.08.155.041.27.289.334.715.085.563.029.798-.408%201.717-.63%201.329-2.034%202.851-2.559%202.777-.467-.066-.514-.703-.128-1.735.351-.938%201.58-2.744%202.099-3.084.56-.367.309-.4-.378-.05-1.337.683-2.797%202.721-2.965%204.138-.087.733.037.955.599%201.072%201.005.21%202.666-1.172%203.582-2.982l.404-.797.43.363c.573.481%201.035.58%201.733.372.583-.175%201.847-1.206%201.844-1.504-.001-.09-.164.044-.363.296-.526.668-1.231%201.055-1.923%201.055-.52%200-.635-.062-.883-.469-.314-.514-.375-1.46-.145-2.26.126-.441.136-.585-.069-.579M46.053%2014.92c.132%200%20.213.033.213.108%200%20.205-1.438%202.524-1.961%203.163-.29.353-.848.896-1.24%201.206-.822.65-1.12.71-1.12.223%200-1.024%202.017-3.824%203.181-4.418.349-.178.707-.28.927-.282m6.873.022c.252-.012.399.016.399.084%200%20.08-.325.643-.723%201.252-.398.61-.68%201.18-.626%201.266.054.088.031.116-.053.064-.083-.051-.33.15-.548.446a16%2016%200%200%201-1.055%201.223c-.839.873-1.095.895-.986.085.122-.907%201.04-2.626%201.876-3.513.646-.685.838-.803%201.43-.88q.16-.02.286-.027%22%2F%3E%3C%2Fsvg%3E";


function $764ad612b1583952$export$b64708c6f1b3ed96() {
    const [readyToRender, setReadyToRender] = (0, $acw62.useState)(false);
    const [emailSent, setEmailSent] = (0, $acw62.useState)();
    const sendSigninMessage = (0, $f80eb65c55aee8de$export$352d3be0a3f23d6d)();
    (0, $acw62.useEffect)(()=>{
        document.documentElement.classList.add('light-only');
        // Typeform-initiated sign-up
        const hashParams = new URLSearchParams(document.location.hash.substring(1));
        const typeformSignUp = hashParams.get('typeformSignUp') === 'true';
        if (typeformSignUp) console.info('typeform sign-up referrer', document.referrer);
        const shortName = hashParams.get('shortName');
        const pronouns = hashParams.get('pronouns');
        const email = hashParams.get('email');
        const phone = hashParams.get('phone');
        const dateOfBirth = hashParams.get('dateOfBirth');
        const country = hashParams.get('country');
        if (typeformSignUp && email) {
            localStorage.setItem('prefill-profile', JSON.stringify({
                timestamp: (0, $5d669742300defa8$export$336849d529cb05e5).Now.instant().toString(),
                shortName: shortName ?? undefined,
                pronouns: pronouns ?? undefined,
                dateOfBirth: dateOfBirth ? dateOfBirth.replaceAll('/', '-') : undefined
            }));
            sendSigninMessage.mutate({
                email: email
            }, {
                onSuccess: ({ email: email })=>{
                    setReadyToRender(true);
                    setEmailSent(email);
                }
            });
            const url = new URL(document.location.href);
            url.search = '';
            url.hash = '';
            if (document.location.href != url.toString()) window.history.replaceState(null, '', url);
        } else setReadyToRender(true);
    }, []);
    return readyToRender ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "sign-in",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: !emailSent ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                    style: {
                        alignItems: 'center',
                        gap: '32px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            alt: "Imago",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($70e10692f0bcbb5e$exports))),
                            style: {
                                width: '50%'
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                            style: {
                                width: '80%'
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: "Your e-mail"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    name: "email",
                                    type: "email",
                                    autoFocus: true,
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$8b7b7cdfb85d78c5), {
                            mutation: sendSigninMessage,
                            vars: (data)=>({
                                    email: data.get('email')
                                }),
                            onSuccess: ({ data: { email: email } })=>{
                                setReadyToRender(true);
                                setEmailSent(email);
                            },
                            children: "Continue"
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            children: "Check your e-mail"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                "We've sent you (",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: emailSent
                                }),
                                ") a sign-in link."
                            ]
                        })
                    ]
                })
            })
        })
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
}
function $764ad612b1583952$var$TestAccounts() {
    const signIn = (0, $f80eb65c55aee8de$export$509d1303b8ce1e78)();
    if (!signIn) return;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("aside", {
        className: "dev",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                style: {
                    textAlign: "center"
                },
                children: "Test accounts"
            }),
            (0, $e1e31c6aafe0d6d0$export$76eaf902870ebb73).map((template)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8600c5f9d86d8c95$export$8b7b7cdfb85d78c5), {
                    mutation: signIn,
                    vars: (data)=>({
                            templateID: template.ID
                        }),
                    children: [
                        "Sign in as ",
                        template.shortName,
                        " - ",
                        template.description
                    ]
                }, template.ID))
        ]
    });
}




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");



var $a85645d511b7da1c$exports = {};
$a85645d511b7da1c$exports = import.meta.resolve("6uBMV");


function $80b0682ebef62618$export$157c131647dc68e() {
    const setUserProfile = (0, $d7de34ca5c825acf$export$9b3562d446df4d7d)();
    const signOut = (0, $f80eb65c55aee8de$export$68089b5bbafb026b)();
    let prefill;
    try {
        const prefill_raw = localStorage.getItem('prefill-profile');
        prefill = prefill_raw ? JSON.parse(prefill_raw) : undefined;
        if (prefill && (0, $5d669742300defa8$export$336849d529cb05e5).Instant.compare(prefill.timestamp, (0, $5d669742300defa8$export$336849d529cb05e5).Now.instant().subtract({
            hours: 24
        })) < 0) {
            prefill = undefined;
            localStorage.removeItem('prefill-profile');
        }
    } catch (e) {
        console.warn(e);
    }
    (0, $acw62.useEffect)(()=>{
        document.documentElement.classList.add('light-only');
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "register",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                    style: {
                        alignItems: 'center',
                        gap: '32px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            alt: "Imago",
                            src: new URL($a85645d511b7da1c$exports).toString(),
                            style: {
                                width: '50%'
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            children: "Welcome to Imago!"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                width: '80%'
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Your chosen name"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            name: "shortName",
                                            type: "string",
                                            defaultValue: prefill?.shortName,
                                            autoFocus: true,
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Your chosen pronouns"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            name: "pronouns",
                                            type: "string",
                                            defaultValue: prefill?.pronouns,
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Legal name"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            name: "legalName",
                                            type: "string",
                                            defaultValue: prefill?.legalName,
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Date of birth"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            name: "dateOfBirth",
                                            type: "date",
                                            defaultValue: prefill?.dateOfBirth,
                                            required: true
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                minWidth: '50%'
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$8b7b7cdfb85d78c5), {
                                    mutation: setUserProfile,
                                    vars: (data)=>({
                                            shortName: data.get('shortName'),
                                            pronouns: data.get('pronouns'),
                                            legalName: data.get('legalName'),
                                            dateOfBirth: (0, $5d669742300defa8$export$336849d529cb05e5).PlainDate.from(data.get('dateOfBirth'))
                                        }),
                                    children: "Let\u2019s go"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$857ebcebc4ae5918), {
                                    mutation: signOut,
                                    children: "Sign out"
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}







var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
window.addEventListener('beforeinstallprompt', (ev)=>{
    window._x_installApp = async ()=>{
        window._x_installApp = undefined;
        window.dispatchEvent(new CustomEvent('_x_installabilitychanged'));
        return (await ev.prompt()).outcome === 'accepted';
    };
    window.dispatchEvent(new CustomEvent('_x_installabilitychanged'));
});
window._x_controllerChanged = false;
navigator.serviceWorker.addEventListener('controllerchange', ()=>{
    window._x_controllerChanged = true;
});
function $9019f8b149ea5d03$export$bc1021199b2ef019() {
    const [installable, setInstallable] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const callback = ()=>{
            setInstallable(window._x_installApp !== undefined);
        };
        window.addEventListener('_x_installabilitychanged', callback);
        callback();
        return ()=>{
            window.removeEventListener('_x_installabilitychanged', callback);
        };
    });
    const mutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationKey: [
            'install-app'
        ],
        mutationFn: async ()=>{
            const res = await window._x_installApp();
            // Wait for Chromium to emit another prompt.
            await new Promise((resolve)=>setTimeout(resolve, 100));
            return res;
        }
    });
    const activeMutations = (0, $e8df1924a4e3fb84$export$29ea95f3fea1dc1c)({
        filters: {
            mutationKey: [
                'install-app'
            ]
        }
    }).filter((mutation)=>mutation.status === 'pending');
    return activeMutations.length || installable ? {
        ...mutation,
        isPending: activeMutations.length >= 1
    } : undefined;
}
function $9019f8b149ea5d03$export$1c052fd244acfcc8() {
    const navMobile = navigator.userAgentData?.mobile;
    if (navMobile !== undefined) return navMobile ? 'install_mobile' : 'install_desktop';
    const touchSupport = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    return touchSupport ? 'install_mobile' : 'install_desktop';
}
function $9019f8b149ea5d03$export$a914cc583649c1ff() {
    const [reloadable, setReloadable] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const callback = ()=>{
            setReloadable(window._x_controllerChanged);
        };
        navigator.serviceWorker.addEventListener('controllerchange', callback);
        callback();
        return ()=>{
            navigator.serviceWorker.removeEventListener('controllerchange', callback);
        };
    });
    const mutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationKey: [
            'reload-app'
        ],
        mutationFn: async ()=>{
            window.location.reload();
        }
    });
    return reloadable ? mutation : undefined;
}




var $07b61d8d388d113d$exports = {};
$07b61d8d388d113d$exports = import.meta.resolve("6OWPW");



function $a59113ba74a90868$export$f7bfe31b45496d55({ children: children }) {
    const { shortName: shortName } = (0, $d7de34ca5c825acf$export$73fc7af4ef9455f4)();
    const page = (0, $acw62.useContext)((0, $51953425ccf4a998$export$9a1b410c76d0e146));
    const installApp = (0, $9019f8b149ea5d03$export$bc1021199b2ef019)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("hgroup", {
                className: "hello",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "display-large",
                        children: [
                            "Hello ",
                            shortName,
                            "!"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        role: "toolbar",
                        children: [
                            page !== 'account' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$cda51eb07c9d035c), {
                                href: "/account",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "material-symbols-outlined",
                                    children: "manage_accounts"
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                            page === 'account' && installApp ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8600c5f9d86d8c95$export$857ebcebc4ae5918), {
                                    className: "only-on-expanded-plus",
                                    mutation: installApp,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: new URL($07b61d8d388d113d$exports).toString(),
                                            height: 16
                                        }),
                                        "Install Imago app"
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                        ]
                    })
                ]
            }),
            page === 'account' && installApp ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8600c5f9d86d8c95$export$857ebcebc4ae5918), {
                    className: "high-prio only-on-medium-minus",
                    mutation: installApp,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: new URL($07b61d8d388d113d$exports).toString(),
                            height: 16
                        }),
                        "Install Imago app"
                    ]
                })
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
            children,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                "data-total": true
            })
        ]
    });
}


function $57045cda87c2a0a1$var$BookWelcomeCall() {
    const bookWelcome = (0, $3a6539ac03d750fd$export$a2838450ef33c04b)({
        serviceID: (0, $0eecc90764142418$export$64fb8ef928532180)
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                children: "Book a call"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                            children: [
                                "By booking a welcome call you hereby confirm that you have read our ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: "https://www.imago.tg/principles-and-values/",
                                    children: "Principles & Values"
                                }),
                                ", ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: "https://www.imago.tg/mission-and-vision/",
                                    children: "Mission & Vision"
                                }),
                                ", and the ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: "https://www.imago.tg/faq/",
                                    children: "Frequently Asked Questions"
                                }),
                                "."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "Get to know us, share any doubts or concerns you might have, tell us your story, and start or continue your GAHT with Imago."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$8b7b7cdfb85d78c5), {
                        mutation: bookWelcome,
                        vars: (data)=>{},
                        children: "Book a welcome call"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a6539ac03d750fd$export$71540c2ebad0fa07), {
                mutation: bookWelcome
            })
        ]
    });
}
function $57045cda87c2a0a1$export$23191e4434a9e834({ fullScreen: fullScreen }) {
    const skip = (0, $8608494418c9c764$export$64aca93ace2eaec0)();
    const appointment = (0, $61899bf53dd757a9$export$597f86bf439bd7d0)((0, $0eecc90764142418$export$64fb8ef928532180));
    const [wasNotBooked, setWasNotBooked] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (appointment === null) setWasNotBooked(true);
    }, [
        appointment
    ]);
    if (appointment === undefined) return;
    return appointment ? fullScreen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a59113ba74a90868$export$f7bfe31b45496d55), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                children: [
                    wasNotBooked ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        children: "Thanks, see you!"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    wasNotBooked ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "Confirmation was sent to your email address."
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a6539ac03d750fd$export$2e6a7cb81fe42451), {
                        appointment: appointment,
                        showTips: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$857ebcebc4ae5918), {
                className: "secondary",
                mutation: skip,
                children: "TEST: Skip until after the welcome call"
            })
        ]
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            marginBottom: '-33px'
        }
    }) : fullScreen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a59113ba74a90868$export$f7bfe31b45496d55), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "display-small",
                    children: "Welcome to Imago."
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($57045cda87c2a0a1$var$BookWelcomeCall, {})
        ]
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                children: "Welcome to Imago!"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "Want to start your Gender-Affirming Hormone Therapy at Imago?"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$cda51eb07c9d035c), {
                className: "primary",
                href: "/gaht",
                children: "Book a Welcome call"
            })
        ]
    });
}







var $acw62 = parcelRequire("acw62");




const $018285c0404a134a$var$MAX_FILES = 9;
const $018285c0404a134a$var$QUESTIONS = [
    'If applicable: How long before your test you applied your hormone gel?',
    "If applicable: What\u2019s the date of your last hormone injection?",
    'If you are currently taking Spironolactone: Please share a blood pressure reading'
];
function $018285c0404a134a$var$_TakeBloodTests() {
    const submitFiles = (0, $8608494418c9c764$export$df7a2a42fca09185)();
    const [files, setFiles] = (0, $acw62.useState)([]);
    function addFiles(newFiles) {
        setFiles(files.concat(newFiles));
    }
    function removeFile(file) {
        setFiles(files.filter((f)=>f !== file));
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
        onSubmit: (ev)=>{
            if (!(files.length && files.length <= $018285c0404a134a$var$MAX_FILES)) ev.preventDefault();
        },
        className: "send-emr",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$cda51eb07c9d035c), {
                href: "https://www.imago.tg/faq/#blood-tests",
                target: "_blank",
                children: "See the list of required diagnostics"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "Note: We require an original results sheet issued by the lab (PDF or photo-scan are sufficient)."
            }),
            files.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                className: "files",
                children: files.map((file, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                title: file.name,
                                children: file.name
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                title: "Remove",
                                onClick: (ev)=>{
                                    ev.preventDefault();
                                    removeFile(file);
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "material-symbols-outlined",
                                    children: "delete"
                                })
                            })
                        ]
                    }, i))
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
            files.length < $018285c0404a134a$var$MAX_FILES ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                role: "button",
                className: files.length ? '' : 'high-prio',
                children: [
                    "Add files",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "file",
                        multiple: true,
                        onChange: (ev)=>{
                            ev.preventDefault();
                            const input = ev.target;
                            addFiles(Array.from(input.files));
                            input.value = '';
                        }
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    "You can upload at most ",
                    $018285c0404a134a$var$MAX_FILES,
                    " files.",
                    " ",
                    files.length > $018285c0404a134a$var$MAX_FILES ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "Please remove some of the above."
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                ]
            }),
            $018285c0404a134a$var$QUESTIONS.map((q, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    className: "high-label",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: q
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "text",
                            name: `q${i}`
                        })
                    ]
                }, i)),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$8b7b7cdfb85d78c5), {
                mutation: submitFiles,
                vars: (data)=>{
                    let qa = '';
                    for (const [i, q] of $018285c0404a134a$var$QUESTIONS.entries())qa += q + '\n' + data.get(`q${i}`) + '\n\n';
                    const qatxt = new Blob([
                        qa
                    ], {
                        type: 'text/plain'
                    });
                    // @ts-ignore
                    qatxt.name = 'qa.txt';
                    return {
                        files: [
                            ...files,
                            qatxt
                        ]
                    };
                },
                children: "Submit"
            })
        ]
    });
}
function $018285c0404a134a$export$f410b8e268eb39c6() {
    const lastBloodResults = (0, $8608494418c9c764$export$d99dd18eda00f4fd)();
    const now = (0, $95adfbcee8b79b25$export$3a404aece3dff2fa)('hour');
    if (lastBloodResults === undefined) return;
    return !!lastBloodResults && (0, $5d669742300defa8$export$336849d529cb05e5).Instant.compare(lastBloodResults, now.subtract({
        months: 1
    }).toInstant()) > 0;
}
function $018285c0404a134a$export$1c1f6f480f495f1d() {
    const fakeSubmitFiles = (0, $8608494418c9c764$export$7f2e4386c7f3fda4)();
    const done = $018285c0404a134a$export$f410b8e268eb39c6();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        "data-done": done ? true : undefined,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("hgroup", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        children: "Take blood tests"
                    }),
                    !done ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$857ebcebc4ae5918), {
                        className: "secondary",
                        mutation: fakeSubmitFiles,
                        children: "TEST: Skip"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                ]
            }),
            !done ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($018285c0404a134a$var$_TakeBloodTests, {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
        ]
    });
}






var $acw62 = parcelRequire("acw62");
var $a5b6342546b0cfcd$exports = {};
!function(e, t) {
    $a5b6342546b0cfcd$exports = t();
}($a5b6342546b0cfcd$exports, function() {
    return function() {
        "use strict";
        var e = {
            8027: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.DEFAULT_DOMAIN = t.POPUP_SIZE = t.SLIDER_WIDTH = t.SLIDER_POSITION = t.LIVE_EMBED_ATTRIBUTE = t.SIDETAB_ATTRIBUTE = t.WIDGET_ATTRIBUTE = t.SLIDER_ATTRIBUTE = t.POPUP_ATTRIBUTE = t.POPOVER_ATTRIBUTE = void 0, t.POPOVER_ATTRIBUTE = "data-tf-popover", t.POPUP_ATTRIBUTE = "data-tf-popup", t.SLIDER_ATTRIBUTE = "data-tf-slider", t.WIDGET_ATTRIBUTE = "data-tf-widget", t.SIDETAB_ATTRIBUTE = "data-tf-sidetab", t.LIVE_EMBED_ATTRIBUTE = "data-tf-live", t.SLIDER_POSITION = "right", t.SLIDER_WIDTH = 800, t.POPUP_SIZE = 100, t.DEFAULT_DOMAIN = "form.typeform.com";
            },
            7528: function(e, t, n) {
                var o = this && this.__assign || function() {
                    return o = Object.assign || function(e) {
                        for(var t, n = 1, o = arguments.length; n < o; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                        return e;
                    }, o.apply(this, arguments);
                }, r = this && this.__rest || function(e, t) {
                    var n = {};
                    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
                    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                        var r = 0;
                        for(o = Object.getOwnPropertySymbols(e); r < o.length; r++)t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
                    }
                    return n;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.createPopover = void 0;
                var i = n(6797), a = n(1320), c = function(e, t) {
                    var n = e.parentNode;
                    n && (n.removeChild(e), n.appendChild(t));
                }, u = function(e, t) {
                    void 0 === e && (e = "span"), void 0 === t && (t = "tf-v1-popover-button-icon");
                    var n = document.createElement(e);
                    return n.className = "".concat(t, " tf-v1-close-icon"), n.innerHTML = i.closeIconSvg, n.dataset.testid = t, n;
                }, l = {
                    buttonColor: "#3a7685"
                };
                t.createPopover = function(e, t) {
                    void 0 === t && (t = {});
                    var n, s, d, f = o(o({}, l), t), p = f.domain, v = r(f, [
                        "domain"
                    ]), m = (0, i.createIframe)("popover", {
                        formId: e,
                        domain: p,
                        options: v
                    }), h = m.iframe, b = m.embedId, y = m.refresh, g = m.focus, w = function(e, t) {
                        var n = document.createElement("div");
                        return n.className = "tf-v1-popover", n.dataset.testid = "tf-v1-popover", (0, i.setElementSize)(n, {
                            width: e,
                            height: t
                        });
                    }(v.width, v.height), O = function() {
                        var e = document.createElement("div");
                        return e.className = "tf-v1-popover-wrapper", e.dataset.testid = "tf-v1-popover-wrapper", e;
                    }(), _ = function(e, t) {
                        var n = (0, i.getTextColor)(t), o = document.createElement("div");
                        o.className = "tf-v1-popover-button-icon";
                        var r = (0, i.triggerIconSvg)(n), a = null == e ? void 0 : e.startsWith("http");
                        return o.innerHTML = a ? "<img alt='popover trigger icon button' src='".concat(e, "'/>") : null != e ? e : r, o.dataset.testid = "default-icon", o;
                    }(v.customIcon, v.buttonColor || l.buttonColor), E = function() {
                        var e = document.createElement("div");
                        e.className = "tf-v1-spinner";
                        var t = document.createElement("div");
                        return t.className = "tf-v1-popover-button-icon", t.dataset.testid = "spinner-icon", t.append(e), t;
                    }(), P = u(), j = u("button", "tf-v1-popover-close"), I = function(e, t) {
                        void 0 === t && (t = {});
                        var n = (0, i.getTextColor)(e), o = document.createElement("button");
                        return o.className = "tf-v1-popover-button", o.dataset.testid = "tf-v1-popover-button", o.style.backgroundColor = e, o.style.color = n, (0, i.addAttributesToElement)(o, t), o;
                    }(v.buttonColor || l.buttonColor, v.buttonProps);
                    (v.container || document.body).append(w), O.append(h), w.append(I), w.append(j), I.append(_);
                    var T = function() {
                        s && s.parentNode && (s.classList.add("closing"), setTimeout(function() {
                            (0, i.unmountElement)(s);
                        }, 250));
                    };
                    v.tooltip && v.tooltip.length > 0 && (s = function(e, t) {
                        var n = document.createElement("span");
                        n.className = "tf-v1-popover-tooltip-close", n.dataset.testid = "tf-v1-popover-tooltip-close", n.innerHTML = i.closeIconSvg, n.onclick = t;
                        var o = document.createElement("div");
                        o.className = "tf-v1-popover-tooltip-text", o.innerHTML = e;
                        var r = document.createElement("div");
                        return r.className = "tf-v1-popover-tooltip", r.dataset.testid = "tf-v1-popover-tooltip", r.appendChild(o), r.appendChild(n), r;
                    }(v.tooltip, T), w.append(s)), v.notificationDays && (v.enableSandbox || (0, a.canBuildNotificationDot)(e)) && (d = (0, a.buildNotificationDot)(), I.append(d)), h.onload = function(e) {
                        (null == e ? void 0 : e.isTrusted) && (w.classList.add("open"), O.style.opacity = "1", j.style.opacity = "1", c(E, P), (0, i.addCustomKeyboardListener)(C));
                    };
                    var S = function() {
                        (0, i.isOpen)(O) || (T(), d && (d.classList.add("closing"), v.notificationDays && !v.enableSandbox && (0, a.saveNotificationDotHideUntilTime)(e, v.notificationDays), setTimeout(function() {
                            (0, i.unmountElement)(d);
                        }, 250)), setTimeout(function() {
                            (0, i.isInPage)(O) ? (O.style.opacity = "0", j.style.opacity = "0", O.style.display = "flex", setTimeout(function() {
                                w.classList.add("open"), O.style.opacity = "1", j.style.opacity = "1";
                            }), c(_, P)) : (w.append(O), c(_, E), O.style.opacity = "0", j.style.opacity = "0");
                        }));
                    }, C = function() {
                        var n;
                        (0, i.isOpen)(w) && ((0, i.handlePreventReopenOnClose)(v, e), null === (n = t.onClose) || void 0 === n || n.call(t), setTimeout(function() {
                            v.keepSession ? O.style.display = "none" : (0, i.unmountElement)(O), w.classList.remove("open"), c(P, _);
                        }, 250));
                    };
                    (0, i.setAutoClose)(b, v.autoClose, C);
                    var M = function() {
                        (0, i.isOpen)(O) ? C() : S();
                    };
                    return I.onclick = (0, i.invokeWithoutDefault)(M), j.onclick = (0, i.invokeWithoutDefault)(C), v.open && !(0, i.isOpen)(O) && (n = (0, i.handleCustomOpen)(S, v, e)), {
                        open: S,
                        close: C,
                        toggle: M,
                        refresh: y,
                        focus: g,
                        unmount: function() {
                            (0, i.unmountElement)(w), v.open && (null == n ? void 0 : n.remove) && n.remove();
                        }
                    };
                };
            },
            1797: function(e, t, n) {
                var o = this && this.__createBinding || (Object.create ? function(e, t, n, o) {
                    void 0 === o && (o = n);
                    var r = Object.getOwnPropertyDescriptor(t, n);
                    r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    }), Object.defineProperty(e, o, r);
                } : function(e, t, n, o) {
                    void 0 === o && (o = n), e[o] = t[n];
                }), r = this && this.__exportStar || function(e, t) {
                    for(var n in e)"default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), r(n(7528), t), r(n(6100), t);
            },
            1320: function(e, t) {
                var n = this && this.__assign || function() {
                    return n = Object.assign || function(e) {
                        for(var t, n = 1, o = arguments.length; n < o; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                        return e;
                    }, n.apply(this, arguments);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.buildNotificationDot = t.canBuildNotificationDot = t.saveNotificationDotHideUntilTime = void 0;
                var o = "tfNotificationData", r = function() {
                    var e = localStorage.getItem(o);
                    return e ? JSON.parse(e) : {};
                }, i = function(e) {
                    e && localStorage.setItem(o, JSON.stringify(e));
                };
                t.saveNotificationDotHideUntilTime = function(e, t) {
                    var o, a = new Date;
                    a.setDate(a.getDate() + t), i(n(n({}, r()), ((o = {})[e] = {
                        hideUntilTime: a.getTime()
                    }, o)));
                }, t.canBuildNotificationDot = function(e) {
                    var t = function(e) {
                        var t;
                        return (null === (t = r()[e]) || void 0 === t ? void 0 : t.hideUntilTime) || 0;
                    }(e);
                    return (new Date).getTime() > t && (t && function(e) {
                        var t = r();
                        delete t[e], i(t);
                    }(e), !0);
                }, t.buildNotificationDot = function() {
                    var e = document.createElement("span");
                    return e.className = "tf-v1-popover-unread-dot", e.dataset.testid = "tf-v1-popover-unread-dot", e;
                };
            },
            6100: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            9630: function(e, t, n) {
                var o = this && this.__rest || function(e, t) {
                    var n = {};
                    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
                    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                        var r = 0;
                        for(o = Object.getOwnPropertySymbols(e); r < o.length; r++)t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
                    }
                    return n;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.createPopup = void 0;
                var r = n(6797), i = n(8027), a = n(6797);
                t.createPopup = function(e, t) {
                    if (void 0 === t && (t = {}), !(0, r.hasDom)()) return {
                        open: function() {},
                        close: function() {},
                        toggle: function() {},
                        refresh: function() {},
                        focus: function() {},
                        unmount: function() {}
                    };
                    var n, c = t.width, u = t.height, l = t.size, s = void 0 === l ? i.POPUP_SIZE : l, d = t.onClose, f = t.domain, p = o(t, [
                        "width",
                        "height",
                        "size",
                        "onClose",
                        "domain"
                    ]), v = (0, r.createIframe)("popup", {
                        formId: e,
                        domain: f,
                        options: p
                    }), m = v.iframe, h = v.embedId, b = v.refresh, y = v.focus, g = document.body.style.overflow, w = function() {
                        var e = document.createElement("div");
                        return e.className = "tf-v1-popup", e.dataset.testid = "tf-v1-popup", e.style.opacity = "0", e;
                    }(), O = function() {
                        var e = document.createElement("div");
                        return e.className = "tf-v1-spinner", e;
                    }(), _ = function(e, t, n) {
                        var o = document.createElement("div");
                        return o.className = "tf-v1-iframe-wrapper", o.style.opacity = "0", (0, r.isDefined)(e) && (0, r.isDefined)(t) ? (0, r.setElementSize)(o, {
                            width: e,
                            height: t
                        }) : (o.style.width = "calc(".concat(n, "% - 80px)"), o.style.height = "calc(".concat(n, "% - 80px)"), o);
                    }(c, u, s);
                    _.append(m), w.append(O), w.append(_);
                    var E = p.container || document.body;
                    m.onload = function(e) {
                        (null == e ? void 0 : e.isTrusted) && (_.style.opacity = "1", setTimeout(function() {
                            O.style.display = "none";
                        }, 250), (0, r.addCustomKeyboardListener)(j));
                    };
                    var P = function() {
                        (0, a.isOpen)(w) || ((0, a.isInPage)(w) ? w.style.display = "flex" : (O.style.display = "block", E.append(w)), document.body.style.overflow = "hidden", setTimeout(function() {
                            w.style.opacity = "1";
                        }));
                    }, j = function() {
                        (0, a.isOpen)(w) && ((0, r.handlePreventReopenOnClose)(p, e), null == d || d(), w.style.opacity = "0", document.body.style.overflow = g, setTimeout(function() {
                            p.keepSession ? w.style.display = "none" : I();
                        }, 250));
                    };
                    _.append(function(e) {
                        var t = document.createElement("button");
                        return t.className = "tf-v1-close tf-v1-close-icon", t.innerHTML = r.closeIconSvg, t.ariaLabel = "Close", t.onclick = (0, r.invokeWithoutDefault)(e), t;
                    }(j)), (0, r.setAutoClose)(h, p.autoClose, j), p.open && !(0, a.isOpen)(w) && (n = (0, r.handleCustomOpen)(P, p, e));
                    var I = function() {
                        (0, r.unmountElement)(w), p.open && (null == n ? void 0 : n.remove) && n.remove();
                    };
                    return {
                        open: P,
                        close: j,
                        toggle: function() {
                            (0, a.isOpen)(w) ? j() : P();
                        },
                        refresh: b,
                        focus: y,
                        unmount: I
                    };
                };
            },
            5970: function(e, t, n) {
                var o = this && this.__createBinding || (Object.create ? function(e, t, n, o) {
                    void 0 === o && (o = n);
                    var r = Object.getOwnPropertyDescriptor(t, n);
                    r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    }), Object.defineProperty(e, o, r);
                } : function(e, t, n, o) {
                    void 0 === o && (o = n), e[o] = t[n];
                }), r = this && this.__exportStar || function(e, t) {
                    for(var n in e)"default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), r(n(9630), t), r(n(7394), t);
            },
            7394: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            382: function(e, t, n) {
                var o = this && this.__assign || function() {
                    return o = Object.assign || function(e) {
                        for(var t, n = 1, o = arguments.length; n < o; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                        return e;
                    }, o.apply(this, arguments);
                }, r = this && this.__rest || function(e, t) {
                    var n = {};
                    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
                    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                        var r = 0;
                        for(o = Object.getOwnPropertySymbols(e); r < o.length; r++)t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
                    }
                    return n;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.createSidetab = void 0;
                var i = n(6797), a = {
                    buttonColor: "#3a7685",
                    buttonText: "Launch me"
                }, c = function(e, t) {
                    void 0 === e && (e = "div"), void 0 === t && (t = "tf-v1-sidetab-button-icon");
                    var n = document.createElement(e);
                    return n.className = "".concat(t, " tf-v1-close-icon"), n.innerHTML = i.closeIconSvg, n.dataset.testid = t, n;
                }, u = function(e, t) {
                    var n = e.parentNode;
                    n && (n.removeChild(e), n.appendChild(t));
                };
                t.createSidetab = function(e, t) {
                    void 0 === t && (t = {});
                    var n, l = o(o({}, a), t), s = l.domain, d = r(l, [
                        "domain"
                    ]), f = (0, i.createIframe)("side-tab", {
                        formId: e,
                        domain: s,
                        options: d
                    }), p = f.iframe, v = f.embedId, m = f.refresh, h = f.focus, b = function(e, t, n, o) {
                        var r = document.createElement("div");
                        return r.className = "tf-v1-sidetab", r.dataset.testid = "tf-v1-sidetab", (0, i.setElementSize)(r, {
                            width: e,
                            height: t
                        }), void 0 !== n ? (r.style.top = "calc(".concat((0, i.getValueWithUnits)(n), " + ").concat((0, i.getValueWithUnits)(t || 580), " / 2)"), r.style.bottom = "auto") : void 0 !== o && (r.style.top = "auto", r.style.bottom = "calc(".concat((0, i.getValueWithUnits)(o), " - ").concat((0, i.getValueWithUnits)(t || 580), " / 2)")), r;
                    }(d.width, d.height, d.top, d.bottom), y = function() {
                        var e = document.createElement("div");
                        return e.className = "tf-v1-sidetab-wrapper", e.dataset.testid = "tf-v1-sidetab-wrapper", e;
                    }(), g = function() {
                        var e = document.createElement("div");
                        e.className = "tf-v1-spinner";
                        var t = document.createElement("div");
                        return t.className = "tf-v1-sidetab-button-icon", t.dataset.testid = "spinner-icon", t.append(e), t;
                    }(), w = function(e) {
                        var t = e.backgroundColor, n = e.textColor, o = e.width, r = e.height, a = e.align, c = void 0 === a ? "center" : a, u = e.buttonProps, l = void 0 === u ? {} : u, s = document.createElement("button");
                        return s.className = "tf-v1-sidetab-button", s.style.backgroundColor = t, s.style.color = n || (0, i.getTextColor)(t), (0, i.addAttributesToElement)(s, l), (0, i.setElementSize)(s, {
                            width: o,
                            height: r
                        }), r && (s.style.left = "-".concat((0, i.getValueWithUnits)(r))), "top" === c ? (s.style.transform = "rotate(-90deg) translateX(-100%)", s.style.top = "0") : "bottom" === c && (s.style.transform = "rotate(-90deg) translateX(0)", s.style.top = "auto", s.style.bottom = "-".concat((0, i.getValueWithUnits)(r || 48))), s;
                    }({
                        backgroundColor: d.buttonColor || a.buttonColor,
                        textColor: d.buttonTextColor,
                        width: d.buttonHeight,
                        height: d.buttonWidth,
                        align: d.buttonAlign,
                        buttonProps: d.buttonProps
                    }), O = function(e, t) {
                        var n = document.createElement("span");
                        return n.className = "tf-v1-sidetab-button-text", n.innerHTML = e, t && (n.style.fontSize = (0, i.getValueWithUnits)(t)), n;
                    }(d.buttonText || a.buttonText, d.buttonTextSize), _ = function(e, t, n, o) {
                        var r = n || (0, i.getTextColor)(t), a = document.createElement("div");
                        a.className = "tf-v1-sidetab-button-icon", o && (a.style.width = (0, i.getValueWithUnits)(o), a.style.height = (0, i.getValueWithUnits)(o));
                        var c = (0, i.triggerIconSvg)(r), u = null == e ? void 0 : e.startsWith("http");
                        return a.innerHTML = u ? "<img alt='popover trigger icon button' src='".concat(e, "'/>") : null != e ? e : c, a.dataset.testid = "default-icon", a;
                    }(d.customIcon, d.buttonColor || a.buttonColor, d.buttonTextColor, d.buttonTextSize), E = c(), P = c("button", "tf-v1-sidetab-close");
                    (d.container || document.body).append(b), y.append(p), b.append(w), b.append(P), w.append(_), w.append(O), setTimeout(function() {
                        b.classList.add("ready");
                    }, 250), p.onload = function(e) {
                        (null == e ? void 0 : e.isTrusted) && (b.classList.add("open"), u(g, E), (0, i.addCustomKeyboardListener)(I));
                    };
                    var j = function() {
                        (0, i.isOpen)(y) || ((0, i.isInPage)(y) ? (y.style.display = "flex", b.classList.add("open"), u(_, E)) : (b.append(y), u(_, g)));
                    }, I = function() {
                        var t;
                        (0, i.isOpen)(y) && ((0, i.handlePreventReopenOnClose)(d, e), null === (t = d.onClose) || void 0 === t || t.call(d), b.classList.remove("open"), setTimeout(function() {
                            d.keepSession ? y.style.display = "none" : (0, i.unmountElement)(y), u(E, _);
                        }, 250));
                    };
                    (0, i.setAutoClose)(v, d.autoClose, I);
                    var T = function() {
                        (0, i.isOpen)(y) ? I() : j();
                    };
                    return w.onclick = (0, i.invokeWithoutDefault)(T), P.onclick = (0, i.invokeWithoutDefault)(I), d.open && !(0, i.isOpen)(y) && (n = (0, i.handleCustomOpen)(j, d, e)), {
                        open: j,
                        close: I,
                        toggle: T,
                        refresh: m,
                        focus: h,
                        unmount: function() {
                            (0, i.unmountElement)(b), d.open && (null == n ? void 0 : n.remove) && n.remove();
                        }
                    };
                };
            },
            1434: function(e, t, n) {
                var o = this && this.__createBinding || (Object.create ? function(e, t, n, o) {
                    void 0 === o && (o = n);
                    var r = Object.getOwnPropertyDescriptor(t, n);
                    r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    }), Object.defineProperty(e, o, r);
                } : function(e, t, n, o) {
                    void 0 === o && (o = n), e[o] = t[n];
                }), r = this && this.__exportStar || function(e, t) {
                    for(var n in e)"default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), r(n(382), t), r(n(7668), t);
            },
            7668: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            2603: function(e, t, n) {
                var o = this && this.__rest || function(e, t) {
                    var n = {};
                    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
                    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                        var r = 0;
                        for(o = Object.getOwnPropertySymbols(e); r < o.length; r++)t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
                    }
                    return n;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.createSlider = void 0;
                var r = n(6797), i = n(8027);
                t.createSlider = function(e, t) {
                    if (void 0 === t && (t = {}), !(0, r.hasDom)()) return {
                        open: function() {},
                        close: function() {},
                        toggle: function() {},
                        refresh: function() {},
                        focus: function() {},
                        unmount: function() {}
                    };
                    var n, a = t.position, c = void 0 === a ? i.SLIDER_POSITION : a, u = t.width, l = void 0 === u ? i.SLIDER_WIDTH : u, s = t.onClose, d = t.domain, f = o(t, [
                        "position",
                        "width",
                        "onClose",
                        "domain"
                    ]), p = (0, r.createIframe)("slider", {
                        formId: e,
                        domain: d,
                        options: f
                    }), v = p.iframe, m = p.embedId, h = p.refresh, b = p.focus, y = document.body.style.overflow, g = function(e) {
                        var t = document.createElement("div");
                        return t.className = "tf-v1-slider ".concat(e), t.dataset.testid = "tf-v1-slider", t.style.opacity = "0", t;
                    }(c), w = function() {
                        var e = document.createElement("div");
                        return e.className = "tf-v1-spinner", e;
                    }(), O = function(e, t) {
                        var n = document.createElement("div");
                        return n.className = "tf-v1-iframe-wrapper", n.style[e] = "-100%", (0, r.setElementSize)(n, {
                            width: t
                        });
                    }(c, l);
                    O.append(v), g.append(w), g.append(O);
                    var _ = f.container || document.body;
                    v.onload = function(e) {
                        (null == e ? void 0 : e.isTrusted) && (O.style[c] = "0", setTimeout(function() {
                            w.style.display = "none";
                        }, 500), (0, r.addCustomKeyboardListener)(P));
                    };
                    var E = function() {
                        (0, r.isOpen)(g) || ((0, r.isInPage)(g) ? (g.style.display = "flex", setTimeout(function() {
                            O.style[c] = "0";
                        })) : (_.append(g), w.style.display = "block"), document.body.style.overflow = "hidden", setTimeout(function() {
                            g.style.opacity = "1";
                        }));
                    }, P = function() {
                        (0, r.isOpen)(g) && ((0, r.handlePreventReopenOnClose)(f, e), null == s || s(), g.style.opacity = "0", O.style[c] = "-100%", document.body.style.overflow = y, setTimeout(function() {
                            f.keepSession ? g.style.display = "none" : j();
                        }, 500));
                    };
                    (0, r.setAutoClose)(m, f.autoClose, P), O.append(function(e) {
                        var t = document.createElement("button");
                        return t.className = "tf-v1-close tf-v1-close-icon", t.innerHTML = r.closeIconSvg, t.ariaLabel = "Close", t.onclick = (0, r.invokeWithoutDefault)(e), t;
                    }(P)), f.open && !(0, r.isOpen)(g) && (n = (0, r.handleCustomOpen)(E, f, e));
                    var j = function() {
                        (0, r.unmountElement)(g), f.open && (null == n ? void 0 : n.remove) && n.remove();
                    };
                    return {
                        open: E,
                        close: P,
                        toggle: function() {
                            (0, r.isOpen)(g) ? P() : E();
                        },
                        refresh: h,
                        focus: b,
                        unmount: j
                    };
                };
            },
            4071: function(e, t, n) {
                var o = this && this.__createBinding || (Object.create ? function(e, t, n, o) {
                    void 0 === o && (o = n);
                    var r = Object.getOwnPropertyDescriptor(t, n);
                    r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    }), Object.defineProperty(e, o, r);
                } : function(e, t, n, o) {
                    void 0 === o && (o = n), e[o] = t[n];
                }), r = this && this.__exportStar || function(e, t) {
                    for(var n in e)"default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), r(n(2603), t), r(n(3162), t);
            },
            3162: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            718: function(e, t, n) {
                var o = this && this.__rest || function(e, t) {
                    var n = {};
                    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
                    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                        var r = 0;
                        for(o = Object.getOwnPropertySymbols(e); r < o.length; r++)t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
                    }
                    return n;
                }, r = this && this.__read || function(e, t) {
                    var n = "function" == typeof Symbol && e[Symbol.iterator];
                    if (!n) return e;
                    var o, r, i = n.call(e), a = [];
                    try {
                        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
                    } catch (e) {
                        r = {
                            error: e
                        };
                    } finally{
                        try {
                            o && !o.done && (n = i.return) && n.call(i);
                        } finally{
                            if (r) throw r.error;
                        }
                    }
                    return a;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.createWidget = void 0;
                var i = n(6797), a = n(8554), c = n(2313), u = n(1126);
                t.createWidget = function(e, t) {
                    if (!(0, i.hasDom)()) return {
                        refresh: function() {},
                        focus: function() {},
                        unmount: function() {}
                    };
                    var n = t.domain, l = o(t, [
                        "domain"
                    ]);
                    l.inlineOnMobile = t.inlineOnMobile || t.fullScreen;
                    var s = document.body.style.overflow;
                    l.inlineOnMobile || !l.forceTouch && !(0, i.isFullscreen)() || (l.displayAsFullScreenModal = !0, l.forceTouch = !0, l.autoResize = !1);
                    var d = (0, i.createIframe)("widget", {
                        formId: e,
                        domain: n,
                        options: l
                    }), f = d.embedId, p = d.iframe, v = d.refresh, m = d.focus, h = (0, c.buildWidget)(p, l.width, l.height);
                    if (l.fullScreen && (0, u.overrideFullScreenStyles)(t.container, p), l.autoResize) {
                        var b = r("string" == typeof l.autoResize ? l.autoResize.split(",").map(function(e) {
                            return parseInt(e);
                        }) : [], 2), y = b[0], g = b[1];
                        window.addEventListener("message", (0, a.getFormHeightChangedHandler)(f, function(e) {
                            var n = Math.max(e.height, y || 0);
                            g && (n = Math.min(n, g)), t.container.style.height = "".concat(n, "px");
                        }));
                    }
                    l.autoFocus && window.addEventListener("message", (0, a.getFormReadyHandler)(f, function() {
                        setTimeout(function() {
                            m();
                        }, 1e3);
                    }));
                    var w, O = function() {
                        return t.container.append(h);
                    };
                    if (t.container.innerHTML = "", t.lazy ? (0, i.lazyInitialize)(t.container, O) : O(), l.displayAsFullScreenModal) {
                        var _ = "", E = t.container, P = E.style.height;
                        window.addEventListener("message", (0, a.getWelcomeScreenHiddenHandler)(f, function() {
                            E.classList.add("tf-v1-widget-fullscreen"), void 0 !== t.opacity && (E.style.backgroundColor = _);
                        })), window.addEventListener("message", (0, a.getFormThemeHandler)(f, function(e) {
                            var t;
                            _ = (0, i.changeColorOpacity)(null === (t = null == e ? void 0 : e.theme) || void 0 === t ? void 0 : t.backgroundColor);
                        }));
                        var j = ((w = document.createElement("button")).className = "tf-v1-widget-close tf-v1-close-icon", w.innerHTML = "&times;", w.ariaLabel = "Close", w);
                        j.onclick = (0, i.invokeWithoutDefault)(function() {
                            var e;
                            if (E.style.height = P, null === (e = t.onClose) || void 0 === e || e.call(t), E.classList.remove("tf-v1-widget-fullscreen"), E.style.backgroundColor = "", l.fullScreen && (document.body.style.overflow = s), t.keepSession) {
                                var n = document.createElement("div");
                                n.className = "tf-v1-widget-iframe-overlay", n.onclick = function() {
                                    E.classList.add("tf-v1-widget-fullscreen"), (0, i.unmountElement)(n);
                                }, h.append(n);
                            } else t.container.innerHTML = "", O(), E.append(j);
                        }), E.append(j);
                    }
                    return {
                        refresh: v,
                        focus: m,
                        unmount: function() {
                            (0, i.unmountElement)(h);
                        }
                    };
                };
            },
            1419: function(e, t, n) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.buildWidget = void 0;
                var o = n(6797);
                t.buildWidget = function(e, t, n) {
                    var r = document.createElement("div");
                    return r.className = "tf-v1-widget", r.dataset.testid = "tf-v1-widget", r.append(e), (0, o.setElementSize)(r, {
                        width: t,
                        height: n
                    });
                };
            },
            2313: function(e, t, n) {
                var o = this && this.__createBinding || (Object.create ? function(e, t, n, o) {
                    void 0 === o && (o = n);
                    var r = Object.getOwnPropertyDescriptor(t, n);
                    r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    }), Object.defineProperty(e, o, r);
                } : function(e, t, n, o) {
                    void 0 === o && (o = n), e[o] = t[n];
                }), r = this && this.__exportStar || function(e, t) {
                    for(var n in e)"default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), r(n(1419), t);
            },
            1126: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.overrideFullScreenStyles = void 0, t.overrideFullScreenStyles = function(e, t) {
                    Object.assign(e.style, {
                        zIndex: "10001",
                        position: "absolute",
                        top: "0",
                        left: "0",
                        width: "100%",
                        height: "100%"
                    }), t.style.borderRadius = "0", Object.assign(document.body.style, {
                        overflow: "hidden"
                    });
                };
            },
            9321: function(e, t, n) {
                var o = this && this.__createBinding || (Object.create ? function(e, t, n, o) {
                    void 0 === o && (o = n);
                    var r = Object.getOwnPropertyDescriptor(t, n);
                    r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    }), Object.defineProperty(e, o, r);
                } : function(e, t, n, o) {
                    void 0 === o && (o = n), e[o] = t[n];
                }), r = this && this.__exportStar || function(e, t) {
                    for(var n in e)"default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), r(n(718), t), r(n(4058), t);
            },
            4058: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            1920: function(e, t, n) {
                var o = this && this.__createBinding || (Object.create ? function(e, t, n, o) {
                    void 0 === o && (o = n);
                    var r = Object.getOwnPropertyDescriptor(t, n);
                    r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    }), Object.defineProperty(e, o, r);
                } : function(e, t, n, o) {
                    void 0 === o && (o = n), e[o] = t[n];
                }), r = this && this.__exportStar || function(e, t) {
                    for(var n in e)"default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), r(n(1797), t), r(n(5970), t), r(n(4071), t), r(n(9321), t), r(n(1434), t);
            },
            5084: function(e, t, n) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.addAttributesToElement = void 0;
                var o = n(7377);
                t.addAttributesToElement = function(e, t) {
                    void 0 === t && (t = {}), Object.keys(t).forEach(function(n) {
                        e.setAttribute((0, o.camelCaseToKebabCase)(n), t[n]);
                    });
                };
            },
            3626: function(e, t, n) {
                var o = this && this.__assign || function() {
                    return o = Object.assign || function(e) {
                        for(var t, n = 1, o = arguments.length; n < o; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                        return e;
                    }, o.apply(this, arguments);
                }, r = this && this.__read || function(e, t) {
                    var n = "function" == typeof Symbol && e[Symbol.iterator];
                    if (!n) return e;
                    var o, r, i = n.call(e), a = [];
                    try {
                        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
                    } catch (e) {
                        r = {
                            error: e
                        };
                    } finally{
                        try {
                            o && !o.done && (n = i.return) && n.call(i);
                        } finally{
                            if (r) throw r.error;
                        }
                    }
                    return a;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.buildIframeSrc = void 0;
                var i = n(8027), a = n(4527), c = n(2346), u = n(2698), l = n(863), s = {
                    widget: "embed-widget",
                    popup: "popup-blank",
                    slider: "popup-drawer",
                    popover: "popup-popover",
                    "side-tab": "popup-side-panel"
                };
                t.buildIframeSrc = function(e) {
                    var t = e.domain, n = e.formId, d = e.type, f = e.embedId, p = e.options, v = function(e, t, n) {
                        var r = n.transitiveSearchParams, i = n.source, a = n.medium, c = n.mediumVersion, l = n.hideFooter, d = n.hideHeaders, f = n.opacity, p = n.disableTracking, v = n.enableSandbox, m = n.shareGaInstance, h = n.forceTouch, b = n.displayAsFullScreenModal, y = n.tracking, g = n.redirectTarget, w = n.autoResize, O = n.disableScroll, _ = n.onEndingButtonClick, E = n.noHeading, P = n.noScrollbars, j = (0, u.getTransitiveSearchParams)(r);
                        return o(o(o({}, {
                            "typeform-embed-id": t,
                            "typeform-embed": s[e],
                            "typeform-source": i,
                            "typeform-medium": a,
                            "typeform-medium-version": c,
                            "embed-hide-footer": l ? "true" : void 0,
                            "embed-hide-headers": d ? "true" : void 0,
                            "embed-opacity": f,
                            "disable-tracking": p || v ? "true" : void 0,
                            "__dangerous-disable-submissions": v ? "true" : void 0,
                            "share-ga-instance": m ? "true" : void 0,
                            "force-touch": h ? "true" : void 0,
                            "add-placeholder-ws": "widget" === e && b ? "true" : void 0,
                            "typeform-embed-redirect-target": g,
                            "typeform-embed-handles-redirect": 1,
                            "typeform-embed-auto-resize": w ? "true" : void 0,
                            "typeform-embed-disable-scroll": O ? "true" : void 0,
                            "typeform-embed-handle-ending-button-click": _ ? "true" : void 0,
                            "typeform-embed-no-heading": E ? "true" : void 0,
                            "typeform-embed-no-scrollbars": P ? "true" : void 0
                        }), j), y);
                    }(d, f, function(e) {
                        var t;
                        return e.noHeading || (e.noHeading = document.querySelectorAll("h1").length > 0), o(o({}, {
                            source: null === (t = null === window || void 0 === window ? void 0 : window.location) || void 0 === t ? void 0 : t.hostname.replace(/^www\./, ""),
                            medium: "embed-sdk",
                            mediumVersion: "next"
                        }), (0, a.removeUndefinedKeys)(e));
                    }(p)), m = function(e, t) {
                        return void 0 === t && (t = i.DEFAULT_DOMAIN), e.startsWith("http://") || e.startsWith("https://") ? new URL(e) : new URL("https://".concat(t, "/to/").concat(e));
                    }(n, t);
                    if (Object.entries(v).filter(function(e) {
                        var t = r(e, 2)[1];
                        return (0, c.isDefined)(t);
                    }).forEach(function(e) {
                        var t = r(e, 2), n = t[0], o = t[1];
                        m.searchParams.set(n, o);
                    }), p.hubspot) {
                        var h = (0, l.getHubspotHiddenFields)();
                        p.hidden = o(o({}, p.hidden), h);
                    }
                    return m.hash = function(e, t) {
                        var n = new URLSearchParams;
                        t.hidden && Object.entries(t.hidden).filter(function(e) {
                            var t = r(e, 2)[1];
                            return (0, c.isDefined)(t) && "" !== t;
                        }).forEach(function(o) {
                            var i = r(o, 2), a = i[0], c = i[1];
                            "boolean" == typeof t.transitiveSearchParams && e.searchParams.delete(a), n.set(a, c);
                        });
                        var o = function(e) {
                            if (!e) return null;
                            var t = Object.keys(e).at(0), n = t && e[t] || void 0;
                            return void 0 === t || void 0 === n ? null : {
                                key: "answers-".concat(t),
                                value: n
                            };
                        }(t.preselect);
                        if (o) {
                            var i = o.key, a = o.value;
                            n.set(i, a);
                        }
                        return n.toString();
                    }(m, p), m.href;
                };
            },
            2391: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.changeColorOpacity = void 0, t.changeColorOpacity = function(e, t) {
                    return void 0 === e && (e = ""), void 0 === t && (t = 255), e.startsWith("rgba(") ? null == e ? void 0 : e.replace(/, [\d.]+\)$/, ", ".concat(t, ")")) : e;
                };
            },
            6289: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.closeIconSvg = void 0, t.closeIconSvg = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.293 4.293a1 1 0 0 1 1.414 0L12 10.586l6.293-6.293a1 1 0 1 1 1.414 1.414L13.414 12l6.293 6.293a1 1 0 0 1-1.414 1.414L12 13.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L10.586 12 4.293 5.707a1 1 0 0 1 0-1.414Z" fill="currentColor"/>\n</svg>';
            },
            8972: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.handleCustomOpen = t.handlePreventReopenOnClose = void 0;
                var n = {
                    remove: function() {}
                };
                t.handlePreventReopenOnClose = function(e, t) {
                    e.preventReopenOnClose && r(t);
                };
                t.handleCustomOpen = function(e, t, r) {
                    var i = t.open, a = t.openValue, c = t.preventReopenOnClose, u = function(e, t, n, r) {
                        return function() {
                            var i, a;
                            if (!(r && o(t) || "all" === n && (a = document.querySelector(".tf-v1-popup, .tf-v1-slider, .tf-v1-popover-wrapper, .tf-v1-sidetab-wrapper"), (null == a ? void 0 : a.offsetHeight) || (null == a ? void 0 : a.offsetWidth) || (null === (i = null == a ? void 0 : a.getClientRects()) || void 0 === i ? void 0 : i.length)) || "same" === n && function(e) {
                                var t = document.querySelectorAll(".tf-v1-popup, .tf-v1-slider, .tf-v1-popover-wrapper, .tf-v1-sidetab-wrapper");
                                return Array.from(t).some(function(t) {
                                    var n, o = null === (n = t.querySelector("iframe")) || void 0 === n ? void 0 : n.src;
                                    return (null == o ? void 0 : o.includes("typeform.com/to/".concat(e))) || (null == o ? void 0 : o.startsWith(e));
                                });
                            }(t))) return e();
                        };
                    }(e, r, t.respectOpenModals, c);
                    switch(i){
                        case "load":
                            return u(), n;
                        case "exit":
                            return a ? function(e, t) {
                                var n = 0, o = function(r) {
                                    r.clientY < e && r.clientY < n ? (document.removeEventListener("mousemove", o, !0), t()) : n = r.clientY;
                                };
                                return document.addEventListener("mousemove", o, !0), {
                                    remove: function() {
                                        return document.removeEventListener("mousemove", o, !0);
                                    }
                                };
                            }(a, u) : n;
                        case "time":
                            return setTimeout(function() {
                                u();
                            }, a), n;
                        case "scroll":
                            return a ? function(e, t) {
                                function n() {
                                    var o = window.pageYOffset || document.documentElement.scrollTop, r = document.documentElement.clientTop || 0, i = document.documentElement.scrollHeight, a = o - r, c = a / i * 100, u = a + window.innerHeight >= i;
                                    (c >= e || u) && (t(), document.removeEventListener("scroll", n));
                                }
                                return document.addEventListener("scroll", n), {
                                    remove: function() {
                                        return document.removeEventListener("scroll", n);
                                    }
                                };
                            }(a, u) : n;
                        default:
                            return n;
                    }
                };
                var o = function(e) {
                    return document.cookie.includes("tf-".concat(e, "-closed=true"));
                }, r = function(e) {
                    document.cookie = "tf-".concat(e, "-closed=true;Path=/");
                };
            },
            1553: function(e, t, n) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.createIframe = void 0;
                var o = n(3626), r = n(6797), i = n(8866), a = n(8554), c = n(2256), u = n(7144), l = n(5511);
                t.createIframe = function(e, t) {
                    var n = t.formId, s = t.domain, d = t.options, f = (0, i.generateEmbedId)(), p = d.iframeProps, v = void 0 === p ? {} : p, m = d.onReady, h = d.onStarted, b = d.onQuestionChanged, y = d.onHeightChanged, g = d.onSubmit, w = d.onEndingButtonClick, O = d.onDuplicateDetected, _ = d.shareGaInstance, E = (0, o.buildIframeSrc)({
                        formId: n,
                        domain: s,
                        embedId: f,
                        type: e,
                        options: d
                    }), P = document.createElement("iframe");
                    return P.src = E, P.dataset.testid = "iframe", P.style.border = "0px", P.allow = "microphone; camera", (0, r.addAttributesToElement)(P, v), P.addEventListener("load", c.triggerIframeRedraw, {
                        once: !0
                    }), window.addEventListener("message", (0, a.getFormReadyHandler)(f, m)), window.addEventListener("message", (0, a.getFormStartedHandler)(f, h)), window.addEventListener("message", (0, a.getFormQuestionChangedHandler)(f, b)), window.addEventListener("message", (0, a.getFormHeightChangedHandler)(f, y)), window.addEventListener("message", (0, a.getFormSubmitHandler)(f, g)), window.addEventListener("message", (0, a.getFormThemeHandler)(f, function(e) {
                        var t;
                        if (null == e ? void 0 : e.theme) {
                            var n = document.querySelector(".tf-v1-close-icon");
                            n && (n.style.color = null === (t = e.theme) || void 0 === t ? void 0 : t.color);
                        }
                    })), window.addEventListener("message", (0, a.getThankYouScreenButtonClickHandler)(f, w)), window.addEventListener("message", (0, a.getRedirectHandler)(f, P)), window.addEventListener("message", (0, a.getDuplicateDetectedHandler)(f, O)), "widget" !== e && window.addEventListener("message", u.dispatchCustomKeyEventFromIframe), _ && window.addEventListener("message", (0, a.getFormReadyHandler)(f, function() {
                        (0, r.setupGaInstance)(P, f, _);
                    })), {
                        iframe: P,
                        embedId: f,
                        refresh: function() {
                            return (0, l.refreshIframe)(P);
                        },
                        focus: function() {
                            var e;
                            null === (e = P.contentWindow) || void 0 === e || e.postMessage("embed-focus", "*");
                        }
                    };
                };
            },
            8866: function(e, t) {
                var n = this && this.__read || function(e, t) {
                    var n = "function" == typeof Symbol && e[Symbol.iterator];
                    if (!n) return e;
                    var o, r, i = n.call(e), a = [];
                    try {
                        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
                    } catch (e) {
                        r = {
                            error: e
                        };
                    } finally{
                        try {
                            o && !o.done && (n = i.return) && n.call(i);
                        } finally{
                            if (r) throw r.error;
                        }
                    }
                    return a;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.generateEmbedId = void 0, t.generateEmbedId = function() {
                    var e = Math.random();
                    return n(String(e).split("."), 2)[1];
                };
            },
            8554: function(e, t, n) {
                var o = this && this.__rest || function(e, t) {
                    var n = {};
                    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
                    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                        var r = 0;
                        for(o = Object.getOwnPropertySymbols(e); r < o.length; r++)t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
                    }
                    return n;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getRedirectHandler = t.getThankYouScreenButtonClickHandler = t.getFormThemeHandler = t.getWelcomeScreenHiddenHandler = t.getDuplicateDetectedHandler = t.getFormSubmitHandler = t.getFormHeightChangedHandler = t.getFormQuestionChangedHandler = t.getFormStartedHandler = t.getFormReadyHandler = void 0;
                var r = n(8743);
                t.getFormReadyHandler = function(e, t) {
                    return a("form-ready", e, t);
                }, t.getFormStartedHandler = function(e, t) {
                    return a("form-started", e, t);
                }, t.getFormQuestionChangedHandler = function(e, t) {
                    return a("form-screen-changed", e, t);
                }, t.getFormHeightChangedHandler = function(e, t) {
                    return a("form-height-changed", e, t);
                }, t.getFormSubmitHandler = function(e, t) {
                    return a("form-submit", e, t);
                }, t.getDuplicateDetectedHandler = function(e, t) {
                    return a("duplicate-detected", e, t);
                }, t.getWelcomeScreenHiddenHandler = function(e, t) {
                    return a("welcome-screen-hidden", e, t);
                }, t.getFormThemeHandler = function(e, t) {
                    return a("form-theme", e, t);
                }, t.getThankYouScreenButtonClickHandler = function(e, t) {
                    return a("thank-you-screen-button-click", e, t);
                }, t.getRedirectHandler = function(e, t) {
                    return a([
                        "redirect-after-submit",
                        "thank-you-screen-redirect"
                    ], e, (0, r.handleFormRedirect)(t));
                };
                var i = function(e, t) {
                    return Array.isArray(e) ? e.includes(t) : e === t;
                };
                function a(e, t, n) {
                    return function(r) {
                        var a = r.data, c = a.type, u = a.embedId, l = o(a, [
                            "type",
                            "embedId"
                        ]);
                        i(e, c) && u === t && (null == n || n(l));
                    };
                }
            },
            8743: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.handleFormRedirect = void 0, t.handleFormRedirect = function(e) {
                    return function(t) {
                        var n, o, r = t.url, i = t.target;
                        if (r) switch(void 0 === i ? "_parent" : i){
                            case "_self":
                                e.src = (n = e.src, (o = r).includes("#") && o.startsWith("".concat(n, "#")) ? o.includes("?") ? o.replace("#", "&tf-embed-ts=".concat(Date.now(), "#")) : o.replace("#", "?tf-embed-ts=".concat(Date.now(), "#")) : o);
                                break;
                            case "_blank":
                                window.open(r, "_blank");
                                break;
                            case "_top":
                                var a = document.createElement("a");
                                a.href = r, a.target = "_top", document.body.appendChild(a), a.click(), document.body.removeChild(a);
                                break;
                            default:
                                window.location.href = r;
                        }
                        else console.error("Redirect failed, no URL provided");
                    };
                };
            },
            339: function(e, t, n) {
                var o = this && this.__createBinding || (Object.create ? function(e, t, n, o) {
                    void 0 === o && (o = n);
                    var r = Object.getOwnPropertyDescriptor(t, n);
                    r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    }), Object.defineProperty(e, o, r);
                } : function(e, t, n, o) {
                    void 0 === o && (o = n), e[o] = t[n];
                }), r = this && this.__exportStar || function(e, t) {
                    for(var n in e)"default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), r(n(1553), t), r(n(7144), t);
            },
            5511: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.refreshIframe = void 0, t.refreshIframe = function(e) {
                    if (e) {
                        var t = e.src;
                        if (t.includes("&refresh")) {
                            var n = t.split("&refresh#");
                            e.src = n.join("#");
                        } else (n = t.split("#"))[0] = "".concat(n[0], "&refresh"), e.src = n.join("#");
                    }
                };
            },
            7144: function(e, t) {
                var n = this && this.__awaiter || function(e, t, n, o) {
                    return new (n || (n = Promise))(function(r, i) {
                        function a(e) {
                            try {
                                u(o.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            try {
                                u(o.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                                e(t);
                            })).then(a, c);
                        }
                        u((o = o.apply(e, t || [])).next());
                    });
                }, o = this && this.__generator || function(e, t) {
                    var n, o, r, i, a = {
                        label: 0,
                        sent: function() {
                            if (1 & r[0]) throw r[1];
                            return r[1];
                        },
                        trys: [],
                        ops: []
                    };
                    return i = {
                        next: c(0),
                        throw: c(1),
                        return: c(2)
                    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                        return this;
                    }), i;
                    function c(c) {
                        return function(u) {
                            return function(c) {
                                if (n) throw new TypeError("Generator is already executing.");
                                for(; i && (i = 0, c[0] && (a = 0)), a;)try {
                                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                                    switch(o = 0, r && (c = [
                                        2 & c[0],
                                        r.value
                                    ]), c[0]){
                                        case 0:
                                        case 1:
                                            r = c;
                                            break;
                                        case 4:
                                            return a.label++, {
                                                value: c[1],
                                                done: !1
                                            };
                                        case 5:
                                            a.label++, o = c[1], c = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            c = a.ops.pop(), a.trys.pop();
                                            continue;
                                        default:
                                            if (!((r = (r = a.trys).length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                                a = 0;
                                                continue;
                                            }
                                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                                a.label = c[1];
                                                break;
                                            }
                                            if (6 === c[0] && a.label < r[1]) {
                                                a.label = r[1], r = c;
                                                break;
                                            }
                                            if (r && a.label < r[2]) {
                                                a.label = r[2], a.ops.push(c);
                                                break;
                                            }
                                            r[2] && a.ops.pop(), a.trys.pop();
                                            continue;
                                    }
                                    c = t.call(e, a);
                                } catch (e) {
                                    c = [
                                        6,
                                        e
                                    ], o = 0;
                                } finally{
                                    n = r = 0;
                                }
                                if (5 & c[0]) throw c[1];
                                return {
                                    value: c[0] ? c[1] : void 0,
                                    done: !0
                                };
                            }([
                                c,
                                u
                            ]);
                        };
                    }
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.dispatchCustomKeyEventFromIframe = t.removeCustomKeyboardListener = t.addCustomKeyboardListener = void 0;
                var r = "Escape", i = function(e, i) {
                    return n(void 0, void 0, void 0, function() {
                        return o(this, function(n) {
                            return e.code === r && "function" == typeof i && (i(), (0, t.removeCustomKeyboardListener)()), [
                                2
                            ];
                        });
                    });
                };
                t.addCustomKeyboardListener = function(e) {
                    return window.document.addEventListener("keydown", function(t) {
                        return i(t, e);
                    });
                }, t.removeCustomKeyboardListener = function() {
                    return window.document.removeEventListener("keydown", i);
                }, t.dispatchCustomKeyEventFromIframe = function(e) {
                    "form-close" === e.data.type && window.document.dispatchEvent(new KeyboardEvent("keydown", {
                        code: r
                    }));
                };
            },
            2256: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.triggerIframeRedraw = void 0, t.triggerIframeRedraw = function() {
                    this.style.transform = "translateZ(0)";
                };
            },
            8939: function(e, t, n) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getTextColor = void 0;
                var o = n(2938);
                t.getTextColor = function(e) {
                    if (!e) return "#FFFFFF";
                    var t = e.startsWith("#") ? (0, o.hexRgb)(e) : function(e) {
                        var t = {
                            red: 0,
                            green: 0,
                            blue: 0
                        }, n = e.match(/\d+/g);
                        return n && (t.red = parseInt(n[0], 10), t.green = parseInt(n[0], 10), t.blue = parseInt(n[0], 10)), t;
                    }(e), n = t.red, r = t.green, i = t.blue;
                    return Math.round((299 * n + 587 * r + 114 * i) / 1e3) > 150 ? "#000000" : "#FFFFFF";
                };
            },
            2698: function(e, t) {
                var n = this && this.__assign || function() {
                    return n = Object.assign || function(e) {
                        for(var t, n = 1, o = arguments.length; n < o; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                        return e;
                    }, n.apply(this, arguments);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getTransitiveSearchParams = void 0, t.getTransitiveSearchParams = function(e) {
                    var t = new URL(window.location.href);
                    return "boolean" == typeof e && e ? Object.fromEntries(t.searchParams.entries()) : Array.isArray(e) && e.length > 0 ? e.reduce(function(e, o) {
                        var r, i = t.searchParams.get(o);
                        return i ? n(n({}, e), ((r = {})[o] = i, r)) : e;
                    }, {}) : {};
                };
            },
            8252: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hasDom = void 0, t.hasDom = function() {
                    return "undefined" != typeof document && "undefined" != typeof window;
                };
            },
            2938: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hexRgb = void 0;
                var n = "a-f\\d", o = "#?[".concat(n, "]{3}[").concat(n, "]?"), r = "#?[".concat(n, "]{6}([").concat(n, "]{2})?"), i = new RegExp("[^#".concat(n, "]"), "gi"), a = new RegExp("^".concat(o, "$|^").concat(r, "$"), "i");
                t.hexRgb = function(e) {
                    if ("string" != typeof e || i.test(e) || !a.test(e)) throw new TypeError("Expected a valid hex string");
                    8 === (e = e.replace(/^#/, "")).length && (e = e.slice(0, 6)), 4 === e.length && (e = e.slice(0, 3)), 3 === e.length && (e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2]);
                    var t = Number.parseInt(e, 16);
                    return {
                        red: t >> 16,
                        green: t >> 8 & 255,
                        blue: 255 & t
                    };
                };
            },
            863: function(e, t, n) {
                var o = this && this.__awaiter || function(e, t, n, o) {
                    return new (n || (n = Promise))(function(r, i) {
                        function a(e) {
                            try {
                                u(o.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            try {
                                u(o.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                                e(t);
                            })).then(a, c);
                        }
                        u((o = o.apply(e, t || [])).next());
                    });
                }, r = this && this.__generator || function(e, t) {
                    var n, o, r, i, a = {
                        label: 0,
                        sent: function() {
                            if (1 & r[0]) throw r[1];
                            return r[1];
                        },
                        trys: [],
                        ops: []
                    };
                    return i = {
                        next: c(0),
                        throw: c(1),
                        return: c(2)
                    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                        return this;
                    }), i;
                    function c(c) {
                        return function(u) {
                            return function(c) {
                                if (n) throw new TypeError("Generator is already executing.");
                                for(; i && (i = 0, c[0] && (a = 0)), a;)try {
                                    if (n = 1, o && (r = 2 & c[0] ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
                                    switch(o = 0, r && (c = [
                                        2 & c[0],
                                        r.value
                                    ]), c[0]){
                                        case 0:
                                        case 1:
                                            r = c;
                                            break;
                                        case 4:
                                            return a.label++, {
                                                value: c[1],
                                                done: !1
                                            };
                                        case 5:
                                            a.label++, o = c[1], c = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            c = a.ops.pop(), a.trys.pop();
                                            continue;
                                        default:
                                            if (!((r = (r = a.trys).length > 0 && r[r.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                                a = 0;
                                                continue;
                                            }
                                            if (3 === c[0] && (!r || c[1] > r[0] && c[1] < r[3])) {
                                                a.label = c[1];
                                                break;
                                            }
                                            if (6 === c[0] && a.label < r[1]) {
                                                a.label = r[1], r = c;
                                                break;
                                            }
                                            if (r && a.label < r[2]) {
                                                a.label = r[2], a.ops.push(c);
                                                break;
                                            }
                                            r[2] && a.ops.pop(), a.trys.pop();
                                            continue;
                                    }
                                    c = t.call(e, a);
                                } catch (e) {
                                    c = [
                                        6,
                                        e
                                    ], o = 0;
                                } finally{
                                    n = r = 0;
                                }
                                if (5 & c[0]) throw c[1];
                                return {
                                    value: c[0] ? c[1] : void 0,
                                    done: !0
                                };
                            }([
                                c,
                                u
                            ]);
                        };
                    }
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.waitForHubspotCookie = t.getHubspotHiddenFields = t.getHubspotCookieValue = void 0;
                var i = n(4623);
                t.getHubspotCookieValue = function() {
                    var e = document.cookie.match(new RegExp("(^| )".concat("hubspotutk", "=([^;]+)")));
                    return e && e[2] || void 0;
                }, t.getHubspotHiddenFields = function() {
                    return {
                        hubspot_page_name: document.title,
                        hubspot_page_url: window.location.href,
                        hubspot_utk: (0, t.getHubspotCookieValue)()
                    };
                }, t.waitForHubspotCookie = function() {
                    return o(void 0, void 0, void 0, function() {
                        var e, n;
                        return r(this, function(o) {
                            switch(o.label){
                                case 0:
                                    e = 10, n = 0, o.label = 1;
                                case 1:
                                    return !(0, t.getHubspotCookieValue)() && n < e ? [
                                        4,
                                        (0, i.sleep)(250)
                                    ] : [
                                        3,
                                        4
                                    ];
                                case 2:
                                    o.sent(), o.label = 3;
                                case 3:
                                    return n++, [
                                        3,
                                        1
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                };
            },
            9071: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.includeCss = void 0, t.includeCss = function(e) {
                    var t = function(e) {
                        return "".concat("https://embed.typeform.com/next/css/").concat(e);
                    }(e);
                    if (!document.querySelector('link[href="'.concat(t, '"]'))) {
                        var n = document.createElement("link");
                        n.rel = "stylesheet", n.href = t, document.head.append(n);
                    }
                };
            },
            6797: function(e, t, n) {
                var o = this && this.__createBinding || (Object.create ? function(e, t, n, o) {
                    void 0 === o && (o = n);
                    var r = Object.getOwnPropertyDescriptor(t, n);
                    r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    }), Object.defineProperty(e, o, r);
                } : function(e, t, n, o) {
                    void 0 === o && (o = n), e[o] = t[n];
                }), r = this && this.__exportStar || function(e, t) {
                    for(var n in e)"default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), r(n(3626), t), r(n(339), t), r(n(8252), t), r(n(9071), t), r(n(2346), t), r(n(7377), t), r(n(6563), t), r(n(4527), t), r(n(9533), t), r(n(1451), t), r(n(8972), t), r(n(4748), t), r(n(4392), t), r(n(8939), t), r(n(9917), t), r(n(1987), t), r(n(2391), t), r(n(863), t), r(n(6890), t), r(n(5084), t), r(n(6289), t), r(n(9832), t);
            },
            6890: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.invokeWithoutDefault = void 0, t.invokeWithoutDefault = function(e) {
                    return function(t) {
                        null == t || t.preventDefault(), e();
                    };
                };
            },
            2346: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isDefined = void 0, t.isDefined = function(e) {
                    return null != e;
                };
            },
            1987: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isVisible = t.isInPage = t.isOpen = void 0, t.isOpen = function(e) {
                    return (0, t.isInPage)(e) && (0, t.isVisible)(e);
                }, t.isInPage = function(e) {
                    return !!e.parentNode;
                }, t.isVisible = function(e) {
                    return "none" !== e.style.display;
                };
            },
            9917: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.lazyInitialize = void 0, t.lazyInitialize = function(e, t) {
                    var n = new IntersectionObserver(function(e) {
                        e.forEach(function(e) {
                            e.isIntersecting && (t(), n.unobserve(e.target));
                        });
                    });
                    n.observe(e);
                };
            },
            7377: function(e, t) {
                var n = this && this.__assign || function() {
                    return n = Object.assign || function(e) {
                        for(var t, n = 1, o = arguments.length; n < o; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                        return e;
                    }, n.apply(this, arguments);
                }, o = this && this.__read || function(e, t) {
                    var n = "function" == typeof Symbol && e[Symbol.iterator];
                    if (!n) return e;
                    var o, r, i = n.call(e), a = [];
                    try {
                        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
                    } catch (e) {
                        r = {
                            error: e
                        };
                    } finally{
                        try {
                            o && !o.done && (n = i.return) && n.call(i);
                        } finally{
                            if (r) throw r.error;
                        }
                    }
                    return a;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.loadOptionsFromAttributes = t.transformAttributeValue = t.camelCaseToKebabCase = void 0, t.camelCaseToKebabCase = function(e) {
                    return e.split("").map(function(e, t) {
                        return e.toUpperCase() === e ? "".concat(0 !== t ? "-" : "").concat(e.toLowerCase()) : e;
                    }).join("");
                };
                var r = function(e) {
                    return e || void 0;
                }, i = function(e) {
                    if (null !== e) return "" === e || "yes" === e || "true" === e;
                }, a = function(e) {
                    var t = e ? parseInt(e, 10) : NaN;
                    return isNaN(t) ? void 0 : t;
                }, c = "%ESCAPED_COMMA%", u = function(e) {
                    if (e) return e.replace(/\s/g, "").replace(/\\,/g, c).split(",").filter(function(e) {
                        return !!e;
                    }).map(function(e) {
                        return e.replace(c, ",");
                    });
                };
                t.transformAttributeValue = function(e, t) {
                    var l, s, d;
                    switch(t){
                        case "string":
                            return r(e);
                        case "boolean":
                            return i(e);
                        case "integer":
                            return a(e);
                        case "function":
                            return function(e) {
                                var t = e && e in window ? window[e] : void 0;
                                return "function" == typeof t ? t : void 0;
                            }(e);
                        case "array":
                            return u(e);
                        case "record":
                            return function(e) {
                                if (e) return e.replace(/\\,/g, c).split(",").filter(function(e) {
                                    return !!e;
                                }).map(function(e) {
                                    return e.replace(c, ",");
                                }).reduce(function(e, t) {
                                    var r, i = t.match(/^([^=]+)=(.*)$/);
                                    if (i) {
                                        var a = o(i, 3), c = a[1], u = a[2];
                                        return n(n({}, e), ((r = {})[c.trim()] = u, r));
                                    }
                                    return e;
                                }, {});
                            }(e);
                        case "integerOrString":
                            return function(e) {
                                if (e) return e.match(/^[0-9]+$/) ? a(e) : r(e);
                            }(e);
                        case "integerOrBoolean":
                            return null !== (l = a(e)) && void 0 !== l ? l : i(e);
                        case "stringOrBoolean":
                            return null !== (s = r(e)) && void 0 !== s ? s : i(e);
                        case "arrayOrBoolean":
                            return null !== (d = u(e)) && void 0 !== d ? d : i(e);
                        default:
                            throw new Error("Invalid attribute transformation ".concat(t));
                    }
                }, t.loadOptionsFromAttributes = function(e, o) {
                    return Object.keys(o).reduce(function(r, i) {
                        var a;
                        return n(n({}, r), ((a = {})[i] = (0, t.transformAttributeValue)(e.getAttribute("data-tf-".concat((0, t.camelCaseToKebabCase)(i))), o[i]), a));
                    }, {});
                };
            },
            6563: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isFullscreen = t.isMobile = t.isBigScreen = void 0, t.isBigScreen = function() {
                    return window.screen.width >= 1024 && window.screen.height >= 768;
                }, t.isMobile = function() {
                    return /mobile|tablet|android/i.test(navigator.userAgent.toLowerCase());
                }, t.isFullscreen = function() {
                    return (0, t.isMobile)() && !(0, t.isBigScreen)();
                };
            },
            4527: function(e, t, n) {
                var o = this && this.__assign || function() {
                    return o = Object.assign || function(e) {
                        for(var t, n = 1, o = arguments.length; n < o; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                        return e;
                    }, o.apply(this, arguments);
                }, r = this && this.__read || function(e, t) {
                    var n = "function" == typeof Symbol && e[Symbol.iterator];
                    if (!n) return e;
                    var o, r, i = n.call(e), a = [];
                    try {
                        for(; (void 0 === t || t-- > 0) && !(o = i.next()).done;)a.push(o.value);
                    } catch (e) {
                        r = {
                            error: e
                        };
                    } finally{
                        try {
                            o && !o.done && (n = i.return) && n.call(i);
                        } finally{
                            if (r) throw r.error;
                        }
                    }
                    return a;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.removeUndefinedKeys = void 0;
                var i = n(2346);
                t.removeUndefinedKeys = function(e) {
                    return Object.entries(e).filter(function(e) {
                        var t = r(e, 2)[1];
                        return (0, i.isDefined)(t);
                    }).reduce(function(e, t) {
                        var n, i = r(t, 2), a = i[0], c = i[1];
                        return o(o({}, e), ((n = {})[a] = c, n));
                    }, {});
                };
            },
            4748: function(e, t, n) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.setAutoClose = t.DEFAULT_AUTO_CLOSE_TIME = void 0;
                var o = n(8554);
                t.DEFAULT_AUTO_CLOSE_TIME = 500, t.setAutoClose = function(e, n, r) {
                    n && r && window.addEventListener("message", (0, o.getFormSubmitHandler)(e, function() {
                        var e, o;
                        return setTimeout(r, (o = "number" == typeof (e = n) ? e : 0, Math.max(o, t.DEFAULT_AUTO_CLOSE_TIME)));
                    }));
                };
            },
            9533: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.setElementSize = t.getValueWithUnits = void 0, t.getValueWithUnits = function(e) {
                    return "string" != typeof e || e.match(/^[0-9]+$/) ? "".concat(e, "px") : e;
                }, t.setElementSize = function(e, n) {
                    var o = n.width, r = n.height;
                    return o && (e.style.width = (0, t.getValueWithUnits)(o)), r && (e.style.height = (0, t.getValueWithUnits)(r)), e;
                };
            },
            4392: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.setupGaInstance = t.sendGaIdMessage = void 0, t.sendGaIdMessage = function(e, t, n) {
                    var o = {
                        embedId: e,
                        gaClientId: t
                    };
                    setTimeout(function() {
                        n && n.contentWindow && n.contentWindow.postMessage({
                            type: "ga-client-id",
                            data: o
                        }, "*");
                    }, 0);
                };
                var n = function(e) {
                    console.error(e);
                }, o = function(e) {
                    n("Whoops! You enabled the shareGaInstance feature in your typeform embed but ".concat(e, ".\n\n") + "Make sure to include Google Analytics Javascript code before the Typeform Embed Javascript code in your page and use correct tracker ID.\n\nIt is also possible the Google Analytics was blocked by your adblock plugin.");
                };
                t.setupGaInstance = function(e, r, i) {
                    var a = "string" == typeof i ? i : void 0;
                    if (window.gtag) {
                        if (a || (a = function() {
                            if (window.dataLayer) {
                                var e = window.dataLayer.find(function(e) {
                                    return e.length > 1 && "config" === e[0];
                                });
                                return e && e[1];
                            }
                        }()), !a) return void o("the tracking ID could not be retrieved");
                        var c = !1;
                        window.gtag("get", a, "client_id", function(n) {
                            c = !0, (0, t.sendGaIdMessage)(r, n, e);
                        }), setTimeout(function() {
                            c || o("the tracker with ID ".concat(a, " was not found"));
                        }, 3e3);
                    } else try {
                        var u = function(e, t) {
                            return t ? e.find(function(e) {
                                return e.get("trackingId") === t;
                            }) : e[0];
                        }(window.ga.getAll(), a);
                        u ? (0, t.sendGaIdMessage)(r, u.get("clientId"), e) : o("the tracker with ID ".concat(a, " was not found"));
                    } catch (e) {
                        o("the Google Analytics object was not found"), n(e);
                    }
                };
            },
            4623: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.sleep = void 0, t.sleep = function(e) {
                    return new Promise(function(t) {
                        return setTimeout(t, e);
                    });
                };
            },
            9832: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.triggerIconSvg = void 0, t.triggerIconSvg = function(e) {
                    return '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <path\n      fill-rule="evenodd"\n      clip-rule="evenodd"\n      d="M2.002 5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6.697l-5.748 3.832A1 1 0 0 1 6.002 22v-3h-2a2 2 0 0 1-2-2V5Zm18 0h-16v12h3a1 1 0 0 1 1 1v2.131l4.445-2.963a1 1 0 0 1 .555-.168h7V5Z"\n      fill='.concat(e, '\n    />\n    <path\n      fill-rule="evenodd"\n      clip-rule="evenodd"\n      d="M7.5 12.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Zm4.5 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Zm4.5 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Z"\n      fill=').concat(e, "\n    />\n  </svg>");
                };
            },
            1451: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.unmountElement = void 0, t.unmountElement = function(e) {
                    var t;
                    null === (t = e.parentNode) || void 0 === t || t.removeChild(e);
                };
            }
        }, t = {};
        return function n(o) {
            var r = t[o];
            if (void 0 !== r) return r.exports;
            var i = t[o] = {
                exports: {}
            };
            return e[o].call(i.exports, i, i.exports, n), i.exports;
        }(1920);
    }();
});




function $ec503a6bf0c8e53f$export$32cc5c3e0585c0b1() {
    return (0, $b65e8c04b9a293c5$export$4d093cbddae87bf2)({
        verb: 'file',
        formID: (0, $7de83232caba786b$export$4c4b23d7b53b8b73)
    });
}
function $ec503a6bf0c8e53f$var$useFake(formID) {
    const config = (0, $1068f99e90f736b6$export$b3611e87cd5ba6ce)();
    const tf_file = (0, $8608494418c9c764$export$15bc16b7d42c8de9)();
    return config.testMode ? {
        mutateAsync: async ()=>{
            const intent = await (0, $b65e8c04b9a293c5$export$81fad94074969359)({
                verb: 'file',
                formID: formID
            });
            await tf_file.mutateAsync({
                form: intent.tf_secret_v2.formID,
                response: '__sandbox'
            });
        },
        isPending: tf_file.isPending
    } : null;
}
function $ec503a6bf0c8e53f$export$225f820da0108706() {
    return $ec503a6bf0c8e53f$var$useFake((0, $7de83232caba786b$export$4c4b23d7b53b8b73));
}
function $ec503a6bf0c8e53f$export$841d8c15f45e3e6d() {
    return (0, $b65e8c04b9a293c5$export$4d093cbddae87bf2)({
        verb: 'file',
        formID: (0, $b052d1f0285c58fa$export$e4f044c2fd9cdd6a)
    });
}
function $ec503a6bf0c8e53f$export$4f79489c758bb0e9() {
    return (0, $b65e8c04b9a293c5$export$4d093cbddae87bf2)({
        verb: 'file',
        formID: (0, $b052d1f0285c58fa$export$293a15f1e074a8e8)
    });
}
function $ec503a6bf0c8e53f$export$314c869600309c12() {
    return $ec503a6bf0c8e53f$var$useFake((0, $b052d1f0285c58fa$export$e4f044c2fd9cdd6a));
}
function $ec503a6bf0c8e53f$export$3a8c53e4019c817d() {
    return $ec503a6bf0c8e53f$var$useFake((0, $b052d1f0285c58fa$export$293a15f1e074a8e8));
}
function $ec503a6bf0c8e53f$export$ed8869c34b2bb205({ mutation: mutation }) {
    const config = (0, $1068f99e90f736b6$export$b3611e87cd5ba6ce)();
    const tf_file = (0, $8608494418c9c764$export$15bc16b7d42c8de9)();
    async function showModal() {
        const tf = (await mutation.intent).tf_secret_v2;
        let resolveDone = undefined;
        const done = new Promise((resolve, reject)=>{
            resolveDone = resolve;
        });
        const popup = (0, $a5b6342546b0cfcd$exports.createPopup)(tf.formID, {
            hidden: tf.hidden,
            enableSandbox: config.testMode,
            onSubmit: (ev)=>tf_file.mutate({
                    form: tf.formID,
                    response: ev.responseId
                }, {
                    onSettled: ()=>resolveDone ? resolveDone(undefined) : undefined
                }),
            onEndingButtonClick: async (ev)=>{
                await done;
                popup.close();
            },
            onClose: ()=>{
                mutation.cancel();
            }
        });
        popup.open();
    }
    function close() {}
    (0, $acw62.useEffect)(()=>{
        if (mutation.isPending) showModal();
        else close();
    }, [
        mutation.isPending
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
}


function $61b15eaed752b5c6$var$_Intake() {
    const intake = (0, $ec503a6bf0c8e53f$export$32cc5c3e0585c0b1)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "To help you, we need to ask you some questions. Please give yourself 15 minutes to complete this form."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "The better we know you, the more efficient treatment we\u2019ll be able to provide."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$8b7b7cdfb85d78c5), {
                            mutation: intake,
                            vars: (data)=>{},
                            children: "Fill out the intake form"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec503a6bf0c8e53f$export$ed8869c34b2bb205), {
                mutation: intake
            })
        ]
    });
}
function $61b15eaed752b5c6$export$6d7fa08b65da91ad() {
    const done = (0, $8608494418c9c764$export$b55ed848e06e10f2)();
    const fakeIntake = (0, $ec503a6bf0c8e53f$export$225f820da0108706)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        "data-done": done ? true : undefined,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("hgroup", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        children: "Tell us about yourself"
                    }),
                    !done ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$857ebcebc4ae5918), {
                        className: "secondary",
                        mutation: fakeIntake,
                        children: "TEST: Skip"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                ]
            }),
            !done ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($61b15eaed752b5c6$var$_Intake, {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
        ]
    });
}




var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");


function $feae82f99096698e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $feae82f99096698e$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $feae82f99096698e$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $feae82f99096698e$var$_typeof(obj);
}
var $feae82f99096698e$var$RELEASE_TRAIN = 'clover';
var $feae82f99096698e$var$runtimeVersionToUrlVersion = function runtimeVersionToUrlVersion(version) {
    return version === 3 ? 'v3' : version;
};
var $feae82f99096698e$var$ORIGIN = 'https://js.stripe.com';
var $feae82f99096698e$var$STRIPE_JS_URL = "".concat($feae82f99096698e$var$ORIGIN, "/").concat($feae82f99096698e$var$RELEASE_TRAIN, "/stripe.js");
var $feae82f99096698e$var$V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var $feae82f99096698e$var$STRIPE_JS_URL_REGEX = /^https:\/\/js\.stripe\.com\/(v3|[a-z]+)\/stripe\.js(\?.*)?$/;
var $feae82f99096698e$var$EXISTING_SCRIPT_MESSAGE = 'loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used';
var $feae82f99096698e$var$isStripeJSURL = function isStripeJSURL(url) {
    return $feae82f99096698e$var$V3_URL_REGEX.test(url) || $feae82f99096698e$var$STRIPE_JS_URL_REGEX.test(url);
};
var $feae82f99096698e$var$findScript = function findScript() {
    var scripts = document.querySelectorAll("script[src^=\"".concat($feae82f99096698e$var$ORIGIN, "\"]"));
    for(var i = 0; i < scripts.length; i++){
        var script = scripts[i];
        if (!$feae82f99096698e$var$isStripeJSURL(script.src)) continue;
        return script;
    }
    return null;
};
var $feae82f99096698e$var$injectScript = function injectScript(params) {
    var queryString = params && !params.advancedFraudSignals ? '?advancedFraudSignals=false' : '';
    var script = document.createElement('script');
    script.src = "".concat($feae82f99096698e$var$STRIPE_JS_URL).concat(queryString);
    var headOrBody = document.head || document.body;
    if (!headOrBody) throw new Error('Expected document.body not to be null. Stripe.js requires a <body> element.');
    headOrBody.appendChild(script);
    return script;
};
var $feae82f99096698e$var$registerWrapper = function registerWrapper(stripe, startTime) {
    if (!stripe || !stripe._registerWrapper) return;
    stripe._registerWrapper({
        name: 'stripe-js',
        version: "8.7.0",
        startTime: startTime
    });
};
var $feae82f99096698e$var$stripePromise = null;
var $feae82f99096698e$var$onErrorListener = null;
var $feae82f99096698e$var$onLoadListener = null;
var $feae82f99096698e$var$onError = function onError(reject) {
    return function(cause) {
        reject(new Error('Failed to load Stripe.js', {
            cause: cause
        }));
    };
};
var $feae82f99096698e$var$onLoad = function onLoad(resolve, reject) {
    return function() {
        if (window.Stripe) resolve(window.Stripe);
        else reject(new Error('Stripe.js not available'));
    };
};
var $feae82f99096698e$var$loadScript = function loadScript(params) {
    // Ensure that we only attempt to load Stripe.js at most once
    if ($feae82f99096698e$var$stripePromise !== null) return $feae82f99096698e$var$stripePromise;
    $feae82f99096698e$var$stripePromise = new Promise(function(resolve, reject) {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            // Resolve to null when imported server side. This makes the module
            // safe to import in an isomorphic code base.
            resolve(null);
            return;
        }
        if (window.Stripe && params) console.warn($feae82f99096698e$var$EXISTING_SCRIPT_MESSAGE);
        if (window.Stripe) {
            resolve(window.Stripe);
            return;
        }
        try {
            var script = $feae82f99096698e$var$findScript();
            if (script && params) console.warn($feae82f99096698e$var$EXISTING_SCRIPT_MESSAGE);
            else if (!script) script = $feae82f99096698e$var$injectScript(params);
            else if (script && $feae82f99096698e$var$onLoadListener !== null && $feae82f99096698e$var$onErrorListener !== null) {
                var _script$parentNode;
                // remove event listeners
                script.removeEventListener('load', $feae82f99096698e$var$onLoadListener);
                script.removeEventListener('error', $feae82f99096698e$var$onErrorListener); // if script exists, but we are reloading due to an error,
                // reload script to trigger 'load' event
                (_script$parentNode = script.parentNode) === null || _script$parentNode === void 0 || _script$parentNode.removeChild(script);
                script = $feae82f99096698e$var$injectScript(params);
            }
            $feae82f99096698e$var$onLoadListener = $feae82f99096698e$var$onLoad(resolve, reject);
            $feae82f99096698e$var$onErrorListener = $feae82f99096698e$var$onError(reject);
            script.addEventListener('load', $feae82f99096698e$var$onLoadListener);
            script.addEventListener('error', $feae82f99096698e$var$onErrorListener);
        } catch (error) {
            reject(error);
            return;
        }
    }); // Resets stripePromise on error
    return $feae82f99096698e$var$stripePromise["catch"](function(error) {
        $feae82f99096698e$var$stripePromise = null;
        return Promise.reject(error);
    });
};
var $feae82f99096698e$var$initStripe = function initStripe(maybeStripe, args, startTime) {
    if (maybeStripe === null) return null;
    var pk = args[0];
    if (typeof pk !== 'string') throw new Error("Expected publishable key to be of type string, got type ".concat($feae82f99096698e$var$_typeof(pk), " instead."));
    var isTestKey = pk.match(/^pk_test/); // @ts-expect-error this is not publicly typed
    var version = $feae82f99096698e$var$runtimeVersionToUrlVersion(maybeStripe.version);
    var expectedVersion = $feae82f99096698e$var$RELEASE_TRAIN;
    if (isTestKey && version !== expectedVersion) console.warn("Stripe.js@".concat(version, " was loaded on the page, but @stripe/stripe-js@").concat("8.7.0", " expected Stripe.js@").concat(expectedVersion, ". This may result in unexpected behavior. For more information, see https://docs.stripe.com/sdks/stripejs-versioning"));
    var stripe = maybeStripe.apply(undefined, args);
    $feae82f99096698e$var$registerWrapper(stripe, startTime);
    return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var $feae82f99096698e$var$validateLoadParams = function validateLoadParams(params) {
    var errorMessage = "invalid load parameters; expected object of shape\n\n    {advancedFraudSignals: boolean}\n\nbut received\n\n    ".concat(JSON.stringify(params), "\n");
    if (params === null || $feae82f99096698e$var$_typeof(params) !== 'object') throw new Error(errorMessage);
    if (Object.keys(params).length === 1 && typeof params.advancedFraudSignals === 'boolean') return params;
    throw new Error(errorMessage);
};
var $feae82f99096698e$var$loadParams;
var $feae82f99096698e$var$loadStripeCalled = false;
var $feae82f99096698e$export$de80f7562c3fd6b1 = function loadStripe() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $feae82f99096698e$var$loadStripeCalled = true;
    var startTime = Date.now();
    return $feae82f99096698e$var$loadScript($feae82f99096698e$var$loadParams).then(function(maybeStripe) {
        return $feae82f99096698e$var$initStripe(maybeStripe, args, startTime);
    });
};
$feae82f99096698e$export$de80f7562c3fd6b1.setLoadParameters = function(params) {
    // we won't throw an error if setLoadParameters is called with the same values as before
    if ($feae82f99096698e$var$loadStripeCalled && $feae82f99096698e$var$loadParams) {
        var validatedParams = $feae82f99096698e$var$validateLoadParams(params);
        var parameterKeys = Object.keys(validatedParams);
        var sameParameters = parameterKeys.reduce(function(previousValue, currentValue) {
            var _loadParams;
            return previousValue && params[currentValue] === ((_loadParams = $feae82f99096698e$var$loadParams) === null || _loadParams === void 0 ? void 0 : _loadParams[currentValue]);
        }, true);
        if (sameParameters) return;
    }
    if ($feae82f99096698e$var$loadStripeCalled) throw new Error('You cannot change load parameters after calling loadStripe');
    $feae82f99096698e$var$loadParams = $feae82f99096698e$var$validateLoadParams(params);
};





var $acw62 = parcelRequire("acw62");
var $8da5bfbbed271cd7$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$8da5bfbbed271cd7$exports = (parcelRequire("hOzOt"))();


function $73a9e50d695997bb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $73a9e50d695997bb$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $73a9e50d695997bb$var$ownKeys(Object(source), true).forEach(function(key) {
            $73a9e50d695997bb$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $73a9e50d695997bb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $73a9e50d695997bb$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $73a9e50d695997bb$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $73a9e50d695997bb$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $73a9e50d695997bb$var$_typeof(obj);
}
function $73a9e50d695997bb$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $73a9e50d695997bb$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $73a9e50d695997bb$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $73a9e50d695997bb$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function $73a9e50d695997bb$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $73a9e50d695997bb$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $73a9e50d695997bb$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $73a9e50d695997bb$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $73a9e50d695997bb$var$_slicedToArray(arr, i) {
    return $73a9e50d695997bb$var$_arrayWithHoles(arr) || $73a9e50d695997bb$var$_iterableToArrayLimit(arr, i) || $73a9e50d695997bb$var$_unsupportedIterableToArray(arr, i) || $73a9e50d695997bb$var$_nonIterableRest();
}
function $73a9e50d695997bb$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $73a9e50d695997bb$var$_iterableToArrayLimit(arr, i) {
    var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $73a9e50d695997bb$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $73a9e50d695997bb$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $73a9e50d695997bb$var$_arrayLikeToArray(o, minLen);
}
function $73a9e50d695997bb$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $73a9e50d695997bb$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $73a9e50d695997bb$var$useAttachEvent = function useAttachEvent(element, event, cb) {
    var cbDefined = !!cb;
    var cbRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(cb); // In many integrations the callback prop changes on each render.
    // Using a ref saves us from calling element.on/.off every render.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        cbRef.current = cb;
    }, [
        cb
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        if (!cbDefined || !element) return function() {};
        var decoratedCb = function decoratedCb() {
            if (cbRef.current) cbRef.current.apply(cbRef, arguments);
        };
        element.on(event, decoratedCb);
        return function() {
            element.off(event, decoratedCb);
        };
    }, [
        cbDefined,
        event,
        element,
        cbRef
    ]);
};
var $73a9e50d695997bb$var$usePrevious = function usePrevious(value) {
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(value);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
var $73a9e50d695997bb$var$isUnknownObject = function isUnknownObject(raw) {
    return raw !== null && $73a9e50d695997bb$var$_typeof(raw) === 'object';
};
var $73a9e50d695997bb$var$isPromise = function isPromise(raw) {
    return $73a9e50d695997bb$var$isUnknownObject(raw) && typeof raw.then === 'function';
}; // We are using types to enforce the `stripe` prop in this lib,
// but in an untyped integration `stripe` could be anything, so we need
// to do some sanity validation to prevent type errors.
var $73a9e50d695997bb$var$isStripe = function isStripe(raw) {
    return $73a9e50d695997bb$var$isUnknownObject(raw) && typeof raw.elements === 'function' && typeof raw.createToken === 'function' && typeof raw.createPaymentMethod === 'function' && typeof raw.confirmCardPayment === 'function';
};
var $73a9e50d695997bb$var$PLAIN_OBJECT_STR = '[object Object]';
var $73a9e50d695997bb$var$isEqual = function isEqual(left, right) {
    if (!$73a9e50d695997bb$var$isUnknownObject(left) || !$73a9e50d695997bb$var$isUnknownObject(right)) return left === right;
    var leftArray = Array.isArray(left);
    var rightArray = Array.isArray(right);
    if (leftArray !== rightArray) return false;
    var leftPlainObject = Object.prototype.toString.call(left) === $73a9e50d695997bb$var$PLAIN_OBJECT_STR;
    var rightPlainObject = Object.prototype.toString.call(right) === $73a9e50d695997bb$var$PLAIN_OBJECT_STR;
    if (leftPlainObject !== rightPlainObject) return false; // not sure what sort of special object this is (regexp is one option), so
    // fallback to reference check.
    if (!leftPlainObject && !leftArray) return left === right;
    var leftKeys = Object.keys(left);
    var rightKeys = Object.keys(right);
    if (leftKeys.length !== rightKeys.length) return false;
    var keySet = {};
    for(var i = 0; i < leftKeys.length; i += 1)keySet[leftKeys[i]] = true;
    for(var _i = 0; _i < rightKeys.length; _i += 1)keySet[rightKeys[_i]] = true;
    var allKeys = Object.keys(keySet);
    if (allKeys.length !== leftKeys.length) return false;
    var l = left;
    var r = right;
    var pred = function pred(key) {
        return isEqual(l[key], r[key]);
    };
    return allKeys.every(pred);
};
var $73a9e50d695997bb$var$extractAllowedOptionsUpdates = function extractAllowedOptionsUpdates(options, prevOptions, immutableKeys) {
    if (!$73a9e50d695997bb$var$isUnknownObject(options)) return null;
    return Object.keys(options).reduce(function(newOptions, key) {
        var isUpdated = !$73a9e50d695997bb$var$isUnknownObject(prevOptions) || !$73a9e50d695997bb$var$isEqual(options[key], prevOptions[key]);
        if (immutableKeys.includes(key)) {
            if (isUpdated) console.warn("Unsupported prop change: options.".concat(key, " is not a mutable property."));
            return newOptions;
        }
        if (!isUpdated) return newOptions;
        return $73a9e50d695997bb$var$_objectSpread2($73a9e50d695997bb$var$_objectSpread2({}, newOptions || {}), {}, $73a9e50d695997bb$var$_defineProperty({}, key, options[key]));
    }, null);
};
var $73a9e50d695997bb$var$INVALID_STRIPE_ERROR$1 = 'Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.'; // We are using types to enforce the `stripe` prop in this lib, but in a real
// integration `stripe` could be anything, so we need to do some sanity
// validation to prevent type errors.
var $73a9e50d695997bb$var$validateStripe = function validateStripe(maybeStripe) {
    var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $73a9e50d695997bb$var$INVALID_STRIPE_ERROR$1;
    if (maybeStripe === null || $73a9e50d695997bb$var$isStripe(maybeStripe)) return maybeStripe;
    throw new Error(errorMsg);
};
var $73a9e50d695997bb$var$parseStripeProp = function parseStripeProp(raw) {
    var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $73a9e50d695997bb$var$INVALID_STRIPE_ERROR$1;
    if ($73a9e50d695997bb$var$isPromise(raw)) return {
        tag: 'async',
        stripePromise: Promise.resolve(raw).then(function(result) {
            return $73a9e50d695997bb$var$validateStripe(result, errorMsg);
        })
    };
    var stripe = $73a9e50d695997bb$var$validateStripe(raw, errorMsg);
    if (stripe === null) return {
        tag: 'empty'
    };
    return {
        tag: 'sync',
        stripe: stripe
    };
};
var $73a9e50d695997bb$var$registerWithStripeJs = function registerWithStripeJs(stripe) {
    if (!stripe || !stripe._registerWrapper || !stripe.registerAppInfo) return;
    stripe._registerWrapper({
        name: 'react-stripe-js',
        version: "5.6.0"
    });
    stripe.registerAppInfo({
        name: 'react-stripe-js',
        version: "5.6.0",
        url: 'https://stripe.com/docs/stripe-js/react'
    });
};
var $73a9e50d695997bb$var$ElementsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
$73a9e50d695997bb$var$ElementsContext.displayName = 'ElementsContext';
var $73a9e50d695997bb$var$parseElementsContext = function parseElementsContext(ctx, useCase) {
    if (!ctx) throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(useCase, " in an <Elements> provider."));
    return ctx;
};
/**
 * The `Elements` provider allows you to use [Element components](https://stripe.com/docs/stripe-js/react#element-components) and access the [Stripe object](https://stripe.com/docs/js/initializing) in any nested component.
 * Render an `Elements` provider at the root of your React app so that it is available everywhere you need it.
 *
 * To use the `Elements` provider, call `loadStripe` from `@stripe/stripe-js` with your publishable key.
 * The `loadStripe` function will asynchronously load the Stripe.js script and initialize a `Stripe` object.
 * Pass the returned `Promise` to `Elements`.
 *
 * @docs https://docs.stripe.com/sdks/stripejs-react?ui=elements#elements-provider
 */ var $73a9e50d695997bb$export$3abb4be70fa2c84e = function Elements(_ref) {
    var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
    var parsed = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        return $73a9e50d695997bb$var$parseStripeProp(rawStripeProp);
    }, [
        rawStripeProp
    ]); // For a sync stripe instance, initialize into context
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(function() {
        return {
            stripe: parsed.tag === 'sync' ? parsed.stripe : null,
            elements: parsed.tag === 'sync' ? parsed.stripe.elements(options) : null
        };
    }), _React$useState2 = $73a9e50d695997bb$var$_slicedToArray(_React$useState, 2), ctx = _React$useState2[0], setContext = _React$useState2[1];
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        var isMounted = true;
        var safeSetContext = function safeSetContext(stripe) {
            setContext(function(ctx) {
                // no-op if we already have a stripe instance (https://github.com/stripe/react-stripe-js/issues/296)
                if (ctx.stripe) return ctx;
                return {
                    stripe: stripe,
                    elements: stripe.elements(options)
                };
            });
        }; // For an async stripePromise, store it in context once resolved
        if (parsed.tag === 'async' && !ctx.stripe) parsed.stripePromise.then(function(stripe) {
            if (stripe && isMounted) // Only update Elements context if the component is still mounted
            // and stripe is not null. We allow stripe to be null to make
            // handling SSR easier.
            safeSetContext(stripe);
        });
        else if (parsed.tag === 'sync' && !ctx.stripe) // Or, handle a sync stripe instance going from null -> populated
        safeSetContext(parsed.stripe);
        return function() {
            isMounted = false;
        };
    }, [
        parsed,
        ctx,
        options
    ]); // Warn on changes to stripe prop
    var prevStripe = $73a9e50d695997bb$var$usePrevious(rawStripeProp);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.');
    }, [
        prevStripe,
        rawStripeProp
    ]); // Apply updates to elements when options prop has relevant changes
    var prevOptions = $73a9e50d695997bb$var$usePrevious(options);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        if (!ctx.elements) return;
        var updates = $73a9e50d695997bb$var$extractAllowedOptionsUpdates(options, prevOptions, [
            'clientSecret',
            'fonts'
        ]);
        if (updates) ctx.elements.update(updates);
    }, [
        options,
        prevOptions,
        ctx.elements
    ]); // Attach react-stripe-js version to stripe.js instance
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        $73a9e50d695997bb$var$registerWithStripeJs(ctx.stripe);
    }, [
        ctx.stripe
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($73a9e50d695997bb$var$ElementsContext.Provider, {
        value: ctx
    }, children);
};
$73a9e50d695997bb$export$3abb4be70fa2c84e.propTypes = {
    stripe: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).any,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
};
var $73a9e50d695997bb$var$useElementsContextWithUseCase = function useElementsContextWithUseCase(useCaseMessage) {
    var ctx = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($73a9e50d695997bb$var$ElementsContext);
    return $73a9e50d695997bb$var$parseElementsContext(ctx, useCaseMessage);
};
/**
 * @docs https://stripe.com/docs/stripe-js/react#useelements-hook
 */ var $73a9e50d695997bb$export$83d5c6859f2ae3df = function useElements() {
    var _useElementsContextWi = $73a9e50d695997bb$var$useElementsContextWithUseCase('calls useElements()'), elements = _useElementsContextWi.elements;
    return elements;
};
/**
 * @docs https://stripe.com/docs/stripe-js/react#elements-consumer
 */ var $73a9e50d695997bb$export$785fd7b02914946b = function ElementsConsumer(_ref2) {
    var children = _ref2.children;
    var ctx = $73a9e50d695997bb$var$useElementsContextWithUseCase('mounts <ElementsConsumer>'); // Assert to satisfy the busted React.FC return type (it should be ReactNode)
    return children(ctx);
};
$73a9e50d695997bb$export$785fd7b02914946b.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func.isRequired
};
var $73a9e50d695997bb$var$CheckoutContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
$73a9e50d695997bb$var$CheckoutContext.displayName = 'CheckoutContext';
(0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).any, (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
    clientSecret: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).instanceOf(Promise)
    ]).isRequired,
    elementsOptions: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
}).isRequired;
var $73a9e50d695997bb$var$useElementsOrCheckoutContextWithUseCase = function useElementsOrCheckoutContextWithUseCase(useCaseString) {
    var checkout = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($73a9e50d695997bb$var$CheckoutContext);
    var elements = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($73a9e50d695997bb$var$ElementsContext);
    if (checkout) {
        if (elements) throw new Error("You cannot wrap the part of your app that ".concat(useCaseString, " in both <CheckoutProvider> and <Elements> providers."));
        else return checkout;
    } else return $73a9e50d695997bb$var$parseElementsContext(elements, useCaseString);
};
var $73a9e50d695997bb$var$_excluded = [
    "mode"
];
var $73a9e50d695997bb$var$capitalized = function capitalized(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var $73a9e50d695997bb$var$createElementComponent = function createElementComponent(type, isServer) {
    var displayName = "".concat($73a9e50d695997bb$var$capitalized(type), "Element");
    var ClientElement = function ClientElement(_ref) {
        var id = _ref.id, className = _ref.className, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, onBlur = _ref.onBlur, onFocus = _ref.onFocus, onReady = _ref.onReady, onChange = _ref.onChange, onEscape = _ref.onEscape, onClick = _ref.onClick, onLoadError = _ref.onLoadError, onLoaderStart = _ref.onLoaderStart, onNetworksChange = _ref.onNetworksChange, onConfirm = _ref.onConfirm, onCancel = _ref.onCancel, onShippingAddressChange = _ref.onShippingAddressChange, onShippingRateChange = _ref.onShippingRateChange, onSavedPaymentMethodRemove = _ref.onSavedPaymentMethodRemove, onSavedPaymentMethodUpdate = _ref.onSavedPaymentMethodUpdate;
        var ctx = $73a9e50d695997bb$var$useElementsOrCheckoutContextWithUseCase("mounts <".concat(displayName, ">"));
        var elements = 'elements' in ctx ? ctx.elements : null;
        var checkoutState = 'checkoutState' in ctx ? ctx.checkoutState : null;
        var checkoutSdk = (checkoutState === null || checkoutState === void 0 ? void 0 : checkoutState.type) === 'success' || (checkoutState === null || checkoutState === void 0 ? void 0 : checkoutState.type) === 'loading' ? checkoutState.sdk : null;
        var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null), _React$useState2 = $73a9e50d695997bb$var$_slicedToArray(_React$useState, 2), element = _React$useState2[0], setElement = _React$useState2[1];
        var elementRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
        var domNode = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null); // For every event where the merchant provides a callback, call element.on
        // with that callback. If the merchant ever changes the callback, removes
        // the old callback with element.off and then call element.on with the new one.
        $73a9e50d695997bb$var$useAttachEvent(element, 'blur', onBlur);
        $73a9e50d695997bb$var$useAttachEvent(element, 'focus', onFocus);
        $73a9e50d695997bb$var$useAttachEvent(element, 'escape', onEscape);
        $73a9e50d695997bb$var$useAttachEvent(element, 'click', onClick);
        $73a9e50d695997bb$var$useAttachEvent(element, 'loaderror', onLoadError);
        $73a9e50d695997bb$var$useAttachEvent(element, 'loaderstart', onLoaderStart);
        $73a9e50d695997bb$var$useAttachEvent(element, 'networkschange', onNetworksChange);
        $73a9e50d695997bb$var$useAttachEvent(element, 'confirm', onConfirm);
        $73a9e50d695997bb$var$useAttachEvent(element, 'cancel', onCancel);
        $73a9e50d695997bb$var$useAttachEvent(element, 'shippingaddresschange', onShippingAddressChange);
        $73a9e50d695997bb$var$useAttachEvent(element, 'shippingratechange', onShippingRateChange);
        $73a9e50d695997bb$var$useAttachEvent(element, 'savedpaymentmethodremove', onSavedPaymentMethodRemove);
        $73a9e50d695997bb$var$useAttachEvent(element, 'savedpaymentmethodupdate', onSavedPaymentMethodUpdate);
        $73a9e50d695997bb$var$useAttachEvent(element, 'change', onChange);
        var readyCallback;
        if (onReady) {
            if (type === 'expressCheckout') // Passes through the event, which includes visible PM types
            readyCallback = onReady;
            else // For other Elements, pass through the Element itself.
            readyCallback = function readyCallback() {
                onReady(element);
            };
        }
        $73a9e50d695997bb$var$useAttachEvent(element, 'ready', readyCallback);
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(function() {
            if (elementRef.current === null && domNode.current !== null && (elements || checkoutSdk)) {
                var newElement = null;
                if (checkoutSdk) switch(type){
                    case 'paymentForm':
                        newElement = checkoutSdk.createPaymentFormElement(options);
                        break;
                    case 'payment':
                        newElement = checkoutSdk.createPaymentElement(options);
                        break;
                    case 'address':
                        if ('mode' in options) {
                            var mode = options.mode, restOptions = $73a9e50d695997bb$var$_objectWithoutProperties(options, $73a9e50d695997bb$var$_excluded);
                            if (mode === 'shipping') newElement = checkoutSdk.createShippingAddressElement(restOptions);
                            else if (mode === 'billing') newElement = checkoutSdk.createBillingAddressElement(restOptions);
                            else throw new Error("Invalid options.mode. mode must be 'billing' or 'shipping'.");
                        } else throw new Error("You must supply options.mode. mode must be 'billing' or 'shipping'.");
                        break;
                    case 'expressCheckout':
                        newElement = checkoutSdk.createExpressCheckoutElement(options);
                        break;
                    case 'currencySelector':
                        newElement = checkoutSdk.createCurrencySelectorElement();
                        break;
                    case 'taxId':
                        newElement = checkoutSdk.createTaxIdElement(options);
                        break;
                    default:
                        throw new Error("Invalid Element type ".concat(displayName, ". You must use either the <PaymentElement />, <AddressElement options={{mode: 'shipping'}} />, <AddressElement options={{mode: 'billing'}} />, or <ExpressCheckoutElement />."));
                }
                else if (elements) newElement = elements.create(type, options);
                 // Store element in a ref to ensure it's _immediately_ available in cleanup hooks in StrictMode
                elementRef.current = newElement; // Store element in state to facilitate event listener attachment
                setElement(newElement);
                if (newElement) newElement.mount(domNode.current);
            }
        }, [
            elements,
            checkoutSdk,
            options
        ]);
        var prevOptions = $73a9e50d695997bb$var$usePrevious(options);
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
            if (!elementRef.current) return;
            var updates = $73a9e50d695997bb$var$extractAllowedOptionsUpdates(options, prevOptions, [
                'paymentRequest'
            ]);
            if (updates && 'update' in elementRef.current) elementRef.current.update(updates);
        }, [
            options,
            prevOptions
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(function() {
            return function() {
                if (elementRef.current && typeof elementRef.current.destroy === 'function') try {
                    elementRef.current.destroy();
                    elementRef.current = null;
                } catch (error) {}
            };
        }, []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            id: id,
            className: className,
            ref: domNode
        });
    }; // Only render the Element wrapper in a server environment.
    var ServerElement = function ServerElement(props) {
        $73a9e50d695997bb$var$useElementsOrCheckoutContextWithUseCase("mounts <".concat(displayName, ">"));
        var id = props.id, className = props.className;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            id: id,
            className: className
        });
    };
    var Element = isServer ? ServerElement : ClientElement;
    Element.propTypes = {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        onChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        onReady: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        onEscape: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        onLoadError: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        onLoaderStart: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        onNetworksChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        onConfirm: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        onShippingAddressChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        onShippingRateChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        onSavedPaymentMethodRemove: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        onSavedPaymentMethodUpdate: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        options: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
    };
    Element.displayName = displayName;
    Element.__elementType = type;
    return Element;
};
var $73a9e50d695997bb$var$isServer = typeof window === 'undefined';
var $73a9e50d695997bb$var$EmbeddedCheckoutContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
$73a9e50d695997bb$var$EmbeddedCheckoutContext.displayName = 'EmbeddedCheckoutProviderContext';
var $73a9e50d695997bb$var$useEmbeddedCheckoutContext = function useEmbeddedCheckoutContext() {
    var ctx = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($73a9e50d695997bb$var$EmbeddedCheckoutContext);
    if (!ctx) throw new Error('<EmbeddedCheckout> must be used within <EmbeddedCheckoutProvider>');
    return ctx;
};
var $73a9e50d695997bb$var$INVALID_STRIPE_ERROR = 'Invalid prop `stripe` supplied to `EmbeddedCheckoutProvider`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.';
var $73a9e50d695997bb$export$10af8eb72fe0ac61 = function EmbeddedCheckoutProvider(_ref) {
    var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
    var parsed = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        return $73a9e50d695997bb$var$parseStripeProp(rawStripeProp, $73a9e50d695997bb$var$INVALID_STRIPE_ERROR);
    }, [
        rawStripeProp
    ]);
    var embeddedCheckoutPromise = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    var loadedStripe = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        embeddedCheckout: null
    }), _React$useState2 = $73a9e50d695997bb$var$_slicedToArray(_React$useState, 2), ctx = _React$useState2[0], setContext = _React$useState2[1];
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        // Don't support any ctx updates once embeddedCheckout or stripe is set.
        if (loadedStripe.current || embeddedCheckoutPromise.current) return;
        var setStripeAndInitEmbeddedCheckout = function setStripeAndInitEmbeddedCheckout(stripe) {
            if (loadedStripe.current || embeddedCheckoutPromise.current) return;
            loadedStripe.current = stripe;
            embeddedCheckoutPromise.current = loadedStripe.current.initEmbeddedCheckout(options).then(function(embeddedCheckout) {
                setContext({
                    embeddedCheckout: embeddedCheckout
                });
            });
        }; // For an async stripePromise, store it once resolved
        if (parsed.tag === 'async' && !loadedStripe.current && (options.clientSecret || options.fetchClientSecret)) parsed.stripePromise.then(function(stripe) {
            if (stripe) setStripeAndInitEmbeddedCheckout(stripe);
        });
        else if (parsed.tag === 'sync' && !loadedStripe.current && (options.clientSecret || options.fetchClientSecret)) // Or, handle a sync stripe instance going from null -> populated
        setStripeAndInitEmbeddedCheckout(parsed.stripe);
    }, [
        parsed,
        options,
        ctx,
        loadedStripe
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        // cleanup on unmount
        return function() {
            // If embedded checkout is fully initialized, destroy it.
            if (ctx.embeddedCheckout) {
                embeddedCheckoutPromise.current = null;
                ctx.embeddedCheckout.destroy();
            } else if (embeddedCheckoutPromise.current) // If embedded checkout is still initializing, destroy it once
            // it's done. This could be caused by unmounting very quickly
            // after mounting.
            embeddedCheckoutPromise.current.then(function() {
                embeddedCheckoutPromise.current = null;
                if (ctx.embeddedCheckout) ctx.embeddedCheckout.destroy();
            });
        };
    }, [
        ctx.embeddedCheckout
    ]); // Attach react-stripe-js version to stripe.js instance
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        $73a9e50d695997bb$var$registerWithStripeJs(loadedStripe);
    }, [
        loadedStripe
    ]); // Warn on changes to stripe prop.
    // The stripe prop value can only go from null to non-null once and
    // can't be changed after that.
    var prevStripe = $73a9e50d695997bb$var$usePrevious(rawStripeProp);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the `stripe` prop after setting it.');
    }, [
        prevStripe,
        rawStripeProp
    ]); // Warn on changes to options.
    var prevOptions = $73a9e50d695997bb$var$usePrevious(options);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        if (prevOptions == null) return;
        if (options == null) {
            console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot unset options after setting them.');
            return;
        }
        if (options.clientSecret === undefined && options.fetchClientSecret === undefined) console.warn('Invalid props passed to EmbeddedCheckoutProvider: You must provide one of either `options.fetchClientSecret` or `options.clientSecret`.');
        if (prevOptions.clientSecret != null && options.clientSecret !== prevOptions.clientSecret) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the client secret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead.');
        if (prevOptions.fetchClientSecret != null && options.fetchClientSecret !== prevOptions.fetchClientSecret) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change fetchClientSecret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead.');
        if (prevOptions.onComplete != null && options.onComplete !== prevOptions.onComplete) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onComplete option after setting it.');
        if (prevOptions.onShippingDetailsChange != null && options.onShippingDetailsChange !== prevOptions.onShippingDetailsChange) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onShippingDetailsChange option after setting it.');
        if (prevOptions.onLineItemsChange != null && options.onLineItemsChange !== prevOptions.onLineItemsChange) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onLineItemsChange option after setting it.');
    }, [
        prevOptions,
        options
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($73a9e50d695997bb$var$EmbeddedCheckoutContext.Provider, {
        value: ctx
    }, children);
};
var $73a9e50d695997bb$var$EmbeddedCheckoutClientElement = function EmbeddedCheckoutClientElement(_ref) {
    var id = _ref.id, className = _ref.className;
    var _useEmbeddedCheckoutC = $73a9e50d695997bb$var$useEmbeddedCheckoutContext(), embeddedCheckout = _useEmbeddedCheckoutC.embeddedCheckout;
    var isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    var domNode = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(function() {
        if (!isMounted.current && embeddedCheckout && domNode.current !== null) {
            embeddedCheckout.mount(domNode.current);
            isMounted.current = true;
        } // Clean up on unmount
        return function() {
            if (isMounted.current && embeddedCheckout) try {
                embeddedCheckout.unmount();
                isMounted.current = false;
            } catch (e) {
            // Parent effects are destroyed before child effects, so
            // in cases where both the EmbeddedCheckoutProvider and
            // the EmbeddedCheckout component are removed at the same
            // time, the embeddedCheckout instance will be destroyed,
            // which causes an error when calling unmount.
            }
        };
    }, [
        embeddedCheckout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: domNode,
        id: id,
        className: className
    });
}; // Only render the wrapper in a server environment.
var $73a9e50d695997bb$var$EmbeddedCheckoutServerElement = function EmbeddedCheckoutServerElement(_ref2) {
    var id = _ref2.id, className = _ref2.className;
    // Validate that we are in the right context by calling useEmbeddedCheckoutContext.
    $73a9e50d695997bb$var$useEmbeddedCheckoutContext();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: id,
        className: className
    });
};
var $73a9e50d695997bb$export$93e2cdf6005e8689 = $73a9e50d695997bb$var$isServer ? $73a9e50d695997bb$var$EmbeddedCheckoutServerElement : $73a9e50d695997bb$var$EmbeddedCheckoutClientElement;
var $73a9e50d695997bb$export$1c7ab45938af06d4 = function FinancialAccountDisclosure(_ref) {
    var rawStripeProp = _ref.stripe, onLoad = _ref.onLoad, onError = _ref.onError, options = _ref.options;
    var businessName = options === null || options === void 0 ? void 0 : options.businessName;
    var learnMoreLink = options === null || options === void 0 ? void 0 : options.learnMoreLink;
    var containerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    var parsed = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        return $73a9e50d695997bb$var$parseStripeProp(rawStripeProp);
    }, [
        rawStripeProp
    ]);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(parsed.tag === 'sync' ? parsed.stripe : null), _React$useState2 = $73a9e50d695997bb$var$_slicedToArray(_React$useState, 2), stripeState = _React$useState2[0], setStripeState = _React$useState2[1];
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        var isMounted = true;
        if (parsed.tag === 'async') parsed.stripePromise.then(function(stripePromise) {
            if (stripePromise && isMounted) setStripeState(stripePromise);
        });
        else if (parsed.tag === 'sync') setStripeState(parsed.stripe);
        return function() {
            isMounted = false;
        };
    }, [
        parsed
    ]); // Warn on changes to stripe prop
    var prevStripe = $73a9e50d695997bb$var$usePrevious(rawStripeProp);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on FinancialAccountDisclosure: You cannot change the `stripe` prop after setting it.');
    }, [
        prevStripe,
        rawStripeProp
    ]); // Attach react-stripe-js version to stripe.js instance
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        $73a9e50d695997bb$var$registerWithStripeJs(stripeState);
    }, [
        stripeState
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        var createDisclosure = /*#__PURE__*/ function() {
            var _ref2 = $73a9e50d695997bb$var$_asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee() {
                var _yield$stripeState$cr, disclosureContent, error, container;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!(!stripeState || !containerRef.current)) {
                                _context.next = 2;
                                break;
                            }
                            return _context.abrupt("return");
                        case 2:
                            _context.next = 4;
                            return stripeState.createFinancialAccountDisclosure({
                                businessName: businessName,
                                learnMoreLink: learnMoreLink
                            });
                        case 4:
                            _yield$stripeState$cr = _context.sent;
                            disclosureContent = _yield$stripeState$cr.htmlElement;
                            error = _yield$stripeState$cr.error;
                            if (error && onError) onError(error);
                            else if (disclosureContent) {
                                container = containerRef.current;
                                container.innerHTML = '';
                                container.appendChild(disclosureContent);
                                if (onLoad) onLoad();
                            }
                        case 8:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function createDisclosure() {
                return _ref2.apply(this, arguments);
            };
        }();
        createDisclosure();
    }, [
        stripeState,
        businessName,
        learnMoreLink,
        onLoad,
        onError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('div', {
        ref: containerRef
    });
};
var $73a9e50d695997bb$export$f10043fb34bc3d96 = function IssuingDisclosure(_ref) {
    var rawStripeProp = _ref.stripe, onLoad = _ref.onLoad, onError = _ref.onError, options = _ref.options;
    var issuingProgramID = options === null || options === void 0 ? void 0 : options.issuingProgramID;
    var publicCardProgramName = options === null || options === void 0 ? void 0 : options.publicCardProgramName;
    var learnMoreLink = options === null || options === void 0 ? void 0 : options.learnMoreLink;
    var containerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    var parsed = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        return $73a9e50d695997bb$var$parseStripeProp(rawStripeProp);
    }, [
        rawStripeProp
    ]);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(parsed.tag === 'sync' ? parsed.stripe : null), _React$useState2 = $73a9e50d695997bb$var$_slicedToArray(_React$useState, 2), stripeState = _React$useState2[0], setStripeState = _React$useState2[1];
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        var isMounted = true;
        if (parsed.tag === 'async') parsed.stripePromise.then(function(stripePromise) {
            if (stripePromise && isMounted) setStripeState(stripePromise);
        });
        else if (parsed.tag === 'sync') setStripeState(parsed.stripe);
        return function() {
            isMounted = false;
        };
    }, [
        parsed
    ]); // Warn on changes to stripe prop
    var prevStripe = $73a9e50d695997bb$var$usePrevious(rawStripeProp);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on IssuingDisclosure: You cannot change the `stripe` prop after setting it.');
    }, [
        prevStripe,
        rawStripeProp
    ]); // Attach react-stripe-js version to stripe.js instance
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        $73a9e50d695997bb$var$registerWithStripeJs(stripeState);
    }, [
        stripeState
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        var createDisclosure = /*#__PURE__*/ function() {
            var _ref2 = $73a9e50d695997bb$var$_asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee() {
                var _yield$stripeState$cr, disclosureContent, error, container;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!(!stripeState || !containerRef.current)) {
                                _context.next = 2;
                                break;
                            }
                            return _context.abrupt("return");
                        case 2:
                            _context.next = 4;
                            return stripeState.createIssuingDisclosure({
                                issuingProgramID: issuingProgramID,
                                publicCardProgramName: publicCardProgramName,
                                learnMoreLink: learnMoreLink
                            });
                        case 4:
                            _yield$stripeState$cr = _context.sent;
                            disclosureContent = _yield$stripeState$cr.htmlElement;
                            error = _yield$stripeState$cr.error;
                            if (error && onError) onError(error);
                            else if (disclosureContent) {
                                container = containerRef.current;
                                container.innerHTML = '';
                                container.appendChild(disclosureContent);
                                if (onLoad) onLoad();
                            }
                        case 8:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function createDisclosure() {
                return _ref2.apply(this, arguments);
            };
        }();
        createDisclosure();
    }, [
        stripeState,
        issuingProgramID,
        publicCardProgramName,
        learnMoreLink,
        onLoad,
        onError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('div', {
        ref: containerRef
    });
};
/**
 * @docs https://stripe.com/docs/stripe-js/react#usestripe-hook
 */ var $73a9e50d695997bb$export$cef05aaebd2acb04 = function useStripe() {
    var _useElementsOrCheckou = $73a9e50d695997bb$var$useElementsOrCheckoutContextWithUseCase('calls useStripe()'), stripe = _useElementsOrCheckou.stripe;
    return stripe;
};
/**
 * Requires beta access:
 * Contact [Stripe support](https://support.stripe.com/) for more information.
 *
 * @docs https://stripe.com/docs/stripe-js/react#element-components
 */ var $73a9e50d695997bb$export$ed0404944aa0a0be = $73a9e50d695997bb$var$createElementComponent('auBankAccount', $73a9e50d695997bb$var$isServer);
/**
 * @docs https://stripe.com/docs/stripe-js/react#element-components
 */ var $73a9e50d695997bb$export$642653cabb64aed9 = $73a9e50d695997bb$var$createElementComponent('card', $73a9e50d695997bb$var$isServer);
/**
 * @docs https://stripe.com/docs/stripe-js/react#element-components
 */ var $73a9e50d695997bb$export$a2311b18160d2f3f = $73a9e50d695997bb$var$createElementComponent('cardNumber', $73a9e50d695997bb$var$isServer);
/**
 * @docs https://stripe.com/docs/stripe-js/react#element-components
 */ var $73a9e50d695997bb$export$3a2a66ad1738a165 = $73a9e50d695997bb$var$createElementComponent('cardExpiry', $73a9e50d695997bb$var$isServer);
/**
 * @docs https://stripe.com/docs/stripe-js/react#element-components
 */ var $73a9e50d695997bb$export$4b93a2b03641f711 = $73a9e50d695997bb$var$createElementComponent('cardCvc', $73a9e50d695997bb$var$isServer);
/**
 * @docs https://stripe.com/docs/stripe-js/react#element-components
 */ var $73a9e50d695997bb$export$52fa2d0f5cb711db = $73a9e50d695997bb$var$createElementComponent('iban', $73a9e50d695997bb$var$isServer);
var $73a9e50d695997bb$export$eedb0774fec67577 = $73a9e50d695997bb$var$createElementComponent('payment', $73a9e50d695997bb$var$isServer);
/**
 * @docs https://stripe.com/docs/stripe-js/react#element-components
 */ var $73a9e50d695997bb$export$2ec2b5014d212262 = $73a9e50d695997bb$var$createElementComponent('expressCheckout', $73a9e50d695997bb$var$isServer);
/**
 * @docs https://stripe.com/docs/stripe-js/react#element-components
 */ var $73a9e50d695997bb$export$512724b08d5d9db9 = $73a9e50d695997bb$var$createElementComponent('paymentRequestButton', $73a9e50d695997bb$var$isServer);
/**
 * @docs https://stripe.com/docs/stripe-js/react#element-components
 */ var $73a9e50d695997bb$export$ca1eb6baad29454b = $73a9e50d695997bb$var$createElementComponent('linkAuthentication', $73a9e50d695997bb$var$isServer);
/**
 * @docs https://stripe.com/docs/stripe-js/react#element-components
 */ var $73a9e50d695997bb$export$282d92e1eac0c29f = $73a9e50d695997bb$var$createElementComponent('address', $73a9e50d695997bb$var$isServer);
/**
 * @deprecated
 * Use `AddressElement` instead.
 *
 * @docs https://stripe.com/docs/stripe-js/react#element-components
 */ var $73a9e50d695997bb$export$2d5a3a9ddde0bb0e = $73a9e50d695997bb$var$createElementComponent('shippingAddress', $73a9e50d695997bb$var$isServer);
/**
 * @docs https://stripe.com/docs/stripe-js/react#element-components
 */ var $73a9e50d695997bb$export$aacf365dfd59d15a = $73a9e50d695997bb$var$createElementComponent('paymentMethodMessaging', $73a9e50d695997bb$var$isServer);
/**
 * Requires beta access:
 * Contact [Stripe support](https://support.stripe.com/) for more information.
 */ var $73a9e50d695997bb$export$36353afd9c10e87a = $73a9e50d695997bb$var$createElementComponent('taxId', $73a9e50d695997bb$var$isServer);



var $acw62 = parcelRequire("acw62");


function $84b8faab069143e8$var$useColorScheme() {
    const darkPreferred = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');
    const [colorScheme, setColorScheme] = (0, $acw62.useState)(darkPreferred.matches ? 'dark' : 'light');
    (0, $acw62.useEffect)(()=>{
        darkPreferred.addEventListener('change', (ev)=>{
            setColorScheme(ev.matches ? "dark" : "light");
        });
    }, []);
    return colorScheme;
}
function $84b8faab069143e8$var$useThemeColors() {
    $84b8faab069143e8$var$useColorScheme() // ensure we re-render on every theme switch
    ;
    const style = getComputedStyle(document.body);
    return {
        primary: style.getPropertyValue('--md-sys-color-primary'),
        onSurface: style.getPropertyValue('--md-sys-color-on-surface'),
        onSurfaceVariant: style.getPropertyValue('--md-sys-color-on-surface-variant'),
        outline: style.getPropertyValue('--md-sys-color-outline'),
        outlineVariant: style.getPropertyValue('--md-sys-color-outline-variant'),
        surfaceContainerLowest: style.getPropertyValue('--md-sys-color-surface-container-lowest'),
        surfaceContainerLow: style.getPropertyValue('--md-sys-color-surface-container-low'),
        surfaceContainer: style.getPropertyValue('--md-sys-color-surface-container'),
        surfaceContainerHigh: style.getPropertyValue('--md-sys-color-surface-container-high'),
        surfaceContainerHighest: style.getPropertyValue('--md-sys-color-surface-container-highest')
    };
}
let $84b8faab069143e8$var$stripePromiseByKey = new Map();
function $84b8faab069143e8$export$54422dabec1fc6e8({ intent: intentPromise, children: children }) {
    const intent = (0, $acw62.use)(intentPromise);
    const colors = $84b8faab069143e8$var$useThemeColors();
    const config = (0, $1068f99e90f736b6$export$b3611e87cd5ba6ce)();
    const key = intent?.stripe_secret.publishableKey ?? config.stripePublishableKey;
    if (!$84b8faab069143e8$var$stripePromiseByKey.get(key)) $84b8faab069143e8$var$stripePromiseByKey.set(key, (0, $feae82f99096698e$export$de80f7562c3fd6b1)(key));
    const stripePromise = $84b8faab069143e8$var$stripePromiseByKey.get(key);
    return !intent ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $73a9e50d695997bb$export$3abb4be70fa2c84e), {
        stripe: stripePromise,
        options: {
            clientSecret: intent.stripe_secret.clientSecret,
            customerSessionClientSecret: intent.stripe_secret.customerSessionClientSecret,
            appearance: {
                theme: "flat",
                variables: {
                    colorPrimary: colors.primary,
                    colorText: colors.onSurface,
                    borderRadius: '4px',
                    focusBoxShadow: 'none',
                    accordionItemSpacing: '0'
                },
                rules: {
                    '.AccordionItem': {
                        backgroundColor: 'transparent',
                        paddingLeft: '16px',
                        paddingRight: '16px',
                        border: '0px solid transparent'
                    },
                    '.Input': {
                        backgroundColor: colors.surfaceContainerHigh,
                        borderRadius: '0',
                        border: '0',
                        borderBottom: `1px solid ${colors.onSurfaceVariant}`,
                        marginBottom: '1px',
                        transition: 'none'
                    },
                    '.Input:focus': {
                        borderBottom: `2px solid ${colors.primary}`,
                        marginBottom: '0px',
                        transition: 'none'
                    },
                    '.CheckboxInput': {
                        backgroundColor: 'transparent',
                        border: `2px solid ${colors.onSurfaceVariant}`,
                        borderRadius: '2px'
                    },
                    '.CheckboxInput--checked': {
                        border: `2px solid ${colors.primary}`
                    },
                    '.Block': {
                        backgroundColor: 'transparent',
                        boxShadow: 'none'
                    },
                    '.BlockDivider': {
                        backgroundColor: 'transparent'
                    },
                    '.RedirectText': {
                        borderTop: '0.75rem solid transparent'
                    },
                    '.PickerItem--selected, .PickerItem--selected:focus, .PickerItem--selected:hover': {
                        backgroundColor: 'transparent',
                        border: `1px solid ${colors.outlineVariant}`,
                        boxShadow: 'none'
                    },
                    '.PickerItem--highlight, .PickerItem--highlight:focus, .PickerItem--highlight:hover': {
                        backgroundColor: 'transparent',
                        border: `1px solid ${colors.primary}`,
                        boxShadow: `0 0 4px ${colors.primary}`
                    },
                    '.PickerItem, .PickerItem:hover, .PickerItem:focus': {
                        backgroundColor: 'transparent',
                        border: `1px solid ${colors.outline}`,
                        boxShadow: 'none'
                    }
                }
            }
        },
        children: children
    });
}
function $84b8faab069143e8$export$f2e0a34fc44faced() {
    const div = (0, $acw62.useRef)(null);
    (0, $acw62.useLayoutEffect)(()=>{
        const pse = div.current.getElementsByClassName('__PrivateStripeElement')[0];
        const iframe = div.current.getElementsByTagName('iframe')[0];
        if (!pse || !iframe) return;
        function pseOverride() {
            pse.style.height = '';
        }
        pseOverride();
        const pseObserver = new MutationObserver(pseOverride);
        pseObserver.observe(pse, {
            attributes: true,
            attributeFilter: [
                'style'
            ]
        });
        function iframeOverride() {
            iframe.style.transition = 'height 0.2s';
            // At the beginning, iframe has 2px height. No idea why, but this breaks transitions.
            if (iframe.style.height === '2px') iframe.style.height = '313px';
        }
        iframeOverride();
        const iframeObserver = new MutationObserver(iframeOverride);
        iframeObserver.observe(iframe, {
            attributes: true,
            attributeFilter: [
                'style'
            ]
        });
        return ()=>{
            pseObserver.disconnect();
            iframeObserver.disconnect();
        };
    }, [
        (0, $73a9e50d695997bb$export$83d5c6859f2ae3df)()
    ]) // the iframe will be there <=> elements !== null
    ;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: div,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $73a9e50d695997bb$export$eedb0774fec67577), {
            options: {
                layout: {
                    type: 'accordion'
                }
            }
        })
    });
}
function $84b8faab069143e8$export$430e143f7f0ee720() {
    const stripe = (0, $73a9e50d695997bb$export$cef05aaebd2acb04)() ?? undefined;
    const finalizeStripe = (0, $196d349a3b911925$export$e4ed0cee43b6a619)();
    const elements = (0, $73a9e50d695997bb$export$83d5c6859f2ae3df)() ?? undefined;
    const confirm = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: async ()=>{
            const result = await stripe.confirmPayment({
                elements: elements,
                confirmParams: {
                    return_url: location.href
                },
                redirect: 'if_required'
            });
            if (result.error) throw new (0, $196d349a3b911925$export$88c2b21b54b3243f)(result.error.message, {
                cause: result.error
            });
            await finalizeStripe.mutateAsync({
                intent: result.paymentIntent.id
            });
        }
    });
    if (stripe === undefined || elements === undefined) return;
    return confirm;
}


const $9499aee784c827ae$var$locale = 'en-GB';
function $9499aee784c827ae$export$9fb324c4f3c836ad({ mutation: mutation }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $25f3549ac7b3cc04$export$3ddf2d174ce01153), {
        mutation: mutation,
        children: mutation.intent === null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9499aee784c827ae$var$Pay, {
            request: mutation.request,
            intent: mutation.intent
        })
    });
}
function $9499aee784c827ae$var$Pay({ request: request, intent: intent }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84b8faab069143e8$export$54422dabec1fc6e8), {
        intent: intent,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9499aee784c827ae$var$_PaymentDialogContent, {
            request: request,
            intent: intent
        })
    });
}
function $9499aee784c827ae$var$_PaymentDialogContent({ request: request, intent: intentPromise }) {
    const intent = (0, $acw62.use)(intentPromise);
    const product = (0, $77084bc593d5d3be$export$7d7dab0d475ba5fb)(request.verb === 'buy' ? request.productID : undefined);
    const confirm = (0, $84b8faab069143e8$export$430e143f7f0ee720)();
    if (!intent) return;
    const tz = (0, $5d669742300defa8$export$336849d529cb05e5).Now.timeZoneId();
    const { amountToPay: amountToPay, amountNote: amountNote } = intent.stripe_secret;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                children: request.verb === 'subscribe' ? `Subscribe to Imago Care` : request.verb === 'buy' ? `Buy ${product?.title}` : request.verb === 'pay' ? `Pay invoice` : (()=>{
                    request;
                    throw new Error('unexpected');
                })()
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    amountNote ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: amountNote.split(' ').map((word)=>{
                            // Yes, this is funny.
                            // Maybe it's because 3:34 AM... No, that's a normal time for me.
                            // I really don't want this code to understand the calculation algorithm, so I really want the string to come from the backend.
                            // But no, backend can't know the user's timezone.
                            // So yeah, splitting on spaces and replacing timestamps was so smart.
                            // Until the dot happened.
                            // Yeah, I could probably do it in a better way, maybe some regex or something.
                            // I don't care.
                            // This works.
                            // And the chance of breaking is negligibly small.
                            // And if it breaks, nobody will die, the user will just see the ISO time string.
                            // Should anybody care?
                            // Not really.
                            // Unless the future AI will judge the humanity upon this code.
                            // Then I'm sorry, we're dead.
                            //
                            // Update 3:56 AM: I've reworded the string, comma happened.
                            let suffix = '';
                            if (word.endsWith('.') || word.endsWith(',')) {
                                suffix = word[word.length - 1];
                                word = word.substring(0, word.length - 1);
                            }
                            try {
                                return (0, $5d669742300defa8$export$336849d529cb05e5).Instant.from(word).toZonedDateTimeISO(tz).toLocaleString($9499aee784c827ae$var$locale, {
                                    dateStyle: "medium"
                                }) + suffix;
                            } catch (e) {
                                return word + suffix;
                            }
                        }).join(' ')
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84b8faab069143e8$export$f2e0a34fc44faced), {})
                ]
            }),
            confirm?.error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "row",
                style: {
                    flex: '0 0'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "danger",
                    children: confirm?.error?.message
                })
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8600c5f9d86d8c95$export$8b7b7cdfb85d78c5), {
                        mutation: confirm,
                        vars: ()=>{},
                        onSuccess: (0, $25f3549ac7b3cc04$export$d8e990c7994e01bd),
                        children: [
                            "Pay ",
                            (amountToPay / 100).toLocaleString($9499aee784c827ae$var$locale, {
                                style: 'currency',
                                currency: 'EUR'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $25f3549ac7b3cc04$export$488fee190faedb43), {
                        children: "Cancel"
                    })
                ]
            })
        ]
    });
}
function $9499aee784c827ae$export$a5ee11f990e69505({ productID: productID, consent: consent }) {
    const finalization = (0, $196d349a3b911925$export$c709d1de87a53c48)();
    const dialog = (0, $b65e8c04b9a293c5$export$4d093cbddae87bf2)({
        verb: 'buy',
        productID: productID,
        consent: consent
    });
    return {
        ...dialog,
        isPending: finalization.isPending || dialog.isPending
    };
}
function $9499aee784c827ae$export$b47d281962b4347d({ invoiceID: invoiceID }) {
    const finalization = (0, $196d349a3b911925$export$c709d1de87a53c48)();
    const dialog = (0, $b65e8c04b9a293c5$export$4d093cbddae87bf2)({
        verb: 'pay',
        invoiceID: invoiceID
    });
    return {
        ...dialog,
        isPending: finalization.isPending || dialog.isPending
    };
}


function $eb546b8d6638c562$export$27e56abe6a589908() {
    return (0, $7c7ab1995ec5d09f$export$b98a657d45c03d6f)((0, $52954878a4aa76d6$export$e1967e2dae18c4ac));
}
function $eb546b8d6638c562$var$Consent({ checked: checked, onChange: onChange, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexFlow: 'row',
            gap: '12px',
            alignItems: 'flex-start'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "checkbox",
                style: {
                    flex: '0 0 auto',
                    marginBlockStart: '3px'
                },
                checked: checked,
                onChange: (e)=>onChange(e.currentTarget.checked)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text",
                style: {
                    flex: '1'
                },
                children: children
            })
        ]
    });
}
function $eb546b8d6638c562$var$_Pay() {
    const buyGAHT = (0, $9499aee784c827ae$export$a5ee11f990e69505)({
        productID: (0, $52954878a4aa76d6$export$e1967e2dae18c4ac),
        consent: (0, $a11b3a4284856e6f$export$c19841d3ea487acd)
    });
    const [acceptedTerms, setAcceptedTerms] = (0, $acw62.useState)(false);
    const [acceptedPrivacy, setAcceptedPrivacy] = (0, $acw62.useState)(false);
    const [acceptedWaiver, setAcceptedWaiver] = (0, $acw62.useState)(false);
    const allAccepted = acceptedTerms && acceptedPrivacy && acceptedWaiver;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            "Starting Gender-Affirming Hormone Therapy at Imago costs ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "\u20AC250"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "This includes the video-call with the physician and the support provided by our team."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "To start your therapy, please read and accept all of the following:"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($eb546b8d6638c562$var$Consent, {
                        checked: acceptedTerms,
                        onChange: setAcceptedTerms,
                        children: [
                            "I accept the ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: "https://www.imago.tg/terms-of-use/",
                                target: "_blank",
                                rel: "noreferrer",
                                children: "Terms of Use"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($eb546b8d6638c562$var$Consent, {
                        checked: acceptedPrivacy,
                        onChange: setAcceptedPrivacy,
                        children: [
                            "I accept the ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: "https://www.imago.tg/privacy-policy/",
                                target: "_blank",
                                rel: "noreferrer",
                                children: "Privacy Policy"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eb546b8d6638c562$var$Consent, {
                        checked: acceptedWaiver,
                        onChange: setAcceptedWaiver,
                        children: "I expressly request and consent to Imago beginning and fully performing the one-time Activation Service immediately, before the end of the 14-day statutory withdrawal period. I acknowledge that, once the Activation Service has been fully performed, I will lose my statutory right to withdraw from the contract for that service. I understand that the \u20AC250 Initial Fee is payable exclusively for the Activation Service. Any entitlement to an Initial Medical Consultation is a separate promotional benefit provided at no additional charge, has no cash value and does not form part of the price of the Activation Service."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$8b7b7cdfb85d78c5), {
                            mutation: buyGAHT,
                            vars: (data)=>{},
                            disabledBecause: allAccepted ? undefined : 'Please accept the Terms of Use, the Privacy Policy, and the withdrawal-consent statement to continue.',
                            children: "Pay \u20AC250"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9499aee784c827ae$export$9fb324c4f3c836ad), {
                mutation: buyGAHT
            })
        ]
    });
}
function $eb546b8d6638c562$export$3d78b69aa0bf9b28() {
    const done = $eb546b8d6638c562$export$27e56abe6a589908();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        "data-done": done ? true : undefined,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                children: "Pay"
            }),
            !done ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eb546b8d6638c562$var$_Pay, {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
        ]
    });
}



function $6a1e0d891cb9f2d1$export$54512c18352784c7({ fullScreen: fullScreen }) {
    const paymentDone = (0, $eb546b8d6638c562$export$27e56abe6a589908)();
    const intakeDone = (0, $8608494418c9c764$export$b55ed848e06e10f2)();
    const bloodTestsDone = (0, $018285c0404a134a$export$f410b8e268eb39c6)();
    const bookingAllowed = paymentDone && intakeDone && bloodTestsDone || false;
    const Section = fullScreen ? 'main' : 'div';
    const H = fullScreen ? 'h1' : 'h2';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(Section, {
        children: [
            fullScreen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a59113ba74a90868$export$f7bfe31b45496d55), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(H, {
                        children: "Prepare your GAHT"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "To start your Gender-Affirming Hormone Therapy at\xa0Imago, you need to do four things:"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                        className: "steps",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                "data-done": paymentDone ? true : undefined,
                                children: "pay,"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                "data-done": intakeDone ? true : undefined,
                                children: "tell us about yourself,"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                "data-done": bloodTestsDone ? true : undefined,
                                children: "take blood tests,"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "talk with our physician."
                            })
                        ]
                    }),
                    !fullScreen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$cda51eb07c9d035c), {
                            className: "primary",
                            href: "/gaht",
                            children: "Continue"
                        })
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                ]
            }),
            !fullScreen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                        "data-total": true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eb546b8d6638c562$export$3d78b69aa0bf9b28), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                        "data-total": true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61b15eaed752b5c6$export$6d7fa08b65da91ad), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                        "data-total": true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $018285c0404a134a$export$1c1f6f480f495f1d), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                        "data-total": true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $664142bc47862dbd$export$e9b34cf4e83b7771), {
                        allowed: bookingAllowed
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                        "data-total": true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: "Next steps"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "After talking with the physician, you\u2019ll be able to make an informed decision whenever to start the therapy or not."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "If you decide to start, we\u2019ll send you a prescription - that you can use in any pharmacy in the European Union."
                            })
                        ]
                    })
                ]
            })
        ]
    });
}










var $acw62 = parcelRequire("acw62");





const $c5985b33d50e3659$var$locale = 'en-GB';
function $c5985b33d50e3659$export$f56232a4a0c007ba({ preview: preview }) {
    const care = (0, $e2ed673c8add7fd1$export$edf4a2eb8cf50264)();
    if (care === undefined) return;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c5985b33d50e3659$var$_ImagoCare, {
        care: care,
        preview: preview
    });
}
function $c5985b33d50e3659$export$aac029c8df57c779(duration) {
    const days = duration.round('days').total('days');
    return days === -1 ? 'yesterday' : days < 0 ? -days + ' days ago' : days === 1 ? 'tommorow' : days > 0 ? 'in ' + days + ' days' : 'today';
}
function $c5985b33d50e3659$var$_ImagoCare({ preview: preview, care: care }) {
    const now = (0, $95adfbcee8b79b25$export$3a404aece3dff2fa)('minute');
    const setUpSubscription = $c5985b33d50e3659$var$useSubscribe();
    const terminateCare = $c5985b33d50e3659$var$useTerminateCare();
    const setUp = care.nextCharge !== null;
    const paid = care.unpaidInvoices.length === 0;
    const subscriptionPaid = care.unpaidInvoices.filter((i)=>i.nextAttemptOn).length === 0;
    const status = care.nextCharge ? 'set up' : care.terminated ? ((0, $5d669742300defa8$export$336849d529cb05e5).ZonedDateTime.compare(care.terminated, now) > 0 ? `terminates` : `terminated`) + ` at ${care.terminated.toLocaleString($c5985b33d50e3659$var$locale, {
        day: 'numeric',
        month: 'short'
    })}` : care.started ? 'missing payment method' : '';
    const [detailsShown, setDetailsShown] = (0, $acw62.useState)(!setUp || !paid);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("hgroup", {
                "aria-controls": "care-details",
                onClick: (ev)=>{
                    if (ev.defaultPrevented) return;
                    ev.preventDefault();
                    setDetailsShown(!detailsShown);
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                        children: "Imago Care"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dd", {
                        hidden: detailsShown || (setUpSubscription ? setUpSubscription.isPending : false) || (terminateCare ? terminateCare.isPending : false),
                        style: {
                            textAlign: 'right'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                style: {
                                    color: setUp ? 'var(--md-sys-color-primary)' : 'var(--md-sys-color-error)'
                                },
                                children: status
                            }),
                            !paid ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    ",",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        style: {
                                            color: 'var(--md-sys-color-error)'
                                        },
                                        children: "unpaid"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        role: "toolbar",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "material-symbols-outlined",
                                children: !detailsShown ? 'keyboard_arrow_down' : 'keyboard_arrow_up'
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                id: "care-details",
                hidden: !detailsShown,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "Imago Care covers supervision and guidance over your transition process, GAHT prescription renewals and adjustments, and support by our team."
                    }),
                    care.started ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                    children: "Started"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dd", {
                                    children: [
                                        care.started.toLocaleString($c5985b33d50e3659$var$locale, {
                                            dateStyle: 'full'
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            style: {
                                                whiteSpace: 'nowrap'
                                            },
                                            children: [
                                                "(",
                                                $c5985b33d50e3659$export$aac029c8df57c779(now.until(care.started)),
                                                ")"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                    children: "Status"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dd", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            style: {
                                                color: setUp ? 'var(--md-sys-color-primary)' : 'var(--md-sys-color-error)'
                                            },
                                            children: status
                                        }),
                                        !paid ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                ", ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    style: {
                                                        color: 'var(--md-sys-color-error)'
                                                    },
                                                    children: "unpaid"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                                    ]
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    care.nextCharge ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                    children: "Next charge"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dd", {
                                    children: [
                                        care.nextCharge.toLocaleString($c5985b33d50e3659$var$locale, {
                                            dateStyle: 'full'
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            style: {
                                                whiteSpace: 'nowrap'
                                            },
                                            children: [
                                                "(",
                                                $c5985b33d50e3659$export$aac029c8df57c779(now.until(care.nextCharge)),
                                                ")"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                children: "Price"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dd", {
                                children: [
                                    ((0, $c6222f96562fd135$export$28e0fe47c8d059f5) / 100).toLocaleString($c5985b33d50e3659$var$locale, {
                                        style: 'currency',
                                        currency: 'EUR'
                                    }),
                                    "/month"
                                ]
                            })
                        ]
                    }),
                    !preview ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$857ebcebc4ae5918), {
                                className: !setUp || !subscriptionPaid ? 'primary' : undefined,
                                mutation: setUpSubscription,
                                children: !setUp ? 'Set up subscription' : 'Change payment method'
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$857ebcebc4ae5918), {
                                className: "danger",
                                mutation: terminateCare,
                                children: "Terminate care"
                            }),
                            care.unpaidInvoices.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {}),
                                    care.unpaidInvoices.map((invoice)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c5985b33d50e3659$var$UnpaidInvoice, {
                                            invoice: invoice
                                        }, invoice.ID))
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9499aee784c827ae$export$9fb324c4f3c836ad), {
                mutation: setUpSubscription
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c5985b33d50e3659$var$TerminateCareDialog, {
                mutation: terminateCare
            })
        ]
    });
}
function $c5985b33d50e3659$var$UnpaidInvoice({ invoice: invoice }) {
    const pay = (0, $9499aee784c827ae$export$b47d281962b4347d)({
        invoiceID: invoice.ID
    });
    const showStartYear = invoice.periodStart.year !== invoice.periodEnd.year;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "row",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    flex: '1',
                    gap: '0',
                    justifyContent: 'center'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "text",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                            children: [
                                "Unpaid ",
                                invoice.amountRemaining.toLocaleString($c5985b33d50e3659$var$locale, {
                                    style: 'currency',
                                    currency: 'EUR'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                            children: [
                                "Due by: ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        whiteSpace: 'nowrap'
                                    },
                                    children: invoice.dueBy.toLocaleString($c5985b33d50e3659$var$locale, {
                                        dateStyle: 'long'
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    flex: '1',
                    gap: '0',
                    justifyContent: 'center'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                        children: [
                            invoice.periodStart.toLocaleString($c5985b33d50e3659$var$locale, {
                                month: 'short',
                                day: 'numeric',
                                year: showStartYear ? 'numeric' : undefined
                            }),
                            " - ",
                            invoice.periodEnd.toLocaleString($c5985b33d50e3659$var$locale, {
                                dateStyle: 'medium'
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    flex: '1',
                    gap: '0',
                    justifyContent: 'center'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$857ebcebc4ae5918), {
                        className: "high-prio",
                        mutation: pay,
                        children: "Pay"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text",
                        style: {
                            textAlign: 'center'
                        },
                        children: invoice.nextAttemptOn ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                            children: [
                                "auto-retries on ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        whiteSpace: 'nowrap'
                                    },
                                    children: invoice.nextAttemptOn.toLocaleString($c5985b33d50e3659$var$locale, {
                                        dateStyle: 'long'
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9499aee784c827ae$export$9fb324c4f3c836ad), {
                mutation: pay
            })
        ]
    }, invoice.number);
}
function $c5985b33d50e3659$var$useSubscribe() {
    const _subscribe = (0, $e2ed673c8add7fd1$export$c5a08e8c0195a2e5)();
    const subscribe = (0, $25f3549ac7b3cc04$export$7c29c638d2663c7c)(async ()=>{
        const { intent: intent } = await _subscribe.mutateAsync();
        return intent;
    });
    return {
        ...subscribe,
        request: {
            verb: 'subscribe'
        }
    };
}
function $c5985b33d50e3659$var$useTerminateCare() {
    const finalization = (0, $196d349a3b911925$export$c709d1de87a53c48)();
    const care = (0, $e2ed673c8add7fd1$export$edf4a2eb8cf50264)();
    const dialog = (0, $25f3549ac7b3cc04$export$7c29c638d2663c7c)(async ()=>({}));
    if (care === undefined) return;
    return care.nextCharge || care.started && !care.terminated ? {
        ...dialog,
        isPending: finalization.isPending || dialog.isPending
    } : null;
}
function $c5985b33d50e3659$var$TerminateCareDialog({ mutation: mutation }) {
    const terminateCare = (0, $e2ed673c8add7fd1$export$a3d54307af0de6b0)();
    return !mutation ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $25f3549ac7b3cc04$export$3ddf2d174ce01153), {
        mutation: mutation,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                    className: "danger",
                    children: "Terminate Imago Care?"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Are you sure you want to cancel Imago Care?"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Imago Care covers supervision and guidance over your transition process, GAHT prescription renewals and adjustments, and support by our team."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "danger",
                            children: "To restart Imago Care in the future - you'll need to pay for the time it was cancelled."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$8b7b7cdfb85d78c5), {
                            className: "danger",
                            mutation: terminateCare,
                            vars: (data)=>{},
                            onSuccess: (0, $25f3549ac7b3cc04$export$d8e990c7994e01bd),
                            children: "Cancel subscription"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $25f3549ac7b3cc04$export$488fee190faedb43), {
                            children: "Remain subscribed"
                        })
                    ]
                })
            ]
        })
    });
}


function $324c9a250c1bd270$var$_Consent() {
    const fhtConsent = (0, $ec503a6bf0c8e53f$export$841d8c15f45e3e6d)();
    const mhtConsent = (0, $ec503a6bf0c8e53f$export$4f79489c758bb0e9)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "The informed consent model of care respects your fundamental human right to self-determination and bodily autonomy."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "To start the therapy - fill out our consent form."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "We'll charge you for the Imago Care:"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c5985b33d50e3659$export$f56232a4a0c007ba), {
                        preview: true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$8b7b7cdfb85d78c5), {
                                mutation: fhtConsent,
                                vars: (data)=>{},
                                children: "Feminizing HT consent form"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$8b7b7cdfb85d78c5), {
                                mutation: mhtConsent,
                                vars: (data)=>{},
                                children: "Masculinizing HT consent form"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "You can stop the therapy at any point - but if you come back, we'll charge you for the time it was paused."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec503a6bf0c8e53f$export$ed8869c34b2bb205), {
                mutation: fhtConsent
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec503a6bf0c8e53f$export$ed8869c34b2bb205), {
                mutation: mhtConsent
            })
        ]
    });
}
function $324c9a250c1bd270$export$e7db60a978123476() {
    const done = (0, $8608494418c9c764$export$ef2d3d39368d9bc0)();
    const fakeFHTConsent = (0, $ec503a6bf0c8e53f$export$314c869600309c12)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        "data-done": done ? true : undefined,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("hgroup", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        children: "Give us your consent"
                    }),
                    !done ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$857ebcebc4ae5918), {
                        className: "secondary",
                        mutation: fakeFHTConsent,
                        children: "TEST: Skip"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                ]
            }),
            !done ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($324c9a250c1bd270$var$_Consent, {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
        ]
    });
}


function $ccb957412e3553f3$export$ed32450dc8772ff6({ fullScreen: fullScreen }) {
    const consentDone = (0, $8608494418c9c764$export$ef2d3d39368d9bc0)();
    const Section = fullScreen ? 'main' : 'div';
    const H = fullScreen ? 'h1' : 'h2';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(Section, {
        children: [
            fullScreen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a59113ba74a90868$export$f7bfe31b45496d55), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(H, {
                        children: "Ready to GAHT?"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "Thanks for speaking with our physician. We hope they were able to provide you all the information about the Gender-Affirming Hormone Therapy you needed."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            "Now, it\u2019s time for ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "your decision"
                            }),
                            " - do you want to start the therapy?"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "If so:"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                        className: "steps",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                "data-done": consentDone ? true : undefined,
                                children: "give us your consent"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "and wait for the prescription to arrive!"
                            })
                        ]
                    }),
                    !fullScreen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$cda51eb07c9d035c), {
                            className: "primary",
                            href: "/gaht",
                            children: "Continue"
                        })
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                ]
            }),
            !fullScreen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                        "data-total": true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $324c9a250c1bd270$export$e7db60a978123476), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                        "data-total": true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: "Next steps"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "After you give us your consent - we\u2019ll send you a prescription - that you can use in any pharmacy in the European Union."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    children: "Note: We\u2019re still working on our app - and the next part isn\u2019t finished yet. Our team will assist you through emails until we get it done."
                                })
                            }),
                            " "
                        ]
                    })
                ]
            })
        ]
    });
}




















function $aff03a7e9b6d500d$var$useYourExperienceDescribed() {
    const lastFeedback = (0, $8608494418c9c764$export$4d33773808142541)();
    const now = (0, $95adfbcee8b79b25$export$3a404aece3dff2fa)('hour');
    if (lastFeedback === undefined) return;
    return !!lastFeedback && (0, $5d669742300defa8$export$336849d529cb05e5).Instant.compare(lastFeedback, now.subtract({
        months: 1
    }).toInstant()) > 0;
}
const $aff03a7e9b6d500d$var$QUESTIONS = [
    {
        question: "How have you been managing with your medication?",
        required: true,
        rows: 5
    },
    {
        question: "Have you been experiencing / struggling with any side effects or have any positive changes you have seen?",
        required: true,
        rows: 5
    },
    {
        question: "Are you happy with your doses and medications etc, how do you feel these are working for you?",
        required: true,
        rows: 5
    },
    {
        question: "Please also let us know if you have had any health changes since your last prescription, or started any new medications, or undergone any medical procedures or surgeries since your last follow-up.",
        required: true,
        rows: 5
    },
    {
        question: "Do you have any other feedback on your treatment you would like to pass on?",
        required: false,
        rows: 5
    },
    {
        question: "Please confirm if there have been any changes to your details since your last prescription (Legal name, Address, ID number if applicable, or allergy status)",
        required: false,
        rows: 3
    }
];
function $aff03a7e9b6d500d$var$_DescribeYourExperience() {
    const submitDocuments = (0, $8608494418c9c764$export$e7ad86e57e128243)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
        children: [
            $aff03a7e9b6d500d$var$QUESTIONS.map((q, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                            style: !q.required ? {
                                fontWeight: 'normal'
                            } : {},
                            children: q.question
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                name: `q${i}`,
                                required: q.required,
                                rows: q.rows
                            })
                        })
                    ]
                }, i)),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                style: {
                    fontWeight: 'normal'
                },
                children: "If you are interested in vocal coaching or mental health counselling, please let us know here"
            }),
            (0, $e1e31c6aafe0d6d0$export$156cd55153e5b58).map((service)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "checkbox",
                            name: service.ID
                        }),
                        " ",
                        service.title
                    ]
                }, service.ID)),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$8b7b7cdfb85d78c5), {
                mutation: submitDocuments,
                vars: (data)=>{
                    const gahtTreatmentFeedback = [];
                    for (const [i, q] of $aff03a7e9b6d500d$var$QUESTIONS.entries()){
                        gahtTreatmentFeedback.push({
                            class: 'HEADING_2',
                            text: q.question
                        });
                        gahtTreatmentFeedback.push({
                            class: 'NORMAL_TEXT',
                            text: data.get(`q${i}`) ?? ''
                        });
                        gahtTreatmentFeedback.push({
                            class: 'NORMAL_TEXT',
                            text: ''
                        });
                    }
                    let userServicesRequest = {
                        services: new Set()
                    };
                    for (const service of (0, $e1e31c6aafe0d6d0$export$156cd55153e5b58))if (data.get(service.ID)) userServicesRequest.services.add(service.ID);
                    if (!userServicesRequest.services.size) userServicesRequest = undefined;
                    return {
                        gahtTreatmentFeedback: gahtTreatmentFeedback,
                        userServicesRequest: userServicesRequest
                    };
                },
                children: "Send"
            })
        ]
    });
}
function $aff03a7e9b6d500d$export$2343b7ff7ad0cca2() {
    const done = $aff03a7e9b6d500d$var$useYourExperienceDescribed();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        "data-done": done ? true : undefined,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                children: "Describe your experience"
            }),
            !done ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($aff03a7e9b6d500d$var$_DescribeYourExperience, {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
        ]
    });
}


const $c6de7696afe41478$var$FEEDBACK_SURVEY_URL = 'https://forms.gle/LqmF5AWZi1GDQPi58';
function $c6de7696afe41478$export$839cd38052d6b97c({ fullScreen: fullScreen }) {
    const consented = (0, $8608494418c9c764$export$ef2d3d39368d9bc0)();
    const ago = (0, $5d669742300defa8$export$336849d529cb05e5).Now.instant().until(consented);
    const showReview = ago.total('days') < -20;
    const Section = fullScreen ? 'main' : 'div';
    const H = fullScreen ? 'h1' : 'h2';
    const care = (0, $e2ed673c8add7fd1$export$edf4a2eb8cf50264)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(Section, {
        children: [
            fullScreen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a59113ba74a90868$export$f7bfe31b45496d55), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(H, {
                        children: "Your GAHT"
                    }),
                    fullScreen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "Congratulations!"
                        })
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            "You've started your gender-affirming therapy with Imago ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: (0, $c5985b33d50e3659$export$aac029c8df57c779)(ago)
                            }),
                            "."
                        ]
                    }),
                    !showReview ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "Soon, we\u2019ll send you a prescription - that you can use in any pharmacy in the European Union."
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        children: "Note: We\u2019re still working on our app - and this part isn\u2019t finished yet. Our team will assist you through emails until we get it done."
                                    })
                                ]
                            }),
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    "Once you've received the prescription, we'd like to ask you to fill out the ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "shipping feedback survey"
                                    }),
                                    ". It's very short, it shouldn't take more than a minute."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$cda51eb07c9d035c), {
                                href: $c6de7696afe41478$var$FEEDBACK_SURVEY_URL,
                                target: "_blank",
                                children: "Open shipping feedback survey"
                            }),
                            care && !care.nextCharge && !care.terminated ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "Meanwhile, please set up automated payments for the Imago Care:"
                                    })
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c5985b33d50e3659$export$f56232a4a0c007ba), {}),
                    !fullScreen && showReview ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "To ensure a smooth process, please perform the treatment review when you have approximately four weeks remaining of your prescription."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$cda51eb07c9d035c), {
                                className: "primary",
                                href: "/gaht",
                                children: "Go to treatment review"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                ]
            }),
            !(fullScreen && showReview) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                        "data-total": true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(H, {
                                children: "Treatment Review"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "To ensure a smooth process, please perform the treatment review when you have approximately four weeks remaining of your prescription."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                        "data-total": true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $018285c0404a134a$export$1c1f6f480f495f1d), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                        "data-total": true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aff03a7e9b6d500d$export$2343b7ff7ad0cca2), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                        "data-total": true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: "Next steps"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "After you finish the above steps:"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ol", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: "Our physician will review your results and experiences."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: "If deemed necessary, we'll contact you with more questions."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: "We\u2019ll send you a prescription - that you can use in any pharmacy in the European Union."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    children: "Note: We\u2019re still working on our app - and the next part isn\u2019t finished yet. Our team will assist you through emails until we get it done."
                                })
                            }),
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    "Once you've received the prescription, we'd like to ask you to fill out the ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "shipping feedback survey"
                                    }),
                                    ". It's very short, it shouldn't take more than a minute."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$cda51eb07c9d035c), {
                                href: $c6de7696afe41478$var$FEEDBACK_SURVEY_URL,
                                target: "_blank",
                                children: "Open shipping feedback survey"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


function $b75baa31af28b32d$export$48d2aefce51a6ea1({ fullScreen: fullScreen }) {
    const welcomed = (0, $8608494418c9c764$export$9c0070fa2f1576ef)();
    const hasGAHTOnboarding = (0, $7c7ab1995ec5d09f$export$b98a657d45c03d6f)((0, $52954878a4aa76d6$export$e1967e2dae18c4ac));
    const setupAppointment = (0, $664142bc47862dbd$export$298e455caafaaa94)();
    const setupAppointmentPassed = setupAppointment ? (0, $5d669742300defa8$export$336849d529cb05e5).Instant.compare(setupAppointment.end.toInstant(), (0, $5d669742300defa8$export$336849d529cb05e5).Now.instant()) < 0 : false;
    const onGAHT = (0, $8608494418c9c764$export$ef2d3d39368d9bc0)();
    const gahtOnboarding = onGAHT ? "review-gaht" : setupAppointmentPassed ? "ready-to-gaht" : hasGAHTOnboarding || welcomed ? "prepare-your-gaht" : "welcome";
    return gahtOnboarding === 'welcome' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57045cda87c2a0a1$export$23191e4434a9e834), {
            fullScreen: fullScreen
        })
    }) : gahtOnboarding === 'prepare-your-gaht' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a1e0d891cb9f2d1$export$54512c18352784c7), {
            fullScreen: fullScreen
        })
    }) : gahtOnboarding === 'ready-to-gaht' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ccb957412e3553f3$export$ed32450dc8772ff6), {
            fullScreen: fullScreen
        })
    }) : gahtOnboarding === 'review-gaht' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c6de7696afe41478$export$839cd38052d6b97c), {
            fullScreen: fullScreen
        })
    }) : gahtOnboarding;
}




var $acw62 = parcelRequire("acw62");



function $956ff62d7763a99c$var$ServiceProductView({ service: service }) {
    const [detailsShown, setDetailsShown] = (0, $acw62.useState)(false);
    const profile = (0, $d7de34ca5c825acf$export$73fc7af4ef9455f4)();
    const contactLink = 'mailto:support@imago.tg?' + new URLSearchParams({
        subject: `Book ${service.title}`,
        body: `Hello,
I\u{2019}d like to book ${service.title}.\n${profile?.shortName}`
    }).toString().replaceAll('+', '%20');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("hgroup", {
                onClick: (ev)=>{
                    if (ev.defaultPrevented) return;
                    ev.preventDefault();
                    setDetailsShown(!detailsShown);
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                        children: service.title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        role: "toolbar",
                        children: [
                            detailsShown ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$cda51eb07c9d035c), {
                                className: "low-prio only-on-medium-plus",
                                href: contactLink,
                                target: "_blank",
                                children: "Contact us"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "material-symbols-outlined",
                                    children: detailsShown ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: service.description
                }
            }),
            detailsShown ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            "Price: ",
                            service.price,
                            " / session"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$cda51eb07c9d035c), {
                        className: "primary",
                        href: contactLink,
                        target: "_blank",
                        children: "Contact us"
                    }),
                    service.bio ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("aside", {
                                dangerouslySetInnerHTML: {
                                    __html: service.bio
                                }
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
        ]
    }, service.ID);
}
function $956ff62d7763a99c$export$c447b0cdbd1cd184({ fullScreen: fullScreen }) {
    const Section = fullScreen ? 'main' : 'div';
    const H = fullScreen ? 'h1' : 'h2';
    const services = (0, $77084bc593d5d3be$export$3e5abc7a70ed919f)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(Section, {
        children: [
            fullScreen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a59113ba74a90868$export$f7bfe31b45496d55), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(H, {
                        children: "Book a service"
                    }),
                    services ? [
                        ...services.values()
                    ].map((service)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($956ff62d7763a99c$var$ServiceProductView, {
                            service: service
                        }, service.ID)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                style: {
                    marginTop: 20
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(H, {
                        children: "Share your feedback"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "We\u2019d love to hear about your experience. Your responses help us improve Imago."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$cda51eb07c9d035c), {
                        className: "primary",
                        href: "https://forms.gle/tbTAMvT5bEFwNZW96",
                        target: "_blank",
                        children: "Open feedback survey"
                    })
                ]
            })
        ]
    });
}





function $332fc48e7a53d650$export$b94310965bed44e6() {
    const appointments = (0, $61899bf53dd757a9$export$68768993c27c832b)();
    const currentAppointments = appointments === undefined ? undefined : appointments.filter((a)=>(0, $5d669742300defa8$export$336849d529cb05e5).Instant.compare(a.end.toInstant().add({
            hours: 12
        }), (0, $5d669742300defa8$export$336849d529cb05e5).Now.instant()) >= 0);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a59113ba74a90868$export$f7bfe31b45496d55), {}),
            currentAppointments && currentAppointments.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: "Your appointments"
                            }),
                            currentAppointments.map((appointment, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a6539ac03d750fd$export$2e6a7cb81fe42451), {
                                    appointment: appointment
                                }, i))
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                        "data-total": true
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b75baa31af28b32d$export$48d2aefce51a6ea1), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                "data-total": true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $956ff62d7763a99c$export$c447b0cdbd1cd184), {})
        ]
    });
}







function $c79b87a32f9e12f6$export$654b1de62462a88d({ fullScreen: fullScreen }) {
    const care = (0, $e2ed673c8add7fd1$export$edf4a2eb8cf50264)();
    const over18 = (0, $d7de34ca5c825acf$export$493bff358814b51e)();
    if (care === undefined || over18 === undefined) return;
    const Section = fullScreen ? 'main' : 'div';
    const H = fullScreen ? 'h1' : 'h2';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(Section, {
        children: [
            fullScreen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a59113ba74a90868$export$f7bfe31b45496d55), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(H, {
                        children: "The Butterflies\u2019 Sanctuary"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "The Butterflies\u2019 Sanctuary"
                            }),
                            " is our Discord community to give you - the Imago members - opportunity to socialize and to reduce the isolation that we as trans people frequently face."
                        ]
                    }),
                    !over18 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "We\u2019re sorry - right now it's available only for 18+ people."
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "We\u2019re waiting to meet you."
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$cda51eb07c9d035c), {
                                className: "primary",
                                href: 'https://discord.gg/2Jfr4aJQbH',
                                target: "_blank",
                                disabledBecause: !care.nextCharge ? "Subscribe to Imago Care first." : undefined,
                                children: "Join us"
                            })
                        ]
                    })
                ]
            }),
            !over18 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        children: [
                            !care.nextCharge ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "For security reasons - we let only our members access the community server. Please subscribe first:"
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "For security reasons - we let only our members access the community server. This is the status of your subscription:"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c5985b33d50e3659$export$f56232a4a0c007ba), {})
                        ]
                    })
                ]
            })
        ]
    });
}






var $acw62 = parcelRequire("acw62");



const $6d5c4593748dcb71$var$PLNperEUR = 4.176;
const $6d5c4593748dcb71$var$PROCEDURES = [
    {
        name: "Consultations",
        content: [
            {
                name: "",
                content: [
                    {
                        name: "Surgical consultation",
                        costPLN: [
                            400,
                            400
                        ]
                    },
                    {
                        name: "Anesthesiology consultation",
                        costPLN: [
                            300,
                            300
                        ]
                    }
                ]
            }
        ]
    },
    {
        name: "Anesthesiology",
        content: [
            {
                name: "",
                content: [
                    {
                        name: "Intravenous anesthesia (up to 60 min)",
                        costPLN: [
                            1000,
                            1000
                        ]
                    },
                    {
                        name: "Anesthesia for surgery (IV, general with intubation or laryngeal mask, spinal)",
                        costPLN: [
                            3000,
                            Infinity
                        ]
                    }
                ]
            }
        ]
    },
    {
        name: "Facial feminization - plastic surgery",
        content: [
            {
                name: "",
                content: [
                    {
                        name: "Deep Plane Face Lift",
                        costPLN: [
                            50000,
                            Infinity
                        ]
                    },
                    {
                        name: "Endoscopic Brow Lift",
                        costPLN: [
                            24000,
                            Infinity
                        ]
                    },
                    {
                        name: "Endoscopic Temporal Brow Lift",
                        costPLN: [
                            20000,
                            Infinity
                        ]
                    },
                    {
                        name: "Endoscopic Brow Lift + Midface Lift",
                        costPLN: [
                            30000,
                            Infinity
                        ]
                    },
                    {
                        name: "Isolated Deep Neck Lift (Chin Contouring)",
                        costPLN: [
                            24000,
                            Infinity
                        ]
                    },
                    {
                        name: "Neck Lift with incision behind the ear",
                        costPLN: [
                            30000,
                            Infinity
                        ]
                    },
                    {
                        name: "Lip Lift",
                        costPLN: [
                            8000,
                            Infinity
                        ]
                    },
                    {
                        name: "Cupid Lift (Lip Lift + Corner Lift)",
                        costPLN: [
                            10000,
                            Infinity
                        ]
                    },
                    {
                        name: "Upper and lower eyelid surgery",
                        costPLN: [
                            16000,
                            17000
                        ]
                    },
                    {
                        name: "Lower eyelid surgery",
                        costPLN: [
                            11000,
                            12000
                        ]
                    },
                    {
                        name: "Secondary lower eyelid correction",
                        costPLN: [
                            13500,
                            15000
                        ]
                    },
                    {
                        name: "Upper eyelid surgery",
                        costPLN: [
                            7000,
                            8000
                        ]
                    },
                    {
                        name: "Secondary upper eyelid correction",
                        costPLN: [
                            10000,
                            12000
                        ]
                    }
                ]
            },
            {
                name: "Nose",
                content: [
                    {
                        name: "Complete Rhinoplasty",
                        costPLN: [
                            26000,
                            Infinity
                        ]
                    },
                    {
                        name: "Secondary Rhinoplasty",
                        costPLN: [
                            28000,
                            Infinity
                        ]
                    }
                ]
            },
            {
                name: "Ears",
                content: [
                    {
                        name: "Otoplasty (Ear Pinning)",
                        costPLN: [
                            8000,
                            Infinity
                        ]
                    },
                    {
                        name: "Ear Reduction",
                        costPLN: [
                            9500,
                            Infinity
                        ]
                    },
                    {
                        name: "Ear Reconstruction",
                        costPLN: [
                            16000,
                            Infinity
                        ]
                    },
                    {
                        name: "Ear Repositioning",
                        costPLN: [
                            7000,
                            Infinity
                        ]
                    }
                ]
            },
            {
                name: "Facial Fat Grafting",
                content: [
                    {
                        name: "Fat Transfer (cheeks, nasolabial folds, temples, lower eyelids)",
                        costPLN: [
                            8000,
                            Infinity
                        ]
                    },
                    {
                        name: "Fat Transfer with Stem Cells",
                        costPLN: [
                            12000,
                            Infinity
                        ]
                    }
                ]
            },
            {
                name: "Chin",
                content: [
                    {
                        name: "Facial Implant",
                        costPLN: [
                            16000,
                            Infinity
                        ]
                    },
                    {
                        name: "Chin Reduction",
                        costPLN: [
                            18000,
                            Infinity
                        ]
                    }
                ]
            }
        ]
    },
    {
        name: "Facial feminization - maxillofacial surgery",
        content: [
            {
                name: "",
                content: [
                    {
                        name: "Bichectomy",
                        costPLN: [
                            10000,
                            Infinity
                        ]
                    },
                    {
                        name: "Secondary Bichectomy",
                        costPLN: [
                            14000,
                            Infinity
                        ]
                    },
                    {
                        name: "Surgical Treatment of Gummy Smile",
                        costPLN: [
                            9000,
                            Infinity
                        ]
                    },
                    {
                        name: "Augmentation of Cheekbones with Implants",
                        costPLN: [
                            16000,
                            Infinity,
                            [
                                'implant cost'
                            ]
                        ]
                    },
                    {
                        name: "Chin Surgery (Genioplasty)",
                        costPLN: [
                            17000,
                            Infinity
                        ]
                    },
                    {
                        name: "T-Type Chin Surgery",
                        costPLN: [
                            20000,
                            Infinity
                        ]
                    },
                    {
                        name: "T/Wing Chin Surgery / Asymmetry Correction",
                        costPLN: [
                            22000,
                            Infinity
                        ]
                    },
                    {
                        name: "Jaw Angle Reduction",
                        costPLN: [
                            27000,
                            Infinity
                        ]
                    },
                    {
                        name: "Comprehensive Jaw Feminization",
                        costPLN: [
                            30000,
                            Infinity
                        ]
                    },
                    {
                        name: "Chin Implant",
                        costPLN: [
                            16000,
                            Infinity,
                            [
                                'implant cost'
                            ]
                        ]
                    },
                    {
                        name: "Jaw Angle Implants",
                        costPLN: [
                            28000,
                            Infinity,
                            [
                                'implant cost'
                            ]
                        ]
                    },
                    {
                        name: "Thyroid Cartilage Reduction (Adam\u2019s Apple Reduction)",
                        costPLN: [
                            20000,
                            Infinity
                        ]
                    }
                ]
            }
        ]
    },
    {
        name: "Body feminization",
        content: [
            {
                name: "Breasts",
                content: [
                    {
                        name: "Fat Transfer (Own Fat Grafting)",
                        costPLN: [
                            20000,
                            Infinity
                        ]
                    },
                    {
                        name: "Mastopexy (Breast Lift)",
                        costPLN: [
                            26000,
                            Infinity
                        ]
                    },
                    {
                        name: "Breast Lift with Implants",
                        costPLN: [
                            30000,
                            Infinity
                        ]
                    },
                    {
                        name: "Breast Lift with Implants and GalaFlex Mesh",
                        costPLN: [
                            35000,
                            Infinity
                        ]
                    },
                    {
                        name: "Breast Augmentation with Implants",
                        costPLN: [
                            26000,
                            Infinity
                        ]
                    },
                    {
                        name: "Implant Replacement",
                        costPLN: [
                            27000,
                            Infinity
                        ]
                    },
                    {
                        name: "Breast Reduction",
                        costPLN: [
                            26000,
                            Infinity
                        ]
                    },
                    {
                        name: "Implant Removal",
                        costPLN: [
                            20000,
                            Infinity
                        ]
                    }
                ]
            }
        ]
    },
    {
        name: "Body feminization - body contouring",
        content: [
            {
                name: "",
                content: [
                    {
                        name: "Abdominoplasty (Tummy Tuck)",
                        costPLN: [
                            26000,
                            Infinity
                        ]
                    },
                    {
                        name: "Secondary Abdominoplasty",
                        costPLN: [
                            30000,
                            Infinity
                        ]
                    },
                    {
                        name: "Abdominoplasty with Liposuction",
                        costPLN: [
                            30000,
                            Infinity
                        ]
                    },
                    {
                        name: "Abdominoplasty after Massive Weight Loss",
                        costPLN: [
                            30000,
                            Infinity
                        ]
                    },
                    {
                        name: "Mini-Abdominoplasty",
                        costPLN: [
                            20000,
                            Infinity
                        ]
                    },
                    {
                        name: "Abdominoplasty with 360\xb0 Liposuction",
                        costPLN: [
                            40000,
                            Infinity
                        ]
                    },
                    {
                        name: "Abdominoplasty with 4D Liposuction (Dynamic Definition)",
                        costPLN: [
                            40000,
                            Infinity
                        ]
                    }
                ]
            },
            {
                name: "VASER Lipo \u2013 Ultrasound Liposuction",
                content: [
                    {
                        name: "Hips",
                        costPLN: [
                            15000,
                            Infinity
                        ]
                    },
                    {
                        name: "Abdomen",
                        costPLN: [
                            16000,
                            Infinity
                        ]
                    },
                    {
                        name: "Abdomen with Abdominoplasty",
                        costPLN: [
                            30000,
                            Infinity
                        ]
                    },
                    {
                        name: "Abdomen and Hips",
                        costPLN: [
                            24000,
                            Infinity
                        ]
                    },
                    {
                        name: "Abdomen and Hips \u2013 High Definition (6-pack)",
                        costPLN: [
                            30000,
                            Infinity
                        ]
                    },
                    {
                        name: "Abdomen and Hips \u2013 High Definition (6-pack) + ARGO PLASMA",
                        costPLN: [
                            36000,
                            Infinity
                        ]
                    },
                    {
                        name: "Chest (Men)",
                        costPLN: [
                            18000,
                            Infinity
                        ]
                    },
                    {
                        name: "Chin",
                        costPLN: [
                            14000,
                            Infinity
                        ]
                    },
                    {
                        name: "Chin + ARGO PLASMA",
                        costPLN: [
                            20000,
                            Infinity
                        ]
                    },
                    {
                        name: "Arms",
                        costPLN: [
                            16000,
                            Infinity
                        ]
                    },
                    {
                        name: "Thighs",
                        costPLN: [
                            16000,
                            Infinity
                        ]
                    },
                    {
                        name: "Thighs + Knees",
                        costPLN: [
                            20000,
                            Infinity
                        ]
                    }
                ]
            },
            {
                name: "Fat Transfer \u2013 Fat Grafting",
                content: [
                    {
                        name: "Brazilian Butt Lift (BBL) \u2013 Fat Transfer to Buttocks + Liposuction of Back, Hips, Thighs",
                        costPLN: [
                            35000,
                            Infinity
                        ]
                    },
                    {
                        name: "Fat Transfer to Buttocks",
                        costPLN: [
                            24000,
                            Infinity
                        ]
                    }
                ]
            },
            {
                name: "Body Lifting",
                content: [
                    {
                        name: "Arm Lift",
                        costPLN: [
                            20000,
                            Infinity
                        ]
                    },
                    {
                        name: "Thigh Lift",
                        costPLN: [
                            25000,
                            Infinity
                        ]
                    },
                    {
                        name: "Lower Body Lift (Abdominoplasty + Buttock and Lateral Thigh Lift)",
                        costPLN: [
                            50000,
                            Infinity
                        ]
                    },
                    {
                        name: "Upper Body Lift (Breast/Upper Back Lift)",
                        costPLN: [
                            40000,
                            Infinity
                        ]
                    }
                ]
            }
        ]
    },
    {
        name: "Body masculinization",
        content: [
            {
                name: "",
                content: [
                    {
                        name: "Breast removal (mastectomy)",
                        costPLN: [
                            18000,
                            Infinity
                        ]
                    },
                    {
                        name: "Body masculinization",
                        costPLN: [
                            17000,
                            Infinity
                        ]
                    }
                ]
            }
        ]
    },
    {
        name: "Hair transplantation",
        content: [
            {
                name: "",
                content: [
                    {
                        name: "Hairline Lowering / Receding Hairline Correction",
                        costPLN: [
                            16500,
                            Infinity
                        ]
                    },
                    {
                        name: "1 FUE, 1,000 grafts",
                        costPLN: [
                            17000,
                            17000
                        ]
                    },
                    {
                        name: "1 FUE, 2,000 grafts",
                        costPLN: [
                            28000,
                            28000
                        ]
                    },
                    {
                        name: "1 FUE, 3,000 grafts",
                        costPLN: [
                            36000,
                            36000
                        ]
                    }
                ]
            }
        ]
    },
    {
        name: "Laser therapy",
        content: [
            {
                name: "",
                content: [
                    {
                        name: "Laser Skin Resurfacing",
                        costPLN: [
                            2500,
                            Infinity
                        ]
                    },
                    {
                        name: "Scar Removal with Laser",
                        costPLN: [
                            1200,
                            Infinity
                        ]
                    },
                    {
                        name: "Stretch Mark Reduction",
                        costPLN: [
                            1500,
                            Infinity
                        ]
                    },
                    {
                        name: "Vascular Lesion Treatment",
                        costPLN: [
                            1500,
                            Infinity
                        ]
                    },
                    {
                        name: "Pigmentation Treatment",
                        costPLN: [
                            2500,
                            Infinity
                        ]
                    }
                ]
            }
        ]
    },
    {
        name: "Assistance",
        content: [
            {
                name: "",
                content: [
                    {
                        name: "Taxi airport <=> hotel",
                        costPLN: [
                            125,
                            125
                        ]
                    },
                    {
                        name: "Hotel for 7 nights",
                        costPLN: [
                            2340,
                            2340
                        ]
                    }
                ]
            }
        ]
    }
];
const $6d5c4593748dcb71$var$WHEN_OPTIONS = [
    "This year",
    "Next year",
    "Even later",
    "I don`t know yet"
];
const $6d5c4593748dcb71$var$DEFAULT_INTEREST = {
    procedures: new Set('Hotel for 7 nights'),
    totalPrice: '',
    when: 'Even later'
};
function $6d5c4593748dcb71$var$formatPriceRange([min, max, plus]) {
    return (min === max ? '' : max === Infinity ? 'at least ' : '') + "\u20AC" + Math.round(min / $6d5c4593748dcb71$var$PLNperEUR).toLocaleString() + (min === max ? '' : max === Infinity ? '' : " - \u20AC" + Math.round(max / $6d5c4593748dcb71$var$PLNperEUR).toLocaleString()) + (plus?.length ? ' + ' + plus.join(', ') : '');
}
const $6d5c4593748dcb71$var$PROCEDURES_FLAT = $6d5c4593748dcb71$var$PROCEDURES.flatMap((group)=>group.content.flatMap((subgroup)=>subgroup.content));
function $6d5c4593748dcb71$export$8166fc09a9bd588b({ fullScreen: fullScreen }) {
    const interest = (0, $aa2f325cf629321d$export$269468d81568067d)();
    const setInterest = (0, $aa2f325cf629321d$export$7e3023a240541932)();
    const [setInterest_changed, setInterest_setChanged] = (0, $acw62.useState)(false);
    const submitSurgeryRequest = (0, $aa2f325cf629321d$export$ed440454d2008047)();
    const [submitSurgeryRequest_done, submitSurgeryRequest_setDone] = (0, $acw62.useState)(false);
    const Section = fullScreen ? 'main' : 'div';
    const H = fullScreen ? 'h1' : 'h2';
    const user = (0, $d7de34ca5c825acf$export$73fc7af4ef9455f4)();
    const defaultInterest = interest ?? $6d5c4593748dcb71$var$DEFAULT_INTEREST;
    const [currentProcedures, setCurrentProcedures] = (0, $acw62.useState)(defaultInterest.procedures);
    const [currentWhen, setCurrentWhen] = (0, $acw62.useState)(defaultInterest.when);
    const currentTotal = $6d5c4593748dcb71$var$PROCEDURES_FLAT.filter((p)=>currentProcedures.has(p.name)).map((p)=>p.costPLN).reduce((acc, v)=>[
            acc[0] + v[0],
            acc[1] + v[1],
            [
                ...acc[2] ?? [],
                ...v[2] ?? []
            ]
        ], [
        0,
        0
    ]);
    if (interest === undefined) return;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(Section, {
        children: [
            fullScreen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a59113ba74a90868$export$f7bfe31b45496d55), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        children: "Gender-affirming surgeries"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: 'We understand that planning gender-affirming surgery can feel overwhelming, and we\u2019re here to make the process as clear and reassuring as possible. Our Surgery Calculator is designed to give you a realistic idea of costs (all prices are listed as "starting from", as the final cost always depends on individual evaluation).'
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "If you're unsure exactly what procedures you need - or if you're concerned about making the \"wrong\" choice - don\u2019t worry! Many people start with a general idea and refine their plan through expert guidance. This tool is here to help you explore, not to pressure you into a decision. Remember, your choices are not binding."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "Once you\u2019ve reviewed your estimate, you can save it for later or send a request to book a consultation, where specialists will help tailor everything to your unique goals. Take your time, explore your options, and know that you\u2019re in good hands every step of the way. "
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        children: "Cost calculator"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                        onChange: (ev)=>{
                            const data = new FormData(ev.currentTarget);
                            setCurrentProcedures(new Set([
                                ...data.keys()
                            ].filter((k)=>k !== 'when')));
                            setCurrentWhen(data.get('when'));
                            setInterest_setChanged(true);
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hgroup", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                            children: "Which procedures am I interested in?"
                                        })
                                    }),
                                    $6d5c4593748dcb71$var$PROCEDURES.map((group, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                                    children: group.name
                                                }),
                                                group.content.map((subgroup, j)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                                                        children: [
                                                            subgroup.name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                                                children: subgroup.name
                                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                                                    children: subgroup.content.map((proc, k)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                    style: {
                                                                                        flex: '0 auto'
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                                        type: "checkbox",
                                                                                        id: proc.name,
                                                                                        name: proc.name,
                                                                                        defaultChecked: defaultInterest.procedures.has(proc.name)
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                                        htmlFor: proc.name,
                                                                                        children: proc.name
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                    style: {
                                                                                        flex: '0 auto',
                                                                                        textAlign: 'right'
                                                                                    },
                                                                                    children: $6d5c4593748dcb71$var$formatPriceRange(proc.costPLN)
                                                                                })
                                                                            ]
                                                                        }, k))
                                                                })
                                                            })
                                                        ]
                                                    }, j))
                                            ]
                                        }, i)),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h5", {
                                        style: {
                                            display: 'flex',
                                            flexFlow: 'row'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                style: {
                                                    flex: '1'
                                                },
                                                children: "Total"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: currentTotal[0] ? $6d5c4593748dcb71$var$formatPriceRange(currentTotal) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hgroup", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                            children: "When do I want to get the procedures done?"
                                        })
                                    }),
                                    $6d5c4593748dcb71$var$WHEN_OPTIONS.map((option, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "radio",
                                                    name: "when",
                                                    value: option,
                                                    defaultChecked: defaultInterest.when === option
                                                }),
                                                " ",
                                                option
                                            ]
                                        }, i))
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$8b7b7cdfb85d78c5), {
                                mutation: setInterest,
                                vars: (data)=>({
                                        procedures: currentProcedures,
                                        when: currentWhen,
                                        totalPrice: $6d5c4593748dcb71$var$formatPriceRange(currentTotal)
                                    }),
                                onSuccess: ()=>setInterest_setChanged(false),
                                disabledBecause: !setInterest_changed ? "Unchanged." : undefined,
                                children: setInterest_changed ? "Save" : "Saved."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        children: "Book a surgery"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hgroup", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                            children: "Your details"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        id: "your-details",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: "Your chosen first name"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "text",
                                                        name: "shortName",
                                                        defaultValue: user.shortName,
                                                        required: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: "Your pronouns"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "text",
                                                        name: "pronouns",
                                                        defaultValue: user.pronouns,
                                                        required: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: "Your email"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "email",
                                                        name: "email",
                                                        required: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: "Your phone number"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "tel",
                                                        name: "phone"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("fieldset", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Any comments?"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$8b7b7cdfb85d78c5), {
                                mutation: submitSurgeryRequest,
                                vars: (data)=>({
                                        quote: {
                                            procedures: currentProcedures,
                                            when: currentWhen,
                                            totalPrice: $6d5c4593748dcb71$var$formatPriceRange(currentTotal)
                                        },
                                        comments: data.get('comments') ?? '',
                                        patient: {
                                            shortName: data.get('shortName') ?? '',
                                            pronouns: data.get('pronouns') ?? '',
                                            email: data.get('email') ?? '',
                                            phone: data.get('phone') ?? ''
                                        }
                                    }),
                                onSuccess: ()=>submitSurgeryRequest_setDone(true),
                                disabledBecause: submitSurgeryRequest_done ? "Already sent." : undefined,
                                children: submitSurgeryRequest_done ? "Sent." : "Send a request to Hospittal"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "Hospittal will respond within 7 days from receiving your application. Your personal concierge will be appointed at this stage to support you during the whole process."
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");




function $325393b18bad7108$export$adccb981c6e2576d() {
    const user = (0, $d7de34ca5c825acf$export$73fc7af4ef9455f4)();
    const [yourDetailsShown, setYourDetailsShown] = (0, $acw62.useState)(false);
    const [legalDetailsShown, setLegalDetailsShown] = (0, $acw62.useState)(false);
    const signOut = (0, $f80eb65c55aee8de$export$68089b5bbafb026b)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a59113ba74a90868$export$f7bfe31b45496d55), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        children: "Account settings"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("hgroup", {
                                "aria-controls": "your-details",
                                onClick: (ev)=>{
                                    if (ev.defaultPrevented) return;
                                    ev.preventDefault();
                                    setYourDetailsShown(!yourDetailsShown);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                        children: "Your details"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        role: "toolbar",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "material-symbols-outlined",
                                                children: !yourDetailsShown ? 'keyboard_arrow_down' : 'keyboard_arrow_up'
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                id: "your-details",
                                hidden: !yourDetailsShown,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Your chosen first name"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "text",
                                                value: user.shortName,
                                                readOnly: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Your pronouns"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "text",
                                                value: user.pronouns,
                                                readOnly: true
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("hgroup", {
                                "aria-controls": "legal-details",
                                onClick: (ev)=>{
                                    if (ev.defaultPrevented) return;
                                    ev.preventDefault();
                                    setLegalDetailsShown(!legalDetailsShown);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                        children: "Legal details"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        role: "toolbar",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "material-symbols-outlined",
                                                children: !legalDetailsShown ? 'keyboard_arrow_down' : 'keyboard_arrow_up'
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                id: "legal-details",
                                hidden: !legalDetailsShown,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Your legal name"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "text",
                                                value: user.legalName,
                                                readOnly: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Date of birth"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "date",
                                                value: user.dateOfBirth.toString(),
                                                readOnly: true
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c5985b33d50e3659$export$f56232a4a0c007ba), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$857ebcebc4ae5918), {
                        mutation: signOut,
                        children: "Sign out"
                    })
                ]
            })
        ]
    });
}










var $acw62 = parcelRequire("acw62");
var $9b91a1695881f364$exports = {};
$9b91a1695881f364$exports = import.meta.resolve("3vSRz");


function $511f12282758d0f5$export$e5e6be0a1e7826f() {
    const installApp = (0, $9019f8b149ea5d03$export$bc1021199b2ef019)();
    const [_, setBannerJustClosed] = (0, $acw62.useState)(false);
    const bannerClosed = localStorage.getItem('app-banner-closed');
    const closeBanner = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        async mutationFn () {
            localStorage.setItem('app-banner-closed', (0, $5d669742300defa8$export$336849d529cb05e5).Now.instant().toString());
        }
    });
    return installApp && bannerClosed === null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
        className: "app-install banner",
        role: "status",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("hgroup", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: new URL($9b91a1695881f364$exports).toString(),
                    height: 32,
                    style: {
                        borderRadius: '8px'
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "Imago app"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    role: "toolbar",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$857ebcebc4ae5918), {
                            className: "low-prio",
                            mutation: installApp,
                            children: "Install"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$857ebcebc4ae5918), {
                            className: "low-prio",
                            mutation: closeBanner,
                            onSuccess: ()=>setBannerJustClosed(true),
                            children: "Dismiss"
                        })
                    ]
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
}
function $511f12282758d0f5$export$721ddba266dcb268() {
    const reloadApp = (0, $9019f8b149ea5d03$export$a914cc583649c1ff)();
    return reloadApp ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
        className: "app-update banner",
        role: "status",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("hgroup", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "You are using out of date app."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    role: "toolbar",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8600c5f9d86d8c95$export$857ebcebc4ae5918), {
                        className: "low-prio",
                        mutation: reloadApp,
                        children: "Reload"
                    })
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
}


function $51953425ccf4a998$export$f670dcb50cfb335b() {
    const profile = (0, $d7de34ca5c825acf$export$73fc7af4ef9455f4)();
    if (profile === undefined) return;
    return !profile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $80b0682ebef62618$export$157c131647dc68e), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($51953425ccf4a998$var$RegisteredPatientsApp, {});
}
const $51953425ccf4a998$export$9a1b410c76d0e146 = /*#__PURE__*/ (0, $acw62.createContext)('');
function $51953425ccf4a998$var$RegisteredPatientsApp() {
    const location = (0, $2f76402fda74d87d$export$45d76561a5302f2b)();
    const page = location.pathname.substring(1);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($51953425ccf4a998$export$9a1b410c76d0e146, {
            value: page,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($51953425ccf4a998$var$_RegisteredPatientsApp, {})
        })
    });
}
function $51953425ccf4a998$var$_RegisteredPatientsApp() {
    (0, $acw62.useEffect)(()=>{
        document.documentElement.classList.remove('light-only');
    }, []);
    const over18 = (0, $d7de34ca5c825acf$export$493bff358814b51e)();
    const page = (0, $acw62.useContext)($51953425ccf4a998$export$9a1b410c76d0e146);
    const installApp = (0, $9019f8b149ea5d03$export$bc1021199b2ef019)();
    const config = (0, $1068f99e90f736b6$export$b3611e87cd5ba6ce)();
    const topLevelPage = page.split('/')[0];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $511f12282758d0f5$export$e5e6be0a1e7826f), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                id: "tab-container",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("nav", {
                        role: "tablist",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8600c5f9d86d8c95$export$cda51eb07c9d035c), {
                                href: "/",
                                role: "tab",
                                "aria-selected": topLevelPage === '' ? true : undefined,
                                "aria-controls": "home",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "material-symbols-outlined",
                                        children: "home"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Home"
                                    })
                                ]
                            }),
                            over18 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8600c5f9d86d8c95$export$cda51eb07c9d035c), {
                                    href: "/community",
                                    role: "tab",
                                    "aria-selected": topLevelPage === 'community' ? true : undefined,
                                    "aria-controls": "community",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "material-symbols-outlined",
                                            children: "diversity_3"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Community"
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8600c5f9d86d8c95$export$cda51eb07c9d035c), {
                                href: "/gaht",
                                role: "tab",
                                "aria-selected": topLevelPage === 'gaht' ? true : undefined,
                                "aria-controls": "gaht",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "material-symbols-outlined",
                                        children: "medical_services"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "GAHT"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8600c5f9d86d8c95$export$cda51eb07c9d035c), {
                                href: "/services",
                                role: "tab",
                                "aria-selected": topLevelPage === 'services' ? true : undefined,
                                "aria-controls": "services",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "material-symbols-outlined",
                                        children: "call"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Services"
                                    })
                                ]
                            }),
                            config.enableSurgeries ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8600c5f9d86d8c95$export$cda51eb07c9d035c), {
                                    href: "/surgeries",
                                    role: "tab",
                                    "aria-selected": topLevelPage === 'surgeries' ? true : undefined,
                                    "aria-controls": "surgeries",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "material-symbols-outlined",
                                            children: "surgical"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Surgeries"
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "only-on-medium-plus",
                                style: {
                                    flex: '1'
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8600c5f9d86d8c95$export$857ebcebc4ae5918), {
                                role: "tab",
                                className: "only-on-medium-plus",
                                mutation: installApp,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "material-symbols-outlined",
                                        children: (0, $9019f8b149ea5d03$export$1c052fd244acfcc8)()
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Install app"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        id: "tabs",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                id: "home",
                                role: "tabpanel",
                                hidden: topLevelPage !== '',
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $332fc48e7a53d650$export$b94310965bed44e6), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                id: "community",
                                role: "tabpanel",
                                hidden: topLevelPage !== 'community',
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c79b87a32f9e12f6$export$654b1de62462a88d), {
                                    fullScreen: true
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                id: "gaht",
                                role: "tabpanel",
                                hidden: topLevelPage !== 'gaht',
                                "data-subpage-open": page.startsWith('gaht/') ? true : undefined,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b75baa31af28b32d$export$48d2aefce51a6ea1), {
                                    fullScreen: true
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                id: "services",
                                role: "tabpanel",
                                hidden: topLevelPage !== 'services',
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $956ff62d7763a99c$export$c447b0cdbd1cd184), {
                                    fullScreen: true
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                id: "surgeries",
                                role: "tabpanel",
                                hidden: topLevelPage !== 'surgeries',
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6d5c4593748dcb71$export$8166fc09a9bd588b), {
                                    fullScreen: true
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                id: "account",
                                role: "tabpanel",
                                hidden: topLevelPage !== 'account',
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $325393b18bad7108$export$adccb981c6e2576d), {})
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $acw62 = parcelRequire("acw62");

// This is a magic string replaced by rollup
const $b0bfa51115099518$export$31499a9cd224b78c = "9.12.0";


/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $1a40e26460b4422e$export$f1a6cdb1459e81d1 = globalThis;


/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $db00931c27c5ec41$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $db00931c27c5ec41$export$c8bfa33e4e8ae492((0, $1a40e26460b4422e$export$f1a6cdb1459e81d1));
    return 0, $1a40e26460b4422e$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $db00931c27c5ec41$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $b0bfa51115099518$export$31499a9cd224b78c);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $b0bfa51115099518$export$31499a9cd224b78c] = __SENTRY__[0, $b0bfa51115099518$export$31499a9cd224b78c] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $db00931c27c5ec41$export$7e223ec222791509(name, creator, obj = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $b0bfa51115099518$export$31499a9cd224b78c] = __SENTRY__[0, $b0bfa51115099518$export$31499a9cd224b78c] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}






const $4f6ba265374890ec$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $4f6ba265374890ec$export$7740643b9eeaf0c4() {
    return Date.now() / $4f6ba265374890ec$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $4f6ba265374890ec$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
    if (!performance?.now) return $4f6ba265374890ec$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $4f6ba265374890ec$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $4f6ba265374890ec$export$ee52dced521e3e18 = $4f6ba265374890ec$var$createUnixTimestampInSecondsFunc();
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $4f6ba265374890ec$var$cachedTimeOrigin;
/**
 * Gets the time origin and the mode used to determine it.
 */ function $4f6ba265374890ec$var$getBrowserTimeOrigin() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
    if (!performance?.now) return [
        undefined,
        'none'
    ];
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) return [
            performance.timeOrigin,
            'timeOrigin'
        ];
        else return [
            navigationStart,
            'navigationStart'
        ];
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    return [
        dateNow,
        'dateNow'
    ];
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $4f6ba265374890ec$export$baf075a948ffc0bf() {
    if (!$4f6ba265374890ec$var$cachedTimeOrigin) $4f6ba265374890ec$var$cachedTimeOrigin = $4f6ba265374890ec$var$getBrowserTimeOrigin();
    return $4f6ba265374890ec$var$cachedTimeOrigin[0];
}


// eslint-disable-next-line @typescript-eslint/unbound-method
const $9a62450b4f3c2c3b$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$e6127cc7fe7395c3(wat) {
    switch($9a62450b4f3c2c3b$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$var$isBuiltin(wat, className) {
    return $9a62450b4f3c2c3b$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$9f9636d330b71954(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$ef9e2056653f0c8e(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$12e869b2a583f783(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$844ec244b1367d54(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$c3825b437cbdea5c(wat) {
    return wat === null || $9a62450b4f3c2c3b$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$53b83ca8eaab0383(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$49841c62b9eff15(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $9a62450b4f3c2c3b$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$bc2894c7158efbac(wat) {
    return $9a62450b4f3c2c3b$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $9a62450b4f3c2c3b$export$6d3d1f317d7cda57(request) {
    return typeof Request !== 'undefined' && $9a62450b4f3c2c3b$export$49034edbe6b62415(request, Request);
}



const $cccaafc2216668b2$var$WINDOW = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
const $cccaafc2216668b2$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $cccaafc2216668b2$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $cccaafc2216668b2$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $cccaafc2216668b2$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $cccaafc2216668b2$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($cccaafc2216668b2$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $cccaafc2216668b2$export$1cfafeee2987818b() {
    try {
        return $cccaafc2216668b2$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $cccaafc2216668b2$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$cccaafc2216668b2$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $18144a665bc8acf7$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;






/** Prefix for logging strings */ const $c9674f9e04798056$var$PREFIX = 'Sentry Logger ';
const $c9674f9e04798056$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $c9674f9e04798056$export$77c4ce905194557b = {};
/** A Sentry Logger instance. */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $c9674f9e04798056$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($c9674f9e04798056$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $c9674f9e04798056$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $c9674f9e04798056$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $18144a665bc8acf7$export$16a28057038b10ef) $c9674f9e04798056$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = (...args)=>{
            if (enabled) $c9674f9e04798056$export$cda52e2a8927a2ca(()=>{
                (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).console[name](`${$c9674f9e04798056$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $c9674f9e04798056$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $c9674f9e04798056$export$af88d00dbe7f521 = (0, $db00931c27c5ec41$export$7e223ec222791509)('logger', $c9674f9e04798056$var$makeLogger);



/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $cee8faa76567523a$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $cee8faa76567523a$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $cee8faa76567523a$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $9a62450b4f3c2c3b$export$7916fad0ebc23f48)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $cee8faa76567523a$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(value)) return false;
    if ((0, $9a62450b4f3c2c3b$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $cee8faa76567523a$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$cee8faa76567523a$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $f4dd084fe83374eb$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== 'function') return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $f4dd084fe83374eb$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $f4dd084fe83374eb$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $f4dd084fe83374eb$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $f4dd084fe83374eb$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $f4dd084fe83374eb$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $f4dd084fe83374eb$export$62ff257738bf57f5(value) {
    if ((0, $9a62450b4f3c2c3b$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$f4dd084fe83374eb$var$getOwnProperties(value)
    };
    else if ((0, $9a62450b4f3c2c3b$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $f4dd084fe83374eb$var$serializeEventTarget(value.target),
            currentTarget: $f4dd084fe83374eb$var$serializeEventTarget(value.currentTarget),
            ...$f4dd084fe83374eb$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $9a62450b4f3c2c3b$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $f4dd084fe83374eb$var$serializeEventTarget(target) {
    try {
        return (0, $9a62450b4f3c2c3b$export$45a5e7f76e0caa8d)(target) ? (0, $cccaafc2216668b2$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $f4dd084fe83374eb$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $f4dd084fe83374eb$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($f4dd084fe83374eb$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return '[object has no keys]';
    if (firstKey.length >= maxLength) return (0, $cee8faa76567523a$export$6a506b36fdea397d)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $cee8faa76567523a$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $f4dd084fe83374eb$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $f4dd084fe83374eb$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $f4dd084fe83374eb$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== 'object') return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($f4dd084fe83374eb$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($f4dd084fe83374eb$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $f4dd084fe83374eb$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $f4dd084fe83374eb$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $f4dd084fe83374eb$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $9a62450b4f3c2c3b$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




function $4f55103f4332a5b0$var$getCrypto() {
    const gbl = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $4f55103f4332a5b0$export$19f53698e68b2496(crypto = $4f55103f4332a5b0$var$getCrypto()) {
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto?.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto?.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $4f55103f4332a5b0$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $4f55103f4332a5b0$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $4f55103f4332a5b0$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $4f55103f4332a5b0$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $4f55103f4332a5b0$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $4f55103f4332a5b0$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $4f55103f4332a5b0$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $4f55103f4332a5b0$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $4f55103f4332a5b0$export$d364f2020ab30578(input) {
    const match = input.match($4f55103f4332a5b0$var$SEMVER_REGEXP) || [];
    const major = $4f55103f4332a5b0$var$_parseInt(match[1]);
    const minor = $4f55103f4332a5b0$var$_parseInt(match[2]);
    const patch = $4f55103f4332a5b0$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $4f55103f4332a5b0$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $cee8faa76567523a$export$4215662d762d6f9d)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $cee8faa76567523a$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $cee8faa76567523a$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $4f55103f4332a5b0$export$6de4ffac6a2f1098(exception) {
    if ($4f55103f4332a5b0$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $4f55103f4332a5b0$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}



/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $ecc06dd71ed8ff5f$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $4f55103f4332a5b0$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$ecc06dd71ed8ff5f$var$sessionToJSON(session)
    };
    if (context) $ecc06dd71ed8ff5f$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $ecc06dd71ed8ff5f$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $ecc06dd71ed8ff5f$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $ecc06dd71ed8ff5f$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $ecc06dd71ed8ff5f$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}






/**
 * Generate a random, valid trace ID.
 */ function $dc99b4184ec29e47$export$dc6d7ea554bcce10() {
    return (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
}
/**
 * Generate a random, valid span ID.
 */ function $dc99b4184ec29e47$export$295213bc4d0c54ad() {
    return (0, $4f55103f4332a5b0$export$19f53698e68b2496)().substring(16);
}




/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $05f9869a4b646370$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $05f9869a4b646370$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}



const $99af9a2b040631ba$var$SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $99af9a2b040631ba$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(scope, $99af9a2b040631ba$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$99af9a2b040631ba$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $99af9a2b040631ba$export$91f063ebb8eff307(scope) {
    return scope[$99af9a2b040631ba$var$SCOPE_SPAN_FIELD];
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $33c387bb26fe522d$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $33c387bb26fe522d$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $dc99b4184ec29e47$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $33c387bb26fe522d$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(newScope, (0, $99af9a2b040631ba$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $ecc06dd71ed8ff5f$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $33c387bb26fe522d$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $9a62450b4f3c2c3b$export$53b83ca8eaab0383)(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $dc99b4184ec29e47$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $33c387bb26fe522d$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $4f6ba265374890ec$export$7740643b9eeaf0c4)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $cee8faa76567523a$export$6a506b36fdea397d)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent('buffer_overflow', 'log_item');
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $99af9a2b040631ba$export$91f063ebb8eff307)(this)
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $05f9869a4b646370$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint?.event_id || (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}


/** Get the default current scope. */ function $4354bb0fac58a6e0$export$6f1b9191db9c4d5() {
    return (0, $db00931c27c5ec41$export$7e223ec222791509)('defaultCurrentScope', ()=>new (0, $33c387bb26fe522d$export$775b6bb06e53a214)());
}
/** Get the default isolation scope. */ function $4354bb0fac58a6e0$export$de9862929b76bf57() {
    return (0, $db00931c27c5ec41$export$7e223ec222791509)('defaultIsolationScope', ()=>new (0, $33c387bb26fe522d$export$775b6bb06e53a214)());
}





/**
 * This is an object that holds a stack of scopes.
 */ class $ab23dab597a507b7$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $33c387bb26fe522d$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $33c387bb26fe522d$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $9a62450b4f3c2c3b$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $ab23dab597a507b7$var$getAsyncContextStack() {
    const registry = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const sentry = (0, $db00931c27c5ec41$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $ab23dab597a507b7$export$d36ec451f120cfba((0, $4354bb0fac58a6e0$export$6f1b9191db9c4d5)(), (0, $4354bb0fac58a6e0$export$de9862929b76bf57)());
}
function $ab23dab597a507b7$var$withScope(callback) {
    return $ab23dab597a507b7$var$getAsyncContextStack().withScope(callback);
}
function $ab23dab597a507b7$var$withSetScope(scope, callback) {
    const stack = $ab23dab597a507b7$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $ab23dab597a507b7$var$withIsolationScope(callback) {
    return $ab23dab597a507b7$var$getAsyncContextStack().withScope(()=>{
        return callback($ab23dab597a507b7$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $ab23dab597a507b7$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $ab23dab597a507b7$var$withIsolationScope,
        withScope: $ab23dab597a507b7$var$withScope,
        withSetScope: $ab23dab597a507b7$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $ab23dab597a507b7$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$ab23dab597a507b7$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$ab23dab597a507b7$var$getAsyncContextStack().getIsolationScope()
    };
}


/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $5cec0a7bd2540b32$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const sentry = (0, $db00931c27c5ec41$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $5cec0a7bd2540b32$export$f639b0c2752203be(carrier) {
    const sentry = (0, $db00931c27c5ec41$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $ab23dab597a507b7$export$329d4d4d54e42710)();
}









/**
 * Get the currently active scope.
 */ function $f106fce27ec076f7$export$c7be4b0125a10cba() {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $f106fce27ec076f7$export$68f3af03034c9e90() {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $f106fce27ec076f7$export$aa55d5ab8e05984f() {
    return (0, $db00931c27c5ec41$export$7e223ec222791509)('globalScope', ()=>new (0, $33c387bb26fe522d$export$775b6bb06e53a214)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $f106fce27ec076f7$export$ec58d9285c204497(...rest) {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $f106fce27ec076f7$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $f106fce27ec076f7$export$6bb76d6eba7e258c() {
    return $f106fce27ec076f7$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $f106fce27ec076f7$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $dc99b4184ec29e47$export$295213bc4d0c54ad)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $b776c95debaa4af0$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



const $fbb22756c9507e85$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $fbb22756c9507e85$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $fbb22756c9507e85$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $fbb22756c9507e85$var$filterDuplicates(integrations);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $fbb22756c9507e85$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $fbb22756c9507e85$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $fbb22756c9507e85$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $fbb22756c9507e85$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($fbb22756c9507e85$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === 'function') {
        integration.setupOnce();
        $fbb22756c9507e85$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $fbb22756c9507e85$export$2d8f5188773bcddd(integration) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $fbb22756c9507e85$export$2323046b9414659f(fn) {
    return fn;
}




const $4010ef0d9b3761f9$var$STACKTRACE_FRAME_LIMIT = 50;
const $4010ef0d9b3761f9$export$27c7e15d453fc0ac = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $4010ef0d9b3761f9$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $4010ef0d9b3761f9$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $4010ef0d9b3761f9$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $4010ef0d9b3761f9$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($4010ef0d9b3761f9$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $4010ef0d9b3761f9$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $4010ef0d9b3761f9$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $4010ef0d9b3761f9$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $4010ef0d9b3761f9$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $4010ef0d9b3761f9$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($4010ef0d9b3761f9$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($4010ef0d9b3761f9$var$STRIP_FRAME_REGEXP.test($4010ef0d9b3761f9$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($4010ef0d9b3761f9$var$STRIP_FRAME_REGEXP.test($4010ef0d9b3761f9$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $4010ef0d9b3761f9$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $4010ef0d9b3761f9$var$getLastStackFrame(localStack).filename,
            function: frame.function || $4010ef0d9b3761f9$export$27c7e15d453fc0ac
        }));
}
function $4010ef0d9b3761f9$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $4010ef0d9b3761f9$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $4010ef0d9b3761f9$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $4010ef0d9b3761f9$var$defaultFunctionName;
        return fn.name || $4010ef0d9b3761f9$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $4010ef0d9b3761f9$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $4010ef0d9b3761f9$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}


const $b99d5bb3db344fdd$var$INTEGRATION_NAME = 'Dedupe';
const $b99d5bb3db344fdd$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $b99d5bb3db344fdd$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($b99d5bb3db344fdd$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $b99d5bb3db344fdd$export$6d39aa44cd0c7567 = (0, $fbb22756c9507e85$export$2323046b9414659f)($b99d5bb3db344fdd$var$_dedupeIntegration);
/** only exported for tests. */ function $b99d5bb3db344fdd$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($b99d5bb3db344fdd$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($b99d5bb3db344fdd$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $b99d5bb3db344fdd$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $b99d5bb3db344fdd$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $b99d5bb3db344fdd$var$_getExceptionFromEvent(previousEvent);
    const currentException = $b99d5bb3db344fdd$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $4010ef0d9b3761f9$export$91d8ca51bd9f6a47)(currentEvent);
    let previousFrames = (0, $4010ef0d9b3761f9$export$91d8ca51bd9f6a47)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $b99d5bb3db344fdd$var$_getExceptionFromEvent(event) {
    return event.exception?.values && event.exception.values[0];
}




let $7dd448759c7f5e18$var$originalFunctionToString;
const $7dd448759c7f5e18$var$INTEGRATION_NAME = 'FunctionToString';
const $7dd448759c7f5e18$var$SETUP_CLIENTS = new WeakMap();
const $7dd448759c7f5e18$var$_functionToStringIntegration = ()=>{
    return {
        name: $7dd448759c7f5e18$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $7dd448759c7f5e18$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $f4dd084fe83374eb$export$e6cc1e135e2092e5)(this);
                    const context = $7dd448759c7f5e18$var$SETUP_CLIENTS.has((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $7dd448759c7f5e18$var$originalFunctionToString.apply(context, args);
                };
            } catch  {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $7dd448759c7f5e18$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $7dd448759c7f5e18$export$7918117e9202e4fb = (0, $fbb22756c9507e85$export$2323046b9414659f)($7dd448759c7f5e18$var$_functionToStringIntegration);



/** Regular expression used to parse a Dsn. */ const $9171e4713e443b9b$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $9171e4713e443b9b$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $9171e4713e443b9b$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $9171e4713e443b9b$export$b892860177f70a30(str) {
    const match = $9171e4713e443b9b$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $c9674f9e04798056$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host = '', port = '', lastPath = ''] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $9171e4713e443b9b$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $9171e4713e443b9b$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $9171e4713e443b9b$var$validateDsn(dsn) {
    if (!(0, $18144a665bc8acf7$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$9171e4713e443b9b$var$isValidProtocol(protocol)) {
        (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $9171e4713e443b9b$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $9171e4713e443b9b$export$b892860177f70a30(from) : $9171e4713e443b9b$var$dsnFromComponents(from);
    if (!components || !$9171e4713e443b9b$var$validateDsn(components)) return undefined;
    return components;
}


const $0e303f054920e2b1$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $0e303f054920e2b1$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $0e303f054920e2b1$var$_getIngestEndpoint(dsn) {
    return `${$0e303f054920e2b1$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $0e303f054920e2b1$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $0e303f054920e2b1$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $0e303f054920e2b1$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$0e303f054920e2b1$var$_getIngestEndpoint(dsn)}?${$0e303f054920e2b1$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $0e303f054920e2b1$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $9171e4713e443b9b$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$0e303f054920e2b1$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}






/**
 * Get a list of possible event messages from a Sentry event.
 */ function $e5904939f3a5a4e3$export$d55a97c329cacfcc(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        // @ts-expect-error Try catching to save bundle size
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch (e) {
    // ignore errors here
    }
    return possibleMessages;
}


// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $42e5926860cf11cf$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    /^Can't find variable: gmo$/,
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler",
    /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/,
    /^Java exception was raised during method invocation$/
];
/** Options for the EventFilters integration */ const $42e5926860cf11cf$var$INTEGRATION_NAME = 'EventFilters';
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 */ const $42e5926860cf11cf$export$9a84f518c163c552 = (0, $fbb22756c9507e85$export$2323046b9414659f)((options = {})=>{
    let mergedOptions;
    return {
        name: $42e5926860cf11cf$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $42e5926860cf11cf$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $42e5926860cf11cf$var$_mergeOptions(options, clientOptions);
            }
            return $42e5926860cf11cf$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 *
 * @deprecated this integration was renamed and will be removed in a future major version.
 * Use `eventFiltersIntegration` instead.
 */ const $42e5926860cf11cf$export$cb3c5c2ceb9818ba = (0, $fbb22756c9507e85$export$2323046b9414659f)((options = {})=>{
    return {
        ...$42e5926860cf11cf$export$9a84f518c163c552(options),
        name: 'InboundFilters'
    };
});
function $42e5926860cf11cf$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $42e5926860cf11cf$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $42e5926860cf11cf$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        // Filter errors
        if ($42e5926860cf11cf$var$_isIgnoredError(event, options.ignoreErrors)) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($42e5926860cf11cf$var$_isUselessError(event)) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($42e5926860cf11cf$var$_isDeniedUrl(event, options.denyUrls)) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}.\nUrl: ${$42e5926860cf11cf$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$42e5926860cf11cf$var$_isAllowedUrl(event, options.allowUrls)) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}.\nUrl: ${$42e5926860cf11cf$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === 'transaction') // Filter transactions
    {
        if ($42e5926860cf11cf$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}`);
            return true;
        }
    }
    return false;
}
function $42e5926860cf11cf$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return (0, $e5904939f3a5a4e3$export$d55a97c329cacfcc)(event).some((message)=>(0, $cee8faa76567523a$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $42e5926860cf11cf$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? (0, $cee8faa76567523a$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $42e5926860cf11cf$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $42e5926860cf11cf$var$_getEventFilterUrl(event);
    return !url ? false : (0, $cee8faa76567523a$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $42e5926860cf11cf$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $42e5926860cf11cf$var$_getEventFilterUrl(event);
    return !url ? true : (0, $cee8faa76567523a$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $42e5926860cf11cf$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $42e5926860cf11cf$var$_getEventFilterUrl(event) {
    try {
        // If there are linked exceptions or exception aggregates we only want to match against the top frame of the "root" (the main exception)
        // The root always comes last in linked exceptions
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === undefined && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $42e5926860cf11cf$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}`);
        return null;
    }
}
function $42e5926860cf11cf$var$_isUselessError(event) {
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== 'Error' || value.value));
}




/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $9af71b6a24a126c8$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $b776c95debaa4af0$export$16a28057038b10ef) (0, $c9674f9e04798056$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $c9674f9e04798056$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $9af71b6a24a126c8$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $9af71b6a24a126c8$export$ecb76f41d43c0e43(client) {
    (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().setClient(client);
}









const $3592a0510b526070$export$849dbeeeda01ae98 = 'production';







/* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var $9ad49a0639c06d33$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($9ad49a0639c06d33$var$States || ($9ad49a0639c06d33$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $9ad49a0639c06d33$export$1fda8aa4d135f8aa(value) {
    return new $9ad49a0639c06d33$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $9ad49a0639c06d33$export$78e43115b553f358(reason) {
    return new $9ad49a0639c06d33$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $9ad49a0639c06d33$export$6f292d4960313241 {
    constructor(executor){
        this._state = $9ad49a0639c06d33$var$States.PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $9ad49a0639c06d33$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $9ad49a0639c06d33$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $9ad49a0639c06d33$var$States.PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $9ad49a0639c06d33$var$States.RESOLVED) handler[1](this._value);
            if (this._state === $9ad49a0639c06d33$var$States.REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $9ad49a0639c06d33$var$States.PENDING) return;
            if ((0, $9a62450b4f3c2c3b$export$f5b060c2914b97c8)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($9ad49a0639c06d33$var$States.RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($9ad49a0639c06d33$var$States.REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}


/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $fa62667502ab5c7a$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $9ad49a0639c06d33$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && processor.id && result === null && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $9a62450b4f3c2c3b$export$f5b060c2914b97c8)(result)) result.then((final)=>$fa62667502ab5c7a$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $fa62667502ab5c7a$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}




let $107941ce73c7a34f$var$parsedStackResults;
let $107941ce73c7a34f$var$lastKeysCount;
let $107941ce73c7a34f$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 */ function $107941ce73c7a34f$export$e069fee9c632ed00(stackParser) {
    const debugIdMap = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return {};
    const debugIdKeys = Object.keys(debugIdMap);
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($107941ce73c7a34f$var$cachedFilenameDebugIds && debugIdKeys.length === $107941ce73c7a34f$var$lastKeysCount) return $107941ce73c7a34f$var$cachedFilenameDebugIds;
    $107941ce73c7a34f$var$lastKeysCount = debugIdKeys.length;
    // Build a map of filename -> debug_id.
    $107941ce73c7a34f$var$cachedFilenameDebugIds = debugIdKeys.reduce((acc, stackKey)=>{
        if (!$107941ce73c7a34f$var$parsedStackResults) $107941ce73c7a34f$var$parsedStackResults = {};
        const result = $107941ce73c7a34f$var$parsedStackResults[stackKey];
        if (result) acc[result[0]] = result[1];
        else {
            const parsedStack = stackParser(stackKey);
            for(let i = parsedStack.length - 1; i >= 0; i--){
                const stackFrame = parsedStack[i];
                const filename = stackFrame?.filename;
                const debugId = debugIdMap[stackKey];
                if (filename && debugId) {
                    acc[filename] = debugId;
                    $107941ce73c7a34f$var$parsedStackResults[stackKey] = [
                        filename,
                        debugId
                    ];
                    break;
                }
            }
        }
        return acc;
    }, {});
    return $107941ce73c7a34f$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $107941ce73c7a34f$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $107941ce73c7a34f$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: 'sourcemap',
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}






/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5eb42146e0d2c9ef$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $5eb42146e0d2c9ef$var$visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $5eb42146e0d2c9ef$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $5eb42146e0d2c9ef$export$a3295358bff77e(object, depth);
    if ($5eb42146e0d2c9ef$var$jsonSize(normalized) > maxSize) return $5eb42146e0d2c9ef$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $5eb42146e0d2c9ef$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $5eb42146e0d2c9ef$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value) || typeof value === 'number' && Number.isFinite(value)) return value;
    const stringified = $5eb42146e0d2c9ef$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $5eb42146e0d2c9ef$var$visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $f4dd084fe83374eb$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $5eb42146e0d2c9ef$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $5eb42146e0d2c9ef$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $9a62450b4f3c2c3b$export$7916fad0ebc23f48)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $9a62450b4f3c2c3b$export$bc2894c7158efbac)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === 'function') return `[Function: ${(0, $4010ef0d9b3761f9$export$aad197c7121a6651)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $5eb42146e0d2c9ef$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $5eb42146e0d2c9ef$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $5eb42146e0d2c9ef$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5eb42146e0d2c9ef$var$jsonSize(value) {
    return $5eb42146e0d2c9ef$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $5eb42146e0d2c9ef$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}
/**
 * Helper to decycle json objects
 */ function $5eb42146e0d2c9ef$var$memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}






/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $068c396dceb690a1$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const $068c396dceb690a1$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $068c396dceb690a1$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $068c396dceb690a1$export$cca8dd30f57f805e = 'sentry.origin';
/** The reason why an idle span finished. */ const $068c396dceb690a1$export$ba73f34502b7a3b3 = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $068c396dceb690a1$export$f5f95cff026507b5 = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ const $068c396dceb690a1$export$69cd5c610c7bb96a = 'sentry.measurement_value';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $068c396dceb690a1$export$165ce9a229f6f050 = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ const $068c396dceb690a1$export$1efec95406bbe327 = 'sentry.profile_id';
const $068c396dceb690a1$export$fea48ba9f4550879 = 'sentry.exclusive_time';
const $068c396dceb690a1$export$b016f89ac1066ec = 'cache.hit';
const $068c396dceb690a1$export$3110e4c3f4386399 = 'cache.key';
const $068c396dceb690a1$export$86be76deee227ff2 = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ const $068c396dceb690a1$export$be7a251980e7e946 = 'http.request.method';
const $068c396dceb690a1$export$25dfd73e0e32c6e1 = 'url.full';
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ const $068c396dceb690a1$export$ff77b5fd5b2d627b = 'sentry.link.type';





const $bcdb7fb6cf7e08bf$export$6e69537d67fa20f = 'sentry-';
const $bcdb7fb6cf7e08bf$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $bcdb7fb6cf7e08bf$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $bcdb7fb6cf7e08bf$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $bcdb7fb6cf7e08bf$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($bcdb7fb6cf7e08bf$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($bcdb7fb6cf7e08bf$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $bcdb7fb6cf7e08bf$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$bcdb7fb6cf7e08bf$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $bcdb7fb6cf7e08bf$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $bcdb7fb6cf7e08bf$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $bcdb7fb6cf7e08bf$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $bcdb7fb6cf7e08bf$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $bcdb7fb6cf7e08bf$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $bcdb7fb6cf7e08bf$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $bcdb7fb6cf7e08bf$export$bdd844ddb2def819) {
            (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}




// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function $39d14882dc0612d9$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
/**
 * @see JSDoc of `hasSpansEnabled`
 * @deprecated Use `hasSpansEnabled` instead, which is a more accurately named version of this function.
 * This function will be removed in the next major version of the SDK.
 */ // TODO(v10): Remove this export
const $39d14882dc0612d9$export$5008da00b1b6dee6 = $39d14882dc0612d9$export$1f70765132c3c225;






const $006ad32cdaebe09b$export$136e25984ba4a383 = 0;
const $006ad32cdaebe09b$export$58f7963109c806fc = 1;
const $006ad32cdaebe09b$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $006ad32cdaebe09b$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $006ad32cdaebe09b$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'not_found'
            };
        case 409:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'already_exists'
            };
        case 413:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'cancelled'
            };
        default:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'unavailable'
            };
        case 504:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'internal_error'
            };
    }
    return {
        code: $006ad32cdaebe09b$export$f966a0446ece71e,
        message: 'unknown_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $006ad32cdaebe09b$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    const spanStatus = $006ad32cdaebe09b$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}



const $4509d165411fd11c$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $4509d165411fd11c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $4509d165411fd11c$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(span, $4509d165411fd11c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(span, $4509d165411fd11c$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $4509d165411fd11c$export$c08fbc656a245d03(span) {
    return {
        scope: span[$4509d165411fd11c$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$4509d165411fd11c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}






/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $1053a52e7802e64c$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}




// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $06e5b8314e290bf2$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $06e5b8314e290bf2$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($06e5b8314e290bf2$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $06e5b8314e290bf2$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $06e5b8314e290bf2$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $bcdb7fb6cf7e08bf$export$5b96ee2c8421f107)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $dc99b4184ec29e47$export$dc6d7ea554bcce10)(),
        sampleRand: Math.random()
    };
    const sampleRand = $06e5b8314e290bf2$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $06e5b8314e290bf2$export$f35d907436da45cf(traceId = (0, $dc99b4184ec29e47$export$dc6d7ea554bcce10)(), spanId = (0, $dc99b4184ec29e47$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function $06e5b8314e290bf2$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = (0, $1053a52e7802e64c$export$a5bd2d81656d9546)(dsc?.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = (0, $1053a52e7802e64c$export$a5bd2d81656d9546)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== undefined) return traceparentData.parentSampled ? Math.random() * parsedSampleRate : parsedSampleRate + Math.random() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return Math.random();
}



// These are aligned with OpenTelemetry trace flags
const $36b15c0d755e29f6$export$208d5b368507fb8b = 0x0;
const $36b15c0d755e29f6$export$eb571cd9b5d98de8 = 0x1;
let $36b15c0d755e29f6$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $36b15c0d755e29f6$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $36b15c0d755e29f6$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $36b15c0d755e29f6$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $36b15c0d755e29f6$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $4509d165411fd11c$export$c08fbc656a245d03)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $dc99b4184ec29e47$export$295213bc4d0c54ad)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $36b15c0d755e29f6$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $36b15c0d755e29f6$export$5caecac1caaf3a71(span);
    return (0, $06e5b8314e290bf2$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $36b15c0d755e29f6$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $36b15c0d755e29f6$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $36b15c0d755e29f6$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $36b15c0d755e29f6$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $36b15c0d755e29f6$var$ensureTimestampInSeconds(input.getTime());
    return (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $36b15c0d755e29f6$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $36b15c0d755e29f6$export$92d8c23565496537(span) {
    if ($36b15c0d755e29f6$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($36b15c0d755e29f6$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, parentSpanId: parentSpanId, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: parentSpanId,
            start_timestamp: $36b15c0d755e29f6$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $36b15c0d755e29f6$export$3f7581298f56c6d7(endTime) || undefined,
            status: $36b15c0d755e29f6$export$e238a77ea3a8cd66(status),
            op: attributes[0, $068c396dceb690a1$export$1a413bd9a88fdb09],
            origin: attributes[0, $068c396dceb690a1$export$cca8dd30f57f805e],
            links: $36b15c0d755e29f6$export$cb3e3a12e0eec16c(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $36b15c0d755e29f6$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $36b15c0d755e29f6$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $36b15c0d755e29f6$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $36b15c0d755e29f6$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $36b15c0d755e29f6$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $006ad32cdaebe09b$export$136e25984ba4a383)) return undefined;
    if (status.code === (0, $006ad32cdaebe09b$export$58f7963109c806fc)) return 'ok';
    return status.message || 'unknown_error';
}
const $36b15c0d755e29f6$var$CHILD_SPANS_FIELD = '_sentryChildSpans';
const $36b15c0d755e29f6$var$ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function $36b15c0d755e29f6$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$36b15c0d755e29f6$var$ROOT_SPAN_FIELD] || span;
    (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(childSpan, $36b15c0d755e29f6$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(span, $36b15c0d755e29f6$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $36b15c0d755e29f6$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $36b15c0d755e29f6$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($36b15c0d755e29f6$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD] ? Array.from(span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $36b15c0d755e29f6$export$c4c6a79b1260ca1b(span) {
    return span[$36b15c0d755e29f6$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $36b15c0d755e29f6$export$1be426a8e585c83e() {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $99af9a2b040631ba$export$91f063ebb8eff307)((0, $f106fce27ec076f7$export$c7be4b0125a10cba)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function $36b15c0d755e29f6$export$d11691ff45a3e535() {
    if (!$36b15c0d755e29f6$var$hasShownSpanDropWarning) {
        (0, $c9674f9e04798056$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly.');
        });
        $36b15c0d755e29f6$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $36b15c0d755e29f6$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $068c396dceb690a1$export$d7a7d984b0791405)]: 'custom',
        [(0, $068c396dceb690a1$export$165ce9a229f6f050)]: name
    });
}



/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function $dfdaf30e5fcd5fd9$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(spanWithMaybeDsc, $dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $dfdaf30e5fcd5fd9$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    const dsc = {
        environment: options.environment || (0, $3592a0510b526070$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id
    };
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $dfdaf30e5fcd5fd9$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $dfdaf30e5fcd5fd9$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $dfdaf30e5fcd5fd9$export$a117f995597e25df(span) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span);
    const rootSpanJson = (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = traceState?.get('sentry.sample_rate') ?? rootSpanAttributes[0, $068c396dceb690a1$export$ccfe0a40627cc34b];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === 'number' || typeof rootSpanSampleRate === 'string') dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState?.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $bcdb7fb6cf7e08bf$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = $dfdaf30e5fcd5fd9$export$366bad00d6815eed(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = rootSpanAttributes[0, $068c396dceb690a1$export$d7a7d984b0791405];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $39d14882dc0612d9$export$1f70765132c3c225)()) {
        dsc.sampled = String((0, $36b15c0d755e29f6$export$5caecac1caaf3a71)(rootSpan));
        dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get('sentry.sample_rand') ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $4509d165411fd11c$export$c08fbc656a245d03)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $dfdaf30e5fcd5fd9$export$95cf936fdacaff7b(span) {
    const dsc = $dfdaf30e5fcd5fd9$export$a117f995597e25df(span);
    return (0, $bcdb7fb6cf7e08bf$export$56766feef403f365)(dsc);
}




/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $29ab5181ea4a2c1b$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $29ab5181ea4a2c1b$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $29ab5181ea4a2c1b$var$applySpanToEvent(event, span);
    $29ab5181ea4a2c1b$var$applyFingerprintToEvent(event, fingerprint);
    $29ab5181ea4a2c1b$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $29ab5181ea4a2c1b$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $29ab5181ea4a2c1b$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, 'extra', extra);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, 'tags', tags);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, 'user', user);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, 'contexts', contexts);
    data.sdkProcessingMetadata = (0, $05f9869a4b646370$export$4950aa0f605343fb)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $05f9869a4b646370$export$4950aa0f605343fb)(data[prop], mergeVal, 1);
}
function $29ab5181ea4a2c1b$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== 'transaction') event.transaction = transactionName;
}
function $29ab5181ea4a2c1b$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $29ab5181ea4a2c1b$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $29ab5181ea4a2c1b$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $36b15c0d755e29f6$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span);
    const transactionName = (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === 'transaction') event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $29ab5181ea4a2c1b$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (!event.fingerprint.length) delete event.fingerprint;
}


/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $baba650ac852ba0c$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $4f55103f4332a5b0$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $4f6ba265374890ec$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $baba650ac852ba0c$export$d7e04067a6fbc882(prepared, options);
    $baba650ac852ba0c$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit('applyFrameMetadata', event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $baba650ac852ba0c$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $baba650ac852ba0c$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $f106fce27ec076f7$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $29ab5181ea4a2c1b$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $29ab5181ea4a2c1b$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $29ab5181ea4a2c1b$export$43988bc651a80216)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $fa62667502ab5c7a$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $baba650ac852ba0c$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $baba650ac852ba0c$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $baba650ac852ba0c$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $3592a0510b526070$export$849dbeeeda01ae98);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url) request.url = (0, $cee8faa76567523a$export$6a506b36fdea397d)(request.url, maxValueLength);
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $baba650ac852ba0c$export$63042efc86f043e7(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $107941ce73c7a34f$export$e069fee9c632ed00)(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $baba650ac852ba0c$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $baba650ac852ba0c$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $baba650ac852ba0c$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $baba650ac852ba0c$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $33c387bb26fe522d$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $baba650ac852ba0c$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($baba650ac852ba0c$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($baba650ac852ba0c$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $baba650ac852ba0c$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $33c387bb26fe522d$export$775b6bb06e53a214) || typeof hint === 'function';
}
const $baba650ac852ba0c$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'propagationContext'
];
function $baba650ac852ba0c$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$baba650ac852ba0c$var$captureContextKeys.includes(key));
}


/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $f2b90654edf2c0a1$export$f5282963edea4a68(exception, hint) {
    return (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().captureException(exception, (0, $baba650ac852ba0c$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $f2b90654edf2c0a1$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $f2b90654edf2c0a1$export$1462b974fdcf6ba2(event, hint) {
    return (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $f2b90654edf2c0a1$export$2f04de43fe27971a(name, context) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $f2b90654edf2c0a1$export$bb4922da0dd51b92(extras) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $f2b90654edf2c0a1$export$8e8e7789d42ed61d(key, extra) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $f2b90654edf2c0a1$export$74a8fb34822092e6(tags) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $f2b90654edf2c0a1$export$a37d07ee78eb4569(key, value) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $f2b90654edf2c0a1$export$8b6bb3dd62a01be2(user) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $f2b90654edf2c0a1$export$5d4e9fd7fac8e617() {
    return (0, $f106fce27ec076f7$export$68f3af03034c9e90)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $f2b90654edf2c0a1$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $f2b90654edf2c0a1$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $f2b90654edf2c0a1$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $f2b90654edf2c0a1$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() - now
        });
    }
    return (0, $f106fce27ec076f7$export$9a4fed82c350c2bd)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn('error');
            throw e;
        }
        if ((0, $9a62450b4f3c2c3b$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
            finishCheckIn('ok');
        }, (e)=>{
            finishCheckIn('error');
            throw e;
        });
        else finishCheckIn('ok');
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $f2b90654edf2c0a1$export$4909b86c8034bf73(timeout) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (client) return client.flush(timeout);
    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $f2b90654edf2c0a1$export$8360e631d277ea4d(timeout) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (client) return client.close(timeout);
    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $f2b90654edf2c0a1$export$3f95c6f800b78024() {
    return !!(0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
}
/** If the SDK is initialized & enabled. */ function $f2b90654edf2c0a1$export$3b029eb57ac4d562() {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $f2b90654edf2c0a1$export$9aac0b9f77928fbf(callback) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $f2b90654edf2c0a1$export$c0d84948cecf78d8(context) {
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    const currentScope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $ecc06dd71ed8ff5f$export$14a186326edbb264)({
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === 'ok') (0, $ecc06dd71ed8ff5f$export$531818e825e774db)(currentSession, {
        status: 'exited'
    });
    $f2b90654edf2c0a1$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $f2b90654edf2c0a1$export$17a5be43989a0bc1() {
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    const currentScope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $ecc06dd71ed8ff5f$export$56521d9ba90f62ee)(session);
    $f2b90654edf2c0a1$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $f2b90654edf2c0a1$var$_sendSessionUpdate() {
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $f2b90654edf2c0a1$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $f2b90654edf2c0a1$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $f2b90654edf2c0a1$var$_sendSessionUpdate();
}




const $020e060e3b422828$var$WINDOW = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$67fc34576016d6ec() {
    return 'history' in $020e060e3b422828$var$WINDOW && !!$020e060e3b422828$var$WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $020e060e3b422828$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $020e060e3b422828$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $020e060e3b422828$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$020e060e3b422828$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($020e060e3b422828$export$d5f608b368e73f38($020e060e3b422828$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $020e060e3b422828$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $020e060e3b422828$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$531055a6c684a70a() {
    return 'ReportingObserver' in $020e060e3b422828$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$020e060e3b422828$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}












/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $f5682b06913d5b03$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $f5682b06913d5b03$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $f5682b06913d5b03$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $f5682b06913d5b03$export$604a45d95a155e2b(envelope, types) {
    return $f5682b06913d5b03$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $f5682b06913d5b03$var$encodeUTF8(input) {
    const carrier = (0, $db00931c27c5ec41$export$c8bfa33e4e8ae492)((0, $1a40e26460b4422e$export$f1a6cdb1459e81d1));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $f5682b06913d5b03$var$decodeUTF8(input) {
    const carrier = (0, $db00931c27c5ec41$export$c8bfa33e4e8ae492)((0, $1a40e26460b4422e$export$f1a6cdb1459e81d1));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $f5682b06913d5b03$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $f5682b06913d5b03$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? $f5682b06913d5b03$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $5eb42146e0d2c9ef$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $f5682b06913d5b03$var$concatBuffers(parts);
}
function $f5682b06913d5b03$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $f5682b06913d5b03$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === 'string' ? $f5682b06913d5b03$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($f5682b06913d5b03$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $f5682b06913d5b03$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $f5682b06913d5b03$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === 'string' ? $f5682b06913d5b03$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $f5682b06913d5b03$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    raw_security: 'security',
    otel_log: 'log_item'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $f5682b06913d5b03$export$b11169581eeaf237(type) {
    return $f5682b06913d5b03$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $f5682b06913d5b03$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $f5682b06913d5b03$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}





/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $b89a3b4f1056006b$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $b89a3b4f1056006b$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $f5682b06913d5b03$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $b89a3b4f1056006b$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $f5682b06913d5b03$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $b89a3b4f1056006b$var$enhanceEventWithSdkInfo(event, metadata?.sdk);
    const envelopeHeaders = (0, $f5682b06913d5b03$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $b89a3b4f1056006b$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn)
        }
    };
    const beforeSendSpan = client?.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span);
        const processedSpan = beforeSendSpan(spanJson);
        if (!processedSpan) {
            (0, $36b15c0d755e29f6$export$d11691ff45a3e535)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $36b15c0d755e29f6$export$92d8c23565496537);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $f5682b06913d5b03$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(headers, items);
}







/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $bbe8beff1aee2812$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $4f6ba265374890ec$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}














/**
 * Converts a transaction event to a span JSON object.
 */ function $fc63bcb83eb88e73$export$d9c6b2464b0a687e(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? '',
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? '',
        origin: origin,
        profile_id: data?.[0, $068c396dceb690a1$export$1efec95406bbe327],
        exclusive_time: data?.[0, $068c396dceb690a1$export$fea48ba9f4550879],
        measurements: event.measurements,
        is_segment: true
    };
}
/**
 * Converts a span JSON object to a transaction event.
 */ function $fc63bcb83eb88e73$export$f2d8fce5ae150e92(span) {
    return {
        type: 'transaction',
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [(0, $068c396dceb690a1$export$1efec95406bbe327)]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [(0, $068c396dceb690a1$export$fea48ba9f4550879)]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}



const $76d0d0aa71b7be3b$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $76d0d0aa71b7be3b$var$MISSING_RELEASE_FOR_SESSION_ERROR = 'Discarded session because of missing or non-string release';
const $76d0d0aa71b7be3b$var$INTERNAL_ERROR_SYMBOL = Symbol.for('SentryInternalError');
const $76d0d0aa71b7be3b$var$DO_NOT_SEND_EVENT_SYMBOL = Symbol.for('SentryDoNotSendEventError');
function $76d0d0aa71b7be3b$var$_makeInternalError(message) {
    return {
        message: message,
        [$76d0d0aa71b7be3b$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $76d0d0aa71b7be3b$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$76d0d0aa71b7be3b$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $76d0d0aa71b7be3b$var$_isInternalError(error) {
    return !!error && typeof error === 'object' && $76d0d0aa71b7be3b$var$INTERNAL_ERROR_SYMBOL in error;
}
function $76d0d0aa71b7be3b$var$_isDoNotSendEventError(error) {
    return !!error && typeof error === 'object' && $76d0d0aa71b7be3b$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link Client._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends Client<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $76d0d0aa71b7be3b$export$1f2bb630327ac4b6 {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $9171e4713e443b9b$export$128827c3562ec0cb)(options.dsn);
        else (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $0e303f054920e2b1$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if ((0, $4f55103f4332a5b0$export$6de4ffac6a2f1098)(exception)) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log($76d0d0aa71b7be3b$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $4f55103f4332a5b0$export$19f53698e68b2496)(),
            ...hint
        };
        const eventMessage = (0, $9a62450b4f3c2c3b$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $9a62450b4f3c2c3b$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if (hint?.originalException && (0, $4f55103f4332a5b0$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log($76d0d0aa71b7be3b$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session) {
        this.sendSession(session);
        // After sending, we set init false to indicate it's not the first occurrence
        (0, $ecc06dd71ed8ff5f$export$531818e825e774db)(session, {
            init: false
        });
    }
    /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */ /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit('flush');
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit('close');
            return result;
        });
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith('Spotlight'))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $fbb22756c9507e85$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $fbb22756c9507e85$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $b89a3b4f1056006b$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $f5682b06913d5b03$export$d650323442802f6f)(env, (0, $f5682b06913d5b03$export$d8fc80952cc31fa4)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        // Backfill release and environment on session
        const { release: clientReleaseOption, environment: clientEnvironmentOption = (0, $3592a0510b526070$export$849dbeeeda01ae98) } = this._options;
        if ('aggregates' in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn($76d0d0aa71b7be3b$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn($76d0d0aa71b7be3b$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit('beforeSendSession', session);
        const env = (0, $b89a3b4f1056006b$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /* eslint-disable @typescript-eslint/unified-signatures */ /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */ /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hooks = this._hooks[hook] = this._hooks[hook] || [];
        // @ts-expect-error We assume the types are correct
        hooks.push(callback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            // @ts-expect-error We assume the types are correct
            const cbIndex = hooks.indexOf(callback);
            if (cbIndex > -1) hooks.splice(cbIndex, 1);
        };
    }
    /** Fire a hook whenever a span starts. */ /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('Error while sending envelope:', reason);
            return reason;
        });
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('Transport disabled');
        return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $fbb22756c9507e85$export$51abed9797baa598)(this, integrations);
        (0, $fbb22756c9507e85$export$35abcfd71227c6ca)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = event.level === 'fatal';
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism?.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $ecc06dd71ed8ff5f$export$531818e825e774db)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $9ad49a0639c06d33$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations?.length) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $baba650ac852ba0c$export$2d67fb380bd11267)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit('postprocessEvent', evt, hint);
            evt.contexts = {
                trace: (0, $f106fce27ec076f7$export$1e83db7ee4876dc4)(currentScope),
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, $dfdaf30e5fcd5fd9$export$89ef1736f08c6b2b)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)(), isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)()) {
        if ((0, $b776c95debaa4af0$export$16a28057038b10ef) && $76d0d0aa71b7be3b$var$isErrorEvent(event)) (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Captured error event \`${(0, $e5904939f3a5a4e3$export$d55a97c329cacfcc)(event)[0] || '<unknown>'}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $b776c95debaa4af0$export$16a28057038b10ef) {
                if ($76d0d0aa71b7be3b$var$_isDoNotSendEventError(reason)) (0, $c9674f9e04798056$export$af88d00dbe7f521).log(reason.message);
                else if ($76d0d0aa71b7be3b$var$_isInternalError(reason)) (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(reason.message);
                else (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $76d0d0aa71b7be3b$var$isTransactionEvent(event);
        const isError = $76d0d0aa71b7be3b$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : (0, $1053a52e7802e64c$export$a5bd2d81656d9546)(sampleRate);
        if (isError && typeof parsedSampleRate === 'number' && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent('sample_rate', 'error');
            return (0, $9ad49a0639c06d33$export$78e43115b553f358)($76d0d0aa71b7be3b$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory);
                throw $76d0d0aa71b7be3b$var$_makeDoNotSendEventError('An event processor returned `null`, will not send event.');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $76d0d0aa71b7be3b$var$processBeforeSend(this, options, prepared, hint);
            return $76d0d0aa71b7be3b$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw $76d0d0aa71b7be3b$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($76d0d0aa71b7be3b$var$_isDoNotSendEventError(reason) || $76d0d0aa71b7be3b$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $76d0d0aa71b7be3b$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('Flushing outcomes...');
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('Sending outcomes:', outcomes);
        const envelope = (0, $bbe8beff1aee2812$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $9171e4713e443b9b$export$44d472fbb931a776)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
const $76d0d0aa71b7be3b$export$4f22f74eddb7716a = $76d0d0aa71b7be3b$export$1f2bb630327ac4b6;
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $76d0d0aa71b7be3b$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $9a62450b4f3c2c3b$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $9a62450b4f3c2c3b$export$53b83ca8eaab0383)(event) && event !== null) throw $76d0d0aa71b7be3b$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $76d0d0aa71b7be3b$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $9a62450b4f3c2c3b$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw $76d0d0aa71b7be3b$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $76d0d0aa71b7be3b$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    let processedEvent = event;
    if ($76d0d0aa71b7be3b$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($76d0d0aa71b7be3b$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan) {
            // process root span
            const processedRootSpanJson = beforeSendSpan((0, $fc63bcb83eb88e73$export$d9c6b2464b0a687e)(processedEvent));
            if (!processedRootSpanJson) (0, $36b15c0d755e29f6$export$d11691ff45a3e535)();
            else // update event with processed root span values
            processedEvent = (0, $05f9869a4b646370$export$4950aa0f605343fb)(event, (0, $fc63bcb83eb88e73$export$f2d8fce5ae150e92)(processedRootSpanJson));
            // process child spans
            if (processedEvent.spans) {
                const processedSpans = [];
                for (const span of processedEvent.spans){
                    const processedSpan = beforeSendSpan(span);
                    if (!processedSpan) {
                        (0, $36b15c0d755e29f6$export$d11691ff45a3e535)();
                        processedSpans.push(span);
                    } else processedSpans.push(processedSpan);
                }
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $76d0d0aa71b7be3b$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $76d0d0aa71b7be3b$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/** Extract trace information from scope */ function $76d0d0aa71b7be3b$export$fb7d833b3fdedf5f(client, scope) {
    if (!scope) return [
        undefined,
        undefined
    ];
    const span = (0, $99af9a2b040631ba$export$91f063ebb8eff307)(scope);
    const traceContext = span ? (0, $36b15c0d755e29f6$export$46c6fbd1d265ebf0)(span) : (0, $f106fce27ec076f7$export$1e83db7ee4876dc4)(scope);
    const dynamicSamplingContext = span ? (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(span) : (0, $dfdaf30e5fcd5fd9$export$89ef1736f08c6b2b)(client, scope);
    return [
        dynamicSamplingContext,
        traceContext
    ];
}




/**
 * Maps a log severity level to a log severity number.
 *
 * @see LogSeverityLevel
 */ const $04aadcf3f679e7b5$export$4fb50c0840d636d1 = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};














/**
 * Creates OTEL log envelope item for a serialized OTEL log.
 *
 * @param log - The serialized OTEL log to include in the envelope.
 * @returns The created OTEL log envelope item.
 */ function $d42718a865457723$export$3fb4f8e4a128d620(log) {
    return [
        {
            type: 'otel_log'
        },
        log
    ];
}
/**
 * Creates an envelope for a list of logs.
 *
 * @param logs - The logs to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function $d42718a865457723$export$4324f1d0c59fd57b(logs, metadata, tunnel, dsn) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn);
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(headers, logs.map($d42718a865457723$export$3fb4f8e4a128d620));
}


const $e2016958b0149e1a$var$MAX_LOG_BUFFER_SIZE = 100;
const $e2016958b0149e1a$var$CLIENT_TO_LOG_BUFFER_MAP = new WeakMap();
/**
 * Converts a log attribute to a serialized log attribute.
 *
 * @param key - The key of the log attribute.
 * @param value - The value of the log attribute.
 * @returns The serialized log attribute.
 */ function $e2016958b0149e1a$export$84cb46f4adfc5d14(key, value) {
    switch(typeof value){
        case 'number':
            return {
                key: key,
                value: {
                    doubleValue: value
                }
            };
        case 'boolean':
            return {
                key: key,
                value: {
                    boolValue: value
                }
            };
        case 'string':
            return {
                key: key,
                value: {
                    stringValue: value
                }
            };
        default:
            {
                let stringValue = '';
                try {
                    stringValue = JSON.stringify(value) ?? '';
                } catch  {
                // Do nothing
                }
                return {
                    key: key,
                    value: {
                        stringValue: stringValue
                    }
                };
            }
    }
}
/**
 * Captures a log event and sends it to Sentry.
 *
 * @param log - The log event to capture.
 * @param scope - A scope. Uses the current scope if not provided.
 * @param client - A client. Uses the current client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $e2016958b0149e1a$export$3ab3d16b9eebd986(beforeLog, client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)(), scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)()) {
    if (!client) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('No client available to capture log.');
        return;
    }
    const { _experiments: _experiments, release: release, environment: environment } = client.getOptions();
    const { enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = _experiments ?? {};
    if (!enableLogs) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('logging option not enabled, log will not be captured.');
        return;
    }
    client.emit('beforeCaptureLog', beforeLog);
    const log = beforeSendLog ? beforeSendLog(beforeLog) : beforeLog;
    if (!log) {
        client.recordDroppedEvent('before_send', 'log_item', 1);
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('beforeSendLog returned null, log will not be captured.');
        return;
    }
    const [, traceContext] = (0, $76d0d0aa71b7be3b$export$fb7d833b3fdedf5f)(client, scope);
    const { level: level, message: message, attributes: attributes, severityNumber: severityNumber } = log;
    const logAttributes = {
        ...attributes
    };
    if (release) logAttributes['sentry.release'] = release;
    if (environment) logAttributes['sentry.environment'] = environment;
    const { sdk: sdk } = client.getSdkMetadata() ?? {};
    if (sdk) {
        logAttributes['sentry.sdk.name'] = sdk.name;
        logAttributes['sentry.sdk.version'] = sdk.version;
    }
    if ((0, $9a62450b4f3c2c3b$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = message;
        logAttributes['sentry.message.template'] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            logAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = (0, $99af9a2b040631ba$export$91f063ebb8eff307)(scope);
    if (span) // Add the parent span ID to the log attributes for trace context
    logAttributes['sentry.trace.parent_span_id'] = span.spanContext().spanId;
    const serializedLog = {
        severityText: level,
        body: {
            stringValue: message
        },
        attributes: Object.entries(logAttributes).map(([key, value])=>$e2016958b0149e1a$export$84cb46f4adfc5d14(key, value)),
        timeUnixNano: `${new Date().getTime().toString()}000000`,
        traceId: traceContext?.trace_id,
        severityNumber: severityNumber ?? (0, $04aadcf3f679e7b5$export$4fb50c0840d636d1)[level]
    };
    const logBuffer = $e2016958b0149e1a$var$CLIENT_TO_LOG_BUFFER_MAP.get(client);
    if (logBuffer === undefined) $e2016958b0149e1a$var$CLIENT_TO_LOG_BUFFER_MAP.set(client, [
        serializedLog
    ]);
    else {
        logBuffer.push(serializedLog);
        if (logBuffer.length > $e2016958b0149e1a$var$MAX_LOG_BUFFER_SIZE) $e2016958b0149e1a$export$f8ed83d3b6a0b504(client, logBuffer);
    }
    client.emit('afterCaptureLog', log);
}
/**
 * Flushes the logs buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeLogBuffer - A log buffer. Uses the log buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $e2016958b0149e1a$export$f8ed83d3b6a0b504(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $e2016958b0149e1a$var$CLIENT_TO_LOG_BUFFER_MAP.get(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $d42718a865457723$export$4324f1d0c59fd57b)(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the log buffer after envelopes have been constructed.
    logBuffer.length = 0;
    client.emit('flushLogs');
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}

// By default, we want to infer the IP address, unless this is explicitly set to `null`
// We do this after all other processing is done
// If `ip_address` is explicitly set to `null` or a value, we leave it as is
/**
 * @internal
 */ function $2cca66f9c5e6f810$export$3e12ad68afa434ac(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === undefined) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: '{{auto}}'
    };
}
/**
 * @internal
 */ function $2cca66f9c5e6f810$export$e8e2d07ba63e2b6c(session) {
    if ('aggregates' in session) {
        if (session.attrs?.['ip_address'] === undefined) session.attrs = {
            ...session.attrs,
            ip_address: '{{auto}}'
        };
    } else if (session.ipAddress === undefined) session.ipAddress = '{{auto}}';
}


/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $605291aa308d4b89$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $b0bfa51115099518$export$31499a9cd224b78c)
            })),
        version: (0, $b0bfa51115099518$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}

/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $1d72e3a9e632bed3$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $1d72e3a9e632bed3$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}



/**
 * This function creates an exception from a JavaScript Error
 */ function $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $23dde874fe12fd4c$export$2e9ae379995d99e3(ex),
        value: $23dde874fe12fd4c$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $23dde874fe12fd4c$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $23dde874fe12fd4c$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $5eb42146e0d2c9ef$export$23fbbb20bed71033)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $9a62450b4f3c2c3b$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $23dde874fe12fd4c$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $23dde874fe12fd4c$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $23dde874fe12fd4c$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const skipLines = $23dde874fe12fd4c$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $23dde874fe12fd4c$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $23dde874fe12fd4c$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $23dde874fe12fd4c$var$getSkipFirstStackStringLines(ex) {
    if (ex && $23dde874fe12fd4c$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $23dde874fe12fd4c$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === 'number') return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $23dde874fe12fd4c$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    if (typeof WebAssembly !== 'undefined' && typeof WebAssembly.Exception !== 'undefined') // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $23dde874fe12fd4c$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $23dde874fe12fd4c$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : 'WebAssembly.Exception';
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $23dde874fe12fd4c$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($23dde874fe12fd4c$var$isWebAssemblyException(ex)) {
        // For Node 18, Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return 'wasm exception';
    }
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $23dde874fe12fd4c$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $23dde874fe12fd4c$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $23dde874fe12fd4c$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $23dde874fe12fd4c$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $9a62450b4f3c2c3b$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $23dde874fe12fd4c$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $9a62450b4f3c2c3b$export$ef9e2056653f0c8e)(exception) || (0, $9a62450b4f3c2c3b$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $23dde874fe12fd4c$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $9a62450b4f3c2c3b$export$ef9e2056653f0c8e)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $4f55103f4332a5b0$export$f26508487bf83ee7)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $9a62450b4f3c2c3b$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $23dde874fe12fd4c$var$eventFromError(stackParser, exception);
    if ((0, $9a62450b4f3c2c3b$export$53b83ca8eaab0383)(exception) || (0, $9a62450b4f3c2c3b$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $23dde874fe12fd4c$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $23dde874fe12fd4c$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $4f55103f4332a5b0$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
function $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
    }
    if ((0, $9a62450b4f3c2c3b$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $23dde874fe12fd4c$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $f4dd084fe83374eb$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $9a62450b4f3c2c3b$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $9a62450b4f3c2c3b$export$9671ea99bd126ace)(exception)) {
        const className = $23dde874fe12fd4c$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $23dde874fe12fd4c$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $23dde874fe12fd4c$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}



const $9130afac94f0b7c9$export$56d8a8a25bd48b81 = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
let $9130afac94f0b7c9$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $9130afac94f0b7c9$export$b79738ab10c590b2() {
    return $9130afac94f0b7c9$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $9130afac94f0b7c9$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $9130afac94f0b7c9$var$ignoreOnError++;
    setTimeout(()=>{
        $9130afac94f0b7c9$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $9130afac94f0b7c9$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === 'function';
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $f4dd084fe83374eb$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$9130afac94f0b7c9$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $9130afac94f0b7c9$export$1265a142ff5ba165();
            (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $4f55103f4332a5b0$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $f2b90654edf2c0a1$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $f4dd084fe83374eb$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    } catch  {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}


const $72d27c0252bb80ff$var$DEFAULT_FLUSH_INTERVAL = 5000;
/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/core Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $72d27c0252bb80ff$export$1df9218a526d318d extends (0, $76d0d0aa71b7be3b$export$1f2bb630327ac4b6) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = {
            // We default this to true, as it is the safer scenario
            parentSpanIsAlwaysRootSpan: true,
            ...options
        };
        const sdkSource = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $1d72e3a9e632bed3$export$8ad33f488b1ab046)();
        (0, $605291aa308d4b89$export$b9f95b027256052c)(opts, 'browser', [
            'browser'
        ], sdkSource);
        super(opts);
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const client = this;
        const { sendDefaultPii: sendDefaultPii, _experiments: _experiments } = client._options;
        const enableLogs = _experiments?.enableLogs;
        if (opts.sendClientReports && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
            if ((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') {
                this._flushOutcomes();
                if (enableLogs) (0, $e2016958b0149e1a$export$f8ed83d3b6a0b504)(client);
            }
        });
        if (enableLogs) {
            client.on('flush', ()=>{
                (0, $e2016958b0149e1a$export$f8ed83d3b6a0b504)(client);
            });
            client.on('afterCaptureLog', ()=>{
                if (client._logFlushIdleTimeout) clearTimeout(client._logFlushIdleTimeout);
                client._logFlushIdleTimeout = setTimeout(()=>{
                    (0, $e2016958b0149e1a$export$f8ed83d3b6a0b504)(client);
                }, $72d27c0252bb80ff$var$DEFAULT_FLUSH_INTERVAL);
            });
        }
        if (sendDefaultPii) {
            client.on('postprocessEvent', (0, $2cca66f9c5e6f810$export$3e12ad68afa434ac));
            client.on('beforeSendSession', (0, $2cca66f9c5e6f810$export$e8e2d07ba63e2b6c));
        }
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $23dde874fe12fd4c$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = 'info', hint) {
        return (0, $23dde874fe12fd4c$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $7b8b500cb80621bc$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;






// We keep the handlers globally
const $f079126c500c7ea2$var$handlers = {};
const $f079126c500c7ea2$var$instrumented = {};
/** Add a handler function. */ function $f079126c500c7ea2$export$a4e09611e30da72e(type, handler) {
    $f079126c500c7ea2$var$handlers[type] = $f079126c500c7ea2$var$handlers[type] || [];
    $f079126c500c7ea2$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $f079126c500c7ea2$export$b17eab759a1cb5fe() {
    Object.keys($f079126c500c7ea2$var$handlers).forEach((key)=>{
        $f079126c500c7ea2$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $f079126c500c7ea2$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$f079126c500c7ea2$var$instrumented[type]) {
        $f079126c500c7ea2$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $f079126c500c7ea2$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $f079126c500c7ea2$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $4010ef0d9b3761f9$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}



const $955496f5d3029976$export$56d8a8a25bd48b81 = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);


const $c79bca128681c716$var$DEBOUNCE_DURATION = 1000;
let $c79bca128681c716$var$debounceTimerID;
let $c79bca128681c716$var$lastCapturedEventType;
let $c79bca128681c716$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $c79bca128681c716$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $c79bca128681c716$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $c79bca128681c716$export$3014bbf0af0e1d4a() {
    if (!(0, $955496f5d3029976$export$56d8a8a25bd48b81).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $f079126c500c7ea2$export$b18c893e424d3127).bind(null, 'dom');
    const globalDOMEventHandler = $c79bca128681c716$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.addEventListener('click', globalDOMEventHandler, false);
    (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        const globalObject = (0, $955496f5d3029976$export$56d8a8a25bd48b81);
        const proto = globalObject[target]?.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto?.hasOwnProperty?.('addEventListener')) return;
        (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $c79bca128681c716$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $c79bca128681c716$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $c79bca128681c716$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $c79bca128681c716$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $c79bca128681c716$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target?.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $c79bca128681c716$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $c79bca128681c716$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($c79bca128681c716$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(target, '_sentryId', (0, $4f55103f4332a5b0$export$19f53698e68b2496)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$c79bca128681c716$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $c79bca128681c716$var$lastCapturedEventType = event.type;
            $c79bca128681c716$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($c79bca128681c716$var$debounceTimerID);
        $c79bca128681c716$var$debounceTimerID = (0, $955496f5d3029976$export$56d8a8a25bd48b81).setTimeout(()=>{
            $c79bca128681c716$var$lastCapturedEventTargetId = undefined;
            $c79bca128681c716$var$lastCapturedEventType = undefined;
        }, $c79bca128681c716$var$DEBOUNCE_DURATION);
    };
}
function $c79bca128681c716$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}



let $3d87653da885c31c$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $3d87653da885c31c$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $3d87653da885c31c$export$d9b613a6254a184e);
}
/**
 * Exported just for testing
 */ function $3d87653da885c31c$export$d9b613a6254a184e() {
    // The `popstate` event may also be triggered on `pushState`, but it may not always reliably be emitted by the browser
    // Which is why we also monkey-patch methods below, in addition to this
    (0, $955496f5d3029976$export$56d8a8a25bd48b81).addEventListener('popstate', ()=>{
        const to = (0, $955496f5d3029976$export$56d8a8a25bd48b81).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $3d87653da885c31c$var$lastHref;
        $3d87653da885c31c$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $f079126c500c7ea2$export$b18c893e424d3127)('history', handlerData);
    });
    // Just guard against this not being available, in weird environments
    if (!(0, $020e060e3b422828$export$67fc34576016d6ec)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $3d87653da885c31c$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $3d87653da885c31c$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $f079126c500c7ea2$export$b18c893e424d3127)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $955496f5d3029976$export$56d8a8a25bd48b81).history, 'pushState', historyReplacementFunction);
    (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $955496f5d3029976$export$56d8a8a25bd48b81).history, 'replaceState', historyReplacementFunction);
}



const $63e43e59b4196dc4$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $63e43e59b4196dc4$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $63e43e59b4196dc4$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $63e43e59b4196dc4$export$c67d533bf77cbf54() {
    if (!(0, $955496f5d3029976$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $63e43e59b4196dc4$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $f079126c500c7ea2$export$b18c893e424d3127)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === 'function') xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(header) && (0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000,
                xhr: sendThisArg
            };
            (0, $f079126c500c7ea2$export$b18c893e424d3127)('xhr', handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
/**
 * Parses the URL argument of a XHR method to a string.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/open#url
 * url: A string or any other object with a stringifier — including a URL object — that provides the URL of the resource to send the request to.
 *
 * @param url - The URL argument of an XHR method
 * @returns The parsed URL string or undefined if the URL is invalid
 */ function $63e43e59b4196dc4$var$parseXhrUrlArg(url) {
    if ((0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(url)) return url;
    try {
        // If the passed in argument is not a string, it should have a `toString` method as a stringifier.
        // If that fails, we just return undefined (like in IE11 where URL is not available)
        return url.toString();
    } catch  {} // eslint-disable-line no-empty
    return undefined;
}





/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $4d76c9d78abc3a9e$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $4d76c9d78abc3a9e$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $4d76c9d78abc3a9e$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $4f6ba265374890ec$export$7740643b9eeaf0c4)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $c9674f9e04798056$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}





/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $16d762171e064dbd$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $16d762171e064dbd$var$instrumentConsole);
}
function $16d762171e064dbd$var$instrumentConsole() {
    if (!('console' in (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1))) return;
    (0, $c9674f9e04798056$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).console)) return;
        (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $c9674f9e04798056$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $f079126c500c7ea2$export$b18c893e424d3127)('console', handlerData);
                const log = (0, $c9674f9e04798056$export$77c4ce905194557b)[level];
                log?.apply((0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}







/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $da5e32477400e3c6$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = 'fetch';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, ()=>$da5e32477400e3c6$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $da5e32477400e3c6$export$1a79663eb318fe6a(handler) {
    const type = 'fetch-body-resolved';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, ()=>$da5e32477400e3c6$var$instrumentFetch($da5e32477400e3c6$var$streamHandler));
}
function $da5e32477400e3c6$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $020e060e3b422828$export$c82d238e23c40b21)()) return;
    (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $1a40e26460b4422e$export$f1a6cdb1459e81d1), 'fetch', function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $da5e32477400e3c6$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $da5e32477400e3c6$var$getHeadersFromFetchArgs(args)
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $f079126c500c7ea2$export$b18c893e424d3127)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $1a40e26460b4422e$export$f1a6cdb1459e81d1), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $f079126c500c7ea2$export$b18c893e424d3127)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $f079126c500c7ea2$export$b18c893e424d3127)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000,
                    error: error
                });
                if ((0, $9a62450b4f3c2c3b$export$e6127cc7fe7395c3)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(error, 'framesToPop', 1);
                }
                // We enhance the not-so-helpful "Failed to fetch" error messages with the host
                // Possible messages we handle here:
                // * "Failed to fetch" (chromium)
                // * "Load failed" (webkit)
                // * "NetworkError when attempting to fetch resource." (firefox)
                if (error instanceof TypeError && (error.message === 'Failed to fetch' || error.message === 'Load failed' || error.message === 'NetworkError when attempting to fetch resource.')) try {
                    const url = new URL(handlerData.fetchData.url);
                    error.message = `${error.message} (${url.host})`;
                } catch  {
                // ignore it if errors happen here
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $da5e32477400e3c6$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch (error) {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $da5e32477400e3c6$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $da5e32477400e3c6$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $f079126c500c7ea2$export$b18c893e424d3127)('fetch-body-resolved', {
            endTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000,
            response: response
        });
    });
}
function $da5e32477400e3c6$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $da5e32477400e3c6$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($da5e32477400e3c6$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $da5e32477400e3c6$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $da5e32477400e3c6$var$getUrlFromResource(url),
            method: $da5e32477400e3c6$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $da5e32477400e3c6$var$getUrlFromResource(arg),
        method: $da5e32477400e3c6$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}
function $da5e32477400e3c6$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === 'object' && optionsArgument !== null && 'headers' in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $9a62450b4f3c2c3b$export$6d3d1f317d7cda57)(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {
    // noop
    }
    return;
}

/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $24280af9d15f06bf$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return 'warning';
    else if (statusCode >= 500) return 'error';
    else return undefined;
}

// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
const $2bf5ed435a4428b5$var$DEFAULT_BASE_URL = 'thismessage:/';
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function $2bf5ed435a4428b5$export$e258e13805402ba7(url) {
    return 'isRelative' in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function $2bf5ed435a4428b5$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.startsWith('/');
    const base = urlBase ?? (isRelative ? $2bf5ed435a4428b5$var$DEFAULT_BASE_URL : undefined);
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ('canParse' in URL && !URL.canParse(url, base)) return undefined;
        const fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $2bf5ed435a4428b5$export$5339fcdc8e2a427c(url) {
    if ($2bf5ed435a4428b5$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = '';
    newUrl.hash = '';
    if ([
        '80',
        '443'
    ].includes(newUrl.port)) newUrl.port = '';
    if (newUrl.password) newUrl.password = '%filtered%';
    if (newUrl.username) newUrl.username = '%filtered%';
    return newUrl.toString();
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $2bf5ed435a4428b5$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $2bf5ed435a4428b5$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $2bf5ed435a4428b5$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, '[filtered]:[filtered]@').replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $197a1d16f7c0faf5$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug'
    ].includes(level) ? level : 'log';
}




/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $8b5b3242e956e79f$var$INTEGRATION_NAME = 'Breadcrumbs';
const $8b5b3242e956e79f$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $8b5b3242e956e79f$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $16d762171e064dbd$export$1d6e0d073f9e6723)($8b5b3242e956e79f$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $c79bca128681c716$export$5aeffd3db2cf9df7)($8b5b3242e956e79f$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $63e43e59b4196dc4$export$26ace48dd54c9aea)($8b5b3242e956e79f$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $da5e32477400e3c6$export$f75d3c772c923df0)($8b5b3242e956e79f$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $3d87653da885c31c$export$3f18c56c58114e75)($8b5b3242e956e79f$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on('beforeSendEvent', $8b5b3242e956e79f$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $8b5b3242e956e79f$export$c079d904b326663a = (0, $fbb22756c9507e85$export$2323046b9414659f)($8b5b3242e956e79f$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $8b5b3242e956e79f$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $4f55103f4332a5b0$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $8b5b3242e956e79f$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $8b5b3242e956e79f$var$_isEvent(event) ? event.target : event;
            target = (0, $cccaafc2216668b2$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $cccaafc2216668b2$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $8b5b3242e956e79f$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $197a1d16f7c0faf5$export$d771ef054122c30a)(handlerData.level),
            message: (0, $cee8faa76567523a$export$465e9d514283d4fd)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $cee8faa76567523a$export$465e9d514283d4fd)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $8b5b3242e956e79f$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $63e43e59b4196dc4$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: 'xhr',
            data: data,
            type: 'http',
            level: (0, $24280af9d15f06bf$export$b8cfcc4175694bcc)(status_code)
        };
        client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)(breadcrumb, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $8b5b3242e956e79f$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        handlerData.fetchData.method, handlerData.fetchData.url;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            handlerData.fetchData.request_body_size;
            handlerData.fetchData.response_body_size;
            response?.status;
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                type: 'http',
                level: (0, $24280af9d15f06bf$export$b8cfcc4175694bcc)(data.status_code)
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)(breadcrumb, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $8b5b3242e956e79f$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $8b5b3242e956e79f$var$_isEvent(event) {
    return !!event && !!event.target;
}




const $4e018dbe28beb052$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $4e018dbe28beb052$var$INTEGRATION_NAME = 'BrowserApiErrors';
const $4e018dbe28beb052$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $4e018dbe28beb052$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81), 'setTimeout', $4e018dbe28beb052$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81), 'setInterval', $4e018dbe28beb052$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81), 'requestAnimationFrame', $4e018dbe28beb052$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81)) (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(XMLHttpRequest.prototype, 'send', $4e018dbe28beb052$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $4e018dbe28beb052$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($4e018dbe28beb052$var$_wrapEventTarget);
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $4e018dbe28beb052$export$59bfe9f1c76150e = (0, $fbb22756c9507e85$export$2323046b9414659f)($4e018dbe28beb052$var$_browserApiErrorsIntegration);
function $4e018dbe28beb052$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
function $4e018dbe28beb052$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $4e018dbe28beb052$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $f4dd084fe83374eb$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $4e018dbe28beb052$var$_wrapEventTarget(target) {
    const globalObject = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81);
    const proto = globalObject[target]?.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!proto?.hasOwnProperty?.('addEventListener')) return;
    (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if ($4e018dbe28beb052$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch  {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $4e018dbe28beb052$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === 'function';
}






/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $8a5b32760c0daa50$export$1baa7880e357371c = (0, $fbb22756c9507e85$export$2323046b9414659f)(()=>{
    return {
        name: 'BrowserSession',
        setupOnce () {
            if (typeof (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document === 'undefined') {
                (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Using the `browserSessionIntegration` in non-browser environments is not supported.');
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $f2b90654edf2c0a1$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $f2b90654edf2c0a1$export$667e7b4d445d566b)();
            // We want to create a session for every navigation as well
            (0, $3d87653da885c31c$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== undefined && from !== to) {
                    (0, $f2b90654edf2c0a1$export$c0d84948cecf78d8)({
                        ignoreDuration: true
                    });
                    (0, $f2b90654edf2c0a1$export$667e7b4d445d566b)();
                }
            });
        }
    };
});




let $4d76cdf59d4d2156$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $4d76cdf59d4d2156$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $4d76cdf59d4d2156$var$instrumentError);
}
function $4d76cdf59d4d2156$var$instrumentError() {
    $4d76cdf59d4d2156$var$_oldOnErrorHandler = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $f079126c500c7ea2$export$b18c893e424d3127)('error', handlerData);
        if ($4d76cdf59d4d2156$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $4d76cdf59d4d2156$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $7878483f8a9932cd$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $7878483f8a9932cd$var$instrumentUnhandledRejection);
}
function $7878483f8a9932cd$var$instrumentUnhandledRejection() {
    $7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $f079126c500c7ea2$export$b18c893e424d3127)('unhandledrejection', handlerData);
        if ($7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





const $3920039f2d643754$var$INTEGRATION_NAME = 'GlobalHandlers';
const $3920039f2d643754$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $3920039f2d643754$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $3920039f2d643754$var$_installGlobalOnErrorHandler(client);
                $3920039f2d643754$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $3920039f2d643754$var$_installGlobalOnUnhandledRejectionHandler(client);
                $3920039f2d643754$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $3920039f2d643754$export$66acc70e8cf2b71a = (0, $fbb22756c9507e85$export$2323046b9414659f)($3920039f2d643754$var$_globalHandlersIntegration);
function $3920039f2d643754$var$_installGlobalOnErrorHandler(client) {
    (0, $4d76cdf59d4d2156$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $3920039f2d643754$var$getOptions();
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client || (0, $9130afac94f0b7c9$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $3920039f2d643754$var$_enhanceEventWithInitialFrame((0, $23dde874fe12fd4c$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $f2b90654edf2c0a1$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $3920039f2d643754$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $7878483f8a9932cd$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $3920039f2d643754$var$getOptions();
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client || (0, $9130afac94f0b7c9$export$b79738ab10c590b2)()) return;
        const error = $3920039f2d643754$var$_getUnhandledRejectionError(e);
        const event = (0, $9a62450b4f3c2c3b$export$c3825b437cbdea5c)(error) ? $3920039f2d643754$var$_eventFromRejectionWithPrimitive(error) : (0, $23dde874fe12fd4c$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $f2b90654edf2c0a1$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $3920039f2d643754$var$_getUnhandledRejectionError(error) {
    if ((0, $9a62450b4f3c2c3b$export$c3825b437cbdea5c)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ('detail' in error && 'reason' in error.detail) return error.detail.reason;
    } catch  {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $3920039f2d643754$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $3920039f2d643754$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = column;
    const lineno = line;
    const filename = (0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $cccaafc2216668b2$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $3920039f2d643754$var$globalHandlerLog(type) {
    (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $3920039f2d643754$var$getOptions() {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $e873ad23f512125c$export$1378794447170364 = (0, $fbb22756c9507e85$export$2323046b9414659f)(()=>{
    return {
        name: 'HttpContext',
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).navigator && !(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && !(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request?.url || (0, $cccaafc2216668b2$export$1cfafeee2987818b)();
            const { referrer: referrer } = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request?.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    'User-Agent': userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
});



/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $71a9151fcd5ea774$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !(0, $9a62450b4f3c2c3b$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $9a62450b4f3c2c3b$export$49034edbe6b62415)(error[key], Error)) {
        $71a9151fcd5ea774$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $71a9151fcd5ea774$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $9a62450b4f3c2c3b$export$49034edbe6b62415)(childError, Error)) {
            $71a9151fcd5ea774$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $71a9151fcd5ea774$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $71a9151fcd5ea774$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $71a9151fcd5ea774$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}



const $74ac7e452f6a0785$var$DEFAULT_KEY = 'cause';
const $74ac7e452f6a0785$var$DEFAULT_LIMIT = 5;
const $74ac7e452f6a0785$var$INTEGRATION_NAME = 'LinkedErrors';
const $74ac7e452f6a0785$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $74ac7e452f6a0785$var$DEFAULT_LIMIT;
    const key = options.key || $74ac7e452f6a0785$var$DEFAULT_KEY;
    return {
        name: $74ac7e452f6a0785$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $71a9151fcd5ea774$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $23dde874fe12fd4c$export$a6c2d27607295951), options.stackParser, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $74ac7e452f6a0785$export$ebabb00eb7f3a395 = (0, $fbb22756c9507e85$export$2323046b9414659f)($74ac7e452f6a0785$var$_linkedErrorsIntegration);



// This was originally forked from https://github.com/csnover/TraceKit, and was largely
// re - written as part of raven - js.
//
// This code was later copied to the JavaScript mono - repo and further modified and
// refactored over the years.
const $e103414b28380d9b$var$OPERA10_PRIORITY = 10;
const $e103414b28380d9b$var$OPERA11_PRIORITY = 20;
const $e103414b28380d9b$var$CHROME_PRIORITY = 30;
const $e103414b28380d9b$var$WINJS_PRIORITY = 40;
const $e103414b28380d9b$var$GECKO_PRIORITY = 50;
function $e103414b28380d9b$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === '<anonymous>' ? (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $e103414b28380d9b$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $e103414b28380d9b$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $e103414b28380d9b$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $e103414b28380d9b$var$chromeStackParserFn = (line)=>{
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $e103414b28380d9b$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $e103414b28380d9b$var$createFrame(filename, (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac), +line, +col);
    }
    const parts = $e103414b28380d9b$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $e103414b28380d9b$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $e103414b28380d9b$var$extractSafariExtensionDetails(parts[1] || (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac), parts[2]);
        return $e103414b28380d9b$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $e103414b28380d9b$export$263a749fff749872 = [
    $e103414b28380d9b$var$CHROME_PRIORITY,
    $e103414b28380d9b$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $e103414b28380d9b$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $e103414b28380d9b$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $e103414b28380d9b$var$gecko = (line)=>{
    const parts = $e103414b28380d9b$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $e103414b28380d9b$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac);
        [func, filename] = $e103414b28380d9b$var$extractSafariExtensionDetails(func, filename);
        return $e103414b28380d9b$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $e103414b28380d9b$export$cdba47a5dd2804d = [
    $e103414b28380d9b$var$GECKO_PRIORITY,
    $e103414b28380d9b$var$gecko
];
const $e103414b28380d9b$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $e103414b28380d9b$var$winjs = (line)=>{
    const parts = $e103414b28380d9b$var$winjsRegex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[2], parts[1] || (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $e103414b28380d9b$export$179460296da408e8 = [
    $e103414b28380d9b$var$WINJS_PRIORITY,
    $e103414b28380d9b$var$winjs
];
const $e103414b28380d9b$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $e103414b28380d9b$var$opera10 = (line)=>{
    const parts = $e103414b28380d9b$var$opera10Regex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[2], parts[3] || (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac), +parts[1]) : undefined;
};
const $e103414b28380d9b$export$f892b52c880ffc7a = [
    $e103414b28380d9b$var$OPERA10_PRIORITY,
    $e103414b28380d9b$var$opera10
];
const $e103414b28380d9b$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $e103414b28380d9b$var$opera11 = (line)=>{
    const parts = $e103414b28380d9b$var$opera11Regex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[5], parts[3] || parts[4] || (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac), +parts[1], +parts[2]) : undefined;
};
const $e103414b28380d9b$export$af11af13f09fb0dc = [
    $e103414b28380d9b$var$OPERA11_PRIORITY,
    $e103414b28380d9b$var$opera11
];
const $e103414b28380d9b$export$7197c0fe6554c079 = [
    $e103414b28380d9b$export$263a749fff749872,
    $e103414b28380d9b$export$cdba47a5dd2804d
];
const $e103414b28380d9b$export$2b2b997d81bf3907 = (0, $4010ef0d9b3761f9$export$a5739666fb2d03d4)(...$e103414b28380d9b$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $e103414b28380d9b$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $e0c2e3106e46caa2$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $d09fa7e5070984b9$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $d09fa7e5070984b9$export$e464f4a514ac28a8(name) {
    const cached = $d09fa7e5070984b9$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $955496f5d3029976$export$56d8a8a25bd48b81)[name];
    // Fast path to avoid DOM I/O
    if ((0, $020e060e3b422828$export$d5f608b368e73f38)(impl)) return $d09fa7e5070984b9$var$cachedImplementations[name] = impl.bind((0, $955496f5d3029976$export$56d8a8a25bd48b81));
    const document = (0, $955496f5d3029976$export$56d8a8a25bd48b81).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $d09fa7e5070984b9$var$cachedImplementations[name] = impl.bind((0, $955496f5d3029976$export$56d8a8a25bd48b81));
}
/** Clear a cached implementation. */ function $d09fa7e5070984b9$export$8aa36702e8c8978(name) {
    $d09fa7e5070984b9$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $d09fa7e5070984b9$export$e7aa7bc5c1b3cfb3(...rest) {
    return $d09fa7e5070984b9$export$e464f4a514ac28a8('fetch')(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $d09fa7e5070984b9$export$831dc9f2ab0a617b(...rest) {
    return $d09fa7e5070984b9$export$e464f4a514ac28a8('setTimeout')(...rest);
}






const $f3cbf180d3404fe0$export$c8667f1887a128dc = Symbol.for('SentryBufferFullError');
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $f3cbf180d3404fe0$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0] || Promise.resolve(undefined);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $9ad49a0639c06d33$export$78e43115b553f358)($f3cbf180d3404fe0$export$c8667f1887a128dc);
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $9ad49a0639c06d33$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $5325f8e04d3d0467$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $5325f8e04d3d0467$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $5325f8e04d3d0467$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $5325f8e04d3d0467$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $5325f8e04d3d0467$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $5325f8e04d3d0467$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $5325f8e04d3d0467$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers?.['x-sentry-rate-limits'];
    const retryAfterHeader = headers?.['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $5325f8e04d3d0467$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



const $edfbff9038a67171$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $edfbff9038a67171$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $f3cbf180d3404fe0$export$85a4f67f852183e6)(options.bufferSize || $edfbff9038a67171$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $f5682b06913d5b03$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $f5682b06913d5b03$export$b11169581eeaf237)(type);
            if ((0, $5325f8e04d3d0467$export$6c91fec22056810a)(rateLimits, dataCategory)) options.recordDroppedEvent('ratelimit_backoff', dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)({});
        const filteredEnvelope = (0, $f5682b06913d5b03$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $f5682b06913d5b03$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, (0, $f5682b06913d5b03$export$b11169581eeaf237)(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $f5682b06913d5b03$export$32f9b428425aac85)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $5325f8e04d3d0467$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('Encountered error running transport request:', error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === (0, $f3cbf180d3404fe0$export$c8667f1887a128dc)) {
                (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $296be0c65ac1edb3$export$b2311068c46d7cc8(options, nativeFetch = (0, $d09fa7e5070984b9$export$e464f4a514ac28a8)('fetch')) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'strict-origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        if (!nativeFetch) {
            (0, $d09fa7e5070984b9$export$8aa36702e8c8978)('fetch');
            return (0, $9ad49a0639c06d33$export$78e43115b553f358)('No fetch implementation available');
        }
        try {
            // TODO: This may need a `suppressTracing` call in the future when we switch the browser SDK to OTEL
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $d09fa7e5070984b9$export$8aa36702e8c8978)('fetch');
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $9ad49a0639c06d33$export$78e43115b553f358)(e);
        }
    }
    return (0, $edfbff9038a67171$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** Get the default integrations for the browser SDK. */ function $928f566aa50bb77a$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        // TODO(v10): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line deprecation/deprecation
        (0, $42e5926860cf11cf$export$cb3c5c2ceb9818ba)(),
        (0, $7dd448759c7f5e18$export$7918117e9202e4fb)(),
        (0, $4e018dbe28beb052$export$59bfe9f1c76150e)(),
        (0, $8b5b3242e956e79f$export$c079d904b326663a)(),
        (0, $3920039f2d643754$export$66acc70e8cf2b71a)(),
        (0, $74ac7e452f6a0785$export$ebabb00eb7f3a395)(),
        (0, $b99d5bb3db344fdd$export$6d39aa44cd0c7567)(),
        (0, $e873ad23f512125c$export$1378794447170364)(),
        (0, $8a5b32760c0daa50$export$1baa7880e357371c)()
    ];
}
/** Exported only for tests. */ function $928f566aa50bb77a$export$4e107b20a7f977(optionsArg = {}) {
    const defaultOptions = {
        defaultIntegrations: $928f566aa50bb77a$export$5783b2920b1d62b9(),
        release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).SENTRY_RELEASE?.id,
        sendClientReports: true
    };
    return {
        ...defaultOptions,
        ...$928f566aa50bb77a$var$dropTopLevelUndefinedKeys(optionsArg)
    };
}
/**
 * In contrast to the regular `dropUndefinedKeys` method,
 * this one does not deep-drop keys, but only on the top level.
 */ function $928f566aa50bb77a$var$dropTopLevelUndefinedKeys(obj) {
    const mutatetedObj = {};
    for (const k of Object.getOwnPropertyNames(obj)){
        const key = k;
        if (obj[key] !== undefined) mutatetedObj[key] = obj[key];
    }
    return mutatetedObj;
}
function $928f566aa50bb77a$var$shouldShowBrowserExtensionError() {
    const windowWithMaybeExtension = typeof (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).window !== 'undefined' && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81);
    if (!windowWithMaybeExtension) // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const extensionKey = windowWithMaybeExtension.chrome ? 'chrome' : 'browser';
    const extensionObject = windowWithMaybeExtension[extensionKey];
    const runtimeId = extensionObject?.runtime?.id;
    const href = (0, $cccaafc2216668b2$export$1cfafeee2987818b)() || '';
    const extensionProtocols = [
        'chrome-extension:',
        'moz-extension:',
        'ms-browser-extension:',
        'safari-web-extension:'
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = !!runtimeId && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81) === (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}//`));
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    const isNWjs = typeof windowWithMaybeExtension.nw !== 'undefined';
    return !!runtimeId && !isDedicatedExtensionPage && !isNWjs;
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $928f566aa50bb77a$export$2cd8252107eb640b(browserOptions = {}) {
    const options = $928f566aa50bb77a$export$4e107b20a7f977(browserOptions);
    if (!options.skipBrowserExtensionCheck && $928f566aa50bb77a$var$shouldShowBrowserExtensionError()) {
        if (0, $7b8b500cb80621bc$export$16a28057038b10ef) (0, $c9674f9e04798056$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error('[Sentry] You cannot run Sentry this way in a browser extension, check: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/');
        });
        return;
    }
    if ((0, $7b8b500cb80621bc$export$16a28057038b10ef) && !(0, $020e060e3b422828$export$edf3cb81fd7d2a3e)()) (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('No Fetch API detected. The Sentry SDK requires a Fetch API compatible environment to send events. Please add a Fetch API polyfill.');
    const clientOptions = {
        ...options,
        stackParser: (0, $4010ef0d9b3761f9$export$1d5cf88b347146d4)(options.stackParser || (0, $e103414b28380d9b$export$2b2b997d81bf3907)),
        integrations: (0, $fbb22756c9507e85$export$68bc4c01ab8ae766)(options),
        transport: options.transport || (0, $296be0c65ac1edb3$export$b2311068c46d7cc8)
    };
    return (0, $9af71b6a24a126c8$export$5333c3f1c58d9bc1)((0, $72d27c0252bb80ff$export$1df9218a526d318d), clientOptions);
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $928f566aa50bb77a$export$3a8fd680da42627b(options = {}) {
    // doesn't work without a document (React Native)
    if (!(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) {
        (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('Global document not defined in showReportDialog call');
        return;
    }
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const client = scope.getClient();
    const dsn = client?.getDsn();
    if (!dsn) {
        (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) {
        const eventId = (0, $f2b90654edf2c0a1$export$5d4e9fd7fac8e617)();
        if (eventId) options.eventId = eventId;
    }
    const script = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $0e303f054920e2b1$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).addEventListener('message', reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.head || (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('Not injecting report dialog. No injection point found in HTML');
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $928f566aa50bb77a$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $928f566aa50bb77a$export$4e4d8b287d028b6b(callback) {
    callback();
}




var $acw62 = parcelRequire("acw62");
var $72623ab6bcb0a33b$exports = {};
'use strict';
var $3251146683c5d714$exports = {};
'use strict';

$3251146683c5d714$exports = (parcelRequire("9cCWX"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($3251146683c5d714$exports.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component['$$typeof']] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$72623ab6bcb0a33b$exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;


// Ensure we use the default export from hoist-non-react-statics if available,
// falling back to the module itself. This handles both ESM and CJS usage.
const $a0fc5be3f0cb3d79$export$6c1f0397687d8b2 = $72623ab6bcb0a33b$exports.default || $72623ab6bcb0a33b$exports;


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $fe334ae3892c74f1$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;





var $acw62 = parcelRequire("acw62");
/**
 * See if React major version is 17+ by parsing version string.
 */ function $262dc4fd22993153$export$a87138b73900f5b(reactVersion) {
    const reactMajor = reactVersion.match(/^([^.]+)/);
    return reactMajor !== null && parseInt(reactMajor[0]) >= 17;
}
/**
 * Recurse through `error.cause` chain to set cause on an error.
 */ function $262dc4fd22993153$export$bc95048bc211a673(error, cause) {
    const seenErrors = new WeakSet();
    function recurse(error, cause) {
        // If we've already seen the error, there is a recursive loop somewhere in the error's
        // cause chain. Let's just bail out then to prevent a stack overflow.
        if (seenErrors.has(error)) return;
        if (error.cause) {
            seenErrors.add(error);
            return recurse(error.cause, cause);
        }
        error.cause = cause;
    }
    recurse(error, cause);
}
/**
 * Captures an error that was thrown by a React ErrorBoundary or React root.
 *
 * @param error The error to capture.
 * @param errorInfo The errorInfo provided by React.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $262dc4fd22993153$export$270be4195468cda9(// eslint-disable-next-line @typescript-eslint/no-explicit-any
error, { componentStack: componentStack }, hint) {
    // If on React version >= 17, create stack trace from componentStack param and links
    // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
    // Linking errors requires the `LinkedErrors` integration be enabled.
    // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
    //
    // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
    // with non-error objects. This is why we need to check if the error is an error-like object.
    // See: https://github.com/getsentry/sentry-javascript/issues/6167
    if ($262dc4fd22993153$export$a87138b73900f5b((0, $acw62.version)) && (0, $9a62450b4f3c2c3b$export$e6127cc7fe7395c3)(error) && componentStack) {
        const errorBoundaryError = new Error(error.message);
        errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
        errorBoundaryError.stack = componentStack;
        // Using the `LinkedErrors` integration to link the errors together.
        $262dc4fd22993153$export$bc95048bc211a673(error, errorBoundaryError);
    }
    return (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
        scope.setContext('react', {
            componentStack: componentStack
        });
        return (0, $f2b90654edf2c0a1$export$f5282963edea4a68)(error, hint);
    });
}
/**
 * Creates an error handler that can be used with the `onCaughtError`, `onUncaughtError`,
 * and `onRecoverableError` options in `createRoot` and `hydrateRoot` React DOM methods.
 *
 * @param callback An optional callback that will be called after the error is captured.
 * Use this to add custom handling for errors.
 *
 * @example
 *
 * ```JavaScript
 * const root = createRoot(container, {
 *  onCaughtError: Sentry.reactErrorHandler(),
 *  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
 *    console.warn('Caught error', error, errorInfo.componentStack);
 *  });
 * });
 * ```
 */ function $262dc4fd22993153$export$1e6f045b27b3cfb1(// eslint-disable-next-line @typescript-eslint/no-explicit-any
callback) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (error, errorInfo)=>{
        const eventId = $262dc4fd22993153$export$270be4195468cda9(error, errorInfo);
        if (callback) callback(error, errorInfo, eventId);
    };
}


const $8921079907ea55d7$export$6ef4c0367e27f2d5 = 'unknown';
const $8921079907ea55d7$var$INITIAL_STATE = {
    componentStack: null,
    error: null,
    eventId: null
};
/**
 * A ErrorBoundary component that logs errors to Sentry.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */ class $8921079907ea55d7$export$e926676385687eaf extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = $8921079907ea55d7$var$INITIAL_STATE;
        this._openFallbackReportDialog = true;
        const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
        if (client && props.showDialog) {
            this._openFallbackReportDialog = false;
            this._cleanupHook = client.on('afterSendEvent', (event)=>{
                if (!event.type && this._lastEventId && event.event_id === this._lastEventId) (0, $928f566aa50bb77a$export$3a8fd680da42627b)({
                    ...props.dialogOptions,
                    eventId: this._lastEventId
                });
            });
        }
    }
    componentDidCatch(error, errorInfo) {
        const { componentStack: componentStack } = errorInfo;
        const { beforeCapture: beforeCapture, onError: onError, showDialog: showDialog, dialogOptions: dialogOptions } = this.props;
        (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
            if (beforeCapture) beforeCapture(scope, error, componentStack);
            const handled = this.props.handled != null ? this.props.handled : !!this.props.fallback;
            const eventId = (0, $262dc4fd22993153$export$270be4195468cda9)(error, errorInfo, {
                mechanism: {
                    handled: handled
                }
            });
            if (onError) onError(error, componentStack, eventId);
            if (showDialog) {
                this._lastEventId = eventId;
                if (this._openFallbackReportDialog) (0, $928f566aa50bb77a$export$3a8fd680da42627b)({
                    ...dialogOptions,
                    eventId: eventId
                });
            }
            // componentDidCatch is used over getDerivedStateFromError
            // so that componentStack is accessible through state.
            this.setState({
                error: error,
                componentStack: componentStack,
                eventId: eventId
            });
        });
    }
    componentDidMount() {
        const { onMount: onMount } = this.props;
        if (onMount) onMount();
    }
    componentWillUnmount() {
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) {
            if (this.state === $8921079907ea55d7$var$INITIAL_STATE) // If the error boundary never encountered an error, call onUnmount with null values
            onUnmount(null, null, null);
            else // `componentStack` and `eventId` are guaranteed to be non-null here because `onUnmount` is only called
            // when the error boundary has already encountered an error.
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            onUnmount(error, componentStack, eventId);
        }
        if (this._cleanupHook) {
            this._cleanupHook();
            this._cleanupHook = undefined;
        }
    }
    resetErrorBoundary() {
        const { onReset: onReset } = this.props;
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        if (onReset) // `componentStack` and `eventId` are guaranteed to be non-null here because `onReset` is only called
        // when the error boundary has already encountered an error.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        onReset(error, componentStack, eventId);
        this.setState($8921079907ea55d7$var$INITIAL_STATE);
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const state = this.state;
        // `componentStack` is only null in the initial state, when no error has been captured.
        // If an error has been captured, `componentStack` will be a string.
        // We cannot check `state.error` because null can be thrown as an error.
        if (state.componentStack === null) return typeof children === 'function' ? children() : children;
        const element = typeof fallback === 'function' ? $acw62.createElement(fallback, {
            error: state.error,
            componentStack: state.componentStack,
            resetError: ()=>this.resetErrorBoundary(),
            eventId: state.eventId
        }) : fallback;
        if ($acw62.isValidElement(element)) return element;
        if (fallback) (0, $fe334ae3892c74f1$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('fallback did not produce a valid ReactElement');
        // Fail gracefully if no fallback provided or is not valid
        return null;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8921079907ea55d7$export$f0c7a449e0cfaec7(WrappedComponent, errorBoundaryOptions) {
    const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || $8921079907ea55d7$export$6ef4c0367e27f2d5;
    const Wrapped = (props)=>$acw62.createElement($8921079907ea55d7$export$e926676385687eaf, {
            ...errorBoundaryOptions
        }, $acw62.createElement(WrappedComponent, {
            ...props
        }));
    Wrapped.displayName = `errorBoundary(${componentDisplayName})`;
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    (0, $a0fc5be3f0cb3d79$export$6c1f0397687d8b2)(Wrapped, WrappedComponent);
    return Wrapped;
}



const $a2534ebb430f536b$var$queryClient = new (0, $83ccb5f70678ce73$export$405d0624ed55a03f)({
    queryCache: new (0, $74dfca891c706a66$export$5dde0cd941da8468)({
        onError: (error)=>{
            console.error(error);
        }
    }),
    mutationCache: new (0, $217efee59d834f2b$export$1fcfd9a244434844)({
        onError: (error)=>{
            console.error(error);
        }
    })
});
function $a2534ebb430f536b$var$LoadingScreen() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "loading",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("x-spinner", {})
    });
}
function $a2534ebb430f536b$export$86fbec116b87613f() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c780594f51309d36$export$45604f0cc8ae667b), {
            client: $a2534ebb430f536b$var$queryClient,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $de2aa269f2af170d$export$cf926772a52f47a5), {
                queries: [
                    (0, $24d88c360a400e92$export$3eee12522424252)
                ],
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $511f12282758d0f5$export$721ddba266dcb268), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8921079907ea55d7$export$e926676385687eaf), {
                        fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {}),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Suspense), {
                            fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a2534ebb430f536b$var$LoadingScreen, {}),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a2534ebb430f536b$var$_App, {})
                        })
                    })
                ]
            })
        })
    });
}
function $a2534ebb430f536b$var$_App() {
    const signedIn = (0, $f80eb65c55aee8de$export$d3a00f9e0caaa235)();
    if (signedIn === undefined) return;
    return !signedIn ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $764ad612b1583952$export$b64708c6f1b3ed96), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51953425ccf4a998$export$f670dcb50cfb335b), {});
}











const $11c8ec3bd1adc03e$var$INTEGRATION_NAME = 'CaptureConsole';
const $11c8ec3bd1adc03e$var$_captureConsoleIntegration = (options = {})=>{
    const levels = options.levels || (0, $c9674f9e04798056$export$2a2b1d2252a69ecb);
    const handled = options.handled ?? true;
    return {
        name: $11c8ec3bd1adc03e$var$INTEGRATION_NAME,
        setup (client) {
            if (!('console' in (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1))) return;
            (0, $16d762171e064dbd$export$1d6e0d073f9e6723)(({ args: args, level: level })=>{
                if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client || !levels.includes(level)) return;
                $11c8ec3bd1adc03e$var$consoleHandler(args, level, handled);
            });
        }
    };
};
/**
 * Send Console API calls as Sentry Events.
 */ const $11c8ec3bd1adc03e$export$caa9b6c4a4144db4 = (0, $fbb22756c9507e85$export$2323046b9414659f)($11c8ec3bd1adc03e$var$_captureConsoleIntegration);
function $11c8ec3bd1adc03e$var$consoleHandler(args, level, handled) {
    const captureContext = {
        level: (0, $197a1d16f7c0faf5$export$d771ef054122c30a)(level),
        extra: {
            arguments: args
        }
    };
    (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
        scope.addEventProcessor((event)=>{
            event.logger = 'console';
            (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(event, {
                handled: handled,
                type: 'console'
            });
            return event;
        });
        if (level === 'assert') {
            if (!args[0]) {
                const message = `Assertion failed: ${(0, $cee8faa76567523a$export$465e9d514283d4fd)(args.slice(1), ' ') || 'console.assert'}`;
                scope.setExtra('arguments', args.slice(1));
                (0, $f2b90654edf2c0a1$export$45654777c133ae80)(message, captureContext);
            }
            return;
        }
        const error = args.find((arg)=>arg instanceof Error);
        if (error) {
            (0, $f2b90654edf2c0a1$export$f5282963edea4a68)(error, captureContext);
            return;
        }
        const message = (0, $cee8faa76567523a$export$465e9d514283d4fd)(args, ' ');
        (0, $f2b90654edf2c0a1$export$45654777c133ae80)(message, captureContext);
    });
}




var $acw62 = parcelRequire("acw62");
/**
 * Inits the React SDK
 */ function $07b303fd558e140e$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $605291aa308d4b89$export$b9f95b027256052c)(opts, 'react');
    (0, $f2b90654edf2c0a1$export$2f04de43fe27971a)('react', {
        version: $acw62.version
    });
    return (0, $928f566aa50bb77a$export$2cd8252107eb640b)(opts);
}


const $65870387029da003$var$css = `
/* Based on https://gist.github.com/flqw/5fe75d8c507b382062ae49fcf2f7eb83 */
:host { display: block; height: 40px; }

.spinner {
	position: relative;
	overflow: hidden;
	height: 100%;
	aspect-ratio: 1;
	margin: auto;
}

.spinner:before {
	content: '';
	display: block;
	padding-top: 100%;
}

.spinner svg {
	position: absolute;
	inset: 0;
	transform-origin: center center;
	animation: spinner-rotate 2.42s linear infinite;
	rotate: 270deg;
}

.spinner svg circle {
	animation: spinner-dash 2.42s ease-in-out infinite;
	fill: none;
	stroke: currentColor;
	stroke-linecap: round;
	stroke-width: 3;
}

@keyframes spinner-rotate {
	100% {
		transform: rotate(720deg);
	}
}

@keyframes spinner-dash {
	0% {
		stroke-dasharray: 0, 1000;
		stroke-dashoffset: 0;
	}
	50% {
		stroke-dasharray: 89, 1000;
		stroke-dashoffset: -35;
	}
	100% {
		stroke-dasharray: 89, 1000;
		stroke-dashoffset: -124; /* < 2*pi*20 */
	}
}
`;
class $65870387029da003$var$Spinner extends HTMLElement {
    connectedCallback() {
        const shadow = this.attachShadow({
            mode: 'open'
        });
        const style = shadow.appendChild(document.createElement("style"));
        style.textContent = $65870387029da003$var$css;
        const spinner = shadow.appendChild(document.createElement('div'));
        spinner.setAttribute('class', 'spinner');
        const svg = spinner.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'svg'));
        svg.setAttribute('viewBox', '-21.5 -21.5 43 43');
        const circle = svg.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'circle'));
        circle.setAttribute('r', '20');
    }
}
customElements.define('x-spinner', $65870387029da003$var$Spinner);




$07b303fd558e140e$export$2cd8252107eb640b({
    dsn: "https://1ea9c6f4bb86c70be9f6a76f65d519ea@o4508022103998464.ingest.de.sentry.io/4508022107013200",
    integrations: [
        $11c8ec3bd1adc03e$export$caa9b6c4a4144db4()
    ]
});
const $275561fa479ca63c$var$container = document.getElementById("app");
const $275561fa479ca63c$var$root = (0, $7e96a608cb33bf79$exports.createRoot)($275561fa479ca63c$var$container);
$275561fa479ca63c$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2534ebb430f536b$export$86fbec116b87613f), {}));


//# sourceMappingURL=main.0d74ae87.js.map
